(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';
$(document).ready(function() {
    $(".wishlist").on('click', ".wishlist-link", function(event) {
        if (!$(this).hasClass("guestUser")) {
            event.preventDefault();
            wishlist($(this));
            return false;
        }
    });

    function getUrlParameterByName(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
    }

    // Wishlist icon function on coordinate tiles
    function wishlist(clickedButton) {
        var wishlisturl = clickedButton.data("href");
        var pid = clickedButton.data("pid");
        var uuid = clickedButton.data("uuid");
        $.ajax({
            url: wishlisturl,
            data: {
                'pid': pid,
                'uuid': uuid
            },
            success: function(res) {
                if (res.result == 'added') {
                    clickedButton.data("href", wishlisturl.replace("action=add", "action=remove"));
                    clickedButton.empty();
                    clickedButton.append('<i class="fas fa-heart"></i>');
					$(".user-wishlist-info .wishlist-quantity").html(res.wilistCount);

                    // Trigger GA4 addtowishlist event for ajax call
					$('body').trigger('analytics:addToWishlistEvent', { targetElement: clickedButton });
                }else if(res.result == 'removed'){
                    clickedButton.data("href", wishlisturl.replace("action=remove", "action=add"));
                    clickedButton.empty();
                    clickedButton.append('<i class="far fa-heart"></i>');
                    $(".wishlist-page li.coordinate-id-" + res.pid).remove();
                    $(".user-wishlist-info .wishlist-quantity").html(res.wilistCount);
                }
            }
        });
    }
    // Home page coordinate section
    var staffDetailsLink = $(".staffDetailsLink").val();
    var coordinateListContrLink = $(".coordinateListContrLink").val();
    var coordinateDetailLink = $(".coordinateDetailLink").val();
    var wishlistLink = $(".wishlistLink").val();
    var wishlistShowLink = $(".wishlistShowLink").val();
    var wishlistEnable = $(".wishlistEnable");
    var userAuth = $(".userAuth").val();
    var checkCoordinateAvailabilityLink = $(".checkCoordinateAvailabilityLink").val();
    var coordinateDetailFunctionLink = $(".coordinateDetailFunctionLink").val();

    function homePageStart() {
        var defaultCount = parseInt($(".defaultCount").val());
        if (defaultCount == "" || typeof(defaultCount) == undefined || defaultCount == 0) {
            defaultCount == 0;
        }
        var defaultSort = $(".defaultSort").val();
        var defaultGender = parseInt($(".defaultGender").val());
        if (defaultGender == "" || typeof(defaultGender) == undefined || defaultGender == 0) {
            defaultGender == 1;
        }
        var gender = 'men';
        if (defaultGender == 2) {
            gender = 'women';
        }
        $.ajax({
            url: coordinateListContrLink,
            data: {
                'count': defaultCount, // need to send it as a dynamic value when calling
                'sort': defaultSort, //need to send it as a dynamic value when calling
                'user_gender': defaultGender
            },
            success: function(res) {
                var result = $.parseJSON(res.obj);
                if (result.total > 0) {
                    createCoordinateList(result, gender, null);
                    truncateTitle($(".product-name"));
                } else {
                    var layout = '<p>条件に一致するSNAPは見つかりませんでした。</p>';
                    $("." + gender + "_coordinate").empty();
                    $("." + gender + "_coordinate").append(layout);
                }
            }
        });
    }
    if ($(".currentPage").val() == "homepage") {
        homePageStart();
        $(".linkClass").click(function(e) {
            var gender = $(this).data('gender');
            var g = '';
            if (gender == 'men') {
                g = 1;
            } else if (gender == 'women') {
                g = 2
            }
            var sort = $('#' + gender + ' .sort.active').data('sort');
            var count = parseInt($(".defaultCount").val());
            if (count == "" || typeof(count) == undefined || count == 0) {
                count == 0;
            }
            $.ajax({
                url: coordinateListContrLink,
                data: {
                    'count': count, // need to send it as a dynamic value when calling
                    'sort': sort, //need to send it as a dynamic value when calling
                    'user_gender': g
                },
                success: function(res) {
                    var result = $.parseJSON(res.obj);
                    displayContent(e, gender);
                    createCoordinateList(result, gender, null);
                    truncateTitle($(".product-name"));
                }
            });
        });
    }


    $(document).on('click','.follow-icon-container',function(evt) {
      evt.preventDefault();
      localStorage.removeItem('snap_id');
      var elm = $(this).find(".coordinate-follow-icon");
      var isLoggedIn =  $(".savedCoordinates").length > 0 ? true : false;
      var cid = $(this).parents('.single-coordinate').length > 0 ?
                $(this).parents('.single-coordinate').find(".clickForDetail").attr("data-cid") : getUrlParameterByName('pid');
      if(isLoggedIn){
        var coordinate_Wishlist_Url = $(".coordinate_Wishlist_Url").val();
        $.ajax({
            url: coordinate_Wishlist_Url,
            data: {user_id:cid},
            success: function(res) {
              console.log(res.result);
              if(res.result.code == 100){
                elm.toggleClass("followed");
                $(".savedCoordinates").val(res.result.updated);
                var SavedCoordinates = $(".savedCoordinates").val() != null ?  $(".savedCoordinates").val().split(",") : [];
                var index = SavedCoordinates.indexOf(cid);
                if(index < 0 && $(".currentPage").val() == "wishlist"){
                  elm.parents(".grid-tile").remove();
                  if($('.coordinates-tab .coordinate_list li').length == 0){
                    var NoCoordiNateFound = '<li class="empty-coordinate">空のスナップ・リスト</li>';
                    $('.coordinates-tab .coordinate_list').html(NoCoordiNateFound);
                  }
                }
              }else{
                  localStorage.setItem('snap_id',cid);
                  window.location.href = $(".wishlistPage").val();
              }
            }
        });
      }else{
        localStorage.setItem('snap_id',cid);
        window.location.href = $(".wishlistPage").val();
      }
    });


    function ReturnFollowIcon(followed) {
      var  followIcon = '<span class="coordinate-follow-icon '+followed+'">';

      followIcon+='<span class="in-the-wishlist"><i class="fas fa-heart" ></i></span>';

      followIcon+='<span class="not-in-the-wishlist"><svg class="svg-inline--fa fa-heart fa-w-16" aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">';
      followIcon+='<path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z">';
      followIcon+='</path>';
      followIcon+='</svg></span>';

      followIcon+='</span>';


      return followIcon;
    }
    function createCoordinateList(result, gender, selector) {
        var layout = '';
        var wishlistitemid = '';
        var wishlistitemuuid = '';
        $(".wishlistitemid").each(function() {
            wishlistitemid = wishlistitemid + $(this).val() + ',';
            wishlistitemuuid = wishlistitemuuid + $(this).data('uuid') + ',';
        });
        $.each(result.item, function(key, value) {
            var SavedCoordinates = $(".savedCoordinates").val() != null ?  $(".savedCoordinates").val().split(",") : [];
            var isFollowed = SavedCoordinates.indexOf(value.cid) >= 0 ? "followed" : "";

            var followIcon = ReturnFollowIcon(isFollowed);

            layout = layout + '<li class="grid-tile ">' +
                '<div class="product-tile single-coordinate">' +
                '<div class="clickForDetail product-image producttile-container" data-cid="' + value.cid + '">';
            $.each(value.resized_main_images, function(imgkey, imgvalue) {
                layout = layout + '<img loading="lazy" class="image" src="' + imgvalue.l + '" alt="' + imgvalue.l + '" /><br/>';
            });
            layout = layout +
                '<a href="' + coordinateDetailFunctionLink + '?pid=' + value.cid + '" class="icon clickForDetail" data-event="event-data-PDS-thumbnail" data-click="' + value.cid + '">' +
                '<div class="overlay_text">' + Resources.QUICK_VIEW + '</div>' +
                '</a>' +
                '<div class="overlay"></div>';
            layout = layout + '<div class="follow-icon-container">';
            layout = layout +followIcon;
            layout = layout +'</div>';
              // layout = layout +'<i class="fas fa-heart" ></i>';

            layout = layout + '</div>' +
                '<div class="staff_details product-set-details">' +
                '<a href="' + staffDetailsLink + '?user_id=' + value.user_id + '" class="userdetaillink">';
            if (value.user_resized_images.length <= 0) {
                layout = layout + '<div class="img" style="background-image:url("/images/noimagemedium.png");"></div>';
            } else {
                $.each(value.user_resized_images, function(imgkey, imgvalue) {
                    if (imgvalue.size == "l") {
                        layout = layout + '<div class="img" style="background-image:url(' + imgvalue.url + ');"></div>';
                    }
                });
            }
            layout = layout + '</a>' +
                '<div class="details">' +
                '<div class="product-name">' +
                '<a class="name-link userdetaillink tooltip" href="' + staffDetailsLink + '?user_id=' + value.user_id + '">' +
                '<span class="store_name shop_name">' + value.shop_name + '</span>' +
                '</a>' +
                '</div>' +
                '<span class="tooltiptext">' + value.shop_name + '</span>' +
                '<span class="store_name staff_name">' + value.user_name + '</span>' +
                '<span class="store_name height">' + value.user_height + 'cm</span>' +
                '</div>' +
                '<div class="product-individual-detail">' +
                '</div>' +
                '</div></div>' +
                '</li>';
        });
        if (gender == null) {
            if(selector != null){
              $(selector).empty();
              $(selector).append(layout);
            }else{
              $(".coordinate_list").empty();
              $(".coordinate_list").append(layout);
            }
        } else {
            $("." + gender + "_coordinate").empty();
            $("." + gender + "_coordinate").append(layout);
        }
          if(selector == null){
            setInterval(function() {
                var imgList = $('.coordinate_container .product-tile img.image');
                var len = imgList.length;
                var imgCounter = 0;
                [].forEach.call(imgList, function(img) {
                    if (img.complete) {
                        incrementImgCounter();
                    } else {
                        img.addEventListener('load', incrementImgCounter, false);
                    }
                });

            function incrementImgCounter() {
                    imgCounter++;
                    if (imgCounter === len) {
                        $('.coordinate_container .grid-tile').equalize();
                    }
                }
            }, 100);
            $.fn.equalize = function() {
                var maxHeight = 0;
                return this.each(function() {
                    var $this = $(this);
                    if ($(this).height() > maxHeight) {
                        maxHeight = $(this).height();
                    }
                    $this.height(maxHeight);
                });
            };
      }
    }
    $(".productset-carousel .sort").click(function(e) {
        var gender = $(this).data('gender');
        var g = '';
        if (gender == 'men') {
            g = 1;
        } else if (gender == 'women') {
            g = 2
        }
        var sort = $(this).data('sort');
        var count = parseInt($(".defaultCount").val());
        if (count == "" || typeof(count) == undefined || count == 0) {
            count == 0;
        }
        if (!$(this).hasClass("active")) {
            $('#' + gender + ' .sort_coordinate .sort').removeClass("active");
            $(this).addClass("active");
        }
        $.ajax({
            url: coordinateListContrLink,
            data: {
                'count': count, // need to send it as a dynamic value when calling
                'sort': sort, //need to send it as a dynamic value when calling
                'user_gender': g
            },
            success: function(res) {
                var result = $.parseJSON(res.obj);
                createCoordinateList(result, gender, null);
                truncateTitle($(".product-name"));
            }
        });
    });

    function truncateTitle(title) {
        title.dotdotdot({
            ellipsis: '...',
            wrap: 'letter',
            fallbackToLetter: 'letter',
            after: null,
            watch: true,
            height: null,
            tolerance: 0
        });
    }

    function onClickSort(ele) {
        $.ajax({
            url: coordinateListContrLink,
            data: {},
            success: function(res) {
                var result = $.parseJSON(res.obj);
                createCoordinateList(result, null, null);
                truncateTitle($(".product-name"));
            }
        });
        if (!$(ele).hasClass("active")) {
            $(".sort_coordinate div").removeClass("active");
            $(ele).addClass("active");
        }
    }

    function displayContent(e, contentNameID) {
        var content = $(".contentClass");
        var totalCount = content.length;
        // Loop through the content class
        // and hide the tabs first
        for (var count = 0; count < totalCount; count++) {
            content[count].style.display = "none";
        }
        var links = $(".linkClass");
        var totalLinks = links.length;
        // Loop through the links and
        // remove the active class
        for (var count = 0; count < totalLinks; count++) {
            links[count].classList.remove("active");
        }
        // // Display the current tab
        document.getElementById(contentNameID).style.display = "block";
        // // Add the active class to the current tab
        e.currentTarget.classList.add("active");
    }
    setTimeout(function() {
        $(".categoryRefinements .toggle").trigger("click");
    }, 500);
    // Coordinate List page
    var staffDetailsLink = $(".staffDetailsLink").val();
    var defaultCategory = "";
    var defaultCount = parseInt($(".perpageCountCoordinateList").val());
    var coordinateTagsList = $(".CoordinateTagsList").val();
    if (defaultCount == "" || typeof(defaultCount) == undefined || defaultCount == 0) {
        defaultCount == 0;
    }
    var defaultSort = $(".search-result-options .sort.active").data("sort");
    var defaultGender = parseInt($(".defaultGender").val());
    if (defaultGender == "" || typeof(defaultGender) == undefined || defaultGender == 0) {
        defaultGender == 1;
    }
    var gender = 'men';
    if (defaultGender == 2) {
        gender = 'women';
    }
    var categoryid = $(".categoryid").val();
    var defaultTags = null;
    var from = null;
    var to = null;

    var baseproductcode = getUrlParameterByName('productcode');
    console.log(baseproductcode);
    // var baseproductcode = localStorage.getItem('productid');


    function start() {
        //offset
        var pageno = $(".paginationNew ol li.active").children('a').data('pageno');
        var offset = (parseInt(pageno) * defaultCount) + 1;
        var defaultCount = parseInt($(".perpageCountCoordinateList").val());
        var defaultSort = $(".defaultSort").val();
        var reqArr = new Array();
        reqArr["defaultCount"] = defaultCount;
        reqArr["defaultSort"] = defaultSort;
        reqArr["activeGender"] = "";
        reqArr["activeCategory"] = "";
        reqArr["activeParentCategory"] = "";
        reqArr["activeTags"] = null;
        reqArr["from"] = null;
        reqArr["to"] = null;
        reqArr["offset"] = offset;
        reqArr["base_product_code"]= baseproductcode;

        if(baseproductcode != null){
            $(".category-refinement").addClass("hide-me");
            $(".refinement.BottomSize").addClass("hide-me");
            $(".refinement.TopSize").addClass("hide-me");
            $(".refinement.Style").addClass("hide-me");
        }
        $.ajax({
            url: coordinateTagsList,
            success: function(res) {
                var result = $.parseJSON(res.obj);
                if (result.total > 0) {
                    var layout = '<div class="recommended_tags">RECOMMENDED TAGS</div>' +
                        '<ul class="tags">';
                    $.each(result.item, function(key, value) {
                        if (key > 9) {
                            layout = layout +
                                '<li class="taggrid hide" data-index="' + key + '">' +
                                '<a href="javascript:void(0);" class="tag" data-tag-id="' + value.tag_id + '" data-tag-name="' + value.tag_name + '">' + value.tag_name + '</a>' +
                                '</li>';
                        } else {
                            layout = layout +
                                '<li class="taggrid" data-index="' + key + '">' +
                                '<a href="javascript:void(0);" class="tag" data-tag-id="' + value.tag_id + '" data-tag-name="' + value.tag_name + '">' + value.tag_name + '</a>' +
                                '</li>';
                        }
                    });
                    if (result.total > 10) {
                        layout = layout +
                            '<li class="viewmoreTagLi" data-index="viewmore">' +
                            '<a href="javascript:void(0);" class="viewmoreTag">' + $(".viewMoreText").val() +
                            '<div id="ss-w-alhd-sp-searchFormMenu_arrow" class="ss-w-alhd-sp-menu-arrows ss-w-alhd-sp-menu-arrows-down"></div>' +
                            '</a>' +
                            '</li>';
                    }
                    layout = layout + '</ul>';
                    $(".tags_list").empty();
                    $(".tags_list").append(layout);
                } else {}
            }
        });
        coordinateList(reqArr, null);
    }
    if ($(".currentPage").val() == "coordinateListPage") {
        start();
        $("body").addClass("coordinate-List-Page");
    }else{
        localStorage.removeItem('productid');
    }

    function coordinateList(reqArr, tagClicked) {
        if (reqArr['defaultCategory'] == '' || reqArr['defaultCategory'] == undefined) {
            reqArr['defaultCategory'] = defaultCategory;
        }
        var params = {
            'count': reqArr['defaultCount'], // need to send it as a dynamic value when calling
            'sort': reqArr['defaultSort'], //need to send it as a dynamic value when calling
            'user_gender': reqArr['activeGender'],
            'tags': reqArr['activeTags'],
            'category': reqArr['activeCategory'],
            'parent_category': reqArr['activeParentCategory'],
            'from_height': reqArr['from'],
            'to_height': reqArr['to'],
            'offset': reqArr['offset'],
            'base_product_code': reqArr['base_product_code']
        };
        $.ajax({
            url: coordinateListContrLink,
            data: params,
            success: function(res) {
                var result = $.parseJSON(res.obj);
                if (result.total > 0) {
                    createCoordinateList(result, null, null);
                    truncateTitle($(".product-name"));
                    var is_paginate = false;
                    $(".paginationNew ol").each(function() {
                        var anchor = $(this).find("a");
                        if (tagClicked[0] == anchor[0]) {
                            is_paginate = true;
                        }
                    });
                    if (!$.trim($(".paginationNew").html()).length || is_paginate !== true) {
                        createPagination(result);
                    }
                } else {
                    var layout =
                        '<p>条件に一致するSNAPは見つかりませんでした。</p>';
                    $(".coordinate_list").empty();
                    $(".coordinate_list").append(layout);
                    createPagination(result);
                }
            }
        });
    }

    function createPagination(result) {
        // paginate
        var pages = Math.ceil(result.total / defaultCount);
        var paginate = '';
        if (pages > 3) {
            paginate = paginate +
                '<a href="javascript:void(0);" class="pagination-prev hide" data-total-pages="' + pages + '">' +
                '<span class="visually-hidden">prev</span>' +
                '</a>';
        }
        var hide = '';
        if (pages > 1) {
            for (var i = 1; i <= pages; i++) {
                var active = '';
                if (i == 1) {
                    active = 'active';
                } else if (i > 3) {
                    hide = 'hide';
                }
                paginate = paginate +
                    '<ol>' +
                    '<li class="' + active + ' page_li_' + i + ' ' + hide + '" data-index="' + i + '">' +
                    '<a class="page" data-pageno=' + i + ' href="javascript:void(0);">' + i + '</a>' +
                    '</li>' +
                    '</ol>';
            }
        }
        if (pages > 3) {
            paginate = paginate +
                '<a href="javascript:void(0);" class="pagination-next" data-total-pages="' + pages + '">' +
                '<span class="visually-hidden">next</span>' +
                '</a>';
        }
        $(".paginationNew").empty();
        $(".paginationNew").append(paginate);
    }
    $(".paginationNew").on("click", ".pagination-prev", function() {
        var totalPages = $(this).data("total-pages");
        changePage("prev", totalPages);
    });
    $(".paginationNew").on("click", ".pagination-next", function() {
        var totalPages = $(this).data("total-pages");
        changePage("next", totalPages);
    });

    function changePage(clickDirection, totalPages) {
        var active_a = $(".paginationNew").find("li.active a");
        var activePage = active_a.data("pageno");
        var activePageIndex = 0;
        if (clickDirection == "next") {
            var activePageIndex = activePage + 1;
        } else if (clickDirection == "prev") {
            var activePageIndex = activePage - 1;
        }
        if (activePageIndex > 0 && activePageIndex < parseInt(totalPages) + 1) {
            refreshPaginate(activePageIndex);
            var nextPage = $(".paginationNew").find('li a[data-pageno="' + activePageIndex + '"]');
            active_a.removeClass("active selected");
            active_a.parent("li").removeClass("active selected");
            toggleActiveClass(nextPage);
            onClickCreateRequestParams(nextPage);
        }
    }
    $(".paginationNew").on("click", ".page", function() {
        var curr_index = $(this).parent('li').data("index");
        refreshPaginate(curr_index);
        toggleActiveClass($(this));
        onClickCreateRequestParams($(this));
    });

    function refreshPaginate(curr_index) {
        var totalNoOfPages = $(".pagination-prev").data("total-pages");
        $(".paginationNew .page").removeClass("active selected");
        $(".paginationNew .page").parent("li").removeClass("active selected");
        $(".paginationNew li").addClass("hide");
        if (curr_index > 1) {
            for (var i = curr_index; i <= (curr_index + 1); i++) {
                $(".paginationNew li.page_li_" + i).removeClass("hide");
            }
            for (var i = curr_index; i >= (curr_index - 1); i--) {
                $(".paginationNew li.page_li_" + i).removeClass("hide");
            }
        } else {
            for (var i = curr_index; i <= (curr_index + 2); i++) {
                $(".paginationNew li.page_li_" + i).removeClass("hide");
            }
        }
        if (curr_index > 2 && totalNoOfPages > 1) {
            $(".pagination-prev").removeClass("hide");
        } else {
            $(".pagination-prev").addClass("hide");
        }
        if (curr_index == totalNoOfPages && totalNoOfPages > 1) {
            $(".pagination-next").addClass("hide");
            for (var i = curr_index; i >= (curr_index - 2); i--) {
                $(".paginationNew li.page_li_" + i).removeClass("hide");
            }
        } else {
            $(".pagination-next").removeClass("hide");
        }
    }
    // Sorting by new arrival or popular
    $(".search-result-options .sort").click(function(e) {
        if (!$(this).hasClass("active")) {
            $('.sort_coordinate .sort').removeClass("active");
            $(this).addClass("active");
        }
        onClickCreateRequestParams($(this));
    });
    var coordinateListGenderFilter = $(".coordinateListGenderFilter").val();
    if ($(".currentPage").val() == "coordinateListPage") {
        var genderArr = coordinateListGenderFilter.split(",");
        var genderFilter = '<div class="refinement gender">' +
            '<h3 class="toggle">性別' +
            '<i class="accordianclose24x24" aria-hidden="true"></i>' +
            '</h3>' +
            '<ul>';
        $.each(genderArr, function(key, value) {
            var datagender = 0;
            if (value == 'Men') {
                datagender = 1;
            } else if (value == 'Women') {
                datagender = 2;
            }
            genderFilter = genderFilter + '<li>' +
                '<a href="javascript:void(0);" class="gender_filter" data-gender="' + datagender + '">' +
                '<input type="checkbox" class="input-checkbox">' +
                '<label>' + value + '</label>' +
                '</a>' +
                '</li>';
        });
        genderFilter = genderFilter + '</ul>' +
            '</div><div class="refinement heights"></div>';
        $(".productset_refinements .ajax-refinements").append(genderFilter);
    }
    var heightfilter = '';
    var coordinateListHeightFilter = $(".coordinateListHeightFilter").val();
    if ($(".currentPage").val() == "coordinateListPage") {
        var heightArr = coordinateListHeightFilter.split(",");
        heightfilter = heightfilter + '<option value="none">指定なし</option>';
        $.each(heightArr, function(key, value) {
            if (key == 0) {
                heightfilter = heightfilter + '<option value=' + value + '>' + "~" + value + '</option>';
            } else if (key == heightArr.length - 1) {
                heightfilter = heightfilter + '<option value=' + value + '>' + value + "~" + '</option>';
            } else {
                heightfilter = heightfilter + '<option value=' + value + '>' + value.replace("--", "~") + '</option>';
            }
        });
        var heightfilterSelect = '<h3 class="toggle">身長' +
            '<i class="accordianclose24x24" aria-hidden="true"></i>' +
            '</h3>' +
            '<select>' + heightfilter + '</select>';
        $(".productset_refinements .ajax-refinements .heights").empty();
        $(".productset_refinements .ajax-refinements .heights").append(heightfilterSelect);
    }
    $(".tags_list").on("click", ".tag", function() {
        var tagClicked = $(this);
        toggleActiveClass(tagClicked);
        onClickCreateRequestParams(tagClicked);
        return false;
    });
    $(".gender_filter").click(function() {
        var genderClicked = $(this);
        var checkBox = genderClicked.children("input");
        checkBox.prop('checked', !(checkBox.is(':checked')));
        $(".gender_filter").each(function() {
            if (genderClicked.data('gender') !== $(this).data('gender')) {
                $(this).children("input").prop('checked', false);
                $(this).removeClass("active selected");
                $(this).parent('li').removeClass("active selected");
            }
        });
        toggleActiveClass(genderClicked);
        selectedFiltersMobileView(genderClicked);
        onClickCreateRequestParams(genderClicked);
        return false;
    });
    $('.category_filter').click(function() {
        var categoryClicked = $(this);
        var checkBox = categoryClicked.children("input");
        checkBox.prop('checked', !(checkBox.is(':checked')));
        toggleActiveClass(categoryClicked);
        selectedFiltersMobileView(categoryClicked);
        onClickCreateRequestParams(categoryClicked);
        return false;
    });

    function selectedFiltersMobileView(filter) {
        if ($(window).width() < 768) {
            var html = '<a class="clearallbutton-coordinateFilters">検索条件をクリア</a>' +
                '<a class="applybutton">適用する</a>';
            $(".mobilefilteractions").empty();
            $(".mobilefilteractions").append(html);
            var exists = false;
            $(".mobile .breadcrumb-refinement").each(function() {
                if (filter.children("label").text() == $(this).children().children("span.breadcrumb-refinement-value").text()) {
                    exists = true;
                    $(this).remove();
                }
                if ($(this).html().trim() == "") {
                    $(this).remove();
                }
            });
            if (filter.attr("class").indexOf("gender_filter") != -1) {
                $(".cancelFilter.gender_filter").parent().parent().parent().parent().remove();
            }
            if (exists == false) {
                var filterHTML = '';
                filterHTML = filterHTML +
                    '<span class="breadcrumb-refinement" data-divider="and">' +
                    '<span class="breadcrumb-refinement-selected">' +
                    '<span class="breadcrumb-refinement-value">' + filter.children("label").text() +
                    '<span class="coordinateRemove-name">' +
                    '<a class="cancelFilter ' + filter.attr("class") + '" data-class="' + filter.attr("class") + '" data-val="' + filter.children("label").text() + '"' +
                    'title="削除"><i class="icon-cancel"></i></a>' +
                    '</span>' +
                    '</span>' +
                    '</span>' +
                    '</span>';
                $(".mobile #secondary_plp.refinements .refinement-values").append(filterHTML);
            }
            if ($(".mobile .refinement-values").html().trim() == "") {
                $(".mobile .mobilefilteractions").hide();
            } else if ($(".mobile .refinement-values .breadcrumb-refinement").html().trim() == "") {
                $(".mobile .mobilefilteractions").hide();
            }
        }
    }

    function onClickCreateRequestParams(tagClicked) {
        // Tags list
        var activeTags = '';
        $(".tag.active").each(function() {
            activeTags = activeTags + $(this).data("tag-name") + ",";
        });
        activeTags = activeTags.slice(0, -1) + '';
        // Gender selection
        var activeGender = '';
        $(".gender_filter.active").each(function() {
            activeGender = $(this).data("gender");
        });
        // Category selection
        var activeCategory = '';
        var activeParentCategory = '';
        $(".category_filter.active").each(function(index, val) {
            var parentCategory = $(this).data("parent-category");
            var catIDStr = $(this).data("category");
            if (catIDStr != undefined) {
                var catIDStr_Arr = catIDStr.split("-");
                var catID = catIDStr_Arr[catIDStr_Arr.length - 1];
                if (catID != undefined && catID != '') {
                    if (index > 0 && activeParentCategory.indexOf(catID) == -1 && activeCategory.indexOf(catID) == -1) {
                        activeCategory = activeCategory + "," + catID;
                    } else if (index == 0 && activeParentCategory.indexOf(catID) == -1) {
                        activeCategory = catID;
                    }
                }
            }
        });
        activeParentCategory = activeParentCategory.replace(/^,|,$/g, '');
        activeCategory = activeCategory.replace(/^,|,$/g, '');
        var from = '';
        var to = '';
        var selectedHeight = '';
        var selectedHeightIndex = '';
        if ($(window).width() > 767) {
            var heightSelect = $('.desktop .productset_refinements .heights select');
        } else {
            var heightSelect = $('.mobile .productset_refinements .heights select');
        }
        $(heightSelect).children('option').each(function(index, value) {
            var attr = $(this).attr('selected');
            if (typeof attr !== 'undefined' && attr !== false) {
                selectedHeight = $(this).val();
                selectedHeightIndex = index;
            }
        });
        if (selectedHeight !== 'none' && selectedHeight !== '指定なし' && selectedHeight !== '') {
            var valArr = selectedHeight.split("--");
            var optionLength = $(heightSelect).children('option').length;
            if (selectedHeightIndex == 1) {
                from = 0;
                to = valArr[0].replace("cm", "");
            } else if (selectedHeightIndex == optionLength - 1) {
                from = valArr[0].replace("cm", "");
                to = undefined;
            } else {
                from = valArr[0].replace("cm", "");
                to = valArr[1].replace("cm", "");
            }
        }
        // Sorting
        var defaultSort = $(".search-result-options .sort.active").data("sort");
        //offset
        var pageno = $(".paginationNew ol li.active").children('a').data('pageno');
        var offset = 0;
        var is_paginate = false;
        $(".paginationNew ol").each(function() {
            var anchor = $(this).find("a");
            if (tagClicked[0] == anchor[0]) {
                is_paginate = true;
            }
        });
        if (!$.trim($(".paginationNew").html()).length || is_paginate == true) {
            offset = (parseInt(pageno) - 1) * defaultCount;
        }
        var reqArr = new Array();
        reqArr["defaultCount"] = defaultCount;
        reqArr["defaultSort"] = defaultSort;
        reqArr["activeGender"] = activeGender;
        reqArr["activeCategory"] = activeCategory;
        reqArr["activeParentCategory"] = activeParentCategory;
        reqArr["activeTags"] = activeTags;
        reqArr["from"] = from;
        reqArr["to"] = to;
        reqArr["offset"] = offset;
        reqArr["base_product_code"]= baseproductcode;
        if ($(window).width() < 768) {
            if (tagClicked.hasClass("tag") || tagClicked.hasClass("sort") || tagClicked.hasClass("page")) {
                coordinateList(reqArr, tagClicked);
            }
            if (activeGender != '' || activeCategory != '' || selectedHeight !== 'none' || selectedHeight !== '指定なし' || selectedHeight !== '') {
                $('.mobilefilteractions').show();
            } else {
                $('.mobilefilteractions').hide();
            }
            $(".applybutton").on("click", function() {
                closeMobileFilter();
                coordinateList(reqArr, tagClicked);
            });
        } else {
            closeMobileFilter();
            coordinateList(reqArr, tagClicked);
        }
    }
    $(".refinement-values").on("click", ".cancelFilter", function() {
        var clickedCancel = $(this);
        if (clickedCancel.hasClass("gender_filter")) {
            $(".mobile .productset_refinements .gender_filter").each(function() {
                if (clickedCancel.data("val") == $(this).children("label").text()) {
                    $(this).children("input").prop('checked', false);
                    $(this).removeClass("active selected");
                    $(this).parent('li').removeClass("active selected");
                }
            });
        }
        if (clickedCancel.hasClass("category_filter")) {
            $(".mobile .productset_refinements .category_filter").each(function() {
                if (clickedCancel.data("val") == $(this).children("label").text()) {
                    $(this).children("input").prop('checked', false);
                    $(this).removeClass("active selected");
                    $(this).parent('li').removeClass("active selected");
                }
            });
        }
        if (clickedCancel.hasClass("heightOption")) {
            $('.mobile .productset_refinements .heights select').find("option").each(function() {
                if ($(this).val() == "none") {
                    $(this).attr("selected", "selected");
                    $('.mobile .productset_refinements .heights .ui-selectmenu-text').html("指定なし");
                } else {
                    $(this).removeAttr("selected");
                }
            });
        }
        if ($(".refinement-values").html() == '') {
            $(".mobilefilteractions").hide();
        }
        clickedCancel.parent().parent().parent().parent().remove();
    });
    $(".clearallbutton-coordinateFilters").on("click", function() {
        if ($(window).width() < 768) {
            $(".gender_filter").each(function() {
                $(this).children("input").prop('checked', false);
                $(this).removeClass("active selected");
                $(this).parent('li').removeClass("active selected");
            });
            $(".category_filter").each(function() {
                $(this).children("input").prop('checked', false);
                $(this).removeClass("active selected");
                $(this).parent('li').removeClass("active selected");
            });
            $('.productset_refinements .heights select').find("option").each(function() {
                if ($(this).val() == "none") {
                    $(this).attr("selected", "selected");
                    $('.mobile .productset_refinements .heights .ui-selectmenu-text').html("指定なし");
                } else {
                    $(this).removeAttr("selected");
                }
            });
            $('.productset_refinements .heights select').trigger("change");
            $(".refinement-values").empty();
            if ($(".refinement-values").html() == '') {
                $(".mobilefilteractions").hide();
            }
        }
    });
    $('.productset_refinements .heights select').on("change", function() {
        var selectedVal = $(this).val();
        $(this).find("option").each(function() {
            if ($(this).val() == selectedVal) {
                $(this).attr("selected", "selected");
            } else {
                $(this).removeAttr("selected");
            }
        });
        if ($(window).width() < 768) {
            var exists = false;
            $(".breadcrumb-refinement").each(function() {
                if ($(this).children().children().children().children().hasClass("heightOption")) {
                    exists = true;
                    $(this).remove();
                }
                if ($(this).html().trim() == "") {
                    $(this).remove();
                }
            });
            if (selectedVal != "none") {
                var filterHTML = '';
                filterHTML = filterHTML +
                    '<span class="breadcrumb-refinement" data-divider="and">' +
                    '<span class="breadcrumb-refinement-selected">' +
                    '<span class="breadcrumb-refinement-value">' + selectedVal +
                    '<span class="coordinateRemove-name">' +
                    '<a class="cancelFilter heightOption" data-class="heightOption" data-val="' + selectedVal + '"' +
                    'title="削除"><i class="icon-cancel"></i></a>' +
                    '</span>' +
                    '</span>' +
                    '</span>' +
                    '</span>';
                $(".mobile #secondary_plp.refinements .refinement-values").append(filterHTML);
            }
            var html = '<a class="clearallbutton-coordinateFilters">検索条件をクリア</a>' +
                '<a class="applybutton">適用する</a>';
            $(".mobilefilteractions").empty();
            $(".mobilefilteractions").append(html);
            if ($(".mobile .refinement-values").html().trim() == "") {
                $(".mobile .mobilefilteractions").hide();
            } else if ($(".mobile .refinement-values .breadcrumb-refinement").html().trim() == "") {
                $(".mobile .mobilefilteractions").hide();
            }
        }
    });

    function toggleActiveClass(tagClicked) {
        tagClicked.toggleClass("active selected");
        tagClicked.parent('li').toggleClass("active selected");
    }
    setTimeout(function() {
        $('.heights select').on('change', function() {
            var select = $(this);
            onClickCreateRequestParams(select);
        });
        $(".productset .search-result-options .viewmoreTagLi").on('click', '.viewmoreTag', function() {
            $(".search-result-options .tags li").each(function() {
                if ($(this).data("index") > 9 && $(this).data("index") != "viewmore") {
                    $(this).toggleClass("hide");
                }
            });
            if ($("#ss-w-alhd-sp-searchFormMenu_arrow").hasClass("ss-w-alhd-sp-menu-arrows-down")) {
                $(this).html('閉じる <div id="ss-w-alhd-sp-searchFormMenu_arrow" class="ss-w-alhd-sp-menu-arrows ss-w-alhd-sp-menu-arrows-up"></div>');
            } else {
                $(this).html('もっと見る <div id="ss-w-alhd-sp-searchFormMenu_arrow" class="ss-w-alhd-sp-menu-arrows ss-w-alhd-sp-menu-arrows-down"></div>');
            }
        });
        var tag_id = $(".tag_id").val();
        if (tag_id != null) {
            $(".tags_list").find('li').each(function() {
                var current = $(this);
                var currentTagId = $(this).children(".tag").data("tag-name");
                if (currentTagId == tag_id) {
                    $(this).children('a.tag').trigger('click');
                }
            });
        }
    }, 1000);
    $('.sbHolder').on('click', function() {
        $('.col-left.sidebar.on').css('display', 'block');
        $('body').addClass('noscroll');
    });
    $('.block-layered-nav .close').on('click', function() {
        closeMobileFilter();
    });

    function closeMobileFilter() {
        $('.col-left.sidebar.on').css('display', 'none');
        $('body').removeClass('noscroll');
    }
    // PLP and PDP
    var displayPageID = $(".displayPageID").val();
    var noOfCoordinate = $(".noOfCoordinate").val();

    function addToQueryString(url, key, value) {
        var query = url.indexOf('?');
        var anchor = url.indexOf('#');
        if (query == url.length - 1) {
            // Strip any ? on the end of the URL
            url = url.substring(0, query);
            query = -1;
        }
        return (anchor > 0 ? url.substring(0, anchor) : url)
             + (query > 0 ? "&" + key + "=" + value : "?" + key + "=" + value)
             + (anchor > 0 ? url.substring(anchor) : "");
    }

    function startOnPDPandPLP() {
        var data = {};
        var gender = '';
        if (displayPageID.indexOf("-Men") != -1 || displayPageID.indexOf("Men-") != -1 || displayPageID == "Men") {
            gender = 1;
        } else if (displayPageID.indexOf("-Women") != -1 || displayPageID.indexOf("Women-") != -1 || displayPageID == "Women") {
            gender = 2;
        }
        if ($(".currentPage").val() == "plpPage") {
            var categoryListOnPLP = $.parseJSON($(".categoryListOnPLP").val());
            var categoryID = '';
            if (categoryListOnPLP != '' && categoryListOnPLP[displayPageID] != null && categoryListOnPLP[displayPageID] != undefined && categoryListOnPLP[displayPageID] != '') {
                data = {
                    'parent_category': categoryListOnPLP[displayPageID],
                    'count': noOfCoordinate,
                    'user_gender': gender
                };
            } else {
                data = {
                    'count': noOfCoordinate,
                    'user_gender': gender
                };
            }
        } else if ($(".currentPage").val() == "pdpPage") {
          	localStorage.setItem('productid',displayPageID);
            data = {
                'base_product_code': displayPageID,
                'count': noOfCoordinate,
                'user_gender': gender
            };
            var AnchorURL = $(".view-more-tab a").attr("href");
            var newURl = addToQueryString(AnchorURL,"productcode",displayPageID);
             $(".view-more-tab a").attr("href",newURl);
        }

        $.ajax({
            url: coordinateListContrLink,
            data: data,
            success: function(res) {
                var result = $.parseJSON(res.obj);
                if (result.total > 0) {
                    createCoordinateList(result, null, null);
                    truncateTitle($(".product-name"));
                    if(result.total <= 10 && $(".currentPage").val() == "pdpPage"){
                      $(".view-more-tab").hide();
                    }
                } else {
                    if ($(".currentPage").val() == "pdpPage") {
                        $(".coordinateList").hide();
                    }
                    var layout = '<p>条件に一致するSNAPは見つかりませんでした。</p>';
                    $(".coordinate_list").empty();
                    $(".coordinate_list").append(layout);
                }
            }
        });
    }
    if ($(".currentPage").val() == "plpPage" || $(".currentPage").val() == "pdpPage") {
        startOnPDPandPLP();
    }
    // Wishlist
    if ($(".currentPage").val() == "wishlist") {
        staffList();
        LoadSnapsOnWishlist();
        $(".linkClass").click(function(e) {
            var tab = $(this).data('tab');
            displayContent(e, tab);
        });
    }

    function staffList() {
        var staff_id = $(".staff_id").val();
        if(staff_id !== 'null'){
          var StaffDetailWishlist = $(".StaffDetailWishlist").val();
          var userIDArr = staff_id.split(",");
          var staffArr = new Array();
          userIDArr.forEach(function(idArr) {
              var params = { 'user_id': idArr};
              if (staff_id.length > 0) {
                  $.ajax({
                      url: StaffDetailWishlist,
                      data: params,
                      async: false,
                      success: function(res) {
                          staffArr.push($.parseJSON(res.obj));
                      }
                  });
              }
          });
          staffDetails(staffArr);
          truncateTitle($(".product-name"));
        }

    }
    function  UpdateSnapsListWishlistPage(snaptab) {
      var SavedCoordinates = $(".savedCoordinates").val() != null ?  $(".savedCoordinates").val() : "";
      if(SavedCoordinates != '' || SavedCoordinates != 'null' || SavedCoordinates != null ){
        $.ajax({
          url: coordinateListContrLink,
          data: {'cid': SavedCoordinates},
          success: function(res) {
            var result = $.parseJSON(res.obj);
            if(result.item.length > 0){
              createCoordinateList(result, null,'.coordinates-tab .coordinate_list');
            }else{
              var NoCoordiNateFound = '<li class="empty-coordinate">空のスナップ・リスト</li>';
              $('.coordinates-tab .coordinate_list').html(NoCoordiNateFound);
            }
            if(snaptab){
              $("#load-snap-tab-button").click();
            }
            localStorage.removeItem('snap_id');
            $(".loader-container").removeClass("visible");
            $(".tabs-and-container").show();
          }
        });
      }else{
        $('.coordinates-tab .coordinate_list').empty();
        $(".loader-container").removeClass("visible");
        $(".tabs-and-container").show();
      }
    }
    function LoadSnapsOnWishlist(){
        var IsAdded  = localStorage.getItem('snap_id');
        if(IsAdded != null){
          var coordinate_Wishlist_Url = $(".coordinate_Wishlist_Url").val();
            $.ajax({
            url: coordinate_Wishlist_Url,
            data: { user_id:IsAdded,'remove':false },
            success: function(res) {
                  $(".savedCoordinates").val(res.result.updated);
                  UpdateSnapsListWishlistPage(true);
              }
            });
        }else{
           UpdateSnapsListWishlistPage(false);
        }

        // UpdateSnapsListWishlistPage(false);

      }

    function staffDetails(staffArr) {
        var staffDetailsLink = $(".staffDetailsLink").val();
        var WishlistStaffDetails = $(".WishlistStaffDetails").val();
        var layout = '';
        $.each(staffArr, function(idKey, result) {
            $.each(result.item, function(key, value) {
                var genderType = '';
                if (value.gender == 1) {
                    genderType = 'Men';
                } else if (value.gender == 2) {
                    genderType = 'Women';
                }
                layout = layout +
                    '<tr class="staff_details product-set-details" style="display:inline-block">' +
                    '<td class="td-img">' +
                    '<a href="' + staffDetailsLink + '?user_id=' + value.user_id + '">';
                if (value.resized_images.length <= 0) {
                    layout = layout + '<div class="img" style="background-image:url("/images/noimagemedium.png");"></div>';
                } else {
                    $.each(value.resized_images, function(imgkey, imgvalue) {
                        if (imgvalue.size == "l") {
                            layout = layout + '<div class="img" style="background-image:url(' + imgvalue.url + ');"></div>';
                        }
                    });
                }
                layout = layout + '</a>' +
                    '</td>' +
                    '<td class="wishlist-staffdetail">' +
                    '<div class="store_name staff_name">' +
                    '<a href="' + staffDetailsLink + '?user_id=' + value.user_id + '">' + value.name + '</a>' +
                    '</div>' +
                    '<div class="wishlist-staffinfo">' +
                    '<span class="gendertypewishlist">' + genderType + " |" + '</span>' +
                    '<span class="heightwishlist" >' + value.height + "cm " + "| " + '</span>' +
                    '<span class="shopnmewishlist">' + value.shop_name + '</span>' +
                    '</div>' +
                    '<div class="follow-wishlistlikelist">' +
                    '<a type="button" href="' + WishlistStaffDetails + '?user_id=' + value.user_id + '&TabName=staff"><i class="icon-heart-outlined" style="color: #C41230;"></i>Unfollow</a>' +
                    '</div>' +
                    '<div class="follow-instagram">';
                if (value.sns.instagram != null) {
                    layout = layout + '<a href="https://www.instagram.com/' + value.sns.instagram.link_value + '" class="instagram-link">' +
                        '<i class="fab fa-instagram"></i>' +
                        '<sapn class="staff-instagram-link">' + value.sns.instagram.link_value + '</span>' +
                        '</a>';
                }
                layout = layout + '</div>' +
                    '</td>' +
                    '</tr>';
            });
        });
        $(".wishlist-page-tab-list .coordinate_list").empty();
        $(".wishlist-page-tab-list .coordinate_list").append(layout);
    }


    function checkonlinestatus(productcode){
    		var FetchDataUrl = $(".FetchModelPath").val();
    		var outofstock = $(".outOfStock").val();
        // var baseCode = productcode;
        var baseCode = productcode.substr(0, 9);
        console.log(productcode,baseCode)
    		$.ajax({
    			url: FetchDataUrl,
    			data : { 'productcode' : baseCode},
    			success: function(res){
    				var stockdata = res.availability;
    				var onlinedata = res.online;
    				var productid = res.product_code;
            console.log(res,stockdata,outofstock);
    				if(stockdata == "NOT_AVAILABLE"){
    					$(".out-of-stock-label"+productcode).text(outofstock);
    				}
    				if(onlinedata == false){
    					$("#"+productcode).css("pointer-events","none");
    					$("#"+productcode).css("cursor","default");
    				}


    			}
    		});
    	}

    // Coordinate detail page
    if ($(".currentPage").val() == "CoordinateDetailsPage") {
        var coordinateDetailUrl = $(".CoordinateDetailUrl").val();
        var currentProductID = $(".currentProductID").val();
        var wishlistStaffDetails = $(".wishlistStaffDetails").val();
        var wishlistUpdateStaffFollowList = $('.wishlistUpdateStaffFollowList').val();
        var wishlistFollowText = $(".wishlistFollowText").val();
        var wishlistUnFollowText = $(".wishlistUnFollowText").val();
        var wishlistShowLink = $(".wishlistShowLink").val();
        var currencysign = $(".currencysign").val();
        var seeMorecoordinates = $(".seeMorecoordinates").val();
        var othercoordinates = $(".othercoordinates").val();
        var PLPLink = $(".PLPLink").val();
        var staff_id = $(".staff_id").val();
        var CoordinateTagsList = $(".CoordinateTagsList").val();

        function startCoordinateDetail() {
          console.log(coordinateDetailUrl)
            $.ajax({
                url: coordinateDetailUrl,
                data: {'cid': currentProductID},
                success: function(res) {
                  console.log(res)
                    var result = $.parseJSON(res.obj);
                    createCoordinateDetails(result);
                }
            });
        }

        function coordinateListSlot(user_id) {
            var defaultCount = 5;
            $.ajax({
                url: coordinateListContrLink,
                data: {
                    'count': defaultCount,
                    'user_id': user_id
                },
                success: function(res) {
                    var result = $.parseJSON(res.obj);
                    createCoordinateList(result, null, null);
                }
            });
        }

        function createCoordinateDetails(result) {
            var layout = '';
            var wishlistitemid = '';
            var wishlistitemuuid = '';
            var tags = "";
            $(".wishlistitemid").each(function() {
                wishlistitemid = wishlistitemid + $(this).val() + ',';
                wishlistitemuuid = wishlistitemuuid + $(this).data('uuid') + ',';
            });
            var i = 0;
            console.log(result);
            $.each(result.item, function(key, value) {
                var wishlistEnabled = wishlistEnable;
                tags = value.tags;
                layout = '<div class="coordinates">' +
                    '<div class="coordinate-img">' +
                    '<div class="coordinate-primary-img img">';
                $.each(value.resized_main_images, function(imgkey, imgvalue) {
                    layout = layout + '<img loading="lazy" class="image" src="' + imgvalue.l + '" alt="' + imgvalue.l + '" /><br/>';
                });
                layout = layout + '<div>';
                var SavedCoordinates = $(".savedCoordinates").val() != null ?  $(".savedCoordinates").val().split(",") : [];
                var isFollowed = SavedCoordinates.indexOf(value.cid) >= 0 ? "followed" : "";
                var followIcon = ReturnFollowIcon(isFollowed);

                layout = layout + '<div class="follow-icon-container">';
                layout = layout +followIcon;
                layout = layout +'</div>';

                layout = layout + '</div>' +
                    '</div>' +
                    '<div id="thumbnails">' +
                    '<ul class="search-result-items thumb-img">' +
                    '<div class="prev-next-img">' +
                    '<div class="prev-button">' +
                    '<i class="fa fa-angle-left fa-lg"></i>' +
                    '</div>' +
                    '<div class="next-button">' +
                    '<i class="fa fa-angle-right fa-lg"></i>' +
                    '</div>' +
                    '</div>' +
                    '<div class="co-owl-thumbnails">' +
                    '<li class="grid-tile sub-image-thumbnails active lastImg pg_' + i + '" data-index="' + i + '">' +
                    '<a href="javascript:void(0);" class="coordinate-sub-img pg_' + i + ' product-image" data-imgno=' + i + '><img src="' + value.image_url + '"/> </a> </li>';
                if (value.sub_image.length > 0) {
                    $.each(value.sub_image, function(subimgkey, subimgvalue) {
                        i++;
                        layout = layout + '<li class="grid-tile sub-image-thumbnails pg_' + i + '" data-index="' + i + '">' +
                            '<a href="javascript:void(0);" class="coordinate-sub-img pg_' + i + ' product-image" data-imgno=' + i + '>' +
                            '<img src="' + subimgvalue + '"/>' +
                            '</a>' +
                            '</li>';
                    });
                }
                layout = layout + '</div>' +
                    '<div class="total-thumbnail-img" data-attr="' + i + '" style="display: none;"></div>' +
                    '</ul>' +
                    '</div>' +
                    '</div>' +
                    '<div class="coordinate-staff-details">' +
                    '<div class="staff-details">' +
                    '<div class="staff-img-profile">' +
                    '<div class="staff-profile-img">' +
                    '<a href="' + staffDetailsLink + '?user_id=' + value.user_id + '">';
                if (value.user_resized_images.length <= 0) {
                    layout = layout + '<img src="/images/noimagemedium.png"/>'
                } else {
                    $.each(value.user_resized_images, function(imgkey, imgvalue) {
                        if (imgvalue.size == "l") {
                            layout = layout + '<img src="' + imgvalue.url + '"/>';
                        }
                    });
                }
                layout = layout + '</a>' +
                    '</div>' +
                    '<div class="staff-profile">' +
                    '<div class="staff-name" id="staff-name" data-user-name="' + value.user_name + '">' + value.user_name + '</div>' +
                    '<div class="store-name">' + value.shop_name + '</div>' +
                    '<div class="coordinate-data">' +
                    '<span class="staff-height">' + value.coordinate_height + " cm" + '</span>' +
                    '</div>' +
                    '<div id="staff-id" data-user-id="' + value.user_id + '" style="display: none;">' + value.user_id + '</div>' +
                    '<div class="staff_follow staff-follow-button">';
                var isAlreadyFollow = staff_id;
                var userAuth = $(".userAuth").val();
                var alreadyFollowed = false;
                if (isAlreadyFollow != null) {
                    $.each(isAlreadyFollow, function(indexValu, isAlready) {
                        if (isAlready == value.user_id) {
                            alreadyFollowed = true;
                        }
                    });
                }
                if (userAuth == "wishlist-customer-authenticated") {
                    if (alreadyFollowed) {
                        layout = layout + '<a class="follow staff_follow-button staff-follow" type="button" data-user-id="' + value.user_id + '" data-attr="' + wishlistStaffDetails + '?user_id=' + value.user_id + '" data-updateurl="' + wishlistUpdateStaffFollowList + '?user_id=' + value.user_id + '">' +
                            '<span class="follow-icon">' +
                            '<i class="far fa-heart"></i>' +
                            '</span>' +
                            '<span class="followText">' + wishlistUnFollowText +
                            '</span>' +
                            '</a>';
                    } else {
                        layout = layout + '<a class="follow staff_follow-button staff-follow" type="button" data-user-id="' + value.user_id + '" data-attr="' + wishlistStaffDetails + '?user_id=' + value.user_id + '" data-updateurl="' + wishlistUpdateStaffFollowList + '?user_id=' + value.user_id + '">' +
                            '<span class="follow-icon">' +
                            '<i class="far fa-heart"></i>' +
                            '</span>' +
                            '<span class="followText">' + wishlistFollowText +
                            '</span>' +
                            '</a>';
                    }
                } else {
                    layout = layout + '<a class="follow staff-follow" type="button" data-user-id="' + value.user_id + '" href="' + wishlistShowLink + '">' +
                        '<span class="follow-icon">' +
                        '<i class="far fa-heart"></i>' +
                        '</span>' +
                        '<span class="followText">' + wishlistFollowText +
                        '</span>' +
                        '</a>';
                }
                layout = layout + '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                var createdDateTime = value.created_at;
                var createdDate = createdDateTime.split(" ");
                layout = layout + '<div class="co-created-date">' + createdDate[0] + '</div>' +
                    '<div class="staff-comment">' +
                    '<span class="more">' +
                    value.comment +
                    ' </span>' +
                    '</div>' +
                    '<div class="tags_list co-tag-lists"></div>' +
                    '<div class="coordinate-products">';
                if (value.products != undefined) {
                  $.each(value.products, function(productkey,productvalue) {
                    checkonlinestatus(productvalue.product_code);
                    layout = layout+'<div class="coordinate-product-details" id="'+productvalue.product_code+'">'
                              +'<div class="img">'
                              +'<a href="'+coordinateDetailLink+'?pid='+productvalue.product_code
                              +'"data-event="event-data-PDS-thumbnail" data-click="'+productvalue.product_code+'">'
                              +'<img src="'+productvalue.image_url+'"/></div>'
                              +'</a>'
                              +'<div id="test" class="red out-of-stock-label'+productvalue.product_code+'"></div>'
                              +'<div class="coordinate-product-name">'
                                +'<a href="'+coordinateDetailLink+'?pid='+productvalue.product_code+'" class="clickForDetail" data-event="event-data-PDS-thumbnail" data-click="'+productvalue.product_code+'">' +productvalue.name+ '</a>'
                              +'</div>'
                              +'<div class="co-product-price">'+ currencysign + productvalue.selling_price+'</div>'
                              +'<div class="co-product-size">'+productvalue.size+'</div>'
                              +'</div>';
                  });

                }
                layout = layout + '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                coordinateListSlot(value.user_id);
            });
            $(".coordinate-details").append(layout);
            createCoordinateListsByStaff();
            createCoordinateListsHeading();
            coordinateTagsLists(tags);
            readMore();
        }

        function coordinateTagsLists(tags) {
            if (tags.length > 0) {
                var layout = '<ul class="tags">';
                $.each(tags, function(key, value) {
                    if (key > 9) {
                        layout = layout +
                            '<li class="taggrid hide" data-index="' + key + '">' +
                            '<a href="' + PLPLink + '?tag_id=' + value + '&cgid=outFits-New" class="tag" data-tag-id="' + value + '" data-tag-name="' + value + '">' + value + '</a>' +
                            '</li>';
                    } else {
                        layout = layout +
                            '<li class="taggrid" data-index="' + key + '">' +
                            '<a href="' + PLPLink + '?tag_id=' + value + '&cgid=outFits-New" class="tag" data-tag-id="' + value + '" data-tag-name="' + value + '">' + value + '</a>' +
                            '</li>';
                    }
                });
                if (tags.length > 10) {
                    layout = layout +
                        '<li class="viewmoreTagLi viewmoreTagCO" data-index="viewmore">' +
                        '<a href="javascript:void(0);" class="viewmoreTag">' + $(".viewMoreText").val() +
                        '<div id="ss-w-alhd-sp-searchFormMenu_arrow" class="ss-w-alhd-sp-menu-arrows ss-w-alhd-sp-menu-arrows-down"></div>' +
                        '</a>' +
                        '</li>';
                }
                layout = layout + '</ul>';
                $(".tags_list").empty();
                $(".tags_list").append(layout);
            } else {}
        }

        function createCoordinateListsByStaff() {
            var staffName = $("#staff-name").data('user-name');
            var user_id = $("#staff-id").data('user-id');
            var layout = '';
            layout = layout + '<a href="' + staffDetailsLink + '?user_id=' + user_id + '">' +
                '<button type="button">' + seeMorecoordinates + " >>" + '</button>' +
                '</a>';
            $(".coordinateListByStaff-button").append(layout);
        }

        function createCoordinateListsHeading() {
            var staffName = $("#staff-name").data('user-name');
            var user_id = $("#staff-id").data('user-id');
            var layout = '';
            layout = layout + '<div>' + staffName + othercoordinates + '</div>';
            $(".coordinateListByStaff-heading").append(layout);
        }

        function tagList() {
            var layoutTag = '';
            $.ajax({
                url: CoordinateTagsList,
                success: function(res) {
                    var result = $.parseJSON(res.obj);
                    if (result.total > 0) {
                        var layout = '<ul class="tags">';
                        $.each(result.item, function(key, value) {
                            if (key > 9) {
                                layout = layout +
                                    '<li class="taggrid hide" data-index="' + key + '">' +
                                    '<a href="' + PLPLink + '?tag_id=' + value.tag_name + '&cgid=outFits-New" class="tag" data-tag-id="' + value.tag_id + '" data-tag-name="' + value.tag_name + '">' + value.tag_name + '</a>' +
                                    '</li>';
                            } else {
                                layout = layout +
                                    '<li class="taggrid" data-index="' + key + '">' +
                                    '<a href="' + PLPLink + '?tag_id=' + value.tag_name + '&cgid=outFits-New" class="tag" data-tag-id="' + value.tag_id + '" data-tag-name="' + value.tag_name + '">' + value.tag_name + '</a>' +
                                    '</li>';
                            }
                        });
                        if (result.total > 10) {
                            layout = layout +
                                '<li class="viewmoreTagLi viewmoreTagCO" data-index="viewmore">' +
                                '<a href="javascript:void(0);" class="viewmoreTag">' + $(".viewMoreText").val() +
                                '<div id="ss-w-alhd-sp-searchFormMenu_arrow" class="ss-w-alhd-sp-menu-arrows ss-w-alhd-sp-menu-arrows-down"></div>' +
                                '</a>' +
                                '</li>';
                        }
                        layout = layout + '</ul>';
                        $(".tags_list").empty();
                        $(".tags_list").append(layout);
                    } else {}
                }
            });
        }

        function readMore() {
            var showChar = 100;
            var ellipsestext = "...";
            var moretext = "もっと見る";
            var lesstext = "閉じる";
            $('.more').each(function() {
                var content = $(this).html();
                var str = content.split('<br>').splice(2).join('<br>');
                if (str.length > 0) {
                    var c = content.split('<br>');
                    var h = str;
                    var pre_str = '';
                    if (c[0] != undefined) {
                        pre_str = pre_str + c[0];
                    }
                    if (c[1] != undefined) {
                        pre_str = pre_str + "<br>" + c[1];
                    }
                    var html = pre_str + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent"><span><br>' + h + '</span><a href="" class="morelink">' + moretext + '</a></span>';
                    $(this).html(html);
                }
            });
            $(".morelink").click(function() {
                if ($(this).hasClass("less")) {
                    $(this).removeClass("less");
                    $(this).html(moretext);
                } else {
                    $(this).addClass("less");
                    $(this).html(lesstext);
                }
                $(this).parent().prev().toggle();
                $(this).prev().toggle();
                return false;
            });
        }
        startCoordinateDetail();
        setTimeout(function() {
            $(".thumb-img").on("click", ".coordinate-sub-img", function() {
                var index = $(this).parent('li').data("index");
                var imgsrc = $(this).find("img").attr("src");
                $(".sub-image-thumbnails").removeClass("active");
                $(this).parent('li').addClass("active");
                $(".coordinate-primary-img img").attr("src", imgsrc);
            });
            $(".prev-next-img").on("click", ".prev-button", function() {
                var imgIndex = $(".sub-image-thumbnails.active").data("index");
                var preImgNo = imgIndex - 1;
                if (preImgNo >= 0) {
                    $('li[data-index="' + preImgNo + '"]').children('a.coordinate-sub-img').trigger('click');
                    $(".sub-image-thumbnails").removeClass("active");
                    $('li[data-index="' + preImgNo + '"]').addClass("active");
                }
            });
            $(".prev-next-img").on("click", ".next-button", function() {
                var imgIndex = $(".sub-image-thumbnails.active").data("index");
                var nextImgNo = imgIndex + 1;
                var totalImg = $(".total-thumbnail-img").data("attr");
                if (totalImg >= nextImgNo) {
                    $('li[data-index="' + nextImgNo + '"]').children('a.coordinate-sub-img').trigger('click');
                    $(".sub-image-thumbnails").removeClass("active");
                    $('li[data-index="' + nextImgNo + '"]').addClass("active");
                }
            });
            $(".viewmoreTagCO.viewmoreTagLi").on('click', '.viewmoreTag', function() {
                $(".co-tag-lists .tags li").each(function() {
                    if ($(this).data("index") > 9 && $(this).data("index") != "viewmore") {
                        $(this).toggleClass("hide");
                    }
                });
                if ($("#ss-w-alhd-sp-searchFormMenu_arrow").hasClass("ss-w-alhd-sp-menu-arrows-down")) {
                    $(this).html('もっと見る <div id="ss-w-alhd-sp-searchFormMenu_arrow" class="ss-w-alhd-sp-menu-arrows ss-w-alhd-sp-menu-arrows-up"></div>');
                } else {
                    $(this).html('閉じる <div id="ss-w-alhd-sp-searchFormMenu_arrow" class="ss-w-alhd-sp-menu-arrows ss-w-alhd-sp-menu-arrows-up"></div>');
                }
            });
            $(".staff-follow-button").on("click", ".staff-follow", function() {
                var dataUrl = $(".staff-follow").data('attr');
                $(".staff-follow").children(".follow-icon").empty();
                $(".staff-follow").children(".follow-icon").append('<i class="fa fa-spinner fa-spin"></i>');
                $.ajax({
                    url: dataUrl,
                    success: function() {
                        wishlistupdate();
                    }
                });
            });
        }, 3000);
    }
    if ($(".currentPage").val() == "staffDetailsPage") {
        var paginginformation_next = $(".paginginformation_next").val();
        var paginginformation_prev = $(".paginginformation_prev").val();
        var wishlistFollowText = $(".wishlistFollowText").val();
        var wishlistUnFollowText = $(".wishlistUnFollowText").val();

        function startStaffDetail() {
            //offset
            var pageno = $(".paginationSD ol li.active").children('a').data('pageno');
            var offset = (parseInt(pageno) * defaultCount) + 1;
            var reqArr = new Array();
            reqArr["defaultCount"] = defaultCount;
            reqArr["offset"] = offset;
            reqArr["user_id"] = $(".userid").val(); // need to send it as a dynamic value when calling
            coordinateListByStaff(reqArr, null);
        }

        function coordinateListByStaff(reqArr, tagClicked) {
            var params = {
                'count': reqArr['defaultCount'], // need to send it as a dynamic value when calling
                'user_id': reqArr['user_id'],
                'offset': reqArr['offset']
            };
            $.ajax({
                url: coordinateListContrLink,
                data: params,
                success: function(res) {
                    var result = $.parseJSON(res.obj);
                    if (result.total > 0) {
                        createCoordinateList(result, null, null);
                        var is_paginate = false;
                        $(".paginationSD ol").each(function() {
                            var anchor = $(this).find("a");
                            if (tagClicked[0] == anchor[0]) {
                                is_paginate = true;
                            }
                        });
                        if (!$.trim($(".paginationSD").html()).length || is_paginate !== true) {
                            createPaginationSD(result);
                        }
                    }
                }
            });
        }

        function createPaginationSD(result) {
            // paginate
            if (result.total > defaultCount) {
                var pages = Math.ceil(result.total / defaultCount);
                var paginate = '';
                if (pages > 3) {
                    paginate = paginate +
                        '<a href="javascript:void(0);" class="pagination-prevSD hide" data-total-pages="' + pages + '">' +
                        '<i class="fa fa-angle-left fa-lg"></i>' +
                        '<span class="visually-hidden"><isprint value="' + paginginformation_prev + '" encoding="on" /></span>' +
                        '</a>';
                }
                var hide = '';
                if (pages > 1) {
                    for (var i = 1; i <= pages; i++) {
                        var active = '';
                        if (i == 1) {
                            active = 'active';
                        } else if (i > 3) {
                            hide = 'hide';
                        }
                        paginate = paginate +
                            '<ol>' +
                            '<li class="' + active + ' page_li_' + i + ' ' + hide + '" data-index="' + i + '">' +
                            '<a class="pageSD" data-pageno=' + i + ' href="javascript:void(0);">' + i + '</a>' +
                            '</li>' +
                            '</ol>';
                    }
                }
                if (pages > 3) {
                    paginate = paginate +
                        '<a href="javascript:void(0);" class="pagination-nextSD" data-total-pages="' + pages + '">' +
                        '<i class="fa fa-angle-right fa-lg"></i>' +
                        '<span class="visually-hidden"><isprint value="' + paginginformation_next + '" encoding="on" /></span>' +
                        '</a>';
                }
                $(".paginationSD").append(paginate);
            }
        }
        $(".paginationSD").on("click", ".pagination-prevSD", function() {
            var totalPages = $(this).data("total-pages");
            changePageSD("prev", totalPages);
        });
        $(".paginationSD").on("click", ".pagination-nextSD", function() {
            var totalPages = $(this).data("total-pages");
            changePageSD("next", totalPages);
        });

        function changePageSD(clickDirection, totalPages) {
            var active_a = $(".paginationSD").find("li.active a");
            var activePage = active_a.data("pageno");
            var activePageIndex = 0;
            if (clickDirection == "next") {
                var activePageIndex = activePage + 1;
            } else if (clickDirection == "prev") {
                var activePageIndex = activePage - 1;
            }
            if (activePageIndex > 0 && activePageIndex < parseInt(totalPages) + 1) {
                refreshPaginateSD(activePageIndex);
                var nextPage = $(".paginationSD").find('li a[data-pageno="' + activePageIndex + '"]');
                active_a.removeClass("active selected");
                active_a.parent("li").removeClass("active selected");
                toggleActiveClassSD(nextPage);
                onClickCreateRequestParamsSD(nextPage);
            }
        }
        $(".paginationSD").on("click", ".pageSD", function() {
            var curr_index = $(this).parent('li').data("index");
            refreshPaginateSD(curr_index);
            toggleActiveClassSD($(this));
            onClickCreateRequestParamsSD($(this));
        });

        function refreshPaginateSD(curr_index) {
            var totalNoOfPages = $(".pagination-prevSD").data("total-pages");
            $(".paginationSD .pageSD").removeClass("active selected");
            $(".paginationSD .pageSD").parent("li").removeClass("active selected");
            $(".paginationSD li").addClass("hide");
            if (curr_index > 1) {
                for (var i = curr_index; i <= (curr_index + 1); i++) {
                    $(".paginationSD li.page_li_" + i).removeClass("hide");
                }
                for (var i = curr_index; i >= (curr_index - 1); i--) {
                    $(".paginationSD li.page_li_" + i).removeClass("hide");
                }
            } else {
                for (var i = curr_index; i <= (curr_index + 2); i++) {
                    $(".paginationSD li.page_li_" + i).removeClass("hide");
                }
            }
            if (curr_index > 2 && totalNoOfPages > 1) {
                $(".pagination-prevSD").removeClass("hide");
            } else {
                $(".pagination-prevSD").addClass("hide");
            }
            if (curr_index == totalNoOfPages && totalNoOfPages > 1) {
                $(".pagination-nextSD").addClass("hide");
                for (var i = curr_index; i >= (curr_index - 2); i--) {
                    $(".paginationSD li.page_li_" + i).removeClass("hide");
                }
            } else {
                $(".pagination-nextSD").removeClass("hide");
            }
        }

        function onClickCreateRequestParamsSD(tagClicked) {
            var pageno = $(".paginationSD ol li.active").children('a').data('pageno');
            var offset = (parseInt(pageno) - 1) * defaultCount;
            var reqArr = new Array();
            reqArr["defaultCount"] = defaultCount;
            reqArr["offset"] = offset;
            reqArr["user_id"] = $(".userid").val();
            coordinateListByStaff(reqArr, tagClicked);
        }

        function toggleActiveClassSD(tagClicked) {
            tagClicked.toggleClass("active selected");
            tagClicked.parent('li').toggleClass("active selected");
        }
        startStaffDetail();
        setTimeout(function() {
            $(".staff-follow-button").on("click", ".staff-follow", function() {
                var dataUrl = $(".staff-follow").data('attr');
                var updateFollow = $(".staff-follow").data('updateFollow');
                $(".staff-follow").children(".follow-icon").empty();
                $(".staff-follow").children(".follow-icon").append('<i class="fa fa-spinner fa-spin"></i>');
                $.ajax({
                    url: dataUrl,
                    success: function() {
                        wishlistupdate();
                        console.log(dataUrl);
                    }
                });
            });
        });
    }

    function wishlistupdate() {
        var updateUrl = $(".staff-follow").data("updateurl");
        $.ajax({
            url: updateUrl,
            success: function(res) {
                var result = $.parseJSON(res.result);
                if (result) {
                    $(".followText").html(wishlistUnFollowText);
                    $(".staff-follow").children(".follow-icon").empty();
                    $(".staff-follow").children(".follow-icon").append('<i class="far fa-heart"></i>');
                } else {
                    $(".followText").html(wishlistFollowText);
                    $(".staff-follow").children(".follow-icon").empty();
                    $(".staff-follow").children(".follow-icon").append('<i class="far fa-heart"></i>');
                }
            }
        });
    }
    function LoadProductsInventory() {
      $.ajax({
          url:$(".GetProductModal").val(),
          success: function(res) {
            console.log(res);
          }
        })
      }
      // LoadProductsInventory();



});

},{}],2:[function(require,module,exports){
'use strict';

window.dataLayer = window.dataLayer || [];

var analyticsData;
var currentPage;
var pageData;
var globalData;
var cache = {};

var util = require('./util');
var pageEventsConfig = require('./events').pageEventsConfig;
var pageEvents = require('./events').pageEvents;

/**
 * Init Global Variables
 */
function initGlobalVariables() {
    globalData = cache.$globalData.data('analytics') || {};

    if (cache.$pageData.length > 1) {
        var analytics = {};

        cache.$pageData.each(function(i, obj) {
            var analyticalData = $(obj).data('analytics');

            Object.keys(analyticalData).forEach(function (key) {
                analytics[key] = analyticalData[key];
            });
        });

        pageData = analytics || {};
    } else {
        pageData = cache.$pageData.data('analytics') || {};
    }
    analyticsData = Object.assign({ globalData: globalData, pageData: pageData, userData: globalData.userData });
    currentPage = pageData.pageContext;
}

/**
 * load events based on pages
 */
function loadEvents() {
    var eventList = $.merge(
        pageEventsConfig.global || [],
        pageEventsConfig[currentPage] || []
    );
    util.initFunctions(eventList, pageEvents, analyticsData);
}

/**
 * Init Cache Globally from the page
 */
function initGA4Cache() {
    cache.$globalData = $('.analytics-global');
    cache.$pageData = $('.analytics-page');
}



/**
 * Initiate GA4 Events
 */
function init() {
    initGA4Cache();
    initGlobalVariables();

    if (globalData && (globalData.market === 'NZ' ? globalData.ga4EnabledNZ : globalData.ga4Enabled)) {
        loadEvents();
        $('body').trigger('analytics:EventsLoadCompleted');
    }
}

module.exports = init;
$(document).ready(function () {
    init();
});
},{"./events":3,"./util":4}],3:[function(require,module,exports){
'use strict';

var pageEventsConfig = {
    global: ['pageLoad', 'productClick', 'videoTracking', 'addToWishlist', 'shareProductEvent', 'storeLocator', 'scrollTrackingEvent', 'checkoutBegin', 'recommendedProductEvent',
        'formValidationErrors','trackOrderEvent','newsletterSubscriptionEvent', 'resourceLoadError', 'filterTrackEvent', 'leviEmailSMSsubscriptionEvent', 'promotionImpression',
        'loginSignup', 'loginSignUpJourney', 'forgotPasswordClickEvent', 'productDetail', 'outOfStockVariants'],
    error: ['pageErrors'],
    product: ['addToCart','productReviewEvent', 'easySizeCheck', 'sizeguideClickEvent', 'viewStoreInventoryPopupEvent'],
    cart: ['removeFromCart','couponCodeSuccess', 'couponCodeError','addOrRemoveQtyOnCartPage'],
    checkout: ['couponCodeSuccess', 'couponCodeError', 'transactionFailedError', 'transactionDiscrepancy', 'addShippingInfo', 'addPaymentInfo'],
    search: ['addToCart', 'searchInitiatedEvent', 'pageErrors','sortByEvent', 'productListPerformance'],
    confirmation: ['orderSuccess']
};

/**
 * This function will return a hashed email with SHA-256 algorithm
 * @param {*} email email
 */
function getHashedEmail(email) {
    const encoder = new TextEncoder();
    const data = encoder.encode(email);
    const hash = crypto.subtle.digest("SHA-256", data);

    window.usersHashedEmail = ''; // clear global variable.
    hash.then(function (digestBuffer) {
        var hashArray = Array.from(new Uint8Array(digestBuffer)) // convert buffer to byte array
        const hashHex = hashArray
            .map(function (b) { return b.toString(16).padStart(2, "0"); })
            .join(""); // convert bytes to hex string
        window.usersHashedEmail = hashHex; // store data to global variable.
    });
}

/**
 *
 * @param {*} data data which will be pushed to dataLayer
 */
function pushData(data) {
    if (!('dataLayer' in window)) {
        window.dataLayer = [];
    }

    window.dataLayer.push(data);
}

var pageEvents = {
    /**
     * This event is trigger on every page load and push the page data to dataLayer object
     * @param {Object} analyticsData analytics data
     */
    pageLoad: function (analyticsData) {
        var pageType = analyticsData.pageData.pageType;
        var pageCategory = analyticsData.pageData.pageCategory;

        if (pageType !== 'shop' && window.location.href.match(/\/(\w|-)*(sustainability)(\w|-)*$/gi)) {
            pageType = 'sustainability';
            pageCategory = 'consideration';

            if(analyticsData.pageData) {
                analyticsData.pageData.pageType = 'sustainability';
                analyticsData.pageData.pageCategory = 'consideration';
            }
        }

        var eventData = {
            'page_type': pageType,
            'market': analyticsData.globalData.market,
            'page_category': pageCategory,
            'event_name':'page_view',
            'event':'hm_page_load'
        };

        if (analyticsData.pageData && analyticsData.pageData.pageContext && analyticsData.pageData.pageContext === 'product') {
            eventData.product_composition = $('<p>' + analyticsData.pageData.productComposition + '</p>').text().slice(0,99);
            eventData.product_description = $('<p>' + analyticsData.pageData.productDescription + '</p>').text().slice(0,99);
            eventData.how_it_fits = $('<p>' + analyticsData.pageData.productFit + '</p>').text().slice(0,99);
        }
        pushData(eventData);

    },

    /**
     * This event will trigger when form validation errors occur.
     * @param {Object} analyticsData analytics data
     */
    formValidationErrors: function (analyticsData) {
        function pushFormErrors(event, validator) {
            var formValidation;

            if (validator) {
                formValidation = validator;
            } else {
                formValidation = $(event.target).closest('form').validate();
            }

            if(formValidation.errorList.length) {
                formValidation.errorList.forEach(function (errorDetail) {
                    var fieldName;

                    if (errorDetail.method === 'required') {
                        var elementName = $(errorDetail.element).attr('id').match(/_\w+/g);
                        if (!elementName) {
                            elementName = $(errorDetail.element).attr('name').match(/_\w+/g);
                        }
                        if (!elementName) {
                            elementName = $(errorDetail.element).attr('name');
                        }
                        if (elementName && typeof elementName !== 'string' && elementName.length) {
                            fieldName = elementName[0].replaceAll('_', ' ').trim();
                        }
                    }

                    pushData({
                        'event_category':'engagement',
                        'event_action':'error_validation',
                        'event_label': errorDetail.message,
                        'error_type': fieldName ? 'required ' + fieldName : errorDetail.method,
                        'error_message': errorDetail.message,
                        'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                        'page_type': analyticsData.pageData.pageType,
                        'market': analyticsData.globalData.market,
                        'page_category': analyticsData.pageData.pageCategory,
                        'event_name':'engagement_error',
                        'event':'hm_push_event'
                    });
                });
            }
        }

        $('body').on('analytics:pushFormErrors', pushFormErrors);
        /**
         * To use above event please trigger it where you want to push form errors to dataLayer.
         *
		 * $('body').trigger('analytics:pushFormErrors', $form.validate());
         */
    },

    /**
     * Page Errors
     * @param {Object} analyticsData analytics data
     */
    pageErrors: function (analyticsData) {
        if(analyticsData.pageData.errorType && analyticsData.pageData.errorMessage){
            var dataObj = {
                'event_category':'engagement',
                'event_action': analyticsData.pageData.eventAction,
                'event_label': analyticsData.pageData.errorMessage,
                'error_type': analyticsData.pageData.errorType,
                'error_message': analyticsData.pageData.errorMessage,
                'line_no': analyticsData.pageData.lineNo,
                'js_script_name': analyticsData.pageData.scriptFileName,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event_name':'engagement_error',
                'event':'hm_push_event'
            };

            if (analyticsData.pageData && analyticsData.pageData.searchTerm) {
                dataObj.search_term =  analyticsData.pageData.searchTerm;
            }
            if (analyticsData.pageData.errorCode) {
                dataObj.error_code = analyticsData.pageData.errorCode;
            }
            pushData(dataObj);
        }
    },

    /**
     * This event will trigger when we got some coupon errors.
     * @param {Object} analyticsData analytics data
     */
    couponCodeError: function(analyticsData) {
        $('body').on('analytics:invalidCoupon', function (event, data) {
            pushData({
                'event_category': 'engagement',
                'event_action': 'error_coupon',
                'event_label': data.status,
                'error_type': 'invalid coupon',
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'coupon_code': data.couponCode,
                'event_name': 'engagement_error',
                'event': 'hm_push_event'
            });
        });
    },

    /**
     * This event will trigger when we initiate serch.
     * @param {Object} analyticsData analytics data
     */
    searchInitiatedEvent: function(analyticsData) {
        if (analyticsData.pageData && analyticsData.pageData.searchTerm && analyticsData.pageData.searchTerm !== '') {
            pushData({
                'event_category': 'engagement',
                'event_action': 'click_textbox_header',
                'event_label': 'na : search',
                'search_term': analyticsData.pageData.searchTerm,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event_name': 'engagement_click',
                'event': 'hm_push_event'
            });
        }
    },

    /**
     * Transaction Failed Error
     * @param {Object} analyticsData analytics data
     */
    transactionFailedError: function (analyticsData) {
        $('body').on('analytics:transactionFailed', function (event, data) {
            var dataObj = {
                'event_category':'engagement',
                'event_action': 'error_transaction',
                'event_label': data.errorLabel,
                'error_type': data.errorType,
                'error_code': data.errorCode,
                'error_message': data.errorMessage,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event_name':'engagement_error',
                'event':'hm_push_event'
            }
            pushData(dataObj);
        });
    },
    /**
     * Transaction Discrepancy
     * @param {Object} analyticsData analytics data
     */
    transactionDiscrepancy: function (analyticsData) {
        $('body').on('analytics:transactionDiscrepancy', function (event, data) {
            pushData({
                'event_category':'engagement',
                'event_action': 'load_na',
                'event_label': 'na : pre-purchase',
                'payment_method': data.paymentMethod,
                'transaction_id': data.transactionId,
                'order_number': data.orderNumber,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'metric_transaction_revenue': data.matrixTransactionRevenue,
                'event_name':'engagement_load',
                'event':'hm_push_event'
            });
        });
    },
    /**
     * Order Success
     * @param {Object} analyticsData analytics data
     */
    orderSuccess: function (analyticsData) {
        $('body').on('analytics:orderSuccess', function (event, data) {
            var products = data.items.map(function (pro) {
                return {
                    item_name: pro.item_name,
                    item_id: pro.item_id,
                    price: pro.price,
                    item_brand: pro.item_brand,
                    item_category: pro.item_category,
                    item_variant: pro.item_variant,
                    quantity: pro.quantity,
                    dimension49: pro.dimension49,
                    dimension48: pro.dimension48,
                    dimension44: pro.dimension44,
                    dimension45: pro.dimension45,
                    dimension46: pro.dimension46,
                    dimension47: pro.dimension47,
                    dimension41: pro.dimension41,
                    dimension50: pro.dimension50,
                    coupon: pro.coupon
                }
            });

            pushData({
                'event_category':'ecommerce',
                'event_action': 'purchase',
                'event_label': 'na',
                'payment_method': data.paymentMethod,
                'order_number': data.orderNumber,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event':'purchase',
                'discount': data.discount,
                'ecommerce': {
                    'transaction_id': data.transactionId,
                    'gift_wrap_charge': data.giftWrapCharge,
                    'hemming': data.hemmingFees,
                    'affiliation': 'Online Store',
                    'value': data.value,
                    'tax':data.tax,
                    'shipping': data.shipping,
                    'currency': analyticsData.globalData.currencyCode,
                    'coupon': data.couponCodes,
                    'items': products
                }
            });
        });
    },
    /**
     * Checkout Begin Event
     * @param {Object} analyticsData analytics data
     */
    checkoutBegin: function (analyticsData) {
        function begin(event) {
            if ($(this).data('isdisabled') === 'disabled') {
                return;
            }
            var products = $('.mini-cart-content .productDataGA4').data('product-analytics') || [];
            if (event.data.page === 'pdp') {
                var product = $('#pdpMain .productDataGA4.pdp[data-product-analytics]').data('product-analytics');
                if (product) {
                    var quantity = $('select#quantity').val();
                    var productExist = products.find(function (pro) { return  pro.dimension41 === product.dimension41; });
                    if(productExist) {
                        products[products.indexOf(productExist)].quantity += parseInt(quantity);
                    } else {
                        product.quantity = quantity && parseInt(quantity) ? parseInt(quantity) : product.quantity;
                        products.push(product);
                    }
                }
            }
            if (products.length) {
                var index = -1;
                var products = products.map(function (pro) {
                    index++;
                    return {
                        item_name: pro.item_name,
                        item_id: pro.item_id,
                        price: pro.price,
                        index: index,
                        item_brand: pro.item_brand,
                        item_category: pro.item_category,
                        item_list_name: pro.item_list_name,
                        item_variant: pro.item_variant,
                        quantity: pro.quantity,
                        dimension49: pro.dimension49,
                        dimension48: pro.dimension48,
                        dimension44: pro.dimension44,
                        dimension45: pro.dimension45,
                        dimension46: pro.dimension46,
                        dimension47: pro.dimension47,
                        dimension41: pro.dimension41
                    }
                });

                pushData({
                    'event_category': 'ecommerce',
                    'event_action': 'begin_checkout',
                    'event_label': 'na',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'begin_checkout',
                    'ecommerce': {
                        'currency': analyticsData.globalData.currencyCode,
                        'items': products
                    }
                });
            }
        }

        $('body').on('analytics:beginCheckout', function (event, data) {
            $('#pdpMain button#buy-now').on('click', '', data, begin);
        });
        $('#pdpMain button#buy-now').on('click', '', { page: 'pdp' }, begin);
        $('body').on('click', '.mini-cart-buttons .mini-cart-link-checkout', { page: 'minicart' }, begin);
        $('body').on('click', 'button[name*="_cart_checkoutCart"]', { page: 'minicart' }, begin);
    },

    /**
     * Add Shipping Info Event
     * @param {Object} analyticsData analytics data
     */
    addShippingInfo: function (analyticsData) {
        function addShippingInfoEvent(event) {
                var index = -1;
                var products = analyticsData.pageData.products.map(function (pro) {
                    index++;
                    return {
                        item_name: pro.item_name,
                        item_id: pro.item_id,
                        price: pro.price,
                        index: index,
                        item_brand: pro.item_brand,
                        item_category: pro.item_category,
                        item_list_name: pro.item_list_name,
                        item_variant: pro.item_variant,
                        quantity: pro.quantity,
                        dimension49: pro.dimension49,
                        dimension48: pro.dimension48,
                        dimension44: pro.dimension44,
                        dimension45: pro.dimension45,
                        dimension46: pro.dimension46,
                        dimension47: pro.dimension47,
                        dimension41: pro.dimension41
                    }
                });

                pushData({
                    'event_category': 'ecommerce',
                    'event_action': 'add_shipping_info',
                    'event_label': 'na',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'add_shipping_info',
                    'ecommerce': {
                        'currency': analyticsData.globalData.currencyCode,
                        'items': products
                    }
                });
        }
        if ($('body').hasClass('LeviKR') || $('body').hasClass('LeviIN')) {
            if( $('.shipToHome.saved-add').length) {
                $('.shipToStore,.shipToHome').on('click', '[name$="_shippingAddress_save"]', addShippingInfoEvent);
            }
        } else {
            $('[name$="_shippingAddress_save"]').on('click', addShippingInfoEvent);
        }
    },

    /**
     * Add Payment Info Event
     * @param {Object} analyticsData analytics data
     */
    addPaymentInfo: function (analyticsData) {
        $('[name$="_billing_save"]').on('click', function(event) {
            var index = -1;
            var products = analyticsData.pageData.products.map(function (pro) {
                index++;
                return {
                    item_name: pro.item_name,
                    item_id: pro.item_id,
                    price: pro.price,
                    index: index,
                    item_brand: pro.item_brand,
                    item_category: pro.item_category,
                    item_list_name: pro.item_list_name,
                    item_variant: pro.item_variant,
                    quantity: pro.quantity,
                    dimension49: pro.dimension49,
                    dimension48: pro.dimension48,
                    dimension44: pro.dimension44,
                    dimension45: pro.dimension45,
                    dimension46: pro.dimension46,
                    dimension47: pro.dimension47,
                    dimension41: pro.dimension41
                }
            });

            pushData({
                'event_category': 'ecommerce',
                'event_action': 'add_payment_info',
                'event_label': 'na',
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event': 'add_payment_info',
                'ecommerce': {
                    'currency': analyticsData.globalData.currencyCode,
                    'payment_type': $('.payment-method').find('input:checked').val() || $('.payment-method').data('method'),
                    'items': products
                }
            });
        });
    },

    /**
     * This event will trigger when newsletter subscribes.
     * @param {Object} analyticsData analytics data
    */
    newsletterSubscriptionEvent: function(analyticsData) {
        $('body').on('analytics:newsletterSubscriptionEvent', function (event, data) {
            getHashedEmail(data.emailValue);
            setTimeout(function () {
                pushData({
                    'event_category':'acquisition',
                    'event_action':'newsletter_subscription',
                    'event_label': data.headingText.trim() + ' : ' + data.buttonText.trim(),
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'page_category': analyticsData.pageData.pageCategory,
                    'market': analyticsData.globalData.market,
                    'hashed_email_id': window.usersHashedEmail,
                    'newsletter_subscribed':'yes',
                    'subscription_medium': 'email',
                    'event_name':'login',
                    'event': "hm_push_event"
                });
            }, 1);
        });
    },

    /**
     * Resource Loading Error
     * @param {*} analyticsData analytics data
     */
    resourceLoadError: function(analyticsData){
        $('img, script').on('error', function (event) {
            var errorMessage = (event.target.tagName === 'IMG' ? event.target.src.split('/images')[1] : event.target.src) + ' not found';
            pushData({
                'event_category': 'engagement',
                'event_action': 'error_page_load',
                'event_label': 'resource not found',
                'error_type': 'not found',
                'error_code':'404',
                'error_message':errorMessage,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event_name': 'engagement_error',
                'event': 'hm_push_event'
            });
        });
    },
    /**
    * Login/Signup event
    * @param {*} analyticsData analytics data
    */
    loginSignup: function (analyticsData) {
        if (analyticsData && analyticsData.userData && analyticsData.userData.loginSignupData) {
            var loginSignupData = analyticsData.userData.loginSignupData;
            var dataObj = {
                'event_category':'acquisition',
                'event_action': loginSignupData.eventAction,
                'event_label': loginSignupData.eventLabel,
                'login_method': loginSignupData.loginType,
                'membership_tier': undefined,
                'newsletter_subscribed': 'no',
                'user_id': analyticsData.userData ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'hashed_email_id': analyticsData.userData.hashedEmail,
                'event_name': loginSignupData.eventName,
                'event':'hm_push_event'
            };
            if (loginSignupData.addToSmsList || loginSignupData.addEmailList) {
                var subscriptionMedium = undefined;
                if (loginSignupData.addEmailList) {
                    subscriptionMedium += 'email';
                    dataObj.newsletter_subscribed = 'yes';
                }
                if (loginSignupData.addToSmsList) {
                    subscriptionMedium += (subscriptionMedium === undefined) ? 'sms' : ',sms';
                }
                dataObj.subscription_medium = subscriptionMedium;
            }
            pushData(dataObj);
        }
    },

    /**
     * This event will trigger click on size guide link on PDP page.
     * @param {Object} analyticsData analytics data
    */
    sizeguideClickEvent: function(analyticsData) {
        $('.size-chart-link a').on('click', function(e){
            var product = $('.productDataGA4').data('product-analytics');
            pushData({
                'event_name':'engagement_click',
                'event_category':'engagement',
                'event_action':'click_textlink_body',
                'event_label': (product.item_name || '') +' : size guide',
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event':'hm_push_event'
            });
        });
    },

    /**
     * This event will trigger when order tracks.
     * @param {Object} analyticsData analytics data
    */
    trackOrderEvent: function(analyticsData) {
        $('body').on('change', 'form[class*="track-order"] [id*="_ordertrack_orderEmail"]', function (event) {
            var emailValue = $(this).val();
            if (emailValue) {
                // store hashed email into window.usersHashedEmail
                getHashedEmail(emailValue);
            } else if (emailValue === ''){
                window.usersHashedEmail = '';
            }
        });
        $('body').on('click', 'form[class*="track-order"] button[type="submit"]', function (event, data) {
			var emailValue = $(this).closest('form').find('[id*="dwfrm_ordertrack_orderEmail"]').val();
            var ga4OrderTrackingEventTrigger = data ? data.ga4TrackingEventTrigger : true;
            if(emailValue && ga4OrderTrackingEventTrigger){
                pushData({
                    'event_name':'engagement_click',
                    'event_category':'engagement',
                    'event_action':'click_button_body',
                    'event_label': 'track_your_order : track_order',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'hashed_email_id': window.usersHashedEmail,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'hm_push_event'
                });
            }
        });
    },

    /**
     * This event will trigger when sort by products.
     * @param {Object} analyticsData analytics data
     */
    sortByEvent: function(analyticsData) {
        $('body').on('analytics:sortbyevent', function (event, data) {
            if (data && data.listpage && data.sortbylabel) {
                pushData({
                    'event_name':'engagement_click',
                    'event_category':'engagement',
                    'event_action':'sort_dropdown_body',
                    'event_label': data.listpage + ' : ' + data.sortbylabel,
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': "hm_push_event"
                });
            }
        });
    },

    /**
     * This function trigger when Easy Size Check popup open.
     * @param {object} analyticsData analytics data
     */
    easySizeCheck: function (analyticsData) {
        if ($('body').hasClass('LeviKR') || $('body').hasClass('LeviJP')) {
            function sizeCheckEvent(event) {
                var product = $('.pdp.productDataGA4').data('product-analytics');
                pushData({
                    'event_name':'easy_size_check_try_on',
                    'event_category':'engagement',
                    'event_action':'easy_size_check_try_on',
                    'event_label': product.item_name || '',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event':'hm_push_event'
                });
            }

            $('body').on('click', '#vs-inpage [class*="_wrapper"]:first', sizeCheckEvent);

            // This logic is for lazy loaded elements and not works with direct click event listener for this element.
            var count = 0;
            var timeUntilFoundElement = setInterval(function () {
                if ($('#vs-inpage [class*="_wrapper"] button').length) {
                    $('#vs-inpage [class*="_wrapper"] button').on('click', sizeCheckEvent);
                    clearInterval(timeUntilFoundElement);
                }
                if (count > 240) {
                    clearInterval(timeUntilFoundElement);
                }
                count++;
            }, 500);
        }
    },
    /**
     * This function push the events regarding recommendation.
     * @param {object} analyticsData analytics data
     */
    recommendedProductEvent: function(analyticsData) {
        $('body').on('click', '.jcarousel-nav.jcarousel-prev1.prev-btn-2.na-prev,.jcarousel-nav.jcarousel-next1.next-btn-2.na-next', function (event) {
            var title = $(this).hasClass('na-prev') ? 'Left' : 'Right';
            pushData({
                'event_name':'engagement_click',
                'event_category':'engagement',
                'event_action':'click_image_body',
                'event_label': 'recommended_for_you : ' + title,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event': "hm_push_event"
            });
        });
    },

    /**
     * This event will trigger when coupon applied successfully.
     * @param {Object} analyticsData analytics data
     */
    // couponCodeSuccess: function(analyticsData) {
    //     $('body').on('analytics:couponSuccess', function (event, data) {
    //         pushData({
    //             'event_name':'coupon_success',
    //             'event_category':'engagement',
    //             'event_action':'coupon_success',
    //             'event_label':'coupon_code',
    //             'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
    //             'page_type': analyticsData.pageData.pageType,
    //             'market': analyticsData.globalData.market,
    //             'page_category': analyticsData.pageData.pageCategory,
    //             'coupon_code': data.couponCode,
    //             'event':'hm_push_event'
    //         });
    //     });
    // },

    /**
     * This event is trigger when user clicks on view Store Inventory Popup.
     * @param {Object} analyticsData analytics data
     */
    viewStoreInventoryPopupEvent: function (analyticsData) {
        if ($('body').hasClass('LeviJP')) {
            $('#pdpMain').on('click', '#findinstoreenabled', function (event) {
                var productName = undefined;
                if($('h1.product-name').find('span').children().length) {
                    var $productName = $('h1.product-name').find('span');

                    while ($productName.children().length) {
                        $productName = $productName.children();
                    }
                    productName = $productName.html();
                } else {
                    productName = $('h1.product-name').find('span').html();
                }
                pushData({
                    'event_category': 'ecommerce',
                    'event_action': 'pop_up_viewed',
                    'event_label': 'view_store_inventory',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'product_name': productName,
                    'market': analyticsData.globalData.market,
                    'pop-up_message': analyticsData.pageData.pageCategory,
                    'hashed_email_id': analyticsData.userData && analyticsData.userData.hashedEmail ? analyticsData.userData.hashedEmail : undefined,
                    'event_name': 'view_store_inventory_pop_up_viewed',
                    'event':'hm_push_event'
                });
            });
        }
    },

    /**
     * This function push product impressions to dataLayer
     * @param {*} analyticsData analytics data
     */
    productDetail: function (analyticsData) {
        function productDetailHandler(event, data) {
            var products = $.map($('.pdp.productDataGA4'), function (elem, index) {
                var product = $(elem).data('product-analytics');
                var pro = {};
                if (product) {
                    pro.item_id = product.dimension41 && product.dimension41.length ? product.dimension41.slice(0,9) : product.item_id;
                    pro.item_name = product.item_name;
                    pro.item_brand = product.item_brand;
                    pro.index = index;
                    pro.item_category = product.item_category;
                    pro.item_list_name = product.item_list_name;
                    pro.item_variant = product.item_variant;
                    pro.price = product.price;
                    pro.dimension39 = product.dimension39;
                }
                return pro;
            });
            if (products.length && (!window.pdpProductViewId || window.pdpProductViewId !== products[0].item_id)) {
                pushData({
                    'event_category': 'ecommerce',
                    'event_action': 'view_item',
                    'event_label': 'na',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'view_item1',
                    'ecommerce': {
                        'currency': analyticsData.globalData.currencyCode,
                        'items': products
                    }
                });
                window.pdpProductViewId = products[0].item_id;
            }
        }
        productDetailHandler();
        $('body').on('analytics:productDetail', productDetailHandler);
    },

    /**
     * This function push the product data on product click.
     * @param {object} analyticsData analytics data
     */
    productClick: function (analyticsData) {
        function productClickEvent() {
            var $productData = $(this).closest('.product-tile').find('.productDataGA4');
            if ($productData) {
                var products = $.map($productData, function (elem, index) {
                    var product = Object.assign({}, $(elem).data('product-analytics'));
                    delete product.dimension39;
                    product.index = index;
                    return product;
                });
                pushData({
                    'event_category': 'ecommerce',
                    'event_action': 'select_item',
                    'event_label': 'na',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'select_item1',
                    'ecommerce': {
                        'item_list_id': 'related_products',
                        'item_list_name': 'Related products',
                        'items': products
                    }
                });
            }
        };
        $('.product-tile a.name-link, .product-tile .product-image a.thumb-link img').on('click', productClickEvent);
        $('body').on('analytics:productClickEvent', function () {
            $('.product-tile a.name-link, .product-tile .product-image a.thumb-link img').off('click').on('click', productClickEvent);
        });
    },
    /**
     * This function will push the event data when add to cart button clicked.
     * @param {object} analyticsData analytics data
     */
    addToCart: function (analyticsData) {
        $('body').on('click', function (event) {
            if ($(event.target).hasClass('add-to-cart')){
                var $productData = $('#pdpMain').find('.pdp.productDataGA4');
                var products = [];

                if ($productData) {
                    products = $.map($productData, function (elem, index) {
                        var product = Object.assign({}, $(elem).data('product-analytics'));
                        product.quantity = parseInt($('select#quantity option:selected').val());
                        delete product.dimension39;
                        product.index = index;
                        return product;
                    });
                }

                if (products.length) {
                    pushData({
                        'event_category': 'ecommerce',
                        'event_action': 'add_to_cart',
                        'event_label': products[0].item_name,
                        'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                        'page_type': analyticsData.pageData.pageType,
                        'market': analyticsData.globalData.market,
                        'page_category': analyticsData.pageData.pageCategory,
                        'event': 'add_to_cart1',
                        'ecommerce': {
                            'currency': analyticsData.globalData.currencyCode,
                            'items': products
                        }
                    });
                }
            }
        });
    },
    /**
     * This function will push event data regarding remove from cart event.
     * @param {object} analyticsData analytics data
     */
    removeFromCart: function (analyticsData) {
        $('button[name$="deleteProduct"]').on('click', function () {
            var productId = $(this).closest('.cart-row').find('.item-details .product-list-item .sku .value').text();
            var products = $('.mini-cart-content .productDataGA4').data('product-analytics') || [];
            if (products.length) {
                products = products.filter(function (product) {
                    return product.dimension41 === productId;
                });
                var index = -1
                products = products.map(function (pro) {
                    index++;
                    return {
                        item_name: pro.item_name,
                        item_id: pro.item_id,
                        price: pro.price,
                        index: index,
                        item_brand: pro.item_brand,
                        item_category: pro.item_category,
                        item_list_name: pro.item_list_name,
                        item_variant: pro.item_variant,
                        quantity: pro.quantity,
                        dimension49: pro.dimension49,
                        dimension48: pro.dimension48,
                        dimension44: pro.dimension44,
                        dimension45: pro.dimension45,
                        dimension46: pro.dimension46,
                        dimension47: pro.dimension47,
                        dimension41: pro.dimension41
                    }
                });
                pushData({
                    'event_category': 'ecommerce',
                    'event_action': 'remove_from_cart',
                    'event_label': products[0].item_name,
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'remove_from_cart1',
                    'ecommerce': {
                        'currency': analyticsData.globalData.currencyCode,
                        'items': products
                    }
                });
            }
        });
    },
    /**
     * Add or remove the product from the cart of cart page
     * @param {object} analyticsData analytics Data
     */
    addOrRemoveQtyOnCartPage: function (analyticsData) {
        $('.cart-row select#quantity').on('change', function (event) {
            var changedQty = parseInt($(this).find('option:selected').val());
            var productId = $(this).closest('.cart-row').find('.item-details .product-list-item .sku .value').text();
            var products = $('.mini-cart-content .productDataGA4').data('product-analytics') || [];
            var product = {};

            if (products.length) {
                product = products.find(function (pro) {
                    return pro.dimension41 === productId;
                });
                if (Object.keys(product).length) {
                    var diff = changedQty - product.quantity;
                    product.quantity = (diff < 0) ? (diff * -1) : diff ;
                    delete product.dimension39;
                    product.index = 0;

                    if (diff > 0) {
                        pushData({
                            'event_category': 'ecommerce',
                            'event_action': 'add_to_cart1',
                            'event_label': product.item_name,
                            'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                            'page_type': analyticsData.pageData.pageType,
                            'market': analyticsData.globalData.market,
                            'page_category': analyticsData.pageData.pageCategory,
                            'event': 'add_to_cart1',
                            'ecommerce': {
                                'currency': analyticsData.globalData.currencyCode,
                                'items': [product]
                            }
                        });
                    } else if (diff < 0) {
                        pushData({
                            'event_category': 'ecommerce',
                            'event_action': 'remove_from_cart',
                            'event_label': product.item_name,
                            'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                            'page_type': analyticsData.pageData.pageType,
                            'market': analyticsData.globalData.market,
                            'page_category': analyticsData.pageData.pageCategory,
                            'event': 'remove_from_cart1',
                            'ecommerce': {
                                'currency': analyticsData.globalData.currencyCode,
                                'items': [product]
                            }
                        });
                    }
                }
            }
        });
    },
    /**
     * This function shows product list on search or plp pages.
     * @param {object} analyticsData analytics data
     */
    productListPerformance: function (analyticsData) {
        function productListPerformanceHandler() {
            var $productsData = $('body').find('.product-tile');
            if ($productsData.length) {
                var products = $.map($productsData, function (elem, index) {
                    var product = Object.assign({}, $(elem).find('.productDataGA4').data('product-analytics'));
                    if (product) {
                        product.index = index;
                        delete product.dimension41;
                        delete product.dimension39;
                    }
                    return product;
                });
                var productListId = analyticsData.pageData && analyticsData.pageData.itemListId;
                var productListName = analyticsData.pageData && analyticsData.pageData.itemListName;
                if(productListId || productListName) {
                    pushData({
                        'event_category': 'ecommerce',
                        'event_action': 'view_item_list',
                        'event_label': 'na',
                        'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                        'page_type': analyticsData.pageData.pageType,
                        'market': analyticsData.globalData.market,
                        'page_category': analyticsData.pageData.pageCategory,
                        'event': 'view_item_list1',
                        'ecommerce': {
                            'item_list_id': productListId,
                            'item_list_name': productListName,
                            'currency': analyticsData.globalData.currencyCode,
                            'items': products
                        }
                    });
                }
            }
        };
        productListPerformanceHandler();
    },

    /**
     * This event will trigger when sort by products.
     * @param {Object} analyticsData analytics data
     */
    filterTrackEvent: function(analyticsData) {
        $('#main').on('click', '.refinement a , .breadcrumb-refinement-name a', function (e) {
            var filterLabel = $(this).closest('.refinement').find('h3').text();
            var filterTitle = $(this).find('label').text();
            if(filterTitle.includes('(')){
                filterTitle = filterTitle.split('(')[0];
            }
            var filterDataType = $(this).find('input').attr('type');
            if (filterDataType && filterTitle && filterLabel) {
                pushData({
                    'event_name':'engagement_click',
                    'event_category':'engagement',
                    'event_action':'filter_'+ filterDataType +'_body',
                    'event_label': filterLabel.trim() + ' : ' + filterTitle.trim(),
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': "hm_push_event"
                });
            }
        });
    },

    /**
     * This event will trigger when sort by products.
     * @param {Object} analyticsData analytics data
     */
    leviEmailSMSsubscriptionEvent: function(analyticsData) {
        if($('body').hasClass('LeviKR')){
            $('body').on('click', '[name$="dwfrm_login_register"], [name$="dwfrm_profile_register"]', function (e) {
                var emailValue = $("input[id^=dwfrm_profile_customer_email]").val();
                var smsSubscription = $(this).closest('form').find('[id$=_addtosmslist]');
                var emailSubscription = $(this).closest('form').find('[id$=_addtoemaillist]');
                var smsFormVal, emailFormVal ;
                if(smsSubscription.length && !smsSubscription.is(":disabled") ){
                    smsFormVal = smsSubscription.is(":checked");
                }
                if(emailSubscription.length && !emailSubscription.is(":disabled")){
                    emailFormVal = emailSubscription.is(":checked");
                }
                var subscriptionString = undefined;
                if(smsFormVal){
                    subscriptionString = 'sms';
                }if(emailFormVal){
                    subscriptionString = 'email';
                }if(smsFormVal && emailFormVal){
                    subscriptionString = 'sms & email';
                }

                getHashedEmail(emailValue);
                setTimeout(function () {
                    pushData({
                        'event_name':'engagement_click',
                        'event_category':'engagement',
                        'event_action':'click_button_body',
                        'event_label': 'levis_rad_tab : submit',
                        'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                        'page_type': analyticsData.pageData.pageType,
                        'hashed_email_id': window.usersHashedEmail,
                        'market': analyticsData.globalData.market,
                        'subscription_device_category': subscriptionString,
                        'page_category': analyticsData.pageData.pageCategory,
                        'event': "hm_push_event"
                    });
                }, 1);
            });
        }
    },

    /**
     * Video Tracking Event
     * @param {object} analyticsData analytics data
     */
    videoTracking: function (analyticsData) {
        function videoTrackingEventHandler(event) {
            var src = $(this).find('source') && $(this).find('source').attr('src');
            var title = 'video';
            if (src) {
                var middleStr = src.match(/\/(\w+).(\w+)$/g);
                title = middleStr.length ? middleStr[0].split('.')[0].replace('/', '') : 'video';
            }
            pushData({
                'event_name':'engagement_' + event.data.action,
                'event_category':'engagement',
                'event_action':  event.data.action + '_div_body',
                'event_label':'na : ' + title,
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event':'hm_push_event'
            });
        }

        $('video').on('play', '', { action: 'play' }, videoTrackingEventHandler);
        $('video').on('pause', '', { action: 'pause' }, videoTrackingEventHandler);
        $('video').on('seeked', '', { action: 'seek' }, videoTrackingEventHandler);
    },

    /**
     * Scroll Tracking Event
     * @param {object} analyticsData analytics data
     */
    scrollTrackingEvent: function (analyticsData) {
        var scrollTwentyFive = true;
        var scrollFifty = true;
        var scrollSeventyFive = true;
        var scrollOneHundred = true;

        $(window).bind('scroll', function() {
            window.scrollPercent = ($(window).scrollTop() / ($(document).height() - $(window).height())) * 100;

            if (window.scrollPercent >= 25 && scrollTwentyFive) {
                pushData({
                    'event_name': 'engagement_click',
                    'event_category': 'engagement',
                    'event_action': 'scroll_na_body',
                    'event_label': '25%',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event':'hm_push_event'
                });
                scrollTwentyFive = false;
            }
            if (window.scrollPercent >= 50 && scrollFifty) {
                pushData({
                    'event_name': 'engagement_click',
                    'event_category': 'engagement',
                    'event_action': 'scroll_na_body',
                    'event_label': '50%',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event':'hm_push_event'
                });
                scrollFifty = false;
            }
            if (window.scrollPercent >= 75 && scrollSeventyFive) {
                pushData({
                    'event_name': 'engagement_click',
                    'event_category': 'engagement',
                    'event_action': 'scroll_na_body',
                    'event_label': '75%',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event':'hm_push_event'
                });
                scrollSeventyFive = false;
            }
            if (window.scrollPercent >= 100 && scrollOneHundred) {
                pushData({
                    'event_name': 'engagement_click',
                    'event_category': 'engagement',
                    'event_action': 'scroll_na_body',
                    'event_label': '100%',
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event':'hm_push_event'
                });
                scrollOneHundred = false;
            }
        });
    },

    /**
     * Store Locator Event
     * @param {object} analyticsData analytics data
     */
    storeLocator: function (analyticsData) {
        $('form[id*="_storelocator"] button').on('click', function() {
            pushData({
                'event_name':'engagement_click',
                'event_category':'engagement',
                'event_action':'click_button_body',
                'event_label':'store_locator : search',
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event':'hm_push_event'
            });
        });
    },
    /**
     * Product Review Event
     * @param {*} analyticsData analytics data
     */
    productReviewEvent: function (analyticsData) {
        var product = $('#pdpMain .productDataGA4.pdp[data-product-analytics]').data('product-analytics');
        $('body').on('click', 'button[class*="bv-write-review"]', function () {
            pushData({
                'event_name':'engagement_click',
                'event_category':'engagement',
                'event_action':'click_button_body',
                'event_label': product.item_name + ' : write a review',
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event':'hm_push_event'
            });
        });
        $('body').on('click', 'button[name="bv-submit-button"]', function () {
            pushData({
                'event_name': 'engagement_click',
                'event_category': 'engagement',
                'event_action': 'click_button_body',
                'event_label': product.item_name + ' : post review',
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'event': 'hm_push_event'
            })
        });
    },

    /**
     * add to wishlist event
     * @param {*} analyticsData analytics data
     */
    addToWishlist: function (analyticsData) {
        function wishlistEvent(event, data) {
            var productName;

            if (typeof data === 'string') {
                productName = data;
            } else if (data && data.targetElement) {
                var $targetElement = data.targetElement;
                var $productTile = $targetElement.closest('.product-tile');
                var productData;
                if ($productTile.length) {
                    productData = $productTile.find('.productDataGA4').data('product-analytics');
                } else if ($targetElement.closest('#product-content').length) {
                    productData = $targetElement.closest('#product-content').find('.pdp.productDataGA4').data('product-analytics');
                }
                productName = productData && productData.item_name ? productData.item_name : undefined;
            }

            if (productName) {
                pushData({
                    'event_name': 'engagement_click',
                    'event_category': 'engagement',
                    'event_action': 'add_to_wishlist',
                    'event_label': productName.trim(),
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'hm_push_event'
                });
            }
        }
        if(analyticsData.userData && analyticsData.userData.wishlistProductName){
            wishlistEvent(null, analyticsData.userData.wishlistProductName);
        }
        $('body').on('analytics:addToWishlistEvent', wishlistEvent);
    },

    /**
     * Share Product Event
     * @param {object} analyticsData analytics data
     */
    shareProductEvent: function (analyticsData) {
        $('.share-social-icon a').on('click', function () {
            var socialMediaName = $(this).attr('id');
            if (socialMediaName.indexOf('-share-icon') !== -1) {
                socialMediaName = socialMediaName.replace('-share-icon', '');
            }
            if (socialMediaName.indexOf('-icon') !== -1) {
                socialMediaName = socialMediaName.replace('-icon', '');
            }
            var product = $('.pdp.productDataGA4').data('product-analytics') ;
            var productName = product && product.item_name;
            if (socialMediaName && productName) {
                pushData({
                    'event_name': 'engagement_click',
                    'event_category': 'engagement',
                    'event_action': 'share_this_product',
                    'event_label': socialMediaName + ' : ' + productName,
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'page_category': analyticsData.pageData.pageCategory,
                    'event': 'hm_push_event'
                });
            }
        });
    },

    /**
     * Promotion Impression Event
     * @param {object} analyticsData analytics data
     */
    // promotionImpression: function (analyticsData) {
    //     $('body').on('click', '.slide,[data-promotion-impression-event]', function (event) {
    //         pushData({
    //             'event_category': 'ecommerce',
    //             'event_action': 'view_promotion',
    //             'event_label': 'na',
    //             'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
    //             'page_type': analyticsData.pageData.pageType,
    //             'market': analyticsData.globalData.market,
    //             'page_category': analyticsData.pageData.pageCategory,
    //             'event': 'view_promotion'
    //         });
    //     });
    // },

    /**
     * Login/Signup Journey
     * @param {Object} analyticsData analytics data
     */
    loginSignUpJourney: function (analyticsData) {

        $('body').on('analytics:loginSignupJourney', function (event, data) {
            if (data) {
                var eventData = {
                    'event_category':'acquisition',
                    'event_action': data.eventAction,
                    'event_label': data.eventLabel,
                    'login_method': data.loginMethod,
                    'subscription_medium': undefined,
                    'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                    'page_type': analyticsData.pageData.pageType,
                    'market': analyticsData.globalData.market,
                    'membership_tier': undefined,
                    'page_category': analyticsData.pageData.pageCategory,
                    'hashed_email_id': data.hashedEmail,
                    'event_name': data.eventName,
                    'event':'hm_push_event'
                };

                if(data && data.subscriptionMedium) {
                    eventData.subscription_medium = data.subscriptionMedium;
                }

                pushData(eventData);
            }
        });

        // For News Letter field of login sign up event journey
        function newsletterField(target) {
            var newsletterFields = '';
            if($(target).closest('form').find('[id*="_addtoemaillist"],[id*="_addtosmslist"]').length) {
                var $addToEmailList = $(target).closest('form').find('[id*="_addtoemaillist"]');
                var $addToSMSList = $(target).closest('form').find('[id*="_addtosmslist"]');
                if ($addToEmailList.length) {
                    if($addToEmailList.filter(function (i, option) {
                        return option.checked;
                    }).length) {
                        newsletterFields += (newsletterFields==='') ? 'email' : ',email';
                    }
                }
                if ($addToSMSList.length) {
                    if($addToSMSList.filter(function (i, option) {
                        return option.checked;
                    }).length) {
                        newsletterFields += (newsletterFields === '') ? 'sms' : ',sms';
                    }
                }
            } else if ($(target).closest('form').find('[id*="_termsandconditions"]').length) {
                newsletterFields += newsletterFields==='' ? 'email' : ',email';
            } else {
                if ($('body').hasClass('LeviIN') && $(this).attr('type') === 'submit') {
                    newsletter = 'email';
                }
            }
            return newsletterFields === '' ? undefined : newsletterFields;
        }

        $('body').on('change', 'form[id*="_profile"],form[id*="_login"] input[type=email]', function (event) {
            var emailValue = $(event.target).val();
            if (emailValue) {
                // store hashed email into window.usersHashedEmail
                getHashedEmail(emailValue);
            } else if (emailValue === ''){
                window.usersHashedEmail = '';
            }
        });

        // Triggers of an event
        $('.header-signin a').on('click', function (event) {
            if (analyticsData.globalData && analyticsData.globalData.userData && analyticsData.globalData.userData.isAuthenticated) {
                return;
            }
            var labelText = $(this).text().trim().replaceAll(' / ', '/').replaceAll(' ', '_').toLowerCase();
            var data = {
                eventLabel: '1. ' + labelText + '_button_click',
                loginMethod: 'manual',
                eventAction: 'unified',
                hashedEmail: undefined,
                eventName: 'unified'
            };
            $('body').trigger('analytics:loginSignupJourney', data);
        });

        // Trigger an event for login screen buttons
        $('body').on('click', '.login-box.login-account button:not("[type=submit]"),.login-box.login-account a[id="password-reset"], .create-new-acct a', function (event) {
            var labelText = $(this).text().trim().replaceAll(' / ', '/').replaceAll(' ', '_').toLowerCase();
            var data = {
                eventLabel: '2. ' + labelText + '_click',
                loginMethod: 'manual',
                eventAction: 'login',
                hashedEmail: undefined,
                eventName: 'login'
            };
            if ($(event.target).closest('.create-new-acct').length) {
                data.eventAction = 'sign_up';
                data.eventName = 'sign_up';
            }

            var email = $(this).closest('form').find('input[type=email]').val();
            if (email) {
                data.hashedEmail = window.usersHashedEmail;
            }
            if ($(this).hasClass('oAuthIcon')) {
                data.loginMethod = $(this).attr('id').split('_')[0];
            }

            $('body').trigger('analytics:loginSignupJourney', data);
        });

        // Trigger an event for signup screen buttons
        $('body').on('click', 'a#clublevissignup.button,a#signuppage.button', function (event) {
            var labelText = $(this).text().trim().replaceAll(' / ', '/').replaceAll(' ', '_').toLowerCase();
            var data = {
                eventLabel: '2. ' + labelText + '_click',
                loginMethod: 'manual',
                eventAction: 'sign_up',
                hashedEmail: undefined,
                eventName: 'sign_up'
            };
            data.subscriptionMedium = newsletterField(this);
            var email = $(this).closest('form').find('input[type=email]').val();
            if (email) {
                data.hashedEmail = window.usersHashedEmail;
            }
            $('body').trigger('analytics:loginSignupJourney', data);
        });

        // Trigger an event for signup popup buttons
        $('body').on('click', '.already-have-acct a', function (event) {
            var labelText = $(this).text().trim().replaceAll(' / ', '/').replaceAll(' ', '_').toLowerCase();
            var data = {
                eventLabel: '3. ' + labelText + '_click',
                loginMethod: 'manual',
                eventAction: 'login',
                hashedEmail: undefined,
                eventName: 'login'
            };
            data.subscriptionMedium = newsletterField(this);
            var email = $(this).closest('form').find('input[type=email]').val();
            if (email) {
                data.hashedEmail = window.usersHashedEmail;
            }
            $('body').trigger('analytics:loginSignupJourney', data);
        });
    },
    /**
     * This event will trigger click on forgot password.
     * @param {Object} analyticsData analytics data
    */
    forgotPasswordClickEvent: function(analyticsData) {
        $('body').on('click', 'button[name*="_requestpassword_send"]', function(e){
        var emailValue = $("input[id^=dwfrm_requestpassword_email]").val();
        getHashedEmail(emailValue);
        setTimeout(function () {
            pushData({
                'event_category':'acquisition',
                'event_action':'login',
                'event_label':'forgot_password_submit_click',
                'login_method':'manual',
                'user_id': analyticsData.userData && analyticsData.userData.userId ? analyticsData.userData.userId : undefined,
                'page_type': analyticsData.pageData.pageType,
                'market': analyticsData.globalData.market,
                'page_category': analyticsData.pageData.pageCategory,
                'hashed_email_id': window.usersHashedEmail,
                'event_name':'unified_login_signup',
                'event':'hm_push_event'
            });
        }, 1);
        });
    },

    /**
     * This event fire on pdp page and with out of stock variants of product.
     * @param {Object} analyticsData analytics data.
     */
    outOfStockVariants: function (analyticsData) {
        function outOfStockVariantsHandler() {
            var variantData = $('.productDataGA4.pdp').data('outOfStockProducts');
            if (variantData && variantData.productId && variantData.outOfStockVariants && variantData.outOfStockVariants.length) {
                var pushEvent = false;
                if (window.oosVariantsData && window.oosVariantsData.productId !== variantData.productId) {
                    pushEvent = true;
                } else if(!window.oosVariantsData) {
                    pushEvent = true;
                }
                window.oosVariantsData = variantData;

                if (pushEvent) {
                    variantData.outOfStockVariants.forEach(function (variantList) {
                        if (variantList.length) {
                            pushData({
                                'event_category': 'engagement',
                                'event_action': 'twist_oos',
                                'event_label': 'na',
                                'event': 'hm_push_event',
                                'event_name': 'twist_oos',
                                'oos_item_id': variantData.productId,
                                'oos_item_variant': variantList.join(',')
                            });
                        }
                    });
                }
            }
        }
        outOfStockVariantsHandler();
        $('body').on('analytics:outOfStockTwist', outOfStockVariantsHandler);
    }
};


module.exports = {
    pageEventsConfig: pageEventsConfig,
    pageEvents: pageEvents
};
},{}],4:[function(require,module,exports){
'use strict';

module.exports = {
    /**
     * Initialize all functions
     * @param {Array} functionList an array of function names
     * @param {Object} objectWithFunctions Json object which contains all methods
     * @param {Object} data arguments
     */
    initFunctions: function (functionList, objectWithFunctions, data) {
        if (functionList && objectWithFunctions) {
            functionList.forEach(function (functionName) {
                if (functionName in objectWithFunctions) {
                    objectWithFunctions[functionName](data);
                }
            });
        }
    }
};
},{}],5:[function(require,module,exports){
"use strict";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
require('./adyen-giving');
require('./amazon');
require('./summary');
var qrCodeMethods = ['swish', 'wechatpayQR', 'bcmc_mobile', 'pix'];
var installmentLocales = ['pt_BR', 'ja_JP', 'tr_TR', 'es_MX'];
var maskedCardNumber;
var MASKED_CC_PREFIX = '************';
var selectedMethod;
var componentsObj = {};
var checkoutConfiguration;
var sessionsResponse;
var paymentMethodsResponse;
var checkout;
var formErrorsExist;
var isValid;
var paypalTerminatedEarly = false;
/**
 * @function
 * @description Initializes Adyen Secured Fields  Billing events
 */
function initializeBillingEvents() {
  return _initializeBillingEvents.apply(this, arguments);
}
function _initializeBillingEvents() {
  _initializeBillingEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            $('#billing-submit').on('click', function () {
              var isAdyenPOS = document.querySelector('.payment-method-options :checked').value === 'AdyenPOS';
              var isAdyen = document.querySelector('.payment-method-options :checked').value === 'AdyenComponent';
              if (isAdyenPOS) {
                document.querySelector('#dwfrm_adyPaydata_terminalId').value = document.querySelector('#terminalList').value;
                return true;
              }
              if (isAdyen) {
                var adyenPaymentMethod = document.querySelector('#adyenPaymentMethodName');
                var paymentMethodLabel = document.querySelector("#lb_".concat(selectedMethod)).innerHTML;
                adyenPaymentMethod.value = paymentMethodLabel;
                validateComponents();
                return showValidation();
              }
            });
            if (!window.sessionsResponse) {
              _context2.next = 16;
              break;
            }
            sessionsResponse = window.sessionsResponse;
            checkoutConfiguration = window.Configuration;
            checkoutConfiguration.onChange = function (state /* , component */) {
              isValid = state.isValid;
              if (!componentsObj[selectedMethod]) {
                componentsObj[selectedMethod] = {};
              }
              componentsObj[selectedMethod].isValid = isValid;
              componentsObj[selectedMethod].stateData = state.data;
            };
            checkoutConfiguration.showPayButton = false;
            checkoutConfiguration.paymentMethodsConfiguration = {
              card: getCardConfig(),
              bcmc: getCardConfig(),
              storedCard: getCardConfig(),
              boletobancario: {
                personalDetailsRequired: true,
                // turn personalDetails section on/off
                billingAddressRequired: false,
                // turn billingAddress section on/off
                showEmailAddress: false // allow shopper to specify their email address
              },

              paywithgoogle: getGooglePayConfig(),
              googlepay: getGooglePayConfig(),
              paypal: {
                environment: window.Configuration.environment,
                showPayButton: true,
                blockPayPalPayLaterButton: true,
                onClick: function onClick(data, actions) {
                  if (paypalTerminatedEarly) {
                    paymentFromComponent({
                      cancelTransaction: true,
                      merchantReference: document.querySelector('#merchantReference').value
                    });
                    paypalTerminatedEarly = false;
                    return actions.resolve();
                  }
                  paypalTerminatedEarly = true;
                  $('#dwfrm_billing').trigger('submit');
                  if (formErrorsExist) {
                    paypalTerminatedEarly = false;
                    return actions.reject();
                  }
                },
                onSubmit: function onSubmit(state, component) {
                  assignPaymentMethodValue();
                  paymentFromComponent(state.data, component);
                  document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
                },
                onCancel: function onCancel(data, component) {
                  paypalTerminatedEarly = false;
                  paymentFromComponent({
                    cancelTransaction: true,
                    merchantReference: document.querySelector('#merchantReference').value
                  }, component);
                },
                onError: function onError( error, component) {
                  paypalTerminatedEarly = false;
                  paymentFromComponent({
                    cancelTransaction: true,
                    merchantReference: document.querySelector('#merchantReference').value
                  }, component);
                  $('#dwfrm_billing').trigger('submit');
                },
                onAdditionalDetails: function onAdditionalDetails(state /* , component */) {
                  paypalTerminatedEarly = false;
                  document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(state.data);
                  // $('#dwfrm_billing').trigger('submit');
                  $( "#dwfrm_billing" )[0].submit();
                }
              },
              mbway: {
                showPayButton: true,
                onSubmit: function onSubmit(state, component) {
                  $('#dwfrm_billing').trigger('submit');
                  assignPaymentMethodValue();
                  if (formErrorsExist) {
                    return false;
                  }
                  document.getElementById('component_mbway').querySelector('button').disabled = true;
                  paymentFromComponent(state.data, component);
                  document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
                },
                onError: function onError( /* error, component */
                ) {
                  $('#dwfrm_billing').trigger('submit');
                },
                onAdditionalDetails: function onAdditionalDetails(state /* , component */) {
                  document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(state.data);
                  $('#dwfrm_billing').trigger('submit');
                }
              },
              swish: getQRCodeConfig(),
              bcmc_mobile: getQRCodeConfig(),
              wechatpayQR: getQRCodeConfig(),
              pix: getQRCodeConfig(),
              amazonpay: getAmazonpayConfig()
            };
            if (window.googleMerchantID !== 'null' && window.Configuration.environment === 'live') {
              checkoutConfiguration.paymentMethodsConfiguration.paywithgoogle.configuration.merchantIdentifier = window.googleMerchantID;
              checkoutConfiguration.paymentMethodsConfiguration.googlepay.configuration.merchantIdentifier = window.googleMerchantID;
            }
            if (window.cardholderNameBool !== 'null') {
              checkoutConfiguration.paymentMethodsConfiguration.card.hasHolderName = true;
              checkoutConfiguration.paymentMethodsConfiguration.card.holderNameRequired = true;
            }
            checkoutConfiguration.session = {
              id: window.sessionsResponse.id,
              sessionData: window.sessionsResponse.sessionData
            };
            _context2.next = 12;
            return AdyenCheckout(checkoutConfiguration);
          case 12:
            checkout = _context2.sent;
            paymentMethodsResponse = checkout.paymentMethodsResponse;
            document.querySelector('#paymentMethodsList').innerHTML = '';
            renderGenericComponent();
          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _initializeBillingEvents.apply(this, arguments);
}
function zeroAuth(data, checkout) {
  $.ajax({
    url: window.zeroAuthURL,
    type: 'POST',
    contentType: 'application/; charset=utf-8',
    data: JSON.stringify(data),
    async: false,
    success: function success(data) {
      if (data.zeroAuthResult.action) {
        document.querySelector('#buttonsContainer').style.display = 'none';
        checkout.createFromAction(data.zeroAuthResult.action).mount('#newCard');
      }
      if (data.zeroAuthResult.resultCode === 'Authorised') {
        window.location.href = window.paymentInstrumentsList;
      } else if (data.zeroAuthResult.resultCode === 'Refused') {
        window.location.href = window.paymentInstrumentsListError;
      }
    }
  });
}
function paymentsDetails(state) {
  $.ajax({
    type: 'post',
    url: window.paymentsDetails,
    data: JSON.stringify({
      data: state.data
    }),
    contentType: 'application/; charset=utf-8',
    async: false,
    success: function success(data) {
      if (data.response.isSuccessful) {
        window.location.href = window.paymentInstrumentsList;
      } else if (!data.response.isFinal && _typeof(data.response.action) === 'object') {
        checkout.createFromAction(data.action).mount('#action-container');
      } else {
        window.location.href = window.paymentInstrumentsListError;
      }
    }
  });
}

/**
 * @function
 * @description Initializes Adyen Checkout My Account events
 */
function initializeAccountEvents() {
  return _initializeAccountEvents.apply(this, arguments);
}
function _initializeAccountEvents() {
  _initializeAccountEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var newCard, adyenStateData, isValid, node;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            checkoutConfiguration = window.Configuration;
            checkoutConfiguration.onAdditionalDetails = function (state) {
              paymentsDetails(state);
            };
            checkoutConfiguration.session = window.sessionData;
            _context3.next = 5;
            return AdyenCheckout(checkoutConfiguration);
          case 5:
            checkout = _context3.sent;
            newCard = document.getElementById('newCard');
            isValid = false;
            node = checkout.create('card', {
              hasHolderName: true,
              holderNameRequired: true,
              onChange: function onChange(state) {
                adyenStateData = state.data;
                isValid = state.isValid;
              }
            }).mount(newCard);
            $('#applyBtn').on('click', function (e) {
              e.preventDefault();
              if (!isValid) {
                node.showValidation();
                return false;
              }
              document.querySelector('#adyenStateData').value = JSON.stringify(adyenStateData);
              zeroAuth(adyenStateData, checkout);
            });
          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _initializeAccountEvents.apply(this, arguments);
}
function assignPaymentMethodValue() {
  var adyenPaymentMethod = document.querySelector('#adyenPaymentMethodName');
  adyenPaymentMethod.value = document.querySelector("#lb_".concat(selectedMethod)).innerHTML;
}

/**
 * To avoid re-rendering components twice, unmounts existing components from payment methods list
 */
function unmountComponents() {
  var promises = Object.entries(componentsObj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    delete componentsObj[key];
    return resolveUnmount(key, val);
  });
  return Promise.all(promises);
}
function resolveUnmount(key, val) {
  try {
    return Promise.resolve(val.node.unmount("component_".concat(key)));
  } catch (e) {
    // try/catch block for val.unmount
    return Promise.resolve(false);
  }
}
function displaySelectedMethod(type) {
  selectedMethod = type;
  resetPaymentMethod();
  if (['paypal', 'paywithgoogle', 'googlepay', 'mbway', 'amazonpay'].concat(qrCodeMethods).indexOf(type) > -1) {
    document.querySelector('#billing-submit').disabled = true;
  } else {
    document.querySelector('#billing-submit').disabled = false;
  }
  document.querySelector("#component_".concat(type)).setAttribute('style', 'display:block');
}
function resetPaymentMethod() {
  $('.additionalFields').hide();
}
function showValidation() {
  if (componentsObj[selectedMethod] && !componentsObj[selectedMethod].isValid) {
    componentsObj[selectedMethod].node.showValidation();
    return false;
  }
  return true;
}

/**
 * Assigns stateData value to the hidden stateData input field
 * so it's sent to the backend for processing
 */
function validateComponents() {
  var stateData;
  if (componentsObj[selectedMethod] && componentsObj[selectedMethod].stateData) {
    stateData = componentsObj[selectedMethod].stateData;
  } else {
    var type = document.querySelector("#component_".concat(selectedMethod, " .type")) ? document.querySelector("#component_".concat(selectedMethod, " .type")).value : selectedMethod;
    stateData = {
      paymentMethod: {
        type: type
      }
    };
    var brandElm = document.querySelector("#component_".concat(selectedMethod, " .brand"));
    if (brandElm && brandElm.value) {
      stateData.paymentMethod.brand = brandElm.value;
    }
  }
  document.querySelector('#adyenStateData').value = JSON.stringify(stateData);
}

/**
 * Contains fallback components for payment methods that don't have an Adyen web component yet
 */
function getFallback(paymentMethod) {
  var fallback = {
    giftcard: "\n      <input type=\"hidden\" class=\"brand\" name=\"brand\" value=\"".concat(paymentMethod.brand, "\"/>\n      <input type=\"hidden\" class=\"type\" name=\"type\" value=\"").concat(paymentMethod.type, "\"/>")
  };
  return fallback[paymentMethod.type];
}

/**
 * Renders all payment methods (including card component) retrieved from Adyen session
 */
function renderGenericComponent() {
  return _renderGenericComponent.apply(this, arguments);
}
function _renderGenericComponent() {
  _renderGenericComponent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var amazonpay, i, paymentMethod, firstPaymentMethod;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!Object.keys(componentsObj).length) {
              _context4.next = 3;
              break;
            }
            _context4.next = 3;
            return unmountComponents();
          case 3:
            checkoutConfiguration.paymentMethodsResponse = paymentMethodsResponse.paymentMethods;
            if (sessionsResponse.amount) {
              checkoutConfiguration.amount = sessionsResponse.amount;
              checkoutConfiguration.paymentMethodsConfiguration.paypal.amount = sessionsResponse.amount;
              checkoutConfiguration.paymentMethodsConfiguration.amazonpay.amount = sessionsResponse.amount;
              setInstallments(sessionsResponse.amount);
            }
            if (sessionsResponse.countryCode) {
              checkoutConfiguration.countryCode = sessionsResponse.countryCode;
            }
            amazonpay = paymentMethodsResponse.paymentMethods.find(function (paymentMethod) {
              return paymentMethod.type === 'amazonpay';
            });
            if (amazonpay) {
              checkoutConfiguration.paymentMethodsConfiguration.amazonpay.configuration = amazonpay.configuration;
            }
            if (paymentMethodsResponse.storedPaymentMethods) {
              for (i = 0; i < checkout.paymentMethodsResponse.storedPaymentMethods.length; i++) {
                paymentMethod = checkout.paymentMethodsResponse.storedPaymentMethods[i];
                if (paymentMethod.supportedShopperInteractions.includes('Ecommerce')) {
                  renderPaymentMethod(paymentMethod, true, sessionsResponse.imagePath);
                }
              }
            }
            paymentMethodsResponse.paymentMethods.forEach(function (pm) {
              renderPaymentMethod(pm, false, sessionsResponse.imagePath);
            });
            firstPaymentMethod = document.querySelector('input[type=radio][name=brandCode]');
            if($('body').hasClass('LeviKR')){
              firstPaymentMethod.checked = true;
            }
            displaySelectedMethod(firstPaymentMethod.value);
          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _renderGenericComponent.apply(this, arguments);
}
function getPaymentMethodID(isStored, paymentMethod) {
  if (isStored) {
    return "storedCard".concat(paymentMethod.id);
  }
  if (paymentMethod.brand) {
    // gift cards all share the same type. Brand is used to differentiate between them
    return "".concat(paymentMethod.type, "_").concat(paymentMethod.brand);
  }
  return paymentMethod.type;
}
function renderPaymentMethod(paymentMethod, storedPaymentMethodBool, path) {
  var paymentMethodsUI = document.querySelector('#paymentMethodsList');
  var li = document.createElement('li');
  var paymentMethodID = getPaymentMethodID(storedPaymentMethodBool, paymentMethod);
  var isSchemeNotStored = paymentMethod.type === 'scheme' && !storedPaymentMethodBool;
  var paymentMethodImage = storedPaymentMethodBool ? "".concat(path).concat(paymentMethod.brand, ".png") : "".concat(path).concat(paymentMethod.type, ".png");
  var cardImage = "".concat(path, "card.png");
  var imagePath = isSchemeNotStored ? cardImage : paymentMethodImage;
  var label = storedPaymentMethodBool ? "".concat(paymentMethod.name, " ").concat(MASKED_CC_PREFIX).concat(paymentMethod.lastFour) : "".concat(paymentMethod.name);
  var liContents = "\n                              <input name=\"brandCode\" type=\"radio\" value=\"".concat(paymentMethodID, "\" id=\"rb_").concat(paymentMethodID, "\">\n                              <img class=\"paymentMethod_img\" src=\"").concat(imagePath, "\" ></img>\n                              <label id=\"lb_").concat(paymentMethodID, "\" for=\"rb_").concat(paymentMethodID, "\" style=\"float: none; width: 100%; display: inline; text-align: inherit\">").concat(label, "</label>\n                             ");
  var container = document.createElement('div');
  li.innerHTML = liContents;
  li.classList.add('paymentMethod');
  var node = renderCheckoutComponent(storedPaymentMethodBool, checkout, paymentMethod, container, paymentMethodID);
  container.classList.add('additionalFields');
  container.setAttribute('id', "component_".concat(paymentMethodID));
  container.setAttribute('style', 'display:none');
  li.append(container);
  paymentMethodsUI.append(li);
  if (paymentMethod.type !== 'paywithgoogle') {
    node && node.mount(container);
  } else {
    node.isAvailable().then(function () {
      node.mount(container);
    })["catch"](function () {}); // eslint-disable-line no-empty
  }

  var input = document.querySelector("#rb_".concat(paymentMethodID));
  input.onchange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (document.querySelector('.adyen-checkout__qr-loader') && qrCodeMethods.indexOf(selectedMethod) > -1 || paypalTerminatedEarly) {
                paypalTerminatedEarly = false;
                paymentFromComponent({
                  cancelTransaction: true,
                  merchantReference: document.querySelector('#merchantReference').value
                });
              }
              displaySelectedMethod(event.target.value);
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  if (paymentMethodID === 'giropay') {
    container.innerHTML = '';
  }
  if (storedPaymentMethodBool && ['bcmc', 'scheme'].indexOf(paymentMethodID) > -1) {
    componentsObj[paymentMethodID].isValid = true;
  }
}
function renderCheckoutComponent(storedPaymentMethodBool, checkout, paymentMethod, container, paymentMethodID) {
  if (storedPaymentMethodBool) {
    return createCheckoutComponent(checkout, paymentMethod, container, paymentMethodID);
  }
  var fallback = getFallback(paymentMethod);
  if (fallback) {
    var template = document.createElement('template');
    template.innerHTML = fallback;
    container.append(template.content);
    return;
  }
  return createCheckoutComponent(checkout, paymentMethod, container, paymentMethodID);
}
function getPersonalDetails() {
  var shippingAddress = sessionsResponse.shippingAddress;
  return {
    firstName: shippingAddress.firstName,
    lastName: shippingAddress.lastName,
    telephoneNumber: shippingAddress.phone
  };
}
function createCheckoutComponent(checkout, paymentMethod, container, paymentMethodID) {
  try {
    var nodeData = Object.assign(paymentMethod, {
      data: Object.assign(getPersonalDetails(), {
        personalDetails: getPersonalDetails()
      }),
      visibility: {
        personalDetails: 'editable',
        billingAddress: 'hidden',
        deliveryAddress: 'hidden'
      }
    });
    var node = checkout.create(paymentMethod.type, nodeData);
    if (!componentsObj[paymentMethodID]) {
      componentsObj[paymentMethodID] = {};
    }
    componentsObj[paymentMethodID].node = node;
    componentsObj[paymentMethodID].isValid = node.isValid;
    return node;
  } catch (e) {} // eslint-disable-line no-empty
  return false;
}

/**
 * Makes an ajax call to the controller function PaymentFromComponent.
 * Used by certain payment methods like paypal
 */
function paymentFromComponent(data, component) {
  $.ajax({
    url: window.paymentFromComponentURL,
    type: 'post',
    data: JSON.stringify(data),
    contentType: 'application/; charset=utf-8',
    success: function success(data) {
      if (data.result && data.result.orderNo && data.result.orderToken) {
        document.querySelector('#orderToken').value = data.result.orderToken;
        document.querySelector('#merchantReference').value = data.result.orderNo;
      }
      if (data.result && data.result.fullResponse && data.result.fullResponse.action) {
        component.handleAction(data.result.fullResponse.action);
      } else {
        document.querySelector('#paymentFromComponentStateData').value = JSON.stringify('null');
        // $('#dwfrm_billing').trigger('submit');
        $( "#dwfrm_billing" )[0].submit();
      }
    }
  }).fail(function /* xhr, textStatus */ () {});
}
$('#dwfrm_billing').submit(function (e) {
  if (['paypal', 'mbway', 'amazonpay'].concat(qrCodeMethods).indexOf(selectedMethod) > -1 && !document.querySelector('#paymentFromComponentStateData').value) {
    e.preventDefault();
    var form = $(this);
    var url = form.attr('action');
    $.ajax({
      type: 'POST',
      url: url,
      data: form.serialize(),
      async: false,
      success: function success(data) {
        formErrorsExist = data.fieldErrors;
      }
    });
  }
});
function getQRCodeConfig() {
  return {
    showPayButton: true,
    onSubmit: function onSubmit(state, component) {
      $('#dwfrm_billing').trigger('submit');
      if (formErrorsExist) {
        return;
      }
      assignPaymentMethodValue();
      document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
      paymentFromComponent(state.data, component);
    },
    onAdditionalDetails: function onAdditionalDetails(state /* , component */) {
      document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(state.data);
      $('#dwfrm_billing').trigger('submit');
    }
  };
}
function getCardConfig() {
  return {
    enableStoreDetails: showStoreDetails,
    showBrandsUnderCardNumber: false,
    onBrand: function onBrand(brandObject) {
      $('#cardType').val(brandObject.brand);
    },
    onFieldValid: function onFieldValid(data) {
      if (data.endDigits) {
        maskedCardNumber = MASKED_CC_PREFIX + data.endDigits;
        $('#cardNumber').val(maskedCardNumber);
      }
    },
    onChange: function onChange(state) {
      isValid = state.isValid;
      var methodToUpdate = state.data.paymentMethod.storedPaymentMethodId ? "storedCard".concat(state.data.paymentMethod.storedPaymentMethodId) : selectedMethod;
      $('#browserInfo').val(JSON.stringify(state.data.browserInfo));
      componentsObj[methodToUpdate].isValid = isValid;
      componentsObj[methodToUpdate].stateData = state.data;
    }
  };
}
function getGooglePayConfig() {
  return {
    environment: window.Configuration.environment,
    onSubmit: function onSubmit() {
      assignPaymentMethodValue();
      document.querySelector('#billing-submit').disabled = false;
      document.querySelector('#billing-submit').click();
    },
    configuration: {
      gatewayMerchantId: window.merchantAccount
    },
    showPayButton: true,
    buttonColor: 'white'
  };
}
function getAmazonpayConfig() {
  return {
    showPayButton: true,
    productType: 'PayAndShip',
    checkoutMode: 'ProcessOrder',
    locale: window.Configuration.locale,
    returnUrl: window.returnURL,
    addressDetails: {
      name: sessionsResponse.shippingAddress.firstName + ' ' + sessionsResponse.shippingAddress.lastName,
      addressLine1: sessionsResponse.shippingAddress.address1,
      city: sessionsResponse.shippingAddress.city,
      stateOrRegion: sessionsResponse.shippingAddress.city,
      postalCode: sessionsResponse.shippingAddress.postalCode,
      countryCode: sessionsResponse.shippingAddress.country,
      phoneNumber: sessionsResponse.shippingAddress.phone
    },
    onClick: function onClick(resolve, reject) {
      $('#dwfrm_billing').trigger('submit');
      if (formErrorsExist) {
        reject();
      } else {
        assignPaymentMethodValue();
        resolve();
      }
    },
    onError: function onError() {}
  };
}
function getInstallmentValues(maxValue) {
  var values = [];
  for (var i = 1; i <= maxValue; i += 1) {
    values.push(i);
  }
  return values;
}
function setInstallments(amount) {
  try {
    if (installmentLocales.indexOf(window.Configuration.locale) < 0) {
      return;
    }
    var _ref4 = window.installments ? window.installments.replace(/\[|]/g, '').split(',') : [null, null],
      _ref5 = _slicedToArray(_ref4, 2),
      minAmount = _ref5[0],
      numOfInstallments = _ref5[1];
    if (minAmount <= amount.value) {
      checkoutConfiguration.paymentMethodsConfiguration.card.installmentOptions = {
        card: {}
      }; // eslint-disable-next-line max-len
      checkoutConfiguration.paymentMethodsConfiguration.card.installmentOptions.card.values = getInstallmentValues(numOfInstallments);
      checkoutConfiguration.paymentMethodsConfiguration.card.showInstallmentAmounts = true;
    }
  } catch (e) {} // eslint-disable-line no-empty
}

/**
 * @function
 * @description Initializes Adyen CSE billing events
 */

exports.initBilling = function () {
  initializeBillingEvents();
};
exports.initAccount = function () {
  initializeAccountEvents();
};
exports.renderGenericComponent = function () {
  renderGenericComponent();
};

},{"./adyen-giving":6,"./amazon":8,"./summary":64}],6:[function(require,module,exports){
"use strict";

var donation;
function handleOnDonate(state, component) {
  if (!state.isValid) {
    return;
  }
  var selectedAmount = state.data.amount;
  var donationData = {
    amountValue: selectedAmount.value,
    amountCurrency: selectedAmount.currency,
    orderNo: window.orderNo,
    pspReference: window.pspReference
  };
  $.ajax({
    url: window.donateURL,
    type: 'post',
    data: JSON.stringify(donationData),
    contentType: 'application/; charset=utf-8',
    success: function success() {
      component.setStatus('success');
    }
  });
}
function handleOnCancel() {
  var adyenGiving = document.getElementById('adyenGiving');
  adyenGiving.style.transition = 'all 3s ease-in-out';
  adyenGiving.style.display = 'none';
  donation.unmount();
}
if (document.querySelector('.adyen-payment-details') && window.adyenGivingAvailable) {
  var adyenGivingNode = document.getElementById('donate-container');
  var amounts;
  try {
    amounts = JSON.parse(window.donationAmounts);
  } catch (e) {
    amounts = [];
  }
  var donationConfig = {
    amounts: amounts,
    backgroundUrl: window.adyenGivingBackgroundUrl,
    description: window.charityDescription,
    logoUrl: window.adyenGivingLogoUrl,
    name: window.charityName,
    url: window.charityWebsite,
    showCancelButton: true,
    onDonate: handleOnDonate,
    onCancel: handleOnCancel
  };
  AdyenCheckout(window.Configuration).then(function (checkout) {
    checkout.create('donation', donationConfig).mount(adyenGivingNode);
  });
}
},{}],7:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

/**
 * @function
 * @description Ajax post request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var postJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }
    
    //alert(options);
    currentRequests[options.url] = true;
    
    // make the server call
    $.ajax({
        method: 'POST',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (XMLHttpRequest, textStatus) {
    	alert(XMLHttpRequest + "@"+textStatus);
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    })
    .done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.postJson = postJson;
exports.load = load;

},{"./progress":55,"./util":67}],8:[function(require,module,exports){
"use strict";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
if (window.amazonCheckoutSessionId) {
  var handleAuthorised = function handleAuthorised(response) {
    document.querySelector('#result').value = JSON.stringify({
      pspReference: response.fullResponse.pspReference,
      resultCode: response.fullResponse.resultCode,
      paymentMethod: response.fullResponse.paymentMethod ? response.fullResponse.paymentMethod : response.fullResponse.additionalData.paymentMethod
    });
    document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(response);
    document.querySelector('#showConfirmationForm').submit();
  };
  var handleError = function handleError() {
    document.querySelector('#result').value = JSON.stringify({
      error: true
    });
    document.querySelector('#paymentFromComponentStateData').value = JSON.stringify({
      error: true
    });
    document.querySelector('#showConfirmationForm').submit();
  };
  var handleAmazonResponse = function handleAmazonResponse(response, component) {
    if (response.fullResponse && response.fullResponse.action) {
      component.handleAction(response.fullResponse.action);
    } else if (response.resultCode === window.resultCodeAuthorised) {
      handleAuthorised(response);
    } else {
      // first try the amazon decline flow
      component.handleDeclineFlow();
      // if this does not trigger a redirect, try the regular handleError flow
      handleError();
    }
  };
  var paymentFromComponent = function paymentFromComponent(data, component) {
    $.ajax({
      url: window.paymentFromComponentURL,
      type: 'post',
      contentType: 'application/; charset=utf-8',
      data: JSON.stringify(data),
      success: function success(response) {
        if (response.result && response.result.orderNo && response.result.orderToken) {
          document.querySelector('#orderToken').value = response.result.orderToken;
          document.querySelector('#merchantReference').value = response.result.orderNo;
        }
        handleAmazonResponse(response.result, component);
      }
    });
  };
  var mountAmazonPayComponent = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var checkout, amazonPayComponent;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AdyenCheckout(window.Configuration);
            case 2:
              checkout = _context.sent;
              amazonPayComponent = checkout.create('amazonpay', amazonConfig).mount(amazonPayNode);
              amazonPayComponent.submit();
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function mountAmazonPayComponent() {
      return _ref.apply(this, arguments);
    };
  }();
  window.sessionsResponse = null;
  var amazonPayNode = document.getElementById('amazonContainerSG');
  var amazonConfig = {
    showOrderButton: false,
    returnUrl: window.returnURL,
    configuration: {
      merchantId: window.amazonMerchantID,
      storeId: window.amazonStoreID,
      publicKeyId: window.amazonPublicKeyID
    },
    amazonCheckoutSessionId: window.amazonCheckoutSessionId,
    onSubmit: function onSubmit(state, component) {
      document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
      paymentFromComponent(state.data, component);
    },
    onAdditionalDetails: function onAdditionalDetails(state) {
      state.data.paymentMethod = 'amazonpay';
      $.ajax({
        type: 'post',
        url: window.paymentsDetailsURL,
        data: JSON.stringify({
          data: state.data,
          orderToken: document.querySelector('#orderToken').value
        }),
        contentType: 'application/; charset=utf-8',
        success: function success(data) {
          if (data.response.isSuccessful) {
            handleAuthorised(data.response);
          } else if (!data.response.isFinal && _typeof(data.response.action) === 'object') {
            checkout.createFromAction(data.action).mount('#amazonContainerSG');
          } else {
            handleError();
          }
        }
      });
    }
  };
  mountAmazonPayComponent();
}
},{}],9:[function(require,module,exports){
'use strict';

var amazonPay = require('./amazon/amazonPay');
var amazonAccount = require('./amazon/amazonAccount');

window.onload = function () {
    amazonPay.init();
    amazonAccount.init();
};

},{"./amazon/amazonAccount":10,"./amazon/amazonPay":11}],10:[function(require,module,exports){
'use strict';

/**
 * @module int_amazonpay_sg/cartridge/js/amazon/amazonAccount.js
 */

/* eslint-disable no-undef */
module.exports = {
    /**
     * @function
     * @description init events for Amazon account button processing
     */
    init: function () {
        var $amazonPayButton = $('.js-amazon-pay-button');
        if ($amazonPayButton.length > 0) {
            var amazonButtonDataUrl = $amazonPayButton.data('amazon-pay-button-data-url');
            $.ajax(amazonButtonDataUrl)
                .done(function (amazonPayButtonData) {
                    amazon.Pay.renderButton('.js-amazon-pay-button', amazonPayButtonData);
                });
        }
    }
};

},{}],11:[function(require,module,exports){
/* eslint-disable no-undef */
'use strict';

/**
 * @module int_amazonpay_sg/cartridge/js/amazon/amazonPay.js
 */

/**
 * Rendering Amazon Pay One Time button.
 *
 * @memberof amazonPay
 * @param {JQuery} $amazonPayButton - Amazon Pay button selector.
 * @returns {undefined}
 */
function renderAmazonPayOneTimeButton($amazonPayButton) {
    $.ajax({
        url: $amazonPayButton.data('rendering-url'),
        type: 'GET',
        dataType: 'JSON',
        success: function (renderAmazonButtonData) {
            if (renderAmazonButtonData.success) {
                amazon.Pay.renderButton('#' + $amazonPayButton.prop('id'), renderAmazonButtonData.amazonPayButtonConfig);
            }
        },
        error: function () {
            // If the signature request cannot be obtained,
            // the button will be hidden and the process will be terminated.
            $amazonPayButton.hide();
        }
    });
}

/**
 * Rendering Amazon Pay APB button.
 *
 * @private
 * @param {JQuery} $amazonPayButton - Amazon Pay button selector.
 * @returns {undefined}
 */
function renderAmazonPayApbButton($amazonPayButton) {
    $.ajax({
        url: $amazonPayButton.data('rendering-url'),
        type: 'GET',
        dataType: 'JSON',
        success: function (renderAmazonButtonData) {
            var renderedAmazonPayButton = amazon.Pay.renderButton('#' + $amazonPayButton.prop('id'), renderAmazonButtonData);

            renderedAmazonPayButton.onClick(function () {
                var csrfTokenName = $amazonPayButton.data('csrf-token-name');
                var csrfTokenValue = $amazonPayButton.data('csrf-token-value');
                var csrfErrorUrl = $amazonPayButton.data('csrf-error-url');
                var postData = {
                    format: 'ajax'
                };
                postData[csrfTokenName] = csrfTokenValue;

                if ($amazonPayButton.prop('disabled')) {
                    // The click event of the AmazonPay button cannot be controlled only by the disabled attribute,
                    // so determine whether the button is disabled or not.
                    return;
                }

                $('#js-amazon-pay-apb-error-message').empty().hide();
                $amazonPayButton.prop('disabled', true);

                $.ajax({
                    url: $amazonPayButton.data('checkout-url'),
                    type: 'POST',
                    dataType: 'JSON',
                    data: postData,
                    success: function (data) {
                        if (data.error) {
                            location.href = csrfErrorUrl;
                            return;
                        }
                        if (!data.success) {
                            if (data.redirectUrl) {
                                location.href = data.redirectUrl;
                                return;
                            }

                            $('#js-amazon-pay-apb-error-message').text(data.errorMessage).show();
                            $amazonPayButton.prop('disabled', false);
                            return;
                        }

                        renderedAmazonPayButton.initCheckout(data.checkoutSignatureData);
                    },
                    error: function () {
                        // If the creation of an order fails, reload the screen to bring the order up to date.
                        location.reload();
                    }
                });
            });
        },
        error: function () {
            // If the signature request cannot be obtained,
            // the button will be hidden and the process will be terminated.
            $amazonPayButton.hide();
        }
    });
}

/**
 * Bind editing links to Amazon Pay server.
 *
 * @memberof amazonPay
 * @returns {undefined}
 */
function bindEditingLinksToAmazonPayServer() {
    var $amazonPayEditShippingLink = $('.js-amazon-pay-shipping-edit-link');

    var existAmazonPayEditShippingLink = $amazonPayEditShippingLink.length > 0;
    if (existAmazonPayEditShippingLink) {
        amazon.Pay.bindChangeAction('.js-amazon-pay-shipping-edit-link', {
            amazonCheckoutSessionId: $amazonPayEditShippingLink.data('checkout-session-id'),
            changeAction: 'changeAddress'
        });
    }

    var $amazonPayEditPaymentLink = $('.js-amazon-pay-payment-edit-link');

    var existAmazonPayEditPaymentLink = $amazonPayEditPaymentLink.length > 0;
    if (existAmazonPayEditPaymentLink) {
        amazon.Pay.bindChangeAction('.js-amazon-pay-payment-edit-link', {
            amazonCheckoutSessionId: $amazonPayEditPaymentLink.data('checkout-session-id'),
            changeAction: 'changePayment'
        });
    }
}

module.exports = {
    init: function () {
        var $amazonPayCartOneTimeButton = $('#amazon-pay-cart-one-time-button');

        var existAmazonPayCartOneTimeButton = $amazonPayCartOneTimeButton.length > 0;
        if (existAmazonPayCartOneTimeButton) {
            renderAmazonPayOneTimeButton($amazonPayCartOneTimeButton);
        }

        var $amazonPayMiniCartOneTimeButton = $('#amazon-pay-mini-cart-one-time-button');

        var existAmazonPayMiniCartOneTimeButton = $amazonPayMiniCartOneTimeButton.length > 0;
        if (existAmazonPayMiniCartOneTimeButton) {
            renderAmazonPayOneTimeButton($amazonPayMiniCartOneTimeButton);
        }

        var $amazonPayApbButton = $('#amazon-pay-cart-apb-button');

        var existAmazonPayApbButton = $amazonPayApbButton.length > 0;
        if (existAmazonPayApbButton) {
            renderAmazonPayApbButton($amazonPayApbButton);
        }

        bindEditingLinksToAmazonPayServer();
    },

    renderAmazonPayOneTimeButton: renderAmazonPayOneTimeButton,
    bindEditingLinksToAmazonPayServer: bindEditingLinksToAmazonPayServer
};

},{}],12:[function(require,module,exports){
/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

var countries = require('./countries'),
dialog = require('./dialog'),
progress = require('./progress'),
minicart = require('./minicart'),
page = require('./page'),
rating = require('./rating'),
searchplaceholder = require('./searchplaceholder'),
searchsuggest = require('./searchsuggest'),
searchsuggestmobile = require('./searchsuggestmobile'),
tooltip = require('./tooltip'),
util = require('./util'),
validator = require('./validator'),
shippinginit = require('./pages/checkout/shipping'),
util = require('./util'),
 tls = require('./tls'),
 ajax = require('./ajax'),
 amazonPay = require('./amazonPay'),
 Pinchzoom = require('./pinch-zoom'),

//custom js file
loyaltyCarousel = require('./loyaltyPage/owlcarouselmin'),
loyaltyCommon = require('./loyaltyPage/common')

var intervalId = null;

 if ($('body').hasClass('LeviJP')){
	var coordinates = require('../../../app_levi_japan/cartridge/js/coordinates');
 }
//if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
	var s = document.createElement('script');
	s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
	s.setAttribute('type', 'text/javascript');
	document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
require('./captcha')();

// Start- Require GA4Events for GA4 events
require('./GA4Events/GA4Events');
// Stop- for GA4 events

$(".loader-img-col").hide();

$( document ).ready(function() {

	$(".loader-img-col").hide();

	$('.updates.sf-optin #dwfrm_profile_customer_termsandconditions').change(function(){
        if($(this).prop('checked') === true){
           console.log(1);
           $('.edit-profile-sms-section .input-checkbox ').prop('disabled', '');
           $('.edit-profile-email-section .input-checkbox ').prop('disabled', '');
        }else{
            console.log(2);
            $(".edit-profile-sms-section .input-checkbox ").prop('disabled', 'disabled');
            $(".edit-profile-email-section .input-checkbox ").prop('disabled', 'disabled');
        }
    });
		
	$(".firstname").keypress(function(e) {
        var k = e.keyCode;
        if((k >= 0 && k <= 64) || (k >= 91 && k <= 96) || (k >= 123 && k <= 126)) { 
			e.preventDefault(); 
        }
    });

	// Dob Validation
    if (window.location.href.indexOf('isDobValidate=false') > -1) {
        $(".select-error").css("display", "block");
    }
    else {
        $(".select-error").css("display", "none");
    }

	if (window.location.href.indexOf('isSuccess=true') > -1)
	{
		$("#successMsgModal").modal("show");

		$(".success-msg-div").text("프로필이 성공적으로 업데이트되었습니다.");

		setTimeout(function() 
		{
			$("#successMsgModal").modal("hide");
			
			const profileUrl = new URL(window.location.href);
			profileUrl.searchParams.set('isSuccess', true);
			profileUrl.searchParams.delete('isSuccess');
			window.history.replaceState(null, null, profileUrl);
			
		}, 3000);

	}

	if (window.location.href.indexOf('isAgeVerified=no') > -1)
	{
		const minimumLoyaltyAgeUrlParams = new URLSearchParams(window.location.search);
        const minimumLoyaltyAgeParam = minimumLoyaltyAgeUrlParams.get('minimumLoyaltyAge');
		$("#successMsgModal").modal("show");

		$(".success-msg-div").text("죄송합니다. 만 " + minimumLoyaltyAgeParam +"세 미만 고객은 가입하실 수 없습니다.");
		setTimeout(function() 
		{
			$("#successMsgModal").modal("hide");
			
			const regUrl = new URL(window.location.href);
			regUrl.searchParams.set('isAgeVerified', 'no');
			regUrl.searchParams.delete('isAgeVerified');
			regUrl.searchParams.delete('minimumLoyaltyAge');
			window.history.replaceState(null, null, regUrl);
			
		}, 3000);

	}

	
	var loyaltyYearData = $(".loyaltyYear option:selected").val();
    var loyaltyMonthData = $(".loyaltyMonth option:selected").val();
    var loyaltyDayData = $(".loyaltyDay option:selected").val();

    if (loyaltyYearData && loyaltyMonthData) {
        $('.loyaltyYear').prop('disabled', true);
        $('.loyaltyMonth').prop('disabled', true);
		$('.loyaltyYear + .ui-selectmenu-button').css("opacity", ".6");
        $('.loyaltyMonth + .ui-selectmenu-button').css("opacity", ".6");
    }
    else{
        $('.loyaltyYear').prop('disabled', false);
        $('.loyaltyMonth').prop('disabled', false);
    }

	if (window.location.href.indexOf('HomePage-profileShow') > -1)
	{
	$("#profileShow-li").addClass("active");
	}
	else if(window.location.href.indexOf('HomePage-RedTabBenefitsShow') > -1)
	{
		$("#RedTabBenefitsShow-li").addClass("active");
		$("#profileShow-li").removeClass("active");
	 }
	else if(window.location.href.indexOf('HomePage-membershipQRCode') > -1)
	{
		$("#membershipQRCode-li").addClass("active");
		$("#profileShow-li").removeClass("active");
	}
	else if(window.location.href.indexOf('HomePage-loyaltyPoint') > -1)
	{
		$("#loyaltyPoint-li").addClass("active");
		$("#profileShow-li").removeClass("active");
	}
	else if(window.location.href.indexOf('HomePage-referFriend') > -1)
	{
		$("#referFriend-li").addClass("active");
		$("#profileShow-li").removeClass("active");
	}
	else if(window.location.href.indexOf('HomePage-purchaseHistory') > -1)
	{
		$("#purchaseHistory-li").addClass("active");
		$("#profileShow-li").removeClass("active");
	}

	$(".popup_close").click(function(){
		$('.global_close_popup').modal('hide');
	});



	$('input[type="text"]').keyup(function() {
        if($(this).val() != '') {
           $('#nameField').text("");
        }
       
     });

     $('input[type="email"]').keyup(function() {
        if($(this).val() != '') {
           $('#emailField').text("");
        }
       
     });

     $('input[type="text"]').keyup(function() {
        if($(this).val() != '') {
           $('#phoneField').text("");
        }
       
     });

	if (window.location.href.indexOf('loyalty_member=no') > -1)
	{
		$('#exampleModal').modal('show');
	}
	else
	{
		$('#exampleModal').modal('hide');
	}

	$(".popup_close").click(function(){
		$('#exampleModal').modal('hide');
		$('#exampleModal').removeClass('sign_up_dialog');
		$('body').removeClass('sign_up_dialog');
	});
	var currentUrl = window.location.href;
	var urlnew = new URL(currentUrl);
	urlnew.searchParams.set("loyalty_member", "yes"); // setting your param
	var newUrl = urlnew.href; 
	$("#loyaltyMemberShipForm").submit(function (event) {
        event.preventDefault();
        $(".loader-img-col").show();
		$("#dob-error-div").hide();
        var form = $("#loyaltyMemberShipForm");
        var url = form.attr('action');
		var emailvalue = document.getElementById("dwfrm_profile_customer_email").value;
		var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		var phoneValue = $("#dwfrm_profile_customer_phone").val();
        var phoneLength = phoneValue.length;

        if($("#dwfrm_profile_customer_signupallconsent").prop('checked') == true && emailvalue.match(mailformat)) {
            if(phoneLength == 10 || phoneLength == 11) {
				$.ajax({
					type: "POST",
					url: url,
					data: form.serialize(),
					success: function (data) {
						$(".loader-img-col").hide();
						$("#dob-error-div").hide();
						if (data.status === 1) {
							$("#phoneno-error-div").hide();
							$("#firstname-error-div").hide();
							$("#email-error-div").hide();
							$("#dob-error-div").hide();
							$(".consent-error").hide();
							$('#exampleModal').modal('hide');
							$("#successMsgModal").modal("show");
							$("#password-error-div").hide();
							$(".success-msg-div").html(data.success);
		
							window.location.href = newUrl;
		
							setTimeout(function () {
								$(".loader-img-col").hide();
								$("#successMsgModal").modal("hide");
								$(".consent-error").hide();
							}, 3000);
						}
						else if (data.status === 0) {
							$("#email-error-div").html(data.success);
							$("#dob-error-div").hide();
							$("#email-error-div").show();
							$(".consent-error").hide();
							$("#password-error-div").hide();
							$("#phoneno-error-div").hide();
						}
						else if (data.status === 2) {
							$("#firstname-error-div").html(data.success);
							$("#firstname-error-div").show();
							$("#email-error-div").hide();
							$("#dob-error-div").hide();
							$(".consent-error").hide();
							$("#password-error-div").hide();
							$("#phoneno-error-div").hide();
		
						}
						else if (data.status === 3) {
							$("#dob-error-div").html(data.success);
							$("#dob-error-div").show();
							$("#firstname-error-div").hide();
							$("#email-error-div").hide();
							$(".consent-error").hide();
							$("#password-error-div").hide();
							$("#phoneno-error-div").hide();
						}
						else if (data.status === 4) {
							$("#phoneno-error-div").html(data.success);
							$("#phoneno-error-div").show();
							$("#firstname-error-div").hide();
							$("#email-error-div").hide();
							$("#dob-error-div").hide();
							$(".consent-error").hide();
							$("#password-error-div").hide();
						}
						else if(data.status === 5){
							$('#exampleModal').modal('hide');
							$("#successMsgModal").modal("show");
							$(".success-msg-div").html(data.success);
							$("#dob-error-div").hide();
							$(".consent-error").hide();
							$("#password-error-div").hide();
							$("#phoneno-error-div").hide();
							setTimeout(function () {
								$(".loader-img-col").hide();
								$("#successMsgModal").modal("hide");
								document.getElementById("loyaltyMemberShipForm").reset();
								window.location.reload();
							}, 3000);
						}
						else if(data.status === 6){
							$("#password-error-div").html(data.success);
							$("#password-error-div").show();
							$("#phoneno-error-div").hide();
							$("#firstname-error-div").hide();
							$("#email-error-div").hide();
							$("#dob-error-div").hide();
							$(".consent-error").hide();
						}
						else if (data.status === 7) {
                            $("#email-error-div").html(data.success);
                            $("#dob-error-div").hide();
                            $("#email-error-div").show();
                            $(".consent-error").hide();
                            $("#password-error-div").hide();
                            $("#phoneno-error-div").hide();
                        }
						else {
							$("#phoneno-error-div").hide();
							$("#firstname-error-div").hide();
							$("#email-error-div").hide();
							$("#dob-error-div").hide();
							$(".consent-error").hide();
							$("#password-error-div").hide();
						}
					},
					error: function (data) {
						$(".loader-img-col").hide();
					}
				});
			}
			else {
                $(".consent-error").hide();
                $(".loader-img-col").hide();
			}
        }
        else {
            $(".consent-error").show();
            $(".loader-img-col").hide();
        }
    });
});

$(document).on('click', ".gamificationbtn", function (event) {
	$("#gamificationmodal").modal('show');
});
$(document).on('click', ".popup_close", function (event) {
	$("#gamificationmodal").modal('hide');
});
$(document).on('click', "#gamificationUrlBtn", function (event) {
	$("#gamificationmodal").modal('hide');
});



$(document).on('click', "#redtabloyalti", function (event) {
	event.preventDefault();
	$(".loader-img-col").show();
	var points = $('#easyRewardConfirmloyalty').find('input').val();
	var pointRate = $("#pointsratio").val();
	var totalPoints = $("#totalpoints").val();
	var url = $("#redtabloyalti").attr("data-url");
   
	$.ajax({
		type: "POST",
		url: url,
		dataType: "json",
		data: { 'easyrewardPoints': points, 'easyrewardTotalPt': totalPoints, 'easyrewardPointsRate': pointRate, 'format': 'ajax' },
		success: function (data) {
			if($('.checkout-order-totals').length > 0){
				if (data.error.err == true) {
					alert("포인트는 최종 결제 금액의 50%까지, 최대"+data.error.limit+"원 사용 가능합니다.");               
				}
				var $summary = $('.secondary-minisummary');
				$summary.load(Urls.summaryRefreshURL, function () {});
				setTimeout(loderhide, 2000);
			}
			else{
			$("#easyRewardConfirmloyalty").load(location.href + " #easyRewardConfirmloyalty");
			$(".order-totals-table").load(location.href + " .order-totals-table");
			if (data.error.err == true) {
				alert("포인트는 최종 결제 금액의 50%까지, 최대"+data.error.limit+"원 사용 가능합니다.");				
			}
			setTimeout(loderhide, 6000);
		}
		
		},
		error: function (data) {
			setTimeout(loderhide, 6000);
		}
	});
});

$(document).on('click', "#redtab", function (event) {
	event.preventDefault();
	$(".loader-img-col").show();
	var url = $("#redtab").attr("data-url");
	$.ajax({
		type: "POST",
		url: url,
		success: function (data) {
			$(".popup-body").replaceWith(data);
			$("#myPopupvoucher").removeClass("hide");
			$(".loader-img-col").hide();
		},
		error: function (data) {
			$(".loader-img-col").hide();
			alert("some Error");
		}
	});
});

$(document).on('click', "#removevoucher", function (event) {
	event.preventDefault();
	$(".loader-img-col").show();
	var url = $("#removevoucher").attr("data-url");
	
	$.ajax({
		type: "POST",
		url: url,
		success: function (data) {
			if($('.checkout-order-totals').length > 0){
				var $summary = $('.secondary-minisummary');
				$summary.load(Urls.summaryRefreshURL, function () {});
				setTimeout(loderhide, 2000);
			}
			else{
			$(".loyaltyvoucher").load(location.href + " .loyaltyvoucher");
	       $(".order-totals-table").load(location.href + " .order-totals-table");
			if (window.location.href.indexOf('COShipping-SingleShipping') > -1 || window.location.href.indexOf('billing') > -1) {
				window.location.reload();
			}
			if (window.location.href.indexOf('Cart-Show') > -1 || window.location.href.indexOf('cart') > -1) {
				window.location.reload();
			}
			//setTimeout(loderhide, 6000);
		   }
		},
		error: function (data) {
			setTimeout(loderhide, 6000);
		}
	});
});
$(document).on('click', ".voucher-apply", function (event) {
	$(".loader-img-col").show();
	var type = $(this).attr("data-type");
	var typeValue = $(this).attr("data-value");
	var no = $(this).attr("data-no");
	var url = $(this).attr("data-url");
	
	$.ajax({
		type: "POST",
		url: url,
		dataType: "json",
		data: { 'vouchervalue': typeValue, 'vouchertype': type, 'voucherno': no, 'format': 'ajax' },
		success: function (data) {
			if($('.checkout-order-totals').length > 0){
				var $summary = $('.secondary-minisummary');
				$summary.load(Urls.summaryRefreshURL, function () {});
				setTimeout(loderhide, 2000);
			}
			else{
			$(".loyaltyvoucher").load(location.href + " .loyaltyvoucher");
	        $("#easyRewardConfirmloyalty").load(location.href + " #easyRewardConfirmloyalty");
	        $(".order-totals-table").load(location.href + " .order-totals-table");
			$("#myPopupvoucher").addClass("hide");
			if (window.location.href.indexOf('COShipping-SingleShipping') > -1 || window.location.href.indexOf('billing') > -1) {
				window.location.reload();
			}
			if (window.location.href.indexOf('Cart-Show') > -1 || window.location.href.indexOf('cart') > -1) {
				window.location.reload();
			}
			//setTimeout(loderhide, 6000);
			}
		},
		error: function (data) {
			setTimeout(loderhide, 6000);
		}
	});
});
$(document).on('click', "#redtabloyaltiremove", function (event) {

	event.preventDefault();

	$(".loader-img-col").show();
	var url = $("#redtabloyaltiremove").attr("data-url");
	$.ajax({
		type: "POST",
		url: url,
		success: function (data) {
			if($('.checkout-order-totals').length > 0){
				var $summary = $('.secondary-minisummary');
				$summary.load(Urls.summaryRefreshURL, function () {});
				setTimeout(loderhide, 2000);
			}
			else{
			$("#easyRewardConfirmloyalty").load(location.href + " #easyRewardConfirmloyalty");
	        $(".order-totals-table").load(location.href + " .order-totals-table");
			setTimeout(loderhide, 6000);
			}
           
		},
		error: function (data) {
			setTimeout(loderhide, 6000);
		}
	});
});
$(document).on('keyup','input[type="number"]', function (event){
	 
	    clearInterval(intervalId)
		if ($(this).val() != '') {		
			$('.easyRewardsCartConfrmBtnloyalty').prop('disabled', false);	
		}
		if ($(this).val() == '' && $(this).val() == 0) {
			
			$('.easyRewardsCartConfrmBtnloyalty').prop('disabled', true);
		}
	
});
function loderhide(){
    $(".loader-img-col").hide();
};
$(document).on('click', ".close",function () {
	$('#myPopupvoucher').addClass('hide');
});

function disablebutton(){
    if ($(".easyPointsloyalty").attr('data-max') == 0) {
        $(".easyPointsloyalty").prop('disabled', true);
    }
    var inputBox = $('.easyRewardsloyalty').find('input[type=number]');
    var invalidChars = [
        "-",
        "+",
        "e", "."
    ];
    inputBox.on("keydown", function (e) {
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
    });
}

$(document).ready(function () {
	
	if ($(".easyPointsloyalty").attr('data-max') == 0) {
		$(".easyPointsloyalty").prop('disabled', true);
	}
	var inputBox = $('.easyRewardsloyalty').find('input[type=number]');
	var invalidChars = [
		"-",
		"+",
		"e", "."
	];
	inputBox.on("keydown", function (e) {
		if (invalidChars.includes(e.key)) {
			e.preventDefault();
		}
	});

	setInterval(disablebutton, 1000);
	
});

function initializeEvents() {
	
	if($('body').hasClass('LeviKR')){
		var KRpopup = {
		        autoOpen: false,
		        modal: true,
		        width: 900,
		        height: 400,
		        title: Resources.SIZE_GUIDE,
		        dialogClass: 'sizeguide-popup'
		};
	
	
		$(".size-chart-link a").on('click',function(e){
			var sizechart = $(".sizechartcontent").dialog(KRpopup);
			sizechart.dialog("open");
			$(".sizechartcontent").css('height','300');
			if(!util.isMobile()){
				if($(".sizechartcontent").find('img').length > 1){
					$('.sizeguide-popup img').css('float','left');
					$('.sizeguide-popup img').css('width','50%');
				}
				$('.sizeguide-popup img').css('max-width','100%');
			}
		});
	} 


	if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')) {

		$('.contact-us textarea.input-textarea').keyup(function (event) {
			var text_max = parseInt($(this).attr('maxlength'));
			var text_length = $(this).val().length;
			var text_remaining = text_max - text_length;
			$(".remaining-char").text("*" + text_remaining + " " +Resources.TEXTLEFT_TEXTAREA);
			if ($('body').hasClass('LeviJP')) {
				$(".remaining-char").text(Resources.TEXTLEFT_TEXTAREA_FIRST + "*" + text_remaining + " " +Resources.TEXTLEFT_TEXTAREA);
			}
		}); 


		// MLP Configuration - START

		$('#commuter-video').on('click', function(e) {
			e.preventDefault();
			dialog.open({
				url: Urls.mlp_video_commuter,
				options: {
					dialogClass: "video-box-mlp",
					open: function() {
						$('.close-mlppopup').on('click', function(e) {
							dialog.close();
							$('iframe').attr('src', $('iframe').attr('src'));
						});
					}
				},
				callback: function() {
					$('div.ui-widget-overlay.ui-front').addClass('video-mlp-overlay');
				}
			});
		});


		// Close dialog if clicked outside	
		$('body').on('click', function(e) {
			if( dialog.isActive() && !$(e.target).is('.ui-dialog, a')
					&& !$(e.target).closest('.ui-dialog').length) {
				if (!$('body.LeviIN').find('.quickview-popup').length) {
					dialog.close();
				}
				$('.video-box-mlp iframe').attr('src', $('iframe').attr('src'));
				if (util.isMobile()) {
					if($('#wrapper').hasClass('menu-active')) { 
						$('#wrapper').css('position','fixed');
					}
					else {
						$('#wrapper').css('position','relative');
					}
				}
			}
		});
		
		//JWG Slider
			$('.jwg_slider_module').jwgSlider('both', 400); 
			$('.jwg_slider_module').eq(1).css('display','none');
			$('#custom-carousel li').removeClass('active');
		
		if (util.isMobile()) {
			$(document).on('click', 'li.menu-item', function(e) {
				e.preventDefault();
				util.scrollBrowser( $('#fit-mobile-' + $(this).data('menuitem')).offset().top + (-300));
				// $(window).scrollTop($('#fit-mobile-' + $(this).closest('li').data('menuitem')).offset().top + (-300));

			});



		}
		/** slider - START **/

		$('.jcarousel').on('jcarousel:reload jcarousel:create', function() {
			var width = $(this).innerWidth();

			if (width > 1400) {
				width = width / 6;
			}else if (width >1024) {
				width = width / 5;
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}

			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		})
		.jcarousel({
			wrap: 'circular'
		});

		$('.jcarousel .jcarousel-prev')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('.horizontal-jcarousel-wrapper1').find('.jcarousel').jcarousel('scroll', '-=1');
		});

		$('.jcarousel .jcarousel-next')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('.horizontal-jcarousel-wrapper1').find('.jcarousel').jcarousel('scroll', '+=1');
		});




		/// END SLIDER
	}

	//Handle left and right navigation
	if ($('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')) {
		var lisize = 0;
		$('#jcarousel1 ul li').each(function() {
			lisize = lisize + $(this).width(); //calculating list size
		});
		var jcarousel = $('#jcarousel1').width();
		var jcarouselsize = jcarousel - 10; //removing 10 pix padding for last li element
	
		if(jcarouselsize > lisize ) {
		 $('.carousel-prev').css('display','none');
		   $('.carousel-next').css('display','none');
		}
	}

	var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];
	var isIPad = navigator.userAgent.match(/iPad/i);
	var isTablet = navigator.userAgent.match(/tablet/i);

	if (util.isMobile() && isIPad == null && isTablet == null) {
		if($(window).width()< 812){
		//changing id for nav for mobile  
		$('#navigation').attr('id', 'navigation1');
		
		var nav = document.createElement("nav");
		nav.id = 'navigation';
		$('body').prepend(nav);
		$('#navigation1').css('display', 'none');
		$('#navigation').attr('role', 'navigation').addClass('nav-mobile').html($('#navigation1').html());
		} else{
			$('#navigation1').css('display', 'block');
			$(".header-banner").css({"display":"block"});
			$(".header-banner .header-banner-slot a").css({"display":"inline"});
		}
	} 
	$('body')
	.on('keydown', 'textarea[data-character-limit]', function (e) {
		var text = $.trim($(this).val()),
		charsLimit = $(this).data('character-limit'),
		charsUsed = text.length;

		if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
			e.preventDefault();
		}
	})
	.on('change keyup mouseup', 'textarea[data-character-limit]', function () {
		var text = $.trim($(this).val()),
		charsLimit = $(this).data('character-limit'),
		charsUsed = text.length,
		charsRemain = charsLimit - charsUsed;

		if (charsRemain < 0) {
			$(this).val(text.slice(0, charsRemain));
			charsRemain = 0;
		}

		$(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
	});

	var $searchContainer = $('#navigation .header-search');
	searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);
	if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
	var $searchContainerMobile = $('.header-search-mobile');
	searchsuggestmobile.init($searchContainerMobile, Resources.SIMPLE_SEARCH);
	}
	if ($('body').hasClass('LeviIN')){	
		var $searchContainerMobile = $('.header-search-mobile');	
		searchsuggestmobile.init($searchContainerMobile, Resources.SIMPLE_SEARCH);	
	}

	// add show/hide navigation elements
	$('.secondary-navigation .toggle').click(function () {
		$(this).toggleClass('expanded').next('ul').toggle();
	});

	// add generic toggle functionality
	$('.toggle').next('.toggle-content').hide();
	$('.toggle').click(function () {
		$(this).toggleClass('expanded').next('.toggle-content').toggle();
	});

	// subscribe email box
	var $subscribeEmail = $('.subscribe-email');
	if ($subscribeEmail.length > 0)    {
		$subscribeEmail.focus(function () {
			var val = $(this.val());
			if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
				return; // do not animate when contains non-default value
			}

			$(this).animate({color: '#999999'}, 500, 'linear', function () {
				$(this).val('').css('color', '#333333');
			});
		}).blur(function () {
			var val = $.trim($(this.val()));
			if (val.length > 0) {
				return; // do not animate when contains value
			}
			$(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
			.css('color', '#999999')
			.animate({color: '#333333'}, 500, 'linear');
		});
	}

	$('.privacy-policy').on('click', function (e) {
		e.preventDefault();
		dialog.open({
			url: $(e.target).attr('href'),
			options: {
				height: 600,
				dialogClass: "terms-popup",
				open: function() {

					$('.terms-popup').on('click', '.close-button , .close-popup-button', function(e) {
						dialog.close();
						$('#dialog-container').animate({scrollTop:0},0); 
					});
					$('#dialog-container').animate({scrollTop:0},0);
				}
			},
			callback: function() {
				$('.terms-popup').find('.ui-dialog-buttonpane').remove(); 
			}
		});
	});

	$('body.LeviKR .privacy-policy.pinformation').on('click', function (e) {
		e.preventDefault();
		dialog.open({
			url: $(e.target).attr('href'),
			options: {
				height: 600,
				dialogClass: "terms-popup pinformation",
				open: function() {
					$('.terms-popup').on('click', '.close-button', function(e) {
						dialog.close();
					});
					$('#dialog-container').animate({scrollTop:0},0);
				}
			},
			callback: function() {
				$('.terms-popup').find('.ui-dialog-buttonpane').remove();
			}
		});
	});

	// main menu toggle
	$('.menu-toggle').on('click', function () {
		$('.menu-category').css('display','block');
		$('.menu-category li.main-menu').css({"border-color": "#000","border-width":"1px","border-style":"solid"});
		$('li.user-info .fa-user').css('display','inline-block');
		
		if (!$('body').hasClass('LeviJP')) {
			$('li.user-info .fa-plus').css('display','inline-block');
		}
		
		if($('body.LeviJP').find('#smartbanner').css('display') == "block")
			$('nav[role="navigation"]').css({"margin-top":$('#smartbanner').height()});

		$('#wrapper').toggleClass('menu-active');
		 if($('#wrapper').hasClass('menu-active')){
			 if($('body').hasClass('LeviKR')){
				 $(".plp-promo-category").css("display","none");
			 }
			$('#wrapper').css('position','fixed');
		 }
		else 
			$('#wrapper').css('position','relative');
	});

	$('#wrapper #main').on('click', function (e) {
		var $hamburger = $(e.target).closest('#wrapper');
		if($hamburger.hasClass('menu-active'))
			$hamburger.toggleClass('menu-active');
		$('#wrapper').css('position','relative');
	});
	
	
	
	
	
		
	if ($('body').hasClass('LeviIN')||$('body').hasClass('LeviKR') ||$('body').hasClass('LeviJP')) {
	$(document).ready(function () {
	$('.menu-category li .menu-item').on('click', function (e) {
		e.preventDefault();
		var $parentLi = $(e.target).closest('li');

		if ($('body').hasClass('LeviIN')){	
			$parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa fa-chevron-up active').addClass('fa fa-angle-down');  	
			$parentLi.toggleClass('active');	
			$(e.target).toggleClass('fa fa-plus fa fa-chevron-up active');	
			$(".menu-item").find('svg').attr('data-icon', 'angle-down'); // keep plus icon for all  	
			$(".main-menu.active a.menu-item").find('svg').attr('data-icon', 'chevron-up');//keep minus icon for active div	
		}	
		else{	
			$parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa fa-minus active').addClass('fa fa-plus'); 	
			$parentLi.toggleClass('active');	
			$(e.target).toggleClass('fa fa-plus fa fa-minus active');	
			$(".menu-item").find('svg').attr('data-icon', 'plus'); // keep plus icon for all  	
			$(".main-menu.active a.menu-item").find('svg').attr('data-icon', 'minus');//keep minus icon for active div	
		}

	})
	
		$('.menu-category li .menu-item-level2').on('click', function (e) {
			e.preventDefault();
			var $parentLi = $(e.target).closest('li');

			if ($('body').hasClass('LeviIN')){	
				$parentLi.siblings('li').removeClass('active').find('.level2-toggle').removeClass('fa fa-chevron-right active').addClass('fa fa-angle-down'); 	
				$parentLi.toggleClass('active');	
				$(e.target).toggleClass('fa fa-angle-down fa fa-chevron-right active');	
				$(".menu-item-level2").find('svg').attr('data-icon', 'angle-down'); // keep plus icon for all  	
				$(".menu-horizontal li.active a.menu-item-level2").find('svg').attr('data-icon', 'chevron-right');//keep minus icon for active div	
				$("#menu-category-level-3-div ul").html($parentLi.html());
	           $("#menu-category-level-3-div").toggle();
	           $("ul.menu-category.level-1").toggle();
			   $("#menu-category-level-3-div").css("display","block");	
	           $("ul.menu-category.level-1").css("display","none");
			}	
			else{	
				$parentLi.siblings('li').removeClass('active').find('.level2-toggle').removeClass('fa fa-minus active').addClass('fa fa-plus'); 	
				$parentLi.toggleClass('active');	
				$(e.target).toggleClass('fa fa-plus fa fa-minus active');	
				$(".menu-item-level2").find('svg').attr('data-icon', 'plus'); // keep plus icon for all  	
				$(".menu-horizontal li.active a.menu-item-level2").find('svg').attr('data-icon', 'minus');//keep minus icon for active div	
			}	
			mobileLevel3NavClick();
		})
		if($('body').hasClass('LeviIN')){
			$('.mobile-menu-back').on('click',function (e){
				$("#menu-category-level-3-div").toggle();
				$("ul.menu-category.level-1").toggle();
				$("#menu-category-level-3-div").css("display","none");	
				$("ul.menu-category.level-1").css("display","block");
				$("#menu-category-level-3-div ul").html('');

				var $parentLi = $('.menu-category li.active .menu-item-level2').parent("li.active");
				$parentLi.siblings('li').removeClass('active').find('.level2-toggle').removeClass('fa fa-chevron-right active').addClass('fa fa-chevron-right'); 
				$parentLi.toggleClass('active');
				$(e.target).toggleClass('fa fa-plus fa fa-chevron-right active');


				$(".menu-item-level2").find('svg').attr('data-icon', 'chevron-right'); // keep plus icon for all  
				$(".menu-horizontal li.active a.menu-item-level2").find('svg').attr('data-icon', 'chevron-right');//keep minus icon for active div
				//    $(".level-2").toggle();
			});
		}
	});
	
	}
	else{
	$(document).ready(function () {
		$('.menu-category li .menu-item').on('click', function (e) {
			e.preventDefault();
			var $parentLi = $(e.target).closest('li');
			$parentLi.toggleClass('active');
			if ($('body').hasClass('LeviIN')){	
				$parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa fa-chevron-up active').addClass('fa fa-angle-down');  	
				$(e.target).toggleClass('fa fa-chevron-up fa fa-angle-down active');	
			}	
			else{	
				$parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa fa-minus active').addClass('fa fa-plus');	
				$(e.target).toggleClass('fa fa-plus fa fa-minus active');	
			}
			var content = this.nextElementSibling;
		    if (content.style.maxHeight){
		      content.style.maxHeight = null;
		    } else {
		      content.style.maxHeight = content.scrollHeight + "px";
		    } 
			$(".menu-item").find('svg').attr('data-icon', 'angle-down'); // keep plus icon for all  
			$(".main-menu.active a.menu-item").find('svg').attr('data-icon', 'chevron-up');//keep minus icon for active div
			

		})
		
		  $('.menu-category li .menu-item-level2').on('click', function (e) {
	           e.preventDefault();
	           var $parentLi = $(e.target).closest('li');
	          
	           $("#menu-category-level-3-div ul").html($parentLi.html());
			   mobileLevel3NavClick();
	           $("#menu-category-level-3-div").toggle();
	           $("ul.menu-category.level-1").toggle();
	          
	       });
	    $('.mobile-menu-back').on('click',function (e){
	           $("#menu-category-level-3-div").toggle();
	           $("ul.menu-category.level-1").toggle();
	           $("#menu-category-level-3-div ul").html('');
	    });
		$(".explore .close").on('click',function(e){

			e.preventDefault();
				$('#wrapper').toggleClass('menu-active');
				$("#menu-category-level-3-div").hide();
				$('.Redesign_menu .secondlevel').css('z-index','0');
				$('#wrapper').css('position','relative');
				
			});

		$('.menu-toggle').on('click', function () {
			
			$('.Redesign_menu .secondlevel').css('z-index','9999');
		});
			$('#wrapper #main').on('click', function (e) {
				var $hamburger = $(e.target).closest('#wrapper');
				if($hamburger.hasClass('menu-active'))
					$hamburger.toggleClass('menu-active');
				$('#wrapper').css('position','relative');
				$('.Redesign_menu .secondlevel').css('z-index','9999');
			});
			
	});
	
	}

		
	$('.sign-in-hover').on('mouseenter click',function (e){

		if (e.type == 'click') {
			//  if (util.isMobile()) {
			// 	 e.preventDefault();	
			//  } 
			 if($('.sign-in-hover').is(":visible")){
				$('.user-info').addClass('active');
				$('.header-signin').addClass('active');
				if($('.user-panel').is(":visible"))
					$('.icon-triangle-down').addClass("rotateIcon"); 
				else
					$('.icon-triangle-down').removeClass("rotateIcon"); 
			 }else{
				e.preventDefault();	
			}
		}	
		if (!util.isMobile()) {
		if ($('div.header-signin').hasClass('active')) {
			$('.header-signin').removeClass('active');
			if ($('.user-panel').is(':hover')) {
				return;
			}
			$('.user-info').removeClass('active');
			$('.user-panel').trigger('mouseleave');
			return;
		}
		
		$('.user-info').addClass('active');
		$('.header-signin').addClass('active');
		$('.icon-triangle-down').addClass("rotateIcon");  
		$('.sign-in-hover').css('background-color','#fff');
		$('.sign-in-hover').css('color','#333'); 
		$('.sign-in-name').css('color','#333');   
		$('.sign-in-name.mobile').css('color','#fff');
		return;
		}

	});
	if (!util.isMobile()) {
	$('.sign-in-hover').on('mouseleave', function () {
		$('.header-signin').removeClass('active');
		if ($('.user-panel').is(':hover')) {
			return;
		}
		$('.user-info').removeClass('active');
		$('.user-panel').trigger('mouseleave');
	});
	$('.user-info').on('mouseleave', function (){
		$('.user-info').removeClass('active');
		$('.sign-in-name').css('color','#fff');
	}); 
	$('.user-panel').on('mouseenter', function (){    	
		$('.icon-triangle-down').addClass("rotateIcon");
		$('.sign-in-hover').css('background-color','#fff');
		$('.sign-in-hover').css('color','#333');
		$('.user-info').addClass('active');
		$('.sign-in-name').css('color','#333');
		$('.sign-in-name.mobile').css('color','#fff');
	});   
	$('.user-panel').on('mouseleave', function (){    	
		$('.icon-triangle-down').removeClass("rotateIcon");
		$('.sign-in-hover').css('background-color','#333');
		$('.sign-in-hover').css('color','#fff');
	});

	}

	$("#icon-triangle-down-mobile").click(function (e) {
		var $parentLi = $(e.target).closest('li');
		$parentLi.siblings('li').removeClass('active').find('.icon-triangle-down').addClass('rotateIcon');
		$parentLi.toggleClass('active');
		$(e.target).toggleClass('.icon-triangle-down rotateIcon');
		var header = $(this);
		//getting the next element
		var content = header.next();
		content.slideToggle(300, function () {
			header.text(function () {
				//change text based on condition
				return;
			});
		});

	}); 
	
	$('.user-dropdown-toggle').on('click', function (e) {
		var $parentLi = $(e.target).closest('li');
		$parentLi.toggleClass('active');
		
		if($(this).find('svg').attr('data-icon') == 'plus' ) {
	        $(this).find('svg').attr('data-icon', 'minus');
	    } else {
	        $(this).find('svg').attr('data-icon', 'plus');
	    }
		
		
		var header = $(this);
		
		//getting the next element
		var content = header.next();
		//open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
		content.slideToggle(300, function () {});
	});

	
	
	if ($('body').hasClass('LeviJP')) {
		$('[id$="_shippingAddress_addressFields_postal"], [id$="_profile_address_postal"]').keyup(function() {		   
			 var val = this.value.replace(/\D/g,'');
	
		    
		    var newVal = '';
		    while (val.length > 3) {
		      newVal += val.substr(0,3) + '-';
		      val = val.substr(3);
		      break;
		    }
	
		    newVal += val;
		    this.value = newVal;
		    if (newVal.length > 8) {
		        
		    	this.value = newVal.substr(0,8);
		        
		      }
		});
	}
	
	if ($('body').hasClass('LeviJP')) {
		$(document).on('keypress', '.phone,[id$="_singleshipping_shippingAddress_addressFields_phone"],[id$="_profile_address_phone"],[id$="_profile_customer_phone"] ', function (e) {
			//if the letter is not digit then display error and don't type anything
			var verified = (e.which == 8 || e.which == undefined || e.which == 0) ? null : String.fromCharCode(e.which).match(/[^0-9]/);
			if (verified) {e.preventDefault();}
		});
	// These fields will take only numbers as inputs
	}
	
	if ($('body').hasClass('LeviJP')) {
	$(document).on('keypress', '.phone,[id$="_inStoreShipments_pinCode"], [id$="_shippingAddress_addressFields_postal"], [id$="_profile_address_postal"], [id*="_paymentMethods_creditCard_number"], [id*="_paymentMethods_creditCard_cvn"]', function (e) {
		//if the letter is not digit then display error and don't type anything
			var verified = (e.which == 8 || e.which == undefined || e.which == 0) ? null : String.fromCharCode(e.which).match(/[^0-9\-]/);
			if (verified) {e.preventDefault();}
		});
		// These fields will take only numbers as inputs
	}
	
	if ($('body').hasClass('LeviIN')||$('body').hasClass('LeviKR') ||$('body').hasClass('LeviAU')) {
		$(document).on('keypress', '.phone,[id$="_inStoreShipments_pinCode"], [id$="_shippingAddress_addressFields_postal"], [id$="_profile_address_postal"], [id*="_paymentMethods_creditCard_number"], [id*="_paymentMethods_creditCard_cvn"]', function (e) {
			//if the letter is not digit then display error and don't type anything
		var verified = (e.which == 8 || e.which == undefined || e.which == 0) ? null : String.fromCharCode(e.which).match(/[^0-9]/);
		if (verified) {e.preventDefault();}
	});
		// These fields will take only numbers as inputs
	}
	
	$(document).on('keypress', '.checkout-coupon-code #dwfrm_cart_couponCode', function (e) {
	    if(e.keyCode == 13)
	    {
	       e.preventDefault();
	        $('#add-coupon').click();
	    }
	});
	

	$('.cart-coupon-code #dwfrm_cart_couponCode').keyup(function(e){
		    if(e.keyCode == 13)
		    {
		    	 e.preventDefault();
		    	$('#add-coupon').click();
		    }
		});
	

	if (util.isMobile()) {
		$(".phone").prop("type", "tel");
		$('[id$="_inStoreShipments_pinCode"]').prop('type', 'tel');
		$('[id$="_shippingAddress_addressFields_postal"]').prop('type', 'tel');
		$('[id$="_profile_address_postal"]').prop('type', 'tel');
		$('[id*="_paymentMethods_creditCard_number"]').prop('type', 'tel');
		$('[id*="_paymentMethods_creditCard_cvn"]').prop('type', 'tel');
	}

	$("#myheaderoffer").click(function () {

		$(this).toggleClass('expand-header-offer');
		$(this).toggleClass('expand-header-offer close');

		var block = $(".subsale .text2").css('display');

		if(block=='inline-block')
		{	
			$(".subsale .text3").addClass("text3display");
			$(".subsale .text2").css({"display":"none"});
			$(".subsale .text3").removeClass("text3displaynone");
		}
		if(block=='none')
		{
			$(".subsale .text2").css({"display":"inline-block"});
			$(".subsale .text3").removeClass("text3display");
			$(".subsale .text3").addClass("text3displaynone");
		}
		var header = $(this);

		var content = header.next();

		content.slideToggle(200,'linear');
		$("body.LeviJP div#main").css({"margin-top":$('.header-promotion-offer').height() + $('.top-banner').height()});

		if( $("#myheaderoffer").hasClass( "close" ))
		{
			if ($('body').hasClass('LeviJP')) {
				if ($(window).width()<=767 ) 
			   {
				$("body.LeviJP .header-offers .header-promotion-offer span.subsale").css({"height":"auto"});

				}
			}	
			$("body.LeviKR div#main").css({"margin-top":"149px"});
			$("body.LeviAU div#main").css({"margin-top":"127px"});
			
			if($(window).width()<=535) 
				{
				$("body.LeviIN div#main").css({"margin-top":"170px"});
				}
			else 
				{
				$("body.LeviIN div#main").css({"margin-top":"115px"});
				}
		}
		else
		{
			if ($('body').hasClass('LeviJP')) {
				if ($(window).width()<=767 ) 
			   {
				$("body.LeviJP .header-offers .header-promotion-offer span.subsale").css({"height":"21px"});

				}
			}

			$("body.LeviKR div#main").css({"margin-top":"88px"});
			$("body.LeviAU div#main").css({"margin-top":"80px"});
			$("body.LeviIN div#main").css({"margin-top":"170px"});
		}
		
	});
	if ($('body').hasClass('LeviIN')||$('body').hasClass('LeviJP') && ($(window).width()<=767) ) {
		
	document.getElementsByTagName("BODY")[0].onresize = function() {

			if( $("#myheaderoffer").hasClass( "close" ))
			{
				if($(window).width()<=535) 
					{
					$("body.LeviIN div#main").css({"margin-top":"170px"});
					}
				else 
					{
					$("body.LeviIN div#main").css({"margin-top":"115px"});
					}
				$("body.LeviJP div#main").css({"margin-top":$('.header-promotion-offer').height() + $('.top-banner').height()});

			}
			else
			{

				if($("body").hasClass("LeviIN")){}	
				else{	
				$("body div#main").css({"margin-top":"80px"});	
				}	
				// $("body.LeviIN div#main").css({"margin-top":"170px"});
				$("body.LeviJP div#main").css({"margin-top":$('.header-promotion-offer').height() + $('.top-banner').height()});
			}
		};	
	}      
	

//	help accordion 
	$('.static-content').on('click', '.accordion-help .help-query', function () {
		var header = $(this);
		var content = header.next();
		content.slideToggle(500, function(){
			if ( content.is(":visible") ) {
				content.prev('.help-query').find('i').attr('class', 'accordianclose24x24');
				content.prev('.help-query').find('p').show();
			} else {
				content.prev('.help-query').find('i').attr('class', 'accordianopen24x24');
				content.prev('.help-query').find('p').hide();
			}
		});
	});

	$("#accordion").click(function () {
		$(this).toggleClass('accordianopen24x24');
		$(this).toggleClass('accordianclose24x24');

		var header = $(this);

		var content = header.next();

		content.slideToggle(700,'linear');

	});
	
	// handle toggle refinement blocks
	if ($('body').hasClass('LeviJP')) {
		$('.includeseolinks').on('click', '#seoaccordian', function () {

			$(this).toggleClass('accordianopen24x24');
			$(this).toggleClass('accordianclose24x24');
			
			var content = $(this).parent().next();
			content.slideToggle(500, function(){
				if ( content.hasClass( "accordianclose24x24" ) ) {
					 content.show();
				}
				else if( content.hasClass( "accordianopen24x24" )) {
					 content.hide();
				}
			});
		});
    }
	$(document).on('scroll', function(e) {

		$.widget("custom.myselectmenu", $.ui.selectmenu, {
			_renderItem: function (ul, item) {
				var li = $("<li>"),
				wrapper = $("<div>", { text: item.label });

				if (item.disabled) {
					li.addClass("ui-state-disabled");
				}
				return li.append(wrapper).appendTo(ul);
			}
		});

		$('select').myselectmenu({
			icons: { button: "ui-icon-arrowthick-1-s" },
			select: function (event, ui) {
				$(this).val(ui.item.value).trigger('change');
			}
		});

		if ($('div.ui-selectmenu-open')) {
			$('select').myselectmenu('close');
		}




		if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')) {


			if ($('div#carousel .flex-viewport').length) {
				$(window).resize();
			}

			if (!util.isMobile()) {

				if ($('div#carousel .flex-viewport').length && $('div#carousel').is(':hidden')) {

					$('div#custom-carousel').show(200);
				}

				if ($('div#slider .flex-viewport').length && $('div#slider').css('visibility') == 'hidden') {
					$('div#slider').css('visibility', 'visible');
					$(window).resize();
				}


			}

		}
	});

	$(document).on('mousemove', function(e) {



		if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')) {


			if ($('div#carousel .flex-viewport').length) {
				$(window).resize();
			}

			if (!util.isMobile()) {

				if ($('div#carousel .flex-viewport').length && $('div#carousel').is(':hidden')) {

					$('div#custom-carousel').show(200);
				}

				if ($('div#slider .flex-viewport').length && $('div#slider').css('visibility') == 'hidden') {
					$('div#slider').css('visibility', 'visible');
					$(window).resize();
				}


			}

		}

		$.widget("custom.myselectmenu", $.ui.selectmenu, {
			_renderItem: function (ul, item) {
				var li = $("<li>"),
				wrapper = $("<div>", { text: item.label });

				if (item.disabled) {
					li.addClass("ui-state-disabled");
				}
				return li.append(wrapper).appendTo(ul);
			}
		});

	});

	//footer accordion changes

	$(".help-expand").click(function () {

		$(this).find('i').toggleClass('accordianopen24x24');
		$(this).find('i').toggleClass('accordianclose24x24');

		var header = $(this);

		var content = header.next();

		content.slideToggle(700,'linear');

	});

	//hiding mega-menu image in mobile
	var mobile = util.isMobile();
	var notIpad = navigator.userAgent.toLowerCase().indexOf('ipad') == -1;
	var notTablet = navigator.userAgent.toLowerCase().indexOf('tablet') == -1;

	if (mobile && (notIpad || notTablet)) {
		$('#navigation ul.menu-category.level-1 .horizontal-image').css('display','none');
	}

	// If mobile, enable swipe features

	if (util.isMobile()) {
		var hammertime = new Hammer(document.body);
		hammertime.get('swipe');
		Hammer(document).on("swipeleft swiperight", function(e) {

			var $target = $(e.target);

			var $homePageSlider = $target.closest('#homepage-slider');
			var $homePageTextSlider = $target.closest('#homepage-text-slider');

			var $wrapper = $target.closest('div.horizontal-jcarousel-wrapper');

			var $wrapper1 = $target.closest('div.horizontal-jcarousel-wrapper1');

			var $mainImageCarousel = $target.closest('.main-image-carousel');


			if (e.type == 'swipeleft') {

				$homePageSlider.find('.jcarousel-next1:visible').trigger('click');
				$homePageSlider.find('.next-btn-2:visible').trigger('click');

				$homePageTextSlider.find('.jcarousel-next1:visible').trigger('click');	
				$homePageTextSlider.find('.next-btn-2:visible').trigger('click');

				$wrapper.find('.jcarousel-next1:visible').trigger('click');
				$wrapper.find('.next-btn-2:visible').trigger('click');

				$wrapper1.find('.jcarousel-next1:visible').trigger('click');
				$wrapper1.find('.next-btn-2:visible').trigger('click');

				$mainImageCarousel.find('.jcarousel-next:visible').trigger('click');
				$mainImageCarousel.find('.chevronright24x24:visible').trigger('click');
			}
			else if (e.type == 'swiperight') {

				$homePageSlider.find('.jcarousel-prev1:visible').trigger('click');
				$homePageSlider.find('.prev-btn-2:visible').trigger('click');
				
				$homePageTextSlider.find('.jcarousel-prev1:visible').trigger('click');
				$homePageTextSlider.find('.prev-btn-2:visible').trigger('click');

				$homePageTextSlider.find('.jcarousel-prev1:visible').trigger('click');	
				$homePageTextSlider.find('.prev-btn-2:visible').trigger('click');''

				$wrapper.find('.jcarousel-prev1:visible').trigger('click');
				$wrapper.find('.prev-btn-2:visible').trigger('click');

				$wrapper1.find('.jcarousel-prev1:visible').trigger('click');
				$wrapper1.find('.prev-btn-2:visible').trigger('click');

				$mainImageCarousel.find('.jcarousel-prev:visible').trigger('click');
				$mainImageCarousel.find('.chevronleft24x24:visible').trigger('click');
			}

		});
	}
	// end - enable swipe

	if ($('body').hasClass('LeviJP')) {
		$('[name$="_address_postal"],[name$="_addressFields_postal"]').on('change', function (e){
			var fieldName = "_address";		
			
			if($('#wrapper').hasClass('pt_checkout')){
				fieldName = "_addressFields";
			}
			if($('[id$='+fieldName+'_postal]').val().length==0) {
				$('[id$='+fieldName+'_postal]').closest('.field-wrapper').find('.errspan').remove();
			}
		});
	}
	
	if ($('body').hasClass('LeviJP')) {
	$('#addresslookup').on('focusin',function(){
		$('#dwfrm_profile_address_postal-error').addClass('errspan');
		$("#dwfrm_profile_address_postal-error").hide();
		$("span.errspan.error").hide();		
		$("input#dwfrm_profile_address_postal").removeClass("error");
		$("input#dwfrm_singleshipping_shippingAddress_addressFields_postal").removeClass("error");
		$("#dwfrm_singleshipping_shippingAddress_addressFields_postal-error").hide();
		$(".new-col .col-1 .form-row:nth-child(3)").css('height', 'auto');
		 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
		});
	
	$('#dwfrm_profile_address_postal').on('focusout',function(){
		 $('#dwfrm_profile_address_postal-error').addClass('errspan');
			$("#dwfrm_profile_address_postal-error").hide();
			$("span.errspan.error").hide();		
			$("input#dwfrm_profile_address_postal").removeClass("error");
			$(".new-col .col-1 .form-row:nth-child(3)").css('height', 'auto');
			 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
			});
	 }
	// Address look up for japan on my account
	$('#addresslookup').on('click',function(){
		
		$("#dwfrm_profile_address_postal-error").hide();
		$("span.errspan.error").hide();		
		$("input#dwfrm_profile_address_postal").removeClass("error");
		$(".new-col .col-1 .form-row:nth-child(3)").css('height', 'auto');
		 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
		
		 $("input#dwfrm_singleshipping_shippingAddress_addressFields_postal").removeClass("error");
		$("#dwfrm_singleshipping_shippingAddress_addressFields_postal-error").hide();
		
		var fieldName = "_address";		
		if($('#wrapper').hasClass('pt_checkout')){
			fieldName = "_addressFields";
		}
		
		
		$("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(""); 
		
		$.ajax({
			type : 'POST', 
			url :  Urls.addresslookupJP,
			dataType: 'json',
			data : {
				postcode : $('[name$='+fieldName+'_postal]').val()
			},
			success : function(data) {	
				var postal_code = $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val();
				$('#dwfrm_singleshipping_shippingAddress_addressFields_postal').keyup(function() { 
			        if ($('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val() != postal_code) {
			            $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val("").myselectmenu('refresh');
			        }
			    });
				
				var postal_code_Profile = $('#dwfrm_profile_address_postal').val();
				$('#dwfrm_profile_address_postal').keyup(function() { 
			        if ($('#dwfrm_profile_address_postal').val() != postal_code) {
			            $('#dwfrm_profile_address_city').val("").myselectmenu('refresh');
			        }
			    });
				
			if(data.results){
				
				$('[id$='+fieldName+'_postal]').closest('.field-wrapper').find('.errspan').remove();
				sessionStorage.setItem("flag", 'false');
				$("#dwfrm_profile_address_postal-error").hide();
				$("span.errspan.error").hide();		
				$("input#dwfrm_profile_address_postal").removeClass("error");
				$("input#dwfrm_singleshipping_shippingAddress_addressFields_postal").removeClass("error");
				$("#dwfrm_singleshipping_shippingAddress_addressFields_postal-error").hide();
				var stateCode = data.results[0].prefcode;
				var stateValue = $("select[id$="+fieldName+"_states_state] > option[optionid=" + stateCode + "]").val();
				$("#dwfrm_profile_address_states_state option:selected").val(stateValue);  
				$('#dwfrm_profile_address_states_state-button .ui-selectmenu-text').text(stateValue);
				
				if($('#wrapper').hasClass('pt_checkout')){		
					$("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(stateValue);  
					$('#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button .ui-selectmenu-text').text(stateValue);	
				}				
	            $('[name$='+fieldName+'_city]').val(data.results[0].address2);
				$('[name$='+fieldName+'_address1]').val(data.results[0].address3);
				
				if($('#wrapper').hasClass('pt_checkout')){
					$("#dwfrm_singleshipping_shippingAddress_addressFields_states_state-error").hide();
					$("#dwfrm_singleshipping_shippingAddress_addressFields_city-error").hide();
					if($('[name$='+fieldName+'_address1]').val()!=''){
						$("#dwfrm_singleshipping_shippingAddress_addressFields_address1-error").hide();
						$("input#dwfrm_singleshipping_shippingAddress_addressFields_address1").removeClass("error");
					}
					$("input#dwfrm_singleshipping_shippingAddress_addressFields_states_state").removeClass("error");
					$("input#dwfrm_singleshipping_shippingAddress_addressFields_city").removeClass("error");
				}
				else
				{
					$("#dwfrm_profile_address_states_state-error").hide();
					$("#dwfrm_profile_address_city-error").hide();
					if($('[name$='+fieldName+'_address1]').val()!=''){
						$("#dwfrm_profile_address_address1-error").hide();
						$("input#dwfrm_profile_address_address1").removeClass("error");	
					}
					$("input#dwfrm_profile_address_states_state").removeClass("error");
					$("input#dwfrm_profile_address_city").removeClass("error");
				}
				
				 if($('.new-col .col-1 .form-row:nth-child(4) .error').length>1)
			     {   	   		 
			    	 $(".new-col .col-2 .form-row:nth-child(4)").css('height', ($(".new-col .col-1 .form-row:nth-child(4)").height()));
			     }
				 else if($('.new-col .col-1 .form-row:nth-child(4) .error').css("display")=='inline') {
					 $(".new-col .col-2 .form-row:nth-child(4)").css('height', ($(".new-col .col-1 .form-row:nth-child(4)").height()));
				    }
				 else {
					 $(".new-col .col-2 .form-row:nth-child(4)").css('height', 'auto');
			    }
		   		 if($('.new-col .col-2 .form-row:nth-child(4) .error').length>1)
			     {   	   		 
			    	 $(".new-col .col-1 .form-row:nth-child(4)").css('height', ($(".new-col .col-2 .form-row:nth-child(4)").height()));
			     }
				else {
					 $(".new-col .col-1 .form-row:nth-child(4)").css('height', 'auto');
			    }
				
			}			
			else{	
				
				if($('[id$='+fieldName+'_postal]').val().length==0) {
					$('[id$='+fieldName+'_postal]').closest('.field-wrapper').find('.errspan').remove();
				}
				else
				{
					$('[name$='+fieldName+'_city]').val("");
					$('[name$='+fieldName+'_address1]').val("");
					
	                $('select[id$='+fieldName+'_states_state] > option[optionid="state"]').prop('selected', true);
	                $('[id$='+fieldName+'_states_state]').myselectmenu('refresh');
	                sessionStorage.setItem("flag", 'true'); 
	                $("#dwfrm_profile_address_postal-error").hide();
	        		$("span.errspan.error").hide();
	        		$("input#dwfrm_profile_address_postal").removeClass("error");
					$('[id$='+fieldName+'_postal]').closest('.field-wrapper').find('.errspan').remove();
					$("input#dwfrm_singleshipping_shippingAddress_addressFields_postal").removeClass("error");
					$("#dwfrm_singleshipping_shippingAddress_addressFields_postal-error").hide();
					var errSpan = document.createElement('span');
					errSpan.innerHTML = Resources.INVALID_POSTAL;
					errSpan.className += "errspan error";
					
					$("input#dwfrm_profile_address_postal").addClass("error");
					$('[id$='+fieldName+'_postal]').closest('.field-wrapper').append(errSpan);
					$(".new-col .col-1 .form-row:nth-child(3)").css('height', 'auto');
					 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
						
				}	
				return;
				}
			},
			error: function(response) {
				
                alert("Service not available. Please try again.");
                return;
            }

		});
		
		 
	});


	// Address lookup
	//$(document).on("keydown.autocomplete",'[name$="_storelocator_postalCode"]',function(e){
	var locale = $('#locale').val();
	if(locale=="en_AU"){
	$('body.LeviAU [name$="_city"]').autocomplete({
		minLength : 3,
		source : function(request, response) { 
			$.ajax({
				type : 'POST',
				url :  Urls.addresslookup,
				dataType: 'json',
				data : {
					postcode : $('[name$="_city"]').val()
				},
				success : function(data) {
					//debugger;
					//if multiple results are returned
					var content = $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val();
					var content_Profile = $('#dwfrm_profile_address_city').val();
					
				
						$('#dwfrm_singleshipping_shippingAddress_addressFields_city').keyup(function() { 
					        if ($('#dwfrm_singleshipping_shippingAddress_addressFields_city').val() != content) {
					            content = $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val();
					            $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val("");
		            			$('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val("").myselectmenu('refresh');
					        }
					        });
						
								$('#dwfrm_profile_address_city').keyup(function() {
							        if ($('#dwfrm_profile_address_city').val() != content) {
							        	content_Profile= $('#dwfrm_profile_address_city').val();
							            $('#dwfrm_profile_address_postal').val("");
				            			$('#dwfrm_profile_address_states_state').val("").myselectmenu('refresh');
							        }
							        });
								
					
						
					var display1 =  $('#dwfrm_singleshipping_shippingAddress_addressFields_city-error').css("display");
						
						if(data.localities.locality == undefined){
							
							
	    
							if($('.errspan.error').length>0)
	        				{
		        				
		        				$('body.LeviAU [name$="_city"]').parent().find('.errspan.error').remove();
	        				}
							
							var errSpan = document.createElement('span');
	            			errSpan.innerHTML = 'Enter a valid Suburb';
	            			errSpan.className += "errspan error";
	            			
	            			$('body.LeviAU [name$="_city"]').parent().append(errSpan);
	            			$('body.LeviAU [name$="_city"]').val("");
	            			$('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val("");
	            			$('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val("").myselectmenu('refresh');
	            			
	            			$('#dwfrm_profile_address_postal').val("");
	            			$('#dwfrm_profile_address_states_state').val("").myselectmenu('refresh');
	            			
	            			var display1 =  $('#dwfrm_singleshipping_shippingAddress_addressFields_city-error').css("display");
	            			//var display_profile =  $('#dwfrm_profile_address_city-error').css("display");
	            			
							    if(display1=="inline")
							    {
							    	
							    	$('body.LeviAU [name$="_city"]').parent().find('.errspan.error').remove();
							    }

						}
					
						
					else if (data.localities.locality instanceof Array)
						{
						
						if($('.errspan.error').length>0)
        				{  
	        				$('body.LeviAU [name$="_city"]').parent().find('.errspan.error').remove();
        				}
						
						response($.map(data.localities.locality,
								function(item) {
		
							return {
								
								
								label : item.location
								+ ', '
								+ item.postcode
								+ ', '
								+ item.state ,
								value : item.location,
								//+ ', '
								//+ item.postcode,

								state : item.state,
								city  : item.location,
								postcode : item.postcode

							}
						}));
						
						}
					//if a single result is returned

					else
						response($.map(data.localities, function(
								item) {
							return {
								label : item.location
								+ ', '
								+ item.postcode
								+ ', '
								+ item.state ,
								value : item.location,
								//+ ', '
								//+ item.postcode,

								state : item.state,
								city  : item.location,
								postcode : item.postcode
							}
						}));

				}

			});
		}
	});
	}

	/* updating city and state field*/
	$("body.LeviAU #dwfrm_singleshipping_shippingAddress_addressFields_city").bind('autocompleteselect', function(event, ui) {
		// autocompletechange
		
		if($('.errspan.error').length>0)
		{
			$('body.LeviAU [name$="_city"]').parent().find('.errspan.error').remove();
		} 
	   
		$('#dwfrm_singleshipping_shippingAddress_addressFields_city').val(ui.item.city);
		$('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val(ui.item.postcode);
		$('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val(ui.item.state).myselectmenu('refresh');
		
		$('#state-code1').val(ui.item.state);
		$('#postal-code1').val(ui.item.postcode);
		
	});



	/* updating city and state field for account address page*/
	$("body.LeviAU #dwfrm_profile_address_city").bind('autocompleteselect', function(event, ui) {
		// autocompletechange
		$('#dwfrm_profile_address_city').val(ui.item.city);
		$('#dwfrm_profile_address_postal').val(ui.item.postcode);
		$('#dwfrm_profile_address_states_state').val(ui.item.state).myselectmenu('refresh');
	});


	$("body.LeviAU #dwfrm_billing_billingAddress_addressFields_city").bind('autocompleteselect', function(event, ui) {
		// autocompletechange
		$('#dwfrm_billing_billingAddress_addressFields_city').val(ui.item.city).trigger('change');
		$('#dwfrm_billing_billingAddress_addressFields_postal').val(ui.item.postcode).trigger('change');
		$('#dwfrm_billing_billingAddress_addressFields_states_state').val(ui.item.state).myselectmenu('refresh').trigger('change');
		$('#dwfrm_billing_billingAddress_addressFields_country').val(ui.item.state).myselectmenu('refresh').trigger('change');
	});

	// Address lookup for store search on shipping page
	//  var locale = $('#locale').val();
	//  if(locale=='en_AU'){
	$('body.LeviAU').on("keydown.autocomplete",'[name$="_storeSearch"]',function(e){
		$(this).autocomplete({
			minLength : 3,
			source : function(request, response) {
				$.ajax({
					type : 'POST',
					url :  Urls.addresslookup,
					dataType: 'json',
					data : {
						postcode : $('[name$="_storeSearch"]').val()
					},
					success : function(data) {
						//if multiple results are returned
						if (data.localities.locality instanceof Array)
							response($.map(data.localities.locality,
									function(item) {
								return {
									label : item.location
									+ ', '
									+ item.postcode
									+ ', '
									+ item.state ,
									value : item.location
									+ ', '
									+ item.postcode
									+ ', '
									+ item.state,

									state : item.state,
									city  : item.location,
									postcode : item.postcode

								}
							}));
						//if a single result is returned
						else
							response($.map(data.localities, function(
									item) {
								return {
									label : item.location
									+ ', '
									+ item.postcode
									+ ', '
									+ item.state ,
									value : item.location
									+ ', '
									+ item.postcode
									+ ', '
									+ item.state,

									state : item.state,
									city  : item.location,
									postcode : item.postcode
								}
							}));
					}
				});
			}
		});
	});
	//  }
	 //NZ post lookup
	 //NZ post
// 	 var locale = $('#locale').val();
// 	 if(locale=='en_NZ'){
// 	 $('body.LeviAU').on("keydown.autocomplete",'[name$="_storeSearch"]',function(e){
// 		 $(this).autocomplete({
// 			 minLength : 3,
// 			 source : function(request, response) {
// 				 $.ajax({
// 					 type : 'POST',
// 					 url :  Urls.addresslookupNZ,
// 					 dataType: 'json',
// 					 data : {
// 						 postcode : $('[name$="_storeSearch"]').val()
// 					 },
// 					 success : function(data) {
// 					 //if multiple results are returned
// 					 if (data.addresses instanceof Array)
// 						 response($.map(data.addresses,
// 								 function(item) {
// 							 return {
// 								 label : item.full_address,
// 								 value : item.full_address
// 							 }
// 						 }));
// 					 //if a single result is returned
// 					 else
// 						 response($.map(data.addresses, function(
// 								 item) {
// 							 return {
// 								 label : item.full_address,
// 								 value : item.full_address
// 							 }
// 						 }));
// 				 }
// 			 });
// 		 }
// 	 });
//  });
//  }

// Start of Email Order Email
	
	$('.sendOrderStatusEmail').on('click', function (e) {
	    e.preventDefault();

        dialog.open({
            url: $(e.target).attr('href'),
            options: {
            	dialogClass:"get-order-email-popup",
                open: function () {  
                	
                    $('.get-order-email-popup').on('click', '.close-order-popup-button', function(e) {
                    	e.preventDefault();
                    	dialog.close();
                    	if(util.isMobile()) {
                    		$('#wrapper').css('position','relative');
                    	}
                    });
                    validator.init();                        
                	
                    var $requestPasswordForm = $('[name$="_sendinvoice"]');
                    var $submit = $requestPasswordForm.find('[name$="_sendinvoice_send"]');
                    $($submit).on('click', function (e) {
                        if (!$requestPasswordForm.valid()) {
                            return;
                        }
                        e.preventDefault();
                        var data = $requestPasswordForm.serialize();
                        data += '&' + $submit.attr('name') + '=';
                        if (data.indexOf('ajax') === -1) {
                            data += '&format=ajax';
                        }
                        $.ajax({
                            type: 'POST',
                            url : Urls.orderStatusEmail,
                            data: {
                				orderno : $('.sendOrderStatusEmail').closest('.orderStatusMailID').data('orderno'),
                				emailaddress : $('[name$="_sendinvoice_email"]').val()
                			},
                            success: function (response) {
                                if (typeof response === 'object' &&
                                        !response.success &&
                                        response.error === 'CSRF Token Mismatch') {
                                    page.redirect(Urls.csrffailed);
                                } else if (typeof response === 'string') {
                                                                          
                                    if (response == 'email error') {
                            			var errSpan = document.createElement('span');
                            			errSpan.innerHTML = Resources.NOT_REGISTERED_EMAIL;
                            			errSpan.className += "errspan error";
                            			$submit.closest('fieldset').find('.field-wrapper').append(errSpan);
                        	    		return;
                            		}
                            		else {
                            			$(this).closest('.field-wrapper').find('.errSpan').remove();
                            			dialog.$container.html(response);	
                            			
                            		}
                                }
                            },
                            failure: function () {
                                dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                            }
                        });
                    });
                }
            }
        });    
	});  



	//Autocomplete then store search
	$("body.LeviAU #dwfrm_singleshipping_inStoreShipments_storeSearch").bind('autocompleteselect', function(event, ui) {
		var postalCode = ui.item.postcode;
		$.ajax({
			url: Urls.getStoresShipping,
			type: 'POST',
			data: {
				postalCode : postalCode
			}
		}).done(function(response) {
			if (!response || !response.success) {
				$('#store-list-shipping').html(response);
				shippinginit.init();
			} else {
				resolve(response);
			}
		}).fail(function(jqxhr, status, err) {
			reject(new Error(err));
		});

	});

	var $pdpMain = $('#pdpMain');
	$pdpMain.on('focusout','[id$="_inStoreShipments_pinCode"]', function(e){
		$('#dwfrm_singleshipping_inStoreShipments_pinCode-error').css('display','none');
		if($('.errspan.error').length > 0){
			$('#cod-check').closest('.cod-button').find('.input-text').addClass("error");
		}else{
			$('#cod-check').closest('.cod-button').find('.input-text').removeClass("error");
		}
		var pinCode = $('#cod-check').closest('form').find('[id$="_inStoreShipments_pinCode"]').val();
		if($pdpMain.find('.product-set-desktop').length > 0){
			pinCode =$('.product-set-desktop').find('#cod-check').closest('form').find('[id$="_inStoreShipments_pinCode"]').val();
		}
		if (util.isMobile()) {
			if($pdpMain.find('.product-set-mobile').length > 0){
			pinCode =$('.product-set-mobile').find('#cod-check').closest('form').find('[id$="_inStoreShipments_pinCode"]').val();
			}
		}
		if (pinCode.length == 6) {
			$('.errspan.error').css('display','none');
			$('#cod-check').closest('.cod-button').find('.input-text').removeClass("error");
		}else{
			if(pinCode.length == 0){
				$('[id$="_inStoreShipments_pinCode"]').closest('.field-wrapper').find('.errspan.error').html(Resources.INVALIDPIN_REQUIRED);
			}
			$('.errspan.error').css('display','block');
			$('#cod-check').closest('#cod-eli-section').find('#cod-del-status').hide();
			if($pdpMain.find('.product-set-desktop').length > 0){
				$('.product-set-desktop').find('#cod-check').closest('#cod-eli-section').find('#cod-del-status').hide();
				if($('.errspan.error').length > 0){
					$('.product-set-desktop').find('#cod-check').closest('.cod-button').find('.input-text').addClass("error");
				}else{
					$('.product-set-desktop').find('#cod-check').closest('.cod-button').find('.input-text').removeClass("error");
				}
			}
			if (util.isMobile()) {
				if($pdpMain.find('.product-set-mobile').length > 0){
					$('.product-set-mobile').find('#cod-check').closest('#cod-eli-section').find('#cod-del-status').hide();
					if($('.errspan.error').length > 0){
						$('.product-set-mobile').find('#cod-check').closest('.cod-button').find('.input-text').addClass("error");
					}else{
						$('.product-set-mobile').find('#cod-check').closest('.cod-button').find('.input-text').removeClass("error");
					}
				}
			}
			
		}
		if($('.deliveryimage').is(':visible')){
			$('.errspan.error').css('display','block');
			$('#cod-check').closest('.cod-button').find('.input-text').addClass("error");
	}
	});
	
	//Regular Expression for alphabet in Credit Card Owner Name
	if($('body').hasClass('LeviJP')){
		$('#dwfrm_billing_paymentMethods_creditCard_owner').keypress(function (e) {
			var regex = new RegExp("^[a-zA-Z ]*$");
			var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
			if (regex.test(str) || e.which == 8) {
				return true;
			}
			
			else
			{
			e.preventDefault();
			return false;
			}
		});
	}
	//hiding check button on pdp for pincode
	if ($("body").hasClass("LeviIN")) {	
		var postalCode = util.getCookie('pincodeckie') || $('#dwfrm_singleshipping_inStoreShipments_pinCode').val();
		if(document.cookie.indexOf("pincodeckie") >= 0 && postalCode != "") {
			$('#dwfrm_singleshipping_inStoreShipments_pinCode').val(postalCode); 
			util.checkDeliveryAvailability(postalCode);                   
		}
	 }
	$('#dwfrm_singleshipping_shippingAddress_addressFields_postal').on('input',function(e){
		$('#dwfrm_singleshipping_shippingAddress_addressFields_postal').closest('.field-wrapper').find('.errspan.error').remove();
	});
	$pdpMain.on('input', '[id$="_inStoreShipments_pinCode"]',function(e) {
		e.preventDefault();
		if (!$("body").hasClass("LeviIN")){
		    return;
		}
		progress.show($('#cod-eli-section'));

		var $submitButton = $('#cod-check');
		$submitButton.closest('#cod-eli-section').find('#cod-status-section').hide();

		var pid = $('#pid').val();
		var pinCode = $('#cod-check').closest('form').find('[id$="_inStoreShipments_pinCode"]').val();
		if($pdpMain.find('.product-set-desktop').length > 0){
			pinCode =$('.product-set-desktop').find('#cod-check').closest('form').find('[id$="_inStoreShipments_pinCode"]').val();
			if(pinCode.length < 6){
				$('.product-set-desktop').find('#cod-check').closest('form').find('.input-text').addClass("error");
			}
		}
		if (util.isMobile()) {
			if($pdpMain.find('.product-set-mobile').length > 0){
			pinCode =$('.product-set-mobile').find('#cod-check').closest('form').find('[id$="_inStoreShipments_pinCode"]').val();
			if(pinCode.length < 6){
				$('.product-set-mobile').find('#cod-check').closest('form').find('.input-text').addClass("error");
			}
			}
		}
		$('.errspan.error').css('display','none');
		$('[id$="_inStoreShipments_pinCode"]').closest('.field-wrapper').find('.errspan.error').remove();
		
		if (pinCode.length < 6) {
					if($('.errspan.error').length == 0){
						var errSpan = document.createElement('span');
						if(pinCode.length == 0){
							errSpan.innerHTML = Resources.INVALIDPIN_REQUIRED;
						}else{
							errSpan.innerHTML = Resources.INVALID_POSTAL;
						}
						errSpan.className += "errspan error";
						$('[id$="_inStoreShipments_pinCode"]').closest('.field-wrapper').append(errSpan);
						
					}else{
						if(pinCode.length == 0){
						$('[id$="_inStoreShipments_pinCode"]').closest('.field-wrapper').find('.errspan.error').html(Resources.INVALIDPIN_REQUIRED);
						}
						else{
						$('[id$="_inStoreShipments_pinCode"]').closest('.field-wrapper').find('.errspan.error').html(Resources.INVALID_POSTAL);
						}
					}
				//$('.pincode.error').html(Resources.INVALID_PINCODE);
			$submitButton.closest('.cod-button').find('.input-text').addClass("error");		
			$('.errspan.error').css('display','block');
			$submitButton.closest('#cod-eli-section').find('.pincode.error').show();

			$submitButton.closest('#cod-eli-section').find('#cod-del-status').hide();
			//$submitButton.closest('#cod-eli-section').find('#cod-status-section').show();
			progress.hide();
			return;
		}
		util.checkDeliveryAvailability(pinCode);
		return;
	});

	
	/* Autocomplete then set postal code*/
	$("body.LeviAU #dwfrm_storelocator_storeSearch").bind('autocompleteselect', function(event, ui) {
		$('#storelocatorpostalcode').val(ui.item.postcode);
	});

	function validateEmailORPhoneNo(emailorphoneno){
		var x = emailorphoneno;
		var regex;
		var isValid=true;
		if(x.indexOf("@")== -1 && x.indexOf(".")== -1)
		{
			regex = /^\d{10}$/;
		}
		else
		{   
			if($('body').hasClass('LeviJP')){
				regex = /^([A-Za-z0-9]){1,}([A-Za-z0-9+\-\.\_\?\~]){0,}\@([A-Za-z0-9_\-\.]){1,}\.([A-Za-z0-9]{2,})$/;
		}
			else{
				regex = /^([\w.%+-]+@[\w.-]+\.[\w]{2,6})$/;
			}
		}
		
		if (!x.match(regex)) {
			isValid = false;
		}
		return isValid;
	}
	
	$('.LeviIN .track-order').on('keypress focusout', '[name^="dwfrm_ordertrack_orderEmail"]', function(e) {
		if ($( "input[name^='dwfrm_ordertrack_orderEmail']" ).val().length == 0) {		
			$('.emailphoneerror').hide();
		}
	});
	var checkedvalidation=false;
	$('body.LeviIN').on('click', '[name$="_ordertrack_findorder"]', function (e) {
		 var $parentfooterform= $(this).closest('form'); 
		 //$parentfooterform.find("#dwfrm_ordertrack_orderEmail").closest('div.field-wrapper').find(".emailphoneerror").remove();
		if($parentfooterform.hasClass('track-order')){
			 if (checkedvalidation) {
				 checkedvalidation = false; // reset flag
			        return; // let the event bubble away
			    }
			e.preventDefault();
			var result =validateEmailORPhoneNo($( "input[name^='dwfrm_ordertrack_orderEmail']" ).val());
			
			if(!result && $( "input[name^='dwfrm_ordertrack_orderEmail']" ).val().length !=0){
				if($( "input[name^='dwfrm_ordertrack_orderEmail']" ).closest('div.field-wrapper').find('.emailphoneerror').length <= 0){
					$("input[name^='dwfrm_ordertrack_orderEmail']").css("border-color" , "#c41230");
					$( "input[name^='dwfrm_ordertrack_orderEmail']" ).closest('div.field-wrapper').append('<span class="emailphoneerror">' + Resources.VALIDATE_EMAIL_OR_PHONE + '</span>');
				}else{
					$('.emailphoneerror').show();
				}
				
			}else{
			checkedvalidation = true;
			$(this).trigger('click', { ga4OrderTrackingEventTrigger: false });
			}
		}
	});
	
	//Enable zoom in mobile
	var zoomFlag = true;
	var iosAgent = window.navigator.userAgent,
	start = iosAgent.indexOf( 'OS ' );
	var iosVersion = window.Number( iosAgent.substr( start + 3, 3 ).replace( '_', '.' ) );
	
	
	if(util.isMobile()) {
		if(navigator.userAgent.match(/(iPad|iPhone|iPod)/g) && iosVersion < 11) {
			zoomFlag = false;
		}
		
		if(zoomFlag) {
			$("#main-image-carousel li").click(function(){
				if(this.id!=null && this.id!= undefined && this.id == "scene7VideoView"){
					return;
				}
				var Imgurl= $(this).find('.main-image').data('zoom-image');
				$('#wrapper.pt_product-details').addClass('wrapper-class-for-zoom');
				if(!$('body').hasClass('LeviJP')){
					var final_url = $('<img class="Zoom-img" src="'+Imgurl+'">');
					$('#zoom-container').append(final_url);
				}
				$('#zoom-container').dialog();
				$('#zoom-container').closest('.ui-dialog.ui-widget').addClass("zoom-container-dialog");
				var zoomContainerHeight = ($('.ui-dialog.zoom-container-dialog #zoom-container').height()/2);
				var zoomContainerWidth = ($('.ui-dialog.zoom-container-dialog #zoom-container').width()/2);
				$('.ui-dialog.ui-widget').scrollTop(175);
				$('.ui-dialog.ui-widget').scrollLeft(300);
				if($('body').hasClass('LeviJP')){
					 zoomCarousel();
				}
			});
			
			$("#main-image-carousel-owlcarousel li").click(function(){
				var Imgurl= $(this).find('.main-image').data('zoom-image');
				$('#wrapper.pt_product-details').addClass('wrapper-class-for-zoom');
				$('#zoom-container').dialog(); 
				$('#zoom-container').closest('.ui-dialog.ui-widget').addClass("zoom-container-dialog");
				var zoomContainerHeight = ($('.ui-dialog.zoom-container-dialog #zoom-container').height()/2);
				var zoomContainerWidth = ($('.ui-dialog.zoom-container-dialog #zoom-container').width()/2);
				$('.ui-dialog.ui-widget').scrollTop(175);
				$('.ui-dialog.ui-widget').scrollLeft(300);
				 if($('body').hasClass('LeviJP')){
					zoomCarousel();
				 }else{
					 var final_url = $('<img class="Zoom-img" src="'+Imgurl+'">');
					 $('#zoom-container').append(final_url);
				 }
			});
			$('#zoom-container .zoom-close').on('click',function(){
				$('#zoom-container').dialog('close');
				 if($('body').hasClass('LeviJP')){
					 $('.pinch-zoom-parent').remove();
				 }else {
		        $('#zoom-container .Zoom-img').remove();
				 }
		        $('#wrapper.pt_product-details').removeClass('wrapper-class-for-zoom');
			});
		}
	}
	
	$('.track-order-popup').on('click', function (e) {
		e.preventDefault();
		
		dialog.open({
			url: $(e.target).attr('href'),
			options: {
				dialogClass: "track-order-popup-window",
				open: function () {

					// var $orderTrackForm = $('#dialog-container').find("#dwfrm_ordertrack");
					validator.init();					
					var $orderTrackForm = $('#dialog-container form[id$="_ordertrack"]');
					var $submit = $orderTrackForm.find('[name$="ordertrack_findorder"]');
					var emailorPhoneval = $('#dwfrm_ordertrack_orderEmail').val();
					$("#dwfrm_ordertrack_orderEmail").closest('div.field-wrapper').find(".emailphoneerror").remove(); 
				//	$("#dwfrm_ordertrack_orderEmail").closest('div.field-wrapper').append('<span class="emailphoneerror"></span>');
					
				
						$('.LeviIN .track-order-popup-window').on('keypress focusout', '#dwfrm_ordertrack_orderEmail', function(e) {
							if ($('#dwfrm_ordertrack_orderEmail').val().length == 0) {												
								$('.emailphoneerror').hide();
							}
						});
		
						$submit.on('click', function (e) {
//							
							var $parentForm = $(this).closest('form'); 
							var trackOrderId = $orderTrackForm.find('#dwfrm_ordertrack_orderNumber').val();

							emailorPhoneval = $orderTrackForm.find('#dwfrm_ordertrack_orderEmail').val();

							var response = validateEmailORPhoneNo($parentForm.find('#dwfrm_ordertrack_orderEmail').val());
							$parentForm.find("#dwfrm_ordertrack_orderEmail").closest('div.field-wrapper').find(".emailphoneerror").remove();
							$parentForm.find("#dwfrm_ordertrack_orderEmail").css("border-color" , "#ccc");
							if (!response && $('body').hasClass('LeviIN')) {
								if ($parentForm.find('#dwfrm_ordertrack_orderEmail').val().length > 0) {
									$("#dwfrm_ordertrack_orderEmail").closest('div.field-wrapper').append('<span class="emailphoneerror">' + Resources.VALIDATE_EMAIL_OR_PHONE + '</span>');
									$("#dwfrm_ordertrack_orderEmail").css("border-color" , "#c41230");
								}else{
									$("#dwfrm_ordertrack_orderEmail").closest('div.field-wrapper').find(".emailphoneerror").remove();
									$("#dwfrm_ordertrack_orderEmail").css("border-color" , "#ccc");
								}
							}				
							else {
								$("#dwfrm_ordertrack_orderEmail").css("border-color" , "#ccc");
							}
							if (!$orderTrackForm.valid() || !response) {						
								e.preventDefault();
								return;
							}else{
								if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
									window.dataLayer = window.dataLayer || [];
									dataLayer.push({
										event: "customEvent",
										eventCategory: "orderTracked",
										eventAction: trackOrderId
									}); 
								}
							}
						});

					$('.track-order-popup-window').on('click', '.close-popup-button,.close-track-order-button', function(e) {
						e.preventDefault();
						$($orderTrackForm).find('.input-text').removeClass("error");
						$($orderTrackForm).find('.error').hide();
						dialog.close();
					});

				}
			}

		});         

	});
	// for header country selector popup of AU and NZ Locale 
	$('.header-banner .selectcountry').on('click', function (e) {
		e.preventDefault();
		
		var countryVisitedCookie = util.getCookie('dw_levis_store_visited');
		
		    dialog.open({
		           url: Urls.country_selector,
		           options: {
		                 close: function() {
		                	 
		                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.header-promo-offer').css('background', '');
		                        if (util.isMobile()) {
		                               $('#wrapper').css('position','relative');
		                               return;
		                        }      
		                 },
		                 width: 640,
		                 height: 385,
		                 dialogClass: "selectcountry",
		                 open: function() {
		                        $('.selectcountry').myselectmenu({
		                               icons: { button: "ui-icon-arrowthick-1-s" },
		                               select: function (event, ui) {
		                                      $(this).val(ui.item.value).trigger('change');
		                               }
		                        });
		                        validator.init();
		                 }
		           },
		           callback: function() {
		                 var imgurl = "";
		                 if (util.isMobile()) {
		           
		                        imgurl = 'url('+ Urls.nzpopupimage_mobile + ')';
		                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.header-promo-offer').css('background', imgurl);
		                 }
		                 else {
		                	 
		                        imgurl = 'url('+ Urls.nzpopupimage + ')';
		                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.header-promo-offer').css('background', imgurl);
		                 }
		                 
		                 util.createCookie('dw_levis_store_visited', 'seen', 30);
      
		           }

		    });
		

	});
		
		

	var is_iPad = navigator.userAgent.match(/iPad/i);
	if(is_iPad == null) {
		if(util.isMobile()) {
			$("ul.menu-footer li").css("display", "none");
			$(".help-link").css("display", "block");

			$('.help').on('click', '.accordianclose24x24, .accordianopen24x24', function() {
				if ($(this).hasClass('accordianclose24x24')) {
					$("ul.menu-footer li").css("display", "none");
					//$("ul.menu-footer").not(".accordion-header").toggle('slide', {direction: 'up'});
					$(this).removeClass('accordianclose24x24').addClass('accordianopen24x24');
					$(".help-link").css("display", "block");
				}
				else {
					$("ul.menu-footer li").css("display", "block");
					//$("ul.menu-footer").not(".accordion-header").toggle('slide', {direction: 'down'});
					$(this).removeClass('accordianopen24x24').addClass('accordianclose24x24');
				}
			});
		}
	}
	
	// Afterpay 
	if ($('body').hasClass('LeviAU')) {
		$(document).on('click', '.afterpay-link', function (e) {
		e.preventDefault();
			dialog.open({
			url: $(e.target).attr('href'),
			options: {
				dialogClass: "afterpay-dialog"
			}
		});
		});
	}
	
}

function zoomCarousel(){	
	var image_array =[],index;
	$('.main-image-carousel .owl-item').each(function(){
		image_array.push($(this).find(".main-image").attr("data-zoom-image"));
	});
	$('#zoom-container .jcarousel').jcarousel({
		wrap: 'circular',
		items: '.product-image-carousel'
	});
	$('.horizontal-jcarousel-wrapper3 .carousel-prev').jcarouselControl({
		target: '-=1'
	});
	$('.horizontal-jcarousel-wrapper3 .carousel-next').jcarouselControl({
		target: '+=1'
	});
	if($(".pinch-zoom-parent").length ==0){
		for(var i=0;i<=image_array.length;i++){
			$('.horizontal-jcarousel-wrapper3 .product-image-carousel:nth-child(' + (i + 1) + ')').attr("data-index", i+1);	
			var final_url = $('<div class="page pinch-zoom-parent"><div class="pinch-zoom"><img class="Zoom-img" src="'+image_array[i]+'"></div></div>');
			$('.horizontal-jcarousel-wrapper3 .product-image-carousel:nth-child(' + (i + 1) + ')').append(final_url);
		}
		$('div.pinch-zoom').each(function () {
			new RTP.PinchZoom($(this), {});
		});
	}
	if($("#main-image-carousel-owlcarousel").is(":visible")){
		index = Number($(".owl-item.active li").attr("data-index"));
	}else{
		$('#main-image-carousel ul li').each(function() {
			if($(this).is(":visible")){ 
				index = Number($(this).attr("data-index"));
			}	
		});		
	}
	$('#zoom-container .jcarousel').jcarousel('scroll',index-1, false);	
}

function initializeDom() {
	// add class to html for css targeting
	$('html').addClass('js');
	if (SitePreferences.LISTING_INFINITE_SCROLL) {
		$('html').addClass('infinite-scroll');
	}
	// load js specific styles
	util.limitCharacters();
}

var pages = {
		account: require('./pages/account'),
		cart: require('./pages/cart'),
		checkout: require('./pages/checkout'),
		compare: require('./pages/compare'),
		product: require('./pages/product'),
		registry: require('./pages/registry'),
		search: require('./pages/search'),
		storefront: require('./pages/storefront'),
		wishlist: require('./pages/wishlist'),
		storelocator: require('./pages/storelocator'),
		orderconfirmation: require('./pages/orderconfirmation')

};

function initializeCookieBar() {
    var enableCookiePolicyBar = SitePreferences.ENABLE_COOKIE_POLICY_BAR;
    if(!enableCookiePolicyBar) {
        return;
    }
    var ckie = util.getCookie('dw_levis_store_cookiepolicybar');

    if (ckie != "") {
        $('.cookiebar').remove();
        return;
    }
    $('.cookiebar').css('display','block');
    util.createCookie('dw_levis_store_cookiepolicybar');
    $('#dismissbtn').on('click', function (e) {
        e.preventDefault();
        $('.cookiebar').remove();
    });
}

var app = {
		init: function () {

			if (document.cookie.length === 0) {
				$('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
			}
			initializeDom();
			initializeEvents();

			// init specific global components
			countries.init();
			tooltip.init();
			minicart.init();
			validator.init();
			rating.init();
			searchplaceholder.init();
			// execute page specific initializations
			$.extend(page, window.pageContext);
			var ns = page.ns;
			if (ns && pages[ns] && pages[ns].init) {
				pages[ns].init();
			}

			// Check TLS status if indicated by site preference
			if (SitePreferences.CHECK_TLS === true) {
				tls.getUserAgent();
			}
			initializeCookieBar();
			$('.menu-category').css('display','block');
			
		}
};

//general extension functions
(function () {
	String.format = function () {
		var s = arguments[0];
		var i, len = arguments.length - 1;
		for (i = 0; i < len; i++) {
			var reg = new RegExp('\\{' + i + '\\}', 'gm');
			s = s.replace(reg, arguments[i + 1]);
		}
		return s;
	};
})();

$(document).ready(function () {

	var locale = $('#locale').val();

	if($('body.LeviJP').find('#smartbanner').css('display') == "block"){
		$('#wrapper').css({"margin-top":$('#smartbanner').height() + 8});
	}

	app.init();	
	if($('body').hasClass('LeviKR')){
		if(!$("input[name$='_termsandconditions']").is(":checked")){
			$(".marketing-info-consent-section").find('.input-checkbox').attr('disabled','disabled');	
		}
		
		$("input[name$='_signupallconsent']").on('click', function(e){
			$(this).parent().parent().parent().find(".consent-group").find('.input-checkbox').prop('checked', this.checked);
			// $(this).parents().find('.consent-group.consent-box').find('.input-checkbox').prop('checked', this.checked);
			$(".marketing-info-consent-section").find('.input-checkbox').prop('checked', this.checked);
			if($("input[name$='_termsandconditions']").is(":checked")){
				$(".marketing-info-consent-section").find('.input-checkbox').prop('disabled',false);	
			}else{
				$(".marketing-info-consent-section").find('.input-checkbox').prop('disabled',true);	
			}
		});
		
		$("input[name$='_termsandconditions']").on('click', function(e){
				$(".marketing-info-consent-section").find('.input-checkbox').prop('checked', this.checked);
				if($("input[name$='_termsandconditions']").is(":checked")){
					$(".marketing-info-consent-section").find('.input-checkbox').prop('disabled',false);	
				}else{
					$(".marketing-info-consent-section").find('.input-checkbox').prop('disabled',true);	
				}
		});
		 $('.activate-search').on('click',function() {
			 $('body').toggleClass('search-active');
		 });
		 $(document).on('click', '.LeviKR .newsletterpopup-sub .close-newsletterpopup', function (e) {
			e.preventDefault();
			dialog.open({
				html: $(".home_popup_magazine").html(),
				options: {	
					dialogClass:"home_popup_magazine",
					width: 600,
					open: function() {
						$('.home_popup_magazine').on('click', '.close-popup-button', function(e) {
							dialog.close();
							$('#dialog-container').animate({scrollTop:0},0); 
						});
					}
				},
			callback: function() {
				$('.home_popup_magazine').find('.ui-dialog-buttonpane').remove();
				$('.ui-dialog-titlebar').remove();
			}
			});
		});
		 
		 $(".close-drawer").on('click', function () {
			 $('#wrapper').removeClass('menu-active');
			 $('#wrapper').css("position",'');
		 });
		 $('.tap-and-hold').on('click', function() {
			//  var targetText = $('#url-copy').attr("href");
			//  var dummy = $("<input>")
			//  $("body").append(dummy);
			//  $(dummy).val(targetText).select();
			//  document.execCommand('copy');
			//  $(dummy).remove();
			 $('.pdp-main .share-social-icon .tap-hint').text('URL이 복사되었습니다.').css("display","block");
			 pdpUrlShareClick();
	 });
	}
	
	if($('body').hasClass('LeviAU') && locale=='en_AU'){
		$('#dwfrm_singleshipping_shippingAddress_addressFields_postal').attr("style", "pointer-events: none; background-color:#dad8d8;");
		$('#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button').attr("style", "pointer-events: none; background-color:#dad8d8;");
		
	}
	if($('body').hasClass('LeviJP')){
		$('#dwfrm_singleshipping_shippingAddress_addressFields_city').attr("style", "pointer-events: none;");
		$('#dwfrm_profile_address_city').attr("style", "pointer-events: none;");

		
	}
	if($('body').hasClass('LeviIN')){
		$('select[id^=selReason]').on("change",function(obj) {
			var strSource=obj.target.id;
			var reasonValue =  $('#'+strSource+ ' option:selected').val();
			$(this).next().removeClass('error_dropdown');
//			if(reasonValue !='' && $("#dwfrm_orders input[type=checkbox]:checked").length >0)
//			{
//				$('#returnProceed').prop('disabled', false);
//			}else{
//				$('#returnProceed').prop('disabled', true);
//				
//			}
			 validateitemreason();
			var selectedVal = $('option:selected', this).text();
			var selectedItem = $('#'+strSource+ ' option:last-child').text();
			 //Get the value of the selected option		   
			if(selectedItem == selectedVal)
			{
				$(this).parent().next().removeClass('hidetxt');
			
			}
			else
			{
				$(this).parent().next().addClass('hidetxt');
				$(this).parent().next().find('input[type=hidden]').val('');
				$(this).parent().next().find('textarea:first-child').val('');
				
			}
		});

		 $('select[id^=returnQty]').on("change",function(obj) {
			 var findStr="returnQtyMob";
			 var replaceStr="returnQty";
			 var strSource=obj.target.id;
			 var strTarget= strSource.indexOf("Mob")>-1?strSource.replace(findStr, replaceStr):strSource.replace(replaceStr,findStr) ; 
			 $('select#'+strTarget).children('option:selected').val($('select#'+strSource).children('option:selected').val());
		 });
		 
		 $('.chkOrders').on("click",function(obj) {
			if($(this).is(":checked"))
			{
			 var reasonValue =  $('#selReason_'+$(this).val() +' option:selected').val();
			//  $('#orderItemId').val($(this).val());
			//  var statusCount= this.getAttribute('data-statusCount');
			//  var reasonValue =  $('#selReason_'+statusCount+$(this).val() +' option:selected').val();
			 if(reasonValue !='')
			 {
				$('#selReason_'+$(this).val()).next().removeClass('error_dropdown');
			//  $('#selReason_'+statusCount+$(this).val()).next().removeClass('error_dropdown');
			 }
			 else
			 {
				$('#selReason_'+$(this).val()).next().addClass('error_dropdown');
			//   $('#selReason_'+statusCount+$(this).val()).next().addClass('error_dropdown');

			}
		  }
			else{
				$('#selReason_'+$(this).val()).next().removeClass('error_dropdown');
				// $('#selReason_'+statusCount+$(this).val()).next().removeClass('error_dropdown');
			}
			
			validateitemreason();   
	 });
	 $('.LeviIN').on('click', '[name^="dwfrm_cart_continueShopping"]', function(e) {
		sessionStorage.setItem('cartContinueShoppingClick',true);
	});
	
updaterewardSummary();
        
       $(".easyRewardsOTPinput").on("keyup paste click",function(e) {
		var _otp_input = $(this);
		var easyOTPInterval = setInterval(function() {
	            if(_otp_input.val()==''){
	                   $('#EasyRewardsValidateOTP').prop('disabled', true);
	             }
	            else{
	                  $('#EasyRewardsValidateOTP').removeAttr('disabled');
	                  clearInterval(easyOTPInterval);
	            }  
	            if (e.keyCode === 13) {
	                e.preventDefault();
	               
	                
	                 if(!$('#EasyRewardsValidateOTP').is(":disabled") && (_otp_input.val()!='')  )
	                 {
	                    $('#EasyRewardsValidateOTP').click();
	                   
	                }
	               }
		}, 700);
	});
        
        
        var INpopup = {
            autoOpen: false,
            modal: true,
             width: 450,
             minHeight:200,
             maxHeight: 400,
             title: 'Your Red Tab Points History',
             dialogClass: 'viewtransdetail-popup',
			position: {my: "left top",at: "right+50 top-100",of: "#viewearningpoints"},
            open: function(){
                jQuery('.ui-widget-overlay').bind('click',function(){
                    jQuery('#easyRewardTransDetail').dialog('close');
                })
            }
    };
	

    $("#viewearningpoints").on('click',function(e){
        try {
	    window.scrollTo(0,200);
        var viewTranDetail = $("#easyRewardTransDetail").dialog(INpopup);
        viewTranDetail.dialog("open");
    } catch (e) {
        console.log("Failed to load earning history popup ::" + e.message);
    }
        
    });

 }


 function validateitemreason()
{
   var disableProceed=false;
   $(".chkOrders" ).each(function( index ) {
	   if($(this).is(":checked"))
		   {
			var reasonValue =  $('#selReason_'+$(this).val() +' option:selected').val();
		// 	var statusCount= this.getAttribute('data-statusCount');
		//    var reasonValue =  $('#selReason_'+statusCount+$(this).val() +' option:selected').val();
		   if(reasonValue =='')
			   {
			   disableProceed=true;
			   }
				}
	});
   $('#returnProceed').prop('disabled', disableProceed);
   
   if($("#dwfrm_orders input[type=checkbox]:checked").length==0)
	{
	$('#returnProceed').prop('disabled', true);
	}	
}
 });

 $('.divshowReturnStatus').click(function(event) {
	event.preventDefault();
	$(this).next().toggle();
});

$('.divHideReturnStatus').click(function(event) {
	event.preventDefault();
	$(this).parent().hide();
});
$('textarea[id^=divtxtreasonforreturn_]').blur(function() {
   var itemId=$(this).data('itemid');
		$(this).next().val(itemId+"_"+ $(this).val());
  });
//Custom Dropdown
$(function () {
	$.widget("custom.myselectmenu", $.ui.selectmenu, {
		_renderItem: function (ul, item) {
			var li = $("<li>"),
			wrapper = $("<div>", { text: item.label });

			if (item.disabled) {
				li.addClass("ui-state-disabled");
			}
			return li.append(wrapper).appendTo(ul);
		}
	});

	$('select').myselectmenu({
		icons: { button: "ui-icon-arrowthick-1-s" },
		select: function (event, ui) {
			$(this).val(ui.item.value).trigger('change');
		}
	});

});
$(document).ready(function () {
	if($('body').hasClass('LeviAU')){
		 $(".afterpay").parents(".payment-method-options").find(".PaymentOptions .payment-method.afterpay-payment").addClass("afterpay");
			$(".afterpay").parents(".payment-method-options").addClass("payment-afterpay");
			$('.input-radio.afterpay').closest('.pMethod').css('pointer-events','none');
	 }
	 if($('body').hasClass('LeviJP')){
		 $('#dwfrm_profile_address_postal-error').addClass('errspan');
		 sessionStorage.setItem("flag", 'false');
		 if (!util.isMobile()) {
			$("#dwfrm_profile").focusout(function () {
			    if($('.edit-profile .col-1 .col-1 .form-row:nth-child(1) .error').length>1)
				  
	   		     {
	   		    	 $(".edit-profile .col-1 .col-2 .form-row:nth-child(1)").css('height', ($(".edit-profile .col-1 .col-1 .form-row:nth-child(1)").height()));
	   		     }
	   			else {
	      			 $(".edit-profile .col-1 .col-2 .form-row:nth-child(1)").css('height', 'auto');
	      		    }
	   			if($('.edit-profile .col-1 .col-2 .form-row:nth-child(1) .error').length>1)
	  		     {
	  		    	 $(".edit-profile .col-1 .col-1 .form-row:nth-child(1)").css('height', ($(".edit-profile .col-1 .col-2 .form-row:nth-child(1)").height()));
	  		     }
	   			else {
	      			 $(".edit-profile .col-1 .col-1 .form-row:nth-child(1)").css('height', 'auto');
	      		    }
	   			if($('.new-col .col-1 .form-row:nth-child(4) .error').length>1)
			     {
					
			    	 $(".new-col .col-2 .form-row:nth-child(4)").css('height', ($(".new-col .col-1 .form-row:nth-child(4)").height()));
			     }
				else {
				 $(".new-col .col-2 .form-row:nth-child(4)").css('height', 'auto');
				
			    }
				if($('.new-col .col-2 .form-row:nth-child(4) .error').length>1)
			     {			
					
			    	 $(".new-col .col-1 .form-row:nth-child(4)").css('height', ($(".new-col .col-2 .form-row:nth-child(4)").height()));
			     }
				else {
					
				 $(".new-col .col-1 .form-row:nth-child(4)").css('height', 'auto');
			     }
	   		
			    });
			 if($('#edit-address-form #addresslookup #dwfrm_login_register').parent(".form-row").find('.errspan').hasClass('error'))
		     {  
				 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
		     }
			 if($('#edit-address-form #addresslookup #dwfrm_login_register').parent(".form-row").find('#dwfrm_profile_address_postal-error').hasClass('error'))
		     {  
				 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
		     }
			 
			 
		 } 
			 if (!util.isMobile()) {	 
			 $("#edit-address-form").focusout(function () {
				 if($('#edit-address-form #addresslookup').parent(".form-row").find('.errspan').hasClass('error'))
			     {   
					 $(".new-col .col-2 .form-row:nth-child(3)").css('height', '$(".new-col .col-1 .form-row:nth-child(3)").height() !important');
			     }
	   			 if($('.new-col .col-1 .form-row:nth-child(1) .error').length>1)
	   		     {
	   		    	 $(".new-col .col-2 .form-row:nth-child(1)").css('height', ($(".new-col .col-1 .form-row:nth-child(1)").height()));
	   		     }
	   			else {
	   			 $(".new-col .col-2 .form-row:nth-child(1)").css('height', 'auto');
	   		    }
	   			if($('.new-col .col-2 .form-row:nth-child(1) .error').length>1)
	  		     {
	  		    	 $(".new-col .col-1 .form-row:nth-child(1)").css('height', ($(".new-col .col-2 .form-row:nth-child(1)").height()));
	  		     }
	   			else {
	   			 $(".new-col .col-1 .form-row:nth-child(1)").css('height', 'auto');
	   		     }
	   			if($('.new-col .col-2 .form-row:nth-child(2) .error').length>1)
	  		     {
	  		    	 $(".new-col .col-1 .form-row:nth-child(2)").css('height', ($(".new-col .col-2 .form-row:nth-child(2)").height()));
	  		     }
	   			else {
	   			 $(".new-col .col-1 .form-row:nth-child(2)").css('height', 'auto');
	   		     }
	   			if($('.new-col .col-1 .form-row:nth-child(2) .error').length>1)
	  		     {
	  		    	 $(".new-col .col-2 .form-row:nth-child(2)").css('height', ($(".new-col .col-1 .form-row:nth-child(2)").height()));
	  		     }
	   			else {
	   			 $(".new-col .col-2 .form-row:nth-child(2)").css('height', 'auto');
	   		     }
	   		    if($('.new-col .col-1 .form-row:nth-child(3) .error').length>1)
			     {   	   		 
			    	 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
			     }
	   		    else if($('.new-col .col-1 .form-row:nth-child(3) .error').css("display")=='none') {
					 $(".new-col .col-2 .form-row:nth-child(3)").css('height', 'auto');
			    }
		   		 if($('.new-col .col-2 .form-row:nth-child(3) .error').length>1)
			     {   	   		 
			    	 $(".new-col .col-1 .form-row:nth-child(3)").css('height', ($(".new-col .col-2 .form-row:nth-child(3)").height()));
			     }
				else {
					 $(".new-col .col-1 .form-row:nth-child(3)").css('height', 'auto');
			    }
	   		     
				if($('.new-col .col-1 .form-row:nth-child(4) .error').length>1)
			     {
					
			    	 $(".new-col .col-2 .form-row:nth-child(4)").css('height', ($(".new-col .col-1 .form-row:nth-child(4)").height()));
			     }
				else {
				 $(".new-col .col-2 .form-row:nth-child(4)").css('height', 'auto');
				
			    }
				if($('.new-col .col-2 .form-row:nth-child(4) .error').length>1)
			     {			
					
			    	 $(".new-col .col-1 .form-row:nth-child(4)").css('height', ($(".new-col .col-2 .form-row:nth-child(4)").height()));
			     }
				else {
					
				 $(".new-col .col-1 .form-row:nth-child(4)").css('height', 'auto');
			     }
				
	   		  });
			 }
			 if (!util.isMobile()) {
			 $("#registration-login-address").focusout(function () {
				  setTimeout(function() {
					  if($('#addresslookup').parent(".form-row").find('.errspan').hasClass('error'))
					     {   
							 $(".new-col .col-2 .form-row:nth-child(3)").css('height', '$(".new-col .col-1 .form-row:nth-child(3)").height() !important');
					     }
						 if($('.new-col .col-1 .form-row:nth-child(1) .error').length>1)
			   		     {
			   		    	 $(".new-col .col-2 .form-row:nth-child(1)").css('height', ($(".new-col .col-1 .form-row:nth-child(1)").height()));
			   		     }
			   			else {
			   			 $(".new-col .col-2 .form-row:nth-child(1)").css('height', 'auto');
			   		    }
			   			if($('.new-col .col-2 .form-row:nth-child(1) .error').length>1)
			  		     {
			  		    	 $(".new-col .col-1 .form-row:nth-child(1)").css('height', ($(".new-col .col-2 .form-row:nth-child(1)").height()));
			  		     }
			   			else {
			   			 $(".new-col .col-1 .form-row:nth-child(1)").css('height', 'auto');
			   		     }
			   			
			   			if($('.new-col .col-1 .form-row:nth-child(2) .error').length>1)
			   		     {
			   		    	 $(".new-col .col-2 .form-row:nth-child(2)").css('height', ($(".new-col .col-1 .form-row:nth-child(2)").height()));
			   		     }
			   			else {
			   			 $(".new-col .col-2 .form-row:nth-child(2)").css('height', 'auto');
			   		    }
			   			if($('.new-col .col-2 .form-row:nth-child(2) .error').length>1)
			  		     {
			  		    	 $(".new-col .col-1 .form-row:nth-child(2)").css('height', ($(".new-col .col-2 .form-row:nth-child(2)").height()));
			  		     }
			   			else {
			   			 $(".new-col .col-1 .form-row:nth-child(2)").css('height', 'auto');
				   		     }
				   		 if($('.new-col .col-1 .form-row:nth-child(3) .error').length>1)
					     {   	   		 
					    	 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
					     }
			   		    else if($('.new-col .col-1 .form-row:nth-child(3) .error').css("display")=='none') {
							 $(".new-col .col-2 .form-row:nth-child(3)").css('height', 'auto');
					    }
				   		 if($('.new-col .col-2 .form-row:nth-child(3) .error').length>1)
					     {   	   		 
					    	 $(".new-col .col-1 .form-row:nth-child(3)").css('height', ($(".new-col .col-2 .form-row:nth-child(3)").height()));
					     }
						else {
							 $(".new-col .col-1 .form-row:nth-child(3)").css('height', 'auto');
					    }
				   		
						if($('.new-col .col-1 .form-row:nth-child(4) .error').length>1)
					     {
					    	 $(".new-col .col-2 .form-row:nth-child(4)").css('height', ($(".new-col .col-1 .form-row:nth-child(4)").height()));
					     }
						else {
						 $(".new-col .col-2 .form-row:nth-child(4)").css('height', 'auto');
					    }
						if($('.new-col .col-2 .form-row:nth-child(4) .error').length>1)
					     {
					    	 $(".new-col .col-1 .form-row:nth-child(4)").css('height', ($(".new-col .col-2 .form-row:nth-child(4)").height()));
					     }
						else {
						 $(".new-col .col-1 .form-row:nth-child(4)").css('height', 'auto');
					     }
				  }, 50);
	   		   });
			
			 }
			 if (!util.isMobile()) {
			 $(".club-levi-registration-page").focusout(function () {
				  setTimeout(function() {
					 
					  if($('#addresslookup').parent(".form-row").find('.errspan').hasClass('error'))
					     {   
							 $(".new-col .col-2 .form-row:nth-child(3)").css('height', '$(".new-col .col-1 .form-row:nth-child(3)").height() !important');
					     }
						 if($('.new-col .col-1 .form-row:nth-child(1) .error').length>1)
			   		     {
			   		    	 $(".new-col .col-2 .form-row:nth-child(1)").css('height', ($(".new-col .col-1 .form-row:nth-child(1)").height()));
			   		     }
			   			else {
			   			 $(".new-col .col-2 .form-row:nth-child(1)").css('height', 'auto');
			   		    }
			   			if($('.new-col .col-2 .form-row:nth-child(1) .error').length>1)
			  		     {
			  		    	 $(".new-col .col-1 .form-row:nth-child(1)").css('height', ($(".new-col .col-2 .form-row:nth-child(1)").height()));
			  		     }
			   			else {
			   			 $(".new-col .col-1 .form-row:nth-child(1)").css('height', 'auto');
			   		     }
			   			
			   			if($('.new-col .col-1 .form-row:nth-child(2) .error').length>1)
			   		     {
			   		    	 $(".new-col .col-2 .form-row:nth-child(2)").css('height', ($(".new-col .col-1 .form-row:nth-child(2)").height()));
			   		     }
			   			else {
			   			 $(".new-col .col-2 .form-row:nth-child(2)").css('height', 'auto');
			   		    }
			   			if($('.new-col .col-2 .form-row:nth-child(2) .error').length>1)
			  		     {
			  		    	 $(".new-col .col-1 .form-row:nth-child(2)").css('height', ($(".new-col .col-2 .form-row:nth-child(2)").height()));
			  		     }
			   			else {
			   			 $(".new-col .col-1 .form-row:nth-child(2)").css('height', 'auto');
				   		     }
				   		 if($('.new-col .col-1 .form-row:nth-child(3) .error').length>1)
					     {   	   		 
					    	 $(".new-col .col-2 .form-row:nth-child(3)").css('height', ($(".new-col .col-1 .form-row:nth-child(3)").height()));
					     }
			   		    else if($('.new-col .col-1 .form-row:nth-child(3) .error').css("display")=='none') {
							 $(".new-col .col-2 .form-row:nth-child(3)").css('height', 'auto');
					    }
				   		 if($('.new-col .col-2 .form-row:nth-child(3) .error').length>1)
					     {   	   		 
					    	 $(".new-col .col-1 .form-row:nth-child(3)").css('height', ($(".new-col .col-2 .form-row:nth-child(3)").height()));
					     }
						else {
							 $(".new-col .col-1 .form-row:nth-child(3)").css('height', 'auto');
					    }
						if($('.new-col .col-1 .form-row:nth-child(4) .error').length>1)
					     {
					    	 $(".new-col .col-2 .form-row:nth-child(4)").css('height', ($(".new-col .col-1 .form-row:nth-child(4)").height()));
					     }
						else {
						 $(".new-col .col-2 .form-row:nth-child(4)").css('height', 'auto');
					    }
						if($('.new-col .col-2 .form-row:nth-child(4) .error').length>1)
					     {
					    	 $(".new-col .col-1 .form-row:nth-child(4)").css('height', ($(".new-col .col-2 .form-row:nth-child(4)").height()));
					     }
						else {
						 $(".new-col .col-1 .form-row:nth-child(4)").css('height', 'auto');
					     }
				  }, 50);
	   		   });
			 }
		   var mywindow=$("body");
		     if((navigator.appVersion.indexOf("NT 10.0")!=-1)&&(navigator.appVersion.indexOf("rv:11.0")!=-1)){
			  mywindow.addClass("WindowsNew IE11");
		     }
		     else if((navigator.appVersion.indexOf("NT 10.0")!=-1)&&(navigator.appVersion.indexOf("Chrome")!=-1)&&(navigator.appVersion.indexOf("Edge")!=-1)) {
				   mywindow.addClass("WindowsNew Edge");
			 }
		    else if((navigator.appVersion.indexOf("NT 10.0")!=-1)&&(navigator.appVersion.indexOf("Chrome")!=-1)) {
			   mywindow.addClass("WindowsNew Chrome");
		     }	
		    else if(navigator.userAgent.indexOf('Windows NT 10.0')==-1&&(navigator.userAgent.indexOf('Firefox')!=-1)) {
		    	mywindow.addClass("WindowsOld Firefox");
		     }	
		    else if(navigator.userAgent.indexOf('Windows NT 10.0')!=-1&&(navigator.userAgent.indexOf('Firefox')!=-1)) {
		    	mywindow.addClass("WindowsNew Firefox");
		     }	
		   	 
		    else {
			   mywindow.addClass("WindowsOld");
		     }
		 
	    }
}); 



if($('body').hasClass('LeviJP')){
	if($('#wrapper').hasClass('pt_order-confirmation') && $('#confirmationpageload').val()=="true") { 
		
		$(document).ready(function () {
			var ID=$(".order-no span.value").text();
			
			$.ajax({
	            type: "GET",
	            url: Urls.isconfirmationpageload,
	            data : {
	                orderid : ID
	             },
	             success: function(response) {}
	       });
	   });
	}
}


$("#warehouseSaleBtn").on('click',function(e){
	try{
		$("#warehouseSaleForm .error-form").hide();
		$("#warehousepasscode").removeClass("error");
		var temp=$("#warehousepasscode").val();
		if(temp==''){
			$("#warehouseSaleForm .error-form").show();
			$("#warehousepasscode").addClass("error");
			return false;
		}else{
		    temp = temp.toLowerCase();
		}
		$.ajax({
	        url: Urls.checkWarehouseSalePasscode,
	        type: 'post',
	        data: {
	        	passcode: temp
	        },
	    	dataType: 'json',
	        success: function(response) {
	        	if(response.success==true){
	        		window.location.reload();
	        	}else{
	        		$("#warehouseSaleForm .error-form").show();
	        		$("#warehousepasscode").addClass("error");
	        	}
	        },
	        error: function(response) {
	        	$("#warehouseSaleForm .error-form").show();
	        	$("#warehousepasscode").addClass("error");
	            return;
	        }
	    });
	}catch(e){
		console.log("Failed to submit warehouseSale popup ::"+e.message);
	}
});
$('#warehousepasscode').on('focusout',function(){
	$("#warehouseSaleForm .error-form").hide();
	$("#warehousepasscode").removeClass("error");
	var passcode_min = parseInt($(this).attr('minlength'));
	var passcode_length = $(this).val().length;
	var passcode_value = $(this).val();
	if(passcode_value == '' || passcode_length < passcode_min){
		$("#warehouseSaleForm .error-form").show();
		$("#warehousepasscode").addClass("error");
		return false;
	}
});


if ($('body').hasClass('LeviAU')){  
    $(document).ready(function () {  
        if($("#dwfrm_singleshipping_shippingAddress_addressFields_city").length>0){  
            $("#dwfrm_singleshipping_shippingAddress_addressFields_city").attr("autocomplete","donot-autofill");  
        }
        if($("#dwfrm_profile_address_city").length>0){
            $("#dwfrm_profile_address_city").attr("autocomplete","donot-autofill");  
        }
    });  
}

if ($('body').hasClass('LeviJP')){

	$(document).ready(function () {
		$('#dwfrm_singleshipping_shippingAddress_addressFields_phone').keyup(function() {
			var phoneNoNew = $('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val().length;
			if (phoneNoNew>12){
				var display1 =  $('#dwfrm_singleshipping_shippingAddress_addressFields_phone-error').css("display");
				if($('.errspan.error').length>0){
    				$('body.LeviJP [name$="_phone"]').parent().find('.errspan.error').remove();
				}
				var errSpan = document.createElement('span');
    			errSpan.innerHTML = '正しい番号を入力してください。';
    			errSpan.className += "errspan error";
        		$('body.LeviJP [name$="_phone"]').parent().append(errSpan);
			} else {
				$('body.LeviJP [name$="_phone"]').parent().find('.errspan.error').remove();
			}
		});
    });  
}


$('#hero_button').on('click', function (e) {
    e.preventDefault();
    hero("show");
});


$('#pause').on('click', function (e) {
	$('#play').css('background-color','#fff');
	$('#play').css('border','none');
	$('#pause').css('background-color','rgb(109 108 108)');
	$('#pause').css('border','rgb(60 60 60)');
});


$('#play').on('click', function (e) {
	$('#play').css('background-color','rgb(109 108 108)');
	$('#play').css('border','rgb(60 60 60)');
	$('#pause').css('background-color','#fff');
	$('#pause').css('border','none');
});


if(util.isMobile() && $('body').hasClass('LeviAU')){
	
$('.icon-triangle-down').on('click', function (e) {	
	$('.user-panel').toggle();	

});
	
}

$('#myBtn').on('click', function (e) {
//When the user clicks on the button, scroll to the top of the document

document.body.scrollTop = 0; // For Safari
document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

});


if(util.isMobile() || ($(window).width() < 768 && $('body').hasClass('LeviIN'))) {
if($('li').hasClass('selected')) { 
	$('.mobilefilteractions').show();
}
else {
	$('.mobilefilteractions').hide();
}
}

$('.divredtabstatus').click(function(event) {
	event.preventDefault();
	$(this).next().toggle();
});


$('.divHideRedTabStatus').click(function(event) {
	event.preventDefault();
	$(this).parent().hide();
});

$('.divshowPointsStatus').click(function(event) {
	event.preventDefault();
	$(this).next().toggle();
});

$('.divHidePointsStatus').click(function(event) {
	event.preventDefault();
	$(this).parent().hide();
});


//RedTab Reward Functionalities
function updaterewardSummary() {
      
	
	// indicate progress
	progress.show($summary);

	    var $summary = $('.easyRewards_Cart').length > 0?$('.easyRewards_Cart') :$('.easyRewards_payment');
	
			var easyRewardOTPStatus= ($('#easyRewardOTPStatus').length == 0)?-1: ($('#easyRewardOTPStatus').val()==0?0:1);
		    var easyRewardOTPSent= ($('#easyRewardOTPSent').length == 0)?-1: ($('#easyRewardOTPSent').val()=='null'?-1:0);
		
			$summary.load(Urls.cartUpdateEasyRewardsURL+ "?param="+ easyRewardOTPStatus + "&param1="+ easyRewardOTPSent , function () {
			
			var $summary = $('#easyRewardsPoints');
			$('.easyRewards').css('display', 'inline-block');
			var points = $summary.find('#easyPointRedemeed').val();
			if (points > 0) {
				$summary.find('#easyRewardEdit').show();
				$summary.find('#easyRewardConfirm').hide();
			}
			else {
				$summary.find('#easyRewardEdit').hide();
				
				$summary.find('#easyRewardConfirm').show();

			}
			   $summary.find('#easyrewardsEditPoint').on('click', function (e) {
				$summary.find('#easyRewardEdit').hide();
				$summary.find('#easyRewardConfirm').show();
			 });
		 // load the updated summary area
		
		 InitializeAddRemoveRewards();
		   
	
});

	progress.hide();
   
}

function InitializeAddRemoveRewards()
{

	//Disable the input textbox if there are no points

	if($(".easyPoints").attr('max')==0)
		{
			$(".easyPoints").prop('disabled', true);
		}
		else
		{
			$(".easyPoints").removeAttr('disabled');
		}

	//  Click event of Confirm Button   
	$('#easyrewardsAddPoint').on('click', function(e){  
		try { 
		var points = $(this).parent().find('input').val();
		var pointRate = $("#dwfrm_cart_easyrewardPointsRate").val();
		var totalPoints = $("#dwfrm_cart_easyrewardTotalPt").val();
		var url = util.appendParamsToUrl(Urls.addEasyRewardPoints);
		ajax.postJson({
					 url: url,
					 dataType: "json",
					 data : {'easyrewardPoints': points, 'easyrewardTotalPt':totalPoints ,'easyrewardPointsRate':pointRate ,'format': 'ajax'},
					 contentType: "application/json",
					 callback: function (response){
						
						if($('.checkout-order-totals').length > 0)
						{
							location.reload();
						}
						else{
							var $summary = $('.cart-order-totals');
							$summary.load(Urls.cartOrderTotalRefreshURL, function () {
							 });
							updaterewardSummary();
						}
					  },
					 success:function(data)
					 {
						
					 }
			   });
			} catch (e) {
				console.log("Failed to call easyRewardsAddpoint ::" + e.message);

			}

			
 });
 
 
  $('#easyrewardsRemovePoint').on('click', function(e){  
	try { 
		 var url = util.appendParamsToUrl(Urls.removeEasyRewardPoints);
		ajax.postJson({
					 url: url,
					 dataType: "json",
					 data : {'format': 'ajax'},
					 contentType: "application/json",
					 callback: function (response){
						
						if($('.checkout-order-totals').length > 0)
						{
							location.reload();
						}
						else
						{
							var $summary = $('.cart-order-totals');
							$summary.load(Urls.cartOrderTotalRefreshURL, function () {
							 });
							updaterewardSummary();
						}
							
					 }
			   });
			} catch (e) {
				console.log("Failed to call easyRewardsRemovepoint ::" + e.message);
			}
 });
 $(".easyPoints").on("keyup", function (event) {
	try {
	   var cartTotal= $("#omniture-cart-details").length > 0?parseInt($('#omniture-cart-details').data('cartdetail').cartTotal) :parseInt($('#omniture-billing-details').data('billingdetail').checkout_Total);
    if (event.keyCode === 13) {
		 event.preventDefault();
		
		 if($(this).val()=="")
		 {
			$('#easyrewardsRemovePoint').click();
		 }
		 else if(!$('#easyrewardsAddPoint').is(":disabled") )
		  {
		   
			$('#easyrewardsAddPoint').click();
		 }
		
   	}
    
	   
   if (($(this).val() < parseInt($(this).attr('min')) || $(this).val() > parseInt($(this).attr('max'))) || ($(this).val()=='')) {
	   $('#dwfrm_cart_easyrewardPoints-error').attr('style', 'display: block !important');
	   $('#custom_easyrewardPoints-error').attr('style', 'display: none !important');
	   $('#easyrewardsAddPoint').prop('disabled', true);

   }
   else if(parseInt($(this).val()) > cartTotal )
   {
	   $('#custom_easyrewardPoints-error').html('Please enter a value less than '+ cartTotal)
	   $('#custom_easyrewardPoints-error').attr('style', 'display: block !important');
	   $('#dwfrm_cart_easyrewardPoints-error').attr('style', 'display: none !important');
	   $('#easyrewardsAddPoint').prop('disabled', true);
   }
   
   else {
	   $('#dwfrm_cart_easyrewardPoints-error').attr('style', 'display: none !important')
	   $('#custom_easyrewardPoints-error').attr('style', 'display: none !important');
	   $('#easyrewardsAddPoint').removeAttr('disabled');
   }
	} catch (e) {
		console.log("Issue on Keypress");
   }
});

var inputBox = $('.easyRewards').find('input[type=number]');

		var invalidChars = [
		"-",
		"+",
		"e","."
		];

		inputBox.on("keydown", function(e) {
		if (invalidChars.includes(e.key)) {
			e.preventDefault();
		}
		});
	
}
$(".wishlist-content button[name*=_deleteItem]").on('click',function(e){
	try{
		if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
			var productName = $(e.target).attr("data-producttitle");
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "customEvent",
				eventCategory: "removeFromWishlist",
				eventAction: productName
			});
		}
	}catch (e) {
		console.log("dataLayer Wishlist remove::" + e.message);
	}
});
$(".share-social-icon a#facebook-share-icon, .share-social-icon a#copyurl-icon, .share-social-icon #kakao-share-icon, .share-social-icon #url-copy").on('click',function(e){
	try{
		e.preventDefault();
		if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
			var $parent = $(e.target).closest('.share-social-icon');
			var productname = $parent.attr("data-producttitle");
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "customEvent",
				eventCategory: "productShared",
				eventAction: productname,
				eventLabel: this.id
			});
		}
	}catch (e) {
		console.log("dataLayer social login click:" + e.message);
	}
});
window.pageName='';
var temp = $("body").attr("class").split(" ");
for(var i=0;i<temp.length;i++){
	if(temp[i].indexOf("page")!= -1){
		window.pageName = temp[i];
	}
}
if($(window).width()< 768){
	$(document).ready(function () {
		$("ul.menu-category.level-1 .has-sub-menu, a.nav-item-level2, .level-3 li a, .level-2 a").on('click',function(e){ 
			try{
				if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
					var categorynavpath = $(e.target).attr("data-header-nav");
					var $parentcat = $(e.target).closest(".main-menu");
					var listname = $parentcat.attr("data-catName");
					var categorynavpath = categorynavpath.replace('Category:','');
					window.dataLayer = window.dataLayer || [];
					dataLayer.push({
						event: "customEvent",
						eventCategory: "NavigationClicked",
						eventAction: listname,
						eventLabel: categorynavpath,
						eventValue: window.pageName
					});
				}
			}catch (e) {
				console.log("dataLayer NavigationClicked error:::mobile" + e.message);
			}
		});
	});
}else{
	$("ul.menu-category.level-1 .has-sub-menu, a.nav-item-level2, .level-3 li a, .level-2 .menu-horizontal a, .level-2 li a").on('click',function(e){ 
		try{
			if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
				var categorynavpath = $(e.target).attr("data-header-nav"); 
				var $parentcat = $(e.target).closest(".main-menu");
				var listname = $parentcat.attr("data-catName");
				var categorynavpath = categorynavpath.replace('Category:','');
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					event: "customEvent",
					eventCategory: "NavigationClicked",
					eventAction: listname,
					eventLabel: categorynavpath,
					eventValue: window.pageName
				});
			}
		}catch (e) {
			console.log("dataLayer NavigationClicked error:::" + e.message);
		}
	});
}

$('[name$="dwfrm_ordertrack_findorder"]').on('click', function(e) {
	try{
		if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
			var $orderTrackForm = $(this).closest('form'); 
			var trackOrderId = $orderTrackForm.find('[id*="dwfrm_ordertrack_orderNumber"]').val();
			if(trackOrderId!=null){
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					event: "customEvent",
					eventCategory: "orderTracked",
					eventAction: trackOrderId
				}); 
			}
		}
	}catch (e) {
		console.log("dataLayer ordertrack error:::" + e.message);
	}
});
function checkGA4Enabled(){ 
	var isGA4Enabled = $("#isGAEnabled").length>0 ? $("#isGAEnabled").val() : false;
	return isGA4Enabled;
}
function checkGA3Enabled(){
	var isGA3Enabled = $("#isGA3Enabled").length>0 ? $("#isGA3Enabled").val() : false;
	return isGA3Enabled;
}
$(".product-tile a.name-link, .product-tile .product-image a.thumb-link img").on('click',function(e){ 
	try{
		var isGA3Enabled = checkGA3Enabled();
		var isGA4Enabled= checkGA4Enabled();
		var currencyCode = $(".productListdataJSON").length > 0 ? $(".productListdataJSON").attr("currencyCode") : '';
		var $parent = $(e.target).closest(".product-tile").children(".productListdataJSON");
		var ga3data = $parent.attr("data-list-ga3-analytcis");
		var ga4data = $parent.attr("data-list-ga4-analytcis");
		var ga3dataJSON = JSON.parse(ga3data);
		var ga4dataJSON = JSON.parse(ga4data);
		var listname='';
		if(evar!=null && evar.pageData!=null && evar.pageData.pagecat!=null){
			listname = evar.pageData.pagecat;
		}
		var eventcategory = typeof evar !='undefined' && evar!=null && evar.pageData !=null && evar.pageData.pagename!=null ? evar.pageData.pagename : window.pageName;
		
		listname = ga3dataJSON.list;
		if(isGA3Enabled && isGA3Enabled == "true"){
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "Product Click",
				eventCategory: eventcategory,
				ecommerce : {
					currecnyCode: currencyCode,
					click : {
						actionField:{
							list: listname,
							"action" : "click"
						},
						products:ga3dataJSON
					}
				}
			});
		}
		if(isGA4Enabled && isGA4Enabled == "true"){
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "select_item",
				eventCategory: eventcategory,
				ecommerce : {
					items:ga4dataJSON
				}
			});
		}
		
	}catch (e) {
		console.log("dataLayer product click event error:::" + e.message);
	}
});
$('.cart-coupon-code #add-coupon, .cart-promo-code #add-coupon').on('click', function(e) {
	if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			event: "customEvent",
			eventCategory: "CouponApplyTracked",
			eventAction: "cartpage-promo-attempt",
			eventLabel: $("[id*='dwfrm_cart_couponCode']").val(),
			EventValue : "attempt"
		});
 	}
});
function mobileLevel3NavClick(){
	if($(window).width()< 768){
		$(".level-3 li a").on('click',function(e){ 
			try{
				if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
					var categorynavpath = $(e.target).attr("data-header-nav");
					var $parentcat = $(e.target).closest(".level-3");
					var listname = $parentcat.attr("data-topcatname");
					var categorynavpath = categorynavpath.replace('Category:','');
					window.dataLayer = window.dataLayer || [];
					dataLayer.push({
						event: "customEvent",
						eventCategory: "NavigationClicked",
						eventAction: listname,
						eventLabel: categorynavpath,
						eventValue: window.pageName
					});
				}
			}catch (e) {
				console.log("dataLayer NavigationClicked error:::mobile::" + e.message);
			}
		});
	}
}
function pdpUrlShareClick(){
	$(".share-social-icon #url-copy").on('click',function(e){
		try{
			if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
				var $parent = $(e.target).closest('.share-social-icon');
				var productname = $parent.attr("data-producttitle");
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					event: "customEvent",
					eventCategory: "productShared",
					eventAction: productname,
					eventLabel: this.id
				});
			}
		}catch (e) {
			console.log("dataLayer social login click:" + e.message);
		}
	});
} 

//Signin/Signup Modal popup
function loginDialog(clickedButton) {
	dialog.open({
		// html: $(".login-account-popup").html(),
		url: clickedButton.data("includepopup"),
		options: {
			dialogClass: "loginpopup-sub",
			open: function() {
				validator.init();
				if (clickedButton.hasClass('guest_sign_in') || clickedButton.hasClass('guest_sign_in_mobile')) {
					var winUrl = window.location.href;
					if (winUrl.indexOf('#') > -1 ) {
						winUrl = winUrl.substring(0, winUrl.lastIndexOf("#"));
					}
					$('.continuepage_url').val(winUrl);
				} else {
					$('.continuepage_url').val(clickedButton.attr('href'));
				}
				$('.loginpopup-sub .svg-icon--eye-closed').hide();
				$('.loginpopup-sub').on('click', '.close-button , .close-popup-button', function(e) {
					dialog.close();
				});

				$('[id$="_login"]').on('submit', function(e) {
					var data = $(this).serialize() + "&format=ajax";
					var Url = Urls.checkMigratedCustomer;
					$.ajax({
						url: Url,
						method: 'POST',
						data: data,
						dataType: 'json',
						async: false,
						success: function(response) {
							if (typeof response === 'object') {
								if (response.message == "migrated") {
									e.preventDefault();
									$('#password-reset').trigger('click');
									return;
								} else if (response.message == "nonmigrated") {
									$('[id$="_login"]').unbind('submit');
									$(this).off('submit');
								}
							}
						}
					});
				});

				var $loginPopupForm = $('.loginpopup-sub .formbox');
				var $submitLogin = $loginPopupForm.find('[name$="_login_login"]');
				var currentPageUrl = $('.continuepage_url').val();

				$($submitLogin).on('click', function(e) {
					if (!$loginPopupForm.valid()) {
						return;
					}
					e.preventDefault();
					var data = $loginPopupForm.serialize();
					// add form action to data
					data += '&' + $submitLogin.attr('name') + '=';
					// make sure the server knows this is an ajax request
					if (data.indexOf('ajax') === -1) {
						data += '&format=ajax';
					}
					if ($loginPopupForm.valid()) {
						dialog.$container.find('.login-button.submit_btn .btntext').addClass('hide');
						dialog.$container.find('.login-button.submit_btn .loader-svg').removeClass('hide');
					}
					$.ajax({
						type: 'POST',
						url: $loginPopupForm.attr('action'),
						data: data,
						success: function(response) {
							dialog.$container.find('.login-button.submit_btn .btntext').removeClass('hide');
							dialog.$container.find('.login-button.submit_btn .loader-svg').addClass('hide');
							if (typeof response === 'object' &&
							!response.success &&
							response.error === 'CSRF Token Mismatch') {
								page.redirect(Urls.csrffailed);
							} else if (typeof response === 'string') {
								if (response === 'FAILURE') {
									dialog.$container.find('.custom-error').html(Resources.INCORRECT_LOGIN_ERROR);
									return;
								} else {
									page.redirect(currentPageUrl);
								}
							} else if (typeof response === 'object'){
								page.redirect(response.location);
							}
						}
					});
				});

				$('#dialog-container').on('keypress focusin', '.input-text', function(e) {
					$(this).closest('.form-grp').addClass('animate-field');
					$(this).closest('.formbox').find('.submit_btn').removeAttr('disabled');
				});

				if ($('.loginpopup-sub .input-text').val()) {
					$('.loginpopup-sub .input-text').closest('.form-grp').addClass('animate-field');
					$('.loginpopup-sub .input-text').closest('.formbox').find('.submit_btn').removeAttr('disabled');
				}

				$('.loginpopup-sub').on('click', '.checkpwd', function() {
					$(this).toggleClass("showing");
					var type = $(this).hasClass("showing") ? "text" : "password";
					$(".loginpopup-sub .password input").attr("type", type);
				});

				$('.oAuthIcon').bind('click', function() {
					$('.loginpopup-sub #OAuthProvider').val(this.id);
				});

				$('.loginpopup-sub').on('click', '.create-acct', function() {
					dialog.close();
					$("#exampleModal").modal('show');
					$("#exampleModal").addClass('sign_up_dialog');
					$('body').addClass('sign_up_dialog');
				})

				$('.loginpopup-sub').on('click', '.pwd-reset-popup', function(e) {
					e.preventDefault();
					dialog.open({
						url: $(this).attr('href'),
						options: {
							dialogClass: "reset-password-sub",
							open: function() {
								if (util.isMobile()) {
									$('#wrapper').css('position', 'fixed');
								}
								$('#PasswordResetForm button').attr('disabled', 'disabled');
								// $('.reset-password-sub #PasswordResetForm .form-row.row-inline').append('<span class="field-name">Email</span>')
								$('.reset-password-sub').append("<span class='close-popup-button' data-click='Close' ><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.70891 0.294696C1.31938 -0.0968216 0.686214 -0.0984333 0.294696 0.291095C-0.0968213 0.680623 -0.0984337 1.31379 0.291095 1.7053L6.55754 8.00374L0.308707 14.2845C-0.0808221 14.676 -0.0792097 15.3092 0.312308 15.6987C0.703825 16.0882 1.33699 16.0866 1.72652 15.6951L7.96816 9.42157L14.2098 15.6951C14.5993 16.0866 15.2325 16.0882 15.624 15.6987C16.0155 15.3092 16.0171 14.676 15.6276 14.2845L9.37879 8.00374L15.6452 1.7053C16.0348 1.31379 16.0331 0.680624 15.6416 0.291096C15.2501 -0.0984328 14.6169 -0.0968205 14.2274 0.294697L7.96816 6.58591L1.70891 0.294696Z' fill='black'/></svg></span>");
								$('#dialog-container').on('keypress focusin', '#PasswordResetForm .email', function(e) {
									$(this).closest('.form-grp').addClass('animate-field');
									$('#PasswordResetForm button').removeAttr('disabled');
								});
								$('.reset-password-sub').on('click', '.reset-password-button', function(e) {
									e.preventDefault();
									dialog.close();
									if (util.isMobile()) {
										$('#wrapper').css('position', 'relative');
									}
								});
								$('.reset-password-sub').on('click', '.reset-password-button-confirm', function(e) {
									e.preventDefault();
									dialog.close();
									if (util.isMobile()) {
										$('#wrapper').css('position', 'relative');
									}
								});
								validator.init();

								$('#dialog-container').on('keypress focusout', '#PasswordResetForm .email', function(e) {
									if ($(this).closest('.field-wrapper').find('.errspan').hasClass('error')) {
										$(".errspan").removeClass('error').text('');
										$(".form-row").removeClass('error');
									}
								});

								var $requestPasswordForm = $('[name$="_requestpassword"]');
								var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
								$($submit).on('click', function(e) {
									if (!$requestPasswordForm.valid()) {
										return;
									}
									e.preventDefault();
									var data = $requestPasswordForm.serialize();
									// add form action to data
									data += '&' + $submit.attr('name') + '=';
									// make sure the server knows this is an ajax request
									if (data.indexOf('ajax') === -1) {
										data += '&format=ajax';
									}
									$.ajax({
										type: 'POST',
										url: $requestPasswordForm.attr('action'),
										data: data,
										success: function(response) {
											if (typeof response === 'object' &&
												!response.success &&
												response.error === 'CSRF Token Mismatch') {
												page.redirect(Urls.csrffailed);
											} else if (typeof response === 'string') {

												if (response == 'email error') {
													var errSpan = document.createElement('span');
													errSpan.innerHTML = Resources.NOT_REGISTERED_EMAIL;
													errSpan.className += "errspan error";
													$submit.closest('fieldset').find('.field-wrapper').append(errSpan);
													return;
												} else {
													$(this).closest('.field-wrapper').find('.errSpan').remove();
													dialog.$container.html(response);

												}
											}
										},
										failure: function() {
											dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
										}
									});
								});
							}
						}
					});

				});

			}
		}
	});
}

//Sigin/Signup Popup from header link
if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') || $('body').hasClass('LeviKR')) {
	$('body').on('click', '.guest_sign_in, .guest_sign_in_mobile, .user-wishlist-info.guestUser .user-wishlist, .cart-saveforlaterGuest', function(event){
		event.preventDefault();
		loginDialog($(this));
		return false;    
	});
}
//Sigin/Signup Popup from header link


$("#search-suggestions .suggestions_close-button").on('click', function(){
	$("#search-suggestions").hide(); 
});

// PLP Color Swatches

function initMoreLess(pid, ulColor) {
    var arr = new Array();
    var noOfSwatches = 5;

	if ($(window).width() < 768 && util.isMobile()) { 
		noOfSwatches = 4;
	}
    if (pid !== undefined && pid > 0 && ulColor) {
        ulColor.find('a').each(function() {
            arr.push($(this).parent());
        });
        ulColor.each(function() {
            var LiN = $(this).find('li').not($(".more")).find('a').length;

            if (LiN > noOfSwatches) {
                $(arr[noOfSwatches - 1]).nextAll().hide().addClass('toggleable');
                $(ulColor).append('<li class="more swatches swatch_show" style="display:block"><a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a></li>');
            }

        });
        ulColor.on('click', '.more.swatch_show', function() {
            var LiN = $(this).closest(ulColor).find('li').not($(".more")).find('a').length;
            if ($(this).hasClass('less')) {
                $(this).siblings('li.toggleable').fadeToggle();
                $(this).html('<a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a>').removeClass('less');
            } else {
                $(this).siblings('li.toggleable').fadeToggle();
				$(this).html('<a class="swatch"><div>'+ Resources.LESS +'</div></a>').addClass('less');
            }
        });
        return;
    }
    $(ulColor).each(function() {
        var LiN = $(this).find('li').not($(".more")).find('a').length;
        $(this).find('a').each(function() {
            arr.push($(this).parent());
        });
        if (LiN > noOfSwatches) {
            $(arr[noOfSwatches - 1]).nextAll().hide().addClass('toggleable');
            $(ulColor).append('<li class="more swatches" style="display:block"><a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a></li>');
        }

    });

    // $(ulColor).on('click', '.more', function(e) {
    //     e.preventDefault();
    //     if ( ( !$('body').hasClass('LeviKR') ) && $(this).closest('div.quickview-popup').length) {
    //         // go to PDP
    //         window.location.href = $(this).closest('.product-variations').data('producturl');
    //     }
    //     e.preventDefault();
    //     var LiN = $(this).closest(ulColor).find('li').not($(".more")).find('a').length;
    //     if ($(this).hasClass('less')) {
    //         $(this).siblings('li.toggleable').fadeToggle();
    //         $(this).html('<a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a>').removeClass('less');
    //     } else {
    //         $(this).siblings('li.toggleable').fadeToggle();
    //         $(this).html('<a class="swatch"><div>Less</div></a>').addClass('less');
    //     }
    // });
}

var plpProductTile = $('.plp-page .search-result-items .product-tile');
if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') || $('body').hasClass('LeviKR') && plpProductTile.length > 0 ) {
	$(plpProductTile).each(function( index ) {
		var masterpid = $(this).data('masterpid');
        var ulColor = $(this).find('ul.swatch-list');
		initMoreLess(masterpid, ulColor);
	});
}

// PLP Color Swatches


// Wishlist Code Block & Login/Signup Modal popup
// Wishlist icon function on coordinate tiles
var timerwishlist = {
	id: null,
	clear: function () {
		if (this.id) {
			window.clearTimeout(this.id);
			delete this.id;
		}
	},
	start: function (duration, callback) {
		this.id = setTimeout(callback, duration);
	}
};

function wishlist(clickedButton) {
    var wishlisturl = clickedButton.data("href");
	var pid = clickedButton.data("pid");
    // var userLoggedin = clickedButton.data("customerAuthenticated");
    var userLoggedin = $('.sign-in-hover').length > 0;
	var locale = $('#locale').val();

    if (!userLoggedin && userLoggedin != undefined) {
		loginDialog(clickedButton);
    } else {
        $.ajax({
            url: wishlisturl,
            data: {
                'pid': pid
            },
            success: function(res) {
                if (res.result == 'added') {
                    if (clickedButton.hasClass("fromCartPage")) {

                        $(".removeCartItem-" + pid).hide();
                        setTimeout(function() {
                            $(".removeCartItemButton-" + pid).trigger("click");
                        }, 3000);
                    } else {
                        clickedButton.data("href", wishlisturl.replace("action=add", "action=remove"));
                        clickedButton.empty();
                        clickedButton.append('<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4175 2.27576C15.7976 2.94178 15.9983 3.69648 16 4.45926C16 4.60601 15.9918 4.75276 15.9786 4.8995C15.8963 5.77355 15.6462 6.5976 15.2875 7.39908C14.8498 8.37955 14.2277 9.27134 13.5169 10.0809C12.5937 11.1307 11.4879 12.0241 10.3097 12.7853C9.98057 12.9997 9.64323 13.2029 9.29931 13.3964C9.11501 13.4996 8.93071 13.5996 8.74312 13.6964C8.64274 13.748 8.54236 13.7996 8.44363 13.8528C8.35641 13.8996 8.27084 13.9528 8.1754 13.9786C7.98616 14.0286 7.8068 13.9867 7.6373 13.898C6.91491 13.5206 6.20238 13.1304 5.52442 12.6804C4.37089 11.9144 3.28976 11.0243 2.39129 9.97767C1.69358 9.16652 1.08966 8.27796 0.665107 7.29909C0.321187 6.50568 0.0809366 5.68969 0.0134691 4.82855C-0.0836184 3.59005 0.347516 2.36607 1.19827 1.44526C2.12306 0.443816 3.54811 -0.109315 4.92379 0.0180821C5.68897 0.0890377 6.43441 0.322869 7.07288 0.74699C7.41504 0.97557 7.72766 1.24536 7.99833 1.55067C8.36377 1.13471 8.80812 0.782453 9.29931 0.527672C10.7276 -0.212524 12.5131 -0.170595 13.8805 0.688935C14.5124 1.08725 15.0505 1.63232 15.4175 2.27576Z" fill="#C21734"/></svg>');
                        $(".user-wishlist-info .user-wishlist").html('<div class="heartfilled"><span class="wishlist-quantity">' + res.wilistCount + '</span></div>');
                    }
                    // if ($(window).width() > 767) {
                        $(".wishlist-slide").empty();
                        var parsData = $.parseJSON(res.jsonData);
						var html;
						if ($('body').hasClass('LeviKR')) {
							html = '<div class="miniwishlist-main">' +
                            '<div class="fav-main">' +
                            '<div class="fav-header">' +
							'<svg class="hearticon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4175 2.27576C15.7976 2.94178 15.9983 3.69648 16 4.45926C16 4.60601 15.9918 4.75276 15.9786 4.8995C15.8963 5.77355 15.6462 6.5976 15.2875 7.39908C14.8498 8.37955 14.2277 9.27134 13.5169 10.0809C12.5937 11.1307 11.4879 12.0241 10.3097 12.7853C9.98057 12.9997 9.64323 13.2029 9.29931 13.3964C9.11501 13.4996 8.93071 13.5996 8.74312 13.6964C8.64274 13.748 8.54236 13.7996 8.44363 13.8528C8.35641 13.8996 8.27084 13.9528 8.1754 13.9786C7.98616 14.0286 7.8068 13.9867 7.6373 13.898C6.91491 13.5206 6.20238 13.1304 5.52442 12.6804C4.37089 11.9144 3.28976 11.0243 2.39129 9.97767C1.69358 9.16652 1.08966 8.27796 0.665107 7.29909C0.321187 6.50568 0.0809366 5.68969 0.0134691 4.82855C-0.0836184 3.59005 0.347516 2.36607 1.19827 1.44526C2.12306 0.443816 3.54811 -0.109315 4.92379 0.0180821C5.68897 0.0890377 6.43441 0.322869 7.07288 0.74699C7.41504 0.97557 7.72766 1.24536 7.99833 1.55067C8.36377 1.13471 8.80812 0.782453 9.29931 0.527672C10.7276 -0.212524 12.5131 -0.170595 13.8805 0.688935C14.5124 1.08725 15.0505 1.63232 15.4175 2.27576Z" fill="#000"/></svg>' +
                            '위시리스트에 추가되었습니다' +
							'<svg class="closeicon" width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.70891 0.294696C1.31938 -0.0968216 0.686214 -0.0984333 0.294696 0.291095C-0.0968213 0.680623 -0.0984337 1.31379 0.291095 1.7053L6.55754 8.00374L0.308707 14.2845C-0.0808221 14.676 -0.0792097 15.3092 0.312308 15.6987C0.703825 16.0882 1.33699 16.0866 1.72652 15.6951L7.96816 9.42157L14.2098 15.6951C14.5993 16.0866 15.2325 16.0882 15.624 15.6987C16.0155 15.3092 16.0171 14.676 15.6276 14.2845L9.37879 8.00374L15.6452 1.7053C16.0348 1.31379 16.0331 0.680624 15.6416 0.291096C15.2501 -0.0984328 14.6169 -0.0968205 14.2274 0.294697L7.96816 6.58591L1.70891 0.294696Z" fill="black"/></svg>' +
                            '<br>' +
                            '</div>' +
                            '<tr class="item-description">' +
                            '<td class="item-image">' +
                            '<div class="fav-p_image">' +
                            '<img src="' + parsData.thumbnailUrl + '"/>' +
                            '</div>' +
                            '</td>';
						}
						else {
							html = '<div class="miniwishlist-main">' +
								'<div class="fav-main">' +
								'<div class="fav-header">' +
								'<svg class="hearticon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4175 2.27576C15.7976 2.94178 15.9983 3.69648 16 4.45926C16 4.60601 15.9918 4.75276 15.9786 4.8995C15.8963 5.77355 15.6462 6.5976 15.2875 7.39908C14.8498 8.37955 14.2277 9.27134 13.5169 10.0809C12.5937 11.1307 11.4879 12.0241 10.3097 12.7853C9.98057 12.9997 9.64323 13.2029 9.29931 13.3964C9.11501 13.4996 8.93071 13.5996 8.74312 13.6964C8.64274 13.748 8.54236 13.7996 8.44363 13.8528C8.35641 13.8996 8.27084 13.9528 8.1754 13.9786C7.98616 14.0286 7.8068 13.9867 7.6373 13.898C6.91491 13.5206 6.20238 13.1304 5.52442 12.6804C4.37089 11.9144 3.28976 11.0243 2.39129 9.97767C1.69358 9.16652 1.08966 8.27796 0.665107 7.29909C0.321187 6.50568 0.0809366 5.68969 0.0134691 4.82855C-0.0836184 3.59005 0.347516 2.36607 1.19827 1.44526C2.12306 0.443816 3.54811 -0.109315 4.92379 0.0180821C5.68897 0.0890377 6.43441 0.322869 7.07288 0.74699C7.41504 0.97557 7.72766 1.24536 7.99833 1.55067C8.36377 1.13471 8.80812 0.782453 9.29931 0.527672C10.7276 -0.212524 12.5131 -0.170595 13.8805 0.688935C14.5124 1.08725 15.0505 1.63232 15.4175 2.27576Z" fill="#000"/></svg>' +
								'Added to your Favorites' +
								'<svg class="closeicon" width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.70891 0.294696C1.31938 -0.0968216 0.686214 -0.0984333 0.294696 0.291095C-0.0968213 0.680623 -0.0984337 1.31379 0.291095 1.7053L6.55754 8.00374L0.308707 14.2845C-0.0808221 14.676 -0.0792097 15.3092 0.312308 15.6987C0.703825 16.0882 1.33699 16.0866 1.72652 15.6951L7.96816 9.42157L14.2098 15.6951C14.5993 16.0866 15.2325 16.0882 15.624 15.6987C16.0155 15.3092 16.0171 14.676 15.6276 14.2845L9.37879 8.00374L15.6452 1.7053C16.0348 1.31379 16.0331 0.680624 15.6416 0.291096C15.2501 -0.0984328 14.6169 -0.0968205 14.2274 0.294697L7.96816 6.58591L1.70891 0.294696Z" fill="black"/></svg>' +
								'<br>' +
								'</div>' +
								'<tr class="item-description">' +
								'<td class="item-image">' +
								'<div class="fav-p_image">' +
								'<img src="' + parsData.thumbnailUrl + '"/>' +
								'</div>' +
								'</td>';
						}

                        if (parsData.productEAN && $('body').hasClass('LeviIN')) {
                            html = html + '<div class= "name-price-fav-main">'

                                +
                                '<div class="fav-details">' + '<td class="item-color">'

                                +
                                '<div class="fav-p_color-main">' +
                                '<div class="fav-p_color">' +
                                'Color ' +
                                '</div>' +
                                '<div class="fav-colorname-sub">' +
                                parsData.colorName +
                                '</div>' +
                                '</div>' +
                                '</td>'

                                +
                                '<td class="item-size">' +
                                '<div class="fav-p_size-main">' +
                                '<div class="fav-p_size">' +
                                'Size ' +
                                '</div>' +
                                '<div class="fav-size-sub">' +
                                parsData.productCustomWaist +
                                '</div>' +
                                '</div>' +
                                '</td>' +
                                '</div>'

                                +
                                '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                '₹' + parsData.productPrice +
                                '</div>' +
                                '</td>'

                                +
                                '</div>';
                        }

						if (parsData.productEAN && $('body').hasClass('LeviKR')) {
                            html = html + '<div class= "name-price-fav-main">'

                                +
                                '<div class="fav-details">' + '<td class="item-color">'

                                +
                                '<div class="fav-p_color-main">' +
                                '<div class="fav-p_color">' +
                                'Color ' +
                                '</div>' +
                                '<div class="fav-colorname-sub">' +
                                parsData.colorName +
                                '</div>' +
                                '</div>' +
                                '</td>'

                                +
                                '<td class="item-size">' +
                                '<div class="fav-p_size-main">' +
                                '<div class="fav-p_size">' +
                                'Size ' +
                                '</div>' +
                                '<div class="fav-size-sub">' +
                                parsData.productCustomWaist +
                                '</div>' +
                                '</div>' +
                                '</td>' +
                                '</div>'

                                +
                                '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                '₩' + parsData.productPrice +
                                '</div>' +
                                '</td>'

                                +
                                '</div>';
                        }
						
                        if (parsData.productEAN && $('body').hasClass('LeviAU') && locale=='en_AU') {
                            html = html + '<div class= "name-price-fav-main">'

                                +
                                '<div class="fav-details">' + '<td class="item-color">'

                                +
                                '<div class="fav-p_color-main">' +
                                '<div class="fav-p_color">' +
                                'Color ' +
                                '</div>' +
                                '<div class="fav-colorname-sub">' +
                                parsData.colorName +
                                '</div>' +
                                '</div>' +
                                '</td>'

                                +
                                '<td class="item-size">' +
                                '<div class="fav-p_size-main">' +
                                '<div class="fav-p_size">' +
                                'Size ' +
                                '</div>' +
                                '<div class="fav-size-sub">' +
                                parsData.productCustomWaist +
                                '</div>' +
                                '</div>' +
                                '</td>' +
                                '</div>'

                                +
                                '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                '$' + parsData.productPrice +
                                '</div>' +
                                '</td>'

                                +
                                '</div>';
                        }
						if (parsData.productEAN && locale=='en_NZ') {
                            html = html + '<div class= "name-price-fav-main">'

                                +
                                '<div class="fav-details">' + '<td class="item-color">'

                                +
                                '<div class="fav-p_color-main">' +
                                '<div class="fav-p_color">' +
                                'Color ' +
                                '</div>' +
                                '<div class="fav-colorname-sub">' +
                                parsData.colorName +
                                '</div>' +
                                '</div>' +
                                '</td>'

                                +
                                '<td class="item-size">' +
                                '<div class="fav-p_size-main">' +
                                '<div class="fav-p_size">' +
                                'Size ' +
                                '</div>' +
                                '<div class="fav-size-sub">' +
                                parsData.productCustomWaist +
                                '</div>' +
                                '</div>' +
                                '</td>' +
                                '</div>'

                                +
                                '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                'A$' + parsData.productPrice +
                                '</div>' +
                                '</td>'

                                +
                                '</div>';
                        }
                        if (!(parsData.productEAN) && $('body').hasClass('LeviIN')) {
                            html = html + '<div class= "name-price-fav-main">' + '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                '₹' + parsData.productPrice +
                                '</div>' +
                                '</td>' +
                                '</div>';
                        }
                        if (!(parsData.productEAN) && $('body').hasClass('LeviKR')) {
                            html = html + '<div class= "name-price-fav-main">' + '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                '₩' + parsData.productPrice +
                                '</div>' +
                                '</td>' +
                                '</div>';
                        }
						if (!(parsData.productEAN) && $('body').hasClass('LeviAU') && locale=='en_AU') {
                            html = html + '<div class= "name-price-fav-main">' + '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                '$' + parsData.productPrice +
                                '</div>' +
                                '</td>' +
                                '</div>';
                        }
                        if (!(parsData.productEAN) && locale=='en_NZ')  {
                            html = html + '<div class= "name-price-fav-main">' + '<td class="item-name">' +
                                '<div class="fav-p_name">' +
                                parsData.productName +
                                '</div>' +
                                '</td>' +
                                '<td class="item-price">' +
                                '<div class="fav-p_price">' +
                                'A$' + parsData.productPrice +
                                '</div>' +
                                '</td>' +
                                '</div>';
                        }
						if ($('body').hasClass('LeviKR')) {
							html = html + '<td class="fav_link">' +
								'<div class="fav-p_link">' +
								'<a class="wishlist-link fav-button" href="' + parsData.wishlistShow + '" >' +
								'<span class="link-fav">' + '위시리스트 보기 ' + '<span class="fav-qty"></span>' + '</span>' +
								'</a>' +
								'<div>' +
								'</td>' +
								'</tr>' +
								'</div>';
						}
						else {
							html = html + '<td class="fav_link">' +
								'<div class="fav-p_link">' +
								'<a class="wishlist-link fav-button" href="' + parsData.wishlistShow + '" >' +
								'<span class="link-fav">' + 'View Favorites ' + '<span class="fav-qty"></span>' + '</span>' +
								'</a>' +
								'<div>' +
								'</td>' +
								'</tr>' +
								'</div>';
						}
                        $(".wishlist-slide").append(html);
						$(".fav-qty").html('<span class="wishlist-quantity">' + res.wilistCount + '</span>');
                        console.log("Desktop View");
                    // } else {
                    //     // overlay popup will work here
                    //     console.log("Mobile View");
                    //     $(".nav-mobile").css('display', 'none');
                    //     $(".pt_product-details").css('opacity', '0.5');
                    //     $(".added-to-favourite-success").show().delay(1000).fadeOut("slow");
                    //     $(".pt_product-details").delay(1000).animate({
                    //         opacity: 1
                    //     }, 1000);

                    //     // $(".pt_cart").css('opacity','0.5');
                    //     // $(".added-to-cart-success").show().delay(1000).fadeOut("slow");
                    //     // $(".pt_cart").delay(1000).animate({opacity:1},1000);

                    //     $(".pt_cart").css('opacity', '0.5');
                    //     $(".added-to-favourite-success").show().delay(1000).fadeOut("slow");
                    //     $(".pt_cart").delay(1000).animate({
                    //         opacity: 1
                    //     }, 1000);

                    //     $(".menu-toggle, #header-mobile-search-icon").on('click', function() {
                    //         $(".nav-mobile").css('display', 'block');
                    //     });
                    // }
                    $(".wishlist-slide").addClass("added");
                    $(".wishlist-slide").removeClass("removed");

					// Trigger GA4 addtowishlist event for ajax call
					$('body').trigger('analytics:addToWishlistEvent', { targetElement: clickedButton });
                } else if (res.result == 'removed') {
                    clickedButton.data("href", wishlisturl.replace("action=remove", "action=add"));
                    clickedButton.empty();
					$(".user-wishlist-info .user-wishlist").html('<div class="heartfilled"><span class="wishlist-quantity">' + res.wilistCount + '</span></div>');
                    clickedButton.append('<svg class="svg-icon svg-icon--heart wishlist_unfilled_icon" xmlns="http://www.w3.org/2000/svg" role="presentation" aria-labelledby="" aria-hidden="true" title="" fill="black" stroke="black" viewBox="0 0 40 40"><path d="M15.5 12h.4c.8.1 1.6.3 2.1.7.4.2.7.5.9.8l1.5 1.7 1.5-1.7c.4-.4.8-.8 1.3-1 .7-.3 1.4-.5 2.2-.5.9 0 1.7.2 2.4.7.6.4 1.2.9 1.5 1.6.4.6.6 1.4.6 2.1v.4c-.1.9-.4 1.9-.8 2.9-.5 1.1-1.2 2.2-2.2 3.3-1.1 1.2-2.5 2.4-4.2 3.5-.4.3-.9.5-1.3.8-.2.1-.5.3-.7.4-.1 0-.1.1-.2.1-.8-.4-1.6-.9-2.4-1.4-1.6-1.1-3-2.3-4.1-3.5-1-1.1-1.7-2.2-2.1-3.3-.4-1-.7-2-.8-2.9-.1-1.2.3-2.4 1.2-3.3.7-.9 2-1.4 3.2-1.4m0-2c-1.8 0-3.6.8-4.8 2.1-1.2 1.3-1.8 3.1-1.7 4.8.1 1.2.4 2.4.9 3.5.6 1.4 1.5 2.7 2.5 3.8 1.3 1.5 2.8 2.8 4.5 3.9 1 .6 2 1.2 3 1.7.2.1.3.1.5.1h.2c.1 0 .3-.1.4-.2.1-.1.3-.1.4-.2.3-.1.5-.3.8-.4.5-.3 1-.6 1.4-.9 1.7-1.1 3.3-2.4 4.6-3.9 1-1.2 1.9-2.4 2.5-3.8.5-1.1.9-2.3 1-3.6v-.6c0-1.1-.3-2.2-.8-3.1-.5-.9-1.3-1.7-2.2-2.3-1-.7-2.2-1-3.5-1-1.1 0-2.1.3-3.1.7-.7.4-1.3.9-1.9 1.5-.4-.4-.8-.8-1.3-1.1-.9-.6-2-.9-3.1-1h-.3z"></path></svg>');
                    $(".wishlist-page li.coordinate-id-" + res.pid).remove();
                    // if ($(window).width() > 767) {
                        $(".wishlist-slide").empty();
						var removehtml;
						if ($('body').hasClass('LeviKR')) {
                        removehtml = '<div class="miniwishlist-main">' +
							'<div class="Item-removed">' +
							'<svg class="hearticon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4175 2.27576C15.7976 2.94178 15.9983 3.69648 16 4.45926C16 4.60601 15.9918 4.75276 15.9786 4.8995C15.8963 5.77355 15.6462 6.5976 15.2875 7.39908C14.8498 8.37955 14.2277 9.27134 13.5169 10.0809C12.5937 11.1307 11.4879 12.0241 10.3097 12.7853C9.98057 12.9997 9.64323 13.2029 9.29931 13.3964C9.11501 13.4996 8.93071 13.5996 8.74312 13.6964C8.64274 13.748 8.54236 13.7996 8.44363 13.8528C8.35641 13.8996 8.27084 13.9528 8.1754 13.9786C7.98616 14.0286 7.8068 13.9867 7.6373 13.898C6.91491 13.5206 6.20238 13.1304 5.52442 12.6804C4.37089 11.9144 3.28976 11.0243 2.39129 9.97767C1.69358 9.16652 1.08966 8.27796 0.665107 7.29909C0.321187 6.50568 0.0809366 5.68969 0.0134691 4.82855C-0.0836184 3.59005 0.347516 2.36607 1.19827 1.44526C2.12306 0.443816 3.54811 -0.109315 4.92379 0.0180821C5.68897 0.0890377 6.43441 0.322869 7.07288 0.74699C7.41504 0.97557 7.72766 1.24536 7.99833 1.55067C8.36377 1.13471 8.80812 0.782453 9.29931 0.527672C10.7276 -0.212524 12.5131 -0.170595 13.8805 0.688935C14.5124 1.08725 15.0505 1.63232 15.4175 2.27576Z" fill="#000"/></svg>' +
                            '위시리스트에서 삭제되었습니다' +
							'<svg class="closeicon" width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.70891 0.294696C1.31938 -0.0968216 0.686214 -0.0984333 0.294696 0.291095C-0.0968213 0.680623 -0.0984337 1.31379 0.291095 1.7053L6.55754 8.00374L0.308707 14.2845C-0.0808221 14.676 -0.0792097 15.3092 0.312308 15.6987C0.703825 16.0882 1.33699 16.0866 1.72652 15.6951L7.96816 9.42157L14.2098 15.6951C14.5993 16.0866 15.2325 16.0882 15.624 15.6987C16.0155 15.3092 16.0171 14.676 15.6276 14.2845L9.37879 8.00374L15.6452 1.7053C16.0348 1.31379 16.0331 0.680624 15.6416 0.291096C15.2501 -0.0984328 14.6169 -0.0968205 14.2274 0.294697L7.96816 6.58591L1.70891 0.294696Z" fill="black"/></svg>' +
                            '</div>' +
							'</div>';
						} else {							
							removehtml = '<div class="miniwishlist-main">' +
							'<div class="Item-removed">' +
							'<svg class="hearticon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4175 2.27576C15.7976 2.94178 15.9983 3.69648 16 4.45926C16 4.60601 15.9918 4.75276 15.9786 4.8995C15.8963 5.77355 15.6462 6.5976 15.2875 7.39908C14.8498 8.37955 14.2277 9.27134 13.5169 10.0809C12.5937 11.1307 11.4879 12.0241 10.3097 12.7853C9.98057 12.9997 9.64323 13.2029 9.29931 13.3964C9.11501 13.4996 8.93071 13.5996 8.74312 13.6964C8.64274 13.748 8.54236 13.7996 8.44363 13.8528C8.35641 13.8996 8.27084 13.9528 8.1754 13.9786C7.98616 14.0286 7.8068 13.9867 7.6373 13.898C6.91491 13.5206 6.20238 13.1304 5.52442 12.6804C4.37089 11.9144 3.28976 11.0243 2.39129 9.97767C1.69358 9.16652 1.08966 8.27796 0.665107 7.29909C0.321187 6.50568 0.0809366 5.68969 0.0134691 4.82855C-0.0836184 3.59005 0.347516 2.36607 1.19827 1.44526C2.12306 0.443816 3.54811 -0.109315 4.92379 0.0180821C5.68897 0.0890377 6.43441 0.322869 7.07288 0.74699C7.41504 0.97557 7.72766 1.24536 7.99833 1.55067C8.36377 1.13471 8.80812 0.782453 9.29931 0.527672C10.7276 -0.212524 12.5131 -0.170595 13.8805 0.688935C14.5124 1.08725 15.0505 1.63232 15.4175 2.27576Z" fill="#000"/></svg>' +
                            'Item removed from favorites' +
							'<svg class="closeicon" width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.70891 0.294696C1.31938 -0.0968216 0.686214 -0.0984333 0.294696 0.291095C-0.0968213 0.680623 -0.0984337 1.31379 0.291095 1.7053L6.55754 8.00374L0.308707 14.2845C-0.0808221 14.676 -0.0792097 15.3092 0.312308 15.6987C0.703825 16.0882 1.33699 16.0866 1.72652 15.6951L7.96816 9.42157L14.2098 15.6951C14.5993 16.0866 15.2325 16.0882 15.624 15.6987C16.0155 15.3092 16.0171 14.676 15.6276 14.2845L9.37879 8.00374L15.6452 1.7053C16.0348 1.31379 16.0331 0.680624 15.6416 0.291096C15.2501 -0.0984328 14.6169 -0.0968205 14.2274 0.294697L7.96816 6.58591L1.70891 0.294696Z" fill="black"/></svg>' +
                            '</div>' +
							'</div>';
						}
                        $(".wishlist-slide").append(removehtml);
                    // } else {
                    //     // overlay popup will work here
                    //     $(".nav-mobile").css('display', 'none');
                    //     $(".pt_product-details").css('opacity', '0.5');
                    //     $(".removed-from-favourite-success").show().delay(1000).fadeOut("slow");
                    //     $(".pt_product-details").delay(1000).animate({
                    //         opacity: 1
                    //     }, 1000);
                    //     $(".menu-toggle, #header-mobile-search-icon").on('click', function() {
                    //         $(".nav-mobile").css('display', 'block');
                    //     });
                    // }
                    $(".wishlist-slide").addClass("removed");
                    $(".wishlist-slide").removeClass("added");
                    if (res.wilistCount > 0) {
                        $(".user-wishlist-info .user-wishlist").html('<div class="heartfilled"><span class="wishlist-quantity">' + res.wilistCount + '</span></div>');
                    } else {
                        $(".user-wishlist-info .user-wishlist").html('<div class="heartoutlined"></div>');
                    }

                }
                timerwishlist.clear();
                timerwishlist.start(30, $(".wishlist-slide").slideDown());
            }
        });
		
        setTimeout(function() {
            $(".wishlist-slide").slideUp();
        }, 6000);
    }
}

$('.wishlist-slide').on('click', '.closeicon', function(){
	$(".wishlist-slide").slideUp();
});
// Wishlist Code Block


if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') || $('body').hasClass('LeviKR')) { 
	$("body").on('click', ".wishlist-link-pid", function(event){
		event.preventDefault();
		wishlist($(this));
		return false;    
	});

	$(".pt_wish-list .addtobag-maindiv form").on("submit", function(e){
		console.log("clicked");	
		$(this).find("#add-to-cart").attr("disabled", "disabled");
		$(this).find("#add-to-cart").text("Adding...");
	});

	var quickview = require('./quickview');
	var $qvButton = $('.quickview');

	$qvButton.on('click', function (e) {
			e.preventDefault();
			var href = $(this).data('href');
			var PC9_ID = $(this).data('pid');
			// setTimeout(function(){
			// 	$(".quickview-popup").addClass("wishlistPage");
			// }, 2000);			
			// $(".wishlistPage .product-add-to-cart .elements").append('<input type="hidden" name="sourcePage" value="wishlist">');
			console.log(href);
			quickview.show({
				url: href,
				source: 'quickview',
				currentPage: 'wishlistPage'
			});
			setTimeout(function(){
				$(".wishlistPage").attr("data-PC9_ID", PC9_ID);
			},2000);
		});
		$('body').on('mouseenter', '#add-to-cart, #buy-now', function(e){
			e.preventDefault();
			console.log("hello");
			e.stopPropagation();
			if($(".wishlistPage .product-add-to-cart .elements").find('input[name="sourcePage"]').length){}else{
				$(".wishlistPage .product-add-to-cart .elements").append('<input type="hidden" name="sourcePage" value="wishlist">');
				$(".wishlistPage .product-add-to-cart .elements").append('<input type="hidden" name="PC9_ID" value="'+$(".wishlistPage").data("pc9_id")+'">');
			}
		});
}

if($("body").hasClass("LeviIN")) {
	$(document).ready(function(){
		if ($(window).width() > 1023 && !(util.isMobile())) { 
			var inner_menus = $('.for_desktop .level-2 .menu-horizontal .level-3');

			$(inner_menus).each(function(index) {
				if ($(this).find('li').length > 11) {
					$(this).parents().closest('.level-2').addClass('scrolled');
				}
			});

		}
			// <!-- Fix Sidebar Refinement filter on Scroll --> 
		if ($(window).width() > 1023 && $('#plp_product_content').length > 0) {
			var slot_grid_header = $('#main > .slot-grid-header').height();
			var headerHeight = $('.top-banner').height() + $('.header-offers').height();
			var filterBarTop = $('.top-heading-plp').position().top + slot_grid_header + headerHeight;
			var filterBarHeight = $(window).height() - headerHeight - $('.top-heading-plp').height();
			$('.plp-page #plp_product_content #secondary').height(filterBarHeight);
		
			$(window).scroll(fixSidebarOnScroll);
		
			function fixSidebarOnScroll() {
				var windowScrollTop = $(window).scrollTop();
				var productContentHeight = $('#plp_product_content').outerHeight() + slot_grid_header;

				if (windowScrollTop >= productContentHeight) {
						$(".top-heading-plp").removeClass('filter_fixed').hide();
						$(".top-heading-plp").css({"top" : "0"});
				}
				else if (windowScrollTop >= filterBarTop) {
					if (!$('.top-heading-plp').hasClass('filter_fixed')) {
						$(".top-heading-plp").addClass('filter_fixed').show();
						$(".top-heading-plp").css({"top" : "140px"});
					}
				} else if (windowScrollTop <= filterBarTop) {
					$(".top-heading-plp").removeClass('filter_fixed').show();
					$(".top-heading-plp").css({"top" : "0"});
				}
			}
		}

		if ($(window).width() < 767) {
			$('select.sort_box_select').myselectmenu({
				appendTo: "#sort_box_select_id",
				select: function (event, ui) {
					$(this).val(ui.item.value).trigger('change');
				}
			});
			$(window).scroll(function(e) {
				$('select.sort_box_select').myselectmenu({
					appendTo: "#sort_box_select_id",
					select: function (event, ui) {
						$(this).val(ui.item.value).trigger('change');
					}
				});
			});
		}
	});
}

if ($('body').hasClass('LeviAU')) {
	$(document).ready(function(){
		if($(window).width() < 768){
			$(".find-store-accordion.BV i").removeClass("accordianclose24x24");
			$(".find-store-accordion.BV i").addClass("accordianopen24x24");
		}
	});
	}

	setInterval(function(){
		$(".plp-page .bv_text").each(function(){
			var val = $(this).text();
			if(val == "(0)"){
				//console.log(val);
				// $(this).text("");
				$(this).parent().parent().parent().parent().css("display", "none");
			}
		})
		},100);
		
		if ($('body').hasClass('LeviIN')) {
		
			$(".pt_wish-list .addtobag-maindiv form").on("submit", function(e){
				console.log("clicked");	
				$(this).find("#add-to-cart").attr("disabled", "disabled");
				$(this).find("#add-to-cart").text("Adding...");
			});
		
			$(".pt_cart .addtobag form").on("submit", function(e){
				console.log("clicked");	
				$(this).find("#add-to-cart").attr("disabled", "disabled");
				$(this).find("#add-to-cart").text("Adding...");
			});
		
		
			// $("#product-content").on('click', ".wishlist-link-pid", function(event){
			// 	event.preventDefault();
			// 	wishlist($(this));
			// 	return false;    
			// });
		
			$(".shopping-bag").on('click', ".cart-saveforlater", function(event){
				event.preventDefault();
				var pid = $(this).data("pid");
				$(".cart-saveforlater").each(function(){
					if(pid != $(this).data("pid")){
						$(this).addClass("disabled");
					}
				});
				wishlist($(this));
				return false;    
			});
		
			var quickview = require('./quickview');
			var $qvButton = $('.quickview');
		
			$qvButton.on('click', function (e) {
					e.preventDefault();
					var href = $(this).data('href');
					var PC9_ID = $(this).data('pid');
					// setTimeout(function(){
					// 	$(".quickview-popup").addClass("wishlistPage");
					// }, 2000);			
					// $(".wishlistPage .product-add-to-cart .elements").append('<input type="hidden" name="sourcePage" value="wishlist">');
					console.log(href);
					quickview.show({
						url: href,
						source: 'quickview',
						currentPage: 'wishlistPage'
					});
					setTimeout(function(){
						$(".wishlistPage").attr("data-PC9_ID", PC9_ID);
					},2000);
				});
				$('body').on('mouseenter', '#add-to-cart, #buy-now', function(e){
					e.preventDefault();
					console.log("hello");
					e.stopPropagation();
					if($(".wishlistPage .product-add-to-cart .elements").find('input[name="sourcePage"]').length){}else{
						$(".wishlistPage .product-add-to-cart .elements").append('<input type="hidden" name="sourcePage" value="wishlist">');
						$(".wishlistPage .product-add-to-cart .elements").append('<input type="hidden" name="PC9_ID" value="'+$(".wishlistPage").data("pc9_id")+'">');
					}
				});
		}
		
			var addItemToCart = function (form) {
			
				var $form = $(form),
				$qty = $form.find('select[name="Quantity"]');
				if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
					$qty.val('1');
				}
				var sourcePage = $form.find('input[name="sourcePage"]').val();
				console.log(sourcePage);
				if((sourcePage == "wishlist") || (sourcePage == "cartPage")){
					$form.find('button.add-to-cart').attr("disabled");
					$form.find('button.add-to-cart').html("adding...");
					if($(window).width() <= 767){
						$(".nav-mobile").css('display','none');
						
			console.log('cartPage :'+$form.find('button[data-pdp="add-to-cart"]'));
							if(sourcePage == "cartPage"){
							$(".pt_cart").css('opacity','0.5');
							if($form.find('button[data-pdp="add-to-cart"]')){
							$(".added-to-cart-success").show().delay(1000).fadeOut("slow");
							}else {
								$(".added-to-favourite-success").show().delay(1000).fadeOut("slow");
							}
							$(".pt_cart").delay(1000).animate({opacity:1},1000);
							  }
							else if(sourcePage == "wishlist"){
								$(".pt_wish-list").css('opacity','0.5');
						console.log("Korea mobile view checking");
							$(".added-to-favourite-success").show().delay(1000).fadeOut("slow");
							$(".pt_wish-list").delay(1000).animate({opacity:1},1000);
							}
					}
				}
				return Promise.resolve($.ajax({
					type: 'POST',
					url: util.ajaxUrl(Urls.addProduct),
					data: $form.serialize(),
					async: false
				})).then(function (response) {
					// handle error in the response	
					if (response.error) {
						//throw new Error(response.error);
						$form.find('.error-message').html(response.errorMessage);
						if($('body').hasClass('LeviJP')){
							$('.error-message.preorder-msg-error').css('display','block');
						}
						return response;
					} else {
						$form.find('.error-message').html('');
						
						if($('body').hasClass('LeviIN')){
							console.log("checking minicart");
						// setTimeout(function(){
						//     minicart.show(response);
						// },10000);
							var pid = $form.find('input[name="PC9_ID"]').val();
							if(pid != undefined){
								//  var sourcePage = $form.find('input[name="sourcePage"]').val();
								console.log(sourcePage);
								var removeWishlistItemLink = $(".removeWishlistItem").val();
								console.log(pid);
								if (removeWishlistItemLink) {
									$.ajax({
										url: removeWishlistItemLink,
										data: {'pid': pid, 'action': 'remove'},
										async: false,
										success: function(res){
											console.log("Checking redirection");
											if((sourcePage == "wishlist") || (sourcePage == "cartPage")){
												setTimeout(function(){
												$form.find('button.add-to-cart').removeAttr("disabled");
												$form.find('button.add-to-cart').html("ADD TO BAG");
												},1000);
											}
											console.log("cartpage redirect")
											window.location.href = $(".wishlistShowLink").val();
										}
									});
								}
							}
						}
						return response;
					}
				});
			};
			
			/**
			 * @description Handler to handle the add to cart event
			 */
			var addToCart = function (e) {
				e.preventDefault();
				
				if ($(this).data('isdisabled') === 'disabled') {
					if (util.isMobile()) {  
						alert(Resources.SELECT_FOR_STOCK);
						return;
					}
					//alert('hello')
					$(this).tooltip({ items: ".add-to-cart", content: Resources.SELECT_FOR_STOCK});
					$(this).tooltip("open");
					$(this).addClass('tooltip');
			
					return;
				}
				if ($(this).data('isdisabled') === 'OutOfStock') {
					if (util.isMobile()) {  
						alert(Resources.COMBINATION_NOT_AVAILABLE);
						return;
					}
					//alert('hello')
					$(this).tooltip({ items: ".add-to-cart", content: Resources.COMBINATION_NOT_AVAILABLE});
					$(this).tooltip("open");
					$(this).addClass('tooltip');
			
					return;
				}
				
				var $form = $(this).closest('form');
			
				addItemToCart($form).then(function (response) {
					var $uuid = $form.find('input[name="uuid"]');
					if ($uuid.length > 0 && $uuid.val().length > 0 && !response.error) {
						page.refresh();
					} else {
						if (response.error) {
							if(response.errorMessage == "product.maxquantityerror"){
								$(this).tooltip({ items: $(this), content: Resources.MAXQUANTITY});
								$(this).tooltip("open");
								$(this).addClass('tooltip');
							}
							return;
						}
						// do not close quickview if adding individual item that is part of product set
						// @TODO should notify the user some other way that the add action has completed successfully
						if (!$(this).hasClass('sub-product-item')) {
							dialog.close();
						}
						if ($(window).width() <= 767) {
							$(".nav-mobile").css('display','none');
							$(".pt_product-details").css('opacity','0.5');
							$(".added-to-cart-success").show().delay(1000).fadeOut("slow");
							$(".pt_product-details").delay(1000).animate({opacity:1},1000);
							$(".menu-toggle, #header-mobile-search-icon").on('click',function() { 
								$(".nav-mobile").css('display', 'block');
							});
						}
						if (!response.error) {
							minicart.show(response);
						}
					}
				}.bind(this));
			};
		$('.LeviIN .pt_cart .product-detail').on('click', '.add-to-cart', addToCart);

		if ($('body').hasClass('LeviIN')) {
		$(window).load(function(){
			$(".quickview").removeAttr("disabled");
		});
		}
		if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviKR')) {
			$(window).load(function(){
				$(".quickView_Wishlist").removeAttr("disabled");
			});
		}
		if($("body").hasClass("LeviIN")) {
			$(document).ready(function(){
				$("#instorezipcode").keyup(function(e){  
					var str = $(this).val();   
		
					if(str.charAt(0)=='0'|| str.charAt(0)== 0){
						// console.log("less than 6"+$(this).val());
						$(".pincode #instorezipcode-error").remove();
						$(".pincode #instorezipcode").after('<span id="instorezipcode-error" class="error"></span>');
						$("#instorezipcode-error").text("Please enter a valid pincode");
						$("#instorezipcode-error").show();
		
					}
					else if(str.length<6){
						$(".pincode #instorezipcode-error").remove();
						$(".pincode #instorezipcode").after('<span id="instorezipcode-error" class="error"></span>');
						$("#instorezipcode-error").text("Please enter at least 6 characters.");
						$("#instorezipcode-error").show();
					}
					else{
						$("#instorezipcode-error").hide();
					}
					if ($("#instorezipcode-error").is(":visible") == true){
						$(".nostoretoship").hide();
					}
		
		
				});
				$("#instorezipcode").on('keypress',function(e){
					if (e.charCode==46 || e.keyCode==46){
						return false;
					}
				});
				
			});
		}
if($("body").hasClass("LeviIN") && $(".timerPage").length) {
	$(document).ready(function(){
		var i = 0;
		var orderId = $(".orderId").val();
		var orderToken = $(".orderToken").val();	
		$(".upi-id").text($(".vpa").val());
		var paymentErrorUrl = $(".paymentErrorUrl").val();
		var interval = setInterval(function() {		
			var timer2 = $(".countdown").val();
			var timer = timer2.split(':');			
			//by parsing integer, I avoid all extra string processing
			var minutes = parseInt(timer[0],10);
			var seconds = parseInt(timer[1],10);
			--seconds;
			minutes = (seconds < 0) ? --minutes : minutes;
			if (minutes < 0) clearInterval(interval);
			seconds = (seconds < 0) ? 59 : seconds;
			seconds = (seconds < 10) ? '0' + seconds : seconds;		
			$('.countdown-timer').html(minutes + ' min:' + seconds+ ' s');
			$(".countdown").val(minutes + ':' + seconds);
			i++;
			if(minutes == 0 && seconds == "00" || minutes < 0){
				window.location.href = paymentErrorUrl;
			}
			if(i % 2 == 0 && i < minutes*seconds){
				paymentsDetails(orderId, orderToken, minutes, seconds);
			}
		}, 1000);
		function paymentsDetails(orderId, orderToken, minutes, seconds) {
			var confirmationUrl = $(".confirmationUrl").val();
			$.ajax({
				type: 'get',
				url: confirmationUrl,
				data: {'orderId': orderId, 'orderToken': orderToken,'minutes': minutes, 'seconds': seconds},	
				async: false,	 
				success: function success(data) {
					if(data.completeURL != undefined && data.obj == true){
						window.location.href = data.completeURL+"&orderId="+data.orderId+"&orderToken="+data.orderToken;
					}else if(data.completeURL != undefined && data.obj == false){
						window.location.href = data.completeURL;
					}					
				}
			});
		}
	});
}

},{"../../../app_levi_japan/cartridge/js/coordinates":1,"./GA4Events/GA4Events":2,"./ajax":7,"./amazonPay":9,"./captcha":14,"./cookieprivacy":16,"./countries":17,"./dialog":18,"./jquery-ext":21,"./loyaltyPage/common":23,"./loyaltyPage/owlcarouselmin":24,"./minicart":25,"./page":28,"./pages/account":29,"./pages/cart":30,"./pages/checkout":34,"./pages/checkout/shipping":36,"./pages/compare":37,"./pages/orderconfirmation":38,"./pages/product":42,"./pages/registry":48,"./pages/search":49,"./pages/storefront":50,"./pages/storelocator":51,"./pages/wishlist":52,"./pinch-zoom":53,"./progress":55,"./quickview":56,"./rating":57,"./searchplaceholder":58,"./searchsuggest":59,"./searchsuggestmobile":60,"./tls":65,"./tooltip":66,"./util":67,"./validator":68}],13:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
page = require('./page'),
util = require('./util'),
image = require('./pages/product/image');

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
	var bonusproducts = [];

	var i, len;
	for (i = 0, len = selectedList.length; i < len; i++) {
		var p = {
				pid: selectedList[i].pid,
				qty: selectedList[i].qty,
				options: {}
		};
		var a, alen, bp = selectedList[i];
		if (bp.options) {
			for (a = 0, alen = bp.options.length; a < alen; a++) {
				var opt = bp.options[a];
				p.options = {optionName:opt.name, optionValue:opt.value};
			}
		}
		bonusproducts.push({product:p});
	}
	return {bonusproducts: bonusproducts};
}

var selectedItemTemplate = function (data) {
	var attributes = '';
	for (var attrID in data.attributes) {
		var attr = data.attributes[attrID];
		attributes += '<li data-attribute-id="' + attrID + '">\n';
		attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
		attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
		attributes += '</li>';
	}
	attributes += '<li class="item-qty">\n';
	attributes += '<span class="display-name">Qty</span>: ';
	attributes += '<span class="display-value">' + data.qty + '</span>';
	return [
	        '<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">',
	        '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>',
	        '<div class="item-name">' + data.name + '</div>',
	        '<ul class="item-attributes">',
	        attributes,
	        '<ul>',
	        '<li>'
	        ].join('\n');
};

//hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
	$('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
	// prevent unselecting the selected variant
	$('.bonus-product-item .swatches .selected').on('click', function () {
		return false;
	});
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
	var $bonusProductList = $('#bonus-product-list');
	if (!selectedList.length) {
		$bonusProductList.find('li.selected-bonus-item').remove();
	} else {
		var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
		var i, len;
		for (i = 0, len = selectedList.length; i < len; i++) {
			var item = selectedList[i];
			var li = selectedItemTemplate(item);
			$(li).appendTo(ulList);
		}
	}

	// get remaining item count
	var remain = maxItems - selectedList.length;
	$bonusProductList.find('.bonus-items-available').text(remain);
	if (remain <= 0) {
		// $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled'); // original

		// modified
		var sbi = $bonusProductList.find('.select-bonus-item');
		if (sbi.hasClass('bonus-selected')) {
			sbi.find('span').text(Resources.BONUS_PRODUCT_DESELECT)
		}
		else {
			// sbi.attr('disabled', 'disabled');

			sbi.data('isdisabled', 'disabled');
		}

	} else {
		$bonusProductList.find('.select-bonus-item').data('isdisabled', 'enabled');
	}
}

function initializeGrid () {

	// init carousel
	selectedList = [];
	image.initCarousel();

	$('.add-to-cart-bonus').data('isdisabled', 'disabled');

	var $bonusProduct = $('#bonus-product-dialog'),
	$bonusProductList = $('#bonus-product-list'),
	bliData = $bonusProductList.data('line-item-detail');
	maxItems = bliData.maxItems;
	bliUUID = bliData.uuid;

	if (bliData.itemCount >= maxItems) {
		$bonusProductList.find('.select-bonus-item').data('isdisabled', 'disabled');
	}


	var cartItems = $bonusProductList.find('.selected-bonus-item');
	cartItems.each(function () {
		var ci = $(this);
		var product = {
				uuid: ci.data('uuid'),
				pid: ci.data('pid'),
				masterpid: ci.masterpid,
				qty: ci.find('.item-qty').text(),
				name: ci.find('.item-name').html(),
				attributes: {}
		};
		var attributes = ci.find('ul.item-attributes li');
		attributes.each(function () {
			var li = $(this);
			product.attributes[li.data('attributeId')] = {
					displayName:li.children('.display-name').html(),
					displayValue:li.children('.display-value').html()
			};
		});
		selectedList.push(product);


	});

	// added functionality to enable deselect button
	var i;
	for (i=0; i < selectedList.length; i++) {

		var selectedPid = selectedList[i].pid; 
		var bi = $bonusProductList.find('.bonus-product-form [name="pid"]');
		bi.each(function() {
			var bi_pid = $(this).val();
			if (bi_pid == selectedPid) {
				$(this).closest('.bonus-product-form').find('.select-bonus-item')
				.data('isdisabled', 'enabled')
				.removeClass('select-bonus-item').addClass('bonus-selected')
				.find('span').text(Resources.BONUS_PRODUCT_DESELECT);

			}
		});

	}

	$bonusProductList.on('mouseout', '.bonus-product-item a[href].swatchanchor', function (e) {
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});

	$bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
		e.preventDefault();

		// if another product is selected, then the clicking on swatch won't do anything

		var url = this.href,
		$this = $(this);
		var uuid= $("#bonusDiscountLineItemUUID").val();
		url = util.appendParamsToUrl(url, {
			'source': 'bonus',
			'format': 'ajax',
			'bonusDiscountLineItemUUID': uuid
		});
		$.ajax({
			url: url,
			success: function (response) {
				$this.closest('.bonus-product-item').empty().html(response);
				hideSwatches();
				image.initCarousel($this);
			}
		});
	})
	.on('change', '.input-text, select', function () {
		// $bonusProductList.find('.select-bonus-item').removeAttr('disabled');

		$bonusProductList.find('.select-bonus-item').data('isdisabled', 'enabled');

		$(this).closest('.bonus-product-form').find('.quantity-error').text('');
	})
	.on('click', '.select-bonus-item', function (e) {
		e.preventDefault();

		var qty = 0;

		if ($('body').hasClass('LeviKR')) {
			qty = selectedList.length;
		}
		else if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') || $('body').hasClass('LeviJP')) {
			for (i=0; i < selectedList.length; i++) {
				var item = selectedList[i];
				qty = qty + item.qty;
			}
		}

		if ($(this).data('isdisabled') === 'OutOfStock') {
			$(this).tooltip({ items: ".select-bonus-item", content: Resources.COMBINATION_NOT_AVAILABLE});
			$(this).tooltip("open");
			$(this).addClass('tooltip');

			return;
		}
		
		if (qty >= maxItems) {
			$(this).tooltip({ items: ".select-bonus-item", content: Resources.BONUS_PRODUCT_TOOMANY});
			$(this).tooltip("open");
			$(this).addClass('tooltip');

			return;
		}

		if ($(this).data('isdisabled') === 'disabled') {
			$(this).tooltip({ items: ".bonus-product-item a[href].swatchanchor", content: Resources.BONUS_PRODUCT_TOOMANY});
			$(this).tooltip("open");
			$(this).addClass('tooltip');

			return;
		}
		

		if ($('body').hasClass('LeviKR')) {
			$('.availability-novariation').css('color', '#999');
		}

		if ($(this).data('variationgroup') === true || $(this).data('variationgroup') == null ) {
			$(this).closest('form').find('.availability-novariation').css('color', '#c41230');
			return;
		}

		if (selectedList.length >= maxItems) {

			$bonusProductList.find('.select-bonus-item').data('isdisabled', 'disabled');

			// $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
			$bonusProductList.find('.bonus-items-available').text('0');
			return;
		}

		var form = $(this).closest('.bonus-product-form'),
		detail = $(this).closest('.product-detail'),
		uuid = form.find('input[name="productUUID"]').val(),
		qtyVal = form.find('select[name="Quantity"]').val(),
		qty = (isNaN(qtyVal)) ? 1 : (+qtyVal);

		if (qty > maxItems) {

			$bonusProductList.find('.select-bonus-item').data('isdisabled', 'disabled');

			// $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
			form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
			return;
		}

		var product = {
				uuid: uuid,
				pid: form.find('input[name="pid"]').val(),
				qty: qty,
				name: detail.find('.product-name').text(),
				attributes: detail.find('.product-variations').data('attributes'),
				options: []
		};

		var optionSelects = form.find('.product-option');

		optionSelects.each(function () {
			product.options.push({
				name: this.name,
				value: $(this).val(),
				display: $(this).children(':selected').first().html(),
				qty:qty
			});
		});
		selectedList.push(product);
		$(this).removeClass('select-bonus-item').addClass('bonus-selected').find('span').text(Resources.BONUS_PRODUCT_DESELECT);
		if (selectedList.length > 0) {
			$('.add-to-cart-bonus').data('isdisabled', 'enabled');
		}
		updateSummary();

	})
	.on('mouseout', '.select-bonus-item', function(e) {
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	})
	.on('click', '.bonus-selected', function(e) {
		e.preventDefault();
		var container = $(this).closest('.bonus-product-form');
		if (!container.find('[name="productUUID"]')) { return; }

		var uuid = container.find('[name="productUUID"]').val();
		var i, len = selectedList.length;
		for (i = 0; i < len; i++) {
			if (selectedList[i].uuid === uuid) {
				selectedList.splice(i, 1);
				break;
			}
		}
		updateSummary();
		$(this).removeClass('bonus-selected').addClass('select-bonus-item').find('span').text(Resources.BONUS_PRODUCT_SELECT);

		if (selectedList.length <= 0) {
			$('.add-to-cart-bonus').data('isdisabled', 'disabled');
		}

	})
	.on('click', '.remove-link', function (e) {
		e.preventDefault();
		var container = $(this).closest('.selected-bonus-item');
		if (!container.data('uuid')) { return; }

		var uuid = container.data('uuid');
		var i, len = selectedList.length;
		for (i = 0; i < len; i++) {
			if (selectedList[i].uuid === uuid) {
				selectedList.splice(i, 1);
				break;
			}
		}
		updateSummary();
	})
	.on('click', '.add-to-cart-bonus', function (e) {
		e.preventDefault();

		if ($(this).data('isdisabled') == 'disabled') {
			if (util.isMobile()) {
				alert(Resources.SELECT_AT_LEAST_ONE);
				return;
			}    		$(this).tooltip({ items: ".add-to-cart-bonus", content: Resources.SELECT_AT_LEAST_ONE});
			$(this).tooltip("open");
			$(this).addClass('tooltip');

			return;
		}

		var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
		var bonusProducts = getBonusProducts();
		if (!bonusProducts.bonusproducts) {
			alert(Resource.BONUS_PRODUCT_SELECTATLEASTONE);
			return;
		}
		if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
			bonusProducts.bonusproducts[0].product.qty = maxItems;
		}
		// make the server call
		$.ajax({
			type: 'POST',
			dataType: 'json',
			cache: false,
			contentType: 'application/json',
			url: url,
			data: JSON.stringify(bonusProducts)
		})
		.done(function () {
			// success
			setTimeout(function () {
				location.reload();
			}, 500);
		})
		.fail(function (xhr, textStatus) {
			// failed
			if (textStatus === 'parsererror') {
				//window.alert(Resources.BAD_RESPONSE);
				window.alert(Resources.SELECT_VALID_PRODUCT);
				page.refresh();
			} else {
				window.alert(Resources.SERVER_CONNECTION_ERROR);
			}
		})
		.always(function () {
			$bonusProduct.dialog('close');
			dialog.close();
		});
	})
	.on('click', '#more-bonus-products', function (e) {
		e.preventDefault();
		var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

		//get the next page of choice of bonus products
		var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
		lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
		$('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

		var url = util.appendParamsToUrl(Urls.getBonusProducts, {
			bonusDiscountLineItemUUID: uuid,
			format: 'ajax',
			lazyLoad: 'true',
			pageStart: lineItemDetail.pageStart,
			pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
			bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
		});

		$.ajax({
			type: 'GET',
			cache: false,
			contentType: 'application/json',
			url: url
		})
		.done(function (data) {
			//add the new page to DOM and remove 'More' link if it is the last page of results
			$('#more-bonus-products').before(data);
			if ((lineItemDetail.pageStart + lineItemDetail.pageSize) >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
				$('#more-bonus-products').remove();
			}
		})
		.fail(function (xhr, textStatus) {
			if (textStatus === 'parsererror') {
				window.alert(Resources.BAD_RESPONSE);
			} else {
				window.alert(Resources.SERVER_CONNECTION_ERROR);
			}
		});
	})
	.on('click', '.no-thanks', function(e) {
		var len = selectedList.length;
		selectedList.splice(0, len);
		updateSummary();
		$bonusProduct.dialog('close');
	})
	.on().on('mouseout', '.add-to-cart-bonus', function (e) {
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});
}

var bonusProductsView = {
		/**
		 * @function
		 * @description Open the list of bonus products selection dialog
		 */
		show: function (url) {
			var $bonusProduct = $('#bonus-product-dialog');
			// create the dialog
			dialog.open({
				target: $bonusProduct,
				url: url,
				options: {
					width: 1080,
					dialogClass: "bonus-product-popup-window"
				},
				callback: function () {
					initializeGrid();
					hideSwatches();
				}
			});
		},
		/**
		 * @function
		 * @description Open bonus product promo prompt dialog
		 */
		loadBonusOption: function () {

			// Korea functionality
			if ($('body').hasClass('LeviKR')) {
				var    self = this,
				bonusDiscountContainer = document.querySelector('.bonus-discount-container');
				if (!bonusDiscountContainer) { return; }

				// get the html from minicart, then trash it
				var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
				bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

				dialog.open({
					html: bonusDiscountContainerHtml,
					options: {
						width: 400,
						title: Resources.SELECT_BONUS_PRODUCTS_DIALOG,
						dialogClass:"bonus-discount-container",
						buttons: [{
							text: Resources.SELECT_BONUS_PRODUCTS,
							click: function () {
								var uuid = $('.bonus-product-promo').data('lineitemid'),
								url = util.appendParamsToUrl(Urls.getBonusProducts, {
									bonusDiscountLineItemUUID: uuid,
									source: 'bonus',
									format: 'ajax',
									lazyLoad: 'false',
									pageStart: 0,
									pageSize: 10,
									bonusProductsTotal: -1
								});
								$(this).dialog('close');
								self.show(url);
							}
						}, {
							text: Resources.NO_THANKS,
							click: function () {
								$(this).dialog('close');
							}
						}]
					},
					callback: function () {
						// show hide promo details
						$('.show-promo-details').on('click', function () {
							$('.promo-details').toggleClass('visible');
						});


					}
				});

			}

			// Australia functionality
			else if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') || $('body').hasClass('LeviJP')) {
				var    self = this,
				bonusDiscountContainer = document.querySelector('.bonus-discount-container');
				if (!bonusDiscountContainer) {
					return; }
				var $bonusProduct = $('#bonus-product-dialog');
				// get the html from minicart, then trash it
				var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
				var uuid = $('.bonus-product-promo').data('lineitemid');
				bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);
				var url = util.appendParamsToUrl(Urls.getBonusProducts, {
					bonusDiscountLineItemUUID: uuid,
					source: 'bonus',
					format: 'ajax',
					lazyLoad: 'false',
					pageStart: 0,
					pageSize: 10,
					bonusProductsTotal: -1
				});
				dialog.open({
					url: url,
					options: {
						width: 1080,
						dialogClass: "bonus-product-popup-window",
						title: Resources.BONUS_PRODUCTS,
						open: function () {
							$('#wrapper').css('position','fixed');
						}
					},
					callback: function () {
						// show hide promo details
						initializeGrid();
						hideSwatches();
					}
				});
			}

		}
};

module.exports = bonusProductsView;

},{"./dialog":18,"./page":28,"./pages/product/image":41,"./util":67}],14:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');
var util = require('./util');
var SessionAttributes = window.SessionAttributes;

/**
 * @function captcha    Used to display/control the scrim containing the simulated captcha code
 **/
module.exports = function () {
    /**
     * if the session.privacy.ratelimited element is present then show the notification
     * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
     */
    if (SessionAttributes.SHOW_CAPTCHA) {
        dialog.open({
            html: '<h1>' + Resources.ARE_YOU_HUMAN + '</h1>',
            options: {
                closeOnEscape: false,
                dialogClass: 'no-close',
                buttons: [{
                    text: Resources.OK,
                    click: function () {
                        var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
                        $.ajax({
                            url: url
                        });
                        $(this).dialog('close');
                    }
                }]
            }
        });
    }
};

},{"./dialog":18,"./util":67}],15:[function(require,module,exports){
'use strict';

var page = require('./page'),
    util = require('./util'),
    TPromise = require('promise');

var _currentCategory = '',
    MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
    var $compareContainer = $('.compare-items');
    var $compareItems = $compareContainer.find('.compare-item');
    var numActive = $compareItems.filter('.active').length;

    if (numActive < 2) {
        $('#compare-items-button').attr('disabled', 'disabled');
    } else {
        $('#compare-items-button').removeAttr('disabled');
    }

    $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
    // get the first compare-item not currently active
    var $item = $('.compare-items .compare-item').not('.active').first(),
        $productTile = $('#' + data.uuid);

    if ($item.length === 0) {
        if ($productTile.length > 0) {
            $productTile.find('.compare-check')[0].checked = false;
        }
        window.alert(Resources.COMPARE_ADD_FAIL);
        return;
    }

    // if already added somehow, return
    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
        return;
    }
    // set as active item
    $item.addClass('active')
        .attr('data-uuid', data.uuid)
        .attr('data-itemid', data.itemid)
        .data('uuid', data.uuid)
        .data('itemid', data.itemid)
        .append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
    if ($item.length === 0) { return; }
    // remove class, data and id from item
    $item.removeClass('active')
        .removeAttr('data-uuid')
        .removeAttr('data-itemid')
        .data('uuid', '')
        .data('itemid', '')
        // remove the image
        .find('.compare-item-image').remove();
}

function addProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareAdd,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_ADD_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function removeProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareRemove,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function shiftImages() {
    return new TPromise(function (resolve) {
        var $items = $('.compare-items .compare-item');
        $items.each(function (i, item) {
            var $item = $(item);
            // last item
            if (i === $items.length - 1) {
                return removeFromList($item);
            }
            var $next = $items.eq(i + 1);
            if ($next.hasClass('active')) {
                // remove its own image
                $next.find('.compare-item-image').detach().appendTo($item);
                $item.addClass('active')
                    .attr('data-uuid', $next.data('uuid'))
                    .attr('data-itemid', $next.data('itemid'))
                    .data('uuid', $next.data('uuid'))
                    .data('itemid', $next.data('itemid'));
            }
        });
        resolve();
    });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
    var promise;
    var $items = $('.compare-items .compare-item');
    var $cb = $(args.cb);
    var numActive = $items.filter('.active').length;
    if (numActive === MAX_ACTIVE) {
        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
            $cb[0].checked = false;
            return;
        }

        // remove product using id
        var $firstItem = $items.first();
        promise = removeItem($firstItem).then(function () {
            return shiftImages();
        });
    } else {
        promise = TPromise.resolve(0);
    }
    return promise.then(function () {
        return addProductAjax(args).then(function () {
            addToList(args);
            if ($cb && $cb.length > 0) { $cb[0].checked = true; }
            refreshContainer();
        });
    }).then(null, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
    var $cb = args.cb ? $(args.cb) : null;
    return removeProductAjax(args).then(function () {
        var $item = $('[data-uuid="' + args.uuid + '"]');
        removeFromList($item);
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
        refreshContainer();
    }, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = true; }
    });
}

function removeItem($item) {
    var uuid = $item.data('uuid'),
        $productTile = $('#' + uuid);
    return removeProduct({
        itemid: $item.data('itemid'),
        uuid: uuid,
        cb: ($productTile.length === 0) ? null : $productTile.find('.compare-check')
    });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
    var $compareContainer = $('.compare-items');
    _currentCategory = $compareContainer.data('category') || '';
    var $active = $compareContainer.find('.compare-item').filter('.active');
    $active.each(function () {
        var $productTile = $('#' +  $(this).data('uuid'));
        if ($productTile.length === 0) {return;}
        $productTile.find('.compare-check')[0].checked = true;
    });
    // set container state
    refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
    // add event to buttons to remove products
    $('.compare-item').on('click', '.compare-item-remove', function () {
        removeItem($(this).closest('.compare-item'));
    });

    // Button to go to compare page
    $('#compare-items-button').on('click', function () {
        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
    });

    // Button to clear all compared items
    // rely on refreshContainer to take care of hiding the container
    $('#clear-compared-items').on('click', function () {
        $('.compare-items .active').each(function () {
            removeItem($(this));
        });
    });
}

exports.init = function () {
    initializeDom();
    initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":28,"./util":67,"promise":74}],16:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function () {
    /**
     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
     */
    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            dialog.open({
                url: Urls.cookieHint,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'no-close',
                    buttons: [{
                        text: Resources.I_AGREE,
                        click: function () {
                            $(this).dialog('close');
                            enableCookies();
                        }
                    }]
                }
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enableCookies();
    }

    function enableCookies() {
        if (document.cookie.indexOf('dw=1') < 0) {
            document.cookie = 'dw=1; path=/';
        }
        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
            document.cookie = 'dw_cookies_accepted=1; path=/';
        }
    }
};

},{"./dialog":18}],17:[function(require,module,exports){
'use strict';

exports.init = function init () {
    $('.country-selector .current-country').on('click', function () {
        $('.country-selector .selector').toggleClass('active');
        $(this).toggleClass('selector-active');
    });
    // set currency first before reload
    $('.country-selector .selector .locale').on('click', function (e) {
        e.preventDefault();
        var url = this.href;
        var currency = this.getAttribute('data-currency');
        $.ajax({
            dataType: 'json',
            url: Urls.setSessionCurrency,
            data: {
                format: 'ajax',
                currencyMnemonic: currency
            }
        })
        .done(function (response) {
            if (!response.success) {
                throw new Error('Unable to set currency');
            }
            window.location.href = url;
        });
    });
};

},{}],18:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        var $target, id;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
        
        // prevents zooming when on PDP
        $('.ui-dialog').css('z-index', '1112');
        $('.ui-widget-overlay').css('z-index', '1111');
       
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        // close any open dialog
        if(util.isMobile() && !$('body').hasClass('LeviKR')){
            $('#wrapper').css('position','fixed');
        }
        this.close();
        this.create(params);
        this.replace(params);
        if(util.isMobile() && $('body').hasClass('LeviKR')){
            if($(".plp-promo-category").length >0) {
                $('#wrapper').css('position','relative');
            }else{
              $('#wrapper').css('position','fixed');
          }
        }
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '800',
        close: function () {
            $(this).dialog('close');
            if(util.isMobile()) {
        		$('#wrapper').css('position','relative');
        	}
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;

},{"./ajax":7,"./util":67,"imagesloaded":72,"lodash":73}],19:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');
/**
 * @function
 * @description Load details to a given gift certificate
 * @param {String} id The ID of the gift certificate
 * @param {Function} callback A function to called
 */
exports.checkBalance = function (id, callback) {
    // load gift certificate details
    var url = util.appendParamToURL(Urls.giftCardCheckBalance, 'giftCertificateID', id);

    ajax.getJson({
        url: url,
        callback: callback
    });
};

},{"./ajax":7,"./util":67}],20:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util');

var setAddToCartHandler = function (e) {
    e.preventDefault();
    var form = $(this).closest('form');

    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };
    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {lineItemId: response.result.lineItemId},
                callback: function (response) {
                    minicart.show(response);
                    form.find('input,textarea').val('');
                }
            });
        } else {
            form.find('span.error').hide();
            for (var id in response.errors.FormErrors) {
                var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
                if (!$errorEl || $errorEl.length === 0) {
                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
                    $('#' + id).after($errorEl);
                }
                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
            }
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        } else {
            window.alert(Resources.SERVER_CONNECTION_ERROR);
        }
    });
};

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);
};

},{"./ajax":7,"./minicart":25,"./util":67}],21:[function(require,module,exports){
'use strict';
// jQuery extensions

module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) { return this; }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {options.callback();}
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };
};

},{}],22:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    validator = require('./validator');
var util = require('./util');

var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        //o-auth binding for which icon is clicked
        $('.oAuthIcon').bind('click', function () {
            $('#OAuthProvider').val(this.id);
        });
        var a = "helloooooo";
        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }  
        });
        if ($('body').hasClass('LeviIN')) {
        $('.primary-content').on('keypress focusout', '.col-1 .email', function(e) {
        	if ($(this).closest('.form-row').find('.form-caption').hasClass('error-message')) {
        		$(".form-caption").removeClass('error-message').text('');
        		$(".form-row").removeClass('error');
        	}
        });
       }
        $('.primary-content').on('keypress focusout', '.col-2 .email', function(e) {
        	if ($(this).closest('.form-row').find('.form-caption').hasClass('error-message')) {
        		$(".form-caption").removeClass('error-message').text('');
        		$(".form-row").removeClass('error');
        	}
        });
        
        //code for migrated customer
        
        
        $('[id$="_login"]').on('submit', function(e) {
        	var data = $(this).serialize() + "&format=ajax";
        	var Url = Urls.checkMigratedCustomer;
        	$.ajax({
        		url: Url,
        		method: 'POST',
        		data: data,
        		dataType: 'json',
        		async: false,
        		success: function(response) {
        			if (typeof response === 'object') {
	        			if (response.message == "migrated") {	
	        				e.preventDefault();		        		
		        			$('#password-reset').trigger('click');			        			
		        			return;
	        			}
	        			else if (response.message == "nonmigrated") {
	        				$('[id$="_login"]').unbind('submit');
		        			$(this).off('submit');
	        			}
        			}
        		}
        	});
        	
        });
        
        
        
        //                                  
        
        $('#password-reset').on('click', function (e) {            	
            e.preventDefault();
            
            dialog.open({
            	url: $(e.target).attr('href'),
            	options: {}
            });
            dialog.close();
            
            dialog.open({
                url: $(e.target).attr('href'),
                options: {
                	dialogClass:"reset-password",
                    open: function () {
                    	if(util.isMobile()) {
                    		$('#wrapper').css('position','fixed');
                    	}
                        $('.reset-password').on('click', '.reset-password-button', function(e) {
                        	e.preventDefault();
                        	dialog.close();
                        	if(util.isMobile()) {
                        		$('#wrapper').css('position','relative');
                        	}
                        });
                        $('.reset-password').on('click', '.reset-password-button-confirm', function(e) {
                        	e.preventDefault();
                        	dialog.close();
                        	if(util.isMobile()) {
                        		$('#wrapper').css('position','relative');
                        	}
                        });
                        validator.init();                        
                        
                        $('#dialog-container').on('keypress focusout', '#PasswordResetForm .email', function(e) {
                        	if ($(this).closest('.field-wrapper').find('.errspan').hasClass('error')) {
                        		$(".errspan").removeClass('error').text('');
                        		$(".form-row").removeClass('error');
                        	}
                        }); 
                        
                        var $requestPasswordForm = $('[name$="_requestpassword"]');
                        var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
                        $($submit).on('click', function (e) {
                            if (!$requestPasswordForm.valid()) {
                                return;
                            }
                            e.preventDefault();
                            var data = $requestPasswordForm.serialize();
                            // add form action to data
                            data += '&' + $submit.attr('name') + '=';
                            // make sure the server knows this is an ajax request
                            if (data.indexOf('ajax') === -1) {
                                data += '&format=ajax';
                            }
                            $.ajax({
                                type: 'POST',
                                url: $requestPasswordForm.attr('action'),
                                data: data,
                                success: function (response) {
                                    if (typeof response === 'object' &&
                                            !response.success &&
                                            response.error === 'CSRF Token Mismatch') {
                                        page.redirect(Urls.csrffailed);
                                    } else if (typeof response === 'string') {
                                                                              
                                        if (response == 'email error') {
                                			var errSpan = document.createElement('span');
                                			errSpan.innerHTML = Resources.NOT_REGISTERED_EMAIL;
                                			errSpan.className += "errspan error";
                                			$submit.closest('fieldset').find('.field-wrapper').append(errSpan);
                            	    		return;
                                		}
                                		else {
                                			$(this).closest('.field-wrapper').find('.errSpan').remove();
                                			dialog.$container.html(response);	
                                			
                                		}
                                    }
                                },
                                failure: function () {
                                    dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                                }
                            });
                        });
                    }
                }
            });
            
        });   
       
        
    }

}

module.exports = login;


},{"./dialog":18,"./page":28,"./util":67,"./validator":68}],23:[function(require,module,exports){
'use strict';

$('.offer-info-slide .owl-carousel').owlCarousel({
  loop:true,
  autoplay: true,
  nav: true,
  dots: false,
  autoplayTimeout: 3000,
  margin:20,
  items: 1,
})

$('.slider-footer .owl-carousel').owlCarousel({
  loop: false,
  margin: 50,
  nav: true,
  dots: false,
  responsive: {
      0: {
          items: 1
      },
      600: {
          items: 2
      },
      1000: {
          items: 3
      }
  }
})

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 150) {
      $(".header").addClass("sticky");
  } else {
      $(".header").removeClass("sticky");
  }
});

$( ".navbar-toggler" ).click(function() {
  $( ".main" ).toggleClass("menu-open");
});

$( ".exit-off-canvas" ).click(function() {
  $( ".main" ).toggleClass("menu-open");
});

$(document).ready(function(){ 
  $(".footer-acc-container .footer-acc-block .footer-acc-list").click(function(){ 
    if ($(window).width() < 1200) { 
      $(this).find(".acc-title").toggleClass("open");
      $(this).find(".list-block").slideToggle(); 
    } 
  });


  $('ul.comn-tabs li').click(function(){
var tab_id = $(this).attr('data-tab');

  $('ul.comn-tabs li').removeClass('comn-tab-current');
  $('.comn-tab-content').removeClass('comn-tab-current');

  $(this).addClass('comn-tab-current');
  $("#"+tab_id).addClass('comn-tab-current');
})
});

// $(document).on('click', '.left-panel ul li', function(){
//   $('.left-panel ul li').removeClass('active');
//   $('.left-panel ul').toggleClass('expanded');
//   $(this).addClass('active');
//   var tab_id = $(this).attr('data-tab');
//   $('.tab-content').removeClass('current');
//   $(this).addClass('current');
//   $('#'+tab_id).addClass('current');
// });

$("#RedTabBenefitsPage").hide();

// $("#referAFrienddiv").hide();

$("#successMsgModal").hide();

$(".loader-img-col").hide();

$(document).ready(function(){
  $(".loader-img-col").hide();
  $("#successMsgModal").hide();
    
  $("#redTabLoginForm").submit(function(e){

    e.preventDefault();

    $(".loader-img-col").show();

    var formdata = $("#redTabLoginForm");

    var formUrl = formdata.attr("action");

    var currentUrl = window.location.href;
    
    var url = new URL(currentUrl);
    
    url.searchParams.set("loyalty_member", "no"); // setting your param

    var newUrl = url.href; 

    $.ajax({

        url: formUrl,
    
        type: "POST",
    
        data: formdata.serialize(),
    
        success: function(response){

          console.log(response);

          $(".loader-img-col").hide();

          if(response.status === 1)
          {
            if(response.isMinimumLoyaltyAge == false && response.isLoyaltyMember == false && response.isDobNull == true)
            {
              //window.location.reload();
              window.location.href = newUrl;
            }

            else if(response.isMinimumLoyaltyAge == false && response.isLoyaltyMember == false && response.isDobNull == false)
            {
              window.location.reload();
              //window.location.href = newUrl;
            }

            else if(response.isMinimumLoyaltyAge == true && response.isLoyaltyMember == false && response.isDobNull == false)
            {
              //window.location.reload();
              window.location.href = newUrl;
            }

            else if(response.isMinimumLoyaltyAge == true && response.isLoyaltyMember == true && response.isDobNull == false)
            {
              window.location.reload();
              //window.location.href = newUrl;
            }

            else
            {
              window.location.reload();
            }

            //document.getElementById("redTabLoginForm").reset();
            
            // $("#successMsgModal").show();

            // $(".success-msg-div").text("Success");

          }
          else if(response.status === 0)
          {
            $("#error-msg").text(response.message);
          }
          
        },
        error: function(response)
        {

          $(".loader-img-col").hide();

        }
     });
  });

  $("#redTabRegistrationForm").submit(function(e){

    e.preventDefault();

    var formdata = $("#redTabRegistrationForm");

    var formUrl = formdata.attr("action");

    

    $.ajax({

        url: formUrl,
    
        type: "POST",
    
        data: formdata.serialize(),
    
        success: function(response){

          if (response.status === 1) {

            window.location.reload();

          } 
          else if(response.status === 2) {

          $('#signupModal').find('.popup-form').html(response.errorMessage);


           
          }
        },
        error: function(response){

          console.log("Error 123");

          console.log(response);
        }
  
     });

  });

  // $("#benefitsPage").click(function(){
  //   $("#RedTabBenefitsPage").show();
  // });

  $(".popup_close").click(function(){
		$('.global_close_popup').modal('hide');
	});

  $("#referAFriendEmailModalBtn").click(function(){
    $("#referAFriendEmailModal").modal('show');
  });

  $("#referAFriendPhoneModalBtn").click(function(){
    $("#referAFriendPhoneModal").modal('show');
  });

  $("#referAFriendEmailForm").submit(function(e){

    e.preventDefault();

    $(".loader-img-col").show();

    var formdata = $("#referAFriendEmailForm");

    var formUrl = formdata.attr("action");

    var email = $("#emailModal").val();

    var name = $("#nameModal").val();

    //var phone = $("#phoneModal").val();
    if(email && name)
    {
      $.ajax({

        url: formUrl,
    
        type: "POST",
  
        data: {
          email: email,
          name: name
        },
        
        success: function(data){
          $(".loader-img-col").hide();
          
          $("#referAFriendEmailModal").modal('hide');

          document.getElementById("referAFriendEmailForm").reset();

          $("#successMsgModal").modal("show");

					$(".success-msg-div").text(data.success);

					setTimeout(function() 
					{
						$("#successMsgModal").modal("hide");
            $(".loader-img-col").hide();

					}, 3000);
          //window.location.reload();
        },
        error: function(data){
          $(".loader-img-col").hide();
          
         // window.location.reload();
  
          $("#referAFriendEmailModal").modal('hide');
  
        }
  
      });
    }
    else if(email == "" || email == null)
    {
      $(".loader-img-col").hide();
      $("#nameField").text("유효한 이름을 입력하십시오");
      $("#emailField").text("유효한 이메일을 입력하세요");
      $("#referAFriendEmailModal").modal('show');
    }
  });

  $("#referAFriendPhoneForm").submit(function(e){

    e.preventDefault();

    $(".loader-img-col").show();
    
    var formdata = $("#referAFriendPhoneForm");

    var formUrl = formdata.attr("action");

    var phone = $("#phoneModal").val();

    if ($.isNumeric(phone)) 
    {
      $.ajax({

        url: formUrl,
    
        type: "POST",
  
        data: {
         phone: phone
          
        },
        
        success: function(data){
          
          $(".loader-img-col").hide();
          $("#referAFriendPhoneModal").modal('hide');
          document.getElementById("referAFriendPhoneForm").reset();
          $("#successMsgModal").modal("show");

					$(".success-msg-div").text(data.success);

					setTimeout(function() 
					{
						$("#successMsgModal").modal("hide");

					}, 3000);
        },
        error: function(data){
          $(".loader-img-col").hide();
          console.log(data);
          console.log("Error 123");
          // window.location.reload();
          $("#referAFriendPhoneModal").modal('hide');
        }
  
      });
    }
    else
    {
      $(".loader-img-col").hide();
      $("#phoneField").text("Please enter phone");
      $("#referAFriendPhoneModal").modal('show');
    }
  });

  $(".redTabLoginModalBtn").click(function(){
    $("#redTabloginModal").modal('show');
  });

  $(".redTabRegistrationModalBtn").on("click", function(){
    
    $("#exampleModal").modal('show');
    
  });

  $(".orderDetailsBtn").click(function(){
    var receiptnumber  = $(this).attr('data-receiptnumber');
    $('#orderDetailsModal-' + receiptnumber).modal('show');
  });

 

});





// $(document).ready(function() {
//   new QRCode(document.getElementById("qrcode"), "ABC123Abc");
// });
},{}],24:[function(require,module,exports){
/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,checkVisibility:!0,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",slideTransition:"",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g>0;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i,g-=1;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.$stage.children(".center").removeClass("center"),this.settings.center&&this.$stage.children().eq(this.current()).addClass("center")}}],e.prototype.initializeStage=function(){this.$stage=this.$element.find("."+this.settings.stageClass),this.$stage.length||(this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+">",{class:this.settings.stageClass}).wrap(a("<div/>",{class:this.settings.stageOuterClass})),this.$element.append(this.$stage.parent()))},e.prototype.initializeItems=function(){var b=this.$element.find(".owl-item");if(b.length)return this._items=b.get().map(function(b){return a(b)}),this._mergers=this._items.map(function(){return 1}),void this.refresh();this.replace(this.$element.children().not(this.$stage.parent())),this.isVisible()?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)},e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var a,b,c;a=this.$element.find("img"),b=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,c=this.$element.children(b).width(),a.length&&c<=0&&this.preloadAutoWidthImages(a)}this.initializeStage(),this.initializeItems(),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.isVisible=function(){return!this.settings.checkVisibility||this.$element.is(":visible")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.isVisible()&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),!1!==this.settings.responsive&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var e=-1,f=30,g=this.width(),h=this.coordinates();return this.settings.freeDrag||a.each(h,a.proxy(function(a,i){return"left"===c&&b>i-f&&b<i+f?e=a:"right"===c&&b>i-g-f&&b<i-g+f?e=a+1:this.op(b,"<",i)&&this.op(b,">",h[a+1]!==d?h[a+1]:i-g)&&(e="left"===c?a+1:a),-1===e},this)),this.settings.loop||(this.op(b,">",h[this.minimum()])?e=b=this.minimum():this.op(b,"<",h[this.maximum()])&&(e=b=this.maximum())),e},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"+(this.settings.slideTransition?" "+this.settings.slideTransition:"")}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){(a=this.normalize(a))!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){if(b=this._items.length)for(c=this._items[--b].width(),d=this.$element.width();b--&&!((c+=this._items[b].width()+this.settings.margin)>d););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2==0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=-1*f*g),a=c+e,(d=((a-h)%g+g)%g+h)!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.isVisible()&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){(a=this.normalize(a,!0))!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),!1!==this.settings.responsive&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.remove(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&-1!==a.namespace.indexOf("owl")?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.isVisible(),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.isVisible()!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type)){var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&-1*e||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);for(c.lazyLoadEager>0&&(e+=c.lazyLoadEager,c.loop&&(g-=c.lazyLoadEager,e++));f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1,lazyLoadEager:0},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src")||f.attr("data-srcset");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):f.is("source")?f.one("load.owl.lazy",a.proxy(function(){this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("srcset",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(c){this._core=c,this._previousHeight=null,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"===a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._intervalId=null;var d=this;a(b).on("load",function(){d._core.settings.autoHeight&&d.update()}),a(b).resize(function(){d._core.settings.autoHeight&&(null!=d._intervalId&&clearTimeout(d._intervalId),d._intervalId=setTimeout(function(){d.update()},250))})};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.settings.lazyLoad,e=this._core.$stage.children().toArray().slice(b,c),f=[],g=0;a.each(e,function(b,c){f.push(a(c).height())}),g=Math.max.apply(null,f),g<=1&&d&&this._previousHeight&&(g=this._previousHeight),this._previousHeight=g,this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?"width:"+c.width+"px;height:"+c.height+"px;":"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(c){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?a("<div/>",{class:"owl-video-tn "+j,srcType:c}):a("<div/>",{class:"owl-video-tn",style:"opacity:1;background-image:url("+c+")"}),b.after(d),b.after(e)};if(b.wrap(a("<div/>",{class:"owl-video-wrapper",style:g})),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),c=a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'),c.attr("height",h),c.attr("width",g),"youtube"===f.type?c.attr("src","//www.youtube.com/embed/"+f.id+"?autoplay=1&rel=0&v="+f.id):"vimeo"===f.type?c.attr("src","//player.vimeo.com/video/"+f.id+"?autoplay=1"):"vzaar"===f.type&&c.attr("src","//view.vzaar.com/"+f.id+"/player?autoplay=true"),a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,
animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._call=null,this._time=0,this._timeout=0,this._paused=!0,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._paused&&(this._time=0)},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype._next=function(d){this._call=b.setTimeout(a.proxy(this._next,this,d),this._timeout*(Math.round(this.read()/this._timeout)+1)-this.read()),this._core.is("interacting")||c.hidden||this._core.next(d||this._core.settings.autoplaySpeed)},e.prototype.read=function(){return(new Date).getTime()-this._time},e.prototype.play=function(c,d){var e;this._core.is("rotating")||this._core.enter("rotating"),c=c||this._core.settings.autoplayTimeout,e=Math.min(this._time%(this._timeout||c),c),this._paused?(this._time=this.read(),this._paused=!1):b.clearTimeout(this._call),this._time+=this.read()%c-e,this._timeout=c,this._call=b.setTimeout(a.proxy(this._next,this,d),c-e)},e.prototype.stop=function(){this._core.is("rotating")&&(this._time=0,this._paused=!0,b.clearTimeout(this._call),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&!this._paused&&(this._time=this.read(),this._paused=!0,b.clearTimeout(this._call))},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:['<span aria-label="Previous">&#x2039;</span>','<span aria-label="Next">&#x203a;</span>'],navSpeed:!1,navElement:'button type="button" role="presentation"',navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","button",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d,e;e=this._core.settings;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)"$relative"===b&&e.navContainer?this._controls[b].html(""):this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);
},{}],25:[function(require,module,exports){
'use strict';
var util = require('./util'),
bonusProductsView = require('./bonus-products-view'),
tooltip = require('./tooltip');
var timer = {
		id: null,
		clear: function () {
			if (this.id) {
				window.clearTimeout(this.id);
				delete this.id;
			}
		},
		start: function (duration, callback) {
			this.id = setTimeout(callback, duration);
		}
};

var minicart = {
		init: function () {
			this.$el = $('#mini-cart');
			this.$content = this.$el.find('.mini-cart-content');

			$('.mini-cart-product').eq(0).find('.mini-cart-toggle').addClass('fa-caret-down');
			$('.mini-cart-product').not(':first').addClass('collapsed')
			.find('.mini-cart-toggle').addClass('fa-caret-right');

			$('.mini-cart-toggle').on('click', function () {
				$(this).toggleClass('fa-caret-down fa-caret-right');
				$(this).closest('.mini-cart-product').toggleClass('collapsed');
			});
			
			if ($('body').hasClass('LeviJP')) {
				$('.mini-cart-buttons').on('click', '#checkout', miniCartProceedToCheckout);
				$('.mini-cart-link-checkout').on('click', function () {
					 localStorage.setItem("fromBilling","false");
				}); 
			}
			if ($('body').hasClass('LeviIN')){
				if(this.$content.length==0){
			localStorage.setItem("cartType",'false');
			localStorage.setItem("BonusEligible",'true');
			}
		}
			// events
			this.$el.find('.mini-cart-total').on('mouseenter', function () {
				$(this).data('event', 'event-data-cart');
				$(this).data('hover', 'Minicart-page');
				$(this).data('event', 'event-data-navigation');
				$(this).data('header-nav', 'Cart');
				if (this.$content.not(':visible')) {
					if ($(".LeviAU #mini-cart").find(".mini-cart-content").length == 0){ 
						$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #fff");
					}
					if ($(".LeviIN #mini-cart").find(".mini-cart-content").length == 0){ 
						$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #fff");
						localStorage.setItem("cartType",'false');
						localStorage.setItem("BonusEligible",'true');
					}
					if ($(".LeviJP #mini-cart").find(".mini-cart-content").length == 0){ 
						$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #fff");
					}

					if ($(".LeviAU #mini-cart").find(".mini-cart-content").length > 0){
						$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #333");
						$(".LeviAU #mini-cart .mini-cart-total").css("border-bottom","none");
					}
					if ($(".LeviIN #mini-cart").find(".mini-cart-content").length > 0){
						$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #333");
						$(".LeviIN #mini-cart .mini-cart-total").css("border-bottom","none");
					}
					if ($(".LeviJP #mini-cart").find(".mini-cart-content").length > 0){
						$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #333");
						$(".LeviJP #mini-cart .mini-cart-total").css("border-bottom","none");
					}
					this.slide();
				}

			}.bind(this));

			this.$el.find('.mini-cart-total').on('mouseleave', function () {
				if (this.$content.is(':visible')) {
					this.$content.trigger('mouseleave');
					$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #fff")
					$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #fff")
					$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #fff")
				}
			}.bind(this));

			this.$content.on('mouseenter', function () {
				$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviAU #mini-cart .mini-cart-total").css("border-bottom","none")
				$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviIN #mini-cart .mini-cart-total").css("border-bottom","none")
				$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviJP #mini-cart .mini-cart-total").css("border-bottom","none")
				timer.clear();

			}).on('mouseleave', function () {
				$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #fff")
				$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #fff")
				$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #fff")
				timer.clear();
				timer.start(30, this.close.bind(this));
			}.bind(this));
		},
		/**
		 * @function
		 * @description Shows the given content in the mini cart
		 * @param {String} A HTML string with the content which will be shown
		 */
		show: function (html) {
			this.$el.html(html);
			this.init();
			this.slide();
			var a = localStorage.getItem("BonusEligible");
			if($('body').hasClass('LeviIN') && (a=='true'||a==true)){
				bonusProductsView.loadBonusOption();
			}
			else if($('body').hasClass('LeviIN') && (a=='false'||a==false || a==null)){

			}
			else{
				bonusProductsView.loadBonusOption();
			}
			
			if ($(".LeviAU #mini-cart").find(".mini-cart-content").length == 0){ 
				$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #fff")
			}
			if ($(".LeviIN #mini-cart").find(".mini-cart-content").length == 0){ 
				$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #fff")
				localStorage.setItem("cartType",'false');
				localStorage.setItem("BonusEligible",'true');
			}
			if ($(".LeviJP #mini-cart").find(".mini-cart-content").length == 0){ 
				$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #fff")
			}
			if ($(".LeviJP #mini-cart").find(".mini-cart-content").length > 0){
				$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviJP #mini-cart .mini-cart-total").css("border-bottom","none")
			}
			if ($(".LeviAU #mini-cart").find(".mini-cart-content").length > 0){
				$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviAU #mini-cart .mini-cart-total").css("border-bottom","none")
			}
			if ($(".LeviIN #mini-cart").find(".mini-cart-content").length > 0){
				$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviIN #mini-cart .mini-cart-total").css("border-bottom","none")
				$("body.LeviIN div#wrapper:not(.pt_wish-list , .pt_cart) #add-to-cart").html("<span class='added-right'></span>");	
				$("body.LeviIN div#wrapper:not(.pt_wish-list, .pt_cart) #add-to-cart").attr("disabled", "disabled"); 
			}
			if (!dialog.isActive()) {
				util.scrollBrowser(0);
			}


		},
		/**
		 * @function
		 * @description Slides down and show the contents of the mini cart
		 */
		slide: function () {
			timer.clear();
			// show the item
			this.$content.slideDown('slow');
			if ($(".LeviAU #mini-cart").find(".mini-cart-content").length == 0){ 
				$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #fff")
			}
			if ($(".LeviIN #mini-cart").find(".mini-cart-content").length == 0){ 
				$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #fff")
			}
			if ($(".LeviJP #mini-cart").find(".mini-cart-content").length == 0){ 
				$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #fff")
			}

			if ($(".LeviJP #mini-cart").find(".mini-cart-content").length > 0){
				$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviJP #mini-cart .mini-cart-total").css("border-bottom","none")
			}

			if ($(".LeviAU #mini-cart").find(".mini-cart-content").length > 0){
				$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviAU #mini-cart .mini-cart-total").css("border-bottom","none")
			}
			if ($(".LeviIN #mini-cart").find(".mini-cart-content").length > 0){
				$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #333")
				$(".LeviIN #mini-cart .mini-cart-total").css("border-bottom","none")
			}

			// after a time out automatically close it
			timer.start(6000, this.close.bind(this));
		},
		/**
		 * @function
		 * @description Closes the mini cart with given delay
		 * @param {Number} delay The delay in milliseconds
		 */
		close: function (delay) {
			timer.clear();
			$(".LeviAU #mini-cart .mini-cart-total").css("border","1px solid #fff")
			$(".LeviIN #mini-cart .mini-cart-total").css("border","1px solid #fff")
			$(".LeviJP #mini-cart .mini-cart-total").css("border","1px solid #fff")
			$("body.LeviIN div#wrapper:not(.pt_wish-list , .pt_cart) #add-to-cart").html("ADD TO BAG");	
			$("body.LeviIN div#wrapper:not(.pt_wish-list , .pt_cart) #add-to-cart").removeAttr("disabled");
			$("body.LeviKR div#wrapper:not(.pt_wish-list) #add-to-cart").html("장바구니 담기");	
			$("body.LeviKR div#wrapper:not(.pt_wish-list) #add-to-cart").removeAttr("disabled"); 
			this.$content.slideUp(delay);
		}
};

function miniCartProceedToCheckout(){
	if ($('#checkout').data('isdisabled') == 'CartExpired') {
		
		if (util.isMobile()) {
			alert(Resources.CART_EXPIRED_PDP);
			return;
		}
		
		$(this).tooltip({ items: "#checkout", content: Resources.CART_EXPIRED_PDP});
		$(this).tooltip("open");
		$(this).addClass('tooltip');
		return;
	}
}

module.exports = minicart;

},{"./bonus-products-view":13,"./tooltip":66,"./util":67}],26:[function(require,module,exports){

;(function($, window, document, undefined) {

	var drag, state, e;

	/**
	 * Template for status information about drag and touch events.
	 * @private
	 */
	drag = {
		start: 0,
		startX: 0,
		startY: 0,
		current: 0,
		currentX: 0,
		currentY: 0,
		offsetX: 0,
		offsetY: 0,
		distance: null,
		startTime: 0,
		endTime: 0,
		updatedX: 0,
		targetEl: null
	};

	/**
	 * Template for some status informations.
	 * @private
	 */
	state = {
		isTouch: false,
		isScrolling: false,
		isSwiping: false,
		direction: false,
		inMotion: false
	};

	/**
	 * Event functions references.
	 * @private
	 */
	e = {
		_onDragStart: null,
		_onDragMove: null,
		_onDragEnd: null,
		_transitionEnd: null,
		_resizer: null,
		_responsiveCall: null,
		_goToLoop: null,
		_checkVisibile: null
	};

	/**
	 * Creates a carousel.
	 * @class The Owl Carousel.
	 * @public
	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
	 * @param {Object} [options] - The options
	 */
	function Owl(element, options) {

		/**
		 * Current settings for the carousel.
		 * @public
		 */
		this.settings = null;

		/**
		 * Current options set by the caller including defaults.
		 * @public
		 */
		this.options = $.extend({}, Owl.Defaults, options);

		/**
		 * Plugin element.
		 * @public
		 */
		this.$element = $(element);

		/**
		 * Caches informations about drag and touch events.
		 */
		this.drag = $.extend({}, drag);

		/**
		 * Caches some status informations.
		 * @protected
		 */
		this.state = $.extend({}, state);

		/**
		 * @protected
		 * @todo Must be documented
		 */
		this.e = $.extend({}, e);

		/**
		 * References to the running plugins of this carousel.
		 * @protected
		 */
		this._plugins = {};

		/**
		 * Currently suppressed events to prevent them from beeing retriggered.
		 * @protected
		 */
		this._supress = {};

		/**
		 * Absolute current position.
		 * @protected
		 */
		this._current = null;

		/**
		 * Animation speed in milliseconds.
		 * @protected
		 */
		this._speed = null;

		/**
		 * Coordinates of all items in pixel.
		 * @todo The name of this member is missleading.
		 * @protected
		 */
		this._coordinates = [];

		/**
		 * Current breakpoint.
		 * @todo Real media queries would be nice.
		 * @protected
		 */
		this._breakpoint = null;

		/**
		 * Current width of the plugin element.
		 */
		this._width = null;

		/**
		 * All real items.
		 * @protected
		 */
		this._items = [];

		/**
		 * All cloned items.
		 * @protected
		 */
		this._clones = [];

		/**
		 * Merge values of all items.
		 * @todo Maybe this could be part of a plugin.
		 * @protected
		 */
		this._mergers = [];

		/**
		 * Invalidated parts within the update process.
		 * @protected
		 */
		this._invalidated = {};

		/**
		 * Ordered list of workers for the update process.
		 * @protected
		 */
		this._pipe = [];

		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
			this._plugins[key[0].toLowerCase() + key.slice(1)]
				= new plugin(this);
		}, this));

		$.each(Owl.Pipe, $.proxy(function(priority, worker) {
			this._pipe.push({
				'filter': worker.filter,
				'run': $.proxy(worker.run, this)
			});
		}, this));

		this.setup();
		this.initialize();
	}

	/**
	 * Default options for the carousel.
	 * @public
	 */
	Owl.Defaults = {
		items: 3,
		loop: false,
		center: false,

		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		freeDrag: false,

		margin: 0,
		stagePadding: 0,

		merge: false,
		mergeFit: true,
		autoWidth: false,

		startPosition: 0,
		rtl: false,

		smartSpeed: 250,
		fluidSpeed: false,
		dragEndSpeed: false,

		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: window,
		responsiveClass: false,

		fallbackEasing: 'swing',

		info: false,

		nestedItemSelector: false,
		itemElement: 'div',
		stageElement: 'div',

		// Classes and Names
		themeClass: 'owl-theme',
		baseClass: 'owl-carousel',
		itemClass: 'owl-item',
		centerClass: 'center',
		activeClass: 'active'
	};

	/**
	 * Enumeration for width.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Width = {
		Default: 'default',
		Inner: 'inner',
		Outer: 'outer'
	};

	/**
	 * Contains all registered plugins.
	 * @public
	 */
	Owl.Plugins = {};

	/**
	 * Update pipe.
	 */
	Owl.Pipe = [ {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = this._items && this._items[this.relative(this._current)];
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			var cached = this._clones,
				clones = this.$stage.children('.cloned');

			if (clones.length !== cached.length || (!this.settings.loop && cached.length > 0)) {
				this.$stage.children('.cloned').remove();
				this._clones = [];
			}
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			var i, n,
				clones = this._clones,
				items = this._items,
				delta = this.settings.loop ? clones.length - Math.max(this.settings.items * 2, 4) : 0;

			for (i = 0, n = Math.abs(delta / 2); i < n; i++) {
				if (delta > 0) {
					this.$stage.children().eq(items.length + clones.length - 1).remove();
					clones.pop();
					this.$stage.children().eq(0).remove();
					clones.pop();
				} else {
					clones.push(clones.length / 2);
					this.$stage.append(items[clones[clones.length - 1]].clone().addClass('cloned'));
					clones.push(items.length - 1 - (clones.length - 1) / 2);
					this.$stage.prepend(items[clones[clones.length - 1]].clone().addClass('cloned'));
				}
			}
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var rtl = (this.settings.rtl ? 1 : -1),
				width = (this.width() / this.settings.items).toFixed(3),
				coordinate = 0, merge, i, n;

			this._coordinates = [];
			for (i = 0, n = this._clones.length + this._items.length; i < n; i++) {
				merge = this._mergers[this.relative(i)];
				merge = (this.settings.mergeFit && Math.min(merge, this.settings.items)) || merge;
				coordinate += (this.settings.autoWidth ? this._items[this.relative(i)].width() + this.settings.margin : width * merge) * rtl;

				this._coordinates.push(coordinate);
			}
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var i, n, width = (this.width() / this.settings.items).toFixed(3), css = {
				'width': Math.abs(this._coordinates[this._coordinates.length - 1]) + this.settings.stagePadding * 2,
				'padding-left': this.settings.stagePadding || '',
				'padding-right': this.settings.stagePadding || ''
			};

			this.$stage.css(css);

			css = { 'width': this.settings.autoWidth ? 'auto' : width - this.settings.margin };
			css[this.settings.rtl ? 'margin-left' : 'margin-right'] = this.settings.margin;

			if (!this.settings.autoWidth && $.grep(this._mergers, function(v) { return v > 1 }).length > 0) {
				for (i = 0, n = this._coordinates.length; i < n; i++) {
					css.width = Math.abs(this._coordinates[i]) - Math.abs(this._coordinates[i - 1] || 0) - this.settings.margin;
					this.$stage.children().eq(i).css(css);
				}
			} else {
				this.$stage.children().css(css);
			}
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current && this.reset(this.$stage.children().index(cache.current));
		}
	}, {
		filter: [ 'position' ],
		run: function() {
			this.animate(this.coordinates(this._current));
		}
	}, {
		filter: [ 'width', 'position', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				padding = this.settings.stagePadding * 2,
				begin = this.coordinates(this.current()) + padding,
				end = begin + this.width() * rtl,
				inner, outer, matches = [], i, n;

			for (i = 0, n = this._coordinates.length; i < n; i++) {
				inner = this._coordinates[i - 1] || 0;
				outer = Math.abs(this._coordinates[i]) + padding * rtl;

				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
					matches.push(i);
				}
			}

			this.$stage.children('.' + this.settings.activeClass).removeClass(this.settings.activeClass);
			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass(this.settings.activeClass);

			if (this.settings.center) {
				this.$stage.children('.' + this.settings.centerClass).removeClass(this.settings.centerClass);
				this.$stage.children().eq(this.current()).addClass(this.settings.centerClass);
			}
		}
	} ];

	/**
	 * Initializes the carousel.
	 * @protected
	 */
	Owl.prototype.initialize = function() {
		this.trigger('initialize');

		this.$element
			.addClass(this.settings.baseClass)
			.addClass(this.settings.themeClass)
			.toggleClass('owl-rtl', this.settings.rtl);

		// check support
		this.browserSupport();

		if (this.settings.autoWidth && this.state.imagesLoaded !== true) {
			var imgs, nestedSelector, width;
			imgs = this.$element.find('img');
			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
			width = this.$element.children(nestedSelector).width();

			if (imgs.length && width <= 0) {
				this.preloadAutoWidthImages(imgs);
				return false;
			}
		}

		this.$element.addClass('owl-loading');

		// create stage
		this.$stage = $('<' + this.settings.stageElement + ' class="owl-stage"/>')
			.wrap('<div class="owl-stage-outer">');

		// append stage
		this.$element.append(this.$stage.parent());

		// append content
		this.replace(this.$element.children().not(this.$stage.parent()));

		// set view width
		this._width = this.$element.width();

		// update view
		this.refresh();

		this.$element.removeClass('owl-loading').addClass('owl-loaded');

		// attach generic events
		this.eventsCall();

		// attach generic events
		this.internalEvents();

		// attach custom control events
		this.addTriggerableEvents();

		this.trigger('initialized');
	};

	/**
	 * Setups the current settings.
	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
	 * @todo Support for media queries by using `matchMedia` would be nice.
	 * @public
	 */
	Owl.prototype.setup = function() {
		var viewport = this.viewport(),
			overwrites = this.options.responsive,
			match = -1,
			settings = null;

		if (!overwrites) {
			settings = $.extend({}, this.options);
		} else {
			$.each(overwrites, function(breakpoint) {
				if (breakpoint <= viewport && breakpoint > match) {
					match = Number(breakpoint);
				}
			});

			settings = $.extend({}, this.options, overwrites[match]);
			delete settings.responsive;

			// responsive class
			if (settings.responsiveClass) {
				this.$element.attr('class', function(i, c) {
					return c.replace(/\b owl-responsive-\S+/g, '');
				}).addClass('owl-responsive-' + match);
			}
		}

		if (this.settings === null || this._breakpoint !== match) {
			this.trigger('change', { property: { name: 'settings', value: settings } });
			this._breakpoint = match;
			this.settings = settings;
			this.invalidate('settings');
			this.trigger('changed', { property: { name: 'settings', value: this.settings } });
		}
	};

	/**
	 * Updates option logic if necessery.
	 * @protected
	 */
	Owl.prototype.optionsLogic = function() {
		// Toggle Center class
		this.$element.toggleClass('owl-center', this.settings.center);

		// if items number is less than in body
		if (this.settings.loop && this._items.length < this.settings.items) {
			this.settings.loop = false;
		}

		if (this.settings.autoWidth) {
			this.settings.stagePadding = false;
			this.settings.merge = false;
		}
	};

	/**
	 * Prepares an item before add.
	 * @todo Rename event parameter `content` to `item`.
	 * @protected
	 * @returns {jQuery|HTMLElement} - The item container.
	 */
	Owl.prototype.prepare = function(item) {
		var event = this.trigger('prepare', { content: item });

		if (!event.data) {
			event.data = $('<' + this.settings.itemElement + '/>')
				.addClass(this.settings.itemClass).append(item)
		}

		this.trigger('prepared', { content: event.data });

		return event.data;
	};

	/**
	 * Updates the view.
	 * @public
	 */
	Owl.prototype.update = function() {
		var i = 0,
			n = this._pipe.length,
			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
			cache = {};

		while (i < n) {
			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
				this._pipe[i].run(cache);
			}
			i++;
		}

		this._invalidated = {};
	};

	/**
	 * Gets the width of the view.
	 * @public
	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
	 * @returns {Number} - The width of the view in pixel.
	 */
	Owl.prototype.width = function(dimension) {
		dimension = dimension || Owl.Width.Default;
		switch (dimension) {
			case Owl.Width.Inner:
			case Owl.Width.Outer:
				return this._width;
			default:
				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
		}
	};

	/**
	 * Refreshes the carousel primarily for adaptive purposes.
	 * @public
	 */
	Owl.prototype.refresh = function() {
		if (this._items.length === 0) {
			return false;
		}

		var start = new Date().getTime();

		this.trigger('refresh');

		this.setup();

		this.optionsLogic();

		// hide and show methods helps here to set a proper widths,
		// this prevents scrollbar to be calculated in stage width
		this.$stage.addClass('owl-refresh');

		this.update();

		this.$stage.removeClass('owl-refresh');

		this.state.orientation = window.orientation;

		this.watchVisibility();

		this.trigger('refreshed');
	};

	/**
	 * Save internal event references and add event based functions.
	 * @protected
	 */
	Owl.prototype.eventsCall = function() {
		// Save events references
		this.e._onDragStart = $.proxy(function(e) {
			this.onDragStart(e);
		}, this);
		this.e._onDragMove = $.proxy(function(e) {
			this.onDragMove(e);
		}, this);
		this.e._onDragEnd = $.proxy(function(e) {
			this.onDragEnd(e);
		}, this);
		this.e._onResize = $.proxy(function(e) {
			this.onResize(e);
		}, this);
		this.e._transitionEnd = $.proxy(function(e) {
			this.transitionEnd(e);
		}, this);
		this.e._preventClick = $.proxy(function(e) {
			this.preventClick(e);
		}, this);
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onThrottledResize = function() {
		window.clearTimeout(this.resizeTimer);
		this.resizeTimer = window.setTimeout(this.e._onResize, this.settings.responsiveRefreshRate);
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onResize = function() {
		if (!this._items.length) {
			return false;
		}

		if (this._width === this.$element.width()) {
			return false;
		}

		if (this.trigger('resize').isDefaultPrevented()) {
			return false;
		}

		this._width = this.$element.width();

		this.invalidate('width');

		this.refresh();

		this.trigger('resized');
	};

	/**
	 * Checks for touch/mouse drag event type and add run event handlers.
	 * @protected
	 */
	Owl.prototype.eventsRouter = function(event) {
		var type = event.type;

		if (type === "mousedown" || type === "touchstart") {
			this.onDragStart(event);
		} else if (type === "mousemove" || type === "touchmove") {
			this.onDragMove(event);
		} else if (type === "mouseup" || type === "touchend") {
			this.onDragEnd(event);
		} else if (type === "touchcancel") {
			this.onDragEnd(event);
		}
	};

	/**
	 * Checks for touch/mouse drag options and add necessery event handlers.
	 * @protected
	 */
	Owl.prototype.internalEvents = function() {
		var isTouch = isTouchSupport(),
			isTouchIE = isTouchSupportIE();

		if (this.settings.mouseDrag){
			this.$stage.on('mousedown', $.proxy(function(event) { this.eventsRouter(event) }, this));
			this.$stage.on('dragstart', function() { return false });
			this.$stage.get(0).onselectstart = function() { return false };
		} else {
			this.$element.addClass('owl-text-select-on');
		}

		if (this.settings.touchDrag && !isTouchIE){
			this.$stage.on('touchstart touchcancel', $.proxy(function(event) { this.eventsRouter(event) }, this));
		}

		// catch transitionEnd event
		if (this.transitionEndVendor) {
			this.on(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd, false);
		}

		// responsive
		if (this.settings.responsive !== false) {
			this.on(window, 'resize', $.proxy(this.onThrottledResize, this));
		}
	};

	/**
	 * Handles touchstart/mousedown event.
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragStart = function(event) {
		var ev, isTouchEvent, pageX, pageY, animatedPos;

		ev = event.originalEvent || event || window.event;

		// prevent right click
		if (ev.which === 3 || this.state.isTouch) {
			return false;
		}

		if (ev.type === 'mousedown') {
			this.$stage.addClass('owl-grab');
		}

		this.trigger('drag');
		this.drag.startTime = new Date().getTime();
		this.speed(0);
		this.state.isTouch = true;
		this.state.isScrolling = false;
		this.state.isSwiping = false;
		this.drag.distance = 0;

		pageX = getTouches(ev).x;
		pageY = getTouches(ev).y;

		// get stage position left
		this.drag.offsetX = this.$stage.position().left;
		this.drag.offsetY = this.$stage.position().top;

		if (this.settings.rtl) {
			this.drag.offsetX = this.$stage.position().left + this.$stage.width() - this.width()
				+ this.settings.margin;
		}

		// catch position // ie to fix
		if (this.state.inMotion && this.support3d) {
			animatedPos = this.getTransformProperty();
			this.drag.offsetX = animatedPos;
			this.animate(animatedPos);
			this.state.inMotion = true;
		} else if (this.state.inMotion && !this.support3d) {
			this.state.inMotion = false;
			return false;
		}

		this.drag.startX = pageX - this.drag.offsetX;
		this.drag.startY = pageY - this.drag.offsetY;

		this.drag.start = pageX - this.drag.startX;
		this.drag.targetEl = ev.target || ev.srcElement;
		this.drag.updatedX = this.drag.start;

		// to do/check
		// prevent links and images dragging;
		if (this.drag.targetEl.tagName === "IMG" || this.drag.targetEl.tagName === "A") {
			this.drag.targetEl.draggable = false;
		}

		$(document).on('mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents', $.proxy(function(event) {this.eventsRouter(event)},this));
	};

	/**
	 * Handles the touchmove/mousemove events.
	 * @todo Simplify
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragMove = function(event) {
		var ev, isTouchEvent, pageX, pageY, minValue, maxValue, pull;

		if (!this.state.isTouch) {
			return;
		}

		if (this.state.isScrolling) {
			return;
		}

		ev = event.originalEvent || event || window.event;

		pageX = getTouches(ev).x;
		pageY = getTouches(ev).y;

		// Drag Direction
		this.drag.currentX = pageX - this.drag.startX;
		this.drag.currentY = pageY - this.drag.startY;
		this.drag.distance = this.drag.currentX - this.drag.offsetX;

		// Check move direction
		if (this.drag.distance < 0) {
			this.state.direction = this.settings.rtl ? 'right' : 'left';
		} else if (this.drag.distance > 0) {
			this.state.direction = this.settings.rtl ? 'left' : 'right';
		}
		// Loop
		if (this.settings.loop) {
			if (this.op(this.drag.currentX, '>', this.coordinates(this.minimum())) && this.state.direction === 'right') {
				this.drag.currentX -= (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length);
			} else if (this.op(this.drag.currentX, '<', this.coordinates(this.maximum())) && this.state.direction === 'left') {
				this.drag.currentX += (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length);
			}
		} else {
			// pull
			minValue = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
			maxValue = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
			pull = this.settings.pullDrag ? this.drag.distance / 5 : 0;
			this.drag.currentX = Math.max(Math.min(this.drag.currentX, minValue + pull), maxValue + pull);
		}

		// Lock browser if swiping horizontal

		if ((this.drag.distance > 8 || this.drag.distance < -8)) {
			if (ev.preventDefault !== undefined) {
				ev.preventDefault();
			} else {
				ev.returnValue = false;
			}
			this.state.isSwiping = true;
		}

		this.drag.updatedX = this.drag.currentX;

		// Lock Owl if scrolling
		if ((this.drag.currentY > 16 || this.drag.currentY < -16) && this.state.isSwiping === false) {
			this.state.isScrolling = true;
			this.drag.updatedX = this.drag.start;
		}

		this.animate(this.drag.updatedX);
	};

	/**
	 * Handles the touchend/mouseup events.
	 * @protected
	 */
	Owl.prototype.onDragEnd = function(event) {
		var compareTimes, distanceAbs, closest;

		if (!this.state.isTouch) {
			return;
		}

		if (event.type === 'mouseup') {
			this.$stage.removeClass('owl-grab');
		}

		this.trigger('dragged');

		// prevent links and images dragging;
		this.drag.targetEl.removeAttribute("draggable");

		// remove drag event listeners

		this.state.isTouch = false;
		this.state.isScrolling = false;
		this.state.isSwiping = false;

		// to check
		if (this.drag.distance === 0 && this.state.inMotion !== true) {
			this.state.inMotion = false;
			return false;
		}

		// prevent clicks while scrolling

		this.drag.endTime = new Date().getTime();
		compareTimes = this.drag.endTime - this.drag.startTime;
		distanceAbs = Math.abs(this.drag.distance);

		// to test
		if (distanceAbs > 3 || compareTimes > 300) {
			this.removeClick(this.drag.targetEl);
		}

		closest = this.closest(this.drag.updatedX);

		this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
		this.current(closest);
		this.invalidate('position');
		this.update();

		// if pullDrag is off then fire transitionEnd event manually when stick
		// to border
		if (!this.settings.pullDrag && this.drag.updatedX === this.coordinates(closest)) {
			this.transitionEnd();
		}

		this.drag.distance = 0;

		$(document).off('.owl.dragEvents');
	};

	/**
	 * Attaches `preventClick` to disable link while swipping.
	 * @protected
	 * @param {HTMLElement} [target] - The target of the `click` event.
	 */
	Owl.prototype.removeClick = function(target) {
		this.drag.targetEl = target;
		$(target).on('click.preventClick', this.e._preventClick);
		// to make sure click is removed:
		window.setTimeout(function() {
			$(target).off('click.preventClick');
		}, 300);
	};

	/**
	 * Suppresses click event.
	 * @protected
	 * @param {Event} ev - The event arguments.
	 */
	Owl.prototype.preventClick = function(ev) {
		if (ev.preventDefault) {
			ev.preventDefault();
		} else {
			ev.returnValue = false;
		}
		if (ev.stopPropagation) {
			ev.stopPropagation();
		}
		$(ev.target).off('click.preventClick');
	};

	/**
	 * Catches stage position while animate (only CSS3).
	 * @protected
	 * @returns
	 */
	Owl.prototype.getTransformProperty = function() {
		var transform, matrix3d;

		transform = window.getComputedStyle(this.$stage.get(0), null).getPropertyValue(this.vendorName + 'transform');
		// var transform = this.$stage.css(this.vendorName + 'transform')
		transform = transform.replace(/matrix(3d)?\(|\)/g, '').split(',');
		matrix3d = transform.length === 16;

		return matrix3d !== true ? transform[4] : transform[12];
	};

	/**
	 * Gets absolute position of the closest item for a coordinate.
	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
	 * @protected
	 * @param {Number} coordinate - The coordinate in pixel.
	 * @return {Number} - The absolute position of the closest item.
	 */
	Owl.prototype.closest = function(coordinate) {
		var position = -1, pull = 30, width = this.width(), coordinates = this.coordinates();

		if (!this.settings.freeDrag) {
			// check closest item
			$.each(coordinates, $.proxy(function(index, value) {
				if (coordinate > value - pull && coordinate < value + pull) {
					position = index;
				} else if (this.op(coordinate, '<', value)
					&& this.op(coordinate, '>', coordinates[index + 1] || value - width)) {
					position = this.state.direction === 'left' ? index + 1 : index;
				}
				return position === -1;
			}, this));
		}

		if (!this.settings.loop) {
			// non loop boundries
			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
				position = coordinate = this.minimum();
			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
				position = coordinate = this.maximum();
			}
		}

		return position;
	};

	/**
	 * Animates the stage.
	 * @public
	 * @param {Number} coordinate - The coordinate in pixels.
	 */
	Owl.prototype.animate = function(coordinate) {
		this.trigger('translate');
		this.state.inMotion = this.speed() > 0;

		if (this.support3d) {
			this.$stage.css({
				transform: 'translate3d(' + coordinate + 'px' + ',0px, 0px)',
				transition: (this.speed() / 1000) + 's'
			});
		} else if (this.state.isTouch) {
			this.$stage.css({
				left: coordinate + 'px'
			});
		} else {
			this.$stage.animate({
				left: coordinate
			}, this.speed() / 1000, this.settings.fallbackEasing, $.proxy(function() {
				if (this.state.inMotion) {
					this.transitionEnd();
				}
			}, this));
		}
	};

	/**
	 * Sets the absolute position of the current item.
	 * @public
	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
	 * @returns {Number} - The absolute position of the current item.
	 */
	Owl.prototype.current = function(position) {
		if (position === undefined) {
			return this._current;
		}

		if (this._items.length === 0) {
			return undefined;
		}

		position = this.normalize(position);

		if (this._current !== position) {
			var event = this.trigger('change', { property: { name: 'position', value: position } });

			if (event.data !== undefined) {
				position = this.normalize(event.data);
			}

			this._current = position;

			this.invalidate('position');

			this.trigger('changed', { property: { name: 'position', value: this._current } });
		}

		return this._current;
	};

	/**
	 * Invalidates the given part of the update routine.
	 * @param {String} part - The part to invalidate.
	 */
	Owl.prototype.invalidate = function(part) {
		this._invalidated[part] = true;
	}

	/**
	 * Resets the absolute position of the current item.
	 * @public
	 * @param {Number} position - The absolute position of the new item.
	 */
	Owl.prototype.reset = function(position) {
		position = this.normalize(position);

		if (position === undefined) {
			return;
		}

		this._speed = 0;
		this._current = position;

		this.suppress([ 'translate', 'translated' ]);

		this.animate(this.coordinates(position));

		this.release([ 'translate', 'translated' ]);
	};

	/**
	 * Normalizes an absolute or a relative position for an item.
	 * @public
	 * @param {Number} position - The absolute or relative position to normalize.
	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
	 * @returns {Number} - The normalized position.
	 */
	Owl.prototype.normalize = function(position, relative) {
		var n = (relative ? this._items.length : this._items.length + this._clones.length);

		if (!$.isNumeric(position) || n < 1) {
			return undefined;
		}

		if (this._clones.length) {
			position = ((position % n) + n) % n;
		} else {
			position = Math.max(this.minimum(relative), Math.min(this.maximum(relative), position));
		}

		return position;
	};

	/**
	 * Converts an absolute position for an item into a relative position.
	 * @public
	 * @param {Number} position - The absolute position to convert.
	 * @returns {Number} - The converted position.
	 */
	Owl.prototype.relative = function(position) {
		position = this.normalize(position);
		position = position - this._clones.length / 2;
		return this.normalize(position, true);
	};

	/**
	 * Gets the maximum position for an item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.maximum = function(relative) {
		var maximum, width, i = 0, coordinate,
			settings = this.settings;

		if (relative) {
			return this._items.length - 1;
		}

		if (!settings.loop && settings.center) {
			maximum = this._items.length - 1;
		} else if (!settings.loop && !settings.center) {
			maximum = this._items.length - settings.items;
		} else if (settings.loop || settings.center) {
			maximum = this._items.length + settings.items;
		} else if (settings.autoWidth || settings.merge) {
			revert = settings.rtl ? 1 : -1;
			width = this.$stage.width() - this.$element.width();
			while (coordinate = this.coordinates(i)) {
				if (coordinate * revert >= width) {
					break;
				}
				maximum = ++i;
			}
		} else {
			throw 'Can not detect maximum absolute position.'
		}

		return maximum;
	};

	/**
	 * Gets the minimum position for an item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.minimum = function(relative) {
		if (relative) {
			return 0;
		}

		return this._clones.length / 2;
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.items = function(position) {
		if (position === undefined) {
			return this._items.slice();
		}

		position = this.normalize(position, true);
		return this._items[position];
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.mergers = function(position) {
		if (position === undefined) {
			return this._mergers.slice();
		}

		position = this.normalize(position, true);
		return this._mergers[position];
	};

	/**
	 * Gets the absolute positions of clones for an item.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
	 */
	Owl.prototype.clones = function(position) {
		var odd = this._clones.length / 2,
			even = odd + this._items.length,
			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };

		if (position === undefined) {
			return $.map(this._clones, function(v, i) { return map(i) });
		}

		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
	};

	/**
	 * Sets the current animation speed.
	 * @public
	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
	 * @returns {Number} - The current animation speed in milliseconds.
	 */
	Owl.prototype.speed = function(speed) {
		if (speed !== undefined) {
			this._speed = speed;
		}

		return this._speed;
	};

	/**
	 * Gets the coordinate of an item.
	 * @todo The name of this method is missleanding.
	 * @public
	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
	 */
	Owl.prototype.coordinates = function(position) {
		var coordinate = null;

		if (position === undefined) {
			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
				return this.coordinates(index);
			}, this));
		}

		if (this.settings.center) {
			coordinate = this._coordinates[position];
			coordinate += (this.width() - coordinate + (this._coordinates[position - 1] || 0)) / 2 * (this.settings.rtl ? -1 : 1);
		} else {
			coordinate = this._coordinates[position - 1] || 0;
		}

		return coordinate;
	};

	/**
	 * Calculates the speed for a translation.
	 * @protected
	 * @param {Number} from - The absolute position of the start item.
	 * @param {Number} to - The absolute position of the target item.
	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	 * @returns {Number} - The time in milliseconds for the translation.
	 */
	Owl.prototype.duration = function(from, to, factor) {
		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
	};

	/**
	 * Slides to the specified item.
	 * @public
	 * @param {Number} position - The position of the item.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.to = function(position, speed) {
		if (this.settings.loop) {
			var distance = position - this.relative(this.current()),
				revert = this.current(),
				before = this.current(),
				after = this.current() + distance,
				direction = before - after < 0 ? true : false,
				items = this._clones.length + this._items.length;

			if (after < this.settings.items && direction === false) {
				revert = before + this._items.length;
				this.reset(revert);
			} else if (after >= items - this.settings.items && direction === true) {
				revert = before - this._items.length;
				this.reset(revert);
			}
			window.clearTimeout(this.e._goToLoop);
			this.e._goToLoop = window.setTimeout($.proxy(function() {
				this.speed(this.duration(this.current(), revert + distance, speed));
				this.current(revert + distance);
				this.update();
			}, this), 30);
		} else {
			this.speed(this.duration(this.current(), position, speed));
			this.current(position);
			this.update();
		}
	};

	/**
	 * Slides to the next item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.next = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) + 1, speed);
	};

	/**
	 * Slides to the previous item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.prev = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) - 1, speed);
	};

	/**
	 * Handles the end of an animation.
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.transitionEnd = function(event) {

		// if css2 animation then event object is undefined
		if (event !== undefined) {
			event.stopPropagation();

			// Catch only owl-stage transitionEnd event
			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
				return false;
			}
		}

		this.state.inMotion = false;
		this.trigger('translated');
	};

	/**
	 * Gets viewport width.
	 * @protected
	 * @return {Number} - The width in pixel.
	 */
	Owl.prototype.viewport = function() {
		var width;
		if (this.options.responsiveBaseElement !== window) {
			width = $(this.options.responsiveBaseElement).width();
		} else if (window.innerWidth) {
			width = window.innerWidth;
		} else if (document.documentElement && document.documentElement.clientWidth) {
			width = document.documentElement.clientWidth;
		} else {
			throw 'Can not detect viewport width.';
		}
		return width;
	};

	/**
	 * Replaces the current content.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The new content.
	 */
	Owl.prototype.replace = function(content) {
		this.$stage.empty();
		this._items = [];

		if (content) {
			content = (content instanceof jQuery) ? content : $(content);
		}

		if (this.settings.nestedItemSelector) {
			content = content.find('.' + this.settings.nestedItemSelector);
		}

		content.filter(function() {
			return this.nodeType === 1;
		}).each($.proxy(function(index, item) {
			item = this.prepare(item);
			this.$stage.append(item);
			this._items.push(item);
			this._mergers.push(item.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
		}, this));

		this.reset($.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

		this.invalidate('items');
	};

	/**
	 * Adds an item.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The item content to add.
	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
	 */
	Owl.prototype.add = function(content, position) {
		position = position === undefined ? this._items.length : this.normalize(position, true);

		this.trigger('add', { content: content, position: position });

		if (this._items.length === 0 || position === this._items.length) {
			this.$stage.append(content);
			this._items.push(content);
			this._mergers.push(content.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
		} else {
			this._items[position].before(content);
			this._items.splice(position, 0, content);
			this._mergers.splice(position, 0, content.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
		}

		this.invalidate('items');

		this.trigger('added', { content: content, position: position });
	};

	/**
	 * Removes an item by its position.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {Number} position - The relative position of the item to remove.
	 */
	Owl.prototype.remove = function(position) {
		position = this.normalize(position, true);

		if (position === undefined) {
			return;
		}

		this.trigger('remove', { content: this._items[position], position: position });

		this._items[position].remove();
		this._items.splice(position, 1);
		this._mergers.splice(position, 1);

		this.invalidate('items');

		this.trigger('removed', { content: null, position: position });
	};

	/**
	 * Adds triggerable events.
	 * @protected
	 */
	Owl.prototype.addTriggerableEvents = function() {
		var handler = $.proxy(function(callback, event) {
			return $.proxy(function(e) {
				if (e.relatedTarget !== this) {
					this.suppress([ event ]);
					callback.apply(this, [].slice.call(arguments, 1));
					this.release([ event ]);
				}
			}, this);
		}, this);

		$.each({
			'next': this.next,
			'prev': this.prev,
			'to': this.to,
			'destroy': this.destroy,
			'refresh': this.refresh,
			'replace': this.replace,
			'add': this.add,
			'remove': this.remove
		}, $.proxy(function(event, callback) {
			this.$element.on(event + '.owl.carousel', handler(callback, event + '.owl.carousel'));
		}, this));

	};

	/**
	 * Watches the visibility of the carousel element.
	 * @protected
	 */
	Owl.prototype.watchVisibility = function() {

		// test on zepto
		if (!isElVisible(this.$element.get(0))) {
			this.$element.addClass('owl-hidden');
			window.clearInterval(this.e._checkVisibile);
			this.e._checkVisibile = window.setInterval($.proxy(checkVisible, this), 500);
		}

		function isElVisible(el) {
			return el.offsetWidth > 0 && el.offsetHeight > 0;
		}

		function checkVisible() {
			if (isElVisible(this.$element.get(0))) {
				this.$element.removeClass('owl-hidden');
				this.refresh();
				window.clearInterval(this.e._checkVisibile);
			}
		}
	};

	/**
	 * Preloads images with auto width.
	 * @protected
	 * @todo Still to test
	 */
	Owl.prototype.preloadAutoWidthImages = function(imgs) {
		var loaded, that, $el, img;

		loaded = 0;
		that = this;
		imgs.each(function(i, el) {
			$el = $(el);
			img = new Image();

			img.onload = function() {
				loaded++;
				$el.attr('src', img.src);
				$el.css('opacity', 1);
				if (loaded >= imgs.length) {
					that.state.imagesLoaded = true;
					that.initialize();
				}
			};

			img.src = $el.attr('src') || $el.attr('data-src') || $el.attr('data-src-retina');
		});
	};

	/**
	 * Destroys the carousel.
	 * @public
	 */
	Owl.prototype.destroy = function() {

		if (this.$element.hasClass(this.settings.themeClass)) {
			this.$element.removeClass(this.settings.themeClass);
		}

		if (this.settings.responsive !== false) {
			$(window).off('resize.owl.carousel');
		}

		if (this.transitionEndVendor) {
			this.off(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd);
		}

		for ( var i in this._plugins) {
			this._plugins[i].destroy();
		}

		if (this.settings.mouseDrag || this.settings.touchDrag) {
			this.$stage.off('mousedown touchstart touchcancel');
			$(document).off('.owl.dragEvents');
			this.$stage.get(0).onselectstart = function() {};
			this.$stage.off('dragstart', function() { return false });
		}

		// remove event handlers in the ".owl.carousel" namespace
		this.$element.off('.owl');

		this.$stage.children('.cloned').remove();
		this.e = null;
		this.$element.removeData('owlCarousel');

		this.$stage.children().contents().unwrap();
		this.$stage.children().unwrap();
		this.$stage.unwrap();
	};

	/**
	 * Operators to calculate right-to-left and left-to-right.
	 * @protected
	 * @param {Number} [a] - The left side operand.
	 * @param {String} [o] - The operator.
	 * @param {Number} [b] - The right side operand.
	 */
	Owl.prototype.op = function(a, o, b) {
		var rtl = this.settings.rtl;
		switch (o) {
			case '<':
				return rtl ? a > b : a < b;
			case '>':
				return rtl ? a < b : a > b;
			case '>=':
				return rtl ? a <= b : a >= b;
			case '<=':
				return rtl ? a >= b : a <= b;
			default:
				break;
		}
	};

	/**
	 * Attaches to an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The event handler to attach.
	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
	 */
	Owl.prototype.on = function(element, event, listener, capture) {
		if (element.addEventListener) {
			element.addEventListener(event, listener, capture);
		} else if (element.attachEvent) {
			element.attachEvent('on' + event, listener);
		}
	};

	/**
	 * Detaches from an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The attached event handler to detach.
	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
	 */
	Owl.prototype.off = function(element, event, listener, capture) {
		if (element.removeEventListener) {
			element.removeEventListener(event, listener, capture);
		} else if (element.detachEvent) {
			element.detachEvent('on' + event, listener);
		}
	};

	/**
	 * Triggers an public event.
	 * @protected
	 * @param {String} name - The event name.
	 * @param {*} [data=null] - The event data.
	 * @param {String} [namespace=.owl.carousel] - The event namespace.
	 * @returns {Event} - The event arguments.
	 */
	Owl.prototype.trigger = function(name, data, namespace) {
		var status = {
			item: { count: this._items.length, index: this.current() }
		}, handler = $.camelCase(
			$.grep([ 'on', name, namespace ], function(v) { return v })
				.join('-').toLowerCase()
		), event = $.Event(
			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
			$.extend({ relatedTarget: this }, status, data)
		);

		if (!this._supress[name]) {
			$.each(this._plugins, function(name, plugin) {
				if (plugin.onTrigger) {
					plugin.onTrigger(event);
				}
			});

			this.$element.trigger(event);

			if (this.settings && typeof this.settings[handler] === 'function') {
				this.settings[handler].apply(this, event);
			}
		}

		return event;
	};

	/**
	 * Suppresses events.
	 * @protected
	 * @param {Array.<String>} events - The events to suppress.
	 */
	Owl.prototype.suppress = function(events) {
		$.each(events, $.proxy(function(index, event) {
			this._supress[event] = true;
		}, this));
	}

	/**
	 * Releases suppressed events.
	 * @protected
	 * @param {Array.<String>} events - The events to release.
	 */
	Owl.prototype.release = function(events) {
		$.each(events, $.proxy(function(index, event) {
			delete this._supress[event];
		}, this));
	}

	/**
	 * Checks the availability of some browser features.
	 * @protected
	 */
	Owl.prototype.browserSupport = function() {
		this.support3d = isPerspective();

		if (this.support3d) {
			this.transformVendor = isTransform();

			// take transitionend event name by detecting transition
			var endVendors = [ 'transitionend', 'webkitTransitionEnd', 'transitionend', 'oTransitionEnd' ];
			this.transitionEndVendor = endVendors[isTransition()];

			// take vendor name from transform name
			this.vendorName = this.transformVendor.replace(/Transform/i, '');
			this.vendorName = this.vendorName !== '' ? '-' + this.vendorName.toLowerCase() + '-' : '';
		}

		this.state.orientation = window.orientation;
	};

	/**
	 * Get touch/drag coordinats.
	 * @private
	 * @param {event} - mousedown/touchstart event
	 * @returns {object} - Contains X and Y of current mouse/touch position
	 */

	function getTouches(event) {
		if (event.touches !== undefined) {
			return {
				x: event.touches[0].pageX,
				y: event.touches[0].pageY
			};
		}

		if (event.touches === undefined) {
			if (event.pageX !== undefined) {
				return {
					x: event.pageX,
					y: event.pageY
				};
			}

		if (event.pageX === undefined) {
			return {
					x: event.clientX,
					y: event.clientY
				};
			}
		}
	}

	/**
	 * Checks for CSS support.
	 * @private
	 * @param {Array} array - The CSS properties to check for.
	 * @returns {Array} - Contains the supported CSS property name and its index or `false`.
	 */
	function isStyleSupported(array) {
		var p, s, fake = document.createElement('div'), list = array;
		for (p in list) {
			s = list[p];
			if (typeof fake.style[s] !== 'undefined') {
				fake = null;
				return [ s, p ];
			}
		}
		return [ false ];
	}

	/**
	 * Checks for CSS transition support.
	 * @private
	 * @todo Realy bad design
	 * @returns {Number}
	 */
	function isTransition() {
		return isStyleSupported([ 'transition', 'WebkitTransition', 'MozTransition', 'OTransition' ])[1];
	}

	/**
	 * Checks for CSS transform support.
	 * @private
	 * @returns {String} The supported property name or false.
	 */
	function isTransform() {
		return isStyleSupported([ 'transform', 'WebkitTransform', 'MozTransform', 'OTransform', 'msTransform' ])[0];
	}

	/**
	 * Checks for CSS perspective support.
	 * @private
	 * @returns {String} The supported property name or false.
	 */
	function isPerspective() {
		return isStyleSupported([ 'perspective', 'webkitPerspective', 'MozPerspective', 'OPerspective', 'MsPerspective' ])[0];
	}

	/**
	 * Checks wether touch is supported or not.
	 * @private
	 * @returns {Boolean}
	 */
	function isTouchSupport() {
		return 'ontouchstart' in window || !!(navigator.msMaxTouchPoints);
	}

	/**
	 * Checks wether touch is supported or not for IE.
	 * @private
	 * @returns {Boolean}
	 */
	function isTouchSupportIE() {
		return window.navigator.msPointerEnabled;
	}

	/**
	 * The jQuery Plugin for the Owl Carousel
	 * @public
	 */
	$.fn.owlCarousel = function(options) {
		return this.each(function() {
			if (!$(this).data('owlCarousel')) {
				$(this).data('owlCarousel', new Owl(this, options));
			}
		});
	};

	/**
	 * The constructor for the jQuery Plugin
	 * @public
	 */
	$.fn.owlCarousel.Constructor = Owl;

})(window.Zepto || window.jQuery, window, document);

;(function($, window, document, undefined) {

	/**
	 * Creates the lazy plugin.
	 * @class The Lazy Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Lazy = function(carousel) {

		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Already loaded items.
		 * @protected
		 * @type {Array.<jQuery>}
		 */
		this._loaded = [];

		/**
		 * Event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel change.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				if (!this._core.settings || !this._core.settings.lazyLoad) {
					return;
				}

				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
					var settings = this._core.settings,
						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
						i = ((settings.center && n * -1) || 0),
						position = ((e.property && e.property.value) || this._core.current()) + i,
						clones = this._core.clones().length,
						load = $.proxy(function(i, v) { this.load(v) }, this);

					while (i++ < n) {
						this.load(clones / 2 + this._core.relative(position));
						clones && $.each(this._core.clones(this._core.relative(position++)), load);
					}
				}
			}, this)
		};

		// set the default options
		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

		// register event handler
		this._core.$element.on(this._handlers);
	}

	/**
	 * Default options.
	 * @public
	 */
	Lazy.Defaults = {
		lazyLoad: false
	}

	/**
	 * Loads all resources of an item at the specified position.
	 * @param {Number} position - The absolute position of the item.
	 * @protected
	 */
	Lazy.prototype.load = function(position) {
		var $item = this._core.$stage.children().eq(position),
			$elements = $item && $item.find('.owl-lazy');

		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
			return;
		}

		$elements.each($.proxy(function(index, element) {
			var $element = $(element), image,
				url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src');

			this._core.trigger('load', { element: $element, url: url }, 'lazy');

			if ($element.is('img')) {
				$element.one('load.owl.lazy', $.proxy(function() {
					$element.css('opacity', 1);
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this)).attr('src', url);
			} else {
				image = new Image();
				image.onload = $.proxy(function() {
					$element.css({
						'background-image': 'url(' + url + ')',
						'opacity': '1'
					});
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this);
				image.src = url;
			}
		}, this));

		this._loaded.push($item.get(0));
	}

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Lazy.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this._core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	}

	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

})(window.Zepto || window.jQuery, window, document);

;(function($, window, document, undefined) {

	/**
	 * Creates the auto height plugin.
	 * @class The Auto Height Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoHeight = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function() {
				if (this._core.settings.autoHeight) {
					this.update();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (this._core.settings.autoHeight && e.property.name == 'position'){
					this.update();
				}
			}, this),
			'loaded.owl.lazy': $.proxy(function(e) {
				if (this._core.settings.autoHeight && e.element.closest('.' + this._core.settings.itemClass)
					=== this._core.$stage.children().eq(this._core.current())) {
					this.update();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	AutoHeight.Defaults = {
		autoHeight: false,
		autoHeightClass: 'owl-height'
	};

	/**
	 * Updates the view.
	 */
	AutoHeight.prototype.update = function() {
		this._core.$stage.parent()
			.height(this._core.$stage.children().eq(this._core.current()).height())
			.addClass(this._core.settings.autoHeightClass);
	};

	AutoHeight.prototype.destroy = function() {
		var handler, property;

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || window.jQuery, window, document);

;(function($, window, document, undefined) {

	/**
	 * Creates the video plugin.
	 * @class The Video Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Video = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Cache all video URLs.
		 * @protected
		 * @type {Object}
		 */
		this._videos = {};

		/**
		 * Current playing item.
		 * @protected
		 * @type {jQuery}
		 */
		this._playing = null;

		/**
		 * Whether this is in fullscreen or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._fullscreen = false;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'resize.owl.carousel': $.proxy(function(e) {
				if (this._core.settings.video && !this.isInFullScreen()) {
					e.preventDefault();
				}
			}, this),
			'refresh.owl.carousel changed.owl.carousel': $.proxy(function(e) {
				if (this._playing) {
					this.stop();
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				var $element = $(e.content).find('.owl-video');
				if ($element.length) {
					$element.css('display', 'none');
					this.fetch($element, $(e.content));
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Video.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);

		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
			this.play(e);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Video.Defaults = {
		video: false,
		videoHeight: false,
		videoWidth: false
	};

	/**
	 * Gets the video ID and the type (YouTube/Vimeo only).
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {jQuery} item - The item containing the video.
	 */
	Video.prototype.fetch = function(target, item) {

		var type = target.attr('data-vimeo-id') ? 'vimeo' : 'youtube',
			id = target.attr('data-vimeo-id') || target.attr('data-youtube-id'),
			width = target.attr('data-width') || this._core.settings.videoWidth,
			height = target.attr('data-height') || this._core.settings.videoHeight,
			url = target.attr('href');

		if (url) {
			id = url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

			if (id[3].indexOf('youtu') > -1) {
				type = 'youtube';
			} else if (id[3].indexOf('vimeo') > -1) {
				type = 'vimeo';
			} else {
				throw new Error('Video URL not supported.');
			}
			id = id[6];
		} else {
			throw new Error('Missing video URL.');
		}

		this._videos[url] = {
			type: type,
			id: id,
			width: width,
			height: height
		};

		item.attr('data-video', url);

		this.thumbnail(target, this._videos[url]);
	};

	/**
	 * Creates video thumbnail.
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {Object} info - The video info object.
	 * @see `fetch`
	 */
	Video.prototype.thumbnail = function(target, video) {

		var tnLink,
			icon,
			path,
			dimensions = video.width && video.height ? 'style="width:' + video.width + 'px;height:' + video.height + 'px;"' : '',
			customTn = target.find('img'),
			srcType = 'src',
			lazyClass = '',
			settings = this._core.settings,
			create = function(path) {
				icon = '<div class="owl-video-play-icon"></div>';

				if (settings.lazyLoad) {
					tnLink = '<div class="owl-video-tn ' + lazyClass + '" ' + srcType + '="' + path + '"></div>';
				} else {
					tnLink = '<div class="owl-video-tn" style="opacity:1;background-image:url(' + path + ')"></div>';
				}
				target.after(tnLink);
				target.after(icon);
			};

		// wrap video content into owl-video-wrapper div
		target.wrap('<div class="owl-video-wrapper"' + dimensions + '></div>');

		if (this._core.settings.lazyLoad) {
			srcType = 'data-src';
			lazyClass = 'owl-lazy';
		}

		// custom thumbnail
		if (customTn.length) {
			create(customTn.attr(srcType));
			customTn.remove();
			return false;
		}

		if (video.type === 'youtube') {
			path = "http://img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
			create(path);
		} else if (video.type === 'vimeo') {
			$.ajax({
				type: 'GET',
				url: 'http://vimeo.com/api/v2/video/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data[0].thumbnail_large;
					create(path);
				}
			});
		}
	};

	/**
	 * Stops the current video.
	 * @public
	 */
	Video.prototype.stop = function() {
		this._core.trigger('stop', null, 'video');
		this._playing.find('.owl-video-frame').remove();
		this._playing.removeClass('owl-video-playing');
		this._playing = null;
	};

	/**
	 * Starts the current video.
	 * @public
	 * @param {Event} ev - The event arguments.
	 */
	Video.prototype.play = function(ev) {
		this._core.trigger('play', null, 'video');

		if (this._playing) {
			this.stop();
		}

		var target = $(ev.target || ev.srcElement),
			item = target.closest('.' + this._core.settings.itemClass),
			video = this._videos[item.attr('data-video')],
			width = video.width || '100%',
			height = video.height || this._core.$stage.height(),
			html, wrap;

		if (video.type === 'youtube') {
			html = '<iframe width="' + width + '" height="' + height + '" src="http://www.youtube.com/embed/'
				+ video.id + '?autoplay=1&v=' + video.id + '" frameborder="0" allowfullscreen></iframe>';
		} else if (video.type === 'vimeo') {
			html = '<iframe src="http://player.vimeo.com/video/' + video.id + '?autoplay=1" width="' + width
				+ '" height="' + height
				+ '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
		}

		item.addClass('owl-video-playing');
		this._playing = item;

		wrap = $('<div style="height:' + height + 'px; width:' + width + 'px" class="owl-video-frame">'
			+ html + '</div>');
		target.after(wrap);
	};

	/**
	 * Checks whether an video is currently in full screen mode or not.
	 * @todo Bad style because looks like a readonly method but changes members.
	 * @protected
	 * @returns {Boolean}
	 */
	Video.prototype.isInFullScreen = function() {

		// if Vimeo Fullscreen mode
		var element = document.fullscreenElement || document.mozFullScreenElement
			|| document.webkitFullscreenElement;

		if (element && $(element).parent().hasClass('owl-video-frame')) {
			this._core.speed(0);
			this._fullscreen = true;
		}

		if (element && this._fullscreen && this._playing) {
			return false;
		}

		// comming back from fullscreen
		if (this._fullscreen) {
			this._fullscreen = false;
			return false;
		}

		// check full screen mode and window orientation
		if (this._playing) {
			if (this._core.state.orientation !== window.orientation) {
				this._core.state.orientation = window.orientation;
				return false;
			}
		}

		return true;
	};

	/**
	 * Destroys the plugin.
	 */
	Video.prototype.destroy = function() {
		var handler, property;

		this._core.$element.off('click.owl.video');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Video = Video;

})(window.Zepto || window.jQuery, window, document);

;(function($, window, document, undefined) {

	/**
	 * Creates the animate plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Animate = function(scope) {
		this.core = scope;
		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
		this.swapping = true;
		this.previous = undefined;
		this.next = undefined;

		this.handlers = {
			'change.owl.carousel': $.proxy(function(e) {
				if (e.property.name == 'position') {
					this.previous = this.core.current();
					this.next = e.property.value;
				}
			}, this),
			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
				this.swapping = e.type == 'translated';
			}, this),
			'translate.owl.carousel': $.proxy(function(e) {
				if (this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
					this.swap();
				}
			}, this)
		};

		this.core.$element.on(this.handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Animate.Defaults = {
		animateOut: false,
		animateIn: false
	};

	/**
	 * Toggles the animation classes whenever an translations starts.
	 * @protected
	 * @returns {Boolean|undefined}
	 */
	Animate.prototype.swap = function() {

		if (this.core.settings.items !== 1 || !this.core.support3d) {
			return;
		}

		this.core.speed(0);

		var left,
			clear = $.proxy(this.clear, this),
			previous = this.core.$stage.children().eq(this.previous),
			next = this.core.$stage.children().eq(this.next),
			incoming = this.core.settings.animateIn,
			outgoing = this.core.settings.animateOut;

		if (this.core.current() === this.previous) {
			return;
		}

		if (outgoing) {
			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
			previous.css( { 'left': left + 'px' } )
				.addClass('animated owl-animated-out')
				.addClass(outgoing)
				.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', clear);
		}

		if (incoming) {
			next.addClass('animated owl-animated-in')
				.addClass(incoming)
				.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', clear);
		}
	};

	Animate.prototype.clear = function(e) {
		$(e.target).css( { 'left': '' } )
			.removeClass('animated owl-animated-out owl-animated-in')
			.removeClass(this.core.settings.animateIn)
			.removeClass(this.core.settings.animateOut);
		this.core.transitionEnd();
	}

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Animate.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this.core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

})(window.Zepto || window.jQuery, window, document);

;(function($, window, document, undefined) {

	/**
	 * Creates the autoplay plugin.
	 * @class The Autoplay Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Autoplay = function(scope) {
		this.core = scope;
		this.core.options = $.extend({}, Autoplay.Defaults, this.core.options);

		this.handlers = {
			'translated.owl.carousel refreshed.owl.carousel': $.proxy(function() {
				this.autoplay();
			}, this),
			'play.owl.autoplay': $.proxy(function(e, t, s) {
				this.play(t, s);
			}, this),
			'stop.owl.autoplay': $.proxy(function() {
				this.stop();
			}, this),
			'mouseover.owl.autoplay': $.proxy(function() {
				if (this.core.settings.autoplayHoverPause) {
					this.pause();
				}
			}, this),
			'mouseleave.owl.autoplay': $.proxy(function() {
				if (this.core.settings.autoplayHoverPause) {
					this.autoplay();
				}
			}, this)
		};

		this.core.$element.on(this.handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Autoplay.Defaults = {
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		autoplaySpeed: false
	};

	/**
	 * @protected
	 * @todo Must be documented.
	 */
	Autoplay.prototype.autoplay = function() {
		if (this.core.settings.autoplay && !this.core.state.videoPlay) {
			window.clearInterval(this.interval);

			this.interval = window.setInterval($.proxy(function() {
				this.play();
			}, this), this.core.settings.autoplayTimeout);
		} else {
			window.clearInterval(this.interval);
		}
	};

	/**
	 * Starts the autoplay.
	 * @public
	 * @param {Number} [timeout] - ...
	 * @param {Number} [speed] - ...
	 * @returns {Boolean|undefined} - ...
	 * @todo Must be documented.
	 */
	Autoplay.prototype.play = function(timeout, speed) {
		// if tab is inactive - doesnt work in <IE10
		if (document.hidden === true) {
			return;
		}

		if (this.core.state.isTouch || this.core.state.isScrolling
			|| this.core.state.isSwiping || this.core.state.inMotion) {
			return;
		}

		if (this.core.settings.autoplay === false) {
			window.clearInterval(this.interval);
			return;
		}

		this.core.next(this.core.settings.autoplaySpeed);
	};

	/**
	 * Stops the autoplay.
	 * @public
	 */
	Autoplay.prototype.stop = function() {
		window.clearInterval(this.interval);
	};

	/**
	 * Pauses the autoplay.
	 * @public
	 */
	Autoplay.prototype.pause = function() {
		window.clearInterval(this.interval);
	};

	/**
	 * Destroys the plugin.
	 */
	Autoplay.prototype.destroy = function() {
		var handler, property;

		window.clearInterval(this.interval);

		for (handler in this.handlers) {
			this.core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

})(window.Zepto || window.jQuery, window, document);

;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the navigation plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} carousel - The Owl Carousel.
	 */
	var Navigation = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Indicates whether the plugin is initialized or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._initialized = false;

		/**
		 * The current paging indexes.
		 * @protected
		 * @type {Array}
		 */
		this._pages = [];

		/**
		 * All DOM elements of the user interface.
		 * @protected
		 * @type {Object}
		 */
		this._controls = {};

		/**
		 * Markup for an indicator.
		 * @protected
		 * @type {Array.<String>}
		 */
		this._templates = [];

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * Overridden methods of the carousel.
		 * @protected
		 * @type {Object}
		 */
		this._overrides = {
			next: this._core.next,
			prev: this._core.prev,
			to: this._core.to
		};

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'prepared.owl.carousel': $.proxy(function(e) {
				if (this._core.settings.dotsData) {
					this._templates.push($(e.content).find('[data-dot]').andSelf('[data-dot]').attr('data-dot'));
				}
			}, this),
			'add.owl.carousel': $.proxy(function(e) {
				if (this._core.settings.dotsData) {
					this._templates.splice(e.position, 0, $(e.content).find('[data-dot]').andSelf('[data-dot]').attr('data-dot'));
				}
			}, this),
			'remove.owl.carousel prepared.owl.carousel': $.proxy(function(e) {
				if (this._core.settings.dotsData) {
					this._templates.splice(e.position, 1);
				}
			}, this),
			'change.owl.carousel': $.proxy(function(e) {
				if (e.property.name == 'position') {
					if (!this._core.state.revert && !this._core.settings.loop && this._core.settings.navRewind) {
						var current = this._core.current(),
							maximum = this._core.maximum(),
							minimum = this._core.minimum();
						e.data = e.property.value > maximum
							? current >= maximum ? minimum : maximum
							: e.property.value < minimum ? maximum : e.property.value;
					}
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.property.name == 'position') {
					this.draw();
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function() {
				if (!this._initialized) {
					this.initialize();
					this._initialized = true;
				}
				this._core.trigger('refresh', null, 'navigation');
				this.update();
				this.draw();
				this._core.trigger('refreshed', null, 'navigation');
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

		// register event handlers
		this.$element.on(this._handlers);
	}

	/**
	 * Default options.
	 * @public
	 * @todo Rename `slideBy` to `navBy`
	 */
	Navigation.Defaults = {
		nav: false,
		navRewind: true,
		navText: [ 'prev', 'next' ],
		navSpeed: false,
		navElement: 'div',
		navContainer: false,
		navContainerClass: 'owl-nav',
		navClass: [ 'owl-prev', 'owl-next' ],
		slideBy: 1,
		dotClass: 'owl-dot',
		dotsClass: 'owl-dots',
		dots: true,
		dotsEach: false,
		dotData: false,
		dotsSpeed: false,
		dotsContainer: false,
		controlsClass: 'owl-controls'
	}

	/**
	 * Initializes the layout of the plugin and extends the carousel.
	 * @protected
	 */
	Navigation.prototype.initialize = function() {
		var $container, override,
			options = this._core.settings;

		// create the indicator template
		if (!options.dotsData) {
			this._templates = [ $('<div>')
				.addClass(options.dotClass)
				.append($('<span>'))
				.prop('outerHTML') ];
		}

		// create controls container if needed
		if (!options.navContainer || !options.dotsContainer) {
			this._controls.$container = $('<div>')
				.addClass(options.controlsClass)
				.appendTo(this.$element);
		}

		// create DOM structure for absolute navigation
		this._controls.$indicators = options.dotsContainer ? $(options.dotsContainer)
			: $('<div>').hide().addClass(options.dotsClass).appendTo(this._controls.$container);

		this._controls.$indicators.on('click', 'div', $.proxy(function(e) {
			var index = $(e.target).parent().is(this._controls.$indicators)
				? $(e.target).index() : $(e.target).parent().index();

			e.preventDefault();

			this.to(index, options.dotsSpeed);
		}, this));

		// create DOM structure for relative navigation
		$container = options.navContainer ? $(options.navContainer)
			: $('<div>').addClass(options.navContainerClass).prependTo(this._controls.$container);

		this._controls.$next = $('<' + options.navElement + '>');
		this._controls.$previous = this._controls.$next.clone();

		this._controls.$previous
			.addClass(options.navClass[0])
			.html(options.navText[0])
			.hide()
			.prependTo($container)
			.on('click', $.proxy(function(e) {
				this.prev(options.navSpeed);
			}, this));
		this._controls.$next
			.addClass(options.navClass[1])
			.html(options.navText[1])
			.hide()
			.appendTo($container)
			.on('click', $.proxy(function(e) {
				this.next(options.navSpeed);
			}, this));

		// override public methods of the carousel
		for (override in this._overrides) {
			this._core[override] = $.proxy(this[override], this);
		}
	}

	/**
	 * Destroys the plugin.
	 * @protected
	 */
	Navigation.prototype.destroy = function() {
		var handler, control, property, override;

		for (handler in this._handlers) {
			this.$element.off(handler, this._handlers[handler]);
		}
		for (control in this._controls) {
			this._controls[control].remove();
		}
		for (override in this.overides) {
			this._core[override] = this._overrides[override];
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	}

	/**
	 * Updates the internal state.
	 * @protected
	 */
	Navigation.prototype.update = function() {
		var i, j, k,
			options = this._core.settings,
			lower = this._core.clones().length / 2,
			upper = lower + this._core.items().length,
			size = options.center || options.autoWidth || options.dotData
				? 1 : options.dotsEach || options.items;

		if (options.slideBy !== 'page') {
			options.slideBy = Math.min(options.slideBy, options.items);
		}

		if (options.dots || options.slideBy == 'page') {
			this._pages = [];

			for (i = lower, j = 0, k = 0; i < upper; i++) {
				if (j >= size || j === 0) {
					this._pages.push({
						start: i - lower,
						end: i - lower + size - 1
					});
					j = 0, ++k;
				}
				j += this._core.mergers(this._core.relative(i));
			}
		}
	}

	/**
	 * Draws the user interface.
	 * @todo The option `dotData` wont work.
	 * @protected
	 */
	Navigation.prototype.draw = function() {
		var difference, i, html = '',
			options = this._core.settings,
			$items = this._core.$stage.children(),
			index = this._core.relative(this._core.current());

		if (options.nav && !options.loop && !options.navRewind) {
			this._controls.$previous.toggleClass('disabled', index <= 0);
			this._controls.$next.toggleClass('disabled', index >= this._core.maximum());
		}

		this._controls.$previous.toggle(options.nav);
		this._controls.$next.toggle(options.nav);

		if (options.dots) {
			difference = this._pages.length - this._controls.$indicators.children().length;

			if (options.dotData && difference !== 0) {
				for (i = 0; i < this._controls.$indicators.children().length; i++) {
					html += this._templates[this._core.relative(i)];
				}
				this._controls.$indicators.html(html);
			} else if (difference > 0) {
				html = new Array(difference + 1).join(this._templates[0]);
				this._controls.$indicators.append(html);
			} else if (difference < 0) {
				this._controls.$indicators.children().slice(difference).remove();
			}

			this._controls.$indicators.find('.active').removeClass('active');
			this._controls.$indicators.children().eq($.inArray(this.current(), this._pages)).addClass('active');
		}

		this._controls.$indicators.toggle(options.dots);
	}

	/**
	 * Extends event data.
	 * @protected
	 * @param {Event} event - The event object which gets thrown.
	 */
	Navigation.prototype.onTrigger = function(event) {
		var settings = this._core.settings;

		event.page = {
			index: $.inArray(this.current(), this._pages),
			count: this._pages.length,
			size: settings && (settings.center || settings.autoWidth || settings.dotData
				? 1 : settings.dotsEach || settings.items)
		};
	}

	/**
	 * Gets the current page position of the carousel.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.current = function() {
		var index = this._core.relative(this._core.current());
		return $.grep(this._pages, function(o) {
			return o.start <= index && o.end >= index;
		}).pop();
	}

	/**
	 * Gets the current succesor/predecessor position.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.getPosition = function(successor) {
		var position, length,
			options = this._core.settings;

		if (options.slideBy == 'page') {
			position = $.inArray(this.current(), this._pages);
			length = this._pages.length;
			successor ? ++position : --position;
			position = this._pages[((position % length) + length) % length].start;
		} else {
			position = this._core.relative(this._core.current());
			length = this._core.items().length;
			successor ? position += options.slideBy : position -= options.slideBy;
		}
		return position;
	}

	/**
	 * Slides to the next item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.next = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
	}

	/**
	 * Slides to the previous item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.prev = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
	}

	/**
	 * Slides to the specified item or page.
	 * @public
	 * @param {Number} position - The position of the item or page.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
	 */
	Navigation.prototype.to = function(position, speed, standard) {
		var length;

		if (!standard) {
			length = this._pages.length;
			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
		} else {
			$.proxy(this._overrides.to, this._core)(position, speed);
		}
	}

	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

})(window.Zepto || window.jQuery, window, document);

;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the hash plugin.
	 * @class The Hash Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Hash = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Hash table for the hashes.
		 * @protected
		 * @type {Object}
		 */
		this._hashes = {};

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function() {
				if (this._core.settings.startPosition == 'URLHash') {
					$(window).trigger('hashchange.owl.navigation');
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				var hash = $(e.content).find('[data-hash]').andSelf('[data-hash]').attr('data-hash');
				this._hashes[hash] = e.content;
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Hash.Defaults, this._core.options);

		// register the event handlers
		this.$element.on(this._handlers);

		// register event listener for hash navigation
		$(window).on('hashchange.owl.navigation', $.proxy(function() {
			var hash = window.location.hash.substring(1),
				items = this._core.$stage.children(),
				position = this._hashes[hash] && items.index(this._hashes[hash]) || 0;

			if (!hash) {
				return false;
			}

			this._core.to(position, false, true);
		}, this));
	}

	/**
	 * Default options.
	 * @public
	 */
	Hash.Defaults = {
		URLhashListener: false
	}

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Hash.prototype.destroy = function() {
		var handler, property;

		$(window).off('hashchange.owl.navigation');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	}

	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

})(window.Zepto || window.jQuery, window, document);

},{}],27:[function(require,module,exports){

(function ($, window, document, undefined) {
    'use strict';

    /**
     * Creates the thumbs plugin.
     * @class The thumbs Plugin
     * @param {Owl} carousel - The Owl Carousel
     */
    var Thumbs = function (carousel) {


        /**
         * Reference to the core.
         * @protected
         * @type {Owl}
         */
        this.owl = carousel;


        /**
         * All DOM elements for thumbnails
         * @protected
         * @type {Object}
         */
        this._thumbcontent = [];


        /**
         * Instance identiefier
         * @type {number}
         * @private
         */
        this._identifier = 0;


        /**
         * Return current item regardless of clones
         * @protected
         * @type {Object}
         */
        this.owl_currentitem = this.owl.options.startPosition;


        /**
         * The carousel element.
         * @type {jQuery}
         */
        this.$element = this.owl.$element;


        /**
         * All event handlers.
         * @protected
         * @type {Object}
         */
        this._handlers = {
            'prepared.owl.carousel': $.proxy(function (e) {
                if (e.namespace && this.owl.options.thumbs && !this.owl.options.thumbImage && !this.owl.options.thumbsPrerendered && !this.owl.options.thumbImage) {
                    if ($(e.content).find('[data-thumb]').attr('data-thumb') !== undefined) {
                        this._thumbcontent.push($(e.content).find('[data-thumb]').attr('data-thumb'));
                    }
                } else if (e.namespace && this.owl.options.thumbs && this.owl.options.thumbImage) {
                    var innerImage = $(e.content).find('img');
                    this._thumbcontent.push(innerImage);
                }
            }, this),

            'initialized.owl.carousel': $.proxy(function (e) {
                if (e.namespace && this.owl.options.thumbs) {
                    this.render();
                    this.listen();
                    this._identifier = this.owl.$element.data('slider-id');
                    this.setActive();
                }
            }, this),

            'changed.owl.carousel': $.proxy(function (e) {
                if (e.namespace && e.property.name === 'position' && this.owl.options.thumbs) {
                    this._identifier = this.owl.$element.data('slider-id');
                    this.setActive();
                }
            }, this)
        };

        // set default options
        this.owl.options = $.extend({}, Thumbs.Defaults, this.owl.options);

        // register the event handlers
        this.owl.$element.on(this._handlers);
    };


    /**
     * Default options.
     * @public
     */
    Thumbs.Defaults = {
        thumbs: true,
        thumbImage: false,
        thumbContainerClass: 'owl-thumbs',
        thumbItemClass: 'owl-thumb-item',
        moveThumbsInside: false
    };


    /**
     * Listen for thumbnail click
     * @protected
     */
    Thumbs.prototype.listen = function () {

        //set default options
        var options = this.owl.options;

        if (options.thumbsPrerendered) {
            this._thumbcontent._thumbcontainer = $('.' + options.thumbContainerClass);
        }

        //check what thumbitem has been clicked and move slider to that item
        $(this._thumbcontent._thumbcontainer).on('click', this._thumbcontent._thumbcontainer.children(), $.proxy(function (e) {

            // find relative slider
            this._identifier = $(e.target).closest('.' + options.thumbContainerClass).data('slider-id');

            // get index of clicked thumbnail
            var index = $(e.target).parent().is(this._thumbcontent._thumbcontainer) ? $(e.target).index() : $(e.target).closest('.'+options.thumbItemClass).index();

            if (options.thumbsPrerendered) {
                // slide to slide :)
                $('[data-slider-id=' + this._identifier + ']').trigger('to.owl.carousel', [index, options.dotsSpeed, true]);
            } else {
                this.owl.to(index, options.dotsSpeed);
            }

            e.preventDefault();
        }, this));
    };


    /**
     * Builds thumbnails
     * @protected
     */
    Thumbs.prototype.render = function () {

        //set default options
        var options = this.owl.options;

        //create thumbcontainer
        if (!options.thumbsPrerendered) {
            this._thumbcontent._thumbcontainer = $('<div>').addClass(options.thumbContainerClass).appendTo(this.$element);
        } else {
            this._thumbcontent._thumbcontainer = $('.' + options.thumbContainerClass + '');
            if(options.moveThumbsInside){
                this._thumbcontent._thumbcontainer.appendTo(this.$element);
            }
        }

        //create thumb items
        var i;
        if (!options.thumbImage) {
            for (i = 0; i < this._thumbcontent.length; ++i) {
                this._thumbcontent._thumbcontainer.append('<button class=' + options.thumbItemClass + '>' + this._thumbcontent[i] + '</button>');
            }
        } else {
            for (i = 0; i < this._thumbcontent.length; ++i) {
                this._thumbcontent._thumbcontainer.append('<button class=' + options.thumbItemClass + '><img src= "' + this._thumbcontent[i].attr('src') + '" height="' + this._thumbcontent[i].attr('height') +'" width="' + this._thumbcontent[i].attr('width') +'" class="' + this._thumbcontent[i].attr('class') + '" alt="' + this._thumbcontent[i].attr('alt') + '" /></button>');
            }
        }
    };


    /**
     * Updates active class on thumbnails
     * @protected
     */
    Thumbs.prototype.setActive = function () {

        // get startslide
        this.owl_currentitem = this.owl._current - (this.owl._clones.length / 2);
        if (this.owl_currentitem === this.owl._items.length) {
            this.owl_currentitem = 0;
        }

        //set default options
        var options = this.owl.options;

        // set relative thumbnail container
        var thumbContainer = options.thumbsPrerendered ? $('.' + options.thumbContainerClass + '[data-slider-id="' + this._identifier + '"]') : this._thumbcontent._thumbcontainer;
        thumbContainer.children().filter('.active').removeClass('active');
        thumbContainer.children().eq(this.owl_currentitem).addClass('active');
        thumbContainer.children().eq(this.owl_currentitem).trigger("focus");
    };


    /**
     * Destroys the plugin.
     * @public
     */
    Thumbs.prototype.destroy = function () {
        var handler, property;
        for (handler in this._handlers) {
            this.owl.$element.off(handler, this._handlers[handler]);
        }
        for (property in Object.getOwnPropertyNames(this)) {
            typeof this[property] !== 'function' && (this[property] = null);
        }
    };

    $.fn.owlCarousel.Constructor.Plugins.Thumbs = Thumbs;

})(window.Zepto || window.jQuery, window, document);
},{}],28:[function(require,module,exports){
'use strict';
var ajax = require('./ajax');
var util = require('./util');
var dialog = require('./dialog');
var validator = require('./validator');
var page = {
		title: '',
		type: '',
		params: util.getQueryStringParams(window.location.search.substr(1)),
		redirect: function (newURL) {
			setTimeout(function () {
				window.location.href = newURL;
			}, 0);
		},
		refresh: function () {
			setTimeout(function () {
				window.location.assign(window.location.href);
			}, 500);
		}
};

module.exports = page;
module.exports = page;
var mywindow = $(window);
var header = $('.top-banner').scrollTop();
var mypos = mywindow.scrollTop();
var up = false;
var is_iPad = navigator.userAgent.match(/iPad/i);
var newscroll;
mywindow.scroll(function () {
	if(util.isMobile()) {
		if($(window).width()< 812){
			$(".header-banner").css({"display":"none"});
		}
	}
	newscroll = mywindow.scrollTop();
if (!$('body').hasClass('LeviKR')) {
	if (newscroll > mypos && !up) {

		$('.header-banner').stop().slideToggle(400,'linear');

		if(is_iPad != null) {
			$(".header-banner").css({"display":"none"});
			if($(window).width()==768) {
				$('.top-banner').css("margin-top","-46px");
				if ($('body').hasClass('LeviIN')) {
					$('.top-banner').css("margin-top","-33px");
				}
			}
			else {
				$('.top-banner').css("margin-top","-33px"); 
			}
		}
		else if(util.isMobile()) {

			if($(window).width()< 812){
				$(".header-banner").css({"display":"none"});
			}
			if($('body.LeviJP').find('#smartbanner').css('display') == "block"){
				$('#wrapper').css({"margin-top":$('#smartbanner').height() + 8});
			}else{
				if ($('body').hasClass('LeviIN')) {	
					$('.top-banner').css("margin-top","-3%");	
				}else{	
				$('.top-banner').css("margin-top","-1%");	
				}
			if ($('body').hasClass('LeviAU')) {
				$('.top-banner').css("margin-top","-3%");
			}else if ($('body').hasClass('LeviIN')) {	
				$('.top-banner').css("margin-top","-3%");
			}
			}
		}
		else {
			$('.top-banner').css("margin-top","-33px");
		}
		up = !up;
	} 
	else if(newscroll ==header && up) {

		$('.header-banner').stop().slideToggle(100,'linear');

		if(is_iPad != null) {
			$(".header-banner").css({"display":"block"});
			if($(window).width()==768) {
				$('.top-banner').css("margin-top","-13px");
				if ($('body').hasClass('LeviIN')) {
					$('.top-banner').css("margin-top","0px");
				}
			}
			else {
				$('.top-banner').css("margin-top","0px"); 
			}
		}
		else if(util.isMobile()) {
			
			if($(window).width()< 812){
				$(".header-banner").css({"display":"none"});
			}
			if($('body.LeviJP').find('#smartbanner').css('display') == "block"){
				$('#wrapper').css({"margin-top":$('#smartbanner').height() + 8});
			}else{
				
				$('.top-banner').css("margin-top","-1%");
				
				if ($('body').hasClass('LeviAU')) {
					$('.top-banner').css("margin-top","-3%");
				}else if ($('body').hasClass('LeviIN')) {	
					$('.top-banner').css("margin-top","-1.6%");
				}
			}
		}
		else {
			$('.top-banner').css("margin-top","0px");
		}

		up = !up;
	}
	mypos = newscroll;
}
});
//search box mobile expansion 
$( document ).ready(function() {
	if($(window).width() == 768) {	
		if ($('body').hasClass('LeviIN')) {	
			$('.top-banner').css("margin-top","-1.6%");	
		}	
	}
	if($(window).width() <= 768) {	
		if ($('body').hasClass('LeviIN')) {	
			$('.user-info .customer-name-mobile').on('click tap', function() {
				$('.user-info .user-panel').toggleClass("show");
				return false;
			});
		}
	}
	if($('#refresh').val() == 'no' ){
		window.history.pushState(null, "", window.location.href);        
		window.onpopstate = function() {
			window.history.pushState(null, "", window.location.href);
		};
	} 

	$("#header-mobile-search-icon").click(function(){
		$(this).css({"display":"none"});
		$(".header-search").css({"display":"block"});
		if (util.isMobile()  && $('body').hasClass('LeviKR')) {
			$('.plp-promo-category').css('display','none');
		}
		$("#header-mobile-close-icon").css({"display":"block"});
		$(".primary-logo").css({"display":"none"});
		$(".menu-toggle").css({"display":"none"});
		$("#mini-cart").css({"display":"none"});
		var is_iPad = navigator.userAgent.match(/iPad/i);
		if (util.isMobile()  && is_iPad == null) {
			$('#wrapper').css('position','relative');
		}
	});
	$("#header-mobile-close-icon").click(function(){
		$(".header-search").css({"display":"none"});
		$(this).css({"display":"none"});
		$(".primary-logo").css({"display":"block"});
		$(".menu-toggle").css({"display":"block"});
		$("#mini-cart").css({"display":"block"});
		$("#header-mobile-search-icon").css({"display":"block"});
		$(".header-search input").val('');
		var is_iPad = navigator.userAgent.match(/iPad/i);
		if (util.isMobile()&&is_iPad == null) {
			$('#wrapper').css('position','relative');
		}
	});


	$('[name$="home-email"]').click(function(e){
		e.preventDefault();
		$('div.newsletter-success').html('').hide();
		var $form = $('.email-alert-signup');
		if (!$form.valid()) {
			return false;
		}

		var email = $('[name$="_footernewsletter_newsletterEmail"]').val();
		var newsletterCheckbox = $('[name$="_footernewsletter_newsletterTermsAndConditions"]').is(":checked");
		var data = null, preference = null,phone= null,firstName=null;
		var siteID = $('[name$="footernewsletter.siteID"]').val();
		var addToEmailList = $('[name$="footernewsletter.addToEmailList"]').val();
		preference = $('[name$="_footernewsletter_preference"]').val();
		if( $('body').hasClass('LeviAU') ){
		firstName= $('[name$="_footernewsletter_firstName"]').val();
		}
		if( $('body').hasClass('LeviIN') ){
			firstName= $('[name$="_footernewsletter_firstName"]').val();
			phone = $('[name$="_footernewsletter_phoneMobile"]').val();
		}
		var finalUrl =  Urls.newsletterSubscription;
		
		if ($('body').hasClass('LeviAU')){ 
			data = {'email':email ,'newsletterCheckbox':newsletterCheckbox ,'preference':preference,'siteID':siteID,'addToEmailList':addToEmailList,'firstName':firstName, 'format' : 'ajax'}
		}else if($('body').hasClass('LeviKR') ){
			data = {'email':email ,'newsletterCheckbox':newsletterCheckbox ,'preference':preference,'siteID':siteID,'addToEmailList':addToEmailList,'format' : 'ajax'}
		}else if( $('body').hasClass('LeviIN') ){
			data = {'email':email ,'newsletterCheckbox':newsletterCheckbox ,'preference':preference,'siteID':siteID,'addToEmailList':addToEmailList,'phone':phone,'firstName':firstName,'format' : 'ajax'}
		}
		else{
			data = {'email':email ,'newsletterCheckbox':newsletterCheckbox ,'siteID':siteID,'addToEmailList':addToEmailList,'format' : 'ajax'};
		}

		//Start- GA4 Event
		var headingText = $(e.target).closest('.footer-item').find('.heading1').text();
        $('body').trigger('analytics:newsletterSubscriptionEvent', { 
			emailValue :email, 
			buttonText : $(e.target).text(), 
			headingText : headingText
		});
        //End- GA4 Event

		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: finalUrl,
			data: data,
			success: function (response) {
				if(JSON.parse(response).success== false) {
					$(".newsletter-success").css('display','none');
					if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')) {
						$("#newsletter-already-registered-email-error").css('display','block');
						$(".footer-item:nth-child(1)").css('padding-bottom',"3%");
						$("#newsletter-already-registered-email-error").html(Resources.NEWSLETTER_FOOTER_REGISTERED_EMAIL);
					}
					else if ($('body').hasClass('LeviKR')) {
						$(".newsletter-email-error").css('display','block');
						$(".footer-item:nth-child(1)").css('padding',"1% 0 3.5% 0");
						$(".newsletter-email-error").html(Resources.NEWSLETTER_FOOTER_REGISTERED_EMAIL);
					}

				}
				else if (JSON.parse(response).success == true)
				{
					if($("#isGTMEnabled").val() == 'true')
					{
						gtmSubscriptionData();
					}
					if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')) {
						// $(".newsletter-success").css('display','block');
						$("#newsletter-already-registered-email-error").css('display','none');
						$(".newsletter-success").html(Resources.NEWSLETTER_FOOTER_SUCCESS);
						$('.newsletter-success').fadeIn(10).delay(3000).fadeOut(); 

						$(".footer-item:nth-child(1)").css('padding-bottom',"2%");

						$('[name$="_footernewsletter_newsletterEmail"]').val("");
						$('[name$="_footernewsletter_phoneMobile"]').val("");
						$('[name$="_footernewsletter_newsletterTermsAndConditions"]').prop('checked',false);
						$('[name$="_footernewsletter_preference"]').val('Men').myselectmenu('refresh');
						$('[name$="_footernewsletter_firstName"]').val("");
					}
					else if ($('body').hasClass('LeviKR')) {
						$(".newsletter-success").css('display','block');
						$(".newsletter-email-error").css('display','none');
						$(".newsletter-success").html(Resources.NEWSLETTER_FOOTER_SUCCESS);
					}
					if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
						window.dataLayer = window.dataLayer || [];
						dataLayer.push({
							event: "customEvent",
							eventCategory: "newslettersignedup",
							eventAction: window.pageName,
							eventLabel: window.pageName
						});
					}
					
				}
			}, 
			error: function(json) {
				$(".newsletter-success").html(Resources.NEWSLETTER_FOOTER_TECHNICAL);
			}
		});
	});

	$('[name$="_footernewsletter_newsletterTermsAndConditions"]').on('change', function (e) {
		$(".newsletter-success").css('display','none');
		$(".newsletter-email-error").css('display','none');
		if ($('body').hasClass('LeviAU')) {
			$(".footer-item:nth-child(1)").css('padding-bottom',"3%");
		}
		else if ($('body').hasClass('LeviKR')) {
			$(".footer-item:nth-child(1)").css('padding',"1% 0 2.4% 0");
		}

	});

	$('[name$="_footernewsletter_newsletterEmail"]').on('change', function (e) {
		$(".newsletter-success").css('display','none');
		$(".newsletter-email-error").css('display','none');

		if ($('body').hasClass('LeviAU')) {
			$(".footer-item:nth-child(1)").css('padding-bottom',"3%");
		}
		else if ($('body').hasClass('LeviKR')) {
			$(".footer-item:nth-child(1)").css('padding',"1% 0 1.5% 0");
		}

	});

	$(".sign-in-hover").hover(function(e){
		$(this).find('.user-info').toggleClass('active');
	});

	$('.track-order-popup').on('click', function (e) {
		e.preventDefault();

		dialog.open({
			url: $(e.target).attr('href'),
			options: {
				dialogClass: "track-order-popup-window",
				open: function () {

					var $orderTrackForm = $('[id$="_ordertrack"]');
					validator.init();

					$('.track-from-header').on('click', function (e) {

						if (!$orderTrackForm.valid()) {
							e.preventDefault();
							return;
						}


					});

					$('.track-order-popup-window').on('click', '.close-track-order-button', function(e) {
						e.preventDefault();
						$($orderTrackForm).find('.input-text').removeClass("error");
						$($orderTrackForm).find('.error').hide();
						dialog.close();
					});

				}
			}

		});
		$('.track-order-popup-window').on("keyup keypress", function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				return false;
			}
		});
	});

	$(document).on('click', '.offer-details-link', function (e) {
		e.preventDefault();
		var $elem = null;
		if ($(this).hasClass('subsale')) {
			$elem = $(this).find('div.offerdetails');
		}
		else {
			$elem = $(this).closest('.subsale').find('div.offerdetails');
		}
		$(".jsHidden").html($elem.html());
		dialog.open({
			html: $(".jsHidden").html(),
			options: {	
				dialogClass:"header-promo-offer",
				width: 600,
				open: function() {
					$('.header-promo-offer').on('click', '.close-button , .close-popup-button', function(e) {
						dialog.close();
						$('#dialog-container').animate({scrollTop:0},0); 
					});
				}
			},
			callback: function() {
				$('.header-promo-offer').find('.ui-dialog-buttonpane').remove();
				$('.ui-dialog-titlebar').remove();
			}
		});
	});
	$(document).on('click', '.category-promo-details', function (e) {
		e.preventDefault();
		dialog.open({
			html: $(".promo-category").html(),
			options: {	
				dialogClass:"plp-promo-category",
				width: 600,
				open: function() {
					$('.plp-promo-category').on('click', '.close-button , .close-popup-button', function(e) {
						dialog.close();
						$('#dialog-container').animate({scrollTop:0},0); 
					});
				}
			},
			callback: function() {
				$('.plp-promo-category').find('.ui-dialog-buttonpane').remove();
				$('.ui-dialog-titlebar').remove();
			}
		});
	});
	$(".category-promo-details").click();
});

},{"./ajax":7,"./dialog":18,"./util":67,"./validator":68}],29:[function(require,module,exports){
'use strict';

var giftcert = require('../giftcert'),
tooltip = require('../tooltip'),
util = require('../util'),
dialog = require('../dialog'),
page = require('../page'),
login = require('../login'),
validator = require('../validator'),
adyenCheckout = require('../adyen-checkout');

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */

function toggleFullOrder () {
	$('.order-items')
	.find('li.hidden:first')
	.prev('li')
	.append('<a class="toggle">View All</a>')
	.children('.toggle')
	.click(function () {
		$(this).parent().siblings('li.hidden').show();
		$(this).remove();
	});
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {

	$('#findaddress').on('click', function (e) {
		e.preventDefault();
		koreaZipCodeValidation();
	});


}
/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */


function initializePaymentForm() {
	$('#CreditCardForm').on('click', '.cancel-button', function (e) {
		e.preventDefault();
		dialog.close();
	});
	if (SitePreferences.ADYEN_SF_ENABLED)  {
		adyenCheckout.initAccount();
	 }
}

function disablecreatebutton() {

	if($('body.LeviAU').length > 0 || $('body.LeviIN').length > 0)
	{
		if($(".postal").val()==""){
			$('.apply-button').prop('disabled', false);    	
		}
	}
	else
	{
		if($(".postal").val()==""){
			$('.apply-button').prop('disabled', true);   	
		} 
	}
	$( ".postal" ).change(function() {
		$('.apply-button').prop('disabled', false);
	});
	if($('body.LeviJP'))
		{
		$('.apply-button').prop('disabled', false);		
		}
}

function changePassword() {
	$('.primary-content').on('keypress focusout', '.password', function(e) {
		if ($(this).closest('.form-row').find('.form-caption').hasClass('error-message')) {
			$(".form-caption").removeClass('error-message').text('');
		}
	}); 
}
function editProfile() {
	$('.edit-profile input#dwfrm_profile_customer_termsandconditions').attr('checked', 'checked');
	$(".edit-profile input#dwfrm_profile_customer_termsandconditions").attr('disabled','disabled');	
}

function koreaZipCodeValidation() {
	
	var element_wrap = $('#wrap');   
//http://postcode.map.daum.net/guide
new daum.Postcode({
       oncomplete: function(data) {  

              var fullRoadAddr = data.roadAddress;  
              var extraRoadAddr = ''; 


              if(data.bname !== '' ){
                    extraRoadAddr += data.bname; 
              }

              if(data.buildingName !== '' && data.apartment === 'Y'){
                    extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName);
              }

              if(extraRoadAddr !== ''){
                    extraRoadAddr = ' (' + extraRoadAddr + ')';
              }

              if(fullRoadAddr !== ''){
                    fullRoadAddr += extraRoadAddr;
              }  

              $( "input[name$='_postal']" ).val( data.zonecode );
              $( "input[name$='_address1']" ).val( fullRoadAddr );

              $( "input[name$='_postal']" ).change();
              $( "input[name$='_address1']" ).change();

              $("input[id$=_postal]").next("span.error").remove();
              $("input[id$=_address1]").next("span.error").remove();

              $("input[id$=_postal]").removeClass('error');
              $("input[id$=_address1]").removeClass('error');
          	
   }
}).embed(element_wrap);  
	$('.btnFoldWrap').clone(true).appendTo('div[id*=daum__layer]');
	
	if(util.isMobile()){
		$('div[id*=daum__layer]').css('top', $('#findaddress').offset().top - 150);
	}else {
		$('div[id*=daum__layer]').css('top', $('#findaddress').offset().top - 100);
	}
}


function initChangePasswordValidation() {

	$("input[name*='newpasswordconfirm']").on('focusout', function(e) {
		e.preventDefault();

		$(this).closest('.field-wrapper').find('.errspan').remove();

		var pass = $("input[name*='newpassword']").val(),
		passConf = $("input[name*='newpasswordconfirm']").val();

		if (passConf.length >= 8) {

			if (pass != passConf) {
				var errSpan = document.createElement('span');
				errSpan.innerHTML = Resources.VALIDATE_PASSWORD;
				errSpan.className += "errspan error";
				$(this).closest('.field-wrapper').append(errSpan);
				return;
			}

			else {
				$(this).closest('.field-wrapper').find('.errspan').remove();
			}
		}
	});

	$('[name$="_changepassword"]').on('click', function(e) {
		if ($('#ChangePassowrdForm').find('.errspan.error').is(':visible')) {
			e.preventDefault();
			return;
		};
	});


}

$('[name$="_address_create"],[name$="_address_edit"],[name$="dwfrm_login_register"]').on('click', function(e) {
	//e.preventDefault();
	
	if($('body.LeviAU').length > 0 || $('body.LeviIN').length > 0 || $('body.LeviJP').length > 0)
	{  
		if ($('#dwfrm_profile_address_states_state').val()=="") {
			$('.field-wrapper .input-select').css('display','block').css('position','absolute').css('opacity','0').css('width','10px');
		}
	}
});

if($('body.LeviAU').length > 0 || $('body.LeviIN').length > 0 || $('body.LeviJP').length > 0)
{ 
	$('[name$="_address_states_state"]').on('change', function(e) {
			if ($('#dwfrm_profile_address_states_state').val()=="") {
				$('.field-wrapper .input-select').css('display','block').css('position','absolute').css('opacity','0').css('width','10px');
			}
			else {
				$(this).closest('.form-row').find('.error').hide();
			}
	
	});
}


    if($('.edit-profile').length > 0 && $('body.LeviJP').length > 0)
	{
		if($("#dwfrm_profile_customer_year").val() != "" && $("#dwfrm_profile_customer_month").val() != "" && $("#dwfrm_profile_customer_day").val() != "") {
			$("#dwfrm_profile_customer_year").prop("disabled", true);
			$("#dwfrm_profile_customer_month").prop("disabled", true);
			$("#dwfrm_profile_customer_day").prop("disabled", true);
		}
	}

	
// customer service topic selection error 
$('[name$="_contactus_send"]').on('click', function(e) {
var mandatoryfieldmissing=false;
	if($('body.LeviIN').length > 0 || $('body.LeviJP').length > 0)
	{  
		if($('#dwfrm_contactus_topic').val()=="")
		{
			mandatoryfieldmissing=true;
			$('[name$="_contactus_topic"]').closest('.field-wrapper').find('.errspan').remove();
		}else{
			mandatoryfieldmissing=false;
		}
		if ($('#dwfrm_contactus_topic').val()=="") {
			var errSpan = document.createElement('span');
			errSpan.innerHTML = Resources.VALIDATE_TOPIC;
			errSpan.className += "errspan error";
			$('[name$="_contactus_topic"]').closest('.field-wrapper').append(errSpan);
		}
		
		 $("#RegistrationForm .form-row.required .input-text,.form-row.required .input-textarea").each(function(e) {
			
			 if($(this).val()=="")
				{
				 mandatoryfieldmissing=true;
				 $(this).closest('.field-wrapper').find('.errspan').remove();
				}else{
					mandatoryfieldmissing=false;
				}
				if ($(this).val()=="" && $(this).closest('.form-row').find('span.error').length ==0) {
					var errSpan = document.createElement('span');
					errSpan.innerHTML = Resources.VALIDATE_REQUIRED;
					errSpan.className += "errspan error";
					$(this).closest('.field-wrapper').append(errSpan);
				}
				if($(this).hasClass( "phone" ) && $(this).closest('.form-row').find('span.error').length ==0){
					if($("#dwfrm_contactus_phone").val().length < 10){
						var errSpan = document.createElement('span');
						errSpan.innerHTML =Resources.INVALID_PHONE;
						errSpan.className += "errspan error";
						$(this).closest('.field-wrapper').append(errSpan);
					}
				}
	        });
		 
		 $("#RegistrationForm .terms-checkbox .input-checkbox").each(function(e) {
			
			 if($(this).prop('checked')==false)
				{
				 mandatoryfieldmissing=true;
				 $(this).closest('.form-row').next().find('.errspan').remove();
				}else{
					mandatoryfieldmissing=false;
				}
				if ($(this).prop('checked')==false && $(this).closest('.form-row').next().find('.errspan').length ==0) {
					
					var errSpan = document.createElement('span');
					errSpan.innerHTML = Resources.VALIDATE_REQUIRED;
					errSpan.className += "errspan error";
					errSpan.id += "dwfrm_profile_customer_confirmationtp-error";
					$(this).closest('.form-row').next().append(errSpan);
				}
	        });
		 
		 if(mandatoryfieldmissing==true){
			 e.preventDefault(); 
		 }
	}
	
	
	
});

	if($('body.LeviIN').length > 0 || $('body.LeviJP').length > 0)
	{ 
		$('[name$="_contactus_topic"]').on('change', function(e) {
				e.preventDefault();
				if ($('#dwfrm_contactus_topic').val()=="") {
					var errSpan = document.createElement('span');
					errSpan.innerHTML = Resources.VALIDATE_TOPIC;
					errSpan.className += "errspan error";
					$('[name$="_contactus_topic"]').closest('.field-wrapper').append(errSpan);
					return;
				}
				else {
					$('[name$="_contactus_topic"]').closest('.field-wrapper').find('.errspan').remove();
				}
		
		});
		
		$("#RegistrationForm .input-text,.input-textarea").on('keypress focusout', function(e) {
			$(this).closest('.form-row').find('span.error').remove();
     	
		});
		
		 $("#RegistrationForm .terms-checkbox .input-checkbox").on('click', function(e) {
			 if($(this).prop('checked')==true)
				{
				 $(this).closest('.form-row').next().find('span.error').remove();
				}
				if ($(this).prop('checked')==false) {
					var errSpan = document.createElement('span');
					errSpan.innerHTML = Resources.VALIDATE_REQUIRED;
					errSpan.className += "error";
					errSpan.id += "dwfrm_profile_customer_confirmationtp-error";
					$(this).closest('.form-row').next().append(errSpan);
				}

     });
	}

	
    // code for delete account pop goes here
	
	if ($('body').hasClass('LeviJP')) {
	$('.deleteexternal').on('click',function(e){	
		e.preventDefault();
		dialog.open({
			url: Urls.disableAccountDialog,
			options: {
                   width: 400,
                   dialogClass:"bonus-discount-container",
                   open: function() {
	                   	$('.bonus-discount-container').on('click', '.close-button', function(e) {
	   						dialog.close();
	   					});
	                   	
	                   	$('.account-delet-yes-btn').on('click', function(e) {
	                   	 //e.preventDefault();
	                        $.ajax ({
	                            type: 'GET',
	                            url: Urls.deleteExternalProfile,
	                            success: function (response) {
	                            	window.location.href = Urls.accountDisableRedirect;
	                            }
	                        }); 
	                    }); 
	                   	$('.account-delet-no-btn').on('click', function(e) {
	   						dialog.close();
	   					});
                   }
			}
	});
	});
	}
	// code ends for asking confirmation for extrenal account disable
	
//getOrderList pagination
$('.order-history-page').on('click', '.jsorderpage', function(e) {
	e.preventDefault();
	var paginationXml = $('#paginationXml').val();
	var pageNumber = $(this).data('pageno');
	$.ajax({
		url: Urls.getOrderListPagination,
		type: 'POST',
		data: {'PageNo':pageNumber ,'paginationXml':paginationXml}
	}).done(function(response) {
		if (!response || !response.success) {
			$('.order-history-page').html(response);
		} else {
			resolve(response);
		}
	})
});

//pop up for coupon code
function initPromoCodeLink(){
	$('.order-totals-table').on('click', '.promo-details', function(e) {
		e.preventDefault();
		var promoDetails = $(this).find('div').html();
		dialog.open({
			html: promoDetails,
			options: {
				title: $(this).siblings("span").text()
			}
		});
	});	
}


/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
	toggleFullOrder();
	initAddressEvents();
	login.init();
	disablecreatebutton();
	changePassword();
	initChangePasswordValidation();
    
	if (!$('body').hasClass('LeviKR')){ 
		editProfile();
	}
	initPromoCodeLink();
	if($('body.LeviJP').length > 0 && $('#wrapper').hasClass('pt_customer-service')){
		 var email = $('#contactusemail').val();
		  if(email != "null"){
			  $('#dwfrm_contactus_email').val(email);
		  }
	 }
		var windowUrl=window.location.href;
		if($('body.LeviJP').length > 0 && windowUrl.indexOf("registration=true")>0 && (windowUrl.indexOf("account")>0 || windowUrl.indexOf("Account-Show")>0)){
			history.pushState({urlPath:windowUrl},"",Urls.showProfile);
		}
		
}

var account = {
		init: function () {
			initializeEvents();
			giftcert.init();
		},
		initCartLogin: function () {
			login.init();
		},
		initZipCodeValidation: function () {
			koreaZipCodeValidation();
		}
};

module.exports = account;
$(document).ready(function(){
	
	if ($('body').hasClass('LeviJP')) {
		$('[name$="_profile_address_lastName"]').attr("tabindex","1");
		$('[name$="_profile_address_firstName"]').attr("tabindex","2");
		$('[name$="_profile_address_kanalastname"]').attr("tabindex","3");
		$('[name$="_profile_address_kanafirstname"]').attr("tabindex","4");
		$('[name$="_profile_address_postal"]').attr("tabindex","5");
		//$('[name$="_profile_address_city"]').attr("tabindex","6");
		$('[name$="_profile_address_address1"]').attr("tabindex","6");
		$('[name$="_profile_address_address2"]').attr("tabindex","7");
		$('[name$="_profile_address_phone"]').attr("tabindex","8");
		
		$('[name$="_profile_customer_lastName"]').attr("tabindex","1");
		$('[name$="_profile_customer_firstName"]').attr("tabindex","2");
		$('[name$="_profile_customer_kanalastname"]').attr("tabindex","3");
		$('[name$="_profile_customer_kanafirstname"]').attr("tabindex","4");
		$('[name$="_profile_customer_phone"]').attr("tabindex","5");
	}	
	
	
	if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')) {

		// When a link is clicked

		$("#tab_2").click(function () {
			$("#tab_1").removeClass("active");
			$("#tab_2").addClass("active");
			$("#tab_3").removeClass("active");
			$("#content_1").removeClass("active");
			$("#content_2").addClass("active");
			$("#content_3").removeClass("active");
			$("#content_2").css('display','block');
			$("#content_1").css('display','none');
			$("#content_3").css('display','none');
		});
		$("#tab_1").click(function () {
			$("#tab_2").removeClass("active");
			$("#tab_3").removeClass("active");
			$("#tab_1").addClass("active");
			$("#content_2").removeClass("active");
			$("#content_1").addClass("active");
			$("#content_3").removeClass("active");
			$("#content_1").css('display','block');
			$("#content_2").css('display','none');
			$("#content_3").css('display','none');
		});
		$("#tab_3").click(function () {
			$("#tab_1").removeClass("active");
			$("#tab_2").removeClass("active");
			$("#tab_3").addClass("active");
			$("#content_1").removeClass("active");
			$("#content_2").removeClass("active");
			$("#content_3").addClass("active");
			$("#content_1").css('display','none');
			$("#content_2").css('display','none');
			$("#content_3").css('display','block');
		});
	}
	
	
	if ($('body').hasClass('LeviJP')) {
		
		if (util.isMobile()) {
			$('.login-box-content').on('click', '#questionimage', signUpPopUp);
			$('.club-levi-checkbox').on('click', '#questionimage', signUpPopUp);
			$('.check.signup-checkbox').on('click', '#questionimage', signUpPopUp);
			}else{
			      $('.login-box-content #questionimage').hover( signUpPopUp);
					$('.club-levi-checkbox #questionimage').hover( signUpPopUp);
					$('.check.signup-checkbox #questionimage').hover( signUpPopUp); 
			} 


		
		$('#dwfrm_profile_customer_clublevisaccount').change(function() {
			if($("input#dwfrm_profile_customer_clublevisaccount").is(":checked")){
		    	if($(".registration-address").hasClass("registration-inactive") ){
		    		$(".registration-address").removeClass("registration-inactive");
		    		$(".registration-address").addClass("registration-active");
		    	}
				
				var cust_phone = $("input[id^=dwfrm_profile_customer_phone]").val();
				$("#dwfrm_profile_address_phone").val(cust_phone);
				
			}
			else{
				$(".registration-address").removeClass("registration-active"); 
				$(".registration-address").addClass("registration-inactive");	    		   		
			}
		});
		
		if($("input[name=dwfrm_profile_customer_clublevisaccount]").is(":checked")){
			if($(".registration-address").hasClass("registration-inactive") ){
				$(".registration-address").addClass("registration-active");
				$(".registration-address").removeClass("registration-inactive");    		
			}
			else{
				$(".registration-address").addClass("registration-inactive");
				$(".registration-address").removeClass("registration-active");    		
			}	
		}
		
		$('.primary-content').on('keypress focusout', '.col-1 .email', function(e) {
			if ($(this).closest('.form-row').find('.form-caption').hasClass('error-message')) {
				$(".form-caption").removeClass('error-message').text('');
				$(".form-row").removeClass('error');
			}
		});
		
		$(function () {
		    $('.registration-address .form-field-tooltip a').on("click", function (e) {
		        e.preventDefault();
		    });
		});
	}	
	
	
});

function signUpPopUp(){
		if (util.isMobile()) {
			alert(Resources.SIGNUP_POPUP);
			return;
		}
		
		$('#questionimage').tooltip({ items: "#questionimage", content: Resources.SIGNUP_POPUP});
		$('#questionimage').tooltip("open");
		$('#questionimage').addClass('tooltip');
		return;
	}

if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
	$('[name$="dwfrm_login_register"], [name$="dwfrm_profile_register"] ').on('click', function(e) {
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "customEvent",
				eventCategory: "SignedUp",
				eventAction: "manual", //manual/Google/Facebook/amazon
				eventLabel: "attempt", //attempt/success/failure
			});
	});
	$('[name$="dwfrm_login_login"]').on('click', function(e) {
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "customEvent",
				eventCategory: "SignedIn",
				eventAction: "manual", 
				eventLabel: "attempt"
			});
	});
	$('[name$="dwfrm_oauthlogin_login"]').on('click', function(e) {
			var id = this.id;
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "customEvent",
				eventCategory: "SignedIn",
				eventAction: id, 
				eventLabel: "attempt"
			});
	});
	$('[id$="headerLogoutSite"]').on('click', function(e) {
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "customEvent",
				eventCategory: "SignedOut"
			});
	});
}



},{"../adyen-checkout":5,"../dialog":18,"../giftcert":20,"../login":22,"../page":28,"../tooltip":66,"../util":67,"../validator":68}],30:[function(require,module,exports){
'use strict';

var util = require('../util');
var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    quickview = require('../quickview'),
    dialog = require('../dialog'),
	ajax = require('../ajax'),
    cartStoreInventory = require('../storeinventory/cart'),
    pickupInstore = require('./product/pickupInstore');
    
/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    $('#cart-table').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        quickview.show({
            url: e.target.href,
            source: 'cart'
        });
    })
    .on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });
    
	
    $.widget("custom.myselectmenu", $.ui.selectmenu, {
		_renderItem: function (ul, item) {
			var li = $("<li>"),
			wrapper = $("<div>", { text: item.label });
			li.attr('data-event', 'event-data-cart');
			li.attr('data-click', 'Quantity:'+item.label);
			if (item.disabled) {
				li.addClass("ui-state-disabled");
			}
			return li.append(wrapper).appendTo(ul);
		}
	});
	
	$('select').myselectmenu({
		icons: { button: "ui-icon-arrowthick-1-s" },
		select: function (event, ui) {
			$(this).val(ui.item.value).trigger('change');
		}
	});
    
	if ($('body').hasClass('LeviJP')) {
		$('#emptyCart').on('click',function(){
			$.ajax({
				type:'POST',
				url: util.ajaxUrl(Urls.emptyCart),
				async: false
			})
			location.reload();
			
		});
		$('#add-coupon').on('click', function (e) {
				var $addCoupon = $('#add-coupon');
				var $checkoutForm = $('.cart-coupon-code');
				var $couponCode = $('input[name$="_couponCode"]');
				var $error = $checkoutForm.find('.coupon-missing-error');
				var $couponError = $checkoutForm.find('.error');
				var code = $couponCode.val();
				if (code.length === 0) {
					e.preventDefault();	
					if($couponError.length != 0){
						$error.html(Resources.COUPON_CODE_MISSING);
						$('.error').remove();
						return;
					}else{
						$error.html(Resources.COUPON_CODE_MISSING);
						return;
					}
				}
			});
		}
    
    /**
	* number input button up down functions
	*
	**/
   
    $(".item-quantity #quantity").on('change', function (e) {
        if ( !$(this).hasClass('disabled') ) {
            $(this).parent().find('.editLineItem').click();
        }
    });
    // override enter key for coupon code entry
    $('form input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13 && $(this).val().length === 0) { return false; }
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }
    });
/** NEW ARRIVALS CAROUSEL - START **/
    $(window).on('mousemove scroll', function(e) {
    	newArrivalCarousel();
    });    
    $('body.LeviIN').on('mousemove scroll', function(e) {
    	newArrivalCarousel();
    }); 
    $('body.LeviAU').on('mousemove scroll', function(e) {
    	newArrivalCarousel();
    }); 
    
    function newArrivalCarousel () {
	$('#new-arrival #jcarousel1').on('jcarousel:reload jcarousel:create', function() {
		var width = $(this).innerWidth();
		if($('body').hasClass('LeviKR')){
			if (width > 1820) {
				width = width / 7;
			}  else if (width >1340) {
				width = width / 5;
			}  else if (width > 924) {
				width = width / 4;
			} else if (width > 738) {
				width = width / 3;
			} else if (width <= 738 && width >= 450) {
				width = width / 2;
			} else if (width < 450 ) {
				width = width /1;
			}
			$(this).jcarousel('items').css('width', width + 'px');		
		}
		else if($('body').hasClass('LeviIN')){
			if (width > 1400) {
				width = width / 6;
			}  else if (width >1024) {
				width = width / 6;
			}  else if (width > 768) {
				width = width / 3;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width / 1;
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}
		else{
		  if (width > 1400) {
				if ($('body').hasClass('LeviJP')) {width = width / 7;}
			else if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')) {width = width / 8;}    


	        }  else if (width >1024) {
				if ($('body').hasClass('LeviJP')) {width = width / 5;}
			else if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')) {width = width / 6;}  
	        }  else if (width > 768) {
	            width = width / 4;
	        } else if (width <= 768 && width >= 480) {
	            width = width / 3;
	        } else if (width < 480) {
	            width = width /2;
	        }
		$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}
	})
	.jcarousel({
		wrap: 'circular'
	});
	

	
	$('#new-arrival .na-prev')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('.horizontal-jcarousel-wrapper1').find('#jcarousel1').jcarousel('scroll', '-=1');
	});
	
	$('#new-arrival .na-next')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#new-arrival').find('#jcarousel1').jcarousel('scroll', '+=1');
	});
 }	
	
	/** NEW ARRIVALS CAROUSEL - END **/
	
	

	/** Recently viewed carousel - START **/
	
	$('#last-visited #jcarousel').on('jcarousel:reload jcarousel:create', function() {
		var width = $(this).innerWidth();
		  if (width > 1400) {
	            width = width / 7;
	        }  else if (width >1024) {
	            width = width / 5;
	        }  else if (width > 768) {
	            width = width / 4;
	        } else if (width <= 768 && width >= 480) {
	            width = width / 3;
	        } else if (width < 480) {
	            width = width /2;
	        }
		$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
	})
	.jcarousel({
		wrap: 'circular'
	});
	
	$('#last-visited .jcarousel-prev1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '-=1');
	});
	
	$('#last-visited .jcarousel-next1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '+=1');
	});
	
	
	/** Recently viewed carousel - END **/
    $('.jcarousel-pagination')
 .on('jcarouselpagination:active', 'a', function() {
     $(this).addClass('active');
 })
 .on('jcarouselpagination:inactive', 'a', function() {
     $(this).removeClass('active');
 })
 .on('click', function(e) {
     e.preventDefault();
 })
 .jcarouselPagination({
  perPage: util.isMobile()?1:3,
     item: function(page, carouselItems) {
         return '<a href="#' + page + '">' + page + '</a>';
     }
 });  
    
    
if ($('body').hasClass('LeviKR')) {
	$('.horizontal-jcarousel-wrapper1 #jcarousel').on('jcarousel:reload jcarousel:create', function () {
    	var carousel = $(this), //use "this" if want to initialize for only first carousel on page
    	width = carousel.innerWidth();
    	if (width > 1400) {
    		width = width / 7;
    	}  else if (width >1024) {
    		width = width / 5;
    	}  else if (width > 768) {
    		width = width / 4;
    	} else if (width <= 768 && width >= 480) {
    		width = width / 3;
    	} else if (width < 480) {
    		width = width /2;
    	}
    	carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');

    })
    .jcarousel({
    	wrap: 'circular'
    });


    $('.jcarousel-prev1')
    .on('jcarouselcontrol:inactive', function() {
    	$(this).addClass('invisible');
    })
    .on('jcarouselcontrol:active', function() {
    	$(this).removeClass('invisible');
    })
    .jcarouselControl({
    	target: '-=1'
    });

    $('.jcarousel-next1')
    .on('jcarouselcontrol:inactive', function() {
    	$(this).addClass('invisible');
    })
    .on('jcarouselcontrol:active', function() {
    	$(this).removeClass('invisible');
    })
    .jcarouselControl({
    	target: '+=1'
    });

    $('.jcarousel-pagination')
    .on('jcarouselpagination:active', 'a', function() {
    	$(this).addClass('active');
    })
    .on('jcarouselpagination:inactive', 'a', function() {
    	$(this).removeClass('active');
    })
    .on('click', function(e) {
    	e.preventDefault();
    })
    .jcarouselPagination({
    	perPage: util.isMobile()?1:3,
    			item: function(page, carouselItems) {
    				return '<a href="#' + page + '">' + page + '</a>';
    			}
    });
}

	$('.horizontal-jcarousel-wrapper #jcarousel').on('jcarousel:reload jcarousel:create', function() {
		var width = $(this).innerWidth();
        	if (width > 1400) {
                width = width / 8;
            }  else if (width >1024) {
                width = width / 6;
            }  else if (width > 768) {
                width = width / 4;
            } else if (width <= 768 && width >= 480) {
                width = width / 3;
            } else if (width < 480) {
                width = width /2;
            }
                                
        	$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
    })
    .jcarousel({
    	wrap: 'circular'
    });
                                                            
    $('.horizontal-jcarousel-wrapper .jcarousel-prev')
    .on('jcarouselcontrol:inactive', function() {
                    $(this).addClass('invisible');
    })
    .on('jcarouselcontrol:active', function() {
                    $(this).removeClass('invisible');
    })
    .on('click', function() {
                    $(this).closest('.horizontal-jcarousel-wrapper').find('#jcarousel').jcarousel('scroll', '-=1');
    });
    
    $('.horizontal-jcarousel-wrapper .jcarousel-next')
    .on('jcarouselcontrol:inactive', function() {
                    alert("next");
                    $(this).addClass('invisible');
    })
    .on('jcarouselcontrol:active', function() {
                    $(this).removeClass('invisible');
    })
    .on('click', function() {
                    $(this).closest('.horizontal-jcarousel-wrapper').find('#jcarousel').jcarousel('scroll', '+=1');
    });


    $('.checkout-button').on('click', 'button[name$="dwfrm_cart_checkoutCart"]', function() {
    	localStorage.setItem("fromBilling","false");
	});

   $('.order-totals-table').on('click', '.promo-details', function(e) {
	   e.preventDefault();
		var promoDetails = $(this).find('div').html();
		dialog.open({
			html: promoDetails,
			options: {
				title: $(this).siblings("span").text()
			}
		});
	});

if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN'))    
{
	$('.horizontal-jcarousel-wrapper #jcarousel').on('jcarousel:reload jcarousel:create', function() {
		var width = $(this).innerWidth();
        	if (width > 1400) {
                width = width / 8;
            }  else if (width >1024) {
                width = width / 6;
            }  else if (width > 768) {
                width = width / 4;
            } else if (width <= 768 && width >= 480) {
                width = width / 3;
            } else if (width < 480) {
                width = width /2;
}

        	$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
    })
    .jcarousel({
    	wrap: 'circular'
    });
                                                            
    $('.horizontal-jcarousel-wrapper .jcarousel-prev')
    .on('jcarouselcontrol:inactive', function() {
                    $(this).addClass('invisible');
    })
    .on('jcarouselcontrol:active', function() {
                    $(this).removeClass('invisible');
    })
    .on('click', function() {
                    $(this).closest('.horizontal-jcarousel-wrapper').find('#jcarousel').jcarousel('scroll', '-=1');
    });
    
    $('.horizontal-jcarousel-wrapper .jcarousel-next')
    .on('jcarouselcontrol:inactive', function() {
                    alert("next");
                    $(this).addClass('invisible');
    })
    .on('jcarouselcontrol:active', function() {
                    $(this).removeClass('invisible');
    })
    .on('click', function() {
                    $(this).closest('.horizontal-jcarousel-wrapper').find('#jcarousel').jcarousel('scroll', '+=1');
    });
}

}

if ($('body').hasClass('LeviJP')) {
	var t = setTimeout(startTimer, 1000);
	
	if ((util.isMobile())&&(navigator.userAgent.match(/iPad/i)==null)) {
		if(!$.trim( $('.item-stock-alert').html() ).length){
			 $(".item-stock-alert").css('display','none');
		}else{
			$(".item-stock-alert").css('display','block');
		}
	}	
}

	function startTimer(){
		var today = new Date();
		var cartStartTime = $('#carttimervalidity').attr('value');
		var iscartExpired = $('#iscartExpired').attr('value');
		if(iscartExpired == "false"){
		    var todaytime = today.getTime();
		    var diff = (todaytime-cartStartTime);
		    var min = convertToMinute(todaytime-cartStartTime);
		    if(min > SitePreferences.CART_EXPIRATION_TIME) {
		    	endTimer();
		    }else{
			    var tmin = SitePreferences.CART_EXPIRATION_TIME - min;
			    var s = Math.floor((tmin*60)%60);
			    var m = Math.floor(tmin);
			    
			    if (m < 10) 
			    {m = "0" + m};
			    if (s < 10) 
			    {s = "0" + s};
			    			    
			    $('.session-timer .startTime').html(m + ":" + s);
			   var t = setTimeout(startTimer, 1000);
		    }
		}
}


function convertToMinute(milli){
	var min = milli/(1000*60);
	return min;
}

function endTimer(){
	$.ajax({
		type:'GET',
		url: util.ajaxUrl(Urls.cartExpired),
		async: false,
		success: function (response) {
			if(response.success){
				location.reload();
			}
		}
	});
}

exports.init = function () {
    initializeEvents();
    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
    if(SitePreferences.OMNI_ENABLED == 'Y'){
		pickupInstore();
	}
    account.initCartLogin();
};

$( document ).ready(function() {
	if($('.pt_cart .cart-empty').length>0)
		{
		 $(".pt_cart footer").css('margin-bottom',"0");
		}
		
});

module.exports.startTimer = startTimer;
},{"../ajax":7,"../bonus-products-view":13,"../dialog":18,"../quickview":56,"../storeinventory/cart":61,"../util":67,"./account":29,"./product/pickupInstore":43}],31:[function(require,module,exports){
'use strict';

var util = require('../../util'),
	formPrepare = require('./formPrepare');
var shipping = require('./shipping');
var ajax = require('../../ajax');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
function updateAddress(addressId) {
	ajax.load({    	
		url:Urls.getSelectedAddress,
		 data: {
			 addressID: addressId
          },
		target: $('.selected-address'),
		callback: function () {
		}
	});
 
};




exports.init = function () {
    var $form = $('.address');
    // select address from list
    $('.customer-address').show();
    $.widget("custom.myselectmenu", $.ui.selectmenu, {
		_renderItem: function (ul, item) {
			var li = $("<li>"),
			wrapper = $("<div>", { text: item.label });
			  li.attr('data-event', 'event-data-checkout');
			  if($('body').hasClass('LeviKR')){
				  li.attr('data-click', 'Select from Saved Addresses');
			  }
			  if($('body').hasClass('LeviAU')){
				  var billingMenu = $("#dwfrm_billing_addressList-menu");
				  if(billingMenu.length > 0)
					{
					 li.attr('data-checkout', 'Select-Billing'); 
					}
				   else
				    {
				   
					 li.attr('data-click', 'Select from Saved Addresses');		
				    } 
				  
			  }
			if (item.disabled) {
				li.addClass("ui-state-disabled");
			}
			return li.append(wrapper).appendTo(ul);
		}
	});

	$('select').myselectmenu({
		icons: { button: "ui-icon-arrowthick-1-s" },
		select: function (event, ui) {
			$(this).val(ui.item.value).trigger('change');
		}
	});
    
    $('select[name$="_addressList"]', $form).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) {return; }
        if($('body').hasClass('LeviJP') && selectedAddress != "newaddress"){
        	updateAddress(this.value);
        	 $('.needsched-disclaimer').find('span.errspan.error').remove();
        }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        // re-validate the form
        $form.validate().form();
        
        //to clear the form if "new address" option is selected from the Address list drop down
        if(selectedAddress == "newaddress"){
        	$(this).closest('form').find("input[type=text], textarea, select, input[type=number]").val("");
        	$('[id$="_shippingAddress_addressFields_states_state"]').myselectmenu('refresh'); 
        	 if($('body').hasClass('LeviJP')){
 	        	document.getElementById("shippingform").style.display = "block";
 	        	document.getElementById("customer-default-address").style.display = "none";
 	        	var email = $('#loggedincustomeremail').val();
 	        	$('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').val(email);
 	        	$('#dwfrm_singleshipping_shippingAddress_addressFields_lastName').val($('#loggedincustomerlastname').val()); 
                $('#dwfrm_singleshipping_shippingAddress_addressFields_firstName').val($('#loggedincustomerfirstname').val());
                $('#dwfrm_singleshipping_shippingAddress_addressFields_kanalastname').val($('#loggedincustomerkanalastname').val());
                $('#dwfrm_singleshipping_shippingAddress_addressFields_kanafirstname').val($('#loggedincustomerkanafirstname').val());
 	        	$("#shippingform").find('input:checkbox').attr('checked', false);
 	        	 $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state option[value=""]').attr('selected','selected');
                 $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button .ui-selectmenu-text').text("都道府県");
                 $("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(""); 
                 $('#shippingform .input-text').removeClass('error');
            	 $('#shippingform span.error').remove();
            	 $('.needsched-disclaimer').find('span.errspan.error').remove();
            	 if(util.isMobile()){
            		 $('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val("");
            		 $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val("");
            	 }
         	 }
            formPrepare.init({
                continueSelector: '[name$="shippingAddress_save"]',
                formSelector:'[id$="singleshipping_shippingAddress"]'
            });
            $("input").removeClass('error');
            $("label.error").remove();
            $("input").next("span.error").remove();
            $('[id$="_shippingAddress_addressFields_states_state"]').closest('div.form-row').find('span.errspan').remove();
            $('.cod-status-section').hide();
        	return;
        } else {
            if($('body').hasClass('LeviJP')) {
                document.getElementById("customer-default-address").style.display = "block";
                document.getElementById("shippingform").style.display = "none";
            }
        }
        formPrepare.init({
            continueSelector: '[name$="shippingAddress_save"]',
            formSelector:'[id$="singleshipping_shippingAddress"]'
        });
        if($('body').hasClass('LeviAU')) {
	        $("input").removeClass('error');
	        $("label.error").remove();
        }
    });
};

module.exports.updateAddress= updateAddress;
},{"../../ajax":7,"../../util":67,"./formPrepare":33,"./shipping":36}],32:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    progress = require('../../progress'),
    giftcard = require('../../giftcard'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    adyenCheckout = require('../../adyen-checkout');

/**
 * @function
* @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
* @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
    var $creditCard = $('[data-method="CREDIT_CARD"]');
    $creditCard.find('input[name$="creditCard_owner"]').val(data.holder).trigger('change');
    $creditCard.find('select[name$="_type"]').val(data.type).trigger('change');
    $creditCard.find('input[name*="_creditCard_number"]').val(data.maskedNumber).trigger('change');
    $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
    $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
    $creditCard.find('input[name$="_cvn"]').val('').trigger('change');
}

function getState()
{
	 $.ajax({
         type: "POST",
         url: Urls.stateSelector,
         data : {
                ID : ID
             },
             success: function(response) {
            	 getState();
             }
  });
	}
function initializeCouponEvents()
{
       var $removeCoupon = $('.remove-coupon');
	$removeCoupon.on('click', function(e){	
              var code = $(this).prev(".couponcode").find(".applied-coupon-code").text();
      var url = util.appendParamsToUrl(Urls.removeCoupon);
     
      ajax.postJson({
                     url: url,
                     dataType: "json",
                     data : {'couponCode': code, 'format': 'ajax'},
                     contentType: "application/json",
                     callback: function (response){
                           var cpcode = response.CouponCode;
                           $("#"+cpcode).remove();
                           if($('body').hasClass('LeviIN')){
                           $(".promoform").show();
                           updateSummary(response);
                           }else{
                            updateSummary(response);
                           }
                     }
              });
    });
	///
	$(function () {
	    $('#ui-id-2, #ui-id-3').on('click', function () {
	        var Status = $(this).val();
	        $.ajax({
	            url: 'Ajax/StatusUpdate.php',
	            data: {
	                text: $("textarea[name=Status]").val(),
	                Status: Status
	            },
	            dataType : 'json'
	        });
	    });
	});
	
	
	//
       
       var $addCoupon = $('#add-coupon');
       var $couponCode = $('input[name$="_couponCode"]');
       $addCoupon.on('click', function (e) {
              e.preventDefault();
              var $checkoutForm = $('.secondary-minisummary');
              var $error = $checkoutForm.find('.coupon-error'),
                  code = $couponCode.val();
                  if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
                     window.dataLayer = window.dataLayer || [];
                     dataLayer.push({
                            event: "customEvent",
                            eventCategory: "CouponApplyTracked",
                            eventAction: "billingpage-promo-attempt",
                            eventLabel: code,
                            EventValue : "attempt"
                     });
              }
              if (code.length === 0) {
                  $error.html(Resources.COUPON_CODE_MISSING);
                  return;
              }
              var url = util.appendParamsToUrl(Urls.addCoupon);
             
              ajax.postJson({
                           url: url,
                           dataType: "json",
                           data : {'couponCode': code, 'format': 'ajax'},
                           contentType: "application/json",
                           callback: function (response){
                                  var fail = false;
                                  var msg = '';
                                  if (!response) {
                                         msg = Resources.BAD_RESPONSE;
                                         fail = true;
                                  } else if (!response.success) {
                                         msg = response.message.split('<').join('&lt;').split('>').join('&gt;');
                                         fail = true;
                                  } else if(response.success && response.status!=='APPLIED'){
                                         msg = response.message;
                                         fail = true;
                                  }
                                  if (fail) {
                                         $error.html(safe_tags(msg));
                                         if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
                                                 window.dataLayer = window.dataLayer || [];
                                                 dataLayer.push({
                                                        event: "customEvent",
                                                        eventCategory: "CouponApplyTracked",
                                                        eventAction: "billingpage-promo-error",
                                                        eventLabel: code,
                                                        EventValue : "failure"
                                                 });
                                          }
                                          $('body').trigger('analytics:invalidCoupon', { status: response.status, couponCode: code });
                                         return;
                                  }

                                  if(response.success && response.status==='APPLIED' && response.baskettotal !== 0){
                                         showCouponInformation(response);
                                         updateSummary(response);
                                         if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
                                                 window.dataLayer = window.dataLayer || [];
                                                 dataLayer.push({
                                                        event: "customEvent",
                                                        eventCategory: "CouponApplyTracked",
                                                        eventAction: "billingpage-promo-success",
                                                        eventLabel: code,
                                                        EventValue : "success"
                                                 });
                                          }
                                          // Trigger GA4 Coupon Success Event
                                          $('body').trigger('analytics:couponSuccess', { couponCode: code });
                                  }
                                  //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
                                  //this will force a page refresh to display the coupon message based on a parameter message
                                  if (response.success && response.baskettotal === 0) {
                                         window.location.assign(Urls.billing);
                                  }
                              
                           }
            });
       });
}

if($('body').hasClass('LeviJP')){
       $('.progress-wrapper .step-1').on('click', function () {
              localStorage.setItem("fromBilling","true");
       });
       $('.payment-method-options input:radio').click(function() { 
              var ID=$(".payment-method-options").find(":checked").val();
                $.ajax({
                       type: "POST",
                       url: Urls.paymentChargeCalculate,
                       data : {
                              ID : ID
                           },
                           success: function(response) {
                                updateSummary(response);
                           }
                });
       });
}

function safe_tags(str) {
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;') ;
}

/**
 * @function
 * @description Updates the credit card form with the attributes of a given card
 * @param {String} cardID the credit card ID of a given card
 */
function populateCreditCardForm(cardID) {
    // load card details
    var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert(Resources.CC_LOAD_ERROR);
                return false;
            }
            setCCFields(data);
        }
    });
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
    var $paymentMethods = $('.payment-method');
   

    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + paymentMethodID + '"]');
  
    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }
    // ensure checkbox of payment method is checked
       if($('body').hasClass('LeviKR')){
      $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
       }
    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');
    
   
    //formPrepare.validateForm();
        
       $selectedPaymentMethod.css({"display":"block"});
              if($('body').hasClass('LeviKR') || $('body').hasClass('LeviIN')){
            	  $selectedPaymentMethod.find('ul#type').find('input').prop('checked', 'checked');
              }
      var toggle= $selectedPaymentMethod.parent().find('.accordianopen');
      toggle.toggleClass('accordianopen');
      toggle.toggleClass('accordianclose');
      
              if($('body').hasClass('LeviKR')){
             toggle.parent().prev().css("background-color", "#c41230");
             toggle.parent().prev().css("color", "#ffffff");
             toggle.parent().prev().css("border-color", "#c41230");
      }
      


       if ($('body').hasClass('LeviIN')) {
              // Does not hide credit card section. Disable it
              var $creditCardDiv = $('.payment-method[data-method="CREDIT_CARD"]');

              // $selectedPaymentMethod.parent().siblings().find('.payment-method').filter('[data-method !="CREDIT_CARD"]').slideUp(700,'linear');

              if (paymentMethodID != 'CREDIT_CARD') {

                     $creditCardDiv.find('input').val('');
                     $creditCardDiv.find('select[id$="_creditCard_expiration_month"]').val('').myselectmenu('refresh');
                     $creditCardDiv.find('select[id$="_creditCard_expiration_year"]').val('').myselectmenu('refresh');

                     $creditCardDiv.find('input').attr('readonly', 'true');
                     $creditCardDiv.find('select').attr('disabled', 'true').myselectmenu('refresh');

                     $creditCardDiv.find('.error').html('');
                     
                     $creditCardDiv.find('.selectedpaymentdetailform').attr('title', Resources.SELECT_APPR_PAYMENT_METHOD).tooltip({track: true});
                     
                     $creditCardDiv.data('isdisabled', 'y');
              }
              else {

                     $creditCardDiv.find('input').removeAttr('readonly');
                     $creditCardDiv.find('select').removeAttr('disabled').myselectmenu('refresh');

                     $creditCardDiv.data('isdisabled', 'n');
                     
                     $creditCardDiv.find('.selectedpaymentdetailform').removeAttr('title');
              }

       }
       else if(!$('body').hasClass('LeviJP') && !$('body').hasClass('LeviAU')){
        $selectedPaymentMethod.parent().siblings().find('.payment-method').slideUp(700,'linear');
       }

          var toggles= $selectedPaymentMethod.parent().siblings().find('.accordianclose');
          toggles.toggleClass('accordianclose');
          toggles.toggleClass('accordianopen');
}

if($('body').hasClass('LeviJP')){ 
       var inputLength;      
       inputLength=$('.form-indent.payment-page .pMethodPayment').find('input').length;      
       
       function selectTab(){
          if(sessionStorage.getItem('btnClicked')!='clicked'){
                 //Showing Credit Card Details Opened by Default
                 $('.form-indent.payment-page .pMethodPayment').find('input').eq(0).attr('checked','checked');
                 $('.form-row span').removeClass('clicked');
                 $('.form-indent.payment-page .pMethodPayment').find('input').eq(0).parent().find('.tabCont').addClass('clicked');//changing credit card to clicked position by default
                 $('.payment-method-options .PaymentOptions').hide();
                 $('.payment-method-options .PaymentOptions #accordion1').parent().show();
                 //toggling below pointing
                 $('.form-row .point').hide();
                 $('.form-indent.payment-page .pMethodPayment').find('input').eq(0).parent().find('.tabCont').find('.point').css('display','inline-block');
                 $('.payment-method-options .text-container').hide();
                 $('.payment-method-options .credit-card-opt').parent().find('img').show();
                  $('.form-row.payment-section .crdt-card-details').show();
                  $('.form-indent.payment-page .pMethodPayment').css('marginBottom','120px');
                  $('.payment-method-options .PaymentOptions').find('.accopen0').parent().css('display','block');
          }else{
                 //Showing Details according to Click on Proceed to Pay            
                 $('.form-row span').removeClass('clicked');
                 $('.payment-method-options .credit-card-opt').parent().find('img').hide();
                  $('.form-row.payment-section .crdt-card-details').hide();
                  $('.form-indent.payment-page .pMethodPayment').css('marginBottom','30px');
                  
                  for(var i=0;i<inputLength;i++){
                       $('.form-indent.payment-page .pMethodPayment').find('input').eq(i).parent().find('.tabCont').find('.point').css('display','none');
                         if($('.form-indent.payment-page .pMethodPayment').find('input').eq(i).attr('checked')=='checked'){
                               $('.form-indent.payment-page .pMethodPayment').find('input').eq(i).parent().find('.tabCont').addClass('clicked');
                               $('.form-indent.payment-page .pMethodPayment').find('input').eq(i).parent().find('.tabCont').find('.point').css('display','inline-block');
                               if($('.form-indent.payment-page .pMethodPayment').find('input').eq(i).attr('id')=='is-CREDIT_CARD'){
                                 $('.payment-method-options .credit-card-opt').parent().find('img').show();
                                   $('.form-row.payment-section .crdt-card-details').show();
                                   $('.form-indent.payment-page .pMethodPayment').css('marginBottom','120px');
                               }
                               $('.payment-method-options .PaymentOptions').find('.accopen'+i).parent().css('display','block');
                          }
                  }
          }
         // });   
                  sessionStorage.setItem('btnClicked','reload');
       }   
       function altrnatePayment(e){ 
              if(($('.pMethodPayment #is-COD').attr('disabled')&&$('.pMethodPayment #is-COD').parent().find('.cod-opt').hasClass('clicked'))||($('.pMethodPayment #is-KONBINI').attr('disabled')&&$('.pMethodPayment #is-KONBINI').parent().find('.konbini-opt').hasClass('clicked'))){
                     e.preventDefault();
                     e.stopImmediatePropagation();
                     $('.continue-checkout-button .custom-tooltip').show();
              }
       };
       $('#billing-submit.button-fancy-large').on('click',function(e){
              altrnatePayment(e);
              sessionStorage.setItem('btnClicked','clicked');
              
       });
       $('#billing-submit.button-fancy-large').hover(function(e){
              altrnatePayment(e);
       }, function(){
              $('.continue-checkout-button .custom-tooltip').hide();
       });
       //Function will be called after Tabs are loaded
       $('.form-row .credit-card-opt, .form-row .cod-opt, .form-row .konbini-opt').ready(function(e){
    	   selectTab();
       });
       $('.form-row .credit-card-opt, .form-row .cod-opt, .form-row .konbini-opt').on('click',function(e){
              //adding class for click effect
              $('.form-row span').removeClass('clicked');
              $(this).toggleClass('clicked');
              $('.payment-method-options .PaymentOptions').hide();
              //toggling below pointing
              $('.form-row .point').hide();
              $(this).find('.point').css('display','inline-block');
              
              $('.form-row .crdt-card-cont img').hide();//hide credit cards images
              $('.form-row.payment-section .crdt-card-details').hide();//credit card related text should hide on other sections
              $('.form-indent.payment-page .pMethodPayment').css('marginBottom','30px');
              
              if($(this).hasClass('credit-card-opt')){
                     //show and hide all required Information
                     $('.form-indent.payment-page .pMethodPayment').css('marginBottom','120px');
                     $('.payment-method-options .PaymentOptions #accordion1').parent().show();
                     $(this).parent().find('img').show();
                     $('.payment-method-options .text-container').hide();
                     $('.form-row.payment-section .crdt-card-details').show();                
              }
              if($(this).hasClass('cod-opt')){              
            $('.payment-method-options .PaymentOptions #accordion3').parent().show();
            
            }
           if($(this).hasClass('konbini-opt')){
                  $('.payment-method-options .PaymentOptions #accordion2').parent().show();
           }
           $('.payment-method-options .PaymentOptions #accordion1').parent().find('.selectedpaymentdetailform').parent().css('display','block');//Showing the Payment Method

       });
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary(response) {
       
    var $summary = $('.secondary-minisummary');
    // indicate progress
    progress.show($summary);
 
    // load the updated summary area
    $summary.load(Urls.summaryRefreshURL, function () {
        // hide edit shipping method link
      
        $summary.fadeIn('fast');
        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        initializeCouponEvents();
        initPromoCodeLink();
        if($('body').hasClass('LeviIN') && !empty(response)){
              if(response.status == "APPLIED"){
                     $(".promoform").hide();
              }else{
              $(".promoform").show();
              }
       }
              if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
                     $(".secondary-minisummary .mini-cart-name").dotdotdot({
				ellipsis	: '...',
				wrap		: 'letter',
                           fallbackToLetter: 'letter',
				after		: null,
		 		watch		: true,
				height		: null,
				tolerance	: 0
                     });
              }
    });
    progress.hide();
}

function showCouponInformation(data)
{
       var couponInfo="<li class='redemption coupon form-row clearfix' id='"+data.CouponCode+"'>"+
                     "<span class='couponcode'>"+"<span class='applied-coupon'>"+data.message+"</span></span>"+"<button class='button-text remove-coupon' type='button' name='removeCoupon'>"+Resources.REMOVE_COUPON+"</button>"+"</li>";
       
       $("ul.coupons-applied").append(couponInfo);
       
       
}

function initPromoCodeLink(){
       $('.order-totals-table').on('click', '.promo-details', function(e) {
         e.preventDefault();
             var promoDetails = $(this).find('div').html();
             dialog.open({
                    html: promoDetails,
                    options: {
                          title: $(this).siblings("span").text()
                    }
             });
  	});	
}
/**
 * @function
 * @description Changes the payment type or issuerId of the selected payment method
 * @param {String, Boolean} value of payment type or issuerId and a test value to see which one it is, to which the payment type or issuerId should be changed to
 
function updatePaymentType(selectedPayType, test) {
       if (!test) {
              $('input[name="brandCode"]').removeAttr('checked');
       } else {
              $('input[name="issuerId"]').removeAttr('checked');
       }
       var selectedPaymentType = $('input[value=' + selectedPayType + ']').prop('checked', 'checked');
       /*if(selectedPaymentType){
              $('button[name$="billing_save"]').removeAttr('disabled');
       }
       else{
              $('button[name$="billing_save"]').attr('disabled','disabled');
       }
       //formPrepare.validateForm();
}*/

// Adyen Upgrade 22.2.1 start
/**
* @function
* @description Changes the payment type or issuerId of the selected payment method
* @param {String, Boolean} value of payment type or issuerId and a test value to see which one it is, to which the payment type or issuerId should be changed to
*/

function updatePaymentType(selectedPayType, issuerType) {
       if(issuerType){
              $('#dwfrm_adyPaydata_issuer').val(selectedPayType);
       }
       else{
              $('input[name="brandCode"]').removeAttr('checked');
              $('input[value=' + selectedPayType + ']').prop('checked', 'checked');
       }
       // if the payment type has hidden fields reveal it
       $('#component_' + selectedPayType).show();
       formPrepare.validateForm();
}
// Adyen Upgrade 22.2.1 end

function setBorder() {
       if( $(".secondary-minisummary").height() < $(".billing-payment-methods").height() && !$('body').hasClass('LeviIN')){
              $(".secondary-minisummary").css('min-height', ($(".billing-payment-methods").height()) + 10);
      }
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
    var $checkoutForm = $('.checkout-billing');
    var $addGiftCert = $('#add-giftcert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $addCoupon = $('#add-coupon');
    var $removeCoupon = $('.remove-coupon');
    var $couponCode = $('input[name$="_couponCode"]');
    var $appliedCoupon =$('.applied-coupon');
    var $selectPaymentMethod = $('.pMethod');
    var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();
    var $payType = $('[name="brandCode"]');
    var $issuer = $('.issuer');
    var selectedPayType = $payType.find(':checked').val();
    
    if (SitePreferences.ADYEN_SF_ENABLED) {
       adyenCheckout.initBilling();
    }
     
       $payType.on('change', function() {
              $('#selectedIssuer').val("");
              $issuer.hide();
              $('.checkoutComponent').hide();
              $('#component_' + $(this).val()).show();
              if($(this).siblings( ".issuer").length > 0){
                     $('#selectedIssuer').val($(this).siblings( ".issuer" ).val());
                     $(this).siblings('.issuer').show();
              }
       });
       
       var $payType = $('[name="brandCode"]');
       var $issuerId = $('[name="issuerId"]');
       var $issuer = $('ul#issuer');
       var selectedPayType = $payType.find(':checked').val();
       var selectedIssuerId = $issuerId.find(':checked').val();
       var $billingsectionhide = $('[name="billingsectionhide"]').val();
       
       
       $.widget("custom.myselectmenu", $.ui.selectmenu, {
   		_renderItem: function (ul, item) {
   			var li = $("<li>"),
   			wrapper = $("<div>", { text: item.label });
   			//li.attr('data-event', 'event-data-cart');
   			//li.attr('data-click', 'Quantity:'+item.label);
   			if (item.disabled) {
   				li.addClass("ui-state-disabled");
   			}
   			return li.append(wrapper).appendTo(ul);
   		}
   	});

   	$('select').myselectmenu({
   		icons: { button: "ui-icon-arrowthick-1-s" },
   		select: function (event, ui) {
   			$(this).val(ui.item.value).trigger('change');
   		}
   	}); 
       
     //Billing Page Changes to get state based on country  
       if ($('body').hasClass('LeviAU')) { 
    	   $('#dwfrm_billing_billingAddress_addressFields_country-menu').on('click', function() {
    		var testcntry= $("#dwfrm_billing_billingAddress_addressFields_country-button").text();
    		   $.ajax({
        	        type: "POST",
        	        url: Urls.getStateList, 
        	        
        	        data : {'countryCode': testcntry },
        	        success: function(response) {
        	        response=JSON.parse(response);
        	        	if(response.length>0)
    	        		{
    	        			$("#dwfrm_billing_billingAddress_addressFields_states_state").empty();
    	        			$.each(response,function(index,response){
    	        			$("#dwfrm_billing_billingAddress_addressFields_states_state").append($("<option></option>").attr({value: response.value , optionid:  response.optionid ,label: response.label}).text(response.text));
    	        				
    	        			});
    	        			
    	        			 $("#dwfrm_billing_billingAddress_addressFields_states_state").myselectmenu('refresh');
    	        		}
        	        		
        	        	
        	        }
        	  });
    	   });
    	   
       
       }
       
       
       
       if (!util.isMobile()) {
              if($('body').hasClass('LeviIN')){
                     setBorder();
              }
       }
       
   

       if ($('body').hasClass('LeviIN')) {
              $('.payment-method[data-method="CREDIT_CARD"]').on('click', function(e) {
                     if ($(this).data('isdisabled') == 'y') {
                           // alert(Resources.SELECT_APPR_PAYMENT_METHOD);
                           
                           
                           
                           /*dialog.open({
                                  dialogClass: 'select-pmethod',
                                  width: 200,
                                  height: 150,
                                  html: '<div class="close-popup-button"><span>' + Resources.CLOSE + "</span></div>" + '<div class="newsletterpopup-text">' + Resources.SELECT_APPR_PAYMENT_METHOD + '</div>'
                           });*/
                     }
              });
       }

       if($('body').hasClass('LeviAU')){
              if($billingsectionhide == "false") {
                     $('.pt_checkout').find('.billing-address-form').css({"display":"block"});
                     var toggle= $(".billing-address").find(".accordianopen24x24");
                     $(toggle).toggleClass('accordianopen24x24');
                     $(toggle).toggleClass('accordianclose24x24');
              }
              
       }
       if($('body').hasClass('LeviAU')){
              $('#primary').on('click', 'button[name$="dwfrm_billing_save"]', function(e) {
              
              
                     var isPaymentMethodSelected = $('.payment-method-options').find('input[type="radio"]:checked').length;

                     if (!isPaymentMethodSelected) {
                           e.preventDefault();

                           if (util.isMobile()) {
                                  alert(Resources.SELECT_PAYMENT_METHOD);
                                  return;
                           }

                           $(this).tooltip({ items: $(this), content: Resources.SELECT_PAYMENT_METHOD});
                           $(this).tooltip("open");
                           $(this).addClass('tooltip');

                           return;
                     }
              
              });

             
        
              $('#primary').on('mouseout', 'button[name$="dwfrm_billing_save"]', function (e) {
                     e.preventDefault();
                     if ($(this).hasClass('tooltip')) {
                           $(this).tooltip("disable");
                           $(this).removeClass('tooltip');
                     }
              });
       }


       if( $('body').hasClass('LeviIN')){
              $('#primary').on('click', 'button[name$="dwfrm_billing_save"]', function(e) {
                 
                      if($('#easyPointRedemeed').val()>0 && ( $('#easyRewardOTPStatus').val()==undefined || $('#easyRewardOTPStatus').val()!=0))
                      {
                            e.preventDefault();
                            if (util.isMobile()) {
                                   alert(Resources.VALIDATE_LOYALTY_POINTS);
                                   return;
                            }
                            $(this).tooltip({ items: $(this), content: Resources.VALIDATE_LOYALTY_POINTS});
                            $(this).tooltip("open");
                            $(this).addClass('tooltip');
                            return;
                     }
                     else
                     {
                     var isPaymentMethodSelected = $('.payment-method-options').find('input[type="radio"]:checked').length;

                     if (!isPaymentMethodSelected) {
                           e.preventDefault();

                           if (util.isMobile()) {
                                  alert(Resources.SELECT_PAYMENT_METHOD);
                                  return;
                           }

                           $(this).tooltip({ items: $(this), content: Resources.SELECT_PAYMENT_METHOD});
                           $(this).tooltip("open");
                           $(this).addClass('tooltip');
                            return;

                     }
              }
                    
                   
              });

              $('#primary').on('mouseout', 'button[name$="dwfrm_billing_save"]', function (e) {
                     e.preventDefault();
                     if ($(this).hasClass('tooltip')) {
                           $(this).tooltip("disable");
                           $(this).removeClass('tooltip');
                     }
              });

       }
       
       $('[name$="_billing_save"]').on('click', function(e) {
           $('#dwfrm_billing').validate().form();
           
              if($('body.LeviAU').length>0)
              {  
                     if($('#dwfrm_billing_billingAddress_addressFields_states_state').val()=="")
                     {
				e.preventDefault();	
                           $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                     }
                     if ($('#dwfrm_billing_billingAddress_addressFields_states_state').val()=="") {
                           var errSpan = document.createElement('span');
                           errSpan.innerHTML = Resources.VALIDATE_STATE;
                           errSpan.className += "errspan error";
                           $('[name$="_addressFields_states_state"]').closest('.field-wrapper').append(errSpan);
                           return;
                     }
                     else {
                           $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                     }
              }
       });

       initPromoCodeLink();
    formPrepare.init({
        formSelector: 'form[id$="billing"]',
        continueSelector: '[name$="billing_save"]'
    }); 

    if ($(".billing-payment-methods").find(".gift-cert-used").length > 0){
              $('button[name$="dwfrm_billing_save"]').attr('disabled','disabled');
    }
   //$(".payment-method-options").accordion({header:".pMethod"});
    
       if($('body').hasClass('LeviIN')){
          // default payment method to 'CREDIT_CARD'
          updatePaymentMethod((selectedPaymentMethod) ? selectedPaymentMethod : 'Credit_Card');
   }
       else if($('body').hasClass('LeviAU')){
              // default payment method to 'PayPal'
      updatePaymentMethod(selectedPaymentMethod);
	      if($('#is-AFTERPAY_PBI').is(':checked')){
	    	  
	    	  $('#is-AFTERPAY_PBI').prop('checked', false);
	    	  $(".afterpay-payment").css('display','none');
	      }
       }else if($('body').hasClass('LeviKR') ){
              updatePaymentMethod("AdyenComponent");
       }

       if($('body').hasClass('LeviIN')){
              $('.pMethod input[type="radio"]').on('click', function () {
                     $('input[name=brandCode]').removeAttr('checked');
                     $(".additionalFields").css("display","none");
                     var selectedMethodId="";
                     selectedMethodId = $(this).val();

                     updatePaymentMethod(selectedMethodId);

                     if (selectedMethodId == 'Adyen' && $payType.length > 0) {
                           //set payment type of Adyen to the first one
                           updatePaymentType((selectedPayType) ? selectedPayType : $payType[0].value, false);
                     }
              });

       } else {

    -  $selectPaymentMethod.on('click', function () {
              var selectedMethodId="";
              if($('body').hasClass('LeviKR')){
                     selectedMethodId = $(this).val();
              }
              else if($('body').hasClass('LeviAU') || $('body').hasClass('LeviJP')){
                     selectedMethodId = $(this).find('input[type="radio"]').val();
                     $(".additionalFields").css("display","none");
              }
              updatePaymentMethod(selectedMethodId);
              if ($(this).val() == 'Adyen' && $payType.length > 0) {
                     // set payment type of Adyen to the first one
                     updatePaymentType((selectedPayType) ? selectedPayType : $payType[0].value, false);
              } else {
                     $payType.removeAttr('checked');
                     $issuerId.removeAttr('checked');
              }      

       });
    
       }
    

    $payType.on('click', function () {
       $('input[id=is-COD]').removeAttr('checked');
       $('input[id=is-AFTERPAY_PBI]').removeAttr('checked');
       $(".afterpay-payment").css('display','none');
      updatePaymentType($(this).val(), false);
      //if the payment type contains issuerId fields, expand form with the values
      if ($(this).siblings('#issuer').length > 0) {
        $issuer.show();
        updatePaymentType((selectedIssuerId) ? selectedIssuerId : $issuerId[0].value, true);
      } else {
             $issuer.hide();
             $('input[name="issuerId"]').removeAttr('checked');
      }
    });
      
    if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
       $(window).load(function(){ 
              setTimeout(function(){ 
                     $('[name="brandCode"]').on('click', function () {
                            $('input[id=is-COD]').removeAttr('checked');
                            $('input[id=is-AFTERPAY_PBI]').removeAttr('checked');
                            $(".afterpay-payment").css('display','none');
                            updatePaymentType($(this).val(), false);
                            updatePaymentMethod("AdyenComponent");
                     });
                     if($('body').hasClass('LeviIN')){
                            $('input[name=brandCode]').removeAttr('checked');
                            // $('input[id=is-COD]').prop('checked', 'checked');
                            $(".additionalFields").css("display","none");
                            $("ul#paymentMethodsList #lb_scheme").text(Resources.CREDIT_TEXT);
                            $("ul#paymentMethodsList #lb_wallet_IN").text(Resources.WALLET_TEXT);
                            $("ul#paymentMethodsList #lb_onlinebanking_IN").text(Resources.NB_TEXT);
                            $("ul#paymentMethodsList #lb_upi").text(Resources.UPI_TEXT);
                            $("ul#paymentMethodsList #upi-area-vpa .adyen-checkout__label__text").text(Resources.UPI_TEXT_VPA);
                            $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").before('<span class="adyen-checkout__label__text1">Enter Your UPI ID</span>');
                            $("#upi-area-vpa .adyen-checkout__label").click(function(){
                                   if($("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").length == 0){
                                          $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").before('<span class="adyen-checkout__label__text1">Enter Your UPI ID</span>');
                                   }
                            });
                            $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input").blur(function(){
                                   if($("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").length == 0){
                                   $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").before('<span class="adyen-checkout__label__text1">Enter Your UPI ID</span>');
                                   }
                            });
                            $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input").focus(function(){
                                   if($("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").length == 0){
                                          $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").before('<span class="adyen-checkout__label__text1">Enter Your UPI ID</span>');
                                   }
                            });
                            $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input").keyup(function(){
                                   if($("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").length == 0){
                                          $("#upi-area-vpa .adyen-checkout__label .adyen-checkout__input-wrapper").before('<span class="adyen-checkout__label__text1">Enter Your UPI ID</span>');
                                   }
                            });
                            $(document).click(function() {
                                   if ($(this) !== $("#upi-area-vpa .adyen-checkout__label")) {
                                          $("#upi-area-vpa .adyen-checkout__label").children(".adyen-checkout__label__text").text("Enter Your UPI ID");
                                   }
                            });
                     }else if($('body').hasClass('LeviAU')){
                            $('input[name=brandCode]').removeAttr('checked');
                            $('input[id=is-AFTERPAY_PBI]').removeAttr('checked');
                            $(".additionalFields").css("display","none");
                     }
              },500);
       });
       }
    $issuerId.on('click', function () {
      updatePaymentType($(this).val(), true);
    });
   
    // select credit card from list
    $('#creditCardList').on('change', function () {
        var cardUUID = $(this).val();
        if (!cardUUID) {return;}
        populateCreditCardForm(cardUUID);

        // remove server side error
        $('.required.error').removeClass('error');
        $('.error-message').remove();
    });

   
    // trigger events on enter
    $couponCode.on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $addCoupon.click();
        }
    });
 
       if($('body').hasClass('LeviKR')){
          if (SitePreferences.ADYEN_CSE_ENABLED) {
          }
    }
       if($('body').hasClass('LeviJP')){
          var hidePaymentOptions = $('#hidePaymentOptions').val();
          if(hidePaymentOptions == 'true') {
              $('.payment-method-options .pMethod').css('display','none');
            $('.payment-method-options .PaymentOptions').css('display','none');
          }
       }
    initializeCouponEvents();
       if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
              $(".secondary-minisummary .mini-cart-name").dotdotdot({
		ellipsis	: '...',
		wrap		: 'letter',
             fallbackToLetter: 'letter',
		after		: null,
 		watch		: true,
		height		: null,
		tolerance	: 0
              });
       }

    //To avoid multiple form submit on payment page
    $("#dwfrm_billing").submit(function() {
        // Show loader on form submit
        progress.show($('#primary'));
        // Disable pointer of footer menu
        $('.footer-container').css('pointer-events','none'); 
        $('[name$="_billing_save"]').css('pointer-events','none');
        $('[name$="_billing_save"]').css('opacity','0.5');
        $(this).submit(function() {
            return false;
        });
        return true;
    });
};

if($('body').hasClass('LeviKR')){
       $(window).load(function(){
              setTimeout(function(){
                     $('input[name="brandCode"]').click(function(){
                            $.ajax({
                                   type: "POST",
                                   url: Urls.updateSessionVariables,  
                                   data: {'action':'clear'},
                                   success: function(response) {
                                          
                                   }
                            });
                            $('input[name$="brandCode"]').removeAttr('checked');
                            $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
                            $('.neverpay').removeAttr('checked');
                            $(".adyen").prop('checked', 'checked');
                            $(this).prop('checked', 'checked');
                            var content = $("#neverpay").parent().parent().next();
                            console.log(content.attr("class"));
                            //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
                            content.slideUp(500);
                     });
              },500);
              $('#neverpay').click(function(){
                     $.ajax({
                            type: "POST",
                            url: Urls.updateSessionVariables,  
                            data: {'action':'clear'},
                            success: function(response) {
                                   
                            }
                     });
                     $('input[name$="brandCode"]').removeAttr('checked');
                     $('.adyen').removeAttr('checked');
                     $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
                     $('.neverpay-radio').prop('checked', 'checked');
                     $(this).prop('checked', 'checked');
                     var content = $(this).parent().parent().next();
                     console.log(content.attr("class"));
                     //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
                     content.slideDown(500);
              });
       });
       $(function() {
             $("#accordion1,#accordion2,#accordion3").click(function () {
            	 
            	 //deleting naverpay from session
            	 $.ajax({
         	        type: "POST",
         	        url: Urls.updateSessionVariables,  
         	        data: {'action':'clear'},
         	        success: function(response) {
         	       	 
         	            }
         	 });
             
               $(this).toggleClass('accordianopen');
              $(this).toggleClass('accordianclose');
              $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
              $(this).parent().prev().find('input[name$="_selectedPaymentMethodID"]').prop('checked', 'checked');
              $(this).parent().find('ul#type').find('input').prop('checked', 'checked');
               var header = $(this);
               var content = header.next();
               content.slideToggle(700,'linear');
       
              
                $(this).parent().siblings().find('.payment-method').slideUp();
                     
               var toggles= $(this).parent().siblings().find('.accordianclose');
               toggles.toggleClass('accordianclose');
               toggles.toggleClass('accordianopen');
             
                if ($(".checkout-overview .billing-payment-methods ").find(".accordianclose").length <= 0){ 
                       $('button[name$="billing_save"]').attr('disabled','disabled');
                    }
               else { 
                       $('button[name$="billing_save"]').removeAttr('disabled');
                    }
               var toggle=$(".checkout-overview .billing-payment-methods ").find('.accordianclose');
             
                       toggle.parent().prev().css("background-color", "#c41230");
                       toggle.parent().prev().css("color", "#ffffff");
                       toggle.parent().prev().css("border-color", "#c41230");
                     
                     var toggles=$(".checkout-overview .billing-payment-methods ").find('.accordianopen');
                     
                       toggles.parent().prev().css("background-color", "#f0f0f0");
                       toggles.parent().prev().css("color", "#00000");
                       toggles.parent().prev().css("border-color", "#cccccc");
                     
             });
             
              $(".pMethod").click(function () {
                     $(this).next().find('.payment-method').find('input').prop('checked', 'checked');
              });
                     
       });
}else if($('body').hasClass('LeviAU')){
       $(window).load(function(){
              setTimeout(function(){
                     $('input[id="is-AFTERPAY_PBI"]').click(function(){
                            $('input[name$="brandCode"]').removeAttr('checked');
                     });
              },500);
       });
}


       $('.LeviAU input[name$="_billing_billingAddress_addressFields_firstName"]').on('change', function() {
       $('.billing-address-firstname').html($(this).val());
       });
       $('.LeviAU input[name$="_billing_billingAddress_addressFields_lastName"]').on('change', function() {
              $('.billing-address-lastname').html($(this).val());
       });
       $('.LeviAU input[name$="_billing_billingAddress_addressFields_address1"]').on('change', function() {
              $('.billing-address-address1').html($(this).val());
       });
       $('.LeviAU input[name$="_billing_billingAddress_addressFields_address2"]').on('change', function() {
              $('.billing-address-address2').html($(this).val());
       });
       $('.LeviAU input[name$="_billing_billingAddress_addressFields_city"]').on('change', function() {
              $('.billing-address-city').html($(this).val());
       });

       $('.LeviAU select[name$="_billing_billingAddress_addressFields_states_state"]').on('change', function() {
              $('.billing-address-state').html($(this).val());
       });
       
//       $('.LeviAU select[name$="_billing_billingAddress_addressFields_country"]').on('change', function() {
//           $('.billing-address-countryName').html($(this).val());
//    });
       
       $('.LeviAU select[name$="_billing_billingAddress_addressFields_country"]').on('change', function() {
           $('.billing-address-countryName').html($('.LeviAU select[name$="_billing_billingAddress_addressFields_country"] option:selected').text());
     }); 

       $('.LeviAU input[name$="_billing_billingAddress_addressFields_postal"]').on('change', function() {
              $('.billing-address-postal').html($(this).val());
       });

       $('.LeviAU input[name$="_billing_billingAddress_addressFields_phone"]').on('change', function() {
              $('.phone').html($(this).val());
       });



if($('body').hasClass('LeviJP')){  
    $('select[name$="_expiration_month"] ').on('change', function () {
        $('span[aria-labelledby*="ui-id"][aria-owns$="_expiration_month-menu"] .ui-selectmenu-text').css('color', '#333');
        $('span[aria-labelledby="ui-id-1"][aria-owns$="_expiration_month-menu"] .ui-selectmenu-text').css('color', '#999');
    });
    
    $('select[name$="_expiration_year"]').on('change', function () {
          $('span[aria-labelledby*="ui-id"][aria-owns$="_expiration_year-menu"] .ui-selectmenu-text').css('color', '#333');
          $('span[aria-labelledby="ui-id-14"][aria-owns$="_expiration_year-menu"] .ui-selectmenu-text').css('color', '#999');
    });   
}  


if($('body').hasClass('LeviKR')){
	
	if( $('.billing-payment-methods').find('.updates').length > 0 ){ 
	    $('#primary').on('click', 'button[name$="dwfrm_billing_save"]', function(e) {
	
	           if (!$("input[name$='_signupprivacypolicy']").is(":checked") || !$("input[name$='_signupconsentprofiledata']").is(":checked")) {
	                 e.preventDefault();
	
	                 if (util.isMobile()) {
	                        alert(Resources.SELECT_MANDATORY_FILEDS);
	                        return;
	                 }
	
	                 $(this).tooltip({ items: $(this), content: Resources.SELECT_MANDATORY_FILEDS});
	                 $(this).tooltip("open");
	                 $(this).addClass('tooltip');
	
	                 return;
	           }
	    
	    });
		
	
	    $('#primary').on('mouseout', 'button[name$="dwfrm_billing_save"]', function (e) {
	           e.preventDefault();
	           if ($(this).hasClass('tooltip')) {
	                 $(this).tooltip("disable");
	                 $(this).removeClass('tooltip');
	           }
	    });
	}
}

$(document).ready(function() {
	 if ($('body').hasClass('LeviKR')) {
		var w = $('.pt_checkout  .updates').find('input'); 
	    for(var i = 0; i < w.length; i++){ 
	      if(w[i].type=='checkbox'){ 
	        w[i].checked = false; 
	      }
	    }
	 }
        if ($(".checkoutlogin .checkout-loginForm").find(".error-form").length > 0 && !$("body").hasClass("LeviKR") && !$("body").hasClass("LeviIN")){ 
              $(".checkoutlogin .checkout-loginForm").slideToggle(700,'linear');
              var toggle= $(".checkoutlogin .checkout-loginForm").prev(".accordianopen24x24");
              $(toggle).toggleClass('accordianopen24x24');
              $(toggle).toggleClass('accordianclose24x24');
       }
});

$('.oAuthIcon').on('click', function () {
       $('#OAuthProvider').val(this.id);
});

},{"../../adyen-checkout":5,"../../ajax":7,"../../dialog":18,"../../giftcard":19,"../../progress":55,"../../util":67,"./formPrepare":33}],33:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var $form, $continue, $requiredInputs, validator;

var hasEmptyRequired = function () {
    // filter out only the visible fields
    var requiredValues = $requiredInputs.filter(':visible').map(function () {
        return $(this).val();
    });
    return _(requiredValues).contains('');
};

var validateForm = function () {
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
    if (!validator) {
        return;
    }
    if (!hasEmptyRequired()) {
        if (validator.form()) {
            $continue.data('isdisabled', 'enabled');
        }
    } else {
        $continue.data('isdisabled', 'disabled');
    }
};

var validateEl = function () {
    if ($(this).val() === '') {
        $continue.data('isdisabled', 'disabled');
    } else {
        // enable continue button on last required field that is valid
        // only validate single field
        if (validator.element(this) && !hasEmptyRequired()) {
            $continue.data('isdisabled', 'enabled');
        } else {
            $continue.data('isdisabled', 'disabled');
        }
    }
};

var init = function (opts) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    $form = $(opts.formSelector);
    $continue = $(opts.continueSelector);
    validator = $form.validate();
    $requiredInputs = $('.required', $form).find(':input');
    validateForm();
    // start listening
    
    if ($('body').hasClass('LeviKR')) {
        $requiredInputs.on('change', validateEl);
        $requiredInputs.filter('input').on('keyup', _.debounce(validateEl, 200));
    }
    
    else if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')) {
    	$requiredInputs.on('focusout', validateEl);
        $requiredInputs.filter('input').on('focusout', _.debounce(validateEl, 200));
    }
    
};

exports.init = init;
exports.validateForm = validateForm;
exports.validateEl = validateEl;

},{"lodash":73}],34:[function(require,module,exports){
'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    address.init();
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else {
        billing.init();
    }

    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
        }
    }
};

},{"./address":31,"./billing":32,"./multiship":35,"./shipping":36}],35:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox() {
    $.each($('.item-list'), function () {
        var $this = $(this);
        var $giftMessage = $this.find('.gift-message-text');

        //handle initial load
        $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');

        //set event listeners
        $this.on('change', function () {
            $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
        });
    });
}


/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
    var $addressForm = $('form[name$="multishipping_editAddress"]'),
        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
        $addressList = $addressForm.find('.address-list'),
        add = true,
        originalUUID,
        resetOptionValue = false,
        selectedAddressUUID = $(target).parent().siblings('.select-address').val();

    $addressDropdown.on('change', function (e) {
        e.preventDefault();

        var selectedAddress = $addressList.find('select').val();
        if (selectedAddress !== 'newAddress') {
            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
                return add.UUID === selectedAddress;
            })[0];
            add = false;
            resetOptionValue = false;
            // proceed to fill the form with the selected address
            util.fillAddressFields(selectedAddress, $addressForm);
        } else if  (selectedAddress === 'newAddress') {
            add = true;
            resetOptionValue = true;
            $addressForm.find('.input-text, .input-select').val('');
        } else {
            //reset the form if the value of the option is not a UUID
            $addressForm.find('.input-text, .input-select').val('');
        }
    });

    $addressForm.on('click', '.cancel', function (e) {
        e.preventDefault();
        dialog.close();
    });

    $addressForm.on('submit', function (e) {
        e.preventDefault();
        if (!$addressForm.valid()) {
            return false;
        }

        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
            if (!response.success) {
                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
                return;
            }
            $('#multiaddresserror').toggleClass('hidden', response.success);

            var address = response.address,
                $shippingAddress = $(target).closest('.shippingaddress'),
                $select = $shippingAddress.find('.select-address'),
                $selected = $select.find('option:selected'),
                newOption = '<option value="' + address.UUID + '">' +
                    ((address.ID) ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' +
                    address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode +
                    '</option>';
            dialog.close();

            if (address.UUID !== originalUUID) {
                resetOptionValue = true;
            }

            if (add) {
                $('.shippingaddress select').removeClass('no-option').append(newOption);
                $('.no-address').hide();
            } else {
                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
            }
            // if there's no previously selected option, select it
            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
            }
        });
    });

    //preserve the uuid of the option for the hop up form
    if (selectedAddressUUID) {
        //update the form with selected address
        $addressList.find('option').each(function () {
            //check the values of the options
            if ($(this).attr('value') === selectedAddressUUID) {
                $(this).prop('selected', 'selected');
                $addressDropdown.trigger('change');
            }
        });
        originalUUID = selectedAddressUUID;
    }

    validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
    initMultiGiftMessageBox();
    if ($('.cart-row .shippingaddress .select-address').length > 0) {
        formPrepare.init({
            continueSelector: '[name$="addressSelection_save"]',
            formSelector: '[id$="multishipping_addressSelection"]'
        });
    }
    $('.edit-address').on('click', 'span', function (e) {
        dialog.open({url: this.attributes.href.value,  options: {open: function () {
            address.init();
            addEditAddress(e.target);
        }}});
    });
};

},{"../../dialog":18,"../../util":67,"../../validator":68,"./address":31,"./formPrepare":33}],36:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
util = require('../../util'),
formPrepare = require('./formPrepare'),
progress = require('../../progress'),
tooltip = require('../../tooltip'),
util = require('../../util'),
login = require('../../login'),
accountzip = require('../account'),
dialog = require('../../dialog'),
page = require('../../page'),
validator = require('../../validator'),
address = require('./address');
const pickupInstore = require('../product/pickupInstore');
var shippingMethods;
var $shipToMeform = $('.shippingform');
var selectedadress;
var shipToHomeAddress,shipToOtherAddress;
/**
* @function
* @description Initializes gift message box, if shipment is gift
*/
if ($('body').hasClass('LeviJP')) {
    function giftMessageBox() {
    // show gift message box, if shipment is gift
        var giftWrapSelected = $('input[name$="_shippingAddress_isGift"]:checked').val();
        if(giftWrapSelected){
            $.ajax({
                type: "POST",
                url: Urls.createGiftWrapLineItem,
                success: function(response) {
                    updateSummary();
                }
            });
        } else if(!giftWrapSelected){
            $.ajax({
                type: "POST",
                url: Urls.removeGiftWrapLineItem,
                success: function(response) {
                    updateSummary();
                }
            });
        }
    }
}

/**
* @function
* @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
*/
function updateSummary() {
      
       var $summary = $('.secondary-minisummary');
       // indicate progress
       progress.show($summary);
       // load the updated summary area
       $summary.load(Urls.summaryRefreshURL, function () {
              // hide edit shipping method link
              $summary.fadeIn('fast');
              $summary.find('.checkout-mini-cart .minishipment .header a').hide();
              $summary.find('.order-totals-table .order-shipping .label a').hide();

              // Add the following code to bind editing links to Amazon Pay server after updating html by ajax.
              var amazonPay = require('../../../../../int_amazonpay_sg/cartridge/js/amazon/amazonPay');
              amazonPay.bindEditingLinksToAmazonPayServer();

              initializeCouponEvents();
              initPromoCodeLink();
              if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
                     $(".singleshipping-page .mini-cart-name").dotdotdot({
                           ellipsis      : '...',
                           wrap          : 'letter',
                           fallbackToLetter: 'letter',
                           after         : null,
                           watch         : true,
                           height        : null,
                           tolerance     : 0
                     });
              }
       });
       progress.hide();
      
}

function initPromoCodeLink(){
       $('.order-totals-table').on('click', '.promo-details', function(e) {
              e.preventDefault();
              var promoDetails = $(this).find('div').html();
              dialog.open({
                     html: promoDetails,
                     options: {
                           title: $(this).siblings("span").text()
                     }
              });
       });    
}

function initializeCouponEvents()
{

       var $summary = $('.secondary-minisummary');
       var $removeCoupon =$summary.find('.remove-coupon');
       $removeCoupon.on('click', function(e){   
              var code = $(this).prev(".couponcode").find(".applied-coupon-code").text();
              var url = util.appendParamsToUrl(Urls.removeCoupon);
              ajax.postJson({
                           url: url,
                           dataType: "json",
                           data : {'couponCode': code, 'format': 'ajax'},
                           contentType: "application/json",
                           callback: function (response){
                                  var cpcode = response.CouponCode;
                                  $("#"+cpcode).remove();
                                  updateSummary();
                           }
                     });
       });
       var $adddeasyPoints =$summary.find('#easyrewardsAddPoint');
       $adddeasyPoints.on('click', function(e){   
              var points = $(this).parent().find('input').val();
              var pointRate = $("#EasyrewardPointsValue").val();
              var totalPoints = $("#EasyrewardTotalPoints").val();
              var url = util.appendParamsToUrl(Urls.addEasyRewardPoints);
              ajax.postJson({
                           url: url,
                           dataType: "json",
                           data : {'easyrewardPoints': points, 'easyrewardTotalPt':totalPoints ,'easyrewardPointsRate':pointRate ,'format': 'ajax'},
                           contentType: "application/json",
                           callback: function (response){
                                  var cpcode = response.EasyRewardPoint;
                                  
                                  updateSummary();
                           }
                     });
       });
       var $removeeasyPoints =$summary.find('#easyrewardsRemovePoint');
        $removeeasyPoints.on('click', function(e){   
               var url = util.appendParamsToUrl(Urls.removeEasyRewardPoints);
              ajax.postJson({
                           url: url,
                           dataType: "json",
                           data : {'format': 'ajax'},
                           contentType: "application/json",
                           callback: function (response){
                                  
                                  updateSummary();
                           }
                     });
       });

       var $addCoupon = $('#add-coupon');
       var $couponCode = $('input[name$="_couponCode"]');
       $addCoupon.on('click', function (e) {
              e.preventDefault();
              var $checkoutForm = $('.secondary-minisummary');
              var $error = $checkoutForm.find('.coupon-error'),
              code = $couponCode.val();
              if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
                     window.dataLayer = window.dataLayer || [];
                     dataLayer.push({
                            event: "customEvent",
                            eventCategory: "CouponApplyTracked",
                            eventAction: "shippingpage-promo-attempt",
                            eventLabel: code,
                            EventValue : "attempt"
                     });
              }
              if (code.length === 0) {
                     $error.html(Resources.COUPON_CODE_MISSING);
                     return;
              }
              var url = util.appendParamsToUrl(Urls.addCoupon);
              
        ajax.postJson({
                     url: url,
                     dataType: "json",
                     data : {'couponCode': code, 'format': 'ajax'},
                     contentType: "application/json",
                     callback: function (response){
                           var fail = false;
                           var msg = '';
                           if (!response) {
                                  msg = Resources.BAD_RESPONSE;
                                  fail = true;
                           } else if (!response.success) {
                                  msg = response.message.split('<').join('&lt;').split('>').join('&gt;');
                                  fail = true;
                           } else if(response.success && response.status!=='APPLIED'){
                                  msg = response.message;
                                  fail = true;
                           }
                           if (fail) {
                                  $error.html(safe_tags(msg));
                                  if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
                                          window.dataLayer = window.dataLayer || [];
                                          dataLayer.push({
                                                 event: "customEvent",
                                                 eventCategory: "CouponApplyTracked",
                                                 eventAction: "shippingpage-promo-error",
                                                 eventLabel: code,
                                                 EventValue : "failure"
                                          });
                                   }
                                   $('body').trigger('analytics:invalidCoupon', { status: response.status, couponCode: code });
                                  return;
                           }

                           if(response.success && response.status==='APPLIED' && response.baskettotal !== 0){
                                  showCouponInformation(response);
                                  updateSummary();
                                  //progress.hide();
                                  //initializeCouponEvents();
                                  if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
                                          window.dataLayer = window.dataLayer || [];
                                          dataLayer.push({
                                                 event: "customEvent",
                                                 eventCategory: "CouponApplyTracked",
                                                 eventAction: "shippingpage-promo-success",
                                                 eventLabel: code,
                                                 EventValue : "success"
                                          });
                                   }
                                   // Trigger GA4 Coupon Success Event
                                   $('body').trigger('analytics:couponSuccess', { couponCode: code });
                           }
                           //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
                           //this will force a page refresh to display the coupon message based on a parameter message
                           if (response.success && response.baskettotal === 0) {
                                  window.location.assign(Urls.billing);
                           }
                           if (!util.isMobile()) {
                                  if($('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')){
                                         setBorder();
                     }
                           }
                     }
      });
       });
       var availablepoint=$('#EasyrewardTotalPoints').val()==null?0:parseInt($('#EasyrewardTotalPoints').val());
       var points = $summary.find('#easyPointRedemeed').val();
       $('#dwfrm_cart_easyrewardTotalPt').val(availablepoint);
        $('#dwfrm_cart_easyrewardPointsRate').val($('#EasyrewardPointsValue').val());
        $('#dwfrm_cart_easyrewardPoints').prop('max', availablepoint);
       $('.displaymoney').html("(<span>&#8377;</span>"+points+")value");
       if(points>0)
       {
       $('.epointsavailable').find('span').text(availablepoint-(points/$('#EasyrewardPointsValue').val()));
       }
       else
       {
        $('.epointsavailable').find('span').text(availablepoint);
       }

       if($(".easyPoints").attr('max')==0)
		{
			$(".easyPoints").prop('disabled', true);
		}
		else
		{
			$(".easyPoints").removeAttr('disabled');
		}
              
      $(".easyPoints").on("keyup",function() {

       try {


              if (event.keyCode === 13) {
                     event.preventDefault();
                    
                     if($(this).val()=="")
                     {
                           $('#easyrewardsRemovePoint').click();
                     }
                     else if(!$('#easyrewardsAddPoint').is(":disabled") )
                      {
                       
                           $('#easyrewardsAddPoint').click();
                     }
                    
                }
              
       if (($(this).val() < parseInt($(this).attr('min')) || $(this).val() > parseInt($(this).attr('max'))) || ($(this).val()=='')) {
              $('#dwfrm_cart_easyrewardPoints-error').attr('style', 'display: block !important');
              $('#custom_easyrewardPoints-error').attr('style', 'display: none !important');
              $('#easyrewardsAddPoint').prop('disabled', true);

       }
       else if(parseInt($(this).val()) > parseInt($('#omniture-shipping-details').data('shippingdetail').Shipping_Total) )
       {
              $('#custom_easyrewardPoints-error').html('Please enter a value less than '+ parseInt($('#omniture-shipping-details').data('shippingdetail').Shipping_Total))
              $('#custom_easyrewardPoints-error').attr('style', 'display: block !important');
              $('#dwfrm_cart_easyrewardPoints-error').attr('style', 'display: none !important');
              $('#easyrewardsAddPoint').prop('disabled', true);
       }
       
       else {
              $('#dwfrm_cart_easyrewardPoints-error').attr('style', 'display: none !important')
              $('#custom_easyrewardPoints-error').attr('style', 'display: none !important');
              $('#easyrewardsAddPoint').removeAttr('disabled');
       }
       } catch (e) {
              console.log("Failed to handle keyup easypoints ::" + e.message);
       }
       });

      

       var $summary = $('#easyRewardsPoints');
       $('.easyRewards').show();
       var points = $summary.find('#easyPointRedemeed').val();
       if (points > 0) {
              $summary.find('#easyRewardEdit').show();
              $summary.find('#easyRewardConfirm').hide();
       }
       else {
              $summary.find('#easyRewardEdit').hide();
              $summary.find('#easyRewardConfirm').show();

       }
       $summary.find('#easyrewardsEditPoint').on('click', function (e) {
              $summary.find('#easyRewardEdit').hide();
              $summary.find('#easyRewardConfirm').show();

       });

       var inputBox = $('.easyRewards').find('input[type=number]');

		var invalidChars = [
		"-",
		"+",
		"e",
		];

		inputBox.on("keydown", function(e) {
		if (invalidChars.includes(e.key)) {
			e.preventDefault();
		}
		});


      
}

function safe_tags(str) {
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;') ;
}

$('#shipToStore-shippingmethods input[type="radio"]').click(function(){
       $('.shipToStore .checkout-shiptostore .stores li').removeClass('selected');
       var li = $(this).parent("li");
       li.addClass('selected');
});



function showCouponInformation(data)
{
       var couponInfo="<li class='redemption coupon form-row clearfix' id='"+data.CouponCode+"'>"+
       "<span class='couponcode'>"+"<span class='applied-coupon'>"+data.message+"</span></span>"+"<button class='button-text remove-coupon' type='button' name='removeCoupon'>"+Resources.REMOVE_COUPON+"</button>"+"</li>";

       $("ul.coupons-applied").append(couponInfo);


}

/**
* @function
* @description Helper method which constructs a URL for an AJAX request using the
* entered address information as URL request parameters.
*/
function getShippingMethodURL(url, extraParams) {
       var $form = $('.address');
       var params = {
                     address1: $form.find('input[name$="_address1"]').val(),
                     address2: $form.find('input[name$="_address2"]').val(),
                     //countryCode: $form.find('select[id$="_country"]').val(),
                     //stateCode: $form.find('select[id$="_state"]').val(),
                     postalCode: $form.find('input[name$="_postal"]').val(),
                     //city: $form.find('input[name$="_city"]').val()
       };
       return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
* @function
* @description selects a shipping method for the default shipment and updates the summary section on the right hand side
* @param
*/
function selectShippingMethod(shippingMethodID) {
       // nothing entered
       if (!shippingMethodID) {
              return;
       }

       if($('body').hasClass('LeviJP') && shippingMethodID=="shipToOther"){
               var sendername = $('#sendername').val();
               if(sendername != "null" && sendername !=" "){
                      $('#dwfrm_singleshipping_shippingAddress_sendername').val(sendername);
               }

       }
       // attempt to set shipping method
       var url = getShippingMethodURL(Urls.selectShippingMethodsList, {shippingMethodID: shippingMethodID});
       ajax.getJson({
              url: url,
              callback: function (data) {
                     updateSummary();
                     if (!data || !data.shippingMethodID) {
                           window.alert('Couldn\'t select shipping method.');
                           return false;
                     }
                     // display promotion in UI and update the summary section,
                     // if some promotions were applied
                     $('.shippingpromotions').empty();
              }
       });
}

/**
* @function
* @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
* based on the merchandise in the cart and the currently entered shipping address
* (the address may be only partially entered).  If the list of applicable shipping methods
* has changed because new address information has been entered, then issue another AJAX
* request which updates the currently selected shipping method (if needed) and also updates
* the UI.
*/
function updateShippingMethodList() {
       if($('body').hasClass('LeviKR')){
              var $shippingMethodList = $('#shipping-method-list');
       }
       else if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
              var $shippingMethodList = $('.method-list');
       }
       if (!$shippingMethodList || $shippingMethodList.length === 0) { return; }
       var url = getShippingMethodURL(Urls.shippingMethodsJSON);
       ajax.getJson({
              url: url,
              callback: function (data) {
                     if (!data) {
                           window.alert('Couldn\'t get list of applicable shipping methods.');
                           return false;
                     }
                     if (shippingMethods && shippingMethods.toString() === data.toString()) {
                           // No need to update the UI.  The list has not changed.
                           return true;
                     }

                     // We need to update the UI.  The list has changed.
                     // Cache the array of returned shipping methods.

                     shippingMethods = data;
                     // indicate progress
                     progress.show($shippingMethodList);


                     // load the shipping method form
                     var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
                     $shippingMethodList.load(smlUrl, function () {
                            if(!$('body').hasClass('LeviKR')){
                                   $shippingMethodList.fadeIn('fast');
                            }
                           // rebind the radio buttons onclick function to a handler.
                           $shippingMethodList.find('[name$="_shippingMethodID"]').click(function () {
                                  selectShippingMethod($(this).val());
                                  $('.singleshipping-page .shipToHome #shipping-method-list .form-row.form-indent').removeClass('selected');
                                  if($('body').hasClass('LeviKR')){
                                         $(this).parent(".field-wrapper").parent().addClass('selected');
                                  }
                                  else if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
                                         $('input[name$="_singleshipping_shippingAddress_shippingMethodID"]:checked').parent().parent().parent().parent().addClass('selected');
                                  }
                           });

                           // update the summary
                           updateSummary();
                           progress.hide();
                           tooltip.init();
                           //if nothing is selected in the shipping methods select the first one
                           if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                                  $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
                           }
                     });
              }
       });
}

/**
* @function
* @description Toggles the display on click of ship to home or ship to store
*/

if($('.deliveryOption .input-section:first input').is(":checked")) {
       document.getElementById("checkout-shipToHome").style.display = "block";
       document.getElementById("checkoutShipping").style.display = "block";
       document.getElementById("checkout-shipToStore").style.display = "none";
}
function selectHomeOrStore(){
       //Separate Event for hitting Zip Code Look Up button
       $('#findaddress').on('click', function (e) {
              e.preventDefault();
              accountzip.initZipCodeValidation();
       });
       // shipping checked validation
	if($('.deliveryOption .input-section:first input').is(":checked")) {
              document.getElementById("checkout-shipToHome").style.display = "block";
              document.getElementById("checkout-shipToStore").style.display = "none";
	}
	// else {
	// 	$(".checkout-shipping").hide();
	// }
       $('.deliveryOption .input-section:first input').click(function(){
              $(".checkout-shiptostore").hide();
              if($('body').hasClass('LeviKR')){
                     $(this).attr('checked','checked');
                     $('.deliveryOption .input-section:last input').removeAttr("checked");
              }
              document.getElementById("checkout-shipToStore").style.display = "none";
              $(".checkout-shipping").show();
              
              document.getElementById("checkout-shipToHome").style.display = "block";
              $('div.error-message').hide();
              updateShippingMethodList();
              if (!util.isMobile()) {
                     if($('body').hasClass('LeviJP')){
                           setBorder();
             }
              }
              //updating the value of the selected shipping method in the order summary on click of ship to home
              var isShippingSelected = $('[name$="_singleshipping_shippingAddress_shippingMethodID"]').is(":checked");
              if(isShippingSelected == true){
                     var selectedShippingMethod = $('[name$="_singleshipping_shippingAddress_shippingMethodID"]:checked').val();
                     selectShippingMethod(selectedShippingMethod);
                     if($('body').hasClass('LeviKR')){
                            $('input[name$="_singleshipping_shippingAddress_shippingMethodID"]:checked').parent().parent().addClass('selected');
                     }
                     else if($('body').hasClass('LeviKR')){
                            $('input[name$="_singleshipping_shippingAddress_shippingMethodID"]:checked').parent().parent().parent().parent().addClass('selected');
                     }
              }
       });
       $('.deliveryOption .input-section:last input').click(function(){
              $(".checkout-shiptostore").show();
              if($('body').hasClass('LeviKR')){
                     $(this).attr('checked','checked');
                     $('.deliveryOption .input-section:first input').removeAttr("checked");
              }
              document.getElementById("checkout-shipToStore").style.display = "block";
              $(".checkout-shipping").hide();
              document.getElementById("checkout-shipToHome").style.display = "none";

              $('div.error-message').hide();
              if (!util.isMobile()) {
                     if($('body').hasClass('LeviJP')){
                           setBorder();
             }
             }
              formPrepare.init({
                     continueSelector: '[name$="shippingAddress_save"]',
                     formSelector:'[id$="singleshipping_shippingAddress"]'
              });
              
              //updating the value of the selected store shipping method in the order summary on click of ship to store
              var isStoreSelected = $('[name$="_singleshipping_inStoreShipments_storeID"]').is(":checked");
              if(isStoreSelected == true){
                     var selectedStoreShippingMethod = $('[name$="_singleshipping_inStoreShipments_storeID"]:checked').data('attribute');
                     selectShippingMethod(selectedStoreShippingMethod);
              }
              $("input").next("span.error").remove();
              $("input").removeClass('error');

              $("label.error").remove();
       });

}

if ($('body').hasClass('LeviJP')) {
       function selectToMeOrOther(){
              //Separate Event for hitting Zip Code Look Up button
              $('#findaddress').on('click', function (e) {
                     e.preventDefault();
                     accountzip.initZipCodeValidation();
              });
              var isShippingSelected = $('[name$="_singleshipping_deliveryPref"]').is(":checked");
              if(isShippingSelected == true){
                     var selectedShippingMethod = $('[name$="_singleshipping_deliveryPref"]:checked').val();
                     selectShippingMethod(selectedShippingMethod);
              }
              
              $('.deliveryOption .input-section:first input').click(function(){
                     $('.deliveryOption .input-section:last input').parent().removeClass('active');
                     $(".checkout .shipToOther").hide();
                            $(this).attr('checked','checked');
                            $(this).parent().addClass('active');
                            $('.deliveryOption .input-section:last input').removeAttr("checked");
                     document.getElementById("checkout-shipToOther").style.display = "none";
                     $(".checkout-shipping").show();
                    selectedadress = getAddress();
                    util.fillAddressFields(selectedadress, $shipToMeform);
                    document.getElementById("checkout-shipToMe").style.display = "block";
                    if($('#customer-address').length > 0){
                      if($('#dwfrm_singleshipping_addressList-button .ui-selectmenu-text').text() =="新しい住所を入力して下さい"){
                             document.getElementById("shippingform").style.display = "block";
                             document.getElementById("customer-default-address").style.display = "block";
                      }else{
                             document.getElementById("shippingform").style.display = "none";
                             if (!util.isMobile()) {
                                   
                                  setBorder();
                    
                             }
                             if($('#shippingform input:empty').length==10){
                                   selectedadress = $('#dwfrm_singleshipping_addressList option[data-isdefaultaddress="true"]').data('address');
                                   util.fillAddressFields(selectedadress, $shipToMeform);
                                   address.updateAddress($('#dwfrm_singleshipping_addressList option[data-isdefaultaddress="true"]').val());
                                   $('#shippingform .input-text').removeClass('error');
                             $('#shippingform span.error').remove();
                             $('#dwfrm_singleshipping_addressList-button .ui-selectmenu-text').text('別のお届け先を選択');
                             }
                      }
                      
                    }else{
                      document.getElementById("shippingform").style.display = "block";
                    }
                    $('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').closest('.form-row').css('display','block');
                    if ($('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val()=="") {
                      $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state option[value=""]').attr('selected','selected');
                        $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button .ui-selectmenu-text').text("都道府県");
                        $("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(""); 
                                  }
                   
                     $('div.error-message').hide();
                     $('.needsched-disclaimer').find('span.errspan.error').remove();
                     var isShippingSelected = $('[name$="_singleshipping_deliveryPref"]').is(":checked");
                     if(isShippingSelected == true){
                            var selectedShippingMethod = $('[name$="_singleshipping_deliveryPref"]:checked').val();
                            selectShippingMethod(selectedShippingMethod);
                     }
                     updateShippingMethodList();
                     if (!util.isMobile()) {
                            
                                  setBorder();
                    
                     }
                   
              });
              $('.deliveryOption .input-section:last input').click(function(){
                     $(this).parent().addClass('active');
                     $('.deliveryOption .input-section:first input').parent().removeClass('active');
                     if($('#dwfrm_singleshipping_shippingAddress_sendername').val()!=""){
                             $('.checkout-shipToOther').removeClass('hide');
                            $('#checkout-shipToOther .form-row').removeClass('error');
                      }else{
                             $('.checkout-shipToOther').removeClass('hide');
                      }
                    $(this).attr('checked','checked');
                    $('.deliveryOption .input-section:first input').removeAttr("checked");
                    document.getElementById("checkout-shipToOther").style.display = "block";
                    $(".checkout-shipping").hide();
                    document.getElementById("checkout-shipToMe").style.display = "none";
                   document.getElementById("shippingform").style.display = "block";
                    selectedadress = getAddress();
                    $("#shippingform").find('input:text').val('');
                    if (util.isMobile()) {
                    	$("#dwfrm_singleshipping_shippingAddress_addressFields_phone").val('');
                    	$("#dwfrm_singleshipping_shippingAddress_addressFields_postal").val('');
                    }
                    
                    if($('#shippingform input:empty').length==10){
                      $('#shippingform .input-text').removeClass('error');
                      $('#shippingform span.error').remove();
                    }
                    var email = $('#loggedincustomeremail').val();
                    $('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').val(email);
                    $('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').closest('.form-row').css('display','none');
                    util.fillAddressFields(selectedadress, $shipToMeform);
                     $('div.error-message').hide();
                     if ($('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val()=="") {
                     $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state option[value=""]').attr('selected','selected');
                         $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button .ui-selectmenu-text').text("都道府県");
                         $("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(""); 
                                  }
                     $('.needsched-disclaimer').find('span.errspan.error').remove();
                     var isShippingSelected = $('[name$="_singleshipping_deliveryPref"]').is(":checked");
                     if(isShippingSelected == true){
                            var selectedShippingMethod = $('[name$="_singleshipping_deliveryPref"]:checked').val();
                            selectShippingMethod(selectedShippingMethod);
                     }
                    
                     if (!util.isMobile()) {
                            
                      setBorder();
                    
        
                 }
                     formPrepare.init({
                            continueSelector: '[name$="shippingAddress_save"]',
                            formSelector:'[id$="singleshipping_shippingAddress"]'
                     });
              });
              $('.mini-shipment.order-component-block').css('display','none');
       }
}      


function getAddress(){
    if($('input[name=dwfrm_singleshipping_deliveryPref]:checked').val() == "shipToOther"){
	              shipToHomeAddress={
	                           firstName: $('[name$=_shippingAddress_addressFields_firstName]').val(),
	                          lastName: $('[name$=_shippingAddress_addressFields_lastName]').val(),
	                          kanaFirstName: $('[name$=_shippingAddress_addressFields_kanafirstname]').val(),
	                          kanaLastName: $('[name$=_shippingAddress_addressFields_kanalastname]').val(),
	                          address1: $('[name$=_shippingAddress_addressFields_address1]').val(),
	                          address2: $('[name$=_shippingAddress_addressFields_address2]').val(),
	                          postalCode: $('[name$=_shippingAddress_addressFields_postal]').val(),
	                          city: $('[name$=_shippingAddress_addressFields_city]').val(),
	                          email:$('[name$=_shippingAddress_addressFields_emailAddress]').val(),
	                          stateCode: $("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(),
	                          phone: $('[name$=_shippingAddress_addressFields_phone]').val()         
	                             
	               }
           selectedadress=shipToOtherAddress;
    }else{
	    	   shipToOtherAddress={
	                           firstName: $('[name$=_shippingAddress_addressFields_firstName]').val(),
	                          lastName: $('[name$=_shippingAddress_addressFields_lastName]').val(),
	                          kanaFirstName: $('[name$=_shippingAddress_addressFields_kanafirstname]').val(),
	                          kanaLastName: $('[name$=_shippingAddress_addressFields_kanalastname]').val(),
	                          address1: $('[name$=_shippingAddress_addressFields_address1]').val(),
	                          address2: $('[name$=_shippingAddress_addressFields_address2]').val(),
	                          postalCode: $('[name$=_shippingAddress_addressFields_postal]').val(),
	                          city: $('[name$=_shippingAddress_addressFields_city]').val(),
	                          email:$('[name$=_shippingAddress_addressFields_emailAddress]').val(),
	                          stateCode: $("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(),
	                          phone: $('[name$=_shippingAddress_addressFields_phone]').val()         
	                             
	               }
	    	   if($("#addresssize").val() == 0 && localStorage.getItem("fromBilling") == "true"){
		    		   shipToHomeAddress={
		                       firstName: $('#loggedincustomerfirstname').val(),
		                      lastName: $('#loggedincustomerlastname').val(),
		                      kanaFirstName: $('#loggedincustomerkanafirstname').val(),
		                      kanaLastName: $('#loggedincustomerkanalastname').val(),
		                      address1: '',
		                      address2: '',
		                      postalCode: '',
		                      city: '',
		                      email:'',
		                      stateCode: '',
		                      phone: ''         
		                         
		           }
	    	   }
           selectedadress=shipToHomeAddress;
    }
    
     return selectedadress;
}

/**
* @function
* @description Loads Store Shipping Method on selection of store
*/
function showStoreShippingMethod() {
       $('input[name$="_singleshipping_inStoreShipments_storeID"]').on('click', function (e) {
              var selectedStoreShippingMethod = $(this).data('attribute');
              selectShippingMethod(selectedStoreShippingMethod);
              if($('body').hasClass('LeviAU')){
                     $('.shipToStore .checkout-shiptostore .stores li').removeClass('selected');
                     $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').parent().addClass('selected');
              }
       });
}

function setBorder() {
       if($('body').hasClass('LeviJP')){
                setTimeout(function() { 
                 $(".deliveryoption-div").css('min-height', 'auto');
                 $("#addressBookWidgetDiv").css('min-height','auto');
                 $(".secondary-minisummary").css('min-height','auto');
                 
         if( ($(".secondary-minisummary").height() > $(".deliveryoption-div").height())||($(".secondary-minisummary").height() > $("#addressBookWidgetDiv").height())){
                $(".deliveryoption-div").css('min-height', $(".secondary-minisummary").height());
                $("#addressBookWidgetDiv").css('min-height', $(".secondary-minisummary").height());
           }
          if( ($(".deliveryoption-div").height() > $(".secondary-minisummary").height())||($("#addressBookWidgetDiv").height() > $(".secondary-minisummary").height())){
                $(".secondary-minisummary").css('min-height',$(".deliveryoption-div").height());
                $(".secondary-minisummary").css('min-height',$("#addressBookWidgetDiv").height());
          }
                }, 50);
       }
       else {
                     if( $(".secondary-minisummary").height() > $("#shipToHome-addressfields").height()){
                           $("#shipToHome-addressfields").css('min-height', ($(".secondary-minisummary").height()) + 10);
                     }
                      else {
                           $(".secondary-minisummary").css('min-height',$("#shipToHome-addressfields").height());
                     }
       }
      
}

if ($('body').hasClass('LeviJP')) {
    $('[name*="_singleshipping_shippingAddress_addressFields_"]').on('click', function (e) {
        if($(this).length > 0){
            $(this).next().remove();
            $(this).removeClass('error');
            $(this).removeClass('error');
        }
     });
}

exports.init = function () {
       formPrepare.init({
              continueSelector: '[name$="shippingAddress_save"]',
              formSelector:'[id$="singleshipping_shippingAddress"]'
       });

       // pincode - cod check
       
       $('[id$="_shippingAddress_addressFields_postal"]').attr('autocomplete','off');
       
       $('body.LeviIN').on('paste', '[id$="_shippingAddress_addressFields_postal"]', function(e) {
              e.preventDefault();
       });
       
       $('body.LeviIN').on('input', '[id$="_shippingAddress_addressFields_postal"]', function(e) {
              var charLength = $(this).val().length;
              if (charLength == 6 ) {
                     var pinCode = $(this).val(); 
                     if (pinCode.length == 6) {
                           util.checkDeliveryAvailability($(this).val());
                     }
              }
              else {
                     $(this).closest('div.postalcode').find('#cod-status-section').hide();
              }
       });
       
       // the below code is for showing the correct state select error message for India site
       if($('body.LeviIN').length > 0)
       { 
              $("span#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button").css('pointer-events','none');
              $("span#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button").css('background-color','#dad8d8');
              if($('.deliveryOption .input-section:first input').attr('checked') == "checked" || SitePreferences.STORE_PICKUP == false) {
                     $('[name$="_addressFields_states_state"]').on('change', function(e) {
                           if ($(this).closest('.form-row').find('.error-message')) {
                                  $(this).closest('.form-row').find('.error-message').hide();
                           }
                           if ($(this).val()=="") {
                                  $(this).closest('.form-row').find('.error-message').show();          
                           }
                     });
              }
       }  // code ends for showing the state select error

       if($('body.LeviAU').length > 0)
       { 
              if($('.deliveryOption .input-section:first input').attr('checked') == "checked" || SitePreferences.STORE_PICKUP == false) {
                     $('[name$="_addressFields_states_state"]').on('change', function(e) {
                           e.preventDefault();
                           if ($(this).val()=="") {
                                  var errSpan = document.createElement('span');
                                  errSpan.innerHTML = Resources.VALIDATE_STATE;
                                  errSpan.className += "errspan error";
                                  $(this).closest('.field-wrapper').append(errSpan);
                                  return;
                           }
                           else {
                                  $(this).closest('.field-wrapper').find('.errspan').remove();
                           }

                     });
              }
       }

       if($('body').hasClass('LeviJP')){
                        $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').on('change', function(e) {
                           if ($('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val()=="") {
                                  $('.field-wrapper .input-select').css('display','block').css('position','absolute').css('opacity','0').css('width','10px');
                           }
                           else {
                                  $(this).closest('.form-row').find('.error').hide();
                           }
              
                     });
       }
              
       $('[name$="_shippingAddress_save"]').on('click', function(e) {
         if($('body').hasClass('LeviJP')){
        	 
        	 var lname = $('.field-wrapper #dwfrm_singleshipping_shippingAddress_addressFields_lastName').val(); 
        	 var fname = $('#dwfrm_singleshipping_shippingAddress_addressFields_firstName').val();
        	 var kanalname = $('#dwfrm_singleshipping_shippingAddress_addressFields_kanalastname').val();
        	 var kanafname = $('#dwfrm_singleshipping_shippingAddress_addressFields_kanafirstname').val(); 
        	 var email = $('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').val();
        	 var phone = $('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val();
        	 var postal = $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val(); 
        	 var state = $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val(); 
        	 var address_city = $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val(); 
        	 var address = $('#dwfrm_singleshipping_shippingAddress_addressFields_address1').val();        	 

        	 if(lname== '' || fname== '' || kanalname== '' || kanafname== '' || email== '' || phone== '' || postal== '' || state== '' || address_city== '' || address == '') {
        	 	$('.shipToOther, .shippingform').css("display","block");
        	 	$("#shippingform .form-row.required .input-text,.form-row.required .input-select").each(function(e) {
        	 		var idOfAttribute = $(this).attr('id');
        	 		var idwithhash = '#'+idOfAttribute;
        	 		if ($(idwithhash).parent().find('.error').length>0) {
        	 			var idforerror= 'label'+idwithhash+'-error';
	         		    $(idforerror).hide();
	         	     }
                });	        	 	
        	 }
	        	 
                $('.LeviJP .primary-content').on ('click', '[name$="shippingAddress_save"]', function(e) {
                       if($('input[name=dwfrm_singleshipping_deliveryPref]:checked').val() == "shipToOther" && $('#dwfrm_singleshipping_shippingAddress_sendername').val() == ""){
                    	   var fieldmissing=false;
                    	   $("#shippingform .form-row.required .input-text,.form-row.required .input-select").each(function(e) {
                               if($(this).val()=="")
                                     {
                                      fieldmissing=true;
                                     }
                                     if(fieldmissing == true) {
                                      return false; 
                                   }
                                     
                         });
                    	   if(fieldmissing == false){
                    	      e.preventDefault(); 
                              if($('.checkout-shipToOther .form-row span.errspan.error').length == 0){
                              var errSpan = document.createElement('span');
		                      errSpan.innerHTML = Resources.VALIDATE_NAME;
		                      errSpan.className += "errspan error";
		                      $('[name$="_singleshipping_shippingAddress_sendername"]').closest('.field-wrapper').append(errSpan);
		                      $('.checkout-shipToOther .input-text').addClass('error');
                            }
                    	   }
                      }
                      
                       if($('input:radio[name=dwfrm_singleshipping_deliveryType]:checked').val() == "お届け日を指定する"){
                            var mandatoryfieldmissing=false;
                                 if($('#estDeliveryDate').val() =="" || $('#estDeliverySlot').val() == ""){
                                        $("#shippingform .form-row.required .input-text,.form-row.required .input-select").each(function(e) {
                                                if($(this).val()=="")
                                                      {
                                                       mandatoryfieldmissing=true;
                                                      }
                                                      if(mandatoryfieldmissing == true) {
                                                       return false; 
                                                    }
                                                      
                                          });
                                               if(mandatoryfieldmissing == false){
                                                      e.preventDefault();  
                                                       if($('.need-delivery span.errspan.error').length == 0){
                                                    	   		var errSpan = document.createElement('span');
                                                               errSpan.innerHTML = Resources.VALIDATE_NAME;
                                                               errSpan.className += "errspan error";
                                                               $('.needsched-disclaimer').prepend(errSpan);
                                                             }
                                                      if($('.need-delivery span.errspan.error').length ==1){
                                                    	  $('.need-delivery span.errspan.error').css('display','block');
                                                      }
                                               }
                                               }
                                        }
                      
                       if($('#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button .ui-selectmenu-text').text()=="都道府県"){
                             $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state.input-select').css('display','block').css('position','absolute').css('opacity','0').css('width','10px');
                       }
                          
                       if($('.emailerror.error').length == 1){
                    	  e.preventDefault(); 
                    	  if (util.isMobile()) {
                    		  $(window).scrollTop($('.emailerror.error').offset().top + (-200));
                    	  }
                     	  $('.emailerror.error').css('display','block');
                       }
                       
                       if($('.shipping-userRegisteredError-error').length == 1){
                    	   $('[name$="_singleshipping_shippingAddress_addressFields_emailAddress"]').addClass('error');
                       }
                
                 });
         }
         
          
              if($('body.LeviAU').length>0)
              {  
                if($('.deliveryOption .input-section:first input').attr('checked') == "checked" || SitePreferences.STORE_PICKUP == false)
                {    
                     $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                     if($('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val()=="")
                     {
                           e.preventDefault();  
                           $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                     }
                     if ($('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val()=="") 
                     {
                           var errSpan = document.createElement('span');
                           errSpan.innerHTML = Resources.VALIDATE_STATE;
                           errSpan.className += "errspan error";
                           $('[name$="_addressFields_states_state"]').closest('.field-wrapper').append(errSpan);
                           return;
                     }
                     else {
                           $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                     }
                }
              }
       });
       
       
       $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
       if($('body').hasClass('LeviAU')){
              //     omniture tag goes here
              $('input[name$="dwfrm_singleshipping_deliveryPref"]').attr('data-event', 'event-data-checkout');
              $('#dwfrm_singleshipping_deliveryPref_0').attr('data-checkout', 'ShiptoHome');
              $('#dwfrm_singleshipping_deliveryPref_1').attr('data-checkout', 'ShiptoStore');
       }

       $('.address').on('change',
                     'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], input[name$="_addressFields_zip"]',
                     updateShippingMethodList
       );

       $('.oAuthIcon').on('click', function () {
              $('#OAuthProvider').val(this.id);
       });

       $('.LeviKR .primary-content').on ('click', '[name$="shippingAddress_save"]', function(e) {
              
              if ($(this).data('isdisabled') == 'disabled') {
                     e.preventDefault();

                     if (util.isMobile()) {
                           alert(Resources.MANDATORY_FIELD);
                            return;
                     }

                     $(this).tooltip({ items: $(this), content: Resources.MANDATORY_FIELD});
                     $(this).tooltip("open");
                     $(this).addClass('tooltip');

                     return;
              }
       });
       
       $('.primary-content').on ('click', '[name$="shippingAddress_save"]', function(e) {
              if ($('body').hasClass('LeviKR') || $('body').hasClass('LeviJP')) {
                     return;
              }
              if ($('body').hasClass('LeviIN')) {
                     if ($('[name$="_addressFields_states_state"]').val()=="") 
                     {      
                                  e.preventDefault();
                                  $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                                  
                                  var buttonfield = $('[name$="_shippingAddress_save"]');
                    
                     buttonfield.tooltip({ items: buttonfield, content: Resources.MANDATORY_FIELD});
                    buttonfield.tooltip("open");
                    buttonfield.addClass('tooltip');

                          var errSpan = document.createElement('span'); 
                           errSpan.innerHTML = Resources.REENTER_PINCODE;
                          errSpan.className += "errspan error";
                          $('[name$="_addressFields_states_state"]').closest('.field-wrapper').append(errSpan);
                                  return;
                     }      
              }
              var isStoreSelected = true;
              if($('.deliveryOption .input-section:last input').attr('checked') == "checked") {
                     if (!$('#store-list-shipping li.selected').length) {
                           isStoreSelected = false;
                     }
                     
              }
              
              
              if ($(this).data('isdisabled') == 'disabled' ) {
                     e.preventDefault();

                     if (util.isMobile()) {
                           alert(Resources.MANDATORY_FIELD);
                           return;
                     }
                     if(isStoreSelected == false) {
                           $(this).tooltip({ items: $(this), content: Resources.SELECT_A_STORE_FOR_SHIPPING});
                     }
                     else {
                           $(this).tooltip({ items: $(this), content: Resources.MANDATORY_FIELD});
                     }
                     $(this).tooltip("open");
                     $(this).addClass('tooltip');
                     $("#dwfrm_singleshipping_shippingAddress").validate().form();
                     return;
              }
              else if ($(this).attr('data-deliverable') == 'no') {
                     e.preventDefault();
                     var x = sessionStorage.getItem("storeID");
                     var lengthof = x.length;
                     var errMsg = "";

                     if ($('body').hasClass('LeviIN')){
                            if(isStoreSelected == false) {
                                   // $(this).tooltip({ items: $(this), content: Resources.SELECT_A_STORE_FOR_SHIPPING});
                                   errMsg = Resources.SELECT_A_STORE_FOR_SHIPPING;
                             }
                             
                             else if(lengthof>0){
                                    $('[name$="_shippingAddress_save"]').attr('data-deliverable', 'yes');
                                    errMsg='';
        
                             }
                             else {
                                   // $(this).tooltip({ items: $(this), content: Resources.PINCODE_NOT_DELIVERABLE});
                                   errMsg = Resources.PINCODE_NOT_DELIVERABLE;
                             }

                     }
                     else {
                            if(isStoreSelected == false) {
                           // $(this).tooltip({ items: $(this), content: Resources.SELECT_A_STORE_FOR_SHIPPING});
                           errMsg = Resources.SELECT_A_STORE_FOR_SHIPPING;
                            }
                            else {
                           // $(this).tooltip({ items: $(this), content: Resources.PINCODE_NOT_DELIVERABLE});
                           errMsg = Resources.PINCODE_NOT_DELIVERABLE;
                            }
                     }

                     if (util.isMobile()) {
                           alert(errMsg);
                           return;
                     }


                     $(this).tooltip({ items: $(this), content: errMsg});
                     $(this).tooltip("open");
                     $(this).addClass('tooltip');

                     return;
              }

              else if (!isStoreSelected) {
                     
                     e.preventDefault();

                     if (util.isMobile()) {
                           alert(Resources.SELECT_A_STORE);
                           return;
                     }

                     $(this).tooltip({ items: $(this), content: Resources.SELECT_A_STORE});
                     $(this).tooltip("open");
                     $(this).addClass('tooltip');

                     return;
                     
              }
       });

       
       if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')) {
              
              $('.primary-content').on('keypress focusout', '.checkoutlogin .firstname', function(e) {
             $('.error-form').hide();
      
     });
              $('.primary-content').on('keypress focusout', '.checkoutlogin .password', function(e) {
                    $('.error-form').hide();
       });
       }
       
       
       
       $('.primary-content').on('mouseout', '[name$="shippingAddress_save"]', function (e) {
              e.preventDefault();
              if ($(this).hasClass('tooltip')) {
                     $(this).tooltip("disable");
                     $(this).removeClass('tooltip');
              }
       });
       
       $('#password-reset').on('click', function (e) {               
        e.preventDefault();
        
        dialog.open({
             url: $(e.target).attr('href'),
             options: {}
        });
        dialog.close();
        
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
             dialogClass:"reset-password",
                open: function () {

                    $('.reset-password').on('click', '.reset-password-button', function(e) {
                    e.preventDefault();
                    dialog.close();
                    });
                    validator.init();                        
                    
                    $('#dialog-container').on('keypress focusout', '#PasswordResetForm .email', function(e) {
                    if ($(this).closest('.field-wrapper').find('.errspan').hasClass('error')) {
                          $(".errspan").removeClass('error').text('');
                          $(".form-row").removeClass('error');
                    }
                    }); 
                    
                    var $requestPasswordForm = $('[name$="_requestpassword"]');
                    var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
                    $($submit).on('click', function (e) {
                        if (!$requestPasswordForm.valid()) {
                            return;
                        }
                        e.preventDefault();
                        var data = $requestPasswordForm.serialize();
                        // add form action to data
                        data += '&' + $submit.attr('name') + '=';
                        // make sure the server knows this is an ajax request
                        if (data.indexOf('ajax') === -1) {
                            data += '&format=ajax';
                        }
                        $.ajax({
                            type: 'POST',
                            url: $requestPasswordForm.attr('action'),
                            data: data,
                            success: function (response) {
                                if (typeof response === 'object' &&
                                        !response.success &&
                                        response.error === 'CSRF Token Mismatch') {
                                    page.redirect(Urls.csrffailed);
                                } else if (typeof response === 'string') {
                                                                          
                                    if (response == 'email error') {
                                               var errSpan = document.createElement('span');
                                               errSpan.innerHTML = Resources.NOT_REGISTERED_EMAIL;
                                               errSpan.className += "errspan error";
                                               $submit.closest('fieldset').find('.field-wrapper').append(errSpan);
                                        return;
                                        }
                                        else {
                                               $(this).closest('.field-wrapper').find('.errSpan').remove();
                                               dialog.$container.html(response); 
                                               
                                         }
                                }
                            },
                            failure: function () {
                                dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                            }
                        });
                    });
                }
            }
        });
        
    }); 
       
       if($('body').hasClass('LeviAU')){
              // By default first store is selected from available list 
              if($('.shipToStore .checkout-shiptostore .stores label:nth-child(1) li input:nth-child(1)').attr('checked')=="checked")
              {
                     $('.shipToStore .checkout-shiptostore .stores label:nth-child(1) li').addClass('selected');
              }
       }
       
       
       //ATL on shipping page for Australia
       if($('body').hasClass('LeviAU')){
              var ship_instruction = $('.input-text.shippingInstructions') 
              if($('input[name$="_deliverySignature"]').is(':checked'))
                     {
                           ship_instruction.val(Resources.ATL_MESSAGE);
                           ship_instruction.attr("readonly","readonly");
                           ship_instruction.css({"border": "1px solid #ccc", "color": "#ccc", "font-size": "14px"}); 
                     }
              $('input[name$="_deliverySignature"]').change(function() {
                     if($(this).is(':checked')) {
                           ship_instruction.val(Resources.ATL_MESSAGE);
                           ship_instruction.attr("readonly","readonly");
                           ship_instruction.css({"border": "1px solid #ccc", "color": "#ccc", "font-size": "14px"}); 
                     }
                     else { 
                           ship_instruction.val('');
                           ship_instruction.removeAttr('readonly');
                           ship_instruction.css({"color": "inherit"});
                     }
              });
       }
       
       //ATL on shipping page for Australia ends

       updateShippingMethodList();
       if(!$('body').hasClass('LeviJP')){
       selectHomeOrStore();
       }
       showStoreShippingMethod();
       initializeCouponEvents();
       initPromoCodeLink();

       if($('body').hasClass('LeviJP')){
           selectToMeOrOther();
       }  
      
       window.onload = function() {
              
              if (!util.isMobile()) {
                     if($('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')){
                           setBorder();
                     }
              }

                           if($('body').hasClass('LeviJP')){
                                  //     omniture tag goes here
                                  $('input[name$="dwfrm_singleshipping_deliveryPref"]').attr('data-event', 'event-data-checkout');
                                  $('#dwfrm_singleshipping_deliveryPref_0').attr('data-click', 'ShiptoMe');
                                  $('#dwfrm_singleshipping_deliveryPref_1').attr('data-click', 'ShiptoStore');
                                  
                                  $('input[name$="dwfrm_singleshipping_deliveryType"]').attr('data-event', 'event-data-checkout');
                                  $('#dwfrm_singleshipping_deliveryType_0').attr('data-click', 'Do Not Specify Date');
                                  $('#dwfrm_singleshipping_deliveryType_1').attr('data-click', 'Designate Delivery Date');
                                  
                                  $('input[name$="_shippingAddress_isGift"]').attr('data-event','event-checkout-delivery');
                                  $('input[name$="_shippingAddress_isGift"]').attr('data-click','Gift Wrapping Service');
                                  
                           }
              if($('body').hasClass('LeviJP')){
            
                if(screen.width>=768) {  
                 $("#shippingform").focusout(function () {
                              setTimeout(function() {
                                     if(($('#shippingform .form-row:nth-child(3) .input-text.required.error').length>0)||($('#shippingform .form-row:nth-child(2) .input-text.required.error').length>0))
                                {  
                                           $("#shippingform .form-row:nth-child(2)").css('height','74px');
                                           $("#shippingform .form-row:nth-child(3)").css('height','74px');
                                }
                                     else {
                                                  $("#shippingform .form-row:nth-child(2)").css('height', 'auto');
                                                  $("#shippingform .form-row:nth-child(3)").css('height', 'auto');
                                            }
                                   }, 50);

                              });
              } 
                  $(function () {
                        $('.shippingform .form-field-tooltip a').on("click", function (e) {
                            e.preventDefault();
                        });
                    });
                      if($('.hide-need-sched').length >0){
                             $('.deliverySched .input-section:last .input-radio').attr('disabled',true);
                        }else{
                             $('.deliverySched .input-section:last .input-radio').attr('disabled',false);
                        }
              
                      if($('.disable-giftwrap').length >0){
                          $('#dwfrm_singleshipping_shippingAddress_isGift').attr('disabled',true);
                          $('.deliveryOption .input-section:last input').parent().css('display','none');
                     }else{
                          $('#dwfrm_singleshipping_shippingAddress_isGift').attr('disabled',false);
                     }

                      if($('.amazon-disable').length >0){
                    	  $(".singleshipping-page .delivery-schedule").css('margin-top', '1.6em');
                    	  $(".singleshipping-page .deliveryOption .guest-deliveryOptionradiobutton .form-row").css('width', '50%');
                     }
           
                      if($('input:radio[name=dwfrm_singleshipping_deliveryType]:checked').val() == Resources.NEED_SCHEDULED){
                            document.getElementById("need-delivery").style.display = "block";
                      }
                      
                       $('.delivery-schedule .input-section:first input').click(function(){
                             $(".need-delivery").hide();
                             $('.needsched-disclaimer').find('span.errspan.error').remove();
                                 });
               
                     if($('#dwfrm_singleshipping_deliveryPref-error').length >0){
                     $(".deliveryOption input:radio:first").trigger("click");
                     }
                     if(!$('.deliveryOption input:radio').is(':checked')){
                     $('.deliveryOption .input-section:first input').attr('checked','checked');
                     }
                     if($('input[name=dwfrm_singleshipping_deliveryPref]:checked').val() == "shipToOther"){
                     $('.deliveryOption .input-section:last input').parent().addClass('active');
                     $('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').closest('.form-row').css('display','none');
                     if($('#dwfrm_singleshipping_shippingAddress_sendername').val()!=""){
                           $('.checkout-shipToOther').removeClass('hide');
                          $('#checkout-shipToOther .form-row').removeClass('error');
                     }else{
                           $('.checkout-shipToOther').removeClass('hide');
                     }
                     if ($('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val() != "") {
                           $('.checkout-shipToOther .error-message').remove()
                               $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                         }
                     }else{
                     $('.deliveryOption .input-section:first input').parent().addClass('active');
                     $('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').closest('.form-row').css('display','block');
                     if($('#customer-address').length > 0){
                           $(".checkout-shipping.address").removeClass('hide');
                                  if($('#dwfrm_singleshipping_addressList-button .ui-selectmenu-text').text() =="新しい住所を入力して下さい"){
                                         document.getElementById("shippingform").style.display = "block";
                                  }else{
                                         document.getElementById("shippingform").style.display = "none";
                                         if($('#shippingform input:empty').length==10 && localStorage.getItem("fromBilling") == "false"){
                                                selectedadress = $('#dwfrm_singleshipping_addressList option[data-isdefaultaddress="true"]').data('address');
                                                util.fillAddressFields(selectedadress, $shipToMeform);
                                                var email = $('#loggedincustomeremail').val();
                                               // $('#dwfrm_singleshipping_shippingAddress_isGift').prop('checked', false);
                                         $('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').val(email);
                                         if($('#dwfrm_singleshipping_shippingAddress_addressFields_lastName').val() == ""){
                                        	 $('#dwfrm_singleshipping_shippingAddress_addressFields_lastName').val($('#loggedincustomerlastname').val());
                                         }
                                        if($('#dwfrm_singleshipping_shippingAddress_addressFields_firstName').val()== ""){
                                        	$('#dwfrm_singleshipping_shippingAddress_addressFields_firstName').val($('#loggedincustomerfirstname').val());
                                        }
                                        if($('#dwfrm_singleshipping_shippingAddress_addressFields_kanalastname').val() == ""){
                                        	$('#dwfrm_singleshipping_shippingAddress_addressFields_kanalastname').val($('#loggedincustomerkanalastname').val());
                                        }
                                        if($('#dwfrm_singleshipping_shippingAddress_addressFields_kanafirstname').val() ==""){
                                        	$('#dwfrm_singleshipping_shippingAddress_addressFields_kanafirstname').val($('#loggedincustomerkanafirstname').val());
                                        }
                                           address.updateAddress($('#dwfrm_singleshipping_addressList option[data-isdefaultaddress="true"]').val());
                                         }
                                  }
                         }
                     }
      
                     $("#dwfrm_singleshipping_shippingAddress_sendername").on('keyup', function (e) {
                       if($('#dwfrm_singleshipping_shippingAddress_sendername').val()!="" &&  $('.checkout-shipToOther .form-row span.errspan.error').length > 0){
                             $('#dwfrm_singleshipping_shippingAddress_sendername').next().remove();
                             $('.checkout-shipToOther .input-text').removeClass('error');
                             $('#checkout-shipToOther .form-row').removeClass('error');
                       }
                    });
                     
                     if($('.shipping-userRegisteredError-error').length == 1){
                    	 $('[name$="_singleshipping_shippingAddress_addressFields_emailAddress"]').addClass('error');
               	   }
              }
              
              $("#deliverySched input[name='dwfrm_singleshipping_deliveryType']").click(function(){
                 if($('input:radio[name=dwfrm_singleshipping_deliveryType]:checked').val() == "お届け日を指定する"){
                        $('input:radio[name=dwfrm_singleshipping_deliveryType]:checked').attr('checked','checked');
                     document.getElementById("need-delivery").style.display = "block";
                     
                     // omniture tag goes here
                    $('.delivery-schedule .need-delivery').on('click',function(){
                                 $('#estDeliveryDate-menu li').attr('data-event','event-checkout-delivery-date');
                                 $('#estDeliveryDate-menu li').attr('data-click' ,function(index) {
                                 var val= $(this).text();
                                 return val;
                                 });
                                 
                                  $('#estDeliverySlot-menu li').attr('data-event','event-checkout-delivery-time');
                                 $('#estDeliverySlot-menu li').attr('data-click' ,function(index) {
                                 var val= $(this).text();
                                 return val;
                                 });
                          });
                    // omniture tag ends here
                    
                  }else{
                        $('input:radio[name=dwfrm_singleshipping_deliveryType]:checked').attr('checked','checked');
                    document.getElementById("need-delivery").style.display = "none";
                 }
             }); 
              
              if($('.deliveryOption .input-section:last input').attr('checked')=="checked")
              {
                     $(".checkout-shiptostore").show();
                     if ($('body').hasClass('LeviJP')) {
                          document.getElementById("checkout-shipToOther").style.display = "block";
                          document.getElementById("checkout-shipToMe").style.display = "none";
                     }
                     $(".checkout-shipping").hide();
                  

                     //updating the value of the selected store shipping method in the order summary on click of ship to store
                     var isStoreSelected = $('[name$="_singleshipping_inStoreShipments_storeID"]').is(":checked");
                     if(isStoreSelected == true){
                           var selectedStoreShippingMethod = $('[name$="_singleshipping_inStoreShipments_storeID"]:checked').data('attribute');
                           selectShippingMethod(selectedStoreShippingMethod);
                     }
              }

              if($('.shipToStore .checkout-shiptostore .stores label:nth-child(1) li input:nth-child(1)').attr('checked')=="checked")
              {
                     $('.shipToStore .checkout-shiptostore .stores li').removeClass('selected');
                     if($('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked'))
                     {
                            $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').parent().addClass('selected');
                     }
                     else{

                           $('.shipToStore .checkout-shiptostore .stores label:nth-child(1) li').addClass('selected');
                     }
              } 

              if ($(".checkoutlogin .checkout-loginForm").find(".error-form").length > 0 && !$("body").hasClass("LeviKR") && !$("body").hasClass("LeviIN")){ 
                     $(".checkoutlogin .checkout-loginForm").slideToggle(700,'linear');
                     var toggle= $(".checkoutlogin .checkout-loginForm").prev(".accordianopen24x24");
                     $(toggle).toggleClass('accordianopen24x24');
                     $(toggle).toggleClass('accordianclose24x24');
              }

              if ($("body").hasClass("LeviIN")) {	
                     $(".phoneno").prev().css("margin-right","50px");
                     var postalCode = util.getCookie('pincodeckie') || $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val();
                     if(document.cookie.indexOf("pincodeckie") >= 0 && postalCode != "") {
                         $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val(postalCode); 
                         util.checkDeliveryAvailability(postalCode);                   
                     }
              }
              
              if ($('body').hasClass('LeviJP')) {
                     $('.mini-shipment.order-component-block').css('display','none');
                     if($('#shippingFulfilled').val() == 'false') {
                         $('#shippingform').css('display','block');
                         $('#shippingform').validate().form();
              }
              }

              
       };


};

$('.btnFoldWrap').bind('click', function(){
	$('div[id*=daum__layer]').css('display','none');
});


$('.selectedpaymentdetailform .input-text').attr('autocomplete','off');
var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
if(isChrome){
       if(!$('.selectedpaymentdetailform .input-text').attr('readonly')){
              $('.selectedpaymentdetailform .input-text').attr('readonly','true'); 
       }
       $('.selectedpaymentdetailform .input-text').focus(function(){
              $(this).removeAttr('readonly');
       });
}
$(document).ready(function () {
       if($('body').hasClass('LeviKR')){
              if($('input[name=dwfrm_singleshipping_deliveryPref]:checked').val()=='shipToStore'){
                     $("#checkout-shipToStore").show();
              }
       }
});


setTimeout(function(){
       $(".secondary-minisummary .easyRewarddisplay #dwfrm_cart_easyrewardPoints").on("keyup", function(){
              var easyRewardInputVal = $(this).val();
              var easyRewardDisplayValue = parseInt($('.easyRewards .easypoints .epointsavailable span').text());
              if(easyRewardInputVal > easyRewardDisplayValue){
                     $(".secondary-minisummary .easyRewardsOTP .custom-error-for-redem-input").text("Please enter a value less than "+easyRewardDisplayValue);
              }else if(easyRewardInputVal > parseInt($('#omniture-shipping-details').data('shippingdetail').Shipping_Total)){
                     $(".secondary-minisummary .easyRewardsOTP .custom-error-for-redem-input").text("Please enter a value less than "+parseInt($('#omniture-shipping-details').data('shippingdetail').Shipping_Total));
              }
              else if(easyRewardInputVal < easyRewardDisplayValue){
                     $(".secondary-minisummary .easyRewardsOTP .custom-error-for-redem-input").text("");
              }
       });
       $(".billing-address .easyRewarddisplay #dwfrm_cart_easyrewardPoints").on("keyup", function(){
              var easyRewardInputVal = $(this).val();
              var easyRewardDisplayValue = parseInt($('.easyRewards .easypoints .epointsavailable span').text());
              if(easyRewardInputVal > easyRewardDisplayValue){
                     $(".billing-address .easyRewardsOTP .custom-error-for-redem-input").text("Please enter a value less than "+easyRewardDisplayValue);
              }else if(easyRewardInputVal > parseInt($('#omniture-shipping-details').data('shippingdetail').Shipping_Total)){
                     $(".billing-address .easyRewardsOTP .custom-error-for-redem-input").text("Please enter a value less than "+parseInt($('#omniture-shipping-details').data('shippingdetail').Shipping_Total));
              }
              else if(easyRewardInputVal < easyRewardDisplayValue){
                     $(".billing-address .easyRewardsOTP .custom-error-for-redem-input").text("");
              }
       });
},5000);


$(window).on('load',function() {
       $( ".easyOTPbutton , #EasyRewardsResendOTP" ).click(function() {
              localStorage.setItem("submitOTPClick", "clicked");
       });

       if($('.billing-address').find('.easyRewards_billing').length && localStorage.getItem("submitOTPClick") == "clicked"){
              $(this).scrollTop($('.paymentmethodsection').offset().top + (0));
              localStorage.setItem("submitOTPClick", "clicked-done");
       }
});

if($('body').hasClass('LeviKR') ){

       $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').attr("style", "pointer-events: none; background-color:#dad8d8;");

       $('#dwfrm_singleshipping_shippingAddress_addressFields_address1').attr("style", "pointer-events: none; background-color:#dad8d8;");

       $('#dwfrm_profile_address_postal').attr("style", "pointer-events: none; background-color:#dad8d8;");

       $('#dwfrm_profile_address_address1').attr("style", "pointer-events: none; background-color:#dad8d8;");
   }

exports.updateShippingMethodList = updateShippingMethodList;



},{"../../../../../int_amazonpay_sg/cartridge/js/amazon/amazonPay":93,"../../ajax":7,"../../dialog":18,"../../login":22,"../../page":28,"../../progress":55,"../../tooltip":66,"../../util":67,"../../validator":68,"../account":29,"../product/pickupInstore":43,"./address":31,"./formPrepare":33}],37:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', function (e) {
        e.preventDefault();
        ajax.getJson({
            url: this.href,
            callback: function () {
                page.refresh();
            }
        });
    })
    .on('click', '.open-quick-view', function (e) {
        e.preventDefault();
        var url = $(this).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    });

    $('#compare-category-list').on('change', function () {
        $(this).closest('form').submit();
    });
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    addProductToCart();
};

},{"../ajax":7,"../page":28,"../product-tile":54,"../quickview":56,"./product/addToCart":39}],38:[function(require,module,exports){
'use strict';


var util = require('../util'),
	dialog = require('../dialog'),
	page = require('../page');



function initPromoCodeLink(){
	 $('.order-totals-table').on('click', '.promo-details', function(e) {
 	   e.preventDefault();
 		var promoDetails = $(this).find('div').html();
 		dialog.open({
 			html: promoDetails,
 			options: {
 				title: $(this).siblings("span").text()
 			}
 		});
 	});	
}

window.onload = function() { 
	 if ($('body').hasClass('LeviKR')) {
		var w = $('.pt_order-confirmation .updates').find('input'); 
	    for(var i = 0; i < w.length; i++){ 
	      if(w[i].type=='checkbox'){ 
	        w[i].checked = false; 
	      }
	    }
	 }
} 

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
	initPromoCodeLink();
};
},{"../dialog":18,"../page":28,"../util":67}],39:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
minicart = require('../../minicart'),
page = require('../../page'),
util = require('../../util'),
Promise = require('promise'),
tooltip = require('../../tooltip'),
//cart = require('../cart'),
_ = require('lodash');


/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */

var mobile = navigator.userAgent.toLowerCase().indexOf('mobile')>= 0;
var notIpad = navigator.userAgent.toLowerCase().indexOf('ipad') == -1;
var notTablet = navigator.userAgent.toLowerCase().indexOf('tablet') == -1;

var isMobileView = mobile && notIpad && notTablet;
	


var addItemToCart = function (form) {
	var $form = $(form),
	$qty = $form.find('select[name="Quantity"]');
	if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
		$qty.val('1');
	}
	var sourcePage = $form.find('input[name="sourcePage"]').val();
	console.log(sourcePage);
	if((sourcePage == "wishlist") || (sourcePage == "cartPage")){
		$form.find('button.add-to-cart').attr("disabled");
		$form.find('button.add-to-cart').html("adding...");
		if($(window).width() <= 767){
			$(".nav-mobile").css('display','none');
			$(".pt_wish-list").css('opacity','0.5');
			console.log("addToCart mobile view checking");
				$(".added-to-favourite-success").show().delay(1000).fadeOut("slow");
				$(".pt_wish-list").delay(1000).animate({opacity:1},1000);

				$(".pt_cart").css('opacity','0.5');
				$(".added-to-favourite-success").show().delay(1000).fadeOut("slow");
				$(".pt_cart").delay(1000).animate({opacity:1},1000);
		}
	}
	var url;
	if($('body').hasClass('LeviIN')){
	var radioVal = $('input[name="Ship"]:checked').val();
	url = util.appendParamToURL(Urls.addProduct,'format', 'ajax','Ship',radioVal);
	url = util.appendParamToURL(url,'Ship',radioVal);
	} else {
		url = util.ajaxUrl(Urls.addProduct);
	}
	return Promise.resolve($.ajax({
		type: 'POST',
		// url: util.ajaxUrl(Urls.addProduct),
		//url: util.appendParamToURL(Urls.addProduct,'Ship','abc'),
        url: url,
		data: $form.serialize(),
		async: false
	})).then(function (response) {
		// handle error in the response	
		if (response.error) {
			//throw new Error(response.error);
			$form.find('.error-message').html(response.errorMessage);
			if($('body').hasClass('LeviIN')){
				
				$('input[name="Ship"]').each(function(){
					 if($(this).attr("checked") == true || $(this).attr("checked") == "checked"){
					 $(this).prop("checked", "checked").attr("disabled",false);
					 }
					});
	
			}
			if($('body').hasClass('LeviJP')){
				$('.error-message.preorder-msg-error').css('display','block');
			}
			return response;
		} else {
			$form.find('.error-message').html('');
			if($('body').hasClass('LeviJP')){
				$('.error-message.preorder-msg-error').css('display','none');
			}
			if($('body').hasClass('LeviIN') || $('body').hasClass('LeviAU')){
				console.log("checking minicart");
            // setTimeout(function(){
            //     minicart.show(response);
            // },10000);
				var pid = $form.find('input[name="PC9_ID"]').val();
				if(pid != undefined){
					//  var sourcePage = $form.find('input[name="sourcePage"]').val();
					console.log(sourcePage);
					var removeWishlistItemLink = $(".removeWishlistItem").val();
					console.log(pid);
					if (removeWishlistItemLink) {
						$.ajax({
							url: removeWishlistItemLink,
							data: {'pid': pid, 'action': 'remove'},
							async: false,
							success: function(res){
								console.log("Checking redirection");
								if((sourcePage == "wishlist") || (sourcePage == "cartPage")){
									setTimeout(function(){
									$form.find('button.add-to-cart').removeAttr("disabled");
									$form.find('button.add-to-cart').html("ADD TO BAG");
									},1000);
								}
								window.location.href = $(".wishlistShowLink").val();
							}
						});
					}
				}
			}

			if($('body').hasClass('LeviKR')){
				console.log("checking minicart");
            // setTimeout(function(){
            //     minicart.show(response);
            // },10000);
				var pid = $form.find('input[name="PC9_ID"]').val();
				if(pid != undefined){
					//  var sourcePage = $form.find('input[name="sourcePage"]').val();
					console.log(sourcePage);
					var removeWishlistItemLink = $(".removeWishlistItem").val();
					console.log(removeWishlistItemLink);
					console.log(pid);
					if (removeWishlistItemLink) {
						$.ajax({
							url: removeWishlistItemLink,
							data: {'pid': pid, 'action': 'remove'},
							async: false,
							success: function(res){
								console.log("Checking redirection");
								if((sourcePage == "wishlist") || (sourcePage == "cartPage")){
									setTimeout(function(){
									$form.find('button.add-to-cart').removeAttr("disabled");
									$form.find('button.add-to-cart').html("장바구니 담기");
									},1000);
								}
								window.location.href = $(".wishlistShowLink").val();
							}
						});
					}
				}
			}
			return response;
		}
	});
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
	e.preventDefault();
	
	if($('body').hasClass('LeviJP')){
		if($("#alterlength").attr('disabled') == undefined) {
			if( $( "select#alterlength option:selected").val() == "" ){
				if (util.isMobile()) {  
					alert(Resources.SELECT_ALTER_LENGTH);
					return;
				}
				$(this).tooltip({ items: ".add-to-cart", content: Resources.SELECT_ALTER_LENGTH});
				$(this).tooltip("open");
				$(this).addClass('tooltip');
	
				return;
			}
		}
	}
	
	//deleting naverpay payment method from session
	if($('body').hasClass('LeviKR')){
	updateSessionVariables('clear');
	}
	
	if ($(this).data('isdisabled') === 'disabled') {
		if (util.isMobile()) {  
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}
		if($('body').hasClass('LeviIN')){
			var colour=$("#PC13Color").val();
			var size=$("#PC13Size").val();
			var checkWaistAvlb = "";
			var checkSizeAvlb = "";
			$("li.attribute.waist ul.swatches.waist .variation-group-value").each(function( index ) {
				if($(this).hasClass('selected')){
					checkWaistAvlb = $(this).hasClass('selected');
				}
			});

			$("li.attribute.size ul.swatches.size .variation-group-value").each(function( index ) {
				if($(this).hasClass('selected')){
					checkSizeAvlb = $(this).hasClass('selected');
				}
			});

			if(checkWaistAvlb == ""){
				$(this).tooltip({ items: ".add-to-cart", content: Resources.SELECT_FOR_WAIST});
				$(this).tooltip("open");
				$(this).addClass('tooltip');
			}else if(checkSizeAvlb == ""){
				$(this).tooltip({ items: ".add-to-cart", content: Resources.SELECT_FOR_LENGTH});
				$(this).tooltip("open");
				$(this).addClass('tooltip');
			}
		}else{
			$(this).tooltip({ items: ".add-to-cart", content: Resources.SELECT_FOR_STOCK});
			$(this).tooltip("open");
			$(this).addClass('tooltip');
		}
		return;
	}
	if ($(this).data('isdisabled') === 'OutOfStock') {
		if (util.isMobile()) {  
			alert(Resources.COMBINATION_NOT_AVAILABLE);
			return;
		}

		$(this).tooltip({ items: ".add-to-cart", content: Resources.COMBINATION_NOT_AVAILABLE});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}
	
	if($('body').hasClass('LeviJP')){
		if ($(this).data('isdisabled') == 'CartExpired') {
			if (util.isMobile()) {
				alert(Resources.CART_EXPIRED_PDP);
				return;
			}
			$(this).tooltip({ items: ".add-to-cart", content: Resources.CART_EXPIRED_PDP});
			$(this).tooltip("open");
			$(this).addClass('tooltip');
	
			return;
		}
	}
	var $form = $(this).closest('form');

	addItemToCart($form).then(function (response) {
		var $uuid = $form.find('input[name="uuid"]');
		if ($uuid.length > 0 && $uuid.val().length > 0 && !response.error) {
			page.refresh();
		} else {
			if (response.error) {
				if(response.errorMessage == "product.maxquantityerror"){
					$(this).tooltip({ items: $(this), content: Resources.MAXQUANTITY});
					$(this).tooltip("open");
					$(this).addClass('tooltip');
				}
				return;
			}
			// do not close quickview if adding individual item that is part of product set
			// @TODO should notify the user some other way that the add action has completed successfully
			if (!$(this).hasClass('sub-product-item')) {
				dialog.close();
			}
			if (isMobileView) {
				$(".nav-mobile").css('display','none');
				$(".pt_product-details").css('opacity','0.5');
				$(".added-to-cart-success").show().delay(1000).fadeOut("slow");
				$(".pt_product-details").delay(1000).animate({opacity:1},1000);
				$(".menu-toggle, #header-mobile-search-icon").on('click',function() { 
					$(".nav-mobile").css('display', 'block');
				});
			}
			if (!response.error) {
				if($('body').hasClass('LeviJP')){			
					var merchant_id = $(".merchant-id").val();
					var product_code = $("#add-to-cart").data('pid');
					var tagScript = $("#add-to-cart").data('tagscript');
					var isStaffNewLayout = $(".staffHomePageNewLayout").val();
					var qty = $('#quantity').val();
					if (isStaffNewLayout) {
						var js = document.createElement("script");
						js.type = "text/javascript";
						console.log(js);
						js.src = tagScript;
						document.body.appendChild(js);
						staffStart.cart.sendTrackingRequest(merchant_id, {"product_code": product_code, "count": qty });
						//console.log(product_code);
					}
				}
				if($('body').hasClass('LeviIN')){
				var fullfillMethod = $('input[name="Ship"]:checked');
				if($('body').hasClass('LeviIN') && fullfillMethod.val() == "Ship"){
					localStorage.removeItem("cartType");
					if(localStorage.getItem("cartType")===null || localStorage.getItem("cartType")===undefined){
						localStorage.setItem("cartType",'false');
					}
					// disabled="disabled"
					$('input[id="InstorePickup"]').attr("disabled", "disabled");
					$(".infomsg").remove();
					$("#shipinstorepickup_div").after('<p class="infomsg" style="">Please remove the items in cart to select a different Shipping Method</p>');
				}else if( $('body').hasClass('LeviIN')  && fullfillMethod.val() == "PickupInstore"){
					$('input[id="Ship"]').attr("disabled", "disabled");
					$(".infomsg").remove();
					$("#shipinstorepickup_div").after('<p class="infomsg" style="">Please remove the items in cart to select a different Shipping Method</p>');
					if(localStorage.getItem("cartType")===null || localStorage.getItem("cartType")==='false' || localStorage.getItem("cartType")===undefined){
						localStorage.setItem("cartType",'true');
					}
					else{

					}
				}
			}
				minicart.show(response);
			}
			
		}
	}.bind(this));
};


/**
 * buyNow - For Korea only
 * @description Handler to handle the buy now event
 * 
 * Adds the current product to cart and takes the user to checkout
 */
var buyNow = function (e) {
	var selectedVal = $(this).val();
	e.preventDefault();
	if($('body').hasClass('LeviJP')){
		if($("#alterlength").attr('disabled') == undefined) {
			if( $( "select#alterlength option:selected").val() == "" ){
				if (util.isMobile()) {  
					alert(Resources.SELECT_ALTER_LENGTH);
					return;
				}
				$(this).tooltip({ items: ".buy-now", content: Resources.SELECT_ALTER_LENGTH});
				$(this).tooltip("open");
				$(this).addClass('tooltip');
	
				return;
			}
		}
	}
	
	if(selectedVal=="Naverpay")
	{
	
	//adding naverpay payment method in session
	if($('body').hasClass('LeviKR')){
		updateSessionVariables('add');
	}
	}

if(selectedVal=="Buy Now")
{
	//deleting naverpay payment method from session
	if($('body').hasClass('LeviKR')){
		updateSessionVariables('clear');
	}
}
	
	if ($(this).data('isdisabled') == 'disabled') {

		if (util.isMobile()) {
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}
		$(this).tooltip({ items: ".buy-now", content: Resources.SELECT_FOR_STOCK});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}
	if ($(this).data('isdisabled') == 'OutOfStock') {

		if (util.isMobile()) {
			alert(Resources.COMBINATION_NOT_AVAILABLE);
			return;
		}
		$(this).tooltip({ items: ".buy-now", content: Resources.COMBINATION_NOT_AVAILABLE});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}
	if($('body').hasClass('LeviJP')){
		if ($(this).data('isdisabled') == 'CartExpired') {
			if (util.isMobile()) {
				alert(Resources.CART_EXPIRED_PDP);
				return;
			}
			$(this).tooltip({ items: ".buy-now", content: Resources.CART_EXPIRED_PDP});
			$(this).tooltip("open");
			$(this).addClass('tooltip');
	
			return;
		}
	}

	var $form = $(this).closest('form');
	addItemToCart($form).then(function (response) {
		// check EPOCH Response
		if (!response.error) {
			window.location.href = $("#buy-now").data('targeturl');
		}else{
			if(response.errorMessage == "product.maxquantityerror"){
				$("#buy-now").tooltip({ items: $("#buy-now"), content: Resources.MAXQUANTITY});
				$("#buy-now").tooltip("open");
				$("#buy-now").addClass('tooltip');
		}
		}
	});
}


/**
 * @description Handler to handle the buy All event
 * 
 * Adds the current product to cart and takes the user to checkout
 */
var buyAll = function (e) {
	e.preventDefault();

	var $addAllToCart = $('#add-all-to-cart'),
    $buyAll = $('#buy-all'),
    $productSetList = $('#product-set-list');
	var isdisabledflag = false;	
	var addToCartButtons = [];
	
	//deleting naverpay payment method from session
	if($('body').hasClass('LeviKR')){
	updateSessionVariables('clear');
	}
	
	$productSetList.find('.add-to-cart').each(function() {
		if($(this).data('isdisabled') == 'OutOfStock'){
			isdisabledflag = true;
		}
		if(isdisabledflag){
			$productSetList.data('isdisabled', 'OutOfStock');
		}else{
			$productSetList.data('isdisabled', 'enabled');
		}
		addToCartButtons.push($(this));
	});
	var i,j;
	var enabledPrd = 0 ;
	for (i = 0 ; i < addToCartButtons.length ; i++) {
		var $item = $(addToCartButtons[i]);
		
		if ($item.data('isdisabled') == 'disabled') {
			$productSetList.data('isdisabled', 'disabled');
			break;
		}
	}
	
	for (j = 0 ; j < addToCartButtons.length ; j++) {
		var $item = $(addToCartButtons[j]);
		
		if ($item.data('isdisabled') === 'enabled') {
			enabledPrd++;
		}
	}
	if(addToCartButtons.length == enabledPrd )
	{
		$productSetList.data('isdisabled', 'enabled');
		$buyAll.data('isdisabled','enabled');
	}	
	
    if ($productSetList.data('isdisabled') == 'disabled') {
        $addAllToCart.data('isdisabled', 'disabled');
        $buyAll.data('isdisabled','disabled');
        
        if (util.isMobile()) {
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}

		$(this).tooltip({ items: ".buy-all", content: Resources.SELECT_FOR_STOCK});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
        
        
    }
    if ($productSetList.data('isdisabled') == 'OutOfStock') {
        $addAllToCart.data('isdisabled', 'OutOfStock');
        $buyAll.data('isdisabled','OutOfStock');

        if (util.isMobile()) {
			alert(Resources.COMBINATION_NOT_AVAILABLE);
			return;
		}

		$(this).tooltip({ items: ".buy-all", content: Resources.COMBINATION_NOT_AVAILABLE});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
        
        
    }

	if ($buyAll.data('isdisabled') === 'disabled') {
		if (util.isMobile()) {
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}

		$(this).tooltip({ items: ".buy-all", content: Resources.SELECT_FOR_STOCK});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}

	var $productForms = $('#product-set-list').find('form').toArray();
	Promise.all(_.map($productForms, addItemToCart))
	.then(function () {
		window.location.href = $('#buy-all').data('targeturl');

	});


}


/**
 * @description Handler to handle the add all items to cart event
 */
var addAllToCart = function (e) {
	e.preventDefault();
	var $addAllToCart = $('#add-all-to-cart'),
    $buynow = $('#buy-now'),
    $productSetList = $('#product-set-list');
	var isAddAllToCart = ($addAllToCart.data('isdisabled') === 'disabled');
	
	//deleting naverpay payment method from session
	if($('body').hasClass('LeviKR')){
	updateSessionVariables('clear');
	}
	
	
	// If product set
	var isdisabledflag = false;
	var addToCartButtons = [];
	$productSetList.find('.add-to-cart').each(function() {
		if($(this).data('isdisabled') == 'OutOfStock'){
			isdisabledflag = true;
		}
		addToCartButtons.push($(this));
	});
	if(isdisabledflag){
		$productSetList.data('isdisabled', 'OutOfStock');
	}else{
		$productSetList.data('isdisabled', 'enabled');
	}
	
	var i,j;
	var enabledPrd = 0 ;
	for (i = 0 ; i < addToCartButtons.length ; i++) {
		var $item = $(addToCartButtons[i]);
		
		if ($item.data('isdisabled') === 'disabled') {
			$productSetList.data('isdisabled', 'disabled');
			break;
		}
	}
	for (j = 0 ; j < addToCartButtons.length ; j++) {
		var $item = $(addToCartButtons[j]);
		
		if ($item.data('isdisabled') === 'enabled') {
			enabledPrd++;
		}
	}
	if(addToCartButtons.length == enabledPrd )
	{
		$productSetList.data('isdisabled', 'enabled');
	}	
    if ($productSetList.data('isdisabled') === 'disabled') {
        $addAllToCart.data('isdisabled', 'disabled');
        
        
        if (util.isMobile()) {
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}
		$(this).tooltip({ items: ".add-all-to-cart", content: Resources.SELECT_FOR_STOCK});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
        
        
    }
    if ($productSetList.data('isdisabled') === 'OutOfStock') {
        $addAllToCart.data('isdisabled', 'disabled');
	
	
        if (util.isMobile()) {
			alert(Resources.COMBINATION_NOT_AVAILABLE);
			return;
		}
		$(this).tooltip({ items: ".add-all-to-cart", content:Resources.COMBINATION_NOT_AVAILABLE});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
        
        
    }
	if (isAddAllToCart === 'false') {

		if (util.isMobile()) {
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}
		$(this).tooltip({ items: ".add-all-to-cart", content: Resources.SELECT_FOR_STOCK});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}
	var $productForms = $('#product-set-list').find('form').toArray();
	Promise.all(_.map($productForms, addItemToCart))
	.then(function (responses) {
		dialog.close();
		var newresponse = [];
		responses.forEach(function(response) {
			if(!response.error) {
				newresponse.push(response);
			}
		}); 
		// show the final response only, which would include all the other items
		if(newresponse.length > 0) {
			if (isMobileView) {
				$(".nav-mobile").css('display','none');
				$(".pt_product-details").css('opacity','0.5');
				$(".added-to-cart-success").show().delay(1000).fadeOut("slow");
				$(".pt_product-details").delay(1000).animate({opacity:1},1000);
				$(".menu-toggle, #header-mobile-search-icon").on('click',function() { 
					$(".nav-mobile").css('display', 'block');
				});
			}
			minicart.show(newresponse[newresponse.length-1]);
		}
	});
};

var updateSessionVariables = function(action)
{
			$.ajax({
	        type: "POST",
	        url: Urls.updateSessionVariables,  
	        data: {'action':action},
	        success: function(response) {
	       	 
	            }
	 });
		
}

// var showFindStoreToolTip = function (e) {
//     if($('body').hasClass('LeviJP')){
//         if($("#findinstore.disabled").attr('disabled') == undefined) {
// 	// if($('.swatches.waist').find('.selectable.selected').length == 0  || $('.swatches.size').find('.selectable.selected').length == 0){

//             e.preventDefault();
//             if (util.isMobile()) {
//                 //$(this).removeAttr("href");
//                 alert(Resources.PRODUCT_FIND_STORE_NO_VARIATION);
//                 return false;
//             }else{
//                // $(this).removeAttr("href");
//                 $(this).addClass('tooltip');
//                 $(this).tooltip({ items: "#findinstore", content: Resources.PRODUCT_FIND_STORE_NO_VARIATION});
//                 $(this).tooltip("open");
//                 return false;
//             }
//         }
// 	// }
//     }
// }
	
var storeInventory = function (e) {
	e.preventDefault();
	
	if($('body').hasClass('LeviJP')){
		if($("#alterlength").attr('disabled') == undefined) {
			if( $( "select#alterlength option:selected").val() == "" ){
				if (util.isMobile()) {  
					alert(Resources.SELECT_ALTER_LENGTH);
					return;
				}
				$(this).tooltip({ items: "#findinstore", content: Resources.SELECT_ALTER_LENGTH});
				$(this).tooltip("open");
				$(this).addClass('tooltip');
	
				return;
			}
		}
	}
	
	//deleting naverpay payment method from session
	if($('body').hasClass('LeviKR')){
	updateSessionVariables('clear');
	}
	
	if ($(this).data('isdisabled') === 'disabled') {
		if (util.isMobile()) {  
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}
		$(this).tooltip({ items: "#findinstore", content: Resources.SELECT_FOR_STOCK});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}
	if ($(this).data('isdisabled') === 'OutOfStock') {
		if (util.isMobile()) {  
			alert(Resources.COMBINATION_NOT_AVAILABLE);
			return;
		}
		$(this).tooltip({ items: "#findinstore", content: Resources.COMBINATION_NOT_AVAILABLE});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}

	if($('body').hasClass('LeviJP')){
		if ($(this).data('isdisabled') == 'CartExpired') {
			if (util.isMobile()) {
				alert(Resources.CART_EXPIRED_PDP);
				return;
			}
			$(this).tooltip({ items: "#findinstore", content: Resources.CART_EXPIRED_PDP});
			$(this).tooltip("open");
			$(this).addClass('tooltip');
	
			return;
		}
	}
};

var likeButton = function (e) {
	e.preventDefault();
	
	if($('body').hasClass('LeviJP')){
		if($("#alterlength").attr('disabled') == undefined) {
			if( $( "select#alterlength option:selected").val() == "" ){
				if (util.isMobile()) {  
					alert(Resources.SELECT_ALTER_LENGTH);
					return;
				}
				$(this).tooltip({ items: "#like-button", content: Resources.SELECT_ALTER_LENGTH});
				$(this).tooltip("open");
				$(this).addClass('tooltip');
	
				return;
			}
		}
	}
	
	//deleting naverpay payment method from session
	if($('body').hasClass('LeviKR')){
	updateSessionVariables('clear');
	}
	
	if ($(this).data('isdisabled') === 'disabled') {
		if (util.isMobile()) {  
			alert(Resources.SELECT_FOR_STOCK);
			return;
		}
		$(this).tooltip({ items: "#like-button", content: Resources.SELECT_FOR_STOCK});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}
	if ($(this).data('isdisabled') === 'OutOfStock') {
		if (util.isMobile()) {  
			alert(Resources.COMBINATION_NOT_AVAILABLE);
			return;
		}
		$(this).tooltip({ items: "#like-button", content: Resources.COMBINATION_NOT_AVAILABLE});
		$(this).tooltip("open");
		$(this).addClass('tooltip');

		return;
	}

	if($('body').hasClass('LeviJP')){
		if ($(this).data('isdisabled') == 'CartExpired') {
			if (util.isMobile()) {
				alert(Resources.CART_EXPIRED_PDP);
				return;
			}
			$(this).tooltip({ items: "#like-button", content: Resources.CART_EXPIRED_PDP});
			$(this).tooltip("open");
			$(this).addClass('tooltip');
	
			return;
		}
	}
};

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
	$('.add-all-to-cart').on('click', addAllToCart);
	$('.product-detail').on('click', '.buy-now', buyNow);
	 $('#pdpMain').on('click', '.buy-all', buyAll);
	 
	$('.product-detail').on('click', '.add-to-cart', addToCart);

	$('.product-detail').on('click', '#like-button', likeButton);

	$('.product-detail').on('click', '#findinstore', storeInventory);
	
	// $('#findinstore').on('click', showFindStoreToolTip);

	// $('#like-button').on('click' , showLikeButtonToolTip);


	$('#like-button').on('mouseout',  function (e) {
        if ($(this).hasClass('tooltip')) {
            $(this).tooltip("disable");
            $(this).removeClass('tooltip');
        }
    });
	
	$('#findinstore').on('mouseout',  function (e) {
        if ($(this).hasClass('tooltip')) {
            $(this).tooltip("disable");
            $(this).removeClass('tooltip');
        }
    });
	
	$('.product-detail').on('mouseout', '.add-to-cart, #like-button, .buy-now, .buy-all, .add-all-to-cart', function (e) {
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});
	
	$('#pdpMain').on('mouseout', '.buy-all, .add-all-to-cart', function (e) {
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});

	
};

},{"../../dialog":18,"../../minicart":25,"../../page":28,"../../tooltip":66,"../../util":67,"lodash":73,"promise":74}],40:[function(require,module,exports){
'use strict';

var ajax =  require('../../ajax'),
    util = require('../../util');

var updateContainer = function (data) {
    var $availabilityMsg = $('#pdpMain .availability .availability-msg');
    var message; // this should be lexically scoped, when `let` is supported (ES6)
    if (!data) {
        $availabilityMsg.html(Resources.ITEM_STATUS_NOTAVAILABLE);
        return;
    }
    $availabilityMsg.empty();
    // Look through levels ... if msg is not empty, then create span el
    if (data.levels.IN_STOCK > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            // Just in stock
            message = Resources.IN_STOCK;
        } else {
            // In stock with conditions ...
            message = data.inStockMsg;
        }
        $availabilityMsg.append('<p class="in-stock-msg">' + message + '</p>');
    }
    if (data.levels.PREORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.PREORDER;
        } else {
            message = data.preOrderMsg;
        }
        $availabilityMsg.append('<p class="preorder-msg">' + message + '</p>');
    }
    if (data.levels.BACKORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.BACKORDER;
        } else {
            message = data.backOrderMsg;
        }
        $availabilityMsg.append('<p class="backorder-msg">' + message + '</p>');
    }
    if (data.inStockDate !== '') {
        $availabilityMsg.append('<p class="in-stock-date-msg">' + String.format(Resources.IN_STOCK_DATE, data.inStockDate) + '</p>');
    }
    if (data.levels.NOT_AVAILABLE > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
            message = Resources.NOT_AVAILABLE;
        } else {
            message = Resources.REMAIN_NOT_AVAILABLE;
        }
        $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
    }
};

var getAvailability = function () {
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.getAvailability, {
            pid: $('#pid').val(),
            Quantity: $(this).val()
        }),
        callback: updateContainer
    });
};

module.exports = function () {
    $('#pdpMain').on('change', '.pdpForm select[name="Quantity"]', getAvailability);
};

},{"../../ajax":7,"../../util":67}],41:[function(require,module,exports){
'use strict';
var dialog = require('../../dialog');
var util = require('../../util');
var qs = require('qs');
var progress = require('../../progress');
var url = require('url');
var _ = require('lodash');
var owl_carousel = require('../../owlcarousel/owlcarousel'); 
var owl_carousel_thumb = require('../../owlcarousel/owlcarousel.thumbs');


var zoomMediaQuery = matchMedia('(min-width: 960px)');

/*
 * Zoom on hover on main product image
 */

function loadElevateZoom(refreshFlag) {
	var isQuickView = $('.pdp-main').find('.primary-image.main-image').data('isquickview');

	if (dialog.isActive() || util.isMobile() || isQuickView) {
		return;
	}

	var ezScriptTag = null, scriptTags = document.getElementsByTagName('script');
	var i = 0;
	for(i = 0; i < scriptTags.length; i++) {
		if (scriptTags[i].src.indexOf('elevatezoom') !== '-1') {
			ezScriptTag = scriptTags[i];
			break;
		}
	}


	var zoomSettings = {
			lensFadeIn: 400,
			lensFadeOut: 400,
			borderSize: 0,
			zoomWindowFadeIn: 400,
			zoomWindowFadeOut: 400,
			easing: true,
			zoomWindowPosition: 1,
			zoomWindowOffsetX: 20,
			zoomWindowOffsetY: -10,
			zoomWindowHeight: 700,
			zoomWindowWidth: 700
	};

	if($("#zoom_01").length > 0){
		if (refreshFlag) {
			$("#zoom_01").ezPlus(zoomSettings);
		}
		else {
			if (ezScriptTag) {
				$("#zoom_01").ezPlus(zoomSettings);
			}

		}
	}

}



/**
 * @description Enables the zoom viewer on the product detail page
 * @param zmq {Media Query List}
 */
function loadZoom (zmq) {

}

zoomMediaQuery.addListener(loadZoom);

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage (atts) {

	//$('#iView').remove();   // remove the video iframe tag every time an image is displayed.
	$('#iView').hide();
	$('#scene7VideoView').hide();
	$('.product-image.main-image').show();

	$('#pdpMain .primary-image').attr({
		src: atts.url,
		alt: atts.alt,
		title: atts.title
	});

	$('#pdpMain .primary-image').data('zoom-image', atts.zoomImg);

	//updatePinButton(atts.url);

	if (!dialog.isActive() && !util.isMobile()) {
		$('#pdpMain .main-image').attr('href', atts.hires);
	}
	//loadZoom();
	//loadElevateZoom();
}

function updatePinButton (imageUrl) {
	var pinButton = document.querySelector('.share-icon[data-share=pinterest]');
	if (!pinButton) {
		return;
	}
	var newUrl = imageUrl;
	if (!imageUrl) {
		newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
	}
	var href = url.parse(pinButton.href);
	var query = qs.parse(href.query);
	query.media = url.resolve(window.location.href, newUrl);
	query.url = window.location.href;
	var newHref = url.format(_.extend({}, href, {
		query: query, // query is only used if search is absent
		search: qs.stringify(query)
	}));
	pinButton.href = newHref;
}

/**
 * @description Replaces the images in the image container, for eg. when a different color was clicked.
 */
function replaceImages () {

	var isQuickView = $('.pdp-main').find('.primary-image.main-image').data('isquickview');

	var $newImages = $('#update-images'),
	$imageContainer = $('#pdpMain .product-image-container');
	if ($newImages.length === 0) { return; }

	var $zoomLens = $('.zoomLens'),
	$zoomWindowContainer = $('.zoomWindowContainer'),
	$zoomContainer = $('.zoomContainer');

	if ($zoomLens && $zoomWindowContainer && $zoomContainer) {
		$zoomLens.remove();
		$zoomWindowContainer.remove();
		$zoomContainer.remove();
	}

	$imageContainer.html($newImages.html());

	initCarousel();

	$newImages.remove();
	//loadZoom();
	if (!isQuickView || !util.isMobile()) {
		loadElevateZoom(true);
	}


}

/*
 * Omniture call to be called from all other pdp pages
 * variant, index
 */
function omniturecall() {
	var $omniDetailElement = $('#omniture-details');

	var pagedetail = $omniDetailElement.data('pagedetail'),
	customerdetail = $omniDetailElement.data('customerdetail'),
	productdetail = $omniDetailElement.data('productdetail'),
	orderdetail = $omniDetailElement.data('orderdetail'),
	searchdetail = $omniDetailElement.data('searchdetail');

	var omniObj = {};

	omniObj.pagedetail = pagedetail;
	omniObj.customerdetail = customerdetail;
	omniObj.productdetail = productdetail;
	omniObj.orderdetail = orderdetail;
	omniObj.searchdetail = searchdetail;

	var dataelement = JSON.stringify(omniObj);

	// manually insert a script tag

	var scrTag = document.createElement('script');
	scrTag.type = "text/javascript";
	var firstScrTag = document.getElementsByTagName('script')[0];
	scrTag.innerHTML = "dataelement =" + dataelement;
	firstScrTag.parentNode.insertBefore(scrTag, firstScrTag); 

	//console.log(omniObj);

	//var pageData = getjsonTrackingObject(JSON.stringify(omniObj));
}


/*
 * @description Initializes the image carousel
 */
function initCarousel(elem) {

	var $container = null;

	if ($(elem).closest('.bonus-product-item')) {
		$container = $(elem).closest('.bonus-product-item').find('.main-image-carousel');
	}
	else {
		$container = $('.main-image-carousel');
	}

	$container.find('li').each(function (e) {
		$(this).hide();
		if ($(this).data('index') == '1') {
			$(this).show('fade');
		}
	});

	// next button handler
	$('.main-image-carousel').on('click', '.chevronright24x24', function (e) {
		e.preventDefault();
		var curIndex;

		$(this).closest('.main-image-carousel').find('li').each(function (e) {
			if ($(this).is(':visible')) {
				curIndex = $(this).data('index');
				$(this).hide();
			}
		});
		pauseScene7VideoOnFocusOut();
		curIndex = Number(curIndex);
		
		$(this).closest('.main-image-carousel').find('li').each(function (e) {

			if ($(this).data('index') == (curIndex + 1)) {
				$(this).show();
				curIndex++;
				return false;
			}
		});


		var imagecount = Number($(this).closest('.main-image-carousel').data('size'));
		
		if ($('.main-image-carousel iframe').length){
			imagecount = imagecount + 1;
		}
		if ($('.main-image-carousel video').length){
			imagecount = imagecount + 1;
		}
		
		if (curIndex >= imagecount) {
			$(this).hide();
		}

		if (curIndex >= 1) {
			$(this).closest('.main-image-carousel').find('.chevronleft24x24').show();
		}

	});

	// prev button handler
	$('.main-image-carousel').on('click', '.chevronleft24x24', function (e) {
		e.preventDefault();
		
		if($('#video_player').is(':visible')){
			
			$('#iView' ).attr( 'src', function ( i, val ) { return val; });
		}
		
		var curIndex;

		$(this).closest('.main-image-carousel').find('li').each(function (e) {
			if ($(this).is(':visible')) {
				curIndex = $(this).data('index');
				$(this).hide();
			}
		});
		pauseScene7VideoOnFocusOut();
		curIndex = Number(curIndex);
		
		$(this).closest('.main-image-carousel').find('li').each(function (e) {

			if ($(this).data('index') == (curIndex - 1)) {
				$(this).show();
				curIndex--;
				return false;
			}
		});

		if (curIndex <= 1) {
			$(this).hide();
		}
		var imagecount = Number($(this).closest('.main-image-carousel').data('size'));
		if ($('.main-image-carousel iframe').length){
			imagecount = imagecount+1;
		}
		if ($('.main-image-carousel video').length){
			imagecount = imagecount+1;
		}
		if (curIndex < imagecount) {
			$(this).closest('.main-image-carousel').find('.chevronright24x24').show();
		}
	});
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {

	if (dialog.isActive() || util.isMobile()) {
		$('#pdpMain .main-image').removeAttr('href');

	}
	
	var zoomTimeOut;
	$('#pdpMain').on('click mouseenter', '.productthumbnail', function(event){
		clearTimeout(zoomTimeOut);
		$('.product-image.main-image').show();
		$('.product-primary-image #iView').hide();
		$('.product-primary-image #scene7VideoView').hide();
		
		// switch indicator
		if ($(this).closest('li').hasClass('selected')) {
			return;
		}
		
		progress.show('#pdpMain .main-image');
		
		// disable zooming feature
		var $zoomLens = $('.zoomLens'),
		$zoomWindowContainer = $('.zoomWindowContainer'),
		$zoomContainer = $('.zoomContainer');
		if ($zoomLens && $zoomWindowContainer && $zoomContainer) {
			$zoomContainer.remove();
			$zoomLens.remove();
			$zoomWindowContainer.remove();

		}
		progress.hide();

		$(this).closest('.product-thumbnails').find('.thumb.selected').removeClass('selected');

		$(this).closest('.thumb').addClass('selected');

		var isQuickView = $('.pdp-main').find('.primary-image.main-image').data('isquickview');
		if ($(this).data('lgimg')) {
			setMainImage($(this).data('lgimg'));
			if (!isQuickView || !util.isMobile() /*|| !detecthover*/) {
				loadElevateZoom(true);
			}
		}	
	});
	
	$('#pdpMain').on('click mouseenter', '.videothumbnail', function(event){
		$(this).closest('.product-thumbnails').find('.thumb.selected').removeClass('selected');
		$(this).closest('.thumb').addClass('selected');
		$('.zoomContainer').remove();
		if($('#iView').is(':visible')){
			$('#iView' ).attr( 'src', function ( i, val ) { return val; });
		}
		$('.product-image.main-image').hide();
		$('.product-primary-image #scene7VideoView').hide();
		$('.product-primary-image #iView').show();
		zoomTimeOut = window.setTimeout(function(){
			$('.zoomContainer').hide(); 
		}, 1000);
		// disable zooming feature
		var $zoomLens = $('.zoomLens'),
		$zoomWindowContainer = $('.zoomWindowContainer'),
		$zoomContainer = $('.zoomContainer');
		if ($zoomLens && $zoomWindowContainer && $zoomContainer) {
			$zoomContainer.remove();
			$zoomLens.remove();
			$zoomWindowContainer.remove();
		}
	});

	$('#pdpMain').on('click mouseleave', '.videothumbnail', function(event){
		$('.zoomContainer').remove(); 
	});
	//scene7 video
	$('#pdpMain').on('click mouseenter', '.videothumbnailscene7', function(event){
		$(this).closest('.product-thumbnails').find('.thumb.selected').removeClass('selected');
		$(this).closest('.thumb').addClass('selected');
		$('.zoomContainer').remove();
		if($('#iView').is(':visible')){
			$('#iView' ).attr( 'src', function ( i, val ) { return val; });
		}
		$('.product-image.main-image').hide();
		$('.product-primary-image #iView').hide();
		$('.product-primary-image #scene7VideoView').show();
		$('.zoomContainer').hide(); 
		zoomTimeOut = window.setTimeout(function(){
			$('.zoomContainer').hide(); 
		}, 2000);
		// disable zooming feature
		var $zoomLens = $('.zoomLens'),
		$zoomWindowContainer = $('.zoomWindowContainer'),
		$zoomContainer = $('.zoomContainer');
		if ($zoomLens && $zoomWindowContainer && $zoomContainer) {
			$zoomContainer.remove();
			$zoomLens.remove();
			$zoomWindowContainer.remove();

		}
	});	
	$('#pdpMain').on('click mouseleave', '.videothumbnailscene7', function(event){
		$('.zoomContainer').hide(); 
	});
};


/*
 * Initializes the PDP thumbnail vetical carousel
 */
function initThumbCarousel() {

	var $pdpMain = $('#pdpMain');

	var isQuickView = $('.pdp-main').find('.primary-image.main-image').data('isquickview');

	if (util.isMobile() || isQuickView || dialog.isActive()) {
		return;
	}

	// INIT
	var minNoOfThumbs = 0;
	if ($("body").hasClass("LeviKR")){
		minNoOfThumbs = 6;
	}
	else {
		minNoOfThumbs = 6;
	}

	var totalNoOfThumbs = $('.product-thumbnails ul li.thumb').length,
	totalPages = Math.ceil(totalNoOfThumbs / minNoOfThumbs);

	if (totalNoOfThumbs > minNoOfThumbs) {

		$('.product-thumbnails').data('page', 1);

		$('.product-thumbnails').css('visibility', 'visible');

		$('.product-thumbnails .arror-box.down-arrow').css('visibility', 'visible');

		$('.product-thumbnails ul li.thumb').each(function() {

			if ($(this).data('index') < (minNoOfThumbs + 1)) {
				$(this).show('fade');
			}
		});
	}
	else {

		$('.product-thumbnails').css('visibility', 'visible');

		$('.product-thumbnails ul li.thumb').each(function() {
			$(this).show('fade');
		});
	}
};

if ($('body').hasClass('LeviJP')){  
	$('.main-image-carousel').on('click', '.owl-next', function (e) {
		e.preventDefault();
		$('.owl-next').css({"background-color":"rgb(105 98 98 / 62%)","border-color":"rgb(107 101 101 / 62%)","color":"black"});
		$('.owl-prev').css({"background-color":"white","border":"1.5px solid #cec2c2","color":"black"});
		
	});
	
	$('.main-image-carousel').on('click', '.owl-prev', function (e) {
		e.preventDefault();
		$('.owl-prev').css({"background-color":"rgb(105 98 98 / 62%)","border-color":"rgb(107 101 101 / 62%)","color":"black"});
		$('.owl-next').css({"background-color":"white","border":"1.5px solid #cec2c2","color":"black"});
		
	});
}
function executePDPCarouselScript(){
	try{
		$('.owl-carousel').owlCarousel({
		    loop:false,
		    margin:10,
		    nav:true,
		    autoHeight:true,
		    navigation: true,
		    navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
		    thumbs: true,
		    thumbImage: true,
		    thumbsPrerendered: false,
		    thumbContainerClass: 'owl-thumbs',
		    thumbItemClass: 'owl-thumb-item',
		    responsive:{
		        0:{
		            items:1
		        },
		        600:{
		            items:1
		        },
		        1000:{
		            items:1
		        }
		    }
		});
	}catch(e){
		console.error("Error in executePDPCarouselScript::"+e);
	}
}
if ($('body').hasClass('LeviJP')) { 
	if($('.owl-carousel').size()>0){
		executePDPCarouselScript();
	}else{
		$(document).ready(function () {
			executePDPCarouselScript();
		});
	}
}
function pauseScene7VideoOnFocusOut(){
	$("#scene7VideoView video").each(function (e) {
		if(this.paused){
		}else{
			this.pause();
		}
	});
} 
	
	
module.exports.loadElevateZoom = loadElevateZoom;
module.exports.loadZoom = loadZoom;
module.exports.setMainImage = setMainImage;
module.exports.replaceImages = replaceImages;
module.exports.initCarousel = initCarousel;
module.exports.initThumbCarousel = initThumbCarousel;
module.exports.omniturecall = omniturecall;
module.exports.executePDPCarouselScript = executePDPCarouselScript;
},{"../../dialog":18,"../../owlcarousel/owlcarousel":26,"../../owlcarousel/owlcarousel.thumbs":27,"../../progress":55,"../../util":67,"lodash":73,"qs":83,"url":90}],42:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
productStoreInventory = require('../../storeinventory/product'),
tooltip = require('../../tooltip'),
util = require('../../util'),
addToCart = require('./addToCart'),
pickupInstore = require('./pickupInstore'),
availability = require('./availability'),
image = require('./image'),
productNav = require('./productNav'),
productSet = require('./productSet'),
recommendations = require('./recommendations'),
variant = require('./variant'),
validator = require('../../validator');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
	productNav();
	recommendations();
	tooltip.init();
	variant.fetchpincode();
	$.widget("custom.myselectmenu", $.ui.selectmenu, {
		_renderItem: function (ul, item) {
			var li = $("<li>"),
			wrapper = $("<div>", { text: item.label });
			
			li.attr('data-event', 'event-data-PDP-Element');
			li.attr('data-PDP', 'Quantity:'+item.label);

			if (item.disabled) {
				li.addClass("ui-state-disabled");
			}
			return li.append(wrapper).appendTo(ul);
		}
	});

	$('select#quantity').myselectmenu({
		select: function (event, ui) {
			$(this).val(ui.item.value).trigger('change');
		}
	});
	
	$('select').myselectmenu({
		icons: { button: "ui-icon-arrowthick-1-s" },
		select: function (event, ui) {
			$(this).val(ui.item.value).trigger('change');
		}
	});
	
}


/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
	var $pdpMain = $('#pdpMain');
	//variant.hideswatches();
	if(SitePreferences.OMNI_ENABLED == 'Y'){
		pickupInstore();
	}
	addToCart();
	availability();
	variant();
	image();
	productSet();
	//initTooltipSelectMenu();
	
	if (SitePreferences.STORE_PICKUP) {
		productStoreInventory.init();
	}

	// Thumb carousel
	var minNoOfThumbs = 0;

	if ( $("body").hasClass("LeviKR") ){
		minNoOfThumbs = 5;
	}
	else {
		minNoOfThumbs = 6;
	}
	
	var totalNoOfThumbs = $('.product-thumbnails ul li.thumb').length,
	totalPages = Math.ceil(totalNoOfThumbs / minNoOfThumbs);

	
	// Next button handler
	$pdpMain.on('click', '.product-thumbnails .arror-box.down-arrow', function(e) {

		$('.product-thumbnails ul li.thumb').hide();

		var curPage = $('.product-thumbnails').data('page');
		curPage++;
		$('.product-thumbnails').data('page', curPage);

		$('.product-thumbnails ul li.thumb').each(function() {
			if ($(this).data('index') > (curPage - 1) * minNoOfThumbs &&
					$(this).data('index') <= (curPage * minNoOfThumbs)) {
				$(this).show('fade');
			}
		});

		if (!$('.product-thumbnails .arror-box.up-arrow').is('visible')) {
			$('.product-thumbnails .arror-box.up-arrow').css('visibility', 'visible');
		}

		if (curPage >= totalPages) {
			$(this).css('visibility', 'hidden');
		}

	});

	// Prev button handler
	$pdpMain.on('click', '.product-thumbnails .arror-box.up-arrow', function(e) {

		$('.product-thumbnails ul li.thumb').hide();

		var curPage = $('.product-thumbnails').data('page');
		curPage--;
		$('.product-thumbnails').data('page', curPage);


		$('.product-thumbnails ul li.thumb').each(function() {
			if ($(this).data('index') > (curPage - 1) * minNoOfThumbs &&
					$(this).data('index') <= (curPage * minNoOfThumbs)) {
				$(this).show('fade');
			}
		});


		if (!$('.product-thumbnails .arror-box.down-arrow').is('visible')) {
			$('.product-thumbnails .arror-box.down-arrow').css('visibility', 'visible');
		}

		if (curPage <= 1) {
			$(this).css('visibility', 'hidden');
		}
	});	

	
	$(document).on('scroll', function(e) {
		if ($('div.ui-selectmenu-open')) {
			$('select').myselectmenu('close');
		}
	});

	/*$(document).on('mousemove', function(e) {
		$('select').myselectmenu({
			icons: { button: "ui-icon-arrowthick-1-s" },
			select: function (event, ui) {
				$(this).val(ui.item.value).trigger('change');
			}
		});
	});*/

	// Add to Wishlist and Add to Gift Registry links behaviors
	$pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
		var data = util.getQueryStringParams($('.pdpForm').serialize());
		if (data.cartAction) {
			delete data.cartAction;
		}
		var url = util.appendParamsToUrl(this.href, data);
		this.setAttribute('href', url);
	});


	//Add to Wishlist for Japan site

	if ( $("body").hasClass("LeviJP") ){

	$('.wishlist-link.inactive #like-alreadyWishlist').attr('title', Resources.ADD_TO_WISHLIST);

	$pdpMain.on('click', '.wishlist-link.inactive #like-alreadyWishlist', function (e) {
		e.preventDefault();

		if (util.isMobile()) {
			alert(Resources.SELECT_SIZE);
			return;
		}

		$(this).tooltip({ items: ".wishlist-link.inactive #like-alreadyWishlist", content: Resources.SELECT_SIZE});
		$(this).tooltip("open");
		$(this).addClass('wishlist-tooltip');
	});

	$pdpMain.on('mouseout', '.wishlist-link.inactive #like-alreadyWishlist', function (e) {
		if ($(this).hasClass('wishlist-tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('wishlist-tooltip');
			$(this).attr('title', Resources.ADD_TO_WISHLIST);
		}
	});
  } 
  else{
		$('.wishlist-link.inactive img').attr('title', Resources.ADD_TO_WISHLIST);
	

	$pdpMain.on('click', '.wishlist-link.inactive img', function (e) {
		e.preventDefault();

		if (util.isMobile()) {
			alert(Resources.SELECT_SIZE);
			return;
		}

		$(this).tooltip({ items: ".wishlist-link.inactive img", content: Resources.SELECT_SIZE});
		$(this).tooltip("open");
		$(this).addClass('wishlist-tooltip');
	});

	$pdpMain.on('mouseout', '.wishlist-link.inactive img', function (e) {
		if ($(this).hasClass('wishlist-tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('wishlist-tooltip');
			$(this).attr('title', Resources.ADD_TO_WISHLIST);
		}
	});

	}
	
	// product already in wishlist for japan 
	if ( $("body").hasClass("LeviJP") ){

	$('.wishlist-link.alreadyaddedtowishlist #like-alreadyWishlist').attr('title', Resources.PRODUCT_ALEADY_IN_WISHLIST);
	
	$pdpMain.on('click', '.wishlist-link.alreadyaddedtowishlist #like-alreadyWishlist', function (e) {
		e.preventDefault();

		if (util.isMobile()) {
			alert(Resources.PRODUCT_ALEADY_IN_WISHLIST);
			return;
		}

		$(this).tooltip({ items: ".wishlist-link.alreadyaddedtowishlist #like-alreadyWishlist", content: Resources.PRODUCT_ALEADY_IN_WISHLIST});
		$(this).tooltip("open");
		$(this).addClass('wishlist-tooltip');
	});

	$pdpMain.on('mouseout', '.wishlist-link.alreadyaddedtowishlist #like-alreadyWishlist', function (e) {
		if ($(this).hasClass('wishlist-tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('wishlist-tooltip');
			$(this).attr('title', Resources.PRODUCT_ALEADY_IN_WISHLIST);
		}
	});
	}
	else{
		// product already in wishlist
	$('.wishlist-link.alreadyaddedtowishlist img').attr('title', Resources.PRODUCT_ALEADY_IN_WISHLIST);
	
	$pdpMain.on('click', '.wishlist-link.alreadyaddedtowishlist img', function (e) {
		e.preventDefault();

		if (util.isMobile()) {
			alert(Resources.PRODUCT_ALEADY_IN_WISHLIST);
			return;
		}

		$(this).tooltip({ items: ".wishlist-link.alreadyaddedtowishlist img", content: Resources.PRODUCT_ALEADY_IN_WISHLIST});
		$(this).tooltip("open");
		$(this).addClass('wishlist-tooltip');
	});

	$pdpMain.on('mouseout', '.wishlist-link.alreadyaddedtowishlist img', function (e) {
		if ($(this).hasClass('wishlist-tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('wishlist-tooltip');
			$(this).attr('title', Resources.PRODUCT_ALEADY_IN_WISHLIST);
		}
	});
	}

	// product like pop up message
	$('.wishlist-link #like-button-enabled').attr('title', Resources.REGISTERED_LIKE_IN_WISHLIST);
	
	$pdpMain.on('click', '.wishlist-link #like-button-enabled', function (e) {
		// e.preventDefault();

		if (util.isMobile()) {
			alert(Resources.REGISTERED_LIKE_IN_WISHLIST);
			return;
		}

		$(this).tooltip({ items: ".wishlist-link #like-button-enabled", content: Resources.REGISTERED_LIKE_IN_WISHLIST});
		$(this).tooltip("open");
		$(this).addClass('wishlist-tooltip');
	});

	$pdpMain.on('mouseout', '.wishlist-link #like-button-enabled', function (e) {
		if ($(this).hasClass('wishlist-tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('wishlist-tooltip');
			$(this).attr('title', Resources.REGISTERED_LIKE_IN_WISHLIST);
		}
	});
	
	// product options
	$pdpMain.on('change', '.product-options select', function () {
		var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
		var selectedItem = $(this).children().filter(':selected').first();
		salesPrice.text(selectedItem.data('combined'));
	});

	$pdpMain.on('click', '.copyurl-icon', function (e) {
		e.preventDefault();
		var copyUrl = $(this).closest('.share-social-icon').data('producturl');
		var aux = document.createElement("input");
		aux.value=copyUrl;

		if ($(this).closest('div.quickview-popup').length) {
			$(this).closest('.ui-dialog').append(aux);
		}
		else {
		$('body').append(aux);
		}
		aux.select();
		document.execCommand("copy");
		aux.remove();
		$(this).tooltip({ items: ".copyurl-icon", content: Resources.URL_COPIED});
		$(this).tooltip("open");
		$(this).addClass('copy-tooltip');
	});

	$pdpMain.on('mouseout', '.copyurl-icon', function (e) {
		if ($(this).hasClass('copy-tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('copy-tooltip');
		}
	});

	$pdpMain.on('click', '.close-button', function(e) {
		$('.socialsharing').removeClass('socialsharingPopOut');
	});

	$pdpMain.on('click', '.facebook-share-icon', function(e) {
		
		var url = "https://www.facebook.com/sharer/sharer.php?u=" + $(this).closest('.share-social-icon').data('producturl');
		var myWindow = window.open(url, "facebook share", "width=600, height=350, top=130, left=350");
	});

	$pdpMain.on('click', '#url-copy', function(e) {
		e.preventDefault();
	}); 

	// handles social share icon click
	$pdpMain.on('click', '.social-share-icon', function(e) {
		e.stopPropagation();
		if ($('.socialsharing').hasClass('socialsharingPopOut')) {
			$('.socialsharing').removeClass('socialsharingPopOut');
		}
		var pid = $(this).data('pid');
		$('.socialsharing.' + pid).toggleClass('socialsharingPopOut');
		
		
		if ($('body').hasClass('LeviKR')) {
			if(!util.isMobile()) {
				$(".socialsharing").find("span.close-button").css("display","none");
				$(".socialsharing").find('.share-all').css('display','inline-flex');
				$(".socialsharing").find(".pdp-icon-facebook span").css("display","none");
				$(".socialsharing").find("div.kakao-share").css("display","none");
				$(".socialsharing").find(".tap-and-hold").css("display","none");
				$(".socialsharing").find("div.tap-hint").css("display","none");
				$(".socialsharing").find("a.url-copy").css("display","none");
			}
			else {
				$(".socialsharing").addClass("socialsharingPopOutMobile");
				$(".socialsharing").find('#copyurl-icon').css('display','none');
				
			}	
		}
		else {
			if (!util.isMobile()) {
				$(".socialsharing").find('span.close-button').css('display','none');
				$(".socialsharing").find('i.pdp-icon-facebook span').css('display','none');
				$(".socialsharing").find('.tap-and-hold').css('display','none');
				$(".socialsharing").find('#url-copy').css('display','none');
				$(".socialsharing").find('.share-all').css('display','flex');
				$(".socialsharing").find('.tap-hint').css('display','none');
			}
		
			else {
				$(".socialsharing").addClass("socialsharingPopOutMobile");
				$(".socialsharing").find('#copyurl-icon').css('display','none');
			}	
		}
		
		
		// if the user is on mobile device then use KakaoTalk API
		//if (util.isMobile()) {

			if ($('#url-copy').text().length > 25) {
				$('#url-copy').text($('#url-copy').text().substring(0, 25) + '...');
				$('#url-copy').css('visibility', 'visible');
			} 

			// check whether the Kakao API has been downloaded. if not, download it first
			if (typeof Kakao !== 'object') {
				var scriptTag = document.createElement('script');
				scriptTag.src = "//developers.kakao.com/sdk/js/kakao.min.js";
				var firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);

				// initialize Kakao API with personal key ONLY when the script has been loaded
				if(scriptTag.readyState) {  //IE Browser
					scriptTag.onreadystatechange = function() {
						if ( scriptTag.readyState === "loaded" || scriptTag.readyState === "complete" ) {
							scriptTag.onreadystatechange = null;
							Kakao.init(SitePreferences.KAKAO_KEY);
							initKakao();
						} 
					}
				} else {  //Non-IE browsers
					scriptTag.onload = function() {
						Kakao.init(SitePreferences.KAKAO_KEY);
						initKakao();
					};
				}  
			}
			else {
				Kakao.init(SitePreferences.KAKAO_KEY);
				initKakao();
			}
		//}
	});

	$pdpMain.on('click', '.socialsharing', function (e) {
		e.stopPropagation();
	});

	$pdpMain.on('click', 'a', function (e) {
		if ($(this).hasClass('social-share-icon')
				|| $(this).hasClass('thumbnail-link')) {
			e.preventDefault();
		}
	}); 

	// below function ensures that when the user clicks anywhere on document except on
	// the social share icon, the options are hidden
	$(document).on('click', function(e) {
		var socialsharing = $(this).find('.socialsharing');  
		if (socialsharing) {
			if ($(socialsharing).hasClass('socialsharingPopOut')) {
				$(socialsharing).removeClass('socialsharingPopOut');
			}
		}
		//$('.store-message').hide();

	});

	// In-store availability

	$pdpMain.on('mouseout', '.search-stores-by-state',function(e) {
		e.preventDefault();
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});	

	$pdpMain.on('click', '.search-stores-by-state',function(e) {
		e.preventDefault();

		if (util.isMobile()) {
			if ($(this).data('isdisabled') == 'disabled') {
				alert(Resources.SELECT_FOR_STOCK);
				return;
			}
		}

		if ($(this).data('isdisabled') == 'disabled') {
			$(this).tooltip({ items: $(this), content: Resources.SELECT_FOR_STOCK});
			$(this).tooltip("open");
			$(this).addClass('tooltip');

			return;
		}
		$(this).closest('span.panel').find('span.errspan').html('').remove();

		var $findByStateForm = $('[id$="_storelocator"]');
		var state = $('[name$="_storelocator_state"]').val();

		if (state == '') {
			var errSpan = document.createElement('span');
			errSpan.innerHTML = Resources.SELECT_STATE;
			errSpan.className += "errspan error";
			$(this).closest('span.panel').append(errSpan);
			return;
		}

		$(this).closest('span.panel').find('span.errspan').html('').remove();

		var pid = $('#pid').val(); // hidden element
		dialog.open({});
		$.ajax({
			url: $(e.target).closest('form').attr('action'),
			type: 'POST',
			data: {
				state: state,
				pid: pid,
				format: 'ajax'
			},
			success: function(response) {
				response=response.trim();
				if(response.length != 0){
					dialog.open({
						html: response,
						options: {
							dialogClass: "pdp-check-store-popup-window",
							open: function() {
								$('.pdp-check-store-popup-window').on('click', '.close-button', function(e) {
									dialog.close();
								});
							}
						}

					});
				} else{
					dialog.open({
						html: response
					});
				}
			},
			error: function(response) {
				alert("Please try again.");
				page.refresh();
			}
		});
	});

	// prevent default behavior of thumbnail link and add this Button
	$pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
		e.preventDefault();
	}); 

	// modified above handler to display size chart even after ajax calls
	if( ! $('body').hasClass('LeviJP')) {
	$pdpMain.on('click', '.size-chart-link a', function (e) {
		e.preventDefault();
		dialog.open({
			url: $(e.target).attr('href'),
			options: {
				dialogClass:'size-chart',
				open: function () {         
                    $(".ui-widget-overlay").on('click', function() {
                  		dialog.close();
		});
                    $('.size-chart').on('click', '.quickview-close', function() {                       	
                      	dialog.close();                      	
	});
                }
			}
		});
	});
	}
	if($('body').hasClass('LeviJP')){
		$pdpMain.on('click', '.true-size-guide a', function (e) {
			e.preventDefault();
			var sizeImage = $('.size-guide-popup').html();
			dialog.open({
				html: sizeImage,
				options: {
					dialogClass:'size-guide-popup',
					open: function () {       
	                    $(".ui-widget-overlay").on('click', function() {
	                  		dialog.close();
	                    });
	                    $('.size-guide-popup').on('click', '.close-button', function() {                       	
	                    	dialog.close();                      	
	                    });
			        }
				}
			});
		});
	}
	
	$pdpMain.on('click', '.fit-guide-link', function (e) {
		e.preventDefault();
		dialog.open({
			html: $(e.target).attr('content')
		});
	});

	// handle toggle refinement blocks
	$pdpMain.on('click', '.accordion h3', function () {
		var header = $(this);
		var content = header.next();
		content.slideToggle(300, function(){
			if ( content.is(":visible") ) {
				content.prev('h3').find('i').attr('class', 'accordianclose24x24');
				content.prev('h3').find('.clear-refinement').show();
			} else {
				content.prev('h3').find('i').attr('class', 'accordianopen24x24');
				content.prev('h3').find('.clear-refinement').hide();
			}
		});
	});

	if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviKR')) {
	$pdpMain.on('click', '.promotion .promo-details', function(e) {
		e.preventDefault();
		var promoDetails = $(this).siblings('.promotion-details').find('#promo-text').html();
		if ($(this).closest('#QuickViewDialog').length) {
			var quickViewToPDP = $('#QuickViewDialog .product-variations').data('producturl');
			window.location.href = quickViewToPDP;
			var promoname = $(this).siblings(".promotion-details").children().attr('class');
			sessionStorage.setItem("navQuickToPDP",promoname);
			return;
		}
		
		dialog.open({
			html: promoDetails,
			options: {
				title: $(this).siblings("span").text(),
				dialogClass:"promo-details-container",
				open:function(){
					$('.promo-details-container .close-button').on('click', function(e) {
						dialog.close();
					});
				}
			},
			callback: function() {
				$('.promo-details-container').find('.ui-dialog-buttonpane').remove();
			}
		});
	});
  }
	if ($('body').hasClass('LeviIN')) {
	$pdpMain.on('click', '.promotion .promo-details', function(e) {
		e.preventDefault();
		var promoDetails = $(this).siblings('.promotion-details').find('#promo-text').html();
		if ($(this).closest('#QuickViewDialog').length) {
			var quickViewToPDP = $('#QuickViewDialog .product-variations').data('producturl');
			window.location.href = quickViewToPDP;
			var promoname = $(this).siblings(".promotion-details").children().attr('class');
			sessionStorage.setItem("navQuickToPDP",promoname); 
			return;
		}
		
		dialog.open({
			html: promoDetails,
			options: {
				title: $(this).siblings("span").text(),
				dialogClass:"promo-details-container",
				open:function(){
					$('.promo-details-container .close-popup-button').on('click', function(e) {
						dialog.close();
					});
				}
			},
			callback: function() {
				$('.promo-details-container').find('.ui-dialog-buttonpane').remove();
			}
		});
	});
  }
	
	$( window ).load(function() {
		var promoname = sessionStorage.getItem("navQuickToPDP");
		if (sessionStorage.getItem("navQuickToPDP") == promoname) {
			$('.promotion .' + promoname).closest('.promotion-callout').find('.promo-details').trigger('click');
			sessionStorage.setItem("navQuickToPDP","false"); 
		}
	});

	// omniture call 
	image.omniturecall();
	

	
	// Search State
	if ($('body').hasClass('LeviJP')) {
		$pdpMain.on('click', '#findinstoreenabled',function(e) {
			e.preventDefault();
			var pid = $('#pid').val(); // hidden element
			// var findInStoreUrl = this.href;
			var findInStoreUrl = $("#findinstoreenabled").attr("data-targeturl");
			$.ajax({
				url: findInStoreUrl,
				type: 'POST',
				data: {
					pid: pid,
					format: 'ajax'
				},
				success: function(response) {
					response=response.trim();
					if(response.length != 0){
						dialog.open({
							html: response,
							options: {
								dialogClass: "pdp-check-store-popup-window",
								width: 720,
								open: function() {
									$('.pdp-check-store-popup-window').on('click', '.close-button', function(e) {
										dialog.close();
									});
								}
							}
	
						});
					} else{
						dialog.open({
							html: response
						});
					}
				},
				error: function(response) {
					alert("Please try again.");
					page.refresh();
				}
			});
		});
		
	}
	
}

/*
 * Inits kakao button
 */
function initKakao() {
	if (typeof Kakao === 'object') {           // script has loaded
		Kakao.Link.createDefaultButton({
			container: '#kakao-share-icon',
			objectType: 'feed',
			content: {
			  title: '리바이스: 공식 온라인 스토어',
			  description: $("#kakao-share-icon").closest(".share-social-icon").data("producttitle"),
			  imageUrl: $("#kakao-share-icon").closest(".share-social-icon").data("productimageurl"),
			  link: {
				mobileWebUrl: $("#kakao-share-icon").closest(".share-social-icon").data("producturl"),
				webUrl: $("#kakao-share-icon").closest(".share-social-icon").data("producturl"),
			  },
			},
			buttons: [
			  {
				title: '상품 보기',
				link: {
				  mobileWebUrl: $("#kakao-share-icon").closest(".share-social-icon").data("producturl"),
				  webUrl: $("#kakao-share-icon").closest(".share-social-icon").data("producturl"),
				},
			  },
			]
		  });
	}
}


function initCaraousel() {

	/** NEW ARRIVALS CAROUSEL - START **/
	
	if(util.isMobile()) {    // carousel for mobile on scroll
		$(window).on('mousemove scroll', function(e){         
			newArrivalCarousel();
			lastVisited();
	 });
	}
	else {					// carousel in desktop
		$('body').on('mousemove scroll', function(e){         
			newArrivalCarousel();
			lastVisited();
		});
	}
	 
function newArrivalCarousel() {
	$('#new-arrival #jcarousel1').on('jcarousel:reload jcarousel:create', function() {
		var width = $(this).innerWidth();
		if($('body').hasClass('LeviJP')){
			if (width > 1400) {
				width = width / 6;
			}else if (width >1024) {
				width = width / 5;
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}else if($('body').hasClass('LeviKR')){
			if (width > 1820) {
				width = width / 7;
			}  else if (width >1340) {
				width = width / 5;
			}  else if (width > 924) {
				width = width / 4;
			} else if (width > 738) {
				width = width / 3;
			} else if (width <= 738 && width >= 450) {
				width = width / 2;
			} else if (width < 450 ) {
				width = width /1;
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}else if($('body').hasClass('LeviIN')){
			if (width > 1400) {
				width = width / 6;
			}  else if (width >1024) {
				width = width / 6;
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width / 1;
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}else{
			if (width > 1366) {
				width = width / 6;
			} else if (width >= 1280 && width <= 1366) {
				width = width / 3 ;
			} else if (width <= 1279 && width >= 768) {
				width = width / 4;
			}else if (width <= 767 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}
	})
	.jcarousel({
		wrap: 'circular'
		});



	$('#new-arrival .na-prev')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#new-arrival').find('#jcarousel1').jcarousel('scroll', '-=1');
	});

	$('#new-arrival .na-next')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#new-arrival').find('#jcarousel1').jcarousel('scroll', '+=1');
	});
}

	/** NEW ARRIVALS CAROUSEL - END **/

/** Recently viewed carousel - START **/

function lastVisited() {
	$('#last-visited #jcarousel').on('jcarousel:reload jcarousel:create', function() {
		var width = $(this).innerWidth();
		if($('body').hasClass('LeviKR')){
			if (width > 1820) {
				width = width / 7;
			}  else if (width >1340) {
				width = width / 5;
			}  else if (width > 924) {
				width = width / 4;
			} else if (width > 738) {
				width = width / 3;
			} else if (width <= 738 && width >= 450) {
				width = width / 2;
			} else if (width < 450 ) {
				width = width /1;
			}
			$(this).jcarousel('items').css('width', width + 'px');		
		}else{
			if (width > 1400) {
				width = width / 6;
			}else if (width >1024) {
				width = width / 5;
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2; 
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}
	})
	.jcarousel({
		wrap: 'circular'
	});

	$('#last-visited .jcarousel-prev1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '-=1');
	});

	$('#last-visited .jcarousel-next1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '+=1');
	});

}
	/** Recently viewed carousel - END **/

}


function initZoom() {

	var isQuickView = $('.pdp-main').find('.primary-image.main-image').data('isquickview');

	if (util.isMobile() || isQuickView) {
		return;
	}


}

var product = {
		initializeEvents: initializeEvents,
		init: function () {
			initZoom();
			initializeDom();
			initializeEvents();			
			image.initCarousel();
			image.initThumbCarousel();
			initCaraousel();
			image.loadElevateZoom(false);
			
			// Pagination

			$('#new-arrival #jcarousel1 .jcarousel-pagination, #last-visited #jcarousel .jcarousel-pagination')
			.on('jcarouselpagination:active', 'a', function() {
				$(this).addClass('active');
			})
			.on('jcarouselpagination:inactive', 'a', function() {
				$(this).removeClass('active');
			})
			.on('click', function(e) {
				e.preventDefault();
			})
			.jcarouselPagination({
				perPage: util.isMobile() ? 1:3,
						item: function(page, carouselItems) {
							return '<a href="#' + page + '">' + page + '</a>';
						}
			});
		}
};

module.exports = product;

},{"../../dialog":18,"../../storeinventory/product":63,"../../tooltip":66,"../../util":67,"../../validator":68,"./addToCart":39,"./availability":40,"./image":41,"./pickupInstore":43,"./productNav":44,"./productSet":45,"./recommendations":46,"./variant":47}],43:[function(require,module,exports){
'use strict';
var util = require('../../util'),
 dialog = require('../../dialog'),
 page = require('../../page');


var openStorePopup = function (e,options) {
	 e.preventDefault();
	 $('.toggleContent').css("display","none");

		$('#selectstorepopup').attr("style","display:block");
		var selectstorepopup = $('#selectstorepopup');
	    dialog.open({
	    	html:selectstorepopup,
	    	options: {
	    		 title : "SELECT A STORE FOR PICKUP",
				 dialogClass:"selectstorepopup",
	    		 width:  600 
	    	   }
	    });
	    var selectedStore = $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').val();
		if(selectedStore != null && selectedStore != undefined){
			$('input[name="dwfrm_singleshipping_inStoreShipments_storeID"]').on('click',showStoreShippingMethodBase);
			  var existingStore = $('#omniBopisStoreId').val();
			  if(null != existingStore && undefined != existingStore){
				  var storeIntheList = $(".stores_ul li").find("input[value='"+existingStore+"']");
				if(null != storeIntheList && undefined != storeIntheList){
					$('.toggleContent').css("display","flex");
					var select = $('input[name=togglebutton]').is(':checked');
					if(select){
						showinstock();
					}
					else{
					$('.stores_ul li').removeClass('selected');	
					storeIntheList.prop('checked',true);
					$(".stores_ul li").find("input[value='"+existingStore+"']").parent().addClass('selected');
					$(".stores_ul li").find("input[value='"+existingStore+"']").siblings(':last').removeClass('not-selected-content');
					$(".stores_ul li").find("input[value='"+existingStore+"']").siblings(':last').addClass('selected-content');
					}
				}
			}
		 }
		$('#searchBtn').on('click',searchStores);
		$('input[name="togglebutton"]').on('click',searchStores);
		$('#current_loc').on('click',currentLocationSearch);
		
		$('.selectstoreBtn').on('click',selectStoretoPickup);
		
}

var currentLocationSearch = function (e){
	if(navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(function(position) {
			var latitude,longitude;
			var radius = $('#instoreradius option:last').val(); // fetching the highest distance value
			// var radius = $('#instoreradius').val();    // fetching current dropdown value
			latitude = position.coords.latitude;
			longitude = position.coords.longitude;
			$.ajax({
				url: Urls.currentLocationSearch,
				data: {
					radius : radius,
					latitude : latitude,
					longitude : longitude
				}
			}).done(function(response) {
				if (!response || !response.success) {
					$('#pickupstoresdiv').html(response);
					$('input[name="dwfrm_singleshipping_inStoreShipments_storeID"]').on('click',showStoreShippingMethodBase);
				} else {
					resolve(response);
				}
			}).fail(function(jqxhr, status, err) {
				reject(new Error(err));
			});
		});	
	}
}

var searchStores = function (e){

	$('#storeToggleText').remove();
	var select = $('input[name=togglebutton]').is(':checked');
		if(select){
			showinstock();
			$('.toggleContent').prepend('<span id="storeToggleText" style="color: #008558;">In-Stock Stores</span>');

		}
		else{
		$('.toggleContent').prepend('<span id="storeToggleText" style="color:#6e6e6e;">All Stores</span>')
		$("#storestockunavailable").text("");
	 	var qty = 1;
		var qtyVal = $("#quantity-button").find('.ui-selectmenu-text').text().trim();
		if(null !== qtyVal && undefined !== qtyVal){
			qty = qtyVal;
		}
		var postalCode = $('#instorezipcode').val();
		var radius = $('#instoreradius').val();
        var pid = window.pid ? window.pid.value : $('.productId')['0'].value
		if(postalCode.length>=6 && postalCode.charAt(0)!='0' && postalCode.charAt(0)!= 0){
		$.ajax({
			url: Urls.searchStoresListForShippingBase,
			type: 'POST',
			data: {
				postalCode : postalCode,
				radius : radius,
				plid: pid,
				quantity : qty
			}
		}).done(function(response) {
			if (!response || !response.success) {
				$('#pickupstoresdiv').html(response);
		//		shippinginit.init();
				$('input[name="dwfrm_singleshipping_inStoreShipments_storeID"]').on('click',showStoreShippingMethodBase);
				$('.selectstoreBtn').on('click',selectStoretoPickup);
				$('.toggleContent').css("display","flex");

			} else {
				resolve(response);

			}
		}).fail(function(jqxhr, status, err) {
			reject(new Error(err));
		});
//	}
		}
	}
}
var showinstock = function (e){
	
			$("#storestockunavailable").text("");
			 var qty = 1;
			var qtyVal = $("#quantity-button").find('.ui-selectmenu-text').text().trim();
			if(null !== qtyVal && undefined !== qtyVal){
				qty = qtyVal;
			}
			var postalCode = $('#instorezipcode').val();
			var radius = $('#instoreradius').val();
			var pid = window.pid ? window.pid.value : $('.productId')['0'].value
	
			$.ajax({
				url: Urls.showInstockOnly,
				type: 'POST',
				data: {
					postalCode : postalCode,
					radius : radius,
					plid: pid,
					quantity : qty
				}
			}).done(function(response) {
				if (!response || !response.success) {
					$('#pickupstoresdiv').html(response);
			
					$('input[name="dwfrm_singleshipping_inStoreShipments_storeID"]').on('click',showStoreShippingMethodBase);
					$('.selectstoreBtn').on('click',selectStoretoPickup);

				} else {
					resolve(response);
				}
			}).fail(function(jqxhr, status, err) {
				reject(new Error(err));
			});
	
		
}
	
var selectStoretoPickup = function (e){
    var selectedStoreShippingMethod =  $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').data('attribute');
	  var selectedStore = $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').val();
	  var isoutofstock = $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').siblings(':last').find(".storeoutofstock").text();
	  if(null != isoutofstock && undefined != isoutofstock && isoutofstock.length > 0){
		 $("#storestockunavailable").text(Resources.OUTOFSTOCK_INSTORE);
		 dialog.close();
	  }else{
		  $("#storestockunavailable").text("");
		  if(null != selectedStore && undefined != selectedStore){
			  var existingStore = $('#omniBopisStoreId').val();
			  if(null != existingStore && undefined != existingStore && "" != existingStore){
				 if(selectedStore !== existingStore){
					  dialog.close(); // close the select store popup and open the confirmation popup
					  $('#changeStoreConfirmDiv').attr("style","display:block");
					  var changeStoreConfirmDiv = $('#changeStoreConfirmDiv').dialog( {title : "CHANGE PICKUP STORE" ,width:"350px"} );
					  // Button events for the buttons inside the dialog div
					  changeStoreConfirmDiv.dialog('close'); 
						  updateStoreDetails(selectedStore);
					  $('#confirmChangeStoreBtn').click(function(){
						  changeStoreConfirmDiv.dialog('close'); 
						  updateStoreDetails(selectedStore);
					  });
					  var path= window.location.pathname.split('/');
					  if(path[path.length-1]=='cart'){
						window.location.reload();
					  }

					  $('#cancelChangeStoreBtn').click(function(){
						  changeStoreConfirmDiv.dialog('close'); 
					  });
			  }else{
				  dialog.close();
			  	}
			  }else{
				  updateStoreDetails(selectedStore);
				  dialog.close();
			  }
		  }
	  }
	
}

function updateStoreDetails(selectedStore){

	  var data = {
	        storeid : selectedStore
	   };
	  $.ajax({
        url: Urls.setStoreInSessionBase,
        data: data,
        success: function () {
        	var addr = $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').next().find('div .selected-store-detail .shipping-store-address').text();
      	  $("#selectedStoreForPickup span").text(addr);
		  $("#storeAddresscart span").text(addr);
      	  $("#selectStoreForPickup").text(" - Change Store");
		  $('#storePickerText .storeSelectmsg').attr("style","display:none");
      	  $('#omniBopisStoreId').val(selectedStore);
      	  sessionStorage.setItem("storeID",selectedStore );
			$("#Ship").prop('checked', false);
			$("#InstorePickup").prop('checked', true).attr("disabled",false);
        }
    });
	  
}
var showStoreShippingMethodBase = function(e){
	var selectedStoreShippingMethod = $(this).data('attribute');
    $('.stores_ul li').removeClass('selected');
	$('.stores_ul li').find('input[name=dwfrm_singleshipping_inStoreShipments_storeID]').siblings(':last').removeClass('selected-content');
	$('.stores_ul li').find('input[name=dwfrm_singleshipping_inStoreShipments_storeID]').siblings(':last').addClass('not-selected-content');
    $('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').parent().addClass('selected');
	$('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').siblings(':last').removeClass('not-selected-content');
	$('input[name=dwfrm_singleshipping_inStoreShipments_storeID]:checked').siblings(':last').addClass('selected-content');
	$('input[name=dwfrm_singleshipping_inStoreShipments_storeID]').on('change',function (element){
		$('.stores_ul li').find("input[name=dwfrm_singleshipping_inStoreShipments_storeID]").each(function(){
			if ($(this).prop('checked')==true){ 
				$(this).parent().addClass('selected');
				$(this).siblings(':last').removeClass('not-selected-content');
				$(this).siblings(':last').addClass('selected-content');			
			}
			else {
				$(this).siblings(':last').removeClass('selected-content');
				$(this).siblings(':last').addClass('not-selected-content');
			}
		});
	});
}

var enablePickupInstoreFields = function(e) {
	var target = e.currentTarget.value;
	if(target === 'Ship' ){
		  localStorage.setItem("BonusEligible",'true');
		  $("#selectedStoreForPickup span").attr("style","display:none");
		  $('#selectStoreForPickup').attr("style","display:none");
		  $('#storePickerText').attr("style","display:none");
		  $('#cod-eli-section').attr("style","display:block");
	}else{
		if($(".product-detail #add-to-cart").data('isdisabled') == 'disabled') {		
			if (util.isMobile()) {  
				alert(Resources.SELECT_FOR_STOCK);
				return;
			}

			$("#selectsizelbl").attr("style","display:block");
			$('#cod-eli-section').attr("style","display:none");	
		}else{
			localStorage.setItem("BonusEligible",'false');
			$("#selectedStoreForPickup span").css('display','');
			$('#selectStoreForPickup').removeAttr("style","display:inline-block");
			$('#storePickerText').attr("style","display:block");
			$('#cod-eli-section').attr("style","display:none");
			if($("#selectedStoreForPickup span").text().trim().length > 0){
				$("#selectStoreForPickup").text(" - Change Store");
				$("#storePickerText h3").text("Store Selected");
			    $('#storePickerText .storeSelectmsg').attr("style","display:none");
			}
		}
	}
}

var cartChangeToShip = function (e){
	e.preventDefault();
//	 var form = $(this).closest('form');
	var field = $(this);
	var uuid = $(this).closest('.cart-row').data('uuid');
	 var data = {
		 puuid : uuid
//		 data: form.serialize()
	  };
	  $.ajax({
	 	type:'POST',
        url: Urls.ChangeToShip,
        data: data,
        success: function (response) {
        	if(response.success){
        		 page.redirect(Urls.cartShow);
        	}else{
        	//	field.tooltip({ items: $(this), content: Resources.QTY_NOT_AVAIL_ITEMSHP});
        		field.tooltip({ items: field, content: Resources.QTY_NOT_AVAIL_ITEMSHP});
        		field.tooltip("open");
        		field.addClass('tooltip');
        	}
        }
	  });
}

var cartChangeToPickup = function (e){
	e.preventDefault();
//	 var form = $(this).closest('form');
	var field = $(this);
	var uuid = $(this).closest('.cart-row').data('uuid');
	 var data = {
		 puuid : uuid
//		 data: form.serialize()
	  };
	  $.ajax({
	 	type:'POST',
       url: Urls.ChangeToPick,
       data: data,
       success: function (response) {
       	if(response.success){
       		page.redirect(Urls.cartShow);
       	}else{
       	//	field.tooltip({ items: $(this), content: Resources.QTY_NOT_AVAIL_ITEMSHP});
       		field.tooltip({ items: field, content: Resources.QTY_NOTAVAIL_FORPICKUP});
       		field.tooltip("open");
       		field.addClass('tooltip');
       	}
       }
	  });
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
	
	$('#selectStoreForPickup').on('click',openStorePopup);
	
	$('#searchBtn').on('click',searchStores);
	$('input[name="togglebutton"]').on('click',searchStores);

	
	$('.selectstoreBtn').on('click',selectStoretoPickup);
	
	$("input[name='Ship']").on('change',enablePickupInstoreFields);
	
	$('.cart-row').on('mouseout', '#cartChangetoShip', function (e) {
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});
	
	$('.cart-row').on('mouseout', '#cartChangeToPick', function (e) {
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});
	
	$('.product-detail').on('focusout', '#shipinstorepickup_div', function (e) {
			$("#selectsizelbl").attr("style","display:none");
	});
	
	 $('#cart-table').on('click', '#cartChangetoShip',cartChangeToShip);
	 $('#cart-table').on('click', '#cartChangeToPick',cartChangeToPickup);	
	


	
};

},{"../../dialog":18,"../../page":28,"../../util":67}],44:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    util = require('../../util');

/**
 * @description loads product's navigation
 **/
module.exports = function () {
    var $pidInput = $('.pdpForm input[name="pid"]').last(),
        $navContainer = $('#product-nav-container');
    // if no hash exists, or no pid exists, or nav container does not exist, return
    if (window.location.hash.length <= 1 || $pidInput.length === 0 || $navContainer.length === 0) {
        return;
    }

    var pid = $pidInput.val(),
        hash = window.location.hash.substr(1),
        url = util.appendParamToURL(Urls.productNav + '?' + hash, 'pid', pid);

    ajax.load({
        url: url,
        target: $navContainer
    });
};

},{"../../ajax":7,"../../util":67}],45:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
    var $addAllToCart = $('#add-all-to-cart'),
        $buynow = $('#buy-now'),
        $productSetList = $('#product-set-list'),
        $buyAll = $('#buy-all');

    var updateAddToCartButtons = function () {
    	
    	var addToCartButtons = [];
    	
    	$productSetList.find('.add-to-cart').each(function() {
    		addToCartButtons.push($(this));
    	});

    	var i;
    	for (i = 0 ; i < addToCartButtons.length ; i++) {
    		var $item = $(addToCartButtons[i]);
    		
    		if ($item.data('isdisabled') == 'disabled') {
    			$productSetList.data('isdisabled', 'disabled');
    			break;
    		}
    	}
    	
        if ($productSetList.data('isdisabled') == 'disabled') {
            $addAllToCart.data('isdisabled', 'disabled');
            $buynow.data('isdisabled','disabled');
        } else {
            $addAllToCart.data('isdisabled', 'enabled');
            $buynow.data('isdisabled', 'enabled');
        }
    };

    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }
    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        e.preventDefault();
        if ($(this).parent('li.color li').hasClass('selected')  ) { 
        	return; 
        	}
        var url = Urls.getSetItem + this.search;
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('form select[name="Quantity"]').first().val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });
};

},{"../../ajax":7,"../../tooltip":66,"../../util":67}],46:[function(require,module,exports){
'use strict';

var util = require('../../util');
/**
 * @description Creates product recommendation carousel using jQuery jcarousel plugin
 **/
module.exports = function () {
    var $carousel = $('#carousel-recommendations');
    if (!$carousel || $carousel.length === 0 || $carousel.children().length === 0) {
        return;
    }
    $carousel.jcarousel().jcarousel({
           wrap: 'circular'
    });
    $('.recommendations.cross-sell .jcarousel-prev')
        .on('jcarouselcontrol:active', function () {
            $(this).removeClass('inactive');
        })
        .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('inactive');
        })
        .jcarouselControl({
            target: '-=1'
        });

    $('.recommendations.cross-sell .jcarousel-next')
        .on('jcarouselcontrol:active', function () {
            $(this).removeClass('inactive');
        })
        .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('inactive');
        })
        .jcarouselControl({
            target: '+=1'
        });
    $('.recommendations .jcarousel-pagination')
    .on('jcarouselpagination:active', 'a', function() {
        $(this).addClass('active');
    })
    .on('jcarouselpagination:inactive', 'a', function() {
        $(this).removeClass('active');
    })
    .on('click', function(e) {
        e.preventDefault();
    })
    .jcarouselPagination({
     perPage: util.isMobile()?1:3,
        item: function(page, carouselItems) {
            return '<a href="#' + page + '">' + page + '</a>';
        }
    });
};

},{"../../util":67}],47:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
image = require('./image'),
progress = require('../../progress'),
productStoreInventory = require('../../storeinventory/product'),
pickupInstore = require('./pickupInstore'),
tooltip = require('../../tooltip'),
util = require('../../util'),
dialog = require('../../dialog');

function initMoreLess(pid) {
    var arr = new Array();
    var noOfSwatches = 8;
    if ($("body").hasClass("LeviKR")){
        noOfSwatches = 9;
    }
    if (pid !== undefined && pid > 0) {
        var ulColor = $('.product-variations.' + pid).find('ul.color');
        ulColor.find('a').each(function() {
            arr.push($(this).parent());
        });
        ulColor.each(function() {
            var LiN = $(this).find('li').not($(".more")).find('a').length;

            if (LiN > noOfSwatches) {
                $(arr[noOfSwatches - 1]).nextAll().hide().addClass('toggleable');
                $('ul.color').append('<li class="more swatches" style="display:block"><a><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a></li>');
            }
            
        });
        ulColor.on('click', '.more', function() {
            var LiN = $(this).closest('ul.color').find('li').not($(".more")).find('a').length;
            if ($(this).hasClass('less')) {
                $(this).siblings('li.toggleable').fadeToggle();
                $(this).html('<a><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a>').removeClass('less');
            } else {
                $(this).siblings('li.toggleable').fadeToggle();
				$(this).html('<a><div>'+ Resources.LESS +'</div></a>').addClass('less');
            }
        });
        return;
    }
    $('ul.color').each(function() {
        var LiN = $(this).find('li').not($(".more")).find('a').length;
        $(this).find('a').each(function() {
            arr.push($(this).parent());
        });
        if (LiN > noOfSwatches) {
            $(arr[noOfSwatches - 1]).nextAll().hide().addClass('toggleable');
            $('ul.color').append('<li class="more swatches" style="display:block"><a><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a></li>');
        }
        
    });

    $('ul.color').on('click', '.more', function(e) {
        e.preventDefault();
        // if ( ( !$('body').hasClass('LeviKR') ) && $(this).closest('div.quickview-popup').length) {
        //     // go to PDP
        //     window.location.href = $(this).closest('.product-variations').data('producturl');
        // }
        e.preventDefault();
        var LiN = $(this).closest('ul.color').find('li').not($(".more")).find('a').length;
        if ($(this).hasClass('less')) {
            $(this).siblings('li.toggleable').fadeToggle();
            $(this).html('<a><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a>').removeClass('less');
        } else {
            $(this).siblings('li.toggleable').fadeToggle();
            $(this).html('<a><div>'+ Resources.LESS +'</div></a>').addClass('less');
        }
    });
}


function fetchpincode() {
	var pincodeckie = util.getCookie('pincodeckie');
	var isdeliverableckie = util.getCookie('isdeliverableckie');
	var iscodavailableckie = util.getCookie('iscodavailableckie');	
	var AuthenticatedCustomer = $('#AuthenticatedCustomer').val();
	var postalCode =$('#PostalCode').val();
	if(document.cookie.indexOf("pincodeckie") >= 0 && pincodeckie!="" && document.cookie.indexOf("isdeliverableckie") >= 0 && document.cookie.indexOf("iscodavailableckie") >= 0){
		$('[id$="singleshipping_inStoreShipments_pinCode"]').val(pincodeckie);
		
		// $('#cod-check').closest('#cod-eli-section').find('#cod-status-section').fadeIn();
		
		if(isdeliverableckie =="NO"){
			$('.cod-check').closest('.cod-eli-section').find('.cod-status-section .deliveryCheck').attr('src', Urls.cod_cross);
			$('.cod-check').closest('.cod-eli-section').find('.cod-status-section .CODCheck').attr('src', Urls.cod_cross);
		}
		else if(iscodavailableckie =="YES"){
			$('.cod-check').closest('.cod-eli-section').find('.cod-status-section .deliveryCheck').attr('src', Urls.cod_tick);
			$('.cod-check').closest('.cod-eli-section').find('.cod-status-section .CODCheck').attr('src', Urls.cod_tick);
		}
		else{
			$('.cod-check').closest('.cod-eli-section').find('.cod-status-section .deliveryCheck').attr('src', Urls.cod_tick);
			$('.cod-check').closest('.cod-eli-section').find('.cod-status-section .CODCheck').attr('src', Urls.cod_cross);
		}
		
		$('.cod-check').closest('.cod-eli-section').find('.cod-del-status').fadeIn();
		
	} else {
		util.createCookie("pincodeckie","","43200");
		util.createCookie("isdeliverableckie","","43200");
		util.createCookie("iscodavailableckie","","43200");
		if(AuthenticatedCustomer == 'true' && postalCode){
			$('[id$="singleshipping_inStoreShipments_pinCode"]').val(postalCode);
		}
	}
}

/**
* @description update product content with new variant from href, load new content to #product-content panel
* @param {String} href - url of the new product variant
**/
var updateContent = function (href, elem) {
	var $pdpForm = $('.pdpForm');
	var qty = $pdpForm.find('select[name="Quantity"]').first().val();
	if ($('body').hasClass('LeviJP')) {
		var alter = $pdpForm.find('select[name="alterstyle"]').val();
	var params = {
			Quantity: isNaN(qty) ? '1' : qty,
					format: 'ajax',
				productlistid: $pdpForm.find('input[name="productlistid"]').first().val(),
				alterStyle : (alter != "") ? alter : ""
		};
	}
	else{
		var params = {
				Quantity: isNaN(qty) ? '1' : qty,
						format: 'ajax',
					productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
 
	};
	}
	progress.show($('#pdpMain'));
	ajax.load({
		url: util.appendParamsToUrl(href, params),
		target: $('#product-content'),
		callback: function () {
			if (SitePreferences.STORE_PICKUP) {
				productStoreInventory.init();
			}
			image.replaceImages();

			tooltip.init();
			var $pdpMain = $('#pdpMain');

			var isquickview= $pdpMain.find('.main-image.primary-image').data('isquickview');
			if(!isquickview){
				if ($('body').hasClass('LeviKR')) {
					//updatebazaarvoicecontainer();
				}

				if(href!="" && href.indexOf("vgid")>0){
					updatedescription();

				}
			}
			
			//after ajax
			image.loadElevateZoom(true);
			
			if($('body').hasClass('LeviKR')){
				var KRpopup = {
				        autoOpen: false,
				        modal: true,
				        width: 900,
				        height: 400,
				        title: Resources.SIZE_GUIDE,
				        dialogClass: 'sizeguide-popup'
				};
			
				
				$('.sizeguide-popup').remove();
				
				$(".size-chart-link a").on('click',function(e){
					var sizechart = $(".sizechartcontent").dialog(KRpopup);
					sizechart.dialog("open");
					$(".sizechartcontent").css('height','300');
					if(!util.isMobile()){
						if($(".sizechartcontent").find('img').length > 1){
							$('.sizeguide-popup img').css('width','50%');
							$('.sizeguide-popup img').css('float','left');
						}
						$('.sizeguide-popup img').css('max-width','100%');
					}
				});
			} 
			
			var zoomFlag = true;
			var iosAgent = window.navigator.userAgent,
			start = iosAgent.indexOf( 'OS ' );
			var iosVersion = window.Number( iosAgent.substr( start + 3, 3 ).replace( '_', '.' ) );
			
            if(util.isMobile()) {
            	if(navigator.userAgent.match(/(iPad|iPhone|iPod)/g) && iosVersion < 11) {
        			zoomFlag = false;
        		}
        		
        		if(zoomFlag) {
	            	//zoom control after variant selection
	    			if($('.ui-dialog.ui-widget').find('#zoom-container').length>=1){ 
	    				$('#zoom-container').remove();
	    			}
                    $("#main-image-carousel li").click(function(e){
                    $('#zoom-container .Zoom-img').remove();
                    $('#wrapper.pt_product-details').removeClass('wrapper-class-for-zoom');
                    	var Imgurl= $(this).find('.main-image').data('zoom-image');
                        $('#wrapper.pt_product-details').addClass('wrapper-class-for-zoom');
                        var final_url = $('<img class="Zoom-img" src="'+Imgurl+'">');
                        $('#zoom-container').css('display','block');
                        $('#zoom-container .zoom-close').css('display','block');
                        $('#zoom-container').append(final_url);
                        $('#zoom-container').dialog(); 
                        $('.ui-dialog.ui-widget').addClass("zoom-container-dialog");
                        $('.ui-widget-content.ui-resizable.zoom-container-dialog').css('display','block');
                        var zoomContainerHeight = ($('.ui-dialog.zoom-container-dialog #zoom-container').height()/2);
                        var zoomContainerWidth = ($('.ui-dialog.zoom-container-dialog #zoom-container').width()/2);
                        $('.ui-dialog.ui-widget').scrollTop(175);
                        $('.ui-dialog.ui-widget').scrollLeft(300);    
                     });
                     $('#zoom-container .zoom-close').on('click',function(event){ 
                      event.stopPropagation(); 
                      $('#zoom-container').dialog('close'); 
                      $('#zoom-container .Zoom-img').remove();
                      $('#wrapper.pt_product-details').removeClass('wrapper-class-for-zoom');
                     });
            	}
            }
            //hide winnersale popup onclick of sizes starts
            var colorClick = elem.closest('ul.swatches.color')[0];
            if($('body').hasClass('LeviKR') && (colorClick==undefined || colorClick=='undefined') && $("#winnerSaleAlert").length>0){
    			$("#winnerSaleAlert").remove();
    		}	
            //hide winnersale popup onclick of sizes ends
			var masterpid = elem.closest('.product-variations').data('masterpid');
			initMoreLess(masterpid);
			//image.initCarousel(); // refreshes the pdp main image carousel
			image.initThumbCarousel();
			
			if ($('body').hasClass('LeviJP')) {//JP owlcarousel script
				image.executePDPCarouselScript();
			}
			
			notifybutton();
			
			//omniture function call
			image.omniturecall();
			//alteration length selection on swatch anchor
			if ($('body').hasClass('LeviJP')) {
			
				$('select').myselectmenu({
					icons: { button: "ui-icon-arrowthick-1-s" },
					select: function (event, ui) {
						$(this).val(ui.item.value).trigger('change');
					}
				});
				alterationStyleSelection();
				
				if (!util.isMobile()) {
					
					$( ".size-waist-variation .unselectable" ).hover(
					  function() {   
						  $(this).tooltip({ items: ".size-waist-variation .unselectable", content: Resources.NOTIFY_ME_MESSAGE });
						  $(this).tooltip("open");
						  $('.ui-tooltip').addClass('custom-tooltip');
							
					 });
				}
				
				// Omniture tag goes here
				$('.alteration-section .alterationstyle').on('click',function(){
					$('#alterstyle-menu li').attr('data-event','event-PDP-Hemming-Type');
					$('#alterstyle-menu li').attr('data-click' ,function(index) {
					var val= $(this).text();
					return val;
					});
				});
				// Omniture tag ends here
				
				
			}
			//fetchpincode function call for india
			if ($('body').hasClass('LeviIN')) {
				fetchpincode();
			}
			if(SitePreferences.OMNI_ENABLED == 'Y'){
				pickupInstore();
			}
			//change dropdown icon when ajax call completes
			changeDropDownArrow();
			if(!$('body').hasClass('LeviIN')) {
				selectinseam();
			}
			if ($('body').hasClass('LeviIN')) {
				$(".secondary.add-to-cart").removeAttr("disabled");		
			}
		}
	});
};


var updatedescription = function (href) {
	ajax.load({    	
		url:Urls.getDescription,
		target: $('.updateproductdescription'),
		callback: function () {
			if (!$('body').hasClass('LeviJP')) {
			productinfoupdate();
		}
		}
	});
 
};

//code for notifyme
function notifybutton() {
    $('#notifymebtn').on('click', function (e) {  
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: { 
            	dialogClass: "notify-me-popup-window",
            	width: 600,
                open: function() {
                	$('.notify-me-popup-window').on('click', '.close-button', function(e) {
						dialog.close();
					});
                	
                    var $notifymeForm = $('[name$="_notifyme"]');
                    var $submit = $notifymeForm.find('[name$="_notifyme_submit"]');
                    
                    //below code goes for omniture tagging
                    var $link = $('#notifymebtn');
                    $submit.attr({
                        'data-product-id': $link.data('pid'),
                        'data-product-name' :$link.data('pname'),
                        'data-product-category':$link.data('pcat'),
                        'data-product-subcategory':$link.data('pcat'),
                        'data-product-department':$link.data('pdepartment'),
                        'notifyme':'1'
                    }).appendTo(this);
                    //the code for omniture track ends here

                    $($submit).on('click', function(e) {
                        if (!$notifymeForm.valid()) {
                             return;
                        }
						if($('.captcha-error').length > 0){
							var v = grecaptcha.getResponse();
							if(document.getElementById('grecaptcharesponse')!=null){
								document.getElementById('grecaptcharesponse').value=grecaptcha.getResponse();
							}
	                        if (v.length === 0) {
	                	    	$('.captcha-error').html(ResourcesRecaptcha.RECAPTCHAVALIDATION);
	                			e.preventDefault();
	                			return;
	                		} else {
	                			$('.captcha-error').html('');
	                		}
						}
						
						
						
						
                        e.preventDefault();
                        $.ajax ({
                            type: 'POST',
                            url: Urls.notifyMeSubscription,
                            data: {
                                pid : $('[name$="pid"]').val(),
                                email : $('[name$="_notifyme_emailAddress"]').val(),
                                grecaptcharesponse : $('[id="grecaptcharesponse"]').val()
                            },
                            
                            success: function (response) {
                               if(response.success== false) {                                    
                                    $(".notifyme-email-already-added").css('display','block');
                                    $(".notifyme-email-already-added").html(Resources.ALREADY_REGISTERED_FOR_NOTIFY);                                    
                               }

                            	
                                if (typeof response === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
                                        page.redirect(Urls.csrffailed);
                                    } else if (typeof response === 'string') {
                                        dialog.$container.html(response);
                                    }
                            },
                            
                            failure: function () {
                                dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                            }
                        }); 
                    });
                }
            }
        });
    });
}

function productinfoupdate() {
	$('.product-info').on('click', '.accordion .logo-heading', function (e) {
		
		e.preventDefault();
		
		if ( !($(this).find('i.accordianclose24x24').is(':visible') || $(this).find('i.accordianopen24x24').is(':visible')) ) {
			return;
		} 
			var header = $(this);
			var content = header.next();
			content.slideToggle(300, function(){
				if ( content.is(":visible") ) {
					content.prev('.logo-heading').find('i.accordianopen24x24').attr('class', 'accordianclose24x24');
					content.prev('.logo-heading').find('.clear-refinement').show();
				} else {
					content.prev('.logo-heading').find('i.accordianclose24x24').attr('class', 'accordianopen24x24');
					content.prev('.logo-heading').find('.clear-refinement').hide();
					
				}
			});
		});

    $('.sizefitredirect').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                dialogClass:'sizefit-redirect-dialog',
                open: function () {
                    $(".ui-widget-overlay").on('click', function() {
                        dialog.close();
                    });
                }
            }
        });
    });
}

function alterationStyleSelection(selectedLength) {
    var $pdpMain = $('#pdpMain');
        var selectedAlterationStyle = $pdpMain.find("#alterstyle option:selected").attr('optionid');
        var selectedSize = $('.product-variations .size-waist-variation .attribute.size .selected a').text();
        var pid = $('.product-variations').attr('data-pid');
        $pdpMain.find("#alterprice").val($pdpMain.find("#alterstyle option:selected").attr('data-price'));
        var minlength = 0;
        var maxlength = 0;
        $.ajax({
            url:  Urls.getAlterationLengths,
            type: 'POST',
            data: {
                style: selectedAlterationStyle,
                length: selectedSize,
                pid : pid
            },
            success: function(response) {
                minlength = response.minLength;
                maxlength = response.maxLength;

                var lengthCount = maxlength - minlength;
                
                var option = '<option value="" selected="selected">'+ Resources.SELECT_ALTER_LENGTH +'</option>';
               
                for(var i= minlength; i <= maxlength; i++) {
                	if(selectedLength == i || lengthCount == 0){
                		option += '<option value="'+ i + '" selected="selected" data-event="event-PDP-Inseam-Size" data-click="'+ i +'">' + i + Resources.CM + '</option>';
                	}
                	else{
                		option += '<option value="'+ i + '" data-event="event-PDP-Inseam-Size" data-click="'+ i +'">' + i + Resources.CM + '</option>';
                	} 
	            }
                
                // omniture tag goes here
                $('.alteration-section .alterationlength').on('click',function(){
					$('#alterlength-menu li').attr('data-event','event-PDP-Inseam-Size');
					$('#alterlength-menu li').attr('data-click' ,function(index) {
					var val= $(this).text();
					return val;
					});
				});
                // omniture tag ends here
                
                $pdpMain.find("#alterlength").html(option);
                $( "#alterlength").myselectmenu( "refresh" );
                
            },
            error: function(response) {
                alert("Please try again.");
                page.refresh();
            }
        });
}

function changeDropDownArrow() {
	$('select').myselectmenu({
		icons: { button: "ui-icon-arrowthick-1-s" },
		select: function (event, ui) {
			$(this).val(ui.item.value).trigger('change');
		}
	});
}

var updatebazaarvoicecontainer = function (href) {
	ajax.load({    	
		url:Urls.getBazaarvoiceContainer,
		target: $('#review-section'),
		callback: function () {
		}
	});
};

$.widget("custom.myselectmenu", $.ui.selectmenu, {
	_renderItem: function (ul, item) {
		var li = $("<li>"),
		wrapper = $("<div>", { text: item.label });

		if (item.disabled) {
			li.addClass("ui-state-disabled");
		}
		return li.append(wrapper).appendTo(ul);
	}
});

$('select').myselectmenu({
	icons: { button: "ui-icon-arrowthick-1-s" },
	select: function (event, ui) {
		$(this).val(ui.item.value).trigger('change');
	}
});


module.exports = function () {
	
		
	var $pdpMain = $('#pdpMain');
	// hover on swatch - should update main image with swatch image
	$pdpMain.on('mouseenter mouseleave', '.swatchanchor', function () {
		// Prevents updating the main product image when video is displayed

		if ($(this).closest('.product-set-list')) {
			return;
		}

		if ($pdpMain.find('.product-primary-image iframe').length == 1
				|| $pdpMain.find('.main-image.primary-image').data('isquickview')) {
			return;
		}
		var largeImg = $(this).data('lgimg'),
		$imgZoom = $pdpMain.find('.main-image'),
		$mainImage = $pdpMain.find('.primary-image');
		if (!largeImg) { return; }
		// store the old data from main image for mouseleave handler
		$(this).data('lgimg', {
			hires: $imgZoom.attr('href'),
			url: $mainImage.attr('src'),
			alt: $mainImage.attr('alt'),
			title: $mainImage.attr('title')
		});
		// set the main image
		image.setMainImage(largeImg);
	});

	$pdpMain.on('mouseout', '#search-stores-by-postalCode',function(e) {
		e.preventDefault();
		if ($(this).hasClass('tooltip')) {
			$(this).tooltip("disable");
			$(this).removeClass('tooltip');
		}
	});

	$pdpMain.on('click', '#search-stores-by-postalCode',function(e) {
		e.preventDefault();

		if (util.isMobile()) {
			if ($(this).data('isdisabled') == 'disabled') {
				alert(Resources.SELECT_FOR_STOCK);
				return;
			}
		}
 
		if ($(this).data('isdisabled') == 'disabled') {
			$(this).tooltip({ items: $(this), content: Resources.SELECT_FOR_STOCK});
			$(this).tooltip("open");
			$(this).addClass('tooltip');
 
			return;
		}

		var pid = $('#pid').val();
		var postalCode;
		var $findInStoreCheck = $('[name="dwfrm_singleshipping_check"]');
		if (!$findInStoreCheck.valid()) {
			return;
		}
		var keyedInpostcalCode = $('#dwfrm_singleshipping_inStoreShipments_storeSearch').val();
		if(keyedInpostcalCode.toString().indexOf(',') != -1){
			postalCode = keyedInpostcalCode.toString().split(',')[1];	 
		}
		else
		{
			postalCode = $('#dwfrm_singleshipping_inStoreShipments_storeSearch').val();
		}

		dialog.open({});
		$.ajax({
			url: $(e.target).closest('form').attr('action'),
			type: 'POST',
			data: {
				postalCode: postalCode,
				pid : pid,
				format: 'ajax'
			},
			success: function(response) {
				response=response.trim();
				if(response.length != 0){
					dialog.open({
						html: response,
						options: {
							dialogClass: "pdp-check-store-popup-window",
							open: function() {
								$('.pdp-check-store-popup-window').on('click', '.close-button', function(e) {
									dialog.close();
								});
							}
						}
 
					});
				} else{
					dialog.open({
						html: response
					});
				}
			},
			error: function(response) {
				alert("Please try again.");
				page.refresh();
			}
		});
	});

	//cod check
	

	//message on unselectable click  
	$('#pdpMain').on('click', '.store-message a', function(e){
		e.stopPropagation();
		//$(document).animate({scrollTop: $('.accordion.store').offset().top }, 2000);
		$(window).scrollTop($('.accordion.store .find-store-accordion').offset().top + (-300));
		if ($('.accordion.store .find-store-accordion').find('i').hasClass('accordianopen24x24')) {
			$('.accordion.store .find-store-accordion').trigger('click');
		}
       });
	if ($('body').hasClass('LeviJP')) {
		$('#pdpMain').on('click', '.size-chart-link a', function(e){
			e.stopPropagation();
			$(window).scrollTop($('.accordion.store .size-chart-link-accordion').offset().top + (-300));
			if ($('.accordion.store .size-chart-link-accordion').find('i').hasClass('accordianopen24x24')) {
				$('.accordion.store .size-chart-link-accordion').trigger('click');
			}
	    });
	}
	// click on swatch - should replace product content with new variant
	$pdpMain.on('click', '.product-detail .swatchanchor', function (e) {
		e.preventDefault();
		e.stopPropagation();
		if ($(this).parent('li.color li').hasClass('selected')  ) { return; }
		if ($('body').hasClass('LeviKR')) {
			$('.store-message').hide();
		}
		updateContent(this.href, $(this));
		if($(this).attr("data-lgimg")!=undefined && $(this).attr("data-lgimg")!="undefined" && $(this).attr("data-lgimg")!=null && $(this).attr("data-lgimg")!=''){
			var swatchcolor = JSON.parse($(this).attr("data-lgimg")).title;
			gtmClickSwatch(swatchcolor, this.id, this);
			var colorproducturl =  $(this).attr('data-colorproducturl');
            if (colorproducturl) {
                window.history.pushState(null, "", colorproducturl);
            }
		}
	});
	$pdpMain.on('click', '.product-detail .wishlist-link', function (e) {
        var locale = $('#locale').val();
      if($("#isGAEnabled").length > 0 && ($("#isGAEnabled").val() == 'true' ))
        {
        gaClickWish();
        }
    });
    $pdpMain.on('click', '#like-button', function (e) {
        var locale = $('#locale').val();
        if($("#isGAEnabled").length > 0 && ($("#isGAEnabled").val() == 'true' )){
            gaClickWish();
        }
    });
	
	if ($('body').hasClass('LeviJP')) {
		$pdpMain.on('change', '.alterationstyle select', function () {
	        var selectedAlterationStyle = $pdpMain.find("#alterstyle option:selected").attr('optionid');
	        if(selectedAlterationStyle == undefined) {
	        	$("#alterlength").attr('disabled', 'true').myselectmenu('refresh');
	        	$('.alteration-disclaimer-section').show();
	        	$('.alteration-disclaimer-section-detail').hide();
	        } else {
	            $("#alterlength").removeAttr('disabled').myselectmenu('refresh');
	            $('.alteration-disclaimer-section').hide();
	            $('.alteration-disclaimer-section-detail').show();
	        }
	        alterationStyleSelection();
		});
	}

	// change drop down variation attribute - should replace product content with new variant
	$pdpMain.on('change', '.variation-select', function () {
		if ($(this).val().length === 0) { return; }
		updateContent($(this).val());
 
	});
	initMoreLess();
	
	notifybutton();
	if (!$('body').hasClass('LeviJP')) {
	productinfoupdate();
	changeDropDownArrow();
	}
	if ($('body').hasClass('LeviJP')) {
		if (!util.isMobile())  {
			$( ".size-waist-variation .unselectable" ).hover(
			  function() {   
				  $(this).tooltip({ items: ".size-waist-variation .unselectable", content: Resources.NOTIFY_ME_MESSAGE });
				  $(this).tooltip("open");
				  $('.ui-tooltip').addClass('custom-tooltip');
					
			});
		}
	}
	
};


$(window).resize(function(){
    $.widget("custom.myselectmenu", $.ui.selectmenu, {
    	_renderItem: function (ul, item) {
    		var li = $("<li>"),
    		wrapper = $("<div>", { text: item.label });

    		if (item.disabled) {
    			li.addClass("ui-state-disabled");
    		}
    		return li.append(wrapper).appendTo(ul);
    	}
    });

    $('select').myselectmenu({
    	icons: { button: "ui-icon-arrowthick-1-s" },
    	select: function (event, ui) {
    		$(this).val(ui.item.value).trigger('change');
    	}
    });
});

function selectinseam() {
	var selectedWaist = $('.size-waist-variation ul.waist').find('.selectable.selected').length;
	var selectedWaistSize = $('.size-waist-variation ul.size').find('.selectable.selected').length;  
	if(selectedWaist == 1 && selectedWaistSize == 0) {
		$('.inseam-select-msg').css('display','inline-block');
	} else {
		$('.inseam-select-msg').css('display','none');
	}
}
function gtmClickSwatch(color, item){ 
	try{
		var isGTMEnabled = $("#isGTMEnabled").val();
		var locale = $('#locale').val();
		if($('body').hasClass('LeviAU') && locale =='en_NZ'){
			isGTMEnabled = $("#isGTMEnabledNZ").val();
		}
		if(isGTMEnabled == 'true'){
			console.log("Swatch clicked from SFCC....");
			dataLayer.push({
			    'event': 'gtm_datalayer_clickswatch',
			    'unique_id': item,
			    'item': item,
			    'color': color 
		    });     
		}
	}catch(e){
		console.log("Error in gtmClickSwatch ::"+e.message);
	}
}
setInterval(function(){
	$('.bv_button_buttonFull').click(function(){
		   $("html").scrollTop( $(".BVDesktop").offset().top );

	 });
	
	}, 1000);
	$(window).load(function(){
	  	if ($('body').hasClass('LeviIN')) {	
			$(".secondary.add-to-cart").removeAttr("disabled");
		}
	});
module.exports.fetchpincode = fetchpincode;
module.exports.alterationStyleSelection = alterationStyleSelection;
},{"../../ajax":7,"../../dialog":18,"../../progress":55,"../../storeinventory/product":63,"../../tooltip":66,"../../util":67,"./image":41,"./pickupInstore":43}],48:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    util = require('../util');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    var url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
            // $form.parent('form').validate().form();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    var $eventAddressForm = $('form[name$="_giftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            var fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });
    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $beforeAddress);
    })
    .on('change', 'select[name$="_addressAfterList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $afterAddress);
    });

    $('.item-list').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        var productListID = $('input[name=productListID]').val();
        quickview.show({
            url: e.target.href,
            source: 'giftregistry',
            productlistid: productListID
        });
    });
}

exports.init = function () {
    initializeEvents();
    addProductToCart();
    login.init();
    util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../ajax":7,"../login":22,"../quickview":56,"../util":67,"./product/addToCart":39}],49:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
productTile = require('../product-tile'),
progress = require('../progress'),
util = require('../util');
/**
 * @description Initialize PLP page with Custom dropdwon
 */

	var scrolledPos;
	var reloadAftrPdp=0;
	var scrolledPosLast;
	var count;
	var scrolledPosUpdted;
	var scrolledPosAftrBack;
	var lastscrlpos;
	var pageheight;

	if(sessionStorage.getItem('scrPos')>0){
		
	}else{
		sessionStorage.setItem('scrPos',0);
	}
	
	if(sessionStorage.getItem('scrolledPosLast') >0 && sessionStorage.getItem('cartContinueShoppingClick') && $('body').hasClass('LeviIN')){
		pageheight = parseInt($('body').height()-$('.footer').height());
		lastscrlpos = parseInt(sessionStorage.getItem('scrolledPosLast')); 
		$(window).scrollTop(lastscrlpos);
		infiniteScroll();
		if(lastscrlpos < pageheight){			
			sessionStorage.removeItem('cartContinueShoppingClick');
		}
	}

function initializeDom() {

	$.widget("custom.myselectmenu", $.ui.selectmenu, {
		_renderItem: function (ul, item) {
			var li = $("<li>"),
			wrapper = $("<div>", { text: item.label });
			li.attr('data-event', 'event-data-searchresult-Interaction');
			li.attr('data-click', item.label);
			if (item.disabled) {
				li.addClass("ui-state-disabled");
			}
			return li.append(wrapper).appendTo(ul);
		}
	});

	$('select').myselectmenu({
		icons: { button: "ui-icon-arrowthick-1-s" },
		select: function (event, ui) {
			$(this).val(ui.item.value).trigger('change');
		}
	});

}

	function infiniteScroll() {
		scrolledPos=$(window).scrollTop();
		sessionStorage.setItem('scrolledPosLast',scrolledPos);
		if(scrolledPosAftrBack>scrolledPos){//To check whether last Scrolling Position was more then current one or not
			scrolledPos=scrolledPosAftrBack;
		}else{
			//To check Page is reloaded or loaded after browser back and whether current scrolled pos is more then sessiond scrolling pos or not
			if(reloadAftrPdp==0&&scrolledPos>sessionStorage.getItem('scrPos')){
				scrolledPos=$(window).scrollTop();
				sessionStorage.setItem('scrPos',scrolledPos);
			}if(reloadAftrPdp==1){
				scrolledPos=sessionStorage.getItem('scrPos');
			}
		}
		
		// getting the hidden div, which is the placeholder for the next page
		var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
		// get url hidden in DOM
		var gridUrl = loadingPlaceHolder.attr('data-grid-url');
	
		if (loadingPlaceHolder.length === 1 && util.elementInViewport(loadingPlaceHolder.get(0), 0)) {
			// switch state to 'loading'
			// - switches state, so the above selector is only matching once
			// - shows loading indicator
			loadingPlaceHolder.attr('data-loading-state', 'loading');
			loadingPlaceHolder.addClass('infinite-scroll-loading');
	
	
			// named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
			var fillEndlessScrollChunk = function (html) {
				loadingPlaceHolder.removeClass('infinite-scroll-loading');
				loadingPlaceHolder.attr('data-loading-state', 'loaded');
				$('div.search-result-content').append(html);
			};
	
			// old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
			// it was removed to temporarily address RAP-2649
			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: gridUrl,
				success: function (response) {
					// put response into cache
					try {
						sessionStorage['scroll-cache_' + gridUrl] = response;
					} catch (e) {
						// nothing to catch in case of out of memory of session storage
						// it will fall back to load via ajax
					}
					// update UI				
					fillEndlessScrollChunk(response);
					productTile.init();
					//to get the Final Scrolled Position for only one time as this section is running multiple times by default
					if(count==1){
						$(window).scrollTop(scrolledPos);
						scrolledPosUpdted=scrolledPos;
					}	
					count++;
						if(scrolledPosUpdted>=scrolledPos){
							scrolledPos=scrolledPosUpdted;
							$(window).scrollTop(scrolledPos);
						}			
						sessionStorage.setItem('scrPos',scrolledPos);
						reloadAftrPdp=0;
					$(".product-name").dotdotdot({
						ellipsis	: '...',
						wrap		: 'letter',
						fallbackToLetter: 'letter',
						after		: null,
						watch		: true,
						height		: null,
						tolerance	: 0

					});
					pageheight = parseInt($('body').height()-$('.footer').height());
					var plpProductTile = $('.plp-page .search-result-items .product-tile');
					if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') || $('body').hasClass('LeviKR') && plpProductTile.length > 0 ) {
						$(plpProductTile).each(function( index ) {
							var masterpid = $(this).data('masterpid');
							var ulColor = $(this).find('ul.swatch-list');
							initMoreLess(masterpid, ulColor);
						});
					}
					if(lastscrlpos >0 && sessionStorage.getItem('cartContinueShoppingClick') && $('body').hasClass('LeviIN')){
						$(window).scrollTop(lastscrlpos);
						if(lastscrlpos -pageheight >0){
							infiniteScroll();
						}else{
							sessionStorage.removeItem('cartContinueShoppingClick');
						}
					}
				}
			});
		}
		
		if($('body').hasClass('LeviIN')){
			$(".product-tile .product-promo").dotdotdot({
				ellipsis	: '...',
				wrap		: 'letter',
				fallbackToLetter: 'letter',
				after		: null,
				watch		: true,
				height		: null,
				tolerance	: 0

			});
		}
		
	}
function createKey() {
	return Math.random().toString(36).slice(2);
}


// PLP Color Swatches

function initMoreLess(pid, ulColor) {
    var arr = new Array();
    var noOfSwatches = 5;

	if ($(window).width() < 768 && util.isMobile()) { 
		noOfSwatches = 4;
	}
    if (pid !== undefined && pid > 0 && ulColor) {
        ulColor.find('a').each(function() {
            arr.push($(this).parent());
        });
        ulColor.each(function() {
            var LiN = $(this).find('li').not($(".more")).find('a').length;

            if (LiN > noOfSwatches) {
                $(arr[noOfSwatches - 1]).nextAll().hide().addClass('toggleable');
                var oldMoreSwatch = $(this).find('li.more.toggleable');
				if (oldMoreSwatch) {
					$(oldMoreSwatch).remove();
				}
                $(ulColor).append('<li class="more swatches swatch_search_shown" style="display:block"><a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a></li>');
			}

        });
        ulColor.on('click', '.more.swatch_search_shown', function(e) {
			e.stopImmediatePropagation();
            var LiN = $(this).closest(ulColor).find('li').not($(".more")).find('a').length;
            if ($(this).hasClass('less')) {
                $(this).siblings('li.toggleable').fadeToggle();
                $(this).html('<a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a>').removeClass('less');
            } else {
                $(this).siblings('li.toggleable').fadeToggle();
				$(this).html('<a class="swatch"><div>'+ Resources.LESS +'</div></a>').addClass('less');
            }
        });
        return;
    }
    $(ulColor).each(function() {
        var LiN = $(this).find('li').not($(".more")).find('a').length;
        $(this).find('a').each(function() {
            arr.push($(this).parent());
        });
        if (LiN > noOfSwatches) {
            $(arr[noOfSwatches - 1]).nextAll().hide().addClass('toggleable');
            $(ulColor).append('<li class="more swatches" style="display:block"><a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a></li>');
        }

    });

    // $(ulColor).on('click', '.more', function(e) {
    //     e.preventDefault();
    //     if ( ( !$('body').hasClass('LeviKR') ) && $(this).closest('div.quickview-popup').length) {
    //         // go to PDP
    //         window.location.href = $(this).closest('.product-variations').data('producturl');
    //     }
    //     e.preventDefault();
    //     var LiN = $(this).closest(ulColor).find('li').not($(".more")).find('a').length;
    //     if ($(this).hasClass('less')) {
    //         $(this).siblings('li.toggleable').fadeToggle();
    //         $(this).html('<a class="swatch"><div>' + '+ ' + (LiN - noOfSwatches) + '</div></a>').removeClass('less');
    //     } else {
    //         $(this).siblings('li.toggleable').fadeToggle();
    //         $(this).html('<a class="swatch"><div>Less</div></a>').addClass('less');
    //     }
    // });
}


/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url) {
	if (!url || url === window.location.href) {
		return;
	}
	progress.show($('.search-result-content'));
	var randomKey = createKey();

	$('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {

		compareWidget.init();
		productTile.init();
		progress.hide();
		if(!$('body').hasClass('LeviIN')){
			history.pushState(undefined, '', url);
		}else{
			var a = new Object;
			a.Controlref = "PLP";
			a.key = randomKey;
			history.pushState(a,'', url);
		}
		initializeDom();
		if($('body').hasClass('LeviKR')){
			window.scrollTo(0,$("#primary").position().top - 50); 
		}else{
			window.scrollTo(0,$('#secondary').position().top - 50);
		} 
		if(!$('body').hasClass('LeviKR') || !$('body').hasClass('LeviAU') || !$('body').hasClass('LeviIN')){
			$(".product-name").dotdotdot({
				ellipsis	: '...',
				wrap		: 'letter',
				fallbackToLetter: 'letter',
				after		: null,
				watch		: true,
				height		: null,
				tolerance	: 0

			});
		}
		
		var plpProductTile = $('.plp-page .search-result-items .product-tile');
		if ($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') || $('body').hasClass('LeviKR') && plpProductTile.length > 0 ) {
			$(plpProductTile).each(function( index ) {
				var masterpid = $(this).data('masterpid');
				var ulColor = $(this).find('ul.swatch-list');
				initMoreLess(masterpid, ulColor);
			});
		}

		$( "div#viewmoreanchor" ).each(function() {
            var $parentUL = $(this).closest('ul').find(".viewall.viewless.selected");
            if($parentUL.length>0){
                $parentUL = $(this).closest('ul').find(".viewall.viewless");
                $parentUL.show();
                $(this).html("View Less");
            }
        });
	});
	
}
if($('body').hasClass('LeviIN')){
	$(window).bind("popstate", function() {
		if(window.history.state!=null && window.history.state!=undefined && window.history.state.Controlref == "PLP"){
			updateProductListingBrowserBack(document.location.href);
		}
	});	
}
function updateProductListingBrowserBack(url) { 
	progress.show($('.search-result-content'));
	$('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {

		compareWidget.init();
		productTile.init();
		progress.hide(); 
		initializeDom(); 
		if($('body').hasClass('LeviKR')){
			window.scrollTo(0,$("#primary").position().top - 50); 
		}else{
			window.scrollTo(0,$('#secondary').position().top - 50);
		} 
		if(!$('body').hasClass('LeviKR') || !$('body').hasClass('LeviAU') || !$('body').hasClass('LeviIN')){
			$(".product-name").dotdotdot({
				ellipsis	: '...',
				wrap		: 'letter',
				fallbackToLetter: 'letter',
				after		: null,
				watch		: true,
				height		: null,
				tolerance	: 0

			});
		}

		$( "div#viewmoreanchor" ).each(function() {
			var $parentUL = $(this).closest('ul').find(".viewall.viewless.selected");
			if($parentUL.length>0){
				$parentUL = $(this).closest('ul').find(".viewall.viewless");
				$parentUL.show();
				$(this).html("View Less");
			}
		});
	});

}

//filter overlay for mobile 
//filter overlay for mobile
function updateleftnavigation(url) {
	url = util.appendParamToURL(url, 'source', 'mobile');
	$('.refinements').load(util.appendParamToURL(url, 'format', 'ajax'), function (){
		$("div#viewmoreanchor").each(function() {
		var $parentUL = $(this).closest('ul').find(".viewall.viewless.selected");
		if($parentUL.length > 0){
		$parentUL = $(this).closest('ul').find(".viewall.viewless");
		$parentUL.show();
		$(this).html("View Less");
	}
	});
});
}

/**
 * @private
 * @function
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
	var $main = $('#main');
	var mainURL = window.location.href;   
	var selectedUrl=window.location.href;

	// handle toggle refinement blocks
	if(!$('body').hasClass('LeviAU')){
	$main.on('click', '.refinement h3', function () {
		var header = $(this);
		if(!$('body').hasClass('LeviJP')){
			var content = header.next();
		}else{
			var content = header.nextAll();
		}
		content.slideToggle(500, function(){
			if ( content.is(":visible") ) {
				content.prev('h3').find('i').attr('class', 'accordianclose24x24');
				content.prev('h3').find('.clear-refinement').show();
			} else {
				content.prev('h3').find('i').attr('class', 'accordianopen24x24');
				content.prev('h3').find('.clear-refinement').hide();
			}
		});
	});
	}
	
	if (util.isMobile()) {
		if(!$('body').hasClass('LeviAU')){
		$main.on('click', 'span.refinement-header', function() {
			var header = $(this);
			var content = header.next();
			content.slideToggle(500, function(){
				content.is(":visible") ? content.prev('span').find('i').attr('class', 'accordianclose24x24') : content.prev('span').find('i').attr('class', 'accordianopen24x24');
			});
		});

		}

	}


	// handle events for updating grid
	$main.on('click', '.pagination a', function (e) {
		// don't intercept for category and folder refinements, as well as unselectable
		if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
			return;
		}
		e.preventDefault();
		/* if( window.innerWidth < 480 && $('body').hasClass('LeviKR')) {
			$('html,body').animate({
			scrollTop: $(".content-slot.slot-grid-header").offset().top},'slow');
		}*/
		updateProductListing(this.href);
		if($('body').hasClass('LeviKR')){
			window.scrollTo(0,$("#primary").position().top - 50); 
		}
	});

	//filter overlay 
	$main.on('click', '.refinement a , .breadcrumb-refinement-name a', function (e) {
		if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
			var listname = evar!=undefined && evar.pageData!=undefined ? evar.pageData.pagecat : '';
			if(listname == ''){
				listname = evar!=undefined && evar.page!=undefined ? evar.page.pagecat : '';
			}
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				"event": "customEvent",
				"eventCategory": "productListFiltered",
				"eventAction": listname,
				"eventLabel": this.title
			});
		}
			
		// don't intercept for category and folder refinements, as well as unselectable
		if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
			return;
		}
		e.preventDefault();
		if ( (navigator.userAgent.toLowerCase().indexOf('ipad') != -1)  ||  (navigator.userAgent.toLowerCase().indexOf('tablet') != -1) ) {
		
			updateProductListing(this.href);
		}
		else if(util.isMobile()){
			selectedUrl = this.href;
			
			updateleftnavigation(selectedUrl);
		}else if($('body').hasClass('LeviKR') && $(window).width()<=768){
			selectedUrl = this.href;
			
			updateleftnavigation(selectedUrl);
			
		}else {
			updateProductListing(this.href);
		}	
	});

	if(util.isMobile()) {
		$main.on('click','.breadcrumb-relax .icon-cancel',function (e) {
			$('.block-layered-nav .close').click();
			updateProductListing(selectedUrl);
		});
		
		$main.on('click','.applybutton',function (e) {
			$('.block-layered-nav .close').click();
			updateProductListing(selectedUrl);
		});
		
		$main.on('click','.clearallbutton',function (e) {
			selectedUrl=mainURL;
			updateleftnavigation(mainURL);
		});
	} else if($('body').hasClass('LeviKR') && $(window).width()<=768){
		$main.on('click','.breadcrumb-relax .icon-cancel',function (e) {
			$('.block-layered-nav .close').click();
			updateProductListing(selectedUrl);
		});
		
		$main.on('click','.applybutton',function (e) {
			$('.block-layered-nav .close').click();
			updateProductListing(selectedUrl);
		});
		
		$main.on('click','.clearallbutton',function (e) {
			selectedUrl=mainURL;
			updateleftnavigation(mainURL);
		});
	}


	// handle events item click. append params.
	$main.on('click', '.product-tile a:not("#quickviewbutton")', function () {
		var a = $(this);
		// get current page refinement values
		var wl = window.location;

		var qsParams = (wl.search.length > 1) ? util.getQueryStringParams(wl.search.substr(1)) : {};
		var hashParams = (wl.hash.length > 1) ? util.getQueryStringParams(wl.hash.substr(1)) : {};

		// merge hash params with querystring params
		var params = $.extend(hashParams, qsParams);
		if (!params.start) {
			params.start = 0;
		}
		// get the index of the selected item and save as start parameter
		var tile = a.closest('.product-tile');
		var idx = tile.data('idx') ? + tile.data('idx') : 0;

		// convert params.start to integer and add index
		params.start = (+params.start) + (idx + 1);
		// set the hash and allow normal action to continue
		a[0].hash = $.param(params);
	});

	// handle sorting change


	$main.on('change', '.sort-by select', function (e) {
		e.preventDefault();
		if ($(this).find('option:selected').val() == "Sort By") {
			return;
		}
		var listname = evar!=undefined && evar.pageData!=undefined ? evar.pageData.pagecat : '';
		if(listname == ''){
			listname = evar!=undefined && evar.page!=undefined ? evar.page.pagecat : '';
		}
		// GA4 sort by event
		$('body').trigger('analytics:sortbyevent', { listpage :listname, sortbylabel: $('#main').find('option:selected').text().trim()});

		if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: "customEvent",
				eventCategory: "sortby",
				eventAction: listname,
				eventLabel: $(this).find('option:selected').html()
			}); 
		}
		updateProductListing($(this).find('option:selected').val());
	})
	.on('change', '.items-per-page select', function () {
		var refineUrl = $(this).find('option:selected').val();
		if (refineUrl === 'INFINITE_SCROLL') {
			$('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
		} else {
			$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
			updateProductListing(refineUrl);
		}
	});

	var isQuickView = $('.pdp-main').find('.primary-image.main-image').data('isquickview');

	if($('#wrapper').hasClass('pt_product-search-noresult') || $('#wrapper').hasClass('pt_categorylanding')) {

		$(window).bind("load", function() {
			newArrivalCarousel();
			recentlyViewedCarousel();
			newTopMenAndWomen();
			newCarousel1();
		});
		$(window).on('mousemove scroll', function(e) {
			newArrivalCarousel();
			recentlyViewedCarousel();
			newTopMenAndWomen();
			newCarousel1();

		});
	}

	/**Added for Clear all issue **/
	
	$(window).ajaxComplete(function() {
		if ($('#secondary.refinements .clear-all').length == 1) {
			var url = window.location.href;
			var originalurl = url.slice( 0, url.indexOf('?') );
			$(".clear-all a").prop("href", originalurl);
			

		}
		
	});
	
	
	
	/** NEW ARRIVALS CAROUSEL - START **/


	function newArrivalCarousel () {
		$('#new-arrival #jcarousel1').on('jcarousel:reload jcarousel:create', function() {
			var width = $(this).innerWidth();
			if($('body').hasClass('LeviJP')){
				if (width > 1400) {
					width = width / 6;
				}else if (width >1024) {
					width = width / 5;
				}  else if (width > 768) {
					width = width / 4;
				} else if (width <= 768 && width >= 480) {
					width = width / 3;
				} else if (width < 480) {
					width = width /2;
				}
				$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
			}else if($('body').hasClass('LeviKR')){
				if (width > 1820) {
					width = width / 7;
				}  else if (width >1340) {
					width = width / 5;
				}  else if (width > 924) {
					width = width / 4;
				} else if (width > 738) {
					width = width / 3;
				} else if (width <= 738 && width >= 450) {
					width = width / 2;
				} else if (width < 450 ) {
					width = width /1;
				}
				$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');	
			}else{
				if (width > 1400) {	
					if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN'))
						width = width / 8;
				}  else if (width >1024) {	
					if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN'))
						width = width / 6;
				}  else if (width > 768) {
					width = width / 4;
				} else if (width <= 768 && width >= 480) {
					width = width / 3;
				} else if (width < 480) {
					width = width /2;
				}	
				$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
			}
			
		})
		.jcarousel({
			wrap: 'circular'
		});



		$('#new-arrival .na-prev')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('.horizontal-jcarousel-wrapper1').find('#jcarousel1').jcarousel('scroll', '-=1');
		});

		$('#new-arrival .na-next')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('#new-arrival').find('#jcarousel1').jcarousel('scroll', '+=1');
		});
	}

	/** NEW ARRIVALS CAROUSEL - END **/



	/** Recently viewed carousel - START **/

	function recentlyViewedCarousel () {	
		$('#last-visited #jcarousel').on('jcarousel:reload jcarousel:create', function() {
			var width = $(this).innerWidth();
			if (width > 1400) {
				width = width / 7;
			}  else if (width >1024) {
				width = width / 5;
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		})
		.jcarousel({
			wrap: 'circular'
		});

		$('#last-visited .jcarousel-prev1')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '-=1');
		});

		$('#last-visited .jcarousel-next1')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '+=1');
		});
	}


	/** Recently viewed carousel - END **/


	function newTopMenAndWomen () {
		$('.horizontal-jcarousel-wrapper #jcarousel').on('jcarousel:reload jcarousel:create', function () {
			var carousel = $(this), //use "this" if want to initialize for only first carousel on page
			width = carousel.innerWidth();

			if (width > 1366) {
				width = width / 6;
			} else if (width >= 1280 && width <= 1366) {
				width = width / 3 ;
			} else if (width <= 1279 && width >= 768) {
				if($('body').hasClass('LeviKR'))
					width = width / 4;


	        	if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN'))
					width = width / 6;
			}else if (width <= 767 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}
			carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
		})
		.jcarousel({
			wrap: 'circular'
		});

		$('.jcarousel-prev')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '-=1'
		});

		$('.jcarousel-next')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '+=1'
		});

	}

	function newCarousel1() {
		$('.horizontal-jcarousel-wrapper1 #jcarousel').on('jcarousel:reload jcarousel:create', function () {
			var carousel = $(this), //use "this" if want to initialize for only first carousel on page
			width = carousel.innerWidth();
			if (width > 1400) {
				width = width / 7;
			}  else if (width >1024) {
				width = width / 5;
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}
			carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');

		})
		.jcarousel({
			wrap: 'circular'
		});


		$('.jcarousel-prev1')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '-=1'
		});

		$('.jcarousel-next1')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '+=1'
		});

		$('.jcarousel-pagination')
		.on('jcarouselpagination:active', 'a', function() {
			$(this).addClass('active');
		})
		.on('jcarouselpagination:inactive', 'a', function() {
			$(this).removeClass('active');
		})
		.on('click', function(e) {
			e.preventDefault();
		})
		.jcarouselPagination({
			perPage: util.isMobile()?1:3,
					item: function(page, carouselItems) {
						return '<a href="#' + page + '">' + page + '</a>';
					}
		});     
	}
}

exports.init = function () {
	if (SitePreferences.LISTING_INFINITE_SCROLL) {
		$(window).on('scroll', infiniteScroll);
	}
	productTile.init();
	initializeDom();
	initializeEvents();
	if($('body').hasClass('LeviIN')){
		$(".product-tile .product-promo").dotdotdot({
			ellipsis	: '...',
			wrap		: 'letter',
			fallbackToLetter: 'letter',
			after		: null,
			watch		: true,
			height		: null,
			tolerance	: 0

		});
	}
};

var amountScrolled = 300;
$(window).scrollTop() == $('body').height()-$('.footer').height()
$(window).scroll(function() {
	if ($(window).scrollTop() > amountScrolled) {
		$('a.back-to-top').fadeIn('slow');
	} else {
		$('a.back-to-top').fadeOut('slow');
	}
});

$('a.back-to-top').click(function() {
	$('html, body').animate({
		scrollTop: 0
	}, 1000);
	return false;
});
$(window).mousedown(function(){
	$(window).scroll(function(){
		count=1;
	});
});

	$(document).ready(function() {
		if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
		    reloadAftrPdp=1;
			count=1;
			scrolledPosAftrBack=sessionStorage.getItem('scrolledPosLast');
		}else{
			reloadAftrPdp=0;
		}
	}); 

// to handle the broken images in IE
	$(document).ready(function(){ 
	    $("img").each(function(index) {
	        $(this).error(function() {
	            $(this).hide();     
	        });
	        $(this).attr("src", $(this).attr("src"));
	  });    
	    
	});
	
	
	function plpViewMoreFunctionality(){
		var $main = $('#main');
	    $main.on('click', 'div#viewmoreanchor', function (e) {
	        var $parentUL = $(e.target).closest('ul').find(".viewall.viewless");
	        $parentUL.toggle();
	        
	        if($(this).html()=="View Less"){
	        	
	            $(this).html("View More");
	        }else{
	           
	            $(this).html("View Less");
	        }
	    });
	    
	    $( "div#viewmoreanchor" ).each(function() {
            var $parentUL = $(this).closest('ul').find(".viewall.viewless.selected");
            if($parentUL.length>0){
                $parentUL = $(this).closest('ul').find(".viewall.viewless");
                $parentUL.show();
                $(this).html("View Less");
            }
        }); 
	}
plpViewMoreFunctionality(); 


function plpPaginationFunctionality(){
	var $main = $('#main');
	if($('body').hasClass('LeviAU') || $('body').hasClass('LeviIN')){
    $main.on('click', '.pagenumber li', function (e) {
	//When the user clicks on the button, scroll to the top of the document
	document.body.scrollTop = 0; // For Safari
	document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
    
	$main.on('click', '#myBtn', function (e) {
		//When the user clicks on the button, scroll to the top of the document

		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

		});
	$main.on('click', '#myBtn_mob', function (e) {
		//When the user clicks on the button, scroll to the top of the document

		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

		});

	}
}
plpPaginationFunctionality();



if($('body').hasClass('LeviIN')){
$(document).ready(function() {
	  $("#content-read-more").click(function() {
	    var elem = $("#content-read-more").text();
	    if (elem == "> Read More") {
	      //Stuff to do when btn is in the read more state
	      $("#content-read-more").text("^ Read Less");
	      $("#content-more").slideDown();
	$("#content-more").css('display','inline');

	    } else {
	      //Stuff to do when btn is in the read less state
	      $("#content-read-more").text("> Read More");
	      $("#content-more").slideUp();
	$("#content-more").css('display','none');
	    }
	  });
	});
}

$(document).ready(function() {
	if($('body').hasClass('LeviIN')){
		if( $("#pageType").length>0 &&$("#pageType").val()=='PLPpage'){
			var randomKey = createKey();
			var a = new Object;
			a.Controlref = "PLP";
			a.key = randomKey;
			history.pushState(a,'', window.location.href);
		}
	}
});
	
},{"../compare-widget":15,"../product-tile":54,"../progress":55,"../util":67}],50:[function(require,module,exports){
'use strict';
var util = require('../util'),
recommendations = require('./product/recommendations'),
dialog = require('../dialog'),
validator = require('../validator');
var NewzealandPopupCookieGlobal='';


exports.init = function () {
	var countryCode = $('#countrycode').val();
	var locale = $('#locale').val();
	
	if ( ($('body').hasClass('LeviAU') ) && ((countryCode =='AU' && locale =='en_AU') || (countryCode =='NZ' && locale =='en_NZ'))) {  
		
		displayNewsletterPopup(); 		// Display newsletterpopup 
	} 
	else if ($('body').hasClass('LeviAU')) {
		if(locale =='en_AU'){
			displayNZPopup(); 			 // Display country Selector popup
		}
				
	}
	else if ($('body').hasClass('LeviIN') || $('body').hasClass('LeviKR') ) {  
		
		displayNewsletterPopup(); 		// Display newsletterpopup for IN and KR
	} 
	
	if ($('body').hasClass('LeviKR')){
		if($('.home-top-carousel .top-men, .home-top-carousel .top-women').children().length == 0){
			$('.home-top-carousel').css("display",'none');
		}
	}
	
	/*Code added if there is no child in home-top-carousel */
	if ($('body').hasClass('LeviKR')){
		if($('.home-top-carousel .top-men, .home-top-carousel .top-women').children().length == 0){
			$('.home-top-carousel').css("display",'none');
			}
	}

	$(document).keydown(function(e) {
		// ESCAPE key pressed
		if (e.keyCode == 27) {
			dialog.close();
		}
	});
	$('.newsletterpopup-sub').on('click', '.close-popup-button, .close-newsletterpopup', function(e) {
		e.preventDefault();
		dialog.close();
		displaySubsequentPopup();
	});
	
	$('.newsletterpopup-sub').on('click', '.hide-till-tomo-btn', function(e) {
		e.preventDefault();
		util.createCookie('dw_hide_popup_tomo', 'active', 30);
		dialog.close();
		displaySubsequentPopup();
	});

	$(document).on('click', '.colse-popup-control a.link-control', function(e) {
		e.preventDefault();
		dialog.close();
	});

	$(document).on('click', '.hide-till-tomo-control a.link-control', function(e) {
		e.preventDefault();
		util.createCookie('hide_subsequent_popup_tomo', 'active', 30);
		dialog.close();
	});
	
	$('.selectcountry').on('click', '.close-popup-button, .close-newzealandpopup', function(e) {
		e.preventDefault();
		dialog.close();
	});
	
	$('#homepage-slider')
	// responsive slides
	.on('jcarousel:create jcarousel:reload', function () {
		var element = $(this),
		width = element.innerWidth();
		element.jcarousel('items').css('width', width + 'px');
		$('#homepage-slides .slide').css('visibility', 'visible');
	})
	.jcarousel({
		wrap: 'circular'
	})
	.jcarouselAutoscroll({
		interval: 5000
	});
	if($("body").hasClass("LeviIN")){
		$('#homepage-text-slider')	
		// responsive slides	
		.on('jcarousel:create jcarousel:reload', function () {	
			var element = $(this),	
			width = element.innerWidth();	
			element.jcarousel('items').css('width', width + 'px');	
			$('#homepage-text-slides .slide').css('visibility', 'visible');	
		})	
		.jcarousel({	
			wrap: 'circular'	
		})	
		.jcarouselAutoscroll({	
			interval: 5000	
		});
	}
	$('.jcarousel-prev-home')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.jcarouselControl({
		target: '-=1'
	});
	$('.jcarousel-next-home')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.jcarouselControl({
		target: '+=1'
	});

	$('#homepage-slider .jcarousel-control')
	.on('jcarouselpagination:active', 'a', function () {
		$(this).addClass('active');
	})
	.on('jcarouselpagination:inactive', 'a', function () {
		$(this).removeClass('active');
	})
	.jcarouselPagination({
		item: function (page) {
			if ($('body').hasClass('LeviJP')) {
			return '<a href="#' + page + '">' + document.getElementById(page).innerHTML +'</a>';
			}
			else {
			return '<a href="#' + page + '">' + page + '</a>';
		}
		}
	});
	if($("body").hasClass("LeviIN")){
		$('#homepage-text-slider .jcarousel-control')	
		.on('jcarouselpagination:active', 'a', function () {	
			$(this).addClass('active');	
		})	
		.on('jcarouselpagination:inactive', 'a', function () {	
			$(this).removeClass('active');	
		})	
		.jcarouselPagination({	
			item: function (page) {	
				if ($('body').hasClass('LeviJP')) {	
				return '<a href="#' + page + '">' + document.getElementById(page).innerHTML +'</a>';	
				}	
				else {	
				return '<a href="#' + page + '">' + page + '</a>';	
			}	
			}	
		});
	}
	if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')) { 
		$('#homepage-slider-marketing')
		// responsive slides
		.on('jcarousel:create jcarousel:reload', function () {
			var element = $(this),
			width = element.innerWidth();
			element.jcarousel('items').css('width', width + 'px');
		})
		.jcarousel({
			wrap: 'circular'
		})
		.jcarouselAutoscroll({
			interval: 5000
		});
		$('.jcarousel-prev-home-marketing')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '-=1'
		});
		$('.jcarousel-next-home-marketing')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '+=1'
		});


		$('#homepage-slider-marketing .jcarousel-control')
		.on('jcarouselpagination:active', 'a', function () {
			$(this).addClass('active');
		})
		.on('jcarouselpagination:inactive', 'a', function () {
			$(this).removeClass('active');
		})
		.jcarouselPagination({
			item: function (page) {
				return '<a href="#' + page + '">' + page + '</a>';
			}
		});
	}



	$('#vertical-carousel')
	.jcarousel({
		vertical: true
	})
	.jcarouselAutoscroll({
		interval: 5000
	});
	$('#vertical-carousel .jcarousel-prev')
	.on('jcarouselcontrol:active', function () {
		$(this).removeClass('inactive');
	})
	.on('jcarouselcontrol:inactive', function () {
		$(this).addClass('inactive');
	})
	.jcarouselControl({
		target: '-=1'
	});

	$('#vertical-carousel .jcarousel-next')
	.on('jcarouselcontrol:active', function () {
		$(this).removeClass('inactive');
	})
	.on('jcarouselcontrol:inactive', function () {
		$(this).addClass('inactive');
	})
	.jcarouselControl({
		target: '+=1'
	});

	/** NEW ARRIVALS CAROUSEL - START **/ 


	$(window).on('mousemove scroll', function(e) {
		newArrivalCarousel();
		newTopMenAndWomen();
	});



	function newArrivalCarousel() {
		var center_align = false;
		if($('body').hasClass('LeviIN')){
			center_align = true;
		}
		$('#new-arrival #jcarousel1').on('jcarousel:reload jcarousel:create', function() {
			var width = $(this).innerWidth();			
			if($('body').hasClass('LeviKR')){
				if (width > 1820) {
					width = width / 7;
				}  else if (width >1340) {
					width = width / 5;
				}  else if (width > 924) {
					width = width / 4;
				} else if (width > 738) {
					width = width / 3;
				} else if (width <= 738 && width >= 450) {
					width = width / 2;
				} else if (width < 450 ) {
					width = width /1;
				}
				$(this).jcarousel('items').css('width', width + 'px');		
			}else{
				if($('body').hasClass('LeviIN')){
					if (width > 1400) {
						width = width / 3;
					}  else if (width >1024) {
						width = width / 3;
					}  else if (width > 768) {
						width = width / 3;
					} else if (width <= 768 && width >= 480) {
						width = width / 3;
					} else if (width < 480) {
						width = width / 1;
					}
				}
				else{
					if (width > 1400) {
						width = width / 7;
					}  else if (width >1024) {
						width = width / 5;
					}  else if (width > 768) {
						width = width / 4;
					} else if (width <= 768 && width >= 480) {
						width = width / 3;
					} else if (width < 480) {
						width = width /2;
					}
				}
				$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
			}
		})
		.jcarousel({
			wrap: 'circular'
		});

		$('#new-arrival .na-prev')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('#new-arrival').find('#jcarousel1').jcarousel('scroll', '-=1');
		});

		$('#new-arrival .na-next')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('#new-arrival').find('#jcarousel1').jcarousel('scroll', '+=1');
		});

	}

	function newTopMenAndWomen() {
		//Men and Women Recommendations
		$('.horizontal-jcarousel-wrapper #jcarousel').on('jcarousel:reload jcarousel:create', function() {
			var width = $(this).innerWidth();
			if (width > 1400) {
				if ($('body').hasClass('LeviKR')||$('body').hasClass('LeviJP')) {width = width / 7;}
				else if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')) {width = width / 8;}
			}  else if (width >1024) {
				if ($('body').hasClass('LeviKR')||$('body').hasClass('LeviJP')) {width = width / 5;}
				else if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')) {width = width / 6;}
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}

			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		})
		.jcarousel({
			wrap: 'circular'
		});

		$('.horizontal-jcarousel-wrapper .jcarousel-prev')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('.horizontal-jcarousel-wrapper').find('#jcarousel').jcarousel('scroll', '-=1');
		});

		$('.horizontal-jcarousel-wrapper .jcarousel-next')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.on('click', function() {
			$(this).closest('.horizontal-jcarousel-wrapper').find('#jcarousel').jcarousel('scroll', '+=1');
		});
	}
	/** NEW ARRIVALS CAROUSEL - END **/


	/** Recently viewed carousel - START **/

	$('#last-visited #jcarousel').on('jcarousel:reload jcarousel:create', function() {
		var width = $(this).innerWidth();
		if($('body').hasClass('LeviKR')){
			if (width > 1820) {
				width = width / 7;
			}  else if (width >1340) {
				width = width / 5;
			}  else if (width > 924) {
				width = width / 4;
			} else if (width > 738) {
				width = width / 3;
			} else if (width <= 738 && width >= 450) {
				width = width / 2;
			} else if (width < 450 ) {
				width = width /1;
			}
			$(this).jcarousel('items').css('width', width + 'px');	
		}else{
			if (width > 1400) {
				width = width / 7;
			}  else if (width >1024) {
				width = width / 5;
			}  else if (width > 768) {
				width = width / 4;
			} else if (width <= 768 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}
			$(this).jcarousel('items').css('width', Math.ceil(width) + 'px');
		}
	})
	.jcarousel({
		wrap: 'circular'
	});

	$('#last-visited .jcarousel-prev1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '-=1');
	});

	$('#last-visited .jcarousel-next1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#last-visited').find('#jcarousel').jcarousel('scroll', '+=1');
	});





	if ($('body').hasClass('LeviKR')) {
		$('.horizontal-jcarousel-wrapper #jcarousel').on('jcarousel:reload jcarousel:create', function () {
			var carousel = $(this), //use "this" if want to initialize for only first carousel on page
			width = carousel.innerWidth();

			if (width > 1366) {
				width = width / 6;
			} else if (width >= 1280 && width <= 1366) {
				width = width / 3 ;
			} else if (width <= 1279 && width >= 768) {
				width = width / 4;
			}else if (width <= 767 && width >= 480) {
				width = width / 3;
			} else if (width < 480) {
				width = width /2;
			}
			carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
		})
		.jcarousel({
			wrap: 'circular'
		});

		$('.jcarousel-prev')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '-=1'
		});

		$('.jcarousel-next')
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('invisible');
		})
		.on('jcarouselcontrol:active', function() {
			$(this).removeClass('invisible');
		})
		.jcarouselControl({
			target: '+=1'
		});
	}


	$('.horizontal-jcarousel-wrapper1 #jcarousel').on('jcarousel:reload jcarousel:create', function () {
		var carousel = $(this), //use "this" if want to initialize for only first carousel on page
		width = carousel.innerWidth();
		if (width > 1400) {
			if ($('body').hasClass('LeviKR')||$('body').hasClass('LeviJP')) {width = width / 7;}
			else if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')) {width = width / 8;}    

		}  else if (width >1024) {
			if ($('body').hasClass('LeviKR')||$('body').hasClass('LeviJP')) {width = width / 5;}
			else if ($('body').hasClass('LeviAU')||$('body').hasClass('LeviIN')) {width = width / 6;}  
		}  else if (width > 768) {
			width = width / 4;
		} else if (width <= 768 && width >= 480) {
			width = width / 3;
		} else if (width < 480) {
			width = width /2;
		}
		carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');

	})
	.jcarousel({
		wrap: 'circular'
	});


	$('.jcarousel-prev1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#jcarousel').jcarousel('scroll', '-=1');
	});

	$('.jcarousel-next1')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.on('click', function() {
		$(this).closest('#jcarousel').jcarousel('scroll', '+=1');
	});

	$('.jcarousel-pagination')
	.on('jcarouselpagination:active', 'a', function() {
		$(this).addClass('active');
	})
	.on('jcarouselpagination:inactive', 'a', function() {
		$(this).removeClass('active');
	})
	.on('click', function(e) {
		e.preventDefault();
	})
	.jcarouselPagination({
		perPage: util.isMobile()?1:3,
				item: function(page, carouselItems) {
					return '<a href="#' + page + '">' + page + '</a>';
				}
	});     

if ($('body').hasClass('LeviJP') || $('body').hasClass('LeviKR')) {	
	$('.horizontal-jcarousel-wrapper2 #jcarousel').on('jcarousel:reload jcarousel:create', function () {
		var carousel = $(this), //use "this" if want to initialize for only first carousel on page
		width = carousel.innerWidth();
		if($('body').hasClass('LeviKR')){
			if (width > 924) {
				width = width / 4;  
			}  else if (width >= 440) {
				width = width / 2;
			} else if (width < 440) {
				width = width /1;
			}
			carousel.jcarousel('items').css('width', width + 'px');
		}else{
			if (width > 1400) {
				width = width / 6;  
			}  else if (width >1024) {
				width = width / 4;  
			}  else if (width > 768) {
				width = width / 2;
			} else if (width <= 768 && width >= 480) {
				width = width / 2;
			} else if (width < 480) {
				width = width /1;
			}
			carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
		}
	})
	.jcarousel({
		wrap: 'circular'
	});


	$('.jcarousel-prev2')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.jcarouselControl({
		target: '-=1'
	});

	$('.jcarousel-next2')
	.on('jcarouselcontrol:inactive', function() {
		$(this).addClass('invisible');
	})
	.on('jcarouselcontrol:active', function() {
		$(this).removeClass('invisible');
	})
	.jcarouselControl({
		target: '+=1'
	});

	$('.jcarousel-pagination')
	.on('jcarouselpagination:active', 'a', function() {
		$(this).addClass('active');
	})
	.on('jcarouselpagination:inactive', 'a', function() {
		$(this).removeClass('active');
	})
	.on('click', function(e) {
		e.preventDefault();
	})
	.jcarouselPagination({
		perPage: util.isMobile()?1:3,
				item: function(page, carouselItems) {
					return '<a href="#' + page + '">' + page + '</a>';
				}
	}); 
}

};   

function displaySubsequentPopup() {
	var enablesubsequentpopupdesktop = $('#enablesubsequentpopup').val() == "true" ? true : false;
	var enablesubsequentpopupmobile = $('#enablesubsequentpopupmobile').val() == "true" ? true : false;
	
	if (!$('body').hasClass('LeviKR')){
		return;
	}

	var KRsubsequentPopupCookie = util.getCookie('hide_subsequent_popup_tomo');
	
	if ( $('body').hasClass('LeviKR') && KRsubsequentPopupCookie != "") {
		return;
	}

	if(enablesubsequentpopupmobile && util.isMobile()){
		dialog.open({
			url: Urls.subsequenthomepagepopupmobile,
			options: {
				dialogClass: "subsequent_homepage_popup_mobile",
				open: function(){
					util.createCookie('dw_subsequent_popup', 'seen', 30);
					$('.close-subsequent_popup-mobile').click(function () {
                  		dialog.close();
                    });
				}
			}
		});

	}else if(enablesubsequentpopupdesktop){
		dialog.open({
			url: Urls.subsequenthomepagepopup,
			options: {
				dialogClass: "subsequent_homepage_popup",
				open: function(){
					console.log("testing in cli");
					util.createCookie('dw_subsequent_popup', 'seen', 30);
					$('.close-subsequent_popup').click(function () {
                  		dialog.close();
                    });
				},	
			},
			width: 320,
			height: 480,
			callback: function() {
				util.createCookie('dw_subsequent_Callback', 'seen', 30);
			}
		});
	}
}

function displayNewsletterPopup() {

	// Display a newsletter popup on homepage - session tracked using cookies

	// Disable popup for mobile devices

	var AuthenticatedCustomer = $('#AuthenticatedCustomer').val();
	var enablenewsletterpopupfordesktop = $('#enablenewsletterpopupfordesktop').val();
	var enablenewsletterpopupformobile = $('#enablenewsletterpopupformobile').val();
	var enablesmallmobilepopup = $('#enablesmallmobilepopup').val() == "true" ? true : false;
	var checkforenable=null;
	var enablesubsequentpopupdesktop = $('#enablesubsequentpopup').val() == "true" ? true : false;
	var enablesubsequentpopupmobile = $('#enablesubsequentpopupmobile').val() == "true" ? true : false;


	if(util.isMobile()){
		if(enablenewsletterpopupformobile =='true'){
			checkforenable=true;
		}

	}else{
		if(enablenewsletterpopupfordesktop=='true'){
			checkforenable=true;
		}

	}

	if (AuthenticatedCustomer == 'true') {
		return;
	}

	// Create cookie
	var NewzealandPopupCookie = util.getCookie('dw_levis_store_newsletterpopup');
	var newsletterpopupregistration = util.getCookie('dw_levis_store_newsletterpopupregistration');

	if ( NewzealandPopupCookie != "" || newsletterpopupregistration =="true") {
		if($('body').hasClass('LeviKR') && enablesubsequentpopupdesktop || enablesubsequentpopupmobile){
			displaySubsequentPopup();
		}
		return;
	}
	
	
	if(enablesmallmobilepopup && util.isMobile()){
		dialog.open({
			url: Urls.newsletterpopupmobile,
			options: {
				dialogClass: "newsletter-mobile-popup",
				open: function(){
					util.createCookie('dw_levis_store_newsletterpopup', 'seen', 30);
					$('#wrapper.pt_storefront').css('position','relative');
					$('.newsletter-mobile-popup').css('position','fixed');
					$('.close-popup-button').click(function () {
                  		dialog.close();
                    });
				}
			}
		});
		
	}
	else if(checkforenable){
		dialog.open({
			url: Urls.newsletterpopup,
			options: {
				close: function() {
					$('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.newsletterpopup-sub.ui-draggable').css('background', '');
					if (util.isMobile()) {
						$('#wrapper').css('position','relative');
						return;
					}	
				},
				width: 640,
				height: 385,
				dialogClass: "newsletterpopup-sub",
				open: function() {
					$('select').myselectmenu({
						icons: { button: "ui-icon-arrowthick-1-s" },
						select: function (event, ui) {
							$(this).val(ui.item.value).trigger('change');
						}
					});
					validator.init();

					var $newsletterForm = $('#newsletter-popup');
					var $submit = $newsletterForm.find('[name$="home-email"]');

					$submit.click(function(e){
						e.preventDefault();
						var data = null, preference = null,addToEmailList=false , finalUrl=null,phone=null,firstName=null;
						var email = $newsletterForm.find('[name$="_newsletterpopup_newsletterEmail"]').val();
						var newsletterCheckbox = $newsletterForm.find('[name$="_newsletterpopup_newsletterTermsAndConditions"]').is(":checked");
						var siteID = $('[name$="footernewsletter.siteID"]').val();
						addToEmailList = $('[name$="footernewsletter.addToEmailList"]').val();
						preference = $('[name$="_newsletterpopup_preference"]').val();
						if( $('body').hasClass('LeviAU') ){
							firstName= $('[name$="_newsletterpopup_firstName"]').val();
							}
						if ($('body').hasClass('LeviIN')){
							phone = $('[name$="_newsletterpopup_phoneMobile"]').val();
						}
						
						finalUrl =  Urls.newsletterSubscription;
						
						if ($('body').hasClass('LeviIN')){
							data = {'email':email ,'newsletterCheckbox':newsletterCheckbox ,'preference':preference,'siteID':siteID,'addToEmailList':addToEmailList, 'phone':phone, 'format' : 'ajax'};
						}
						else if  ($('body').hasClass('LeviAU')){
							data = {'email':email ,'newsletterCheckbox':newsletterCheckbox ,'preference':preference,'siteID':siteID,'addToEmailList':addToEmailList, 'firstName':firstName, 'format' : 'ajax'};
						}	
						else{
							data = {'email':email ,'newsletterCheckbox':newsletterCheckbox ,'preference':preference,'siteID':siteID,'addToEmailList':addToEmailList,'format' : 'ajax'};
						}
						
						if (!$newsletterForm.valid()) {
							return false;
						}
						//Start- GA4 Event
						var headingText = $(e.target).closest('.footer-item').find('.heading1').text();
						// End - GA4 Event
						$.ajax({
							type: 'POST',
							dataType: 'html',
							url: finalUrl,
							data: data,
							success: function (response) {
								if(JSON.parse(response).success == false) {
									$(".newsletter-popup-success").css('display','none');
									$("#newsletter-popup-already-registered-email-error").css('display','block');
									$("body.LeviAU .footer-item:nth-child(1)").css('padding-bottom',"3%");
									$("body.LeviIN .footer-item:nth-child(1)").css('padding-bottom',"3%");
									$("body.LeviKR .footer-item:nth-child(1)").css('padding-bottom',"3%");
									$("#newsletter-popup-already-registered-email-error").html(Resources.NEWSLETTER_FOOTER_REGISTERED_EMAIL);
								}
								else if (JSON.parse(response).success == true)
								{
									//Start- GA4 Event
									$('body').trigger('analytics:newsletterSubscriptionEvent', { 
										emailValue :email, 
										buttonText : $(e.target).text(), 
										headingText : headingText
									});
									//End- GA4 Event

									if($("#isGTMEnabled").val() == 'true')
									{
									gtmSubscriptionData();
									}
									//$newsletterForm.remove();
									$(".newsletter-popup-success").css('display','block');
									$("#newsletter-popup-already-registered-email-error").css('display','none');
									$(".newsletter-popup-success").html(Resources.NEWSLETTER_FOOTER_SUCCESS);
									$("body.LeviAU .footer-item:nth-child(1)").css('padding-bottom',"2%");
									$("body.LeviIN .footer-item:nth-child(1)").css('padding-bottom',"2%");
									$("body.LeviKR .footer-item:nth-child(1)").css('padding-bottom',"2%");
									util.createCookie('dw_levis_store_newsletterpopupregistration', 'true', 525600);

									dialog.open({
										dialogClass: 'newsletterpopup-success',
										width: 200,
										height: 150,
										html: ($('body').hasClass('LeviKR')) ? '<div class="close-popup-button"><span>' + Resources.CLOSE + "</span></div>" + '<div class="newsletterpopup-text">'+SitePreferences.NEWSLETTER_POPUP_SUCCESS+'</div>' 
											: '<div class="close-popup-button"><span>' + Resources.CLOSE + "</span></div>" + '<div class="newsletterpopup-text">'+Resources.NEWSLETTER_POPUP_SUCCESS+'</div>'
									});
									if($("#isGAcustomEventEnabled").length>0 && ($("#isGAcustomEventEnabled").val()==true || $("#isGAcustomEventEnabled").val()=="true")){
										window.dataLayer = window.dataLayer || [];
										dataLayer.push({
											event: "customEvent",
											eventCategory: "newslettersignedup",
											eventAction: window.pageName,
											eventLabel: window.pageName
										});
									}

								}
							}, 
							error: function(json) {
								$(".newsletter-popup-success").html(Resources.NEWSLETTER_FOOTER_TECHNICAL);
							}
						});
					});


				}
			},
			callback: function() {
				var imgurl = "";
				if (util.isMobile()) {
					imgurl = 'url('+ Urls.newletterpopupimage_mobile + ')';
					$('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.newsletterpopup-sub.ui-draggable').css('background', imgurl);
				}
				else {
					imgurl = 'url('+ Urls.newletterpopupimage + ')';
					$('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.newsletterpopup-sub.ui-draggable').css('background', imgurl);
				}
				
				util.createCookie('dw_levis_store_newsletterpopup', 'seen', 30);
			}

		});
	}else if( $('body').hasClass('LeviKR') && enablesubsequentpopupdesktop || enablesubsequentpopupmobile  ){
		displaySubsequentPopup();
	}
}

//cookie for NZ popup
function createCookieForNZPopup(){
	
	var NewzealandPopupCookie = util.getCookie('dw_levis_store_newzealandpopup');
	var countryCookie = util.getCookie('dw_levis_store_country');
	
}

// 
function displayNZPopup() {
    // Display a newzealand popup on homepage - session tracked using cookies

    // Disable popup for mobile devices

var AuthenticatedCustomer = $('#AuthenticatedCustomer').val();
var enablenewzealandpopupfordesktop = $('#enablenewzealandpopupfordesktop').val();
var enablenewzealandpopupformobile = $('#enablenewzealandpopupformobile').val();
var checkforenable=null;




if(util.isMobile()){
    if(enablenewzealandpopupformobile =='true'){
           checkforenable=true;
    }

}else{
    if(enablenewzealandpopupfordesktop=='true'){
           checkforenable=true;
    }

}

if (AuthenticatedCustomer == 'true') {
    return;
}

// Create cookie
var NewzealandPopupCookie = util.getCookie('dw_levis_store_newzealandpopup');
var countryCookie = util.getCookie('dw_levis_store_country');
var PopupVisitedCookieValue =util.getCookie('dw_levis_store_visited');

NewzealandPopupCookieGlobal =util.getCookie('dw_levis_store_newzealandpopup');

if (NewzealandPopupCookie != "") {
    return;
}
if (countryCookie != "") {
    return;
}
if(PopupVisitedCookieValue !=""){
	 return;
}


if(checkforenable){
    dialog.open({
           url: Urls.nzpopup,
           options: {
                 close: function() {
                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.newsletterpopup-sub.ui-draggable').css('background', '');
                        if (util.isMobile()) {
                               $('#wrapper').css('position','relative');
                               return;
                        }      
                 },
                 width: 640,
                 height: 385,
                 dialogClass: "newsletterpopup-sub",
                 open: function() {
                        $('select').myselectmenu({
                               icons: { button: "ui-icon-arrowthick-1-s" },
                               select: function (event, ui) {
                                      $(this).val(ui.item.value).trigger('change');
                               }
                        });
                        validator.init();
                 }
           },
           callback: function() {
                 var imgurl = "";
                 if (util.isMobile()) {
                        imgurl = 'url('+ Urls.nzpopupimage_mobile + ')';
                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.newsletterpopup-sub.ui-draggable').css('background', imgurl);
                 }
                 else {
                        imgurl = 'url('+ Urls.nzpopupimage + ')';
                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.newsletterpopup-sub.ui-draggable').css('background', imgurl);
                 }
                 
                 util.createCookie('dw_levis_store_newzealandpopup', 'seen', 30);
                 util.createCookie('dw_levis_store_country', 'seen', 30);
                 
               
                 
                 
           }

    });
}
}

$(document).on('click', '.map-image', function (e) {
	e.preventDefault();

	dialog.open({
		html: $(".jsHidden").html(),
		options: {	
			dialogClass:"header-promo-offer",
			width: 600,
			open: function() {
				$('.header-promo-offer').on('click', '.close-button , .close-popup-button', function(e) {
					dialog.close();
					$('#dialog-container').animate({scrollTop:0},0); 
				});
			}
		},
		callback: function() {
			$('.header-promo-offer').find('.ui-dialog-buttonpane').remove();
			$('.ui-dialog-titlebar').remove();
		}
	});
});

window.onload = function() {
	if($(".top-men .jcarousel-pagination a").length==1)
	{
		$(".top-men .jcarousel-pagination a").css("display", "none");
	}
	if($(".top-women .jcarousel-pagination a").length==1)
	{
		$(".top-women .jcarousel-pagination a").css('display','none');
	}
	if($("#homepage-slider .jcarousel-control a").length==1)
	{
		$("#homepage-slider .jcarousel-control a").css("display", "none");
		$("#homepage-slider .jcarousel-nav").css("display", "none");
	}	
	if($("body").hasClass("LeviIN")){
		if($("#homepage-text-slider .jcarousel-control a").length==1)
		{
			$("#homepage-text-slider .jcarousel-control a").css("display", "none");
			$("#homepage-text-slider .jcarousel-nav").css("display", "none");
		}
	}
	if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
		document.getElementsByTagName("BODY")[0].className += " safari";
	}

	if ($('body').hasClass('LeviJP')) {
		if (navigator.platform.indexOf("iPhone") != -1) {
			 document.getElementsByTagName("BODY")[0].className += " safari";
		}
		if (!util.isMobile()) {
		$("ul.menu-category.level-1 .main-menu").mouseover(function(){
			if( $(this).find("#categoryjapanese").length > 0) {
			  $(this).find("#categoryenglish").css("display", "none");  
			  $(this).find("#categoryjapanese").css("display", "block");
			}
		  }).mouseout(function() {
			if( $(this).find("#categoryjapanese").length > 0) {
				  $(this).find("#categoryenglish").css("display", "block");  
				  $(this).find("#categoryjapanese").css("display", "none");
				}
        }); 
		
		}
	}
		
}


$(document).ready(function() {
	if (!$('body').hasClass('LeviAU') || !$('body').hasClass('LeviIN')){
	$(window).load(function() {
		$(".product-name").dotdotdot({
			ellipsis	: '...',
			wrap		: 'letter',
			fallbackToLetter: 'letter',
			after		: null,
			watch		: true,
			height		: null,
			tolerance	: 0
	
		});
	});
}
	
	if ($('body').hasClass('LeviIN')) {
		if($(window).width()>=768) {
			if ($(".menu-utility-user .user-wishlist-info").length>=1)
			{
				$(".header-search").css("margin-right", "9em");
			}
			else
			{
				$(".header-search").css("margin-right", "4.5em");
			}
		}

	}
	if ($('body').hasClass('LeviJP')) {
		if($('.menu-category .level-2').find('.right-nav li').length > 0)
		{
		  $($('.menu-category .level-2').find('.right-nav li')).parent('.right-nav').prev('ul').addClass('has-mlp');
		  $($('.menu-category .level-2').find('.right-nav li')).parent('.right-nav').addClass('has-mlp');
		}
	}
});
$('body').on('click','.ui-widget-overlay',function(e){ 
	dialog.close();
});
},{"../dialog":18,"../util":67,"../validator":68,"./product/recommendations":46}],51:[function(require,module,exports){

'use strict';
var dialog = require('../dialog'),
util = require('../util');
function markAllStores(searchKey){
	var zoomAllStore = SitePreferences.ZOOM_ALL_STORE;
	var zoomSingeStore = SitePreferences.ZOOM_SINGLE_STORE; 
	var postalCode = "";
	var stores = document.getElementById('storeJSON').innerHTML;   
	var storesList = JSON.parse(stores);
	var image = "";
	var uluru=null;
	var locale = $('#locale').val();

	if(storesList.length>0)
	{
		uluru = {lat: storesList[0].latitude, lng: storesList[0].longitude};
	}
	else
	{
		uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG);
	}
	var zoomlevel = ( $('body').hasClass('LeviAU') || $('body').hasClass('LeviIN') )  ? zoomAllStore : zoomAllStore;
	if($('body').hasClass('LeviAU')){
		postalCode = $('#storelocatorpostalcode').val();
		var levisStore= $('[name$="_leviStoreCheckBox"]').is(':checked');
		var levisOutlet= $('[name$="_leviOutletCheckBox"]').is(':checked');
		var retailOutlet= $('[name$="_retailOultCheckBox"]').is(':checked');
		if((levisStore==true || levisOutlet==true || retailOutlet==true) && postalCode=="" && locale=='en_AU')
		{
			uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG);
		} 
		else if((levisStore==true || levisOutlet==true || retailOutlet==true) && postalCode=="" && locale=='en_NZ')
		{
			uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG_NZ);
		} 
		
		else if(levisStore==false && levisOutlet==false && retailOutlet==false && postalCode=="" && locale=='en_AU')
		{
			
			uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG);
		}
		else if(levisStore==false && levisOutlet==false && retailOutlet==false && postalCode=="" && locale=='en_NZ')
		{
			
			uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG_NZ);
		}

		if( $('body').hasClass('LeviAU')) {
			if(postalCode)
			{
				//uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG);
				zoomlevel = zoomSingeStore;
			}
		}
	}

	if($('body').hasClass('LeviKR') || $('body').hasClass('LeviIN'))
	{      
		if(searchKey == null || searchKey == "undefined" || searchKey == "")
		{
			uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG);
			if($('body').hasClass('LeviKR'))
				zoomlevel = 10;
		}
	}

	if($('body').hasClass('LeviJP'))
	{      
		if(searchKey == null || searchKey == "undefined" || searchKey == "")
		{
			uluru = JSON.parse(SitePreferences.DEFAULT_STORE_LAT_LONG);
		}
	}


	if( $('body').hasClass('LeviIN') && searchKey ) {
		zoomlevel = 10;
	}

	var map = new google.maps.Map(document.getElementById('map'), {
		zoom: zoomlevel,
		streetViewControl: false,
		mapTypeControl: false,
		center: uluru,
		scrollwheel: false
	});

	var myMarker = new google.maps.Marker({
		map: map,
		animation: google.maps.Animation.DROP
	});
	addYourLocationButton(map, myMarker);

	var infowindow = new google.maps.InfoWindow();

	for (var i = 0; i < storesList.length; i++) {

		if( $('body').hasClass('LeviAU'))
		{
			if((storesList[i].storetype == "LEVI'S Store") || (storesList[i].storetype == "LEVI'S Outlet"))
			{
				image = Urls.storeMarkerOutlet;
			}
			else if(storesList[i].storetype == "Retail Outlet")
			{      
				image =Urls.storeMarkerMain;
			}
		}

		if( $('body').hasClass('LeviJP'))
		{ 
			if(storesList[i].storetype == "Levi's Store")
			{
				image = Urls.storeMain;
			}
			else if(storesList[i].storetype == "Levi's Factory Outlet")
			{      
				image =Urls.storeFactory;
			}
		}      


		var marker = new google.maps.Marker({
			position: new google.maps.LatLng(storesList[i].latitude, storesList[i].longitude),
			map: map,
			icon: image,
			title: storesList[i].storename
		});

		google.maps.event.addListener(marker, 'click', (function(marker, i) {
			return function() {
				 createInfowindow(storesList[i],map,marker,infowindow);
			}
		})(marker, i));
	}      

	google.maps.event.addListener(map, 'click', function() {
		infowindow.close();
	});

	google.maps.event.addListener(infowindow, 'domready', function() {

		var iwOuter = $('.gm-style-iw');

		var iwBackground = iwOuter.prev();

		iwOuter.next("div").hide();
		
		iwOuter.find(button).css('display','none');
	});
	
    var urlParams = document.location.search;
    urlParams = urlParams.substring(urlParams.lastIndexOf('=')+1);

    
    if(urlParams!=null && $('body').hasClass('LeviJP')){
           window.onload = function() {
                  createInfowindow(storesList[0],map,marker,infowindow);
           }
    }
};

function createInfowindow(storesList,map,marker,infowindow){
    var contentString="";
    var latLong = storesList.latitude +","+ storesList.longitude;        
    if(SitePreferences.DEFAULT_DRIVE_MODE)
    {
           var glink = "https://maps.google.com?daddr=" + encodeURI(latLong)+"&ll=" + encodeURI(latLong) + "&dirflg=" +encodeURI(SitePreferences.DEFAULT_DRIVE_MODE) +"&z=15";
    }
    else
    {
           var glink = "https://maps.google.com?daddr=" + encodeURI(latLong)+"&ll=" + encodeURI(latLong) + "&dirflg=r&z=15";   
    }
    contentString = getContentString(storesList.storename,storesList.address1,storesList.city,storesList.postalCode,storesList.hours,storesList.phone,glink,storesList.address2,storesList.stname);

    infowindow.setContent(contentString);
    infowindow.open(map, marker);
};

function getContentString(storename,address1,city,postalCode,hours,phone,glink,address2,stname){

	var storeHours = hours;
	var splittedHours = storeHours.replace(')',')<br/>');

	var contentString = '<div id="markerpopup">';
	if($('body').hasClass('LeviJP') && storename.indexOf("Levis") != -1) 
	{
		var storeName = 'LEVI\'S';
		var storenameNew = storename.split(" ");
		$.each(storenameNew, function( i, val ) {
			if(i>0)
			{storeName = storeName+' '+val;  }      
		});
		storename = storeName;
	}
	contentString = contentString +'<div id="storename">' + storename +'</div>' ; 
	if($('body').hasClass('LeviJP')) {
		if (postalCode != null) contentString = contentString +'<div id="postal-address"><span>' + "〒" +  postalCode + '</span></div>';
		if (stname != null || city != null || address1 !=null) contentString = contentString + '<div id="address"><span>' + stname + city + address1 +'</span></div>';
		if (address2 !=null) contentString = contentString + address2 +'</span></div>';
		if (splittedHours != null) contentString = contentString + '<div id="hours"><span>' + splittedHours +'</span></div>';
	}
	else
	{
		if (address1 != null) contentString = contentString +'<div id="address"><span>' + address1 + '</span></div>';
		if (city != null) contentString = contentString + '<div id="address"><span>' + city + ' ' +  postalCode  +'</span></div><br>';
		if (splittedHours != null) contentString = contentString + '<div id="hours"><span>' + splittedHours +'</span></div><br>';
	}

	if (phone != null) contentString = contentString + '<div id="phone" class="call-me"><span><i class="callmeicon24x24"></i><a  href="tel:['+phone+']">' + phone +'</a></span></div>';
	if (glink != null) contentString = contentString + '<div id="glink" class="get-direction"><span><i class="directionicon24x24"></i><a class="google-map" href=' + glink + ' target="_blank">'+ Resources.GET_DIRECTION +'</a></span></div>';
	contentString = contentString + '</div>';
	return contentString;
};

function addYourLocationButton(map, marker) 
{
	var controlDiv = document.createElement('div');

	var firstChild = document.createElement('button');
	firstChild.id = 'current-location-button';

	controlDiv.appendChild(firstChild);

	var secondChild = document.createElement('div');

	secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';

	secondChild.id = 'your_location_img';
	firstChild.appendChild(secondChild);

	firstChild.addEventListener('click', function() {
		if(navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position) {
				var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
				marker.setPosition(latlng);
				map.setCenter(latlng);
			});
		}
	});

	controlDiv.index = 1;
	map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
}

exports.init = function () {

	if(SitePreferences.STORE_MAP)
	{      
		markAllStores();
		//to show store details on map
		window.initialize = function(e,long, lat, storename, storeaddress1,city,postalcode, storehours,phone,stateCode,countryCode,storetype,storeaddress2,stname) {
			var latLong = lat+","+long;
			if(SitePreferences.DEFAULT_DRIVE_MODE) 
			{
				var glink = "https://maps.google.com?daddr=" + encodeURI(latLong)+"&ll=" + encodeURI(latLong) + "&dirflg=" +encodeURI(SitePreferences.DEFAULT_DRIVE_MODE) +"&z=15";
			}
			else
			{
				var glink = "https://maps.google.com?daddr=" + encodeURI(latLong)+"&ll=" + encodeURI(latLong) + "&dirflg=r&z=15";      
			}

			if( $('body').hasClass('LeviAU'))
			{
				storetype = storetype.replace("LEVIS","LEVI'S");

				storename = storename.replace("LEVIS","LEVI'S");     

				if(storetype == "LEVI'S Store")
				{ 
					var image = Urls.storeMarkerMain;                           
				}
				else if(storetype == "LEVI'S Outlet")
				{
					var image = Urls.storeMarkerOutlet;
				}
				else if(storetype == "Retail Outlet")
				{
					var image = Urls.storeMarkerRetail;
				}      
			}

			if( $('body').hasClass('LeviJP'))
			{

				if(storetype == "Levis Store")
				{
					image = Urls.storeMain;
				}
				else if(storetype == "Levis Factory Outlet")
				{      
					image = Urls.storeFactory;
				}
			}

			var zoomSingeStore = SitePreferences.ZOOM_SINGLE_STORE;
			var map = new google.maps.Map(document.getElementById('map'), {
				center: new google.maps.LatLng(lat, long),
				streetViewControl: false,
				scaleControl: true,
				mapTypeControl: false,
				scrollwheel: false,
				zoom: zoomSingeStore
			});


			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(lat,long),
				map: map,
				icon: image,
				title: storename
			});  

			addYourLocationButton(map, marker);                     

			var contentString="";
			contentString = getContentString(storename,storeaddress1,city,postalcode,storehours,phone,glink,storeaddress2,stname);

			var infowindow = new google.maps.InfoWindow({
				content: contentString
			});

			infowindow.open(map, marker); 

			google.maps.event.addListener(marker, 'click', function(e) {
				infowindow.open(map, marker);
			});

			google.maps.event.addListener(map, 'click', function() {
				infowindow.close();
			});

			google.maps.event.addListener(infowindow, 'domready', function() {

				var iwOuter = $('.gm-style-iw');

				var iwBackground = iwOuter.prev();
				
				iwOuter.find('button').css('display','none');
			});



			$('html, body').animate({
				scrollTop: 0
			}, 1000);
		};
	}
	
	window.initializeStore = function(storename)
    {                          
           var storename=storename.replace("Levis","Levi's");
           var urlBase= window.location.href+ '?storeName=';
           var url= urlBase + encodeURIComponent(storename);
           window.open(url, '_blank');
                                                                  
    }
	
	$('.store-details-link').on('click', function (e) {
		e.preventDefault();
		dialog.open({
			url: $(e.target).attr('href')
		});
	});


	// Code For pagination  

	$('body').on('click', '.storepage', function(e) {
		e.preventDefault();       
		if( $('body').hasClass('LeviKR') || $('body').hasClass('LeviIN')){
			var searchVal = "";
			var urltohit = "";
			if( $('body').hasClass('LeviKR')) {
				searchVal = $("#dwfrm_storelocator_state option:selected").val(); 
			}
			else {
				searchVal = document.getElementById("dwfrm_storelocator_city").value;
			}

			if( $('body').hasClass('LeviKR')) {
				urltohit =  util.appendParamsToUrl( this.href,{state: searchVal}) ;
				//urltohit =  (stateVal !== null && stateVal !== "") ? util.appendParamsToUrl( this.href,{state: stateVal}) : Urls.findStores;    
			}
			else {
				urltohit =  util.appendParamsToUrl( this.href,{city: searchVal}) ;
			}

			$.ajax({
				url: urltohit,
				type: 'POST',
			}).done(function(response) {
				if (!response || !response.success) {
					$('#Store-list').html(response);
					if(SitePreferences.STORE_MAP)
					{      
						markAllStores(searchVal);
					}
				} else {
					resolve(response);
				}
			}).fail(function(jqxhr, status, err) {
				reject(new Error(err));
			});

		}

		if( $('body').hasClass('LeviAU')) {

			if ($(this).hasClass('current-page')) {
				return;
			}

			var postalCode = $('#storelocatorpostalcode').val() ? $('#storelocatorpostalcode').val() : '';   
			$.ajax({
				url: this.href,
				type: 'POST',
				data: {
					state : postalCode,
					levisStore: $('[name$="_leviStoreCheckBox"]').is(':checked'),
					levisOutlet: $('[name$="_leviOutletCheckBox"]').is(':checked'),
					retailOutlet: $('[name$="_retailOultCheckBox"]').is(':checked')
				}
			}).done(function(response) {                  
				if (!response || !response.success) {
					$('#Store-list').html(response);
					if(SitePreferences.STORE_MAP)
					{     
						markAllStores();
					}
				} else {
					resolve(response);
				}
			}).fail(function(jqxhr, status, err) {
				reject(new Error(err));
			});
		}

		if( $('body').hasClass('LeviJP')) {
			if ($(this).hasClass('current-page')) {
				return;
			}

			var searchState = "";
			searchState = $("#dwfrm_storelocator_state option:selected").val(); 
			$.ajax({
				url: this.href,
				type: 'POST',
				data: {
					state : searchState,
					levisStore: $('[name$="_leviStoreCB"]').is(':checked'),
					levisFactory: $('[name$="_leviFactoryCB"]').is(':checked')
				}
			}).done(function(response) {                     
				if (!response || !response.success) {
					$('#Store-list').html(response);
					if(SitePreferences.STORE_MAP)
					{     
						markAllStores();
					}
				} else {
					resolve(response);
				}
			}).fail(function(jqxhr, status, err) {
				reject(new Error(err));
			});
		}


	});

	if($('body').hasClass('LeviAU')){
		$("form input[type=checkbox]" ).on( "change", function(e) {
			e.preventDefault();
			$(this).closest('form').submit();
		});
	}


	//search store for India By city as Input
	$('.primary-content').on('click', '.searchByCity', function(e) {
		var cityVal = document.getElementById("dwfrm_storelocator_city").value;
		$.ajax({
			url: Urls.getStoresByCity,
			type: 'POST',
			data: {
				city : cityVal
			}

		}).done(function(response) {
			if (!response || !response.success) {

				$('#Store-list').html(response);
				if(SitePreferences.STORE_MAP)
				{      
					markAllStores(cityVal);
				}      
				$('html, body').animate({
					scrollTop: $('#Store-list').offset().top - 200
				}, 1000);

			} else {
				resolve(response);
			}
		}).fail(function(jqxhr, status, err) {
			reject(new Error(err));
		});
	});

	//search store 
	$('.primary-content').on('click', '.searchByStateOrPostal', function(e) {
		if($('body').hasClass('LeviKR')){
			var stateVal = document.getElementById("dwfrm_storelocator_state").value;

			$.ajax({
				url: Urls.getStores,
				type: 'POST',
				data: {
					state : stateVal
				}

			}).done(function(response) {
				if (!response || !response.success) {

					$('#Store-list').html(response);
					if(SitePreferences.STORE_MAP)
					{      
						markAllStores(stateVal);
					}      
					$('html, body').animate({
						scrollTop: $('#Store-list').offset().top - 200
					}, 1000);

				} else {
					resolve(response);
				}
			}).fail(function(jqxhr, status, err) {
				reject(new Error(err));
			});
		}
		else if( $('body').hasClass('LeviAU')){
			e.preventDefault();
			$(this).closest('form').submit();
		}

	});


	//search store for jp
	$('[name$="_leviStoreCB"] ,[name$="_leviFactoryCB"]').on('change', function(e) {
		e.preventDefault();
		refreshMapAndListJP();
	});


	$('#searchByState').on('click', function(e) { 
		e.preventDefault();
		refreshMapAndListJP();
	});

	function refreshMapAndListJP() {   	  
		var statename = $('#dwfrm_storelocator_state').val();
		$.ajax({
			url: Urls.getStoresByState,
			type: 'POST',
			data: {
				state : statename,
				levisStore: $('[name$="_leviStoreCB"]').is(':checked'),
				levisOutlet: $('[name$="_leviFactoryCB"]').is(':checked')
			}

		}).done(function(response) {
			if (!response || !response.success) {

				$('#Store-list').html(response);
				if(SitePreferences.STORE_MAP)
				{      
					markAllStores(statename);
				}      
				$('html, body').animate({
					scrollTop: $('#Store-list').offset().top - 200
				}, 1000);

			} else {
				resolve(response); 
			}
		}).fail(function(jqxhr, status, err) {
			reject(new Error(err));
		}); 
	}





	if( $('body').hasClass('LeviAU') ){
		$('form[id$="_storelocator"]').on('submit', function(e) {
			e.preventDefault();
			refreshMapAndList();
		});
		function refreshMapAndList() {
			var postalCode = document.getElementById("dwfrm_storelocator_state").value;

			$.ajax({
				url: Urls.getStoresByPostal,
				type: 'POST',
				data: {
					state : postalCode,
					levisStore: $('[name$="_leviStoreCheckBox"]').is(':checked'),
					levisOutlet: $('[name$="_leviOutletCheckBox"]').is(':checked'),
					retailOutlet: $('[name$="_retailOultCheckBox"]').is(':checked')
				}

			}).done(function(response) {
				if (!response || !response.success) {

					$('#Store-list').html(response);
					if(SitePreferences.STORE_MAP)
					{      
						markAllStores(postalCode);
					}      
					$('html, body').animate({
						scrollTop: $('#Store-list').offset().top - 200
					}, 1000);

				} else {
					resolve(response); 
				}
			}).fail(function(jqxhr, status, err) {
				reject(new Error(err));
			});
		}
	}

	//click of all button map should hide
	$('body').on('click','#allstores', function (e) {
		$('.col-2').hide();
	});


	$('body').on('click','#searchByStateOrPostal, .store-name', function (e) {
		$('.col-2').show();
	});

	$('.storeselectionoptions').on("change", function(e){
		$('.col-2').show();
	});

	if ( (navigator.platform.indexOf("iPhone") != -1) || (navigator.userAgent.toLowerCase().indexOf('ipad') != -1 )) {
		$("body").addClass("iosDevice");
	}
};
},{"../dialog":18,"../util":67}],52:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    page = require('../page'),
    login = require('../login'),
    util = require('../util');

exports.init = function () {
    addProductToCart();
    $('#editAddress').on('change', function () {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();
    
};

},{"../login":22,"../page":28,"../util":67,"./product/addToCart":39}],53:[function(require,module,exports){
/*global jQuery, console, define, setTimeout, window*/
(function () {
    'use strict';
    var definePinchZoom = function ($) {

        /**
         * Pinch zoom using jQuery
         * @version 0.0.2
         * @author Manuel Stofer <mst@rtp.ch>
         * @param el
         * @param options
         * @constructor
         */
        var PinchZoom = function (el, options) {
                this.el = $(el);
                this.zoomFactor = 1;
                this.lastScale = 1;
                this.offset = {
                    x: 0,
                    y: 0
                };
                this.options = $.extend({}, this.defaults, options);
                this.setupMarkup();
                this.bindEvents();
                this.update();
                // default enable.
                this.enable();

            },
            sum = function (a, b) {
                return a + b;
            },
            isCloseTo = function (value, expected) {
                return value > expected - 0.01 && value < expected + 0.01;
            };

        PinchZoom.prototype = {

            defaults: {
                // tapZoomFactor defined for the zoom value on double tap
                tapZoomFactor: 4,
                zoomOutFactor: 1.3,
                animationDuration: 300,
                // maxZoom defined for the zoom value on pinch
                maxZoom: 6,
                minZoom: 0.5,
                lockDragAxis: false,
                use2d: true,
                zoomStartEventName: 'pz_zoomstart',
                zoomEndEventName: 'pz_zoomend',
                dragStartEventName: 'pz_dragstart',
                dragEndEventName: 'pz_dragend',
                doubleTapEventName: 'pz_doubletap'
            },

            /**
             * Event handler for 'dragstart'
             * @param event
             */
            handleDragStart: function (event) {
                this.el.trigger(this.options.dragStartEventName);
                this.stopAnimation();
                this.lastDragPosition = false;
                this.hasInteraction = true;
                this.handleDrag(event);
            },

            /**
             * Event handler for 'drag'
             * @param event
             */
            handleDrag: function (event) {

                if (this.zoomFactor > 1.0) {
                    var touch = this.getTouches(event)[0];
                    this.drag(touch, this.lastDragPosition);
                    this.offset = this.sanitizeOffset(this.offset);
                    this.lastDragPosition = touch;
                }
            },

            handleDragEnd: function () {
                this.el.trigger(this.options.dragEndEventName);
                this.end();
            },

            /**
             * Event handler for 'zoomstart'
             * @param event
             */
            handleZoomStart: function (event) {
                this.el.trigger(this.options.zoomStartEventName);
                this.stopAnimation();
                this.lastScale = 1;
                this.nthZoom = 0;
                this.lastZoomCenter = false;
                this.hasInteraction = true;
            },

            /**
             * Event handler for 'zoom'
             * @param event
             */
            handleZoom: function (event, newScale) {

                // a relative scale factor is used
                var touchCenter = this.getTouchCenter(this.getTouches(event)),
                    scale = newScale / this.lastScale;
                this.lastScale = newScale;

                // the first touch events are thrown away since they are not precise
                this.nthZoom += 1;
                if (this.nthZoom > 3) {

                    this.scale(scale, touchCenter);
                    this.drag(touchCenter, this.lastZoomCenter);
                }
                this.lastZoomCenter = touchCenter;
            },

            handleZoomEnd: function () {
                this.el.trigger(this.options.zoomEndEventName);
                this.end();
            },

            /**
             * Event handler for 'doubletap'
             * @param event
             */
            handleDoubleTap: function (event) {
                var center = this.getTouches(event)[0],
                    zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor,
                    startZoomFactor = this.zoomFactor,
                    updateProgress = (function (progress) {
                        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                    }).bind(this);

                if (this.hasInteraction) {
                    return;
                }
                if (startZoomFactor > zoomFactor) {
                    center = this.getCurrentZoomCenter();
                }

                this.animate(this.options.animationDuration, updateProgress, this.swing);
                this.el.trigger(this.options.doubleTapEventName);
            },

            /**
             * Max / min values for the offset
             * @param offset
             * @return {Object} the sanitized offset
             */
            sanitizeOffset: function (offset) {
                var maxX = (this.zoomFactor - 1) * this.getContainerX(),
                    maxY = (this.zoomFactor - 1) * this.getContainerY(),
                    maxOffsetX = Math.max(maxX, 0),
                    maxOffsetY = Math.max(maxY, 0),
                    minOffsetX = Math.min(maxX, 0),
                    minOffsetY = Math.min(maxY, 0);

                return {
                    x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
                    y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
                };
            },

            /**
             * Scale to a specific zoom factor (not relative)
             * @param zoomFactor
             * @param center
             */
            scaleTo: function (zoomFactor, center) {
                this.scale(zoomFactor / this.zoomFactor, center);
            },

            /**
             * Scales the element from specified center
             * @param scale
             * @param center
             */
            scale: function (scale, center) {
                scale = this.scaleZoomFactor(scale);
                this.addOffset({
                    x: (scale - 1) * (center.x + this.offset.x),
                    y: (scale - 1) * (center.y + this.offset.y)
                });
            },

            /**
             * Scales the zoom factor relative to current state
             * @param scale
             * @return the actual scale (can differ because of max min zoom factor)
             */
            scaleZoomFactor: function (scale) {
                var originalZoomFactor = this.zoomFactor;
                this.zoomFactor *= scale;
                this.zoomFactor = Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom));
                return this.zoomFactor / originalZoomFactor;
            },

            /**
             * Drags the element
             * @param center
             * @param lastCenter
             */
            drag: function (center, lastCenter) {
                if (lastCenter) {
                  if(this.options.lockDragAxis) {
                    // lock scroll to position that was changed the most
                    if(Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
                      this.addOffset({
                        x: -(center.x - lastCenter.x),
                        y: 0
                      });
                    }
                    else {
                      this.addOffset({
                        y: -(center.y - lastCenter.y),
                        x: 0
                      });
                    }
                  }
                  else {
                    this.addOffset({
                      y: -(center.y - lastCenter.y),
                      x: -(center.x - lastCenter.x)
                    });
                  }
                }
            },

            /**
             * Calculates the touch center of multiple touches
             * @param touches
             * @return {Object}
             */
            getTouchCenter: function (touches) {
                return this.getVectorAvg(touches);
            },

            /**
             * Calculates the average of multiple vectors (x, y values)
             */
            getVectorAvg: function (vectors) {
                return {
                    x: vectors.map(function (v) { return v.x; }).reduce(sum) / vectors.length,
                    y: vectors.map(function (v) { return v.y; }).reduce(sum) / vectors.length
                };
            },

            /**
             * Adds an offset
             * @param offset the offset to add
             * @return return true when the offset change was accepted
             */
            addOffset: function (offset) {
                this.offset = {
                    x: this.offset.x + offset.x,
                    y: this.offset.y + offset.y
                };
            },

            sanitize: function () {
                if (this.zoomFactor < this.options.zoomOutFactor) {
                    this.zoomOutAnimation();
                } else if (this.isInsaneOffset(this.offset)) {
                    this.sanitizeOffsetAnimation();
                }
            },

            /**
             * Checks if the offset is ok with the current zoom factor
             * @param offset
             * @return {Boolean}
             */
            isInsaneOffset: function (offset) {
                var sanitizedOffset = this.sanitizeOffset(offset);
                return sanitizedOffset.x !== offset.x ||
                    sanitizedOffset.y !== offset.y;
            },

            /**
             * Creates an animation moving to a sane offset
             */
            sanitizeOffsetAnimation: function () {
                var targetOffset = this.sanitizeOffset(this.offset),
                    startOffset = {
                        x: this.offset.x,
                        y: this.offset.y
                    },
                    updateProgress = (function (progress) {
                        this.offset.x = startOffset.x + progress * (targetOffset.x - startOffset.x);
                        this.offset.y = startOffset.y + progress * (targetOffset.y - startOffset.y);
                        this.update();
                    }).bind(this);

                this.animate(
                    this.options.animationDuration,
                    updateProgress,
                    this.swing
                );
            },

            /**
             * Zooms back to the original position,
             * (no offset and zoom factor 1)
             */
            zoomOutAnimation: function () {
                var startZoomFactor = this.zoomFactor,
                    zoomFactor = 1,
                    center = this.getCurrentZoomCenter(),
                    updateProgress = (function (progress) {
                        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                    }).bind(this);

                this.animate(
                    this.options.animationDuration,
                    updateProgress,
                    this.swing
                );
            },

            /**
             * Updates the aspect ratio
             */
            updateAspectRatio: function () {
                this.setContainerY(this.getContainerX() / this.getAspectRatio());
            },

            /**
             * Calculates the initial zoom factor (for the element to fit into the container)
             * @return the initial zoom factor
             */
            getInitialZoomFactor: function () {
                // use .offsetWidth instead of width()
                // because jQuery-width() return the original width but Zepto-width() will calculate width with transform.
                // the same as .height()
                return this.container[0].offsetWidth / this.el[0].offsetWidth;
            },

            /**
             * Calculates the aspect ratio of the element
             * @return the aspect ratio
             */
            getAspectRatio: function () {
                return this.el[0].offsetWidth / this.el[0].offsetHeight;
            },

            /**
             * Calculates the virtual zoom center for the current offset and zoom factor
             * (used for reverse zoom)
             * @return {Object} the current zoom center
             */
            getCurrentZoomCenter: function () {

                // uses following formula to calculate the zoom center x value
                // offset_left / offset_right = zoomcenter_x / (container_x - zoomcenter_x)
                var length = this.container[0].offsetWidth * this.zoomFactor,
                    offsetLeft  = this.offset.x,
                    offsetRight = length - offsetLeft -this.container[0].offsetWidth,
                    widthOffsetRatio = offsetLeft / offsetRight,
                    centerX = widthOffsetRatio * this.container[0].offsetWidth / (widthOffsetRatio + 1),

                // the same for the zoomcenter y
                    height = this.container[0].offsetHeight * this.zoomFactor,
                    offsetTop  = this.offset.y,
                    offsetBottom = height - offsetTop - this.container[0].offsetHeight,
                    heightOffsetRatio = offsetTop / offsetBottom,
                    centerY = heightOffsetRatio * this.container[0].offsetHeight / (heightOffsetRatio + 1);

                // prevents division by zero
                if (offsetRight === 0) { centerX = this.container[0].offsetWidth; }
                if (offsetBottom === 0) { centerY = this.container[0].offsetHeight; }

                return {
                    x: centerX,
                    y: centerY
                };
            },

            canDrag: function () {
                return !isCloseTo(this.zoomFactor, 1);
            },

            /**
             * Returns the touches of an event relative to the container offset
             * @param event
             * @return array touches
             */
            getTouches: function (event) {
                var position = this.container.offset();
                return Array.prototype.slice.call(event.touches).map(function (touch) {
                    return {
                        x: touch.pageX - position.left,
                        y: touch.pageY - position.top
                    };
                });
            },

            /**
             * Animation loop
             * does not support simultaneous animations
             * @param duration
             * @param framefn
             * @param timefn
             * @param callback
             */
            animate: function (duration, framefn, timefn, callback) {
                var startTime = new Date().getTime(),
                    renderFrame = (function () {
                        if (!this.inAnimation) { return; }
                        var frameTime = new Date().getTime() - startTime,
                            progress = frameTime / duration;
                        if (frameTime >= duration) {
                            framefn(1);
                            if (callback) {
                                callback();
                            }
                            this.update();
                            this.stopAnimation();
                            this.update();
                        } else {
                            if (timefn) {
                                progress = timefn(progress);
                            }
                            framefn(progress);
                            this.update();
                            requestAnimationFrame(renderFrame);
                        }
                    }).bind(this);
                this.inAnimation = true;
                requestAnimationFrame(renderFrame);
            },

            /**
             * Stops the animation
             */
            stopAnimation: function () {
                this.inAnimation = false;
            },

            /**
             * Swing timing function for animations
             * @param p
             * @return {Number}
             */
            swing: function (p) {
                return -Math.cos(p * Math.PI) / 2  + 0.5;
            },

            getContainerX: function () {
                return this.container[0].offsetWidth;
            },

            getContainerY: function () {
                return this.container[0].offsetHeight;
            },

            setContainerY: function (y) {
                return this.container.height(y);
            },

            /**
             * Creates the expected html structure
             */
            setupMarkup: function () {
                this.container = $('<div class="pinch-zoom-container"></div>');
                this.el.before(this.container);
                this.container.append(this.el);

                this.container.css({
                    'overflow': 'hidden',
                    'position': 'relative'
                });

                // Zepto doesn't recognize `webkitTransform..` style
                this.el.css({
                    '-webkit-transform-origin': '0% 0%',
                    '-moz-transform-origin': '0% 0%',
                    '-ms-transform-origin': '0% 0%',
                    '-o-transform-origin': '0% 0%',
                    'transform-origin': '0% 0%',
                    'position': 'absolute'
                });
            },

            end: function () {
                this.hasInteraction = false;
                this.sanitize();
                this.update();
            },

            /**
             * Binds all required event listeners
             */
            bindEvents: function () {
                detectGestures(this.container.get(0), this);
                // Zepto and jQuery both know about `on`
                $(window).on('resize', this.update.bind(this));
                $(this.el).find('img').on('load', this.update.bind(this));
            },

            /**
             * Updates the css values according to the current zoom factor and offset
             */
            update: function () {

                if (this.updatePlaned) {
                    return;
                }
                this.updatePlaned = true;

                setTimeout((function () {
                    this.updatePlaned = false;
                    this.updateAspectRatio();

                    var zoomFactor = this.getInitialZoomFactor() * this.zoomFactor,
                        offsetX = -this.offset.x / zoomFactor,
                        offsetY = -this.offset.y / zoomFactor,
                        transform3d =   'scale3d('     + zoomFactor + ', '  + zoomFactor + ',1) ' +
                            'translate3d(' + offsetX    + 'px,' + offsetY    + 'px,0px)',
                        transform2d =   'scale('       + zoomFactor + ', '  + zoomFactor + ') ' +
                            'translate('   + offsetX    + 'px,' + offsetY    + 'px)',
                        removeClone = (function () {
                            if (this.clone) {
                                this.clone.remove();
                                delete this.clone;
                            }
                        }).bind(this);

                    // Scale 3d and translate3d are faster (at least on ios)
                    // but they also reduce the quality.
                    // PinchZoom uses the 3d transformations during interactions
                    // after interactions it falls back to 2d transformations
                    if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
                        this.is3d = true;
                        removeClone();
                        this.el.css({
                            '-webkit-transform':  transform3d,
                            '-o-transform':       transform2d,
                            '-ms-transform':      transform2d,
                            '-moz-transform':     transform2d,
                            'transform':        transform3d
                        });
                    } else {

                        // When changing from 3d to 2d transform webkit has some glitches.
                        // To avoid this, a copy of the 3d transformed element is displayed in the
                        // foreground while the element is converted from 3d to 2d transform
                        if (this.is3d) {
                            this.clone = this.el.clone();
                            this.clone.css('pointer-events', 'none');
                            this.clone.appendTo(this.container);
                            setTimeout(removeClone, 200);
                        }
                        this.el.css({
                            '-webkit-transform':  transform2d,
                            '-o-transform':       transform2d,
                            '-ms-transform':      transform2d,
                            '-moz-transform':     transform2d,
                            'transform':        transform2d
                        });
                        this.is3d = false;
                    }
                }).bind(this), 0);
            },

            /**
             * Enables event handling for gestures
             */
            enable: function() {
              this.enabled = true;
            },

            /**
             * Disables event handling for gestures
             */
            disable: function() {
              this.enabled = false;
            }
        };

        var detectGestures = function (el, target) {
            var interaction = null,
                fingers = 0,
                lastTouchStart = null,
                startTouches = null,

                setInteraction = function (newInteraction, event) {
                    if (interaction !== newInteraction) {

                        if (interaction && !newInteraction) {
                            switch (interaction) {
                                case "zoom":
                                    target.handleZoomEnd(event);
                                    break;
                                case 'drag':
                                    target.handleDragEnd(event);
                                    break;
                            }
                        }

                        switch (newInteraction) {
                            case 'zoom':
                                target.handleZoomStart(event);
                                break;
                            case 'drag':
                                target.handleDragStart(event);
                                break;
                        }
                    }
                    interaction = newInteraction;
                },

                updateInteraction = function (event) {
                    if (fingers === 2) {
                        setInteraction('zoom');
                    } else if (fingers === 1 && target.canDrag()) {
                        setInteraction('drag', event);
                    } else {
                        setInteraction(null, event);
                    }
                },

                targetTouches = function (touches) {
                    return Array.prototype.slice.call(touches).map(function (touch) {
                        return {
                            x: touch.pageX,
                            y: touch.pageY
                        };
                    });
                },

                getDistance = function (a, b) {
                    var x, y;
                    x = a.x - b.x;
                    y = a.y - b.y;
                    return Math.sqrt(x * x + y * y);
                },

                calculateScale = function (startTouches, endTouches) {
                    var startDistance = getDistance(startTouches[0], startTouches[1]),
                        endDistance = getDistance(endTouches[0], endTouches[1]);
                    return endDistance / startDistance;
                },

                cancelEvent = function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                },

                detectDoubleTap = function (event) {
                    var time = (new Date()).getTime();

                    if (fingers > 1) {
                        lastTouchStart = null;
                    }

                    if (time - lastTouchStart < 300) {
                        cancelEvent(event);

                        target.handleDoubleTap(event);
                        switch (interaction) {
                            case "zoom":
                                target.handleZoomEnd(event);
                                break;
                            case 'drag':
                                target.handleDragEnd(event);
                                break;
                        }
                    }

                    if (fingers === 1) {
                        lastTouchStart = time;
                    }
                },
                firstMove = true;

            el.addEventListener('touchstart', function (event) {
                if(target.enabled) {
                    firstMove = true;
                    fingers = event.touches.length;
                    detectDoubleTap(event);
                }
            });

            el.addEventListener('touchmove', function (event) {
                if(target.enabled) {
                    if (firstMove) {
                        updateInteraction(event);
                        if (interaction) {
                            cancelEvent(event);
                        }
                        startTouches = targetTouches(event.touches);
                    } else {
                        switch (interaction) {
                            case 'zoom':
                                target.handleZoom(event, calculateScale(startTouches, targetTouches(event.touches)));
                                break;
                            case 'drag':
                                target.handleDrag(event);
                                break;
                        }
                        if (interaction) {
                            cancelEvent(event);
                            target.update();
                        }
                    }

                    firstMove = false;
                }
            });

            el.addEventListener('touchend', function (event) {
                if(target.enabled) {
                    fingers = event.touches.length;
                    updateInteraction(event);
                }
            });
        };

        return PinchZoom;
    };

    if (typeof define !== 'undefined' && define.amd) {
        define(['jquery'], function ($) {
            return definePinchZoom($);
        });
    } else {
        window.RTP = window.RTP || {};
        window.RTP.PinchZoom = definePinchZoom(window.$);
    }
}).call(this);

},{}],54:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
    quickview = require('./quickview');

function initQuickViewButtons() {
    $('.tiles-container .product-image').on('mouseenter', function () {
        if( localStorage.getItem("cartType")===null || localStorage.getItem("cartType")==='false'){
        var $qvButton = $('#quickviewbutton');
        if ($qvButton.length === 0) {
            $qvButton = $('<a id="quickviewbutton" class="quickview">' + Resources.QUICK_VIEW + '<i class="fa fa-arrows-alt"></i></a>');
        }
        var $link = $(this).find('.thumb-link');
        $qvButton.attr({
            'href': $link.attr('href'),
            'title': $link.attr('title'),
            'data-product-id': $link.attr('pid'),
            'data-sku-number' :$link.attr('pid'),
            'data-product-category':$link.attr('pcat'),
            'data-product-name':$link.attr('pname'),
            'data-product-department':$link.attr('pdepartment')
        }).appendTo(this);
        $qvButton.on('click', function (e) {
            e.preventDefault();
            quickview.show({
                url: $(this).attr('href'),
                source: 'quickview'
            });
        });
    }
    }
    );
}

function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    
	if ($('body').hasClass('LeviKR')||$('body').hasClass('LeviIN')||$('body').hasClass('LeviJP')) {
        try{
            var enableQuickView = SitePreferences.enableQuickView;
            if($("body").hasClass("LeviIN") && enableQuickView == true){
                if(!localStorage.getItem("cartType") || localStorage.getItem("cartType")===null || localStorage.getItem("cartType")==='false'){
                    initQuickViewButtons();
                }
                else{

                }
            }else{
                initQuickViewButtons();
            }
        }
        catch(err) {
            console.log(err.message);
        }
	}
    gridViewToggle();
    $('.swatch-list').on('mouseleave', function () {
        // Restore current thumb image
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $thumb.data('current');

        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
    $('.swatch-list .swatch').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) { return; }

        var $tile = $(this).closest('.product-tile');
        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');
        $tile.find('.thumb-link').attr('href', $(this).attr('href'));
        $tile.find('name-link').attr('href', $(this).attr('href'));

        var data = $(this).children('img').filter(':first').data('thumb');
        var data_secondary = $(this).children('img').filter(':first').data('thumb-secondary');
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var $thumbBack = $tile.find('.product-image .thumb-link img').eq(1);
        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title
        };
        var currentAttrsBack = {
            src: data_secondary.src,
            alt: data_secondary.alt,
            title: data_secondary.title
        };
        $thumb.attr(currentAttrs);
        $thumbBack.attr(currentAttrsBack);
        $thumb.data('current', currentAttrs);
        var updateprodinfo = $(this).attr('data-updateprodinfo');
        if (updateprodinfo) {
            $.ajax ({
                type: 'GET',
                url: updateprodinfo,
                data: {},

                success: function (response) {
                   if(response) {  
                        var productNameDOM =  $($.parseHTML(response)).find(".product-name.name1").html();
                        if (productNameDOM) {
                            $tile.find('.product-name.name1').html(productNameDOM);
                        }
                        var productPriceDOM =  $($.parseHTML(response)).find(".product-pricing").html();
                        if (productPriceDOM) {
                            $tile.find('.product-pricing').html(productPriceDOM);
                        }
                   }
                },

                failure: function () {
                }
            }); 
        }
    }).on('mouseenter', function () {
        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $(this).children('img').filter(':first').data('thumb'),
            current = $thumb.data('current');

        // If this is the first time, then record the current img
        if (!current) {
            $thumb.data('current', {
                src: $thumb[0].src,
                alt: $thumb[0].alt,
                title: $thumb[0].title
            });
        }

        // Set the tile image to the values provided on the swatch data attributes
        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
    
    $('.sbHolder').on('click',function () {
    	$('.col-left.sidebar.on').css('display','block');
    	$('body').addClass('noscroll');
        if ($('body').hasClass('LeviKR')) {
            $('.plp-promo-category').css('display','none');
        }
    });
    $('.block-layered-nav .close').on('click',function () {
    	$('.col-left.sidebar.on').css('display','none');
    	$('body').removeClass('noscroll');
    });
}

exports.init = function () {
    var $tiles = $('.tiles-container .product-tile');
    if ($tiles.length === 0) { return; }
    imagesLoaded('.tiles-container').on('done', function () {
        $tiles.syncHeight()
            .each(function (idx) {
                $(this).data('idx', idx);
            });
    });
    initializeEvents();
};

},{"./quickview":56,"imagesloaded":72}],55:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],56:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    product = require('./pages/product'),
    util = require('./util'),
    _ = require('lodash'),
    variant = require('./pages/product/variant'),
    image = require('./pages/product/image');


var makeUrl = function (url, source, productListID) {
    if (source) {
        url = util.appendParamToURL(url, 'source', source);
    }
    if (productListID) {
        url = util.appendParamToURL(url, 'productlistid', productListID);
    }
    return url;
};

var removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

var quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
            
        }
        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('href');
        });
        
        
        
    },

    setup: function (qvUrl) {
        var $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        product.initializeEvents();
   
        // init carousel

        image.initCarousel();
        $('.wishlist-link.inactive img').attr('title', Resources.ADD_TO_WISHLIST);
        
        $('.product-set-list').on('scroll', function(e) {
        	$('.product-set-list select').myselectmenu('close');
        });
        
        
        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }
        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));
        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },


    show: function (options) {
        var url;
        if (!this.exists()) {
            this.init();
        }
        url = makeUrl(options.url, options.source, options.productlistid);
        if($("body").hasClass("LeviIN") && options.currentPage != undefined){
            var dialogClass = "quickview-popup"+" "+options.currentPage;
        }else{
            var dialogClass = "quickview-popup";
        }
        console.log(dialogClass);
        dialog.open({
            target: this.$container,
            url: url,
            options: {
                width: 1130,
                dialogClass: dialogClass,
                open: function () {
                    this.setup(url);
                    if ($('body').hasClass('LeviIN')) {
                        $(".secondary.add-to-cart").removeAttr("disabled");	
                    }
                    if (typeof options.callback === 'function') { options.callback(); }
                    $('.quickview-popup').on('click', '.quickview-close', function(e) {                     
                      	dialog.close();
                    });
                    if ($("body").hasClass("LeviAU") || $('body').hasClass('LeviIN')){
                    	$(".ui-widget-overlay").on('click', function() {
                      		dialog.close();
                    	});
                    }
                    if ($("body").hasClass("LeviJP")) {
                    	$('select').myselectmenu({
                    		icons: { button: "ui-icon-arrowthick-1-s" },
                    		select: function (event, ui) {
                    			$(this).val(ui.item.value).trigger('change');
                    		}
                        });
                    	$('.quickview-close').click(function () {
                    		$(this).parents("#QuickViewDialog").dialog('close')
                        });
                    	var selectedLength = $('#alterLengthValue').val();
                        variant.alterationStyleSelection(selectedLength);
                    }
                }.bind(this)
            }
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    initCarousel: function() {
    	image.initCarousel();
    }
};

module.exports = quickview;

},{"./dialog":18,"./pages/product":42,"./pages/product/image":41,"./pages/product/variant":47,"./util":67,"lodash":73}],57:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
    init: function () {
        $('.product-review').each(function (index, review) {
            var pid = $(review).data('pid');
            if (!pid) {
                return;
            }
            // rating range from 2 - 5
            var rating = getRating(pid);
            var baseRating = Math.floor(rating);
            var starsCount = 0;
            for (var i = 0; i < baseRating; i++) {
                $('.rating', review).append('<i class="fa fa-star"></i>');
                starsCount++;
            }
            // give half star for anything in between
            if (rating > baseRating) {
                $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
                starsCount++;
            }
            if (starsCount < 5) {
                for (var j = 0; j < 5 - starsCount; j++) {
                    $('.rating', review).append('<i class="fa fa-star-o"></i>');
                }
            }
        });
    }
};

},{}],58:[function(require,module,exports){
'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */
function initializeEvents() {
    $('.q').focus(function () {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
            input.val('');
        }
    })
    .blur(function () {
        var input = $(this);
        if (input.val() === '' || input.val() === input.attr('placeholder')) {
            input.val('');
        }
    })
    .blur();
}

exports.init = initializeEvents;

},{}],59:[function(require,module,exports){
'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    $resultsContainer;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');

        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
        });

        $(document).on('click', function (e) {
            if (!$searchContainer.is(e.target)) {
                setTimeout(this.clearResults, 200);
            }
        }.bind(this));
        if (SitePreferences.ENABLE_POPULAR_SEARCH) {
            $searchField.on('click', function (e) {
                e.stopPropagation();
                if(runningQuery == null || runningQuery === '' || !runningQuery) {
                    var $popularSuggestions = $resultsContainer.find('.popular_suggestion_wrapper');
                    if($popularSuggestions.length == 0){
                        setTimeout(this.suggest.bind(this), delay);
                    }
                }
            }.bind(this));
        }
        // on key up listener
        $searchField.keyup(function (e) {

            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                return;
            }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (!SitePreferences.ENABLE_POPULAR_SEARCH && runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }             

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery && (runningQuery !== null && runningQuery !== '')) {
            runningQuery = null;
            return;
        }

        if (runningQuery === null) {
            runningQuery = currentQuery = '';
        }

        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
                if($resultsContainer.find('.phrase-suggestions').length > 0 && $resultsContainer.find('.phrase-suggestions').html().trim().length==0)
            	{
            		$('.search-suggestion-wrapper').removeClass('full');
            	}
                
                var is_iPad = navigator.userAgent.match(/iPad/i);
            	if (util.isMobile()&&is_iPad == null) {
            		$('#wrapper').css('position','fixed');
            	}
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
        if($('body').hasClass('LeviJP')|| $('body').hasClass('LeviKR')) {
			$(".product-name").dotdotdot({
				ellipsis	: '...',
				wrap		: 'letter',
				fallbackToLetter: 'letter',
				after		: null,
				watch		: true,
				height		: null,
				tolerance	: 0

			});
        }
		
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(200, function () {$resultsContainer.empty();});
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
        
        
    }
};

module.exports = searchsuggest;
},{"./util":67}],60:[function(require,module,exports){
arguments[4][59][0].apply(exports,arguments)
},{"./util":67,"dup":59}],61:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
    setSelectedStore: function (storeId) {
        var $selectedStore = $('.store-tile.' + storeId),
            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
            storeAddress = $selectedStore.find('.store-address').html(),
            storeStatus = $selectedStore.find('.store-status').data('status'),
            storeStatusText = $selectedStore.find('.store-status').text();
        this.selectedStore = storeId;

        $lineItem.find('.instore-delivery .selected-store-address')
            .data('storeId', storeId)
            .attr('data-store-id', storeId)
            .html(storeAddress);
        $lineItem.find('.instore-delivery .selected-store-availability')
            .data('status', storeStatus)
            .attr('data-status', storeStatus)
            .text(storeStatusText);
        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
    },
    cartSelectStore: function (selectedStore) {
        var self = this;
        inventory.getStoresInventory(this.uuid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: selectedStore,
                selectedStoreText: Resources.SELECTED_STORE,
                continueCallback: function () {},
                selectStoreCallback: self.setSelectedStore.bind(self)
            });
        }).done();
    },
    setDeliveryOption: function (value, storeId) {
        // set loading state
        $('.item-delivery-options')
            .addClass('loading')
            .children().hide();

        var data = {
            plid: this.uuid,
            storepickup: (value === 'store' ? true : false)
        };
        if (value === 'store') {
            data.storepickup = true;
            data.storeid = storeId;
        } else {
            data.storepickup = false;
        }
        $.ajax({
            url: Urls.setStorePickup,
            data: data,
            success: function () {
                // remove loading state
                $('.item-delivery-options')
                    .removeClass('loading')
                    .children().show();
            }
        });
    },
    init: function () {
        var self = this;
        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            self.uuid = $(this).data('uuid');
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.cartSelectStore(selectedStore);
                });
            } else {
                self.cartSelectStore(selectedStore);
            }
        });
        $('.item-delivery-options .delivery-option').on('click', function () {
            // reset the uuid
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            self.uuid = $(this).closest('.cart-row').data('uuid');
            self.setDeliveryOption($(this).val(), selectedStore);
        });
    }
};

module.exports = cartInventory;

},{"./":62}],62:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button" data-store-id="' + store.storeId + '"' +
        (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

var storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
    }
};

var zipPromptTemplate = function () {
    return [
        '<div id="preferred-store-panel">',
        '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>',
        '</div>'
    ].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
var validateZipCode = function (zipCode) {
    var regexes = {
            canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
            usa: /^\d{5}(-\d{4})?$/
        },
        valid = false;
    if (!zipCode) { return; }
    _.each(regexes, function (re) {
        var regexp = new RegExp(re);
        valid = regexp.test(zipCode);
    });
    return valid;
};

var storeinventory = {
    zipPrompt: function (callback) {
        var self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    click: function () {
                        var zipCode = $('#user-zip').val();
                        if (validateZipCode(zipCode)) {
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function () {
                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        var self = this,
            stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText,
            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
        dialog.open({
            html: storeList,
            options: {
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    click: function () {
                        self.setUserZip(null);
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    click: function () {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function () {
                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) { return; }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;

},{"../dialog":18,"../util":67,"lodash":73,"promise":74}],63:[function(require,module,exports){
'use strict';
var util = require('../util');
var _ = require('lodash'),
    inventory = require('./');

var newLine = '\n';
var pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        var $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();

        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }
        
        $.widget("custom.myselectmenu", $.ui.selectmenu, {
            _renderItem: function (ul, item) {
                var li = $("<li>"),
                wrapper = $("<div>", { text: item.label });
                
                li.attr('data-event', 'event-data-PDP-Element');
    			li.attr('data-PDP', 'Quantity:'+item.label);
    			
                if (item.disabled) {
                    li.addClass("ui-state-disabled");
                }
                return li.append(wrapper).appendTo(ul);
            }
        });

        $('select').myselectmenu({
            icons: { button: "ui-icon-arrowthick-1-s" },
    	    select: function (event, ui) {
    	        $(this).val(ui.item.value).trigger('change');
    	    }
        });
    }
    
};

module.exports = productInventory;

if (!$('body').hasClass('LeviAU') || !$('body').hasClass('LeviIN')){
$(document).ready(function() {
	$(".product-name").dotdotdot({
		ellipsis	: '...',
		wrap		: 'letter',
 		fallbackToLetter: 'letter',
		after		: null,
 		watch		: true,
		height		: null,
		tolerance	: 0

	});
});
}
},{"../util":67,"./":62,"lodash":73}],64:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// This script is executed only on the checkout summary page
if ((window.location.pathname.includes('COBilling-Billing') || window.location.pathname.includes('Adyen-ShowConfirmation')) && window.isAdyenPayment) {
  var handleAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(action) {
      var checkout, actionContainer;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.Configuration.onAdditionalDetails = onAdditionalDetails;
              _context.next = 3;
              return AdyenCheckout(window.Configuration);
            case 3:
              checkout = _context.sent;
              actionContainer = document.getElementById('action-container');
              checkout.createFromAction(action).mount(actionContainer);
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleAction(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // onAdditionalDetails event handler to be included in Adyen Component configuration
  // serializes form data and submits to place order. Then proceeds to handle the result
  var placeOrder = function placeOrder(formId) {
    var form = $('#' + formId);
    $.ajax({
      method: 'POST',
      url: window.summarySubmitUrl,
      data: $(form).serialize(),
      success: function success(data) {
        if (data.action) {
          window.orderToken = data.orderToken;
          document.getElementById('action-modal-SG').style.display = "block";
          handleAction(data.action);
        } else {
          window.location.href = data.continueUrl;
        }
      },
      error: function error(err) {}
    });
  };
  var onAdditionalDetails = function onAdditionalDetails(state) {
    $.ajax({
      type: 'POST',
      url: 'Adyen-PaymentsDetails',
      data: JSON.stringify({
        data: state.data,
        orderToken: window.orderToken
      }),
      contentType: 'application/json; charset=utf-8',
      async: false,
      success: function success(data) {
        if (!data.response.isFinal && _typeof(data.response.action) === 'object') {
          handleAction(data.action);
        } else {
          window.location.href = data.response.redirectUrl;
        }
      }
    });
  };
  window.addEventListener("load", function () {
    // Override default submit form behavior
    var formId = 'submit-order-form';
    var form = document.getElementById(formId);
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      placeOrder(formId);
    });
  });
}
},{}],65:[function(require,module,exports){
'use strict';

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    var url = 'https://www.howsmyssl.com/a/check';
    var cookieName = 'dw_TLSWarning';
    var cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    var message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    var userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    var badBrowsers = ['MSIE 6.0','MSIE 7.0','MSIE 8.0','MSIE 9.0','MSIE 10.0',
                       'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3',
                       'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({url: Urls.TLSBadTLS});
        }
    }

    function reportBadBrowser () {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({url: Urls.TLSBadBrowser});
    }

    for (var i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var tokens = cookies[i].split('=');
        var cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

function setCookie (key, value, minutes) {
    var date = new Date();
    date.setTime(date + (minutes * 60 * 1000));

    document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{}],66:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    if ($('.tooltip').length > 0) {
        $(document).tooltip({
            items: '.tooltip',
            track: true,
            content: function () {
                return $(this).find('.tooltip-content').html();
            }
        });
    }
    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
};

},{}],67:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
	progress = require('./progress');


var util = {
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + name + '=' + encodeURIComponent(value);
    },

    removeParamFromURL: function (url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function (url, params) {
        var _url = url;
        _.each(params, function (value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));
        return _url;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     **/
    getQueryString: function (url) {
        var qs;
        if (!_.isString(url)) { return; }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },
    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function (el, offsetToTop) {
        var top = el.offsetTop,
            left = el.offsetLeft,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (typeof(offsetToTop) !== 'undefined') {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );
        }

        if (document.compatMode === 'CSS1Compat') {
            return (
                top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
                left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
                (top + height) > window.document.documentElement.scrollTop &&
                (left + width) > window.document.documentElement.scrollLeft
            );
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function (path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function (urls) {
        var i, len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function (url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function () {
        var i = this.loadedCssFiles.length;
        while (0 > i--) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },
    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (qs) {
        if (!qs || qs.length === 0) { return {}; }
        var params = {},
            unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function ($0, $1, $2, $3) {
                params[$1] = $3;
            }
        );
        return params;
    },

    fillAddressFields: function (address, $form) {
        for (var field in address) {
            if (field === 'ID' || field === 'UUID' || field === 'key') {
                continue;
            }
            // if the key in address object ends with 'Code', remove that suffix
            // keys that ends with 'Code' are postalCode, stateCode and countryCode
            $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
            if($("body").hasClass("LeviJP") && $('#wrapper').hasClass('pt_checkout')){
            	if(field === 'stateCode'){
            		$("#dwfrm_singleshipping_shippingAddress_addressFields_states_state option:selected").val(address[field]);  
    				$('#dwfrm_singleshipping_shippingAddress_addressFields_states_state-button .ui-selectmenu-text').text(address[field]);	
            	}
				if(field === 'kanaFirstName'){
					$('#dwfrm_singleshipping_shippingAddress_addressFields_kanafirstname').val(address[field]);
				}
				if(field === 'kanaLastName'){
					$('#dwfrm_singleshipping_shippingAddress_addressFields_kanalastname').val(address[field]);
				}
				if(field === 'email'){
					if(address[field] !=""){
						$('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').val(address[field]);
					}else{
						var email = $('#loggedincustomeremail').val();
						$('#dwfrm_singleshipping_shippingAddress_addressFields_emailAddress').val(email);
					}
				}
				
 	        	
			}else{
            if (field === 'countryCode') {
            	var locale = $('#locale').val(); 
            	if($("body").hasClass("LeviAU"))
            		{
            		
            		 $form.find('[name$="country"]').trigger('change');
            		 $form.find('[name$="state"]').val(address.stateCode);
            		 
            		 $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').myselectmenu('refresh');
            		 $('#state-code1').val(address.stateCode);
         			$('#postal-code1').val(address.postalCode);
            		}
            	else{
            		 $form.find('[name$="country"]').trigger('change');
		                //retrigger state selection after country has changed
		                //this results in duplication of the state code, but is a necessary evil
		                //for now because sometimes countryCode comes after stateCode
            		 $form.find('[name$="state"]').val(address.stateCode);
            			
            	}
            	
               
			}

            }
            if ($("body").hasClass("LeviIN")) {
                if (field === 'postalCode') {
                    this.checkDeliveryAvailability(address.postalCode);
                }
            }
        }
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function () {
        $('form').find('textarea[data-character-limit]').each(function () {
            var characterLimit = $(this).data('character-limit');
            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
                '<span class="char-remain-count">' + characterLimit + '</span>',
                '<span class="char-allowed-count">' + characterLimit + '</span>');
            var charCountContainer = $(this).next('div.char-count');
            if (charCountContainer.length === 0) {
                charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
            }
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).change();
        });
    },

    setDeleteConfirmation: function (container, message) {
        $(container).on('click', '.delete', function () {
            return window.confirm(message);
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function (xLocation) {
        $('html, body').animate({scrollTop: xLocation}, 500);
    },

    isMobile: function () {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var    idx = 0;
        var isMobile = false;
        var userAgent = (navigator.userAgent).toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
            idx++;
        }
        return isMobile;
    },

    /**
     * @description Check postal code delivery availability
     * @param {String} postalCode - postalCode
     **/
    checkDeliveryAvailability: function (postalCode) {
        var util = this;
        if (!$('body').hasClass('LeviIN')) {
            return;
        }
        $('[name$="_shippingAddress_save"]').attr('data-deliverable', 'yes');
        
        var postalCode = postalCode;
        $.ajax({
            url: Urls.checkdeliveryavailability,
            type: 'POST',
            data: {
                pinCode: postalCode
            },
            success: function(response) {
                $('.state-code-data').html(response);
               
                var stateCode = $(response).find(".state-code").html();
                var isCodAvailable = $(response).find(".cod-value").html();
                
                if (stateCode == undefined) {
                    $('[name$="_shippingAddress_save"]').attr('data-deliverable', 'no');
                    
                    if(document.cookie.indexOf("pincodeckie") >= 0 && document.cookie.indexOf("isdeliverableckie") >= 0 && document.cookie.indexOf("iscodavailableckie") >= 0){
                        util.setCookie("pincodeckie",postalCode,"43200");
                        util.setCookie("isdeliverableckie","NO","43200");
                        util.setCookie("iscodavailableckie","NO","43200");
                    }
                    $('.cod-status-section').find('.deliveryCheck').attr('src', Urls.cod_cross).addClass('deliveryimage');
                    var errSpan = document.createElement('span');
                    errSpan.innerHTML = Resources.CORRECTPIN_REQUIRED;
                    errSpan.className += "errspan error";
                    $('[id$="_inStoreShipments_pinCode"]').closest('.field-wrapper').append(errSpan);
                    $('#dwfrm_singleshipping_shippingAddress_addressFields_postal-error').remove();
                    if($('#dwfrm_singleshipping_shippingAddress_addressFields_postal').closest('.field-wrapper').find('.errspan.error').length== 0){
                        $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').closest('.field-wrapper').append(errSpan);
                    }          
                    $('.cod-status-section').find('.CODCheck').attr('src', Urls.cod_cross);
                    
                    $('.cod-status-section').show();
                    $('.cod-del-status').show();
                    
                    $('select[id$="_shippingAddress_addressFields_states_state"] > option[optionid="state"]').prop('selected', true);
                    $('[id$="_shippingAddress_addressFields_states_state"]').myselectmenu('refresh'); 
                    
                    progress.hide();
                    return;
                }
                
                var stateValue = $('select[id$="_shippingAddress_addressFields_states_state"] > option[optionid="' + stateCode + '"]').val();
                
                if(typeof stateValue != 'undefined') {
                    $('select[id$="_shippingAddress_addressFields_states_state"] > option[optionid="' + stateCode + '"]').prop('selected', true);
                } else {
                    $('select[id$="_shippingAddress_addressFields_states_state"] > option[optionid="state"]').prop('selected', true);
                }
                $('[id$="_shippingAddress_addressFields_states_state"]').myselectmenu('refresh'); 
                
                if(isCodAvailable == 'true') {
                    if(document.cookie.indexOf("pincodeckie") >= 0 && document.cookie.indexOf("isdeliverableckie") >= 0 && document.cookie.indexOf("iscodavailableckie") >= 0){
                        util.setCookie("pincodeckie",postalCode,"43200");
                        util.setCookie("isdeliverableckie","YES","43200");
                        util.setCookie("iscodavailableckie","YES","43200");
                    }
                    $('.cod-status-section').find('.deliveryCheck').attr('src', Urls.cod_tick).removeClass('deliveryimage');   
                              
                    $('.cod-status-section').show();
                    $('.cod-del-status').show();
                    
                    if ($('[name$="_addressFields_states_state"]').val()) {
                        $('[name$="_addressFields_states_state"]').closest('.field-wrapper').find('.errspan').remove();
                    }
                    
                    progress.hide();
                    return;
                } else if(isCodAvailable == 'false'){
                    if(document.cookie.indexOf("pincodeckie") >= 0 && document.cookie.indexOf("isdeliverableckie") >= 0 && document.cookie.indexOf("iscodavailableckie") >= 0){
                        util.setCookie("pincodeckie",postalCode,"43200");
                        util.setCookie("isdeliverableckie","YES","43200");
                        util.setCookie("iscodavailableckie","NO","43200");
                    }
                    $('.cod-status-section').find('.deliveryCheck').attr('src', Urls.cod_tick).removeClass('deliveryimage');
                    //$('.cod-status-section').find('.CODCheck').attr('src', Urls.cod_cross);
                    $('.cod-status-section').show();
                    $('.cod-del-status').show();
                    
                    progress.hide();
                    return;
                }
            },
            error: function(response) {
                return;
            }
        });
    },

    createCookie: function (name, value, minutes) {
    	var expires, domain = window.location.hostname.toString();
    	if (minutes) {
    		var date = new Date();
    		date.setTime(date.getTime() + ( minutes * 60 * 1000));
    		expires = "; expires=" + date.toGMTString();
    	}
    	else {
    		expires = "";
    	}
    	document.cookie =  name + "="+ value + expires + ";path=/;" + "Domain=" + domain + ";";

    	// "domain=sjfnasj; name=pincodeckie; value=111111; expires=hadhad; path=/"
    },

    setCookie: function (c_name,value,minutes) {
    	var expires, domain = window.location.hostname.toString();
    	if (minutes) {
    		var exdate = new Date();
    		exdate.setTime(exdate.getTime() + ( minutes * 60 * 1000));
    		var c_value = escape(value) + ";expires="+exdate.toGMTString();
    		document.cookie = c_name + "=" + c_value + ";path=/;" + "Domain=" + domain + ";";
    		//  "domain=adad; name=pincodeckie; value=111111;expires=sfbhn; path=/"
    	}
    },

    getCookie: function (c_name) {

    	if (document.cookie.length > 0) {
    		var c_start = document.cookie.indexOf(c_name + "="), c_end;
    		if (c_start != -1) {
    			c_start = c_start + c_name.length + 1;
    			c_end = document.cookie.indexOf(";", c_start);
    			if (c_end == -1) {
    				c_end = document.cookie.length;
    			}
    			return unescape(document.cookie.substring(c_start, c_end));
    		}
    	}
    	return "";
    },


    deleteCookie: function (name) {
    	 document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    
};

module.exports = util;
                 
},{"./progress":55,"lodash":73}],68:[function(require,module,exports){
'use strict';

var locale = $('#locale').val();
var phoneNo;

       if ($('body').hasClass('LeviIN')){
              phoneNo = /^[1-9][0-9]{9,10}$/;
       }
       else if(locale=="en_NZ"){
              phoneNo=  /^[0-9]{3,11}$/;
       }
       else if($('body').hasClass('LeviAU')){
              phoneNo=  /^[0-9]{3,10}$/;
       }
       	
       else if($('body').hasClass('LeviJP')){
           phoneNo=  /^[0-9]{10,12}$/;
      }

       else {
               phoneNo=  /^[0-9]{10,11}$/;
       } 

//var phoneNoNZ =/^[0-5]{1,3}$/ ;


var orderNo;
	if($('body').hasClass('LeviAU')){
		orderNo=  /^AUS[0-9]{9}/;
	}
	else if($('body').hasClass('LeviIN')){
		orderNo=  /^IND[0-9]{9}/;
	 }
	else if($('body').hasClass('LeviKR')){
		orderNo=  /^KRL[0-9]{9}/;
	 }
	else if($('body').hasClass('LeviJP')){
		orderNo=  /^JP[0-9]{9}/;
	 }


var regex = {
       phone: phoneNo,
       //phoneNZ: phoneNoNZ,
    postalIndia:  /^[0-9]{6}$/,
    postal: /^\d{5}(-\d{4})?$/,
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    orderNumber : orderNo,
    	///^[0-9a-zA-Z]*$/,
    /*name: {
        us: /^[A-Za-z\.\s]+$/,
        ko_KR:/^[A-Za-z\u00C0-\u017F\.\s]+$/
    }*/
    name: /^[A-Za-z\.\s]+$/,
    address2: /<(.|\n)*?>/i,
    nameJP:  /^[A-Za-z\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf.\s]+$/,
    kana: /^[\u30a0-\u30ff\uff00-\uff9f.\s]+$/ ,
    addressINregex:  /^[a-zA-Z0-9.,-_\s]{1,65}$/
};
// global form validator settings
var settings = {
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
        if (!this.checkable(element)) {
            this.element(element);
        }
    },
    // Start - for GA4 events 
    invalidHandler: function (event, validator) {
       $('body').trigger('analytics:pushFormErrors', validator);
    },
    // End - for GA4 events 
    errorPlacement: function(error, element) {
    if ( element.hasClass("input-select") ) {
    error.insertAfter(element.parent().next(".form-caption"));
    } else if ( element.hasClass("custom-combobox-input") ) {
       error.insertAfter(element.closest(".custom-combobox"));
       } else if ( element.hasClass("input-radio") ) {
       error.appendTo(element.closest(".form-row"));
       } else if ( element.attr("type") === "number" ) {
       error.appendTo(element.parent().parent());
       }else if ($('body').hasClass('LeviJP') && element.hasClass("input-checkbox") && element.parent().parent().parent().hasClass("terms-checkbox" )) {
              error.appendTo(element.parent().parent().next());
       } 
       else if ($('body').hasClass('LeviJP') && element.attr('type') === "checkbox" && element.parents('form').attr('id') === "dwfrm_profile") {
              error.appendTo(element.parent().parent().next());
       }
       else if ( element.hasClass("input-checkbox") ) {
       error.appendTo(element.closest(".form-row"));
       } else if (element.attr('type') === "checkbox" && element.parents('form').attr('id') === "HelpUsImproveForm") {
       error.appendTo(element.closest(".form-row"));
       } else if ($('body').hasClass('LeviJP') && (element.attr('type') === "text" || element.hasClass("input-text"))) {
       error.appendTo(element.parent());
       } 
       else {
       error.insertAfter(element)
       }
    if($('body').hasClass('LeviJP')) {
        if($('input:radio[name=dwfrm_singleshipping_deliveryType]:checked').val() == "お届け日を指定する"){                           if($('#estDeliveryDate').val() =="" || $('#estDeliverySlot').val() == ""){
                                   if($('.need-delivery span.errspan.error').length == 0){
                                                         var errSpan = document.createElement('span');
                                                         errSpan.innerHTML = Resources.VALIDATE_NAME;
                                                         errSpan.className += "errspan error";
                                                         $('.needsched-disclaimer').prepend(errSpan);
                                                       }
                                  }
           }
        if($('input[name=dwfrm_singleshipping_deliveryPref]:checked').val() == "shipToOther" && $('#dwfrm_singleshipping_shippingAddress_sendername').val() == ""){
               if($('.checkout-shipToOther .form-row span.errspan.error').length == 0){
                  var errSpan = document.createElement('span');
                  errSpan.innerHTML = Resources.VALIDATE_NAME;
                  errSpan.className += "errspan error";
                  $('[name$="_singleshipping_shippingAddress_sendername"]').closest('.field-wrapper').append(errSpan);
                  $('.checkout-shipToOther .input-text').addClass('error');
                }
        }
   }
}
    
    
};
/**
* @function
* @description Validates a given phone number against the countries phone regex
* @param {String} value The phone number which will be validated
*/
var validatePhone = function (value) {
       var isValid = regex.phone.test($.trim(value));
    return isValid;
};

var validatePhoneNZ = function (value) {
       var isValid = regex.phoneNZ.test($.trim(value));
    return isValid;
};

var validateOrderNumber = function (value) {
       var isValid = regex.orderNumber.test($.trim(value));
    return isValid;
};

/**
* @function
* @description Validates that a credit card owner is not a Credit card number
* @param {String} value The owner field which will be validated
* @param {String} el The input field
*/
var validateOwner = function (value) {
    var isValid = regex.notCC.test($.trim(value));
    return isValid;
};

/**
* Add phone validation method to jQuery validation plugin.
* Text fields must have 'phone' css class to be validated as phone
*/
var validateName = function (value) {  
       var isValid;
       if($('body').hasClass('LeviJP')) {
              isValid = regex.nameJP.test($.trim(value));
       }else {
              isValid = regex.name.test($.trim(value));
       }
    return isValid;
};

var validateKanaName = function (value) {
       var isValid;
       if($('body').hasClass('LeviJP')) {
              isValid = regex.kana.test($.trim(value));
       }
       return isValid;     

};

var shippingInstruction = function (value) {
       var isValid = true;
       if(value.length>0)
    {
       if($('body').hasClass('LeviJP')) {
              isValid = regex.nameJP.test($.trim(value));
       }else {
     isValid = regex.name.test($.trim(value));
    }
    }
       return isValid;     
};

var validateZip = function (value) {  
       var isValid = true;
       if(value===""){
              isValid = false;
       }
       if($('body').hasClass('LeviJP') &&   sessionStorage.flag=='true'){ 
                              isValid = false; 
                      }
       if($('body').hasClass('LeviIN')) {
        isValid = regex.postalIndia.test($.trim(value));
    }
    return isValid;
};
var validateAddress = function (value) {  
       var isValid = true;
       if(value===""){
              isValid = false;
       }else  if($('body').hasClass('LeviIN')){
    	   isValid = regex.addressINregex.test($.trim(value));
       }
    return isValid;
};

var validateAddress2 = function (value) {  
       var isValid = true;
       if(value.length>0)
       {
        isValid = !regex.address2.test($.trim(value));
       }
          return isValid;	
};
var validateAddress_AU = function (value) {  
       var isValid = true;
       const specialChars = /[|]/;
       if (value.length>0)      
       {
              isValid = !specialChars.test($.trim(value));
       }   
       return isValid;      
};
var validateAddressName = function (value) {  
       var isValid = true;
       if(value===""){
              isValid = false;
       }
    return isValid;
};
var validatePassword = function (value,e) {
       var isValid = true;
       if (value.length < 8) {
              isValid = false;
    } 
       return isValid;
};
 
$.validator.addMethod('password', validatePassword, Resources.INVALID_PASSWORD);
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);
//$.validator.addMethod('phoneNZ', validatePhoneNZ, Resources.INVALID_PHONE);
$.validator.addMethod('orderNumber', validateOrderNumber, Resources.INVALID_ORDERNUMBER);
$.validator.addMethod('postal',validateZip, Resources.INVALID_POSTAL);
$.validator.addMethod('address1',validateAddress, Resources.INVALID_ADDRESS);
$.validator.addMethod('address2',validateAddress2, Resources.INVALID_ADDRESS2);
$.validator.addMethod('addressName',validateAddressName, Resources.INVALID_ADDRESS_NAME);
if($('body').hasClass('LeviAU')){
$.validator.addMethod('firstname',validateName, Resources.INVALID_NAME);
$.validator.addMethod('address1',validateAddress_AU, Resources.INVALID_ADDRESS_SPECIAL_CHARACTER);
$.validator.addMethod('address2',validateAddress_AU, Resources.INVALID_ADDRESS_SPECIAL_CHARACTER);
}
if($('body').hasClass('LeviIN')){
       $.validator.addMethod('address1',validateAddress, Resources.INVALID_ADDRESS_IN);
       $.validator.addMethod('address2',validateAddress, Resources.INVALID_ADDRESS_IN);
}
$.validator.addMethod('firstName',validateName, Resources.INVALID_NAME);
$.validator.addMethod('lastName',validateName, Resources.INVALID_NAME);
$.validator.addMethod('kanalastname',validateKanaName, Resources.INVALID_KANANAME);
$.validator.addMethod('kanafirstname',validateKanaName, Resources.INVALID_KANANAME);
$.validator.addMethod('shippingInstructions',shippingInstruction, Resources.INVALID_NAME);

/**
* Add CCOwner validation method to jQuery validation plugin.
* Text fields must have 'owner' css class to be validated as not a credit card
*/
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);
/**
* Add gift cert amount validation method to jQuery validation plugin.
* Text fields must have 'gift-cert-amont' css class to be validated
*/
$.validator.addMethod('gift-cert-amount', function (value, el) {
    var isOptional = this.optional(el);
    var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
* Add positive number validation method to jQuery validation plugin.
* Text fields must have 'positivenumber' css class to be validated as positivenumber
*/
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

if($('body').hasClass('LeviAU')){
$.validator.methods.email = function( value, element ) {
		return this.optional( element ) || /^([A-Za-z0-9]){1,}([A-Za-z0-9_\-\.]){0,}([A-Za-z0-9]){1,}\@([A-Za-z0-9_\-\.]){1,}\.([A-Za-z0-9]{2,})$/.test( value ) || /^([A-Za-z0-9]){1,}([_\-\.]){0,1}([A-Za-z0-9]){1,}\@([A-Za-z0-9_\-\.]){1,}\.([A-Za-z0-9]{2,})$/.test( value ) || /^([A-Za-z0-9]){1,}([_\-\.]){0,1}([A-Za-z0-9]){1,}([_\-\.]){0,1}([A-Za-z0-9]){1,}\@([A-Za-z0-9_\-\.]){1,}\.([A-Za-z0-9]{2,})$/.test( value );

}
}

else if($('body').hasClass('LeviJP')){
       $.validator.methods.email = function( value, element ) {
              return this.optional( element ) || /^([A-Za-z0-9]){1,}([A-Za-z0-9+\-\.\_\?\~]){0,}\@([A-Za-z0-9_\-\.]){1,}\.([A-Za-z0-9]{2,})$/.test( value );
       }
}

else{
       $.validator.methods.email = function( value, element ) {
		return this.optional( element ) || /^([A-Za-z0-9]){1,}([A-Za-z0-9_\-\.]){0,}([A-Za-z0-9]){1,}\@([A-Za-z0-9_\-\.]){1,}\.([A-Za-z0-9]{2,})$/.test( value );
       }
}
$.extend($.validator.messages, {
    required: Resources.VALIDATE_REQUIRED,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
    minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN)
});

var validator = {
    regex: regex,
    settings: settings,
    init: function () {
        var self = this;
        $('form:not(.suppress)').each(function () {
            $(this).validate(self.settings);
        });
    },
    initForm: function (f) {
       $(f).validate(this.settings);
       
    }
};

module.exports = validator;
},{}],69:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":70}],70:[function(require,module,exports){
(function (global){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
var BrowserMutationObserver = global.MutationObserver || global.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],71:[function(require,module,exports){
/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {

'use strict';

var docElem = document.documentElement;

var bind = function() {};

function getIEEvent( obj ) {
  var event = window.event;
  // add event.target
  event.target = event.target || event.srcElement || obj;
  return event;
}

if ( docElem.addEventListener ) {
  bind = function( obj, type, fn ) {
    obj.addEventListener( type, fn, false );
  };
} else if ( docElem.attachEvent ) {
  bind = function( obj, type, fn ) {
    obj[ type + fn ] = fn.handleEvent ?
      function() {
        var event = getIEEvent( obj );
        fn.handleEvent.call( fn, event );
      } :
      function() {
        var event = getIEEvent( obj );
        fn.call( obj, event );
      };
    obj.attachEvent( "on" + type, obj[ type + fn ] );
  };
}

var unbind = function() {};

if ( docElem.removeEventListener ) {
  unbind = function( obj, type, fn ) {
    obj.removeEventListener( type, fn, false );
  };
} else if ( docElem.detachEvent ) {
  unbind = function( obj, type, fn ) {
    obj.detachEvent( "on" + type, obj[ type + fn ] );
    try {
      delete obj[ type + fn ];
    } catch ( err ) {
      // can't delete window object properties
      obj[ type + fn ] = undefined;
    }
  };
}

var eventie = {
  bind: bind,
  unbind: unbind
};

// ----- module definition ----- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( eventie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = eventie;
} else {
  // browser global
  window.eventie = eventie;
}

})( window );

},{}],72:[function(require,module,exports){
/*!
 * imagesLoaded v3.2.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'eventEmitter/EventEmitter',
      'eventie/eventie'
    ], function( EventEmitter, eventie ) {
      return factory( window, EventEmitter, eventie );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('wolfy87-eventemitter'),
      require('eventie')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EventEmitter,
      window.eventie
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EventEmitter, eventie ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var objToString = Object.prototype.toString;
function isArray( obj ) {
  return objToString.call( obj ) == '[object Array]';
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

  // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {Array, Element, NodeList, String} elem
   * @param {Object or Function} options - if function, use as callback
   * @param {Function} onAlways - callback function
   */
  function ImagesLoaded( elem, options, onAlways ) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if ( !( this instanceof ImagesLoaded ) ) {
      return new ImagesLoaded( elem, options, onAlways );
    }
    // use elem as selector string
    if ( typeof elem == 'string' ) {
      elem = document.querySelectorAll( elem );
    }

    this.elements = makeArray( elem );
    this.options = extend( {}, this.options );

    if ( typeof options == 'function' ) {
      onAlways = options;
    } else {
      extend( this.options, options );
    }

    if ( onAlways ) {
      this.on( 'always', onAlways );
    }

    this.getImages();

    if ( $ ) {
      // add jQuery Deferred object
      this.jqDeferred = new $.Deferred();
    }

    // HACK check async to allow time to bind listeners
    var _this = this;
    setTimeout( function() {
      _this.check();
    });
  }

  ImagesLoaded.prototype = new EventEmitter();

  ImagesLoaded.prototype.options = {};

  ImagesLoaded.prototype.getImages = function() {
    this.images = [];

    // filter & find items if we have an item selector
    for ( var i=0; i < this.elements.length; i++ ) {
      var elem = this.elements[i];
      this.addElementImages( elem );
    }
  };

  /**
   * @param {Node} element
   */
  ImagesLoaded.prototype.addElementImages = function( elem ) {
    // filter siblings
    if ( elem.nodeName == 'IMG' ) {
      this.addImage( elem );
    }
    // get background image on element
    if ( this.options.background === true ) {
      this.addElementBackgroundImages( elem );
    }

    // find children
    // no non-element nodes, #143
    var nodeType = elem.nodeType;
    if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
      return;
    }
    var childImgs = elem.querySelectorAll('img');
    // concat childElems to filterFound array
    for ( var i=0; i < childImgs.length; i++ ) {
      var img = childImgs[i];
      this.addImage( img );
    }

    // get child background images
    if ( typeof this.options.background == 'string' ) {
      var children = elem.querySelectorAll( this.options.background );
      for ( i=0; i < children.length; i++ ) {
        var child = children[i];
        this.addElementBackgroundImages( child );
      }
    }
  };

  var elementNodeTypes = {
    1: true,
    9: true,
    11: true
  };

  ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
    var style = getStyle( elem );
    // get url inside url("...")
    var reURL = /url\(['"]*([^'"\)]+)['"]*\)/gi;
    var matches = reURL.exec( style.backgroundImage );
    while ( matches !== null ) {
      var url = matches && matches[1];
      if ( url ) {
        this.addBackground( url, elem );
      }
      matches = reURL.exec( style.backgroundImage );
    }
  };

  // IE8
  var getStyle = window.getComputedStyle || function( elem ) {
    return elem.currentStyle;
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function( img ) {
    var loadingImage = new LoadingImage( img );
    this.images.push( loadingImage );
  };

  ImagesLoaded.prototype.addBackground = function( url, elem ) {
    var background = new Background( url, elem );
    this.images.push( background );
  };

  ImagesLoaded.prototype.check = function() {
    var _this = this;
    this.progressedCount = 0;
    this.hasAnyBroken = false;
    // complete if no images
    if ( !this.images.length ) {
      this.complete();
      return;
    }

    function onProgress( image, elem, message ) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout( function() {
        _this.progress( image, elem, message );
      });
    }

    for ( var i=0; i < this.images.length; i++ ) {
      var loadingImage = this.images[i];
      loadingImage.once( 'progress', onProgress );
      loadingImage.check();
    }
  };

  ImagesLoaded.prototype.progress = function( image, elem, message ) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // progress event
    this.emit( 'progress', this, image, elem );
    if ( this.jqDeferred && this.jqDeferred.notify ) {
      this.jqDeferred.notify( this, image );
    }
    // check if completed
    if ( this.progressedCount == this.images.length ) {
      this.complete();
    }

    if ( this.options.debug && console ) {
      console.log( 'progress: ' + message, image, elem );
    }
  };

  ImagesLoaded.prototype.complete = function() {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emit( eventName, this );
    this.emit( 'always', this );
    if ( this.jqDeferred ) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[ jqMethod ]( this );
    }
  };

  // --------------------------  -------------------------- //

  function LoadingImage( img ) {
    this.img = img;
  }

  LoadingImage.prototype = new EventEmitter();

  LoadingImage.prototype.check = function() {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      // report based on naturalWidth
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    this.proxyImage = new Image();
    eventie.bind( this.proxyImage, 'load', this );
    eventie.bind( this.proxyImage, 'error', this );
    // bind to image as well for Firefox. #191
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.proxyImage.src = this.img.src;
  };

  LoadingImage.prototype.getIsImageComplete = function() {
    return this.img.complete && this.img.naturalWidth !== undefined;
  };

  LoadingImage.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.img, message );
  };

  // ----- events ----- //

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function( event ) {
    var method = 'on' + event.type;
    if ( this[ method ] ) {
      this[ method ]( event );
    }
  };

  LoadingImage.prototype.onload = function() {
    this.confirm( true, 'onload' );
    this.unbindEvents();
  };

  LoadingImage.prototype.onerror = function() {
    this.confirm( false, 'onerror' );
    this.unbindEvents();
  };

  LoadingImage.prototype.unbindEvents = function() {
    eventie.unbind( this.proxyImage, 'load', this );
    eventie.unbind( this.proxyImage, 'error', this );
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  // -------------------------- Background -------------------------- //

  function Background( url, element ) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  }

  // inherit LoadingImage prototype
  Background.prototype = new LoadingImage();

  Background.prototype.check = function() {
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.img.src = this.url;
    // check if image is already complete
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      this.unbindEvents();
    }
  };

  Background.prototype.unbindEvents = function() {
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  Background.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.element, message );
  };

  // -------------------------- jQuery -------------------------- //

  ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
    jQuery = jQuery || window.jQuery;
    if ( !jQuery ) {
      return;
    }
    // set local variable
    $ = jQuery;
    // $().imagesLoaded()
    $.fn.imagesLoaded = function( options, callback ) {
      var instance = new ImagesLoaded( this, options, callback );
      return instance.jqDeferred.promise( $(this) );
    };
  };
  // try making plugin
  ImagesLoaded.makeJQueryPlugin();

  // --------------------------  -------------------------- //

  return ImagesLoaded;

});

},{"eventie":71,"wolfy87-eventemitter":92}],73:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],74:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":79}],75:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":70}],76:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":75}],77:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

},{"./core.js":75}],78:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":75}],79:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":75,"./done.js":76,"./es6-extensions.js":77,"./finally.js":78,"./node-extensions.js":80,"./synchronous.js":81}],80:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
}

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
}

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
}

},{"./core.js":75,"asap":69}],81:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._81 === 3) {
      return this._65.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._65;
  };

  Promise.prototype.getReason = function () {
    if (this._81 === 3) {
      return this._65.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._65;
  };

  Promise.prototype.getState = function () {
    if (this._81 === 3) {
      return this._65.getState();
    }
    if (this._81 === -1 || this._81 === -2) {
      return 0;
    }

    return this._81;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":75}],82:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],83:[function(require,module,exports){
// Load modules

var Stringify = require('./stringify');
var Parse = require('./parse');


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};

},{"./parse":84,"./stringify":85}],84:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        if (pos === -1) {
            obj[Utils.decode(part)] = '';

            if (options.strictNullHandling) {
                obj[Utils.decode(part)] = null;
            }
        }
        else {
            var key = Utils.decode(part.slice(0, pos));
            var val = Utils.decode(part.slice(pos + 1));

            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                obj[key] = val;
            }
            else {
                obj[key] = [].concat(obj[key]).concat(val);
            }
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = options.allowDots !== false;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};

},{"./utils":86}],85:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, filter) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return Utils.encode(prefix);
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys = Array.isArray(filter) ? filter : Object.keys(obj);
    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }
    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];
        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, filter));
    }

    return keys.join(delimiter);
};

},{"./utils":86}],86:[function(require,module,exports){
// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};

},{}],87:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],88:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],89:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":87,"./encode":88}],90:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":91,"punycode":82,"querystring":89}],91:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}],92:[function(require,module,exports){
/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

},{}],93:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}]},{},[12]);
